(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6955"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6955"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3RUqz", function(module, exports) {

$parcel$export(module.exports, "initCopyButton", function () { return $ecb7496157370467$export$6bfca4f605a2da6d; });
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// This is copied from legacy. It works, but we should rework this if we ever need to change it

var $iW1oU = parcelRequire("iW1oU");
const $ecb7496157370467$var$DOCUMENTATION_OPTIONS = {
    VERSION: '',
    LANGUAGE: 'en',
    COLLAPSE_INDEX: false,
    BUILDER: 'html',
    FILE_SUFFIX: '.html',
    LINK_SUFFIX: '.html',
    HAS_SOURCE: true,
    SOURCELINK_SUFFIX: '.txt',
    NAVIGATION_WITH_KEYS: false,
    SHOW_SEARCH_SUMMARY: true,
    ENABLE_SEARCH_SHORTCUTS: true
};
const $ecb7496157370467$var$messages = {
    en: {
        copy: 'Copy',
        copy_to_clipboard: 'Copy to clipboard',
        copy_success: 'Copied!',
        copy_failure: 'Failed to copy'
    },
    es: {
        copy: 'Copiar',
        copy_to_clipboard: 'Copiar al portapapeles',
        copy_success: "\xa1Copiado!",
        copy_failure: 'Error al copiar'
    },
    de: {
        copy: 'Kopieren',
        copy_to_clipboard: 'In die Zwischenablage kopieren',
        copy_success: 'Kopiert!',
        copy_failure: 'Fehler beim Kopieren'
    },
    fr: {
        copy: 'Copier',
        copy_to_clipboard: 'Copier dans le presse-papier',
        copy_success: "Copi\xe9 !",
        copy_failure: "\xc9chec de la copie"
    },
    ru: {
        copy: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        copy_to_clipboard: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0435\u0440",
        copy_success: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E!",
        copy_failure: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
    },
    'zh-CN': {
        copy: "\u590D\u5236",
        copy_to_clipboard: "\u590D\u5236\u5230\u526A\u8D34\u677F",
        copy_success: "\u590D\u5236\u6210\u529F!",
        copy_failure: "\u590D\u5236\u5931\u8D25"
    },
    it: {
        copy: 'Copiare',
        copy_to_clipboard: 'Copiato negli appunti',
        copy_success: 'Copiato!',
        copy_failure: 'Errore durante la copia'
    }
};
let $ecb7496157370467$var$locale = 'en';
if (document.documentElement.lang !== undefined && $ecb7496157370467$var$messages[document.documentElement.lang] !== undefined) $ecb7496157370467$var$locale = document.documentElement.lang;
let $ecb7496157370467$var$doc_url_root = 'URL_ROOT' in $ecb7496157370467$var$DOCUMENTATION_OPTIONS ? $ecb7496157370467$var$DOCUMENTATION_OPTIONS.URL_ROOT : '';
if ($ecb7496157370467$var$doc_url_root == '#') $ecb7496157370467$var$doc_url_root = '';
/**
 * SVG files for our copy buttons
 */ const $ecb7496157370467$var$iconCheck = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-check" width="44" height="44" viewBox="0 0 24 24" stroke-width="2" stroke="#22863a" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <title>${$ecb7496157370467$var$messages[$ecb7496157370467$var$locale]['copy_success']}</title>
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 12l5 5l10 -10" />
</svg>`;
// If the user specified their own SVG use that, otherwise use the default
let $ecb7496157370467$var$iconCopy = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
</svg>
`;
if (!$ecb7496157370467$var$iconCopy) $ecb7496157370467$var$iconCopy = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-copy" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <title>${$ecb7496157370467$var$messages[$ecb7496157370467$var$locale]['copy_to_clipboard']}</title>
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <rect x="8" y="8" width="12" height="12" rx="2" />
  <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
</svg>`;
const $ecb7496157370467$var$codeCellId = (index, prefix)=>`${prefix}${index}`;
// Changes tooltip text for a moment, then changes it back
// We want the timeout of our `success` class to be a bit shorter than the
// tooltip and icon change, so that we can hide the icon before changing back.
const $ecb7496157370467$var$timeoutIcon = 1500;
const $ecb7496157370467$var$timeoutSuccessClass = 1500;
const $ecb7496157370467$var$temporarilyChangeTooltip = (el, oldText, newText)=>{
    el.setAttribute('data-tooltip', newText);
    el.classList.add('success');
    // Remove success a little bit sooner than we change the tooltip
    // So that we can use CSS to hide the copybutton first
    setTimeout(()=>el.classList.remove('success'), $ecb7496157370467$var$timeoutSuccessClass);
    setTimeout(()=>el.setAttribute('data-tooltip', oldText), $ecb7496157370467$var$timeoutIcon);
};
// Changes the copy button icon for two seconds, then changes it back
const $ecb7496157370467$var$temporarilyChangeIcon = (el)=>{
    el.innerHTML = $ecb7496157370467$var$iconCheck;
    setTimeout(()=>{
        el.innerHTML = $ecb7496157370467$var$iconCopy;
    }, $ecb7496157370467$var$timeoutIcon);
};
const $ecb7496157370467$var$addCopyButtonToCodeCells = (selector, baseElement, prefix)=>{
    // Add copybuttons to all of our code cells
    const codeCells = (0, $iW1oU.$$)(selector, baseElement);
    codeCells.forEach((codeCell, index)=>{
        if (codeCell.id) return;
        const id = $ecb7496157370467$var$codeCellId(index, prefix);
        codeCell.setAttribute('id', id);
        const clipboardButton = document.createElement('button');
        clipboardButton.setAttribute('aria-label', 'Copy code to clipboard');
        clipboardButton.className = 'copybtn o-tooltip--left';
        clipboardButton.setAttribute('data-tooltip', $ecb7496157370467$var$messages[$ecb7496157370467$var$locale]['copy']);
        clipboardButton.setAttribute('data-clipboard-target', `#${id}`);
        clipboardButton.innerHTML = $ecb7496157370467$var$iconCopy;
        clipboardButton.onclick = async ()=>{
            try {
                const text = copyTargetText(clipboardButton, baseElement);
                await navigator.clipboard.writeText(text);
                $ecb7496157370467$var$temporarilyChangeTooltip(clipboardButton, $ecb7496157370467$var$messages[$ecb7496157370467$var$locale]['copy'], $ecb7496157370467$var$messages[$ecb7496157370467$var$locale]['copy_success']);
                $ecb7496157370467$var$temporarilyChangeIcon(clipboardButton);
            } catch (error) {
                console.error(error);
            }
        };
        codeCell.insertAdjacentElement('afterend', clipboardButton);
    });
    function escapeRegExp(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
        ;
    }
    function filterText(target, excludes) {
        const clone = target.cloneNode(true) // clone as to not modify the live DOM
        ;
        clone.querySelectorAll(excludes).forEach((node)=>node.remove());
        return clone.innerText;
    }
    // Callback when a copy button is clicked. Will be passed the node that was clicked
    // should then grab the text and replace pieces of text that shouldn't be used in output
    function formatCopyText(textContent, copybuttonPromptText, isRegexp = false, onlyCopyPromptLines = true, removePrompts = true, copyEmptyLines = true, lineContinuationChar = '', hereDocDelim = '') {
        let regexp;
        let match;
        // Do we check for line continuation characters and "HERE-documents"?
        const useLineCont = !!lineContinuationChar;
        const useHereDoc = !!hereDocDelim;
        // create regexp to capture prompt and remaining line
        if (isRegexp) regexp = new RegExp('^(' + copybuttonPromptText + ')(.*)');
        else regexp = new RegExp('^(' + escapeRegExp(copybuttonPromptText) + ')(.*)');
        const outputLines = [];
        let promptFound = false;
        let gotLineCont = false;
        let gotHereDoc = false;
        const lineGotPrompt = [];
        for (const line of textContent.split('\n')){
            match = line.match(regexp);
            if (match || gotLineCont || gotHereDoc) {
                promptFound = regexp.test(line);
                lineGotPrompt.push(promptFound);
                if (removePrompts && promptFound) outputLines.push(match[2]);
                else outputLines.push(line);
                gotLineCont = line.endsWith(lineContinuationChar) && useLineCont;
                if (line.includes(hereDocDelim) && useHereDoc) gotHereDoc = !gotHereDoc;
            } else if (!onlyCopyPromptLines) outputLines.push(line);
            else if (copyEmptyLines && line.trim() === '') outputLines.push(line);
        }
        // If no lines with the prompt were found then just use original lines
        if (lineGotPrompt.some((v)=>v === true)) textContent = outputLines.join('\n');
        // Remove a trailing newline to avoid auto-running when pasting
        if (textContent.endsWith('\n')) textContent = textContent.slice(0, -1);
        return textContent;
    }
    const copyTargetText = (trigger, searchElement = document)=>{
        const target = searchElement.querySelector(trigger.attributes['data-clipboard-target'].value);
        // get filtered text
        const excludes = [
            '.code-callout',
            '.linenos',
            '.language-apiheader'
        ];
        const text = Array.from(target.querySelectorAll('code')).map((code)=>filterText(code, excludes)).join('\n');
        return formatCopyText(text, '', false, true, true, true, '', '');
    };
};
function $ecb7496157370467$export$6bfca4f605a2da6d(selector = '.highlight pre', baseElement = document, prefix = 'markdown-content-codecell-') {
    $ecb7496157370467$var$addCopyButtonToCodeCells(selector, baseElement, prefix);
}

});
parcelRegister("iW1oU", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $dc8ebaefddaf9a93$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "$$", function () { return $dc8ebaefddaf9a93$export$fe324b23443c13e2; });
// Type predicate for TypeScript
function $dc8ebaefddaf9a93$var$isQueryable(object) {
    return typeof object.querySelectorAll === 'function';
}
function $dc8ebaefddaf9a93$export$3d8c2f653ac9d0b9(selectors, baseElement) {
    // Shortcut with specified-but-null baseElement
    if (arguments.length === 2 && !baseElement) return;
    return (baseElement ?? document).querySelector(String(selectors)) ?? undefined;
}
class $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a extends Error {
    name = 'ElementNotFoundError';
}
function $dc8ebaefddaf9a93$export$40b2bf1d2277be2a(selectors, baseElement) {
    // Shortcut with specified-but-null baseElement
    if (arguments.length === 2 && !baseElement) throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a('Expected element not found because the base is specified but null');
    const element = (baseElement ?? document).querySelector(String(selectors));
    if (element) return element;
    throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a(`Expected element not found: ${String(selectors)}`);
}
function $dc8ebaefddaf9a93$export$2b172101b53b52e6(selectors, baseElement) {
    // Shortcut with specified-but-null baseElement
    if (arguments.length === 2 && !baseElement) return undefined;
    const all = (baseElement ?? document).querySelectorAll(String(selectors));
    // eslint-disable-next-line unicorn/prefer-at -- Not an Array, not worth converting it
    return all[all.length - 1];
}
/**
 * @param selectors      One or more CSS selectors separated by commas
 * @param [baseElement]  The element to look inside of
 * @return               Whether it's been found
 */ function $dc8ebaefddaf9a93$export$b740cc64eb969700(selectors, baseElement) {
    // Shortcut with specified-but-null baseElement
    if (arguments.length === 2 && !baseElement) return false;
    return Boolean((baseElement ?? document).querySelector(String(selectors)));
}
/**
 * @param selectors      One or more CSS selectors separated by commas
 * @param [baseElement]  The element to look inside of
 * @return               void or throws an error
 */ function $dc8ebaefddaf9a93$export$90dcefc949285b5b(selectors, baseElement) {
    // Shortcut with specified-but-null baseElement
    if (arguments.length === 2 && !baseElement) throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a('Element not found because the base is specified but null');
    if (!(baseElement ?? document).querySelector(String(selectors))) throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a(`Element not found: ${String(selectors)}`);
}
/**
 * @param selectors      One or more CSS selectors separated by commas
 * @param [baseElement]  The element to look inside of
 * @return               The number of elements found
 */ function $dc8ebaefddaf9a93$export$fba2a6a78408c3e0(selectors, baseElement) {
    // Shortcut with specified-but-null baseElement
    if (arguments.length === 2 && !baseElement) return 0;
    return (baseElement ?? document).querySelectorAll(String(selectors)).length;
}
function $dc8ebaefddaf9a93$export$fe324b23443c13e2(selectors, baseElements) {
    // Shortcut with specified-but-null baseElements
    if (arguments.length === 2 && !baseElements) return [];
    // Can be: select.all('selectors') or select.all('selectors', singleElementOrDocument)
    if (!baseElements || $dc8ebaefddaf9a93$var$isQueryable(baseElements)) {
        const elements = (baseElements ?? document).querySelectorAll(String(selectors));
        return Array.prototype.slice.call(elements);
    }
    const elements = new Set();
    for (const baseElement of baseElements)for (const element of baseElement.querySelectorAll(String(selectors)))elements.add(element);
    return [
        ...elements
    ]; // Convert to array
}
function $dc8ebaefddaf9a93$export$f1e1a079b4c72e2a(selectors, baseElements) {
    // Shortcut with specified-but-null baseElements
    if (arguments.length === 2 && !baseElements) throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a('Expected elements not found because the base is specified but null');
    const elements = arguments.length === 2 ? $dc8ebaefddaf9a93$export$fe324b23443c13e2(selectors, baseElements) : $dc8ebaefddaf9a93$export$fe324b23443c13e2(selectors);
    if (elements.length > 0) return elements;
    throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a(`Expected elements not found: ${String(selectors)}`);
}
function $dc8ebaefddaf9a93$export$afb9cd7f752a916d(selectors, baseElement) {
    // Shortcut with specified-but-null baseElements
    if (arguments.length === 2 && !baseElement) throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a('Expected element not found because the base is specified but null');
    const all = (baseElement ?? document).querySelectorAll(String(selectors));
    if (all.length > 0) // eslint-disable-next-line unicorn/prefer-at -- Not an Array, not worth converting it
    return all[all.length - 1];
    throw new $dc8ebaefddaf9a93$export$2d60fbfcb9a12b2a(`Expected element not found: ${String(selectors)}`);
}

});


parcelRegister("j96zz", function(module, exports) {

$parcel$export(module.exports, "initHighlight", function () { return $80a0e2a6c204c6db$export$553fc027481fdea0; });
$parcel$export(module.exports, "hljs", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5H3y2")))); });

var $hcZta = parcelRequire("hcZta");

var $4L31j = parcelRequire("4L31j");

var $5H3y2 = parcelRequire("5H3y2");

var $f8yzZ = parcelRequire("f8yzZ");

var $8mb6m = parcelRequire("8mb6m");

var $h4vvL = parcelRequire("h4vvL");

var $lx9iJ = parcelRequire("lx9iJ");

var $iXTF6 = parcelRequire("iXTF6");

var $3AIsM = parcelRequire("3AIsM");

var $hZGrj = parcelRequire("hZGrj");

var $5qGNl = parcelRequire("5qGNl");

var $a3Tks = parcelRequire("a3Tks");

var $4huqg = parcelRequire("4huqg");

var $12CYi = parcelRequire("12CYi");

var $6lvAh = parcelRequire("6lvAh");

var $aLzAh = parcelRequire("aLzAh");

var $5WypX = parcelRequire("5WypX");

var $ajuee = parcelRequire("ajuee");

var $79Fne = parcelRequire("79Fne");

var $4h2Ey = parcelRequire("4h2Ey");

var $aoBt3 = parcelRequire("aoBt3");

var $kDduH = parcelRequire("kDduH");

var $5pr0v = parcelRequire("5pr0v");

var $2zmWr = parcelRequire("2zmWr");

var $aMK1O = parcelRequire("aMK1O");

var $bRjUs = parcelRequire("bRjUs");

var $daysG = parcelRequire("daysG");

var $gAShk = parcelRequire("gAShk");

var $3dIMU = parcelRequire("3dIMU");

var $gbBld = parcelRequire("gbBld");

var $P9VeK = parcelRequire("P9VeK");

var $24si5 = parcelRequire("24si5");

var $HOA0M = parcelRequire("HOA0M");

var $ga94M = parcelRequire("ga94M");

var $drukz = parcelRequire("drukz");

var $8Fi1u = parcelRequire("8Fi1u");

var $1gF76 = parcelRequire("1gF76");

var $iW1oU = parcelRequire("iW1oU");
const $80a0e2a6c204c6db$var$languages = [
    {
        name: 'asciidoc',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($f8yzZ)))
    },
    {
        name: 'bash',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($8mb6m)))
    },
    {
        name: 'c',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($h4vvL)))
    },
    {
        name: 'csharp',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($lx9iJ)))
    },
    {
        name: 'css',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($iXTF6)))
    },
    {
        name: 'dockerfile',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($3AIsM)))
    },
    {
        name: 'dos',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($hZGrj)))
    },
    {
        name: 'ebnf',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($5qGNl)))
    },
    {
        name: 'esql',
        module: (0, $4L31j.default)
    },
    {
        name: 'go',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($a3Tks)))
    },
    {
        name: 'gradle',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($4huqg)))
    },
    {
        name: 'groovy',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($12CYi)))
    },
    {
        name: 'handlebars',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($6lvAh)))
    },
    {
        name: 'http',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($aLzAh)))
    },
    {
        name: 'ini',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($5WypX)))
    },
    {
        name: 'java',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($ajuee)))
    },
    {
        name: 'javascript',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($79Fne)))
    },
    {
        name: 'json',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($4h2Ey)))
    },
    {
        name: 'kotlin',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($aoBt3)))
    },
    {
        name: 'markdown',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($kDduH)))
    },
    {
        name: 'nginx',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($5pr0v)))
    },
    {
        name: 'php',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($2zmWr)))
    },
    {
        name: 'plaintext',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($aMK1O)))
    },
    {
        name: 'powershell',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($bRjUs)))
    },
    {
        name: 'properties',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($daysG)))
    },
    {
        name: 'python',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($gAShk)))
    },
    {
        name: 'ruby',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($3dIMU)))
    },
    {
        name: 'rust',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($gbBld)))
    },
    {
        name: 'scala',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($P9VeK)))
    },
    {
        name: 'shell',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($24si5))),
        aliases: [
            'sh'
        ]
    },
    {
        name: 'sql',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($HOA0M)))
    },
    {
        name: 'swift',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($ga94M)))
    },
    {
        name: 'typescript',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($drukz)))
    },
    {
        name: 'xml',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($8Fi1u)))
    },
    {
        name: 'yaml',
        module: (0, (/*@__PURE__*/$parcel$interopDefault($1gF76)))
    }
];
$80a0e2a6c204c6db$var$languages.forEach((lang)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).registerLanguage(lang.name, lang.module);
    if (lang.aliases) (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).registerAliases(lang.aliases, {
        languageName: lang.name
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).registerLanguage('apiheader', function() {
    return {
        case_insensitive: true,
        keywords: 'GET POST PUT DELETE HEAD OPTIONS PATCH',
        contains: [
            (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).HASH_COMMENT_MODE,
            {
                className: 'subst',
                begin: /(?<=(?:\/|GET |POST |PUT |DELETE |HEAD |OPTIONS |PATH))[^?\n\r/]+/
            }
        ]
    };
});
const $80a0e2a6c204c6db$var$decimalDigits = '[0-9](_?[0-9])*';
const $80a0e2a6c204c6db$var$frac = `\\.(${$80a0e2a6c204c6db$var$decimalDigits})`;
const $80a0e2a6c204c6db$var$decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
const $80a0e2a6c204c6db$var$NUMBER = {
    className: 'number',
    variants: [
        {
            begin: `\\b(${$80a0e2a6c204c6db$var$decimalInteger})\\b((${$80a0e2a6c204c6db$var$frac})\\b|\\.)?|(${$80a0e2a6c204c6db$var$frac})\\b`
        },
        {
            begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
        },
        {
            begin: '\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b'
        },
        {
            begin: '\\b0[bB][0-1](_?[0-1])*n?\\b'
        },
        {
            begin: '\\b0[oO][0-7](_?[0-7])*n?\\b'
        },
        {
            begin: '\\b0[0-7]+n?\\b'
        }
    ],
    relevance: 0
};
(0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).registerLanguage('eql', function() {
    return {
        case_insensitive: true,
        keywords: {
            keyword: 'where sequence sample untill and or not in in~',
            literal: [
                'false',
                'true',
                'null'
            ],
            subst: 'add between cidrMatch concat divide endsWith indexOf length modulo multiply number startsWith string stringContains substring subtract'
        },
        contains: [
            (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).QUOTE_STRING_MODE,
            (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).C_LINE_COMMENT_MODE,
            {
                scope: 'operator',
                match: /(?:<|<=|==|:|!=|>=|>|like~?|regex~?)/
            },
            {
                scope: 'punctuation',
                match: /(?:!?\[|\]|\|)/
            },
            $80a0e2a6c204c6db$var$NUMBER
        ]
    };
});
(0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).registerLanguage('painless', function() {
    return {
        case_insensitive: true,
        keywords: {
            keyword: 'where sequence sample untill and or not in in~',
            literal: [
                'false',
                'true',
                'null'
            ],
            subst: 'add between cidrMatch concat divide endsWith indexOf length modulo multiply number startsWith string stringContains substring subtract'
        },
        contains: [
            (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).QUOTE_STRING_MODE,
            (0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).C_LINE_COMMENT_MODE,
            {
                scope: 'operator',
                match: /(?:<|<=|==|:|!=|>=|>|like~?|regex~?)/
            },
            {
                scope: 'punctuation',
                match: /(?:!?\[|\]|\|)/
            },
            $80a0e2a6c204c6db$var$NUMBER
        ]
    };
});
(0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).addPlugin((0, $hcZta.mergeHTMLPlugin));
// The unescaped HTML warning is caused by the mergeHTMLPlugin which we are using
// for code callouts
(0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).configure({
    ignoreUnescapedHTML: true
});
function $80a0e2a6c204c6db$export$553fc027481fdea0() {
    (0, $iW1oU.$$)('#markdown-content pre code:not([data-highlighted])').forEach((0, (/*@__PURE__*/$parcel$interopDefault($5H3y2))).highlightElement);
}

});
parcelRegister("hcZta", function(module, exports) {

$parcel$export(module.exports, "mergeHTMLPlugin", function () { return $c8733d37131e16ab$export$100d08fbaf3d75d6; });
const $c8733d37131e16ab$export$100d08fbaf3d75d6 = function() {
    'use strict';
    var originalStream;
    /**
   * @param {string} value
   * @returns {string}
   */ function escapeHTML(value) {
        return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
    }
    /* plugin itself */ /** @type {HLJSPlugin} */ const mergeHTMLPlugin = {
        // preserve the original HTML token stream
        'before:highlightElement': ({ el: el })=>{
            originalStream = nodeStream(el);
        },
        // merge it afterwards with the highlighted token stream
        'after:highlightElement': ({ el: el, result: result, text: text })=>{
            if (!originalStream.length) return;
            const resultNode = document.createElement('div');
            resultNode.innerHTML = result.value;
            result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
            el.innerHTML = result.value;
        }
    };
    /* Stream merging support functions */ /**
   * @typedef Event
   * @property {'start'|'stop'} event
   * @property {number} offset
   * @property {Node} node
   */ /**
   * @param {Node} node
   */ function tag(node) {
        return node.nodeName.toLowerCase();
    }
    /**
   * @param {Node} node
   */ function nodeStream(node) {
        /** @type Event[] */ const result = [];
        (function _nodeStream(node, offset) {
            for(let child = node.firstChild; child; child = child.nextSibling){
                if (child.nodeType === 3) offset += child.nodeValue.length;
                else if (child.nodeType === 1) {
                    result.push({
                        event: 'start',
                        offset: offset,
                        node: child
                    });
                    offset = _nodeStream(child, offset);
                    // Prevent void elements from having an end tag that would actually
                    // double them in the output. There are more void elements in HTML
                    // but we list only those realistically expected in code display.
                    if (!tag(child).match(/br|hr|img|input/)) result.push({
                        event: 'stop',
                        offset: offset,
                        node: child
                    });
                }
            }
            return offset;
        })(node, 0);
        return result;
    }
    /**
   * @param {any} original - the original stream
   * @param {any} highlighted - stream of the highlighted source
   * @param {string} value - the original source itself
   */ function mergeStreams(original, highlighted, value) {
        let processed = 0;
        let result = '';
        const nodeStack = [];
        function selectStream() {
            if (!original.length || !highlighted.length) return original.length ? original : highlighted;
            if (original[0].offset !== highlighted[0].offset) return original[0].offset < highlighted[0].offset ? original : highlighted;
            /*
      To avoid starting the stream just before it should stop the order is
      ensured that original always starts first and closes last:

      if (event1 == 'start' && event2 == 'start')
        return original;
      if (event1 == 'start' && event2 == 'stop')
        return highlighted;
      if (event1 == 'stop' && event2 == 'start')
        return original;
      if (event1 == 'stop' && event2 == 'stop')
        return highlighted;

      ... which is collapsed to:
      */ return highlighted[0].event === 'start' ? original : highlighted;
        }
        /**
     * @param {Node} node
     */ function open(node) {
            /** @param {Attr} attr */ function attributeString(attr) {
                return ' ' + attr.nodeName + '="' + escapeHTML(attr.value) + '"';
            }
            result += '<' + tag(node) + [].map.call(node.attributes, attributeString).join('') + '>';
        }
        /**
     * @param {Node} node
     */ function close(node) {
            result += '</' + tag(node) + '>';
        }
        /**
     * @param {Event} event
     */ function render(event) {
            (event.event === 'start' ? open : close)(event.node);
        }
        while(original.length || highlighted.length){
            let stream = selectStream();
            result += escapeHTML(value.substring(processed, stream[0].offset));
            processed = stream[0].offset;
            if (stream === original) {
                /*
        On any opening or closing tag of the original markup we first close
        the entire highlighted node stack, then render the original tag along
        with all the following original tags at the same offset and then
        reopen all the tags on the highlighted stack.
        */ nodeStack.reverse().forEach(close);
                do {
                    render(stream.splice(0, 1)[0]);
                    stream = selectStream();
                }while (stream === original && stream.length && stream[0].offset === processed);
                nodeStack.reverse().forEach(open);
            } else {
                if (stream[0].event === 'start') nodeStack.push(stream[0].node);
                else nodeStack.pop();
                render(stream.splice(0, 1)[0]);
            }
        }
        return result + escapeHTML(value.substr(processed));
    }
    return mergeHTMLPlugin;
}();

});

parcelRegister("4L31j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $376de4f34fb4b3b8$export$2e2bcd8739ae039; });
/*
Language: ES|QL
Description: language definition for Elastic ES|QL language
Website: https://www.elastic.co/guide/en/elasticsearch/reference/current/esql.html
Category: enterprise
*/ const $376de4f34fb4b3b8$var$source = (re)=>{
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
};
const $376de4f34fb4b3b8$var$concat = (...args)=>{
    const joined = args.map((x)=>$376de4f34fb4b3b8$var$source(x)).join("");
    return joined;
};
const $376de4f34fb4b3b8$var$either = (...args)=>{
    const joined = '(' + args.map((x)=>$376de4f34fb4b3b8$var$source(x)).join("|") + ")";
    return joined;
};
function $376de4f34fb4b3b8$export$2e2bcd8739ae039(hljs) {
    const literals = [
        'TRUE',
        'FALSE',
        'NULL'
    ];
    const binaryNamedOperators = [
        'AND',
        'OR',
        'IS',
        'IN',
        'AS',
        'LIKE',
        'RLIKE'
    ];
    const otherNamedOperators = [
        'ASC',
        'DESC',
        'FIRST',
        'LAST',
        'NULLS',
        'NOT'
    ];
    const keywords = [
        'BY',
        'ON',
        'WITH',
        'METADATA'
    ];
    const commands = [
        'CHANGE_POINT',
        'COMPLETION',
        'DISSECT',
        'DROP',
        'ENRICH',
        'EVAL',
        'EXPLAIN',
        'FORK',
        'FROM',
        'FULL JOIN',
        'FUSE',
        'GROK',
        'INFO',
        'INLINESTATS',
        'JOIN',
        'KEEP',
        'LEFT JOIN',
        'LEFT',
        'LIMIT',
        'LOOKUP JOIN',
        'LOOKUP',
        'METRICS',
        'MV_EXPAND',
        'RENAME',
        'RERANK',
        'RIGHT JOIN',
        'RIGHT',
        'ROW',
        'RRF',
        'SAMPLE',
        'SHOW INFO',
        'SHOW',
        'SORT',
        'STATS',
        'TS',
        'WHERE'
    ];
    const OPERATOR = {
        className: "operator",
        match: /\|\+\-%\*\//
    };
    const STRING = {
        className: 'string',
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const functions = [
        'ABS',
        'ACOS',
        'ASIN',
        'ATAN',
        'ATAN2',
        'AVG',
        'BIT_LENGTH',
        'BUCKET',
        'BYTE_LENGTH',
        'CASE',
        'CATEGORIZE',
        'CBRT',
        'CEIL',
        'CIDR_MATCH',
        'COALESCE',
        'CONCAT',
        'COS',
        'COSH',
        'COUNT_DISTINCT',
        'COUNT',
        'DATE_DIFF',
        'DATE_EXTRACT',
        'DATE_FORMAT',
        'DATE_PARSE',
        'DATE_TRUNC',
        'E',
        'ENDS_WITH',
        'EXP',
        'FLOOR',
        'FROM_BASE64',
        'GREATEST',
        'HASH',
        'HYPOT',
        'IP_PREFIX',
        'LEAST',
        'LEFT',
        'LENGTH',
        'LOCATE',
        'LOG',
        'LOG10',
        'LTRIM',
        'MATCH',
        'MAX',
        'MEDIAN_ABSOLUTE_DEVIATION',
        'MEDIAN',
        'MIN',
        'MV_APPEND',
        'MV_AVG',
        'MV_CONCAT',
        'MV_COUNT',
        'MV_DEDUPE',
        'MV_FIRST',
        'MV_LAST',
        'MV_MAX',
        'MV_MEDIAN_ABSOLUTE_DEVIATION',
        'MV_MEDIAN',
        'MV_MIN',
        'MV_PERCENTILE',
        'MV_PSERIES_WEIGHTED_SUM',
        'MV_SLICE',
        'MV_SORT',
        'MV_SUM',
        'MV_ZIP',
        'NOW',
        'PERCENTILE',
        'PI',
        'POW',
        'QSTR',
        'REPEAT',
        'REPLACE',
        'REVERSE',
        'RIGHT',
        'ROUND',
        'RTRIM',
        'SIGNUM',
        'SIN',
        'SINH',
        'SPACE',
        'SPLIT',
        'SQRT',
        'ST_CENTROID_AGG',
        'ST_CONTAINS',
        'ST_DISJOINT',
        'ST_DISTANCE',
        'ST_ENVELOPE',
        'ST_EXTENT_AGG',
        'ST_INTERSECTS',
        'ST_WITHIN',
        'ST_X',
        'ST_XMAX',
        'ST_XMIN',
        'ST_Y',
        'ST_YMAX',
        'ST_YMIN',
        'STARTS_WITH',
        'STD_DEV',
        'SUBSTRING',
        'SUM',
        'TAN',
        'TANH',
        'TAU',
        'TO_BASE64',
        'TO_BOOLEAN',
        'TO_CARTESIANPOINT',
        'TO_CARTESIANSHAPE',
        'TO_DATE_NANOS',
        'TO_DATEPERIOD',
        'TO_DATETIME',
        'TO_DEGREES',
        'TO_DOUBLE',
        'TO_GEOPOINT',
        'TO_GEOSHAPE',
        'TO_INTEGER',
        'TO_IP',
        'TO_LONG',
        'TO_LOWER',
        'TO_RADIANS',
        'TO_STRING',
        'TO_TIMEDURATION',
        'TO_UNSIGNED_LONG',
        'TO_UPPER',
        'TO_VERSION',
        'TOP',
        'TRIM',
        'VALUES',
        'WEIGHTED_AVG'
    ];
    const FUNCTION_CALL = {
        className: 'function',
        begin: $376de4f34fb4b3b8$var$concat(/\b/, $376de4f34fb4b3b8$var$either(...functions), /\s*\(/),
        keywords: {
            keyword: functions
        }
    };
    const DOCTAGS = hljs.COMMENT('/\\*', '\\*/', {
        contains: [
            {
                scope: 'doctag',
                begin: '@\\w+'
            }
        ]
    });
    const PARAM = {
        className: 'variable',
        begin: '\\?(\\w+)?'
    };
    const CAST = {
        className: 'type',
        begin: '::\\w+'
    };
    const PUNCTUATION = {
        scope: "punctuation",
        match: /[,;{}\[\]\(\)]/
    };
    return {
        name: 'esql',
        aliases: [
            'es|ql'
        ],
        case_insensitive: true,
        keywords: {
            $pattern: /\b[\w\.]+\b/,
            keyword: [
                ...keywords,
                ...commands
            ],
            built_in: [
                ...binaryNamedOperators,
                ...otherNamedOperators
            ],
            literal: literals
        },
        contains: [
            DOCTAGS,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            OPERATOR,
            FUNCTION_CALL,
            STRING,
            PARAM,
            CAST,
            PUNCTUATION
        ],
        illegal: /[{}]|<\//
    };
}

});

parcelRegister("5H3y2", function(module, exports) {
/* eslint-disable no-multi-assign */ function $4253b8727c723f00$var$deepFreeze(obj) {
    if (obj instanceof Map) obj.clear = obj.delete = obj.set = function() {
        throw new Error('map is read-only');
    };
    else if (obj instanceof Set) obj.add = obj.clear = obj.delete = function() {
        throw new Error('set is read-only');
    };
    // Freeze self
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach((name)=>{
        const prop = obj[name];
        const type = typeof prop;
        // Freeze prop if it is an object or function and also not already frozen
        if ((type === 'object' || type === 'function') && !Object.isFrozen(prop)) $4253b8727c723f00$var$deepFreeze(prop);
    });
    return obj;
}
/** @typedef {import('highlight.js').CallbackResponse} CallbackResponse */ /** @typedef {import('highlight.js').CompiledMode} CompiledMode */ /** @implements CallbackResponse */ class $4253b8727c723f00$var$Response {
    /**
   * @param {CompiledMode} mode
   */ constructor(mode){
        // eslint-disable-next-line no-undefined
        if (mode.data === undefined) mode.data = {};
        this.data = mode.data;
        this.isMatchIgnored = false;
    }
    ignoreMatch() {
        this.isMatchIgnored = true;
    }
}
/**
 * @param {string} value
 * @returns {string}
 */ function $4253b8727c723f00$var$escapeHTML(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
}
/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */ function $4253b8727c723f00$var$inherit$1(original, ...objects) {
    /** @type Record<string,any> */ const result = Object.create(null);
    for(const key in original)result[key] = original[key];
    objects.forEach(function(obj) {
        for(const key in obj)result[key] = obj[key];
    });
    return /** @type {T} */ result;
}
/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */ /** @typedef {{scope?: string, language?: string, sublanguage?: boolean}} Node */ /** @typedef {{walk: (r: Renderer) => void}} Tree */ /** */ const $4253b8727c723f00$var$SPAN_CLOSE = '</span>';
/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */ const $4253b8727c723f00$var$emitsWrappingTags = (node)=>{
    // rarely we can have a sublanguage where language is undefined
    // TODO: track down why
    return !!node.scope;
};
/**
 *
 * @param {string} name
 * @param {{prefix:string}} options
 */ const $4253b8727c723f00$var$scopeToCSSClass = (name, { prefix: prefix })=>{
    // sub-language
    if (name.startsWith("language:")) return name.replace("language:", "language-");
    // tiered scope: comment.line
    if (name.includes(".")) {
        const pieces = name.split(".");
        return [
            `${prefix}${pieces.shift()}`,
            ...pieces.map((x, i)=>`${x}${"_".repeat(i + 1)}`)
        ].join(" ");
    }
    // simple scope
    return `${prefix}${name}`;
};
/** @type {Renderer} */ class $4253b8727c723f00$var$HTMLRenderer {
    /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */ constructor(parseTree, options){
        this.buffer = "";
        this.classPrefix = options.classPrefix;
        parseTree.walk(this);
    }
    /**
   * Adds texts to the output stream
   *
   * @param {string} text */ addText(text) {
        this.buffer += $4253b8727c723f00$var$escapeHTML(text);
    }
    /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */ openNode(node) {
        if (!$4253b8727c723f00$var$emitsWrappingTags(node)) return;
        const className = $4253b8727c723f00$var$scopeToCSSClass(node.scope, {
            prefix: this.classPrefix
        });
        this.span(className);
    }
    /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */ closeNode(node) {
        if (!$4253b8727c723f00$var$emitsWrappingTags(node)) return;
        this.buffer += $4253b8727c723f00$var$SPAN_CLOSE;
    }
    /**
   * returns the accumulated buffer
  */ value() {
        return this.buffer;
    }
    // helpers
    /**
   * Builds a span element
   *
   * @param {string} className */ span(className) {
        this.buffer += `<span class="${className}">`;
    }
}
/** @typedef {{scope?: string, language?: string, children: Node[]} | string} Node */ /** @typedef {{scope?: string, language?: string, children: Node[]} } DataNode */ /** @typedef {import('highlight.js').Emitter} Emitter */ /**  */ /** @returns {DataNode} */ const $4253b8727c723f00$var$newNode = (opts = {})=>{
    /** @type DataNode */ const result = {
        children: []
    };
    Object.assign(result, opts);
    return result;
};
class $4253b8727c723f00$var$TokenTree {
    constructor(){
        /** @type DataNode */ this.rootNode = $4253b8727c723f00$var$newNode();
        this.stack = [
            this.rootNode
        ];
    }
    get top() {
        return this.stack[this.stack.length - 1];
    }
    get root() {
        return this.rootNode;
    }
    /** @param {Node} node */ add(node) {
        this.top.children.push(node);
    }
    /** @param {string} scope */ openNode(scope) {
        /** @type Node */ const node = $4253b8727c723f00$var$newNode({
            scope: scope
        });
        this.add(node);
        this.stack.push(node);
    }
    closeNode() {
        if (this.stack.length > 1) return this.stack.pop();
        // eslint-disable-next-line no-undefined
        return undefined;
    }
    closeAllNodes() {
        while(this.closeNode());
    }
    toJSON() {
        return JSON.stringify(this.rootNode, null, 4);
    }
    /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */ walk(builder) {
        // this does not
        return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
    }
    /**
   * @param {Renderer} builder
   * @param {Node} node
   */ static _walk(builder, node) {
        if (typeof node === "string") builder.addText(node);
        else if (node.children) {
            builder.openNode(node);
            node.children.forEach((child)=>this._walk(builder, child));
            builder.closeNode(node);
        }
        return builder;
    }
    /**
   * @param {Node} node
   */ static _collapse(node) {
        if (typeof node === "string") return;
        if (!node.children) return;
        if (node.children.every((el)=>typeof el === "string")) // node.text = node.children.join("");
        // delete node.children;
        node.children = [
            node.children.join("")
        ];
        else node.children.forEach((child)=>{
            $4253b8727c723f00$var$TokenTree._collapse(child);
        });
    }
}
/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addText(text)
  - __addSublanguage(emitter, subLanguageName)
  - startScope(scope)
  - endScope()
  - finalize()
  - toHTML()

*/ /**
 * @implements {Emitter}
 */ class $4253b8727c723f00$var$TokenTreeEmitter extends $4253b8727c723f00$var$TokenTree {
    /**
   * @param {*} options
   */ constructor(options){
        super();
        this.options = options;
    }
    /**
   * @param {string} text
   */ addText(text) {
        if (text === "") return;
        this.add(text);
    }
    /** @param {string} scope */ startScope(scope) {
        this.openNode(scope);
    }
    endScope() {
        this.closeNode();
    }
    /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */ __addSublanguage(emitter, name) {
        /** @type DataNode */ const node = emitter.root;
        if (name) node.scope = `language:${name}`;
        this.add(node);
    }
    toHTML() {
        const renderer = new $4253b8727c723f00$var$HTMLRenderer(this, this.options);
        return renderer.value();
    }
    finalize() {
        this.closeAllNodes();
        return true;
    }
}
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $4253b8727c723f00$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $4253b8727c723f00$var$lookahead(re) {
    return $4253b8727c723f00$var$concat('(?=', re, ')');
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $4253b8727c723f00$var$anyNumberOfTimes(re) {
    return $4253b8727c723f00$var$concat('(?:', re, ')*');
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $4253b8727c723f00$var$optional(re) {
    return $4253b8727c723f00$var$concat('(?:', re, ')?');
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $4253b8727c723f00$var$concat(...args) {
    const joined = args.map((x)=>$4253b8727c723f00$var$source(x)).join("");
    return joined;
}
/**
 * @param { Array<string | RegExp | Object> } args
 * @returns {object}
 */ function $4253b8727c723f00$var$stripOptionsFromArgs(args) {
    const opts = args[args.length - 1];
    if (typeof opts === 'object' && opts.constructor === Object) {
        args.splice(args.length - 1, 1);
        return opts;
    } else return {};
}
/** @typedef { {capture?: boolean} } RegexEitherOptions */ /**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
 * @returns {string}
 */ function $4253b8727c723f00$var$either(...args) {
    /** @type { object & {capture?: boolean} }  */ const opts = $4253b8727c723f00$var$stripOptionsFromArgs(args);
    const joined = '(' + (opts.capture ? "" : "?:") + args.map((x)=>$4253b8727c723f00$var$source(x)).join("|") + ")";
    return joined;
}
/**
 * @param {RegExp | string} re
 * @returns {number}
 */ function $4253b8727c723f00$var$countMatchGroups(re) {
    return new RegExp(re.toString() + '|').exec('').length - 1;
}
/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */ function $4253b8727c723f00$var$startsWith(re, lexeme) {
    const match = re && re.exec(lexeme);
    return match && match.index === 0;
}
// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const $4253b8727c723f00$var$BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
// **INTERNAL** Not intended for outside usage
// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {{joinWith: string}} opts
 * @returns {string}
 */ function $4253b8727c723f00$var$_rewriteBackreferences(regexps, { joinWith: joinWith }) {
    let numCaptures = 0;
    return regexps.map((regex)=>{
        numCaptures += 1;
        const offset = numCaptures;
        let re = $4253b8727c723f00$var$source(regex);
        let out = '';
        while(re.length > 0){
            const match = $4253b8727c723f00$var$BACKREF_RE.exec(re);
            if (!match) {
                out += re;
                break;
            }
            out += re.substring(0, match.index);
            re = re.substring(match.index + match[0].length);
            if (match[0][0] === '\\' && match[1]) // Adjust the backreference.
            out += '\\' + String(Number(match[1]) + offset);
            else {
                out += match[0];
                if (match[0] === '(') numCaptures++;
            }
        }
        return out;
    }).map((re)=>`(${re})`).join(joinWith);
}
/** @typedef {import('highlight.js').Mode} Mode */ /** @typedef {import('highlight.js').ModeCallback} ModeCallback */ // Common regexps
const $4253b8727c723f00$var$MATCH_NOTHING_RE = /\b\B/;
const $4253b8727c723f00$var$IDENT_RE = '[a-zA-Z]\\w*';
const $4253b8727c723f00$var$UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const $4253b8727c723f00$var$NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const $4253b8727c723f00$var$C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const $4253b8727c723f00$var$BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const $4253b8727c723f00$var$RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/ const $4253b8727c723f00$var$SHEBANG = (opts = {})=>{
    const beginShebang = /^#![ ]*\//;
    if (opts.binary) opts.begin = $4253b8727c723f00$var$concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
    return $4253b8727c723f00$var$inherit$1({
        scope: 'meta',
        begin: beginShebang,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            if (m.index !== 0) resp.ignoreMatch();
        }
    }, opts);
};
// Common modes
const $4253b8727c723f00$var$BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]',
    relevance: 0
};
const $4253b8727c723f00$var$APOS_STRING_MODE = {
    scope: 'string',
    begin: '\'',
    end: '\'',
    illegal: '\\n',
    contains: [
        $4253b8727c723f00$var$BACKSLASH_ESCAPE
    ]
};
const $4253b8727c723f00$var$QUOTE_STRING_MODE = {
    scope: 'string',
    begin: '"',
    end: '"',
    illegal: '\\n',
    contains: [
        $4253b8727c723f00$var$BACKSLASH_ESCAPE
    ]
};
const $4253b8727c723f00$var$PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */ const $4253b8727c723f00$var$COMMENT = function(begin, end, modeOptions = {}) {
    const mode = $4253b8727c723f00$var$inherit$1({
        scope: 'comment',
        begin: begin,
        end: end,
        contains: []
    }, modeOptions);
    mode.contains.push({
        scope: 'doctag',
        // hack to avoid the space from being included. the space is necessary to
        // match here to prevent the plain text rule below from gobbling up doctags
        begin: '[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)',
        end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
        excludeBegin: true,
        relevance: 0
    });
    const ENGLISH_WORD = $4253b8727c723f00$var$either(// list of common 1 and 2 letter words in English
    "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/ // allow capitalized words at beginning of sentences
    );
    // looking like plain text, more likely to be a comment
    mode.contains.push({
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: $4253b8727c723f00$var$concat(/[ ]+/, '(', ENGLISH_WORD, /[.]?[:]?([.][ ]|[ ])/, '){3}') // look for 3 words in a row
    });
    return mode;
};
const $4253b8727c723f00$var$C_LINE_COMMENT_MODE = $4253b8727c723f00$var$COMMENT('//', '$');
const $4253b8727c723f00$var$C_BLOCK_COMMENT_MODE = $4253b8727c723f00$var$COMMENT('/\\*', '\\*/');
const $4253b8727c723f00$var$HASH_COMMENT_MODE = $4253b8727c723f00$var$COMMENT('#', '$');
const $4253b8727c723f00$var$NUMBER_MODE = {
    scope: 'number',
    begin: $4253b8727c723f00$var$NUMBER_RE,
    relevance: 0
};
const $4253b8727c723f00$var$C_NUMBER_MODE = {
    scope: 'number',
    begin: $4253b8727c723f00$var$C_NUMBER_RE,
    relevance: 0
};
const $4253b8727c723f00$var$BINARY_NUMBER_MODE = {
    scope: 'number',
    begin: $4253b8727c723f00$var$BINARY_NUMBER_RE,
    relevance: 0
};
const $4253b8727c723f00$var$REGEXP_MODE = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
        $4253b8727c723f00$var$BACKSLASH_ESCAPE,
        {
            begin: /\[/,
            end: /\]/,
            relevance: 0,
            contains: [
                $4253b8727c723f00$var$BACKSLASH_ESCAPE
            ]
        }
    ]
};
const $4253b8727c723f00$var$TITLE_MODE = {
    scope: 'title',
    begin: $4253b8727c723f00$var$IDENT_RE,
    relevance: 0
};
const $4253b8727c723f00$var$UNDERSCORE_TITLE_MODE = {
    scope: 'title',
    begin: $4253b8727c723f00$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
const $4253b8727c723f00$var$METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + $4253b8727c723f00$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */ const $4253b8727c723f00$var$END_SAME_AS_BEGIN = function(mode) {
    return Object.assign(mode, {
        /** @type {ModeCallback} */ 'on:begin': (m, resp)=>{
            resp.data._beginMatch = m[1];
        },
        /** @type {ModeCallback} */ 'on:end': (m, resp)=>{
            if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
    });
};
var $4253b8727c723f00$var$MODES = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: $4253b8727c723f00$var$APOS_STRING_MODE,
    BACKSLASH_ESCAPE: $4253b8727c723f00$var$BACKSLASH_ESCAPE,
    BINARY_NUMBER_MODE: $4253b8727c723f00$var$BINARY_NUMBER_MODE,
    BINARY_NUMBER_RE: $4253b8727c723f00$var$BINARY_NUMBER_RE,
    COMMENT: $4253b8727c723f00$var$COMMENT,
    C_BLOCK_COMMENT_MODE: $4253b8727c723f00$var$C_BLOCK_COMMENT_MODE,
    C_LINE_COMMENT_MODE: $4253b8727c723f00$var$C_LINE_COMMENT_MODE,
    C_NUMBER_MODE: $4253b8727c723f00$var$C_NUMBER_MODE,
    C_NUMBER_RE: $4253b8727c723f00$var$C_NUMBER_RE,
    END_SAME_AS_BEGIN: $4253b8727c723f00$var$END_SAME_AS_BEGIN,
    HASH_COMMENT_MODE: $4253b8727c723f00$var$HASH_COMMENT_MODE,
    IDENT_RE: $4253b8727c723f00$var$IDENT_RE,
    MATCH_NOTHING_RE: $4253b8727c723f00$var$MATCH_NOTHING_RE,
    METHOD_GUARD: $4253b8727c723f00$var$METHOD_GUARD,
    NUMBER_MODE: $4253b8727c723f00$var$NUMBER_MODE,
    NUMBER_RE: $4253b8727c723f00$var$NUMBER_RE,
    PHRASAL_WORDS_MODE: $4253b8727c723f00$var$PHRASAL_WORDS_MODE,
    QUOTE_STRING_MODE: $4253b8727c723f00$var$QUOTE_STRING_MODE,
    REGEXP_MODE: $4253b8727c723f00$var$REGEXP_MODE,
    RE_STARTERS_RE: $4253b8727c723f00$var$RE_STARTERS_RE,
    SHEBANG: $4253b8727c723f00$var$SHEBANG,
    TITLE_MODE: $4253b8727c723f00$var$TITLE_MODE,
    UNDERSCORE_IDENT_RE: $4253b8727c723f00$var$UNDERSCORE_IDENT_RE,
    UNDERSCORE_TITLE_MODE: $4253b8727c723f00$var$UNDERSCORE_TITLE_MODE
});
/**
@typedef {import('highlight.js').CallbackResponse} CallbackResponse
@typedef {import('highlight.js').CompilerExt} CompilerExt
*/ // Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833
// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.
// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.
// ------
// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */ function $4253b8727c723f00$var$skipIfHasPrecedingDot(match, response) {
    const before = match.input[match.index - 1];
    if (before === ".") response.ignoreMatch();
}
/**
 *
 * @type {CompilerExt}
 */ function $4253b8727c723f00$var$scopeClassName(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.className !== undefined) {
        mode.scope = mode.className;
        delete mode.className;
    }
}
/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */ function $4253b8727c723f00$var$beginKeywords(mode, parent) {
    if (!parent) return;
    if (!mode.beginKeywords) return;
    // for languages with keywords that include non-word characters checking for
    // a word boundary is not sufficient, so instead we check for a word boundary
    // or whitespace - this does no harm in any case since our keyword engine
    // doesn't allow spaces in keywords anyways and we still check for the boundary
    // first
    mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
    mode.__beforeBegin = $4253b8727c723f00$var$skipIfHasPrecedingDot;
    mode.keywords = mode.keywords || mode.beginKeywords;
    delete mode.beginKeywords;
    // prevents double relevance, the keywords themselves provide
    // relevance, the mode doesn't need to double it
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 0;
}
/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */ function $4253b8727c723f00$var$compileIllegal(mode, _parent) {
    if (!Array.isArray(mode.illegal)) return;
    mode.illegal = $4253b8727c723f00$var$either(...mode.illegal);
}
/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */ function $4253b8727c723f00$var$compileMatch(mode, _parent) {
    if (!mode.match) return;
    if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
    mode.begin = mode.match;
    delete mode.match;
}
/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */ function $4253b8727c723f00$var$compileRelevance(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 1;
}
// allow beforeMatch to act as a "qualifier" for the match
// the full match begin must be [beforeMatch][begin]
const $4253b8727c723f00$var$beforeMatchExt = (mode, parent)=>{
    if (!mode.beforeMatch) return;
    // starts conflicts with endsParent which we need to make sure the child
    // rule is not matched multiple times
    if (mode.starts) throw new Error("beforeMatch cannot be used with starts");
    const originalMode = Object.assign({}, mode);
    Object.keys(mode).forEach((key)=>{
        delete mode[key];
    });
    mode.keywords = originalMode.keywords;
    mode.begin = $4253b8727c723f00$var$concat(originalMode.beforeMatch, $4253b8727c723f00$var$lookahead(originalMode.begin));
    mode.starts = {
        relevance: 0,
        contains: [
            Object.assign(originalMode, {
                endsParent: true
            })
        ]
    };
    mode.relevance = 0;
    delete originalMode.beforeMatch;
};
// keywords that should have no default relevance value
const $4253b8727c723f00$var$COMMON_KEYWORDS = [
    'of',
    'and',
    'for',
    'in',
    'not',
    'or',
    'if',
    'then',
    'parent',
    'list',
    'value' // common variable name
];
const $4253b8727c723f00$var$DEFAULT_KEYWORD_SCOPE = "keyword";
/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */ function $4253b8727c723f00$var$compileKeywords(rawKeywords, caseInsensitive, scopeName = $4253b8727c723f00$var$DEFAULT_KEYWORD_SCOPE) {
    /** @type {import("highlight.js/private").KeywordDict} */ const compiledKeywords = Object.create(null);
    // input can be a string of keywords, an array of keywords, or a object with
    // named keys representing scopeName (which can then point to a string or array)
    if (typeof rawKeywords === 'string') compileList(scopeName, rawKeywords.split(" "));
    else if (Array.isArray(rawKeywords)) compileList(scopeName, rawKeywords);
    else Object.keys(rawKeywords).forEach(function(scopeName) {
        // collapse all our objects back into the parent object
        Object.assign(compiledKeywords, $4253b8727c723f00$var$compileKeywords(rawKeywords[scopeName], caseInsensitive, scopeName));
    });
    return compiledKeywords;
    // ---
    /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} scopeName
   * @param {Array<string>} keywordList
   */ function compileList(scopeName, keywordList) {
        if (caseInsensitive) keywordList = keywordList.map((x)=>x.toLowerCase());
        keywordList.forEach(function(keyword) {
            const pair = keyword.split('|');
            compiledKeywords[pair[0]] = [
                scopeName,
                $4253b8727c723f00$var$scoreForKeyword(pair[0], pair[1])
            ];
        });
    }
}
/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */ function $4253b8727c723f00$var$scoreForKeyword(keyword, providedScore) {
    // manual scores always win over common keywords
    // so you can force a score of 1 if you really insist
    if (providedScore) return Number(providedScore);
    return $4253b8727c723f00$var$commonKeyword(keyword) ? 0 : 1;
}
/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */ function $4253b8727c723f00$var$commonKeyword(keyword) {
    return $4253b8727c723f00$var$COMMON_KEYWORDS.includes(keyword.toLowerCase());
}
/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/ /**
 * @type {Record<string, boolean>}
 */ const $4253b8727c723f00$var$seenDeprecations = {};
/**
 * @param {string} message
 */ const $4253b8727c723f00$var$error = (message)=>{
    console.error(message);
};
/**
 * @param {string} message
 * @param {any} args
 */ const $4253b8727c723f00$var$warn = (message, ...args)=>{
    console.log(`WARN: ${message}`, ...args);
};
/**
 * @param {string} version
 * @param {string} message
 */ const $4253b8727c723f00$var$deprecated = (version, message)=>{
    if ($4253b8727c723f00$var$seenDeprecations[`${version}/${message}`]) return;
    console.log(`Deprecated as of ${version}. ${message}`);
    $4253b8727c723f00$var$seenDeprecations[`${version}/${message}`] = true;
};
/* eslint-disable no-throw-literal */ /**
@typedef {import('highlight.js').CompiledMode} CompiledMode
*/ const $4253b8727c723f00$var$MultiClassError = new Error();
/**
 * Renumbers labeled scope names to account for additional inner match
 * groups that otherwise would break everything.
 *
 * Lets say we 3 match scopes:
 *
 *   { 1 => ..., 2 => ..., 3 => ... }
 *
 * So what we need is a clean match like this:
 *
 *   (a)(b)(c) => [ "a", "b", "c" ]
 *
 * But this falls apart with inner match groups:
 *
 * (a)(((b)))(c) => ["a", "b", "b", "b", "c" ]
 *
 * Our scopes are now "out of alignment" and we're repeating `b` 3 times.
 * What needs to happen is the numbers are remapped:
 *
 *   { 1 => ..., 2 => ..., 5 => ... }
 *
 * We also need to know that the ONLY groups that should be output
 * are 1, 2, and 5.  This function handles this behavior.
 *
 * @param {CompiledMode} mode
 * @param {Array<RegExp | string>} regexes
 * @param {{key: "beginScope"|"endScope"}} opts
 */ function $4253b8727c723f00$var$remapScopeNames(mode, regexes, { key: key }) {
    let offset = 0;
    const scopeNames = mode[key];
    /** @type Record<number,boolean> */ const emit = {};
    /** @type Record<number,string> */ const positions = {};
    for(let i = 1; i <= regexes.length; i++){
        positions[i + offset] = scopeNames[i];
        emit[i + offset] = true;
        offset += $4253b8727c723f00$var$countMatchGroups(regexes[i - 1]);
    }
    // we use _emit to keep track of which match groups are "top-level" to avoid double
    // output from inside match groups
    mode[key] = positions;
    mode[key]._emit = emit;
    mode[key]._multi = true;
}
/**
 * @param {CompiledMode} mode
 */ function $4253b8727c723f00$var$beginMultiClass(mode) {
    if (!Array.isArray(mode.begin)) return;
    if (mode.skip || mode.excludeBegin || mode.returnBegin) {
        $4253b8727c723f00$var$error("skip, excludeBegin, returnBegin not compatible with beginScope: {}");
        throw $4253b8727c723f00$var$MultiClassError;
    }
    if (typeof mode.beginScope !== "object" || mode.beginScope === null) {
        $4253b8727c723f00$var$error("beginScope must be object");
        throw $4253b8727c723f00$var$MultiClassError;
    }
    $4253b8727c723f00$var$remapScopeNames(mode, mode.begin, {
        key: "beginScope"
    });
    mode.begin = $4253b8727c723f00$var$_rewriteBackreferences(mode.begin, {
        joinWith: ""
    });
}
/**
 * @param {CompiledMode} mode
 */ function $4253b8727c723f00$var$endMultiClass(mode) {
    if (!Array.isArray(mode.end)) return;
    if (mode.skip || mode.excludeEnd || mode.returnEnd) {
        $4253b8727c723f00$var$error("skip, excludeEnd, returnEnd not compatible with endScope: {}");
        throw $4253b8727c723f00$var$MultiClassError;
    }
    if (typeof mode.endScope !== "object" || mode.endScope === null) {
        $4253b8727c723f00$var$error("endScope must be object");
        throw $4253b8727c723f00$var$MultiClassError;
    }
    $4253b8727c723f00$var$remapScopeNames(mode, mode.end, {
        key: "endScope"
    });
    mode.end = $4253b8727c723f00$var$_rewriteBackreferences(mode.end, {
        joinWith: ""
    });
}
/**
 * this exists only to allow `scope: {}` to be used beside `match:`
 * Otherwise `beginScope` would necessary and that would look weird

  {
    match: [ /def/, /\w+/ ]
    scope: { 1: "keyword" , 2: "title" }
  }

 * @param {CompiledMode} mode
 */ function $4253b8727c723f00$var$scopeSugar(mode) {
    if (mode.scope && typeof mode.scope === "object" && mode.scope !== null) {
        mode.beginScope = mode.scope;
        delete mode.scope;
    }
}
/**
 * @param {CompiledMode} mode
 */ function $4253b8727c723f00$var$MultiClass(mode) {
    $4253b8727c723f00$var$scopeSugar(mode);
    if (typeof mode.beginScope === "string") mode.beginScope = {
        _wrap: mode.beginScope
    };
    if (typeof mode.endScope === "string") mode.endScope = {
        _wrap: mode.endScope
    };
    $4253b8727c723f00$var$beginMultiClass(mode);
    $4253b8727c723f00$var$endMultiClass(mode);
}
/**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').CompiledLanguage} CompiledLanguage
*/ // compilation
/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @returns {CompiledLanguage}
 */ function $4253b8727c723f00$var$compileLanguage(language) {
    /**
   * Builds a regex with the case sensitivity of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */ function langRe(value, global) {
        return new RegExp($4253b8727c723f00$var$source(value), 'm' + (language.case_insensitive ? 'i' : '') + (language.unicodeRegex ? 'u' : '') + (global ? 'g' : ''));
    }
    /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */ class MultiRegex {
        constructor(){
            this.matchIndexes = {};
            // @ts-ignore
            this.regexes = [];
            this.matchAt = 1;
            this.position = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            opts.position = this.position++;
            // @ts-ignore
            this.matchIndexes[this.matchAt] = opts;
            this.regexes.push([
                opts,
                re
            ]);
            this.matchAt += $4253b8727c723f00$var$countMatchGroups(re) + 1;
        }
        compile() {
            if (this.regexes.length === 0) // avoids the need to check length every time exec is called
            // @ts-ignore
            this.exec = ()=>null;
            const terminators = this.regexes.map((el)=>el[1]);
            this.matcherRe = langRe($4253b8727c723f00$var$_rewriteBackreferences(terminators, {
                joinWith: '|'
            }), true);
            this.lastIndex = 0;
        }
        /** @param {string} s */ exec(s) {
            this.matcherRe.lastIndex = this.lastIndex;
            const match = this.matcherRe.exec(s);
            if (!match) return null;
            // eslint-disable-next-line no-undefined
            const i = match.findIndex((el, i)=>i > 0 && el !== undefined);
            // @ts-ignore
            const matchData = this.matchIndexes[i];
            // trim off any earlier non-relevant match groups (ie, the other regex
            // match groups that make up the multi-matcher)
            match.splice(0, i);
            return Object.assign(match, matchData);
        }
    }
    /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */ class ResumableMultiRegex {
        constructor(){
            // @ts-ignore
            this.rules = [];
            // @ts-ignore
            this.multiRegexes = [];
            this.count = 0;
            this.lastIndex = 0;
            this.regexIndex = 0;
        }
        // @ts-ignore
        getMatcher(index) {
            if (this.multiRegexes[index]) return this.multiRegexes[index];
            const matcher = new MultiRegex();
            this.rules.slice(index).forEach(([re, opts])=>matcher.addRule(re, opts));
            matcher.compile();
            this.multiRegexes[index] = matcher;
            return matcher;
        }
        resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
        }
        considerAll() {
            this.regexIndex = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            this.rules.push([
                re,
                opts
            ]);
            if (opts.type === "begin") this.count++;
        }
        /** @param {string} s */ exec(s) {
            const m = this.getMatcher(this.regexIndex);
            m.lastIndex = this.lastIndex;
            let result = m.exec(s);
            // The following is because we have no easy way to say "resume scanning at the
            // existing position but also skip the current rule ONLY". What happens is
            // all prior rules are also skipped which can result in matching the wrong
            // thing. Example of matching "booger":
            // our matcher is [string, "booger", number]
            //
            // ....booger....
            // if "booger" is ignored then we'd really need a regex to scan from the
            // SAME position for only: [string, number] but ignoring "booger" (if it
            // was the first match), a simple resume would scan ahead who knows how
            // far looking only for "number", ignoring potential string matches (or
            // future "booger" matches that might be valid.)
            // So what we do: We execute two matchers, one resuming at the same
            // position, but the second full matcher starting at the position after:
            //     /--- resume first regex match here (for [number])
            //     |/---- full match here for [string, "booger", number]
            //     vv
            // ....booger....
            // Which ever results in a match first is then used. So this 3-4 step
            // process essentially allows us to say "match at this position, excluding
            // a prior rule that was ignored".
            //
            // 1. Match "booger" first, ignore. Also proves that [string] does non match.
            // 2. Resume matching for [number]
            // 3. Match at index + 1 for [string, "booger", number]
            // 4. If #2 and #3 result in matches, which came first?
            if (this.resumingScanAtSamePosition()) {
                if (result && result.index === this.lastIndex) ;
                else {
                    const m2 = this.getMatcher(0);
                    m2.lastIndex = this.lastIndex + 1;
                    result = m2.exec(s);
                }
            }
            if (result) {
                this.regexIndex += result.position + 1;
                if (this.regexIndex === this.count) // wrap-around to considering all matches again
                this.considerAll();
            }
            return result;
        }
    }
    /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */ function buildModeRegex(mode) {
        const mm = new ResumableMultiRegex();
        mode.contains.forEach((term)=>mm.addRule(term.begin, {
                rule: term,
                type: "begin"
            }));
        if (mode.terminatorEnd) mm.addRule(mode.terminatorEnd, {
            type: "end"
        });
        if (mode.illegal) mm.addRule(mode.illegal, {
            type: "illegal"
        });
        return mm;
    }
    /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */ /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */ function compileMode(mode, parent) {
        const cmode = /** @type CompiledMode */ mode;
        if (mode.isCompiled) return cmode;
        [
            $4253b8727c723f00$var$scopeClassName,
            // do this early so compiler extensions generally don't have to worry about
            // the distinction between match/begin
            $4253b8727c723f00$var$compileMatch,
            $4253b8727c723f00$var$MultiClass,
            $4253b8727c723f00$var$beforeMatchExt
        ].forEach((ext)=>ext(mode, parent));
        language.compilerExtensions.forEach((ext)=>ext(mode, parent));
        // __beforeBegin is considered private API, internal use only
        mode.__beforeBegin = null;
        [
            $4253b8727c723f00$var$beginKeywords,
            // do this later so compiler extensions that come earlier have access to the
            // raw array if they wanted to perhaps manipulate it, etc.
            $4253b8727c723f00$var$compileIllegal,
            // default to 1 relevance if not specified
            $4253b8727c723f00$var$compileRelevance
        ].forEach((ext)=>ext(mode, parent));
        mode.isCompiled = true;
        let keywordPattern = null;
        if (typeof mode.keywords === "object" && mode.keywords.$pattern) {
            // we need a copy because keywords might be compiled multiple times
            // so we can't go deleting $pattern from the original on the first
            // pass
            mode.keywords = Object.assign({}, mode.keywords);
            keywordPattern = mode.keywords.$pattern;
            delete mode.keywords.$pattern;
        }
        keywordPattern = keywordPattern || /\w+/;
        if (mode.keywords) mode.keywords = $4253b8727c723f00$var$compileKeywords(mode.keywords, language.case_insensitive);
        cmode.keywordPatternRe = langRe(keywordPattern, true);
        if (parent) {
            if (!mode.begin) mode.begin = /\B|\b/;
            cmode.beginRe = langRe(cmode.begin);
            if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
            if (mode.end) cmode.endRe = langRe(cmode.end);
            cmode.terminatorEnd = $4253b8727c723f00$var$source(cmode.end) || '';
            if (mode.endsWithParent && parent.terminatorEnd) cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
        }
        if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ mode.illegal);
        if (!mode.contains) mode.contains = [];
        mode.contains = [].concat(...mode.contains.map(function(c) {
            return $4253b8727c723f00$var$expandOrCloneMode(c === 'self' ? mode : c);
        }));
        mode.contains.forEach(function(c) {
            compileMode(/** @type Mode */ c, cmode);
        });
        if (mode.starts) compileMode(mode.starts, parent);
        cmode.matcher = buildModeRegex(cmode);
        return cmode;
    }
    if (!language.compilerExtensions) language.compilerExtensions = [];
    // self is not valid at the top-level
    if (language.contains && language.contains.includes('self')) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    // we need a null object, which inherit will guarantee
    language.classNameAliases = $4253b8727c723f00$var$inherit$1(language.classNameAliases || {});
    return compileMode(/** @type Mode */ language);
}
/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */ function $4253b8727c723f00$var$dependencyOnParent(mode) {
    if (!mode) return false;
    return mode.endsWithParent || $4253b8727c723f00$var$dependencyOnParent(mode.starts);
}
/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */ function $4253b8727c723f00$var$expandOrCloneMode(mode) {
    if (mode.variants && !mode.cachedVariants) mode.cachedVariants = mode.variants.map(function(variant) {
        return $4253b8727c723f00$var$inherit$1(mode, {
            variants: null
        }, variant);
    });
    // EXPAND
    // if we have variants then essentially "replace" the mode with the variants
    // this happens in compileMode, where this function is called from
    if (mode.cachedVariants) return mode.cachedVariants;
    // CLONE
    // if we have dependencies on parents then we need a unique
    // instance of ourselves, so we can be reused with many
    // different parents without issue
    if ($4253b8727c723f00$var$dependencyOnParent(mode)) return $4253b8727c723f00$var$inherit$1(mode, {
        starts: mode.starts ? $4253b8727c723f00$var$inherit$1(mode.starts) : null
    });
    if (Object.isFrozen(mode)) return $4253b8727c723f00$var$inherit$1(mode);
    // no special dependency issues, just return ourselves
    return mode;
}
var $4253b8727c723f00$var$version = "11.11.1";
class $4253b8727c723f00$var$HTMLInjectionError extends Error {
    constructor(reason, html){
        super(reason);
        this.name = "HTMLInjectionError";
        this.html = html;
    }
}
/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/ /**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').CompiledScope} CompiledScope
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSApi} HLJSApi
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').PluginEvent} PluginEvent
@typedef {import('highlight.js').HLJSOptions} HLJSOptions
@typedef {import('highlight.js').LanguageFn} LanguageFn
@typedef {import('highlight.js').HighlightedHTMLElement} HighlightedHTMLElement
@typedef {import('highlight.js').BeforeHighlightContext} BeforeHighlightContext
@typedef {import('highlight.js/private').MatchType} MatchType
@typedef {import('highlight.js/private').KeywordData} KeywordData
@typedef {import('highlight.js/private').EnhancedMatch} EnhancedMatch
@typedef {import('highlight.js/private').AnnotatedError} AnnotatedError
@typedef {import('highlight.js').AutoHighlightResult} AutoHighlightResult
@typedef {import('highlight.js').HighlightOptions} HighlightOptions
@typedef {import('highlight.js').HighlightResult} HighlightResult
*/ const $4253b8727c723f00$var$escape = $4253b8727c723f00$var$escapeHTML;
const $4253b8727c723f00$var$inherit = $4253b8727c723f00$var$inherit$1;
const $4253b8727c723f00$var$NO_MATCH = Symbol("nomatch");
const $4253b8727c723f00$var$MAX_KEYWORD_HITS = 7;
/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */ const $4253b8727c723f00$var$HLJS = function(hljs) {
    // Global internal variables used within the highlight.js library.
    /** @type {Record<string, Language>} */ const languages = Object.create(null);
    /** @type {Record<string, string>} */ const aliases = Object.create(null);
    /** @type {HLJSPlugin[]} */ const plugins = [];
    // safe/production mode - swallows more errors, tries to keep running
    // even if a single syntax or parse hits a fatal error
    let SAFE_MODE = true;
    const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    /** @type {Language} */ const PLAINTEXT_LANGUAGE = {
        disableAutodetect: true,
        name: 'Plain text',
        contains: []
    };
    // Global options used when within external APIs. This is modified when
    // calling the `hljs.configure` function.
    /** @type HLJSOptions */ let options = {
        ignoreUnescapedHTML: false,
        throwUnescapedHTML: false,
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: 'hljs-',
        cssSelector: 'pre code',
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: $4253b8727c723f00$var$TokenTreeEmitter
    };
    /* Utility functions */ /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */ function shouldNotHighlight(languageName) {
        return options.noHighlightRe.test(languageName);
    }
    /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */ function blockLanguage(block) {
        let classes = block.className + ' ';
        classes += block.parentNode ? block.parentNode.className : '';
        // language-* takes precedence over non-prefixed class names.
        const match = options.languageDetectRe.exec(classes);
        if (match) {
            const language = getLanguage(match[1]);
            if (!language) {
                $4253b8727c723f00$var$warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
                $4253b8727c723f00$var$warn("Falling back to no-highlight mode for this block.", block);
            }
            return language ? match[1] : 'no-highlight';
        }
        return classes.split(/\s+/).find((_class)=>shouldNotHighlight(_class) || getLanguage(_class));
    }
    /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrLanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */ function highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals) {
        let code = "";
        let languageName = "";
        if (typeof optionsOrCode === "object") {
            code = codeOrLanguageName;
            ignoreIllegals = optionsOrCode.ignoreIllegals;
            languageName = optionsOrCode.language;
        } else {
            // old API
            $4253b8727c723f00$var$deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
            $4253b8727c723f00$var$deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
            languageName = codeOrLanguageName;
            code = optionsOrCode;
        }
        // https://github.com/highlightjs/highlight.js/issues/3149
        // eslint-disable-next-line no-undefined
        if (ignoreIllegals === undefined) ignoreIllegals = true;
        /** @type {BeforeHighlightContext} */ const context = {
            code: code,
            language: languageName
        };
        // the plugin can change the desired language or the code to be highlighted
        // just be changing the object it was passed
        fire("before:highlight", context);
        // a before plugin can usurp the result completely by providing it's own
        // in which case we don't even need to call highlight
        const result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals);
        result.code = context.code;
        // the plugin can change anything in result to suite it
        fire("after:highlight", result);
        return result;
    }
    /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */ function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
        const keywordHits = Object.create(null);
        /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {string} matchText - the textual match
     * @returns {KeywordData | false}
     */ function keywordData(mode, matchText) {
            return mode.keywords[matchText];
        }
        function processKeywords() {
            if (!top.keywords) {
                emitter.addText(modeBuffer);
                return;
            }
            let lastIndex = 0;
            top.keywordPatternRe.lastIndex = 0;
            let match = top.keywordPatternRe.exec(modeBuffer);
            let buf = "";
            while(match){
                buf += modeBuffer.substring(lastIndex, match.index);
                const word = language.case_insensitive ? match[0].toLowerCase() : match[0];
                const data = keywordData(top, word);
                if (data) {
                    const [kind, keywordRelevance] = data;
                    emitter.addText(buf);
                    buf = "";
                    keywordHits[word] = (keywordHits[word] || 0) + 1;
                    if (keywordHits[word] <= $4253b8727c723f00$var$MAX_KEYWORD_HITS) relevance += keywordRelevance;
                    if (kind.startsWith("_")) // _ implied for relevance only, do not highlight
                    // by applying a class name
                    buf += match[0];
                    else {
                        const cssClass = language.classNameAliases[kind] || kind;
                        emitKeyword(match[0], cssClass);
                    }
                } else buf += match[0];
                lastIndex = top.keywordPatternRe.lastIndex;
                match = top.keywordPatternRe.exec(modeBuffer);
            }
            buf += modeBuffer.substring(lastIndex);
            emitter.addText(buf);
        }
        function processSubLanguage() {
            if (modeBuffer === "") return;
            /** @type HighlightResult */ let result = null;
            if (typeof top.subLanguage === 'string') {
                if (!languages[top.subLanguage]) {
                    emitter.addText(modeBuffer);
                    return;
                }
                result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
                continuations[top.subLanguage] = /** @type {CompiledMode} */ result._top;
            } else result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
            // Counting embedded language score towards the host language may be disabled
            // with zeroing the containing mode relevance. Use case in point is Markdown that
            // allows XML everywhere and makes every XML snippet to have a much larger Markdown
            // score.
            if (top.relevance > 0) relevance += result.relevance;
            emitter.__addSublanguage(result._emitter, result.language);
        }
        function processBuffer() {
            if (top.subLanguage != null) processSubLanguage();
            else processKeywords();
            modeBuffer = '';
        }
        /**
     * @param {string} text
     * @param {string} scope
     */ function emitKeyword(keyword, scope) {
            if (keyword === "") return;
            emitter.startScope(scope);
            emitter.addText(keyword);
            emitter.endScope();
        }
        /**
     * @param {CompiledScope} scope
     * @param {RegExpMatchArray} match
     */ function emitMultiClass(scope, match) {
            let i = 1;
            const max = match.length - 1;
            while(i <= max){
                if (!scope._emit[i]) {
                    i++;
                    continue;
                }
                const klass = language.classNameAliases[scope[i]] || scope[i];
                const text = match[i];
                if (klass) emitKeyword(text, klass);
                else {
                    modeBuffer = text;
                    processKeywords();
                    modeBuffer = "";
                }
                i++;
            }
        }
        /**
     * @param {CompiledMode} mode - new mode to start
     * @param {RegExpMatchArray} match
     */ function startNewMode(mode, match) {
            if (mode.scope && typeof mode.scope === "string") emitter.openNode(language.classNameAliases[mode.scope] || mode.scope);
            if (mode.beginScope) {
                // beginScope just wraps the begin match itself in a scope
                if (mode.beginScope._wrap) {
                    emitKeyword(modeBuffer, language.classNameAliases[mode.beginScope._wrap] || mode.beginScope._wrap);
                    modeBuffer = "";
                } else if (mode.beginScope._multi) {
                    // at this point modeBuffer should just be the match
                    emitMultiClass(mode.beginScope, match);
                    modeBuffer = "";
                }
            }
            top = Object.create(mode, {
                parent: {
                    value: top
                }
            });
            return top;
        }
        /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */ function endOfMode(mode, match, matchPlusRemainder) {
            let matched = $4253b8727c723f00$var$startsWith(mode.endRe, matchPlusRemainder);
            if (matched) {
                if (mode["on:end"]) {
                    const resp = new $4253b8727c723f00$var$Response(mode);
                    mode["on:end"](match, resp);
                    if (resp.isMatchIgnored) matched = false;
                }
                if (matched) {
                    while(mode.endsParent && mode.parent)mode = mode.parent;
                    return mode;
                }
            }
            // even if on:end fires an `ignore` it's still possible
            // that we might trigger the end node because of a parent mode
            if (mode.endsWithParent) return endOfMode(mode.parent, match, matchPlusRemainder);
        }
        /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */ function doIgnore(lexeme) {
            if (top.matcher.regexIndex === 0) {
                // no more regexes to potentially match here, so we move the cursor forward one
                // space
                modeBuffer += lexeme[0];
                return 1;
            } else {
                // no need to move the cursor, we still have additional regexes to try and
                // match at this very spot
                resumeScanAtSamePosition = true;
                return 0;
            }
        }
        /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */ function doBeginMatch(match) {
            const lexeme = match[0];
            const newMode = match.rule;
            const resp = new $4253b8727c723f00$var$Response(newMode);
            // first internal before callbacks, then the public ones
            const beforeCallbacks = [
                newMode.__beforeBegin,
                newMode["on:begin"]
            ];
            for (const cb of beforeCallbacks){
                if (!cb) continue;
                cb(match, resp);
                if (resp.isMatchIgnored) return doIgnore(lexeme);
            }
            if (newMode.skip) modeBuffer += lexeme;
            else {
                if (newMode.excludeBegin) modeBuffer += lexeme;
                processBuffer();
                if (!newMode.returnBegin && !newMode.excludeBegin) modeBuffer = lexeme;
            }
            startNewMode(newMode, match);
            return newMode.returnBegin ? 0 : lexeme.length;
        }
        /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */ function doEndMatch(match) {
            const lexeme = match[0];
            const matchPlusRemainder = codeToHighlight.substring(match.index);
            const endMode = endOfMode(top, match, matchPlusRemainder);
            if (!endMode) return $4253b8727c723f00$var$NO_MATCH;
            const origin = top;
            if (top.endScope && top.endScope._wrap) {
                processBuffer();
                emitKeyword(lexeme, top.endScope._wrap);
            } else if (top.endScope && top.endScope._multi) {
                processBuffer();
                emitMultiClass(top.endScope, match);
            } else if (origin.skip) modeBuffer += lexeme;
            else {
                if (!(origin.returnEnd || origin.excludeEnd)) modeBuffer += lexeme;
                processBuffer();
                if (origin.excludeEnd) modeBuffer = lexeme;
            }
            do {
                if (top.scope) emitter.closeNode();
                if (!top.skip && !top.subLanguage) relevance += top.relevance;
                top = top.parent;
            }while (top !== endMode.parent);
            if (endMode.starts) startNewMode(endMode.starts, match);
            return origin.returnEnd ? 0 : lexeme.length;
        }
        function processContinuations() {
            const list = [];
            for(let current = top; current !== language; current = current.parent)if (current.scope) list.unshift(current.scope);
            list.forEach((item)=>emitter.openNode(item));
        }
        /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */ let lastMatch = {};
        /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */ function processLexeme(textBeforeMatch, match) {
            const lexeme = match && match[0];
            // add non-matched text to the current mode buffer
            modeBuffer += textBeforeMatch;
            if (lexeme == null) {
                processBuffer();
                return 0;
            }
            // we've found a 0 width match and we're stuck, so we need to advance
            // this happens when we have badly behaved rules that have optional matchers to the degree that
            // sometimes they can end up matching nothing at all
            // Ref: https://github.com/highlightjs/highlight.js/issues/2140
            if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
                // spit the "skipped" character that our regex choked on back into the output sequence
                modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
                if (!SAFE_MODE) {
                    /** @type {AnnotatedError} */ const err = new Error(`0 width match regex (${languageName})`);
                    err.languageName = languageName;
                    err.badRule = lastMatch.rule;
                    throw err;
                }
                return 1;
            }
            lastMatch = match;
            if (match.type === "begin") return doBeginMatch(match);
            else if (match.type === "illegal" && !ignoreIllegals) {
                // illegal match, we do not continue processing
                /** @type {AnnotatedError} */ const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.scope || '<unnamed>') + '"');
                err.mode = top;
                throw err;
            } else if (match.type === "end") {
                const processed = doEndMatch(match);
                if (processed !== $4253b8727c723f00$var$NO_MATCH) return processed;
            }
            // edge case for when illegal matches $ (end of line) which is technically
            // a 0 width match but not a begin/end match so it's not caught by the
            // first handler (when ignoreIllegals is true)
            if (match.type === "illegal" && lexeme === "") {
                // advance so we aren't stuck in an infinite loop
                modeBuffer += "\n";
                return 1;
            }
            // infinite loops are BAD, this is a last ditch catch all. if we have a
            // decent number of iterations yet our index (cursor position in our
            // parsing) still 3x behind our index then something is very wrong
            // so we bail
            if (iterations > 100000 && iterations > match.index * 3) {
                const err = new Error('potential infinite loop, way more iterations than matches');
                throw err;
            }
            /*
      Why might be find ourselves here?  An potential end match that was
      triggered but could not be completed.  IE, `doEndMatch` returned NO_MATCH.
      (this could be because a callback requests the match be ignored, etc)

      This causes no real harm other than stopping a few times too many.
      */ modeBuffer += lexeme;
            return lexeme.length;
        }
        const language = getLanguage(languageName);
        if (!language) {
            $4253b8727c723f00$var$error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
            throw new Error('Unknown language: "' + languageName + '"');
        }
        const md = $4253b8727c723f00$var$compileLanguage(language);
        let result = '';
        /** @type {CompiledMode} */ let top = continuation || md;
        /** @type Record<string,CompiledMode> */ const continuations = {}; // keep continuations for sub-languages
        const emitter = new options.__emitter(options);
        processContinuations();
        let modeBuffer = '';
        let relevance = 0;
        let index = 0;
        let iterations = 0;
        let resumeScanAtSamePosition = false;
        try {
            if (!language.__emitTokens) {
                top.matcher.considerAll();
                for(;;){
                    iterations++;
                    if (resumeScanAtSamePosition) // only regexes not matched previously will now be
                    // considered for a potential match
                    resumeScanAtSamePosition = false;
                    else top.matcher.considerAll();
                    top.matcher.lastIndex = index;
                    const match = top.matcher.exec(codeToHighlight);
                    // console.log("match", match[0], match.rule && match.rule.begin)
                    if (!match) break;
                    const beforeMatch = codeToHighlight.substring(index, match.index);
                    const processedCount = processLexeme(beforeMatch, match);
                    index = match.index + processedCount;
                }
                processLexeme(codeToHighlight.substring(index));
            } else language.__emitTokens(codeToHighlight, emitter);
            emitter.finalize();
            result = emitter.toHTML();
            return {
                language: languageName,
                value: result,
                relevance: relevance,
                illegal: false,
                _emitter: emitter,
                _top: top
            };
        } catch (err) {
            if (err.message && err.message.includes('Illegal')) return {
                language: languageName,
                value: $4253b8727c723f00$var$escape(codeToHighlight),
                illegal: true,
                relevance: 0,
                _illegalBy: {
                    message: err.message,
                    index: index,
                    context: codeToHighlight.slice(index - 100, index + 100),
                    mode: err.mode,
                    resultSoFar: result
                },
                _emitter: emitter
            };
            else if (SAFE_MODE) return {
                language: languageName,
                value: $4253b8727c723f00$var$escape(codeToHighlight),
                illegal: false,
                relevance: 0,
                errorRaised: err,
                _emitter: emitter,
                _top: top
            };
            else throw err;
        }
    }
    /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */ function justTextHighlightResult(code) {
        const result = {
            value: $4253b8727c723f00$var$escape(code),
            illegal: false,
            relevance: 0,
            _top: PLAINTEXT_LANGUAGE,
            _emitter: new options.__emitter(options)
        };
        result._emitter.addText(code);
        return result;
    }
    /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - secondBest (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */ function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || Object.keys(languages);
        const plaintext = justTextHighlightResult(code);
        const results = languageSubset.filter(getLanguage).filter(autoDetection).map((name)=>_highlight(name, code, false));
        results.unshift(plaintext); // plaintext is always an option
        const sorted = results.sort((a, b)=>{
            // sort base on relevance
            if (a.relevance !== b.relevance) return b.relevance - a.relevance;
            // always award the tie to the base language
            // ie if C++ and Arduino are tied, it's more likely to be C++
            if (a.language && b.language) {
                if (getLanguage(a.language).supersetOf === b.language) return 1;
                else if (getLanguage(b.language).supersetOf === a.language) return -1;
            }
            // otherwise say they are equal, which has the effect of sorting on
            // relevance while preserving the original ordering - which is how ties
            // have historically been settled, ie the language that comes first always
            // wins in the case of a tie
            return 0;
        });
        const [best, secondBest] = sorted;
        /** @type {AutoHighlightResult} */ const result = best;
        result.secondBest = secondBest;
        return result;
    }
    /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */ function updateClassName(element, currentLang, resultLang) {
        const language = currentLang && aliases[currentLang] || resultLang;
        element.classList.add("hljs");
        element.classList.add(`language-${language}`);
    }
    /**
   * Applies highlighting to a DOM node containing code.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */ function highlightElement(element) {
        /** @type HTMLElement */ let node = null;
        const language = blockLanguage(element);
        if (shouldNotHighlight(language)) return;
        fire("before:highlightElement", {
            el: element,
            language: language
        });
        if (element.dataset.highlighted) {
            console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", element);
            return;
        }
        // we should be all text, no child nodes (unescaped HTML) - this is possibly
        // an HTML injection attack - it's likely too late if this is already in
        // production (the code has likely already done its damage by the time
        // we're seeing it)... but we yell loudly about this so that hopefully it's
        // more likely to be caught in development before making it to production
        if (element.children.length > 0) {
            if (!options.ignoreUnescapedHTML) {
                console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk.");
                console.warn("https://github.com/highlightjs/highlight.js/wiki/security");
                console.warn("The element with unescaped HTML:");
                console.warn(element);
            }
            if (options.throwUnescapedHTML) {
                const err = new $4253b8727c723f00$var$HTMLInjectionError("One of your code blocks includes unescaped HTML.", element.innerHTML);
                throw err;
            }
        }
        node = element;
        const text = node.textContent;
        const result = language ? highlight(text, {
            language: language,
            ignoreIllegals: true
        }) : highlightAuto(text);
        element.innerHTML = result.value;
        element.dataset.highlighted = "yes";
        updateClassName(element, language, result.language);
        element.result = {
            language: result.language,
            // TODO: remove with version 11.0
            re: result.relevance,
            relevance: result.relevance
        };
        if (result.secondBest) element.secondBest = {
            language: result.secondBest.language,
            relevance: result.secondBest.relevance
        };
        fire("after:highlightElement", {
            el: element,
            result: result,
            text: text
        });
    }
    /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */ function configure(userOptions) {
        options = $4253b8727c723f00$var$inherit(options, userOptions);
    }
    // TODO: remove v12, deprecated
    const initHighlighting = ()=>{
        highlightAll();
        $4253b8727c723f00$var$deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    // TODO: remove v12, deprecated
    function initHighlightingOnLoad() {
        highlightAll();
        $4253b8727c723f00$var$deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let wantsHighlight = false;
    /**
   * auto-highlights all pre>code elements on the page
   */ function highlightAll() {
        function boot() {
            // if a highlight was requested before DOM was loaded, do now
            highlightAll();
        }
        // if we are called too early in the loading process
        if (document.readyState === "loading") {
            // make sure the event listener is only added once
            if (!wantsHighlight) window.addEventListener('DOMContentLoaded', boot, false);
            wantsHighlight = true;
            return;
        }
        const blocks = document.querySelectorAll(options.cssSelector);
        blocks.forEach(highlightElement);
    }
    /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */ function registerLanguage(languageName, languageDefinition) {
        let lang = null;
        try {
            lang = languageDefinition(hljs);
        } catch (error$1) {
            $4253b8727c723f00$var$error("Language definition for '{}' could not be registered.".replace("{}", languageName));
            // hard or soft error
            if (!SAFE_MODE) throw error$1;
            else $4253b8727c723f00$var$error(error$1);
            // languages that have serious errors are replaced with essentially a
            // "plaintext" stand-in so that the code blocks will still get normal
            // css classes applied to them - and one bad language won't break the
            // entire highlighter
            lang = PLAINTEXT_LANGUAGE;
        }
        // give it a temporary name if it doesn't have one in the meta-data
        if (!lang.name) lang.name = languageName;
        languages[languageName] = lang;
        lang.rawDefinition = languageDefinition.bind(null, hljs);
        if (lang.aliases) registerAliases(lang.aliases, {
            languageName: languageName
        });
    }
    /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */ function unregisterLanguage(languageName) {
        delete languages[languageName];
        for (const alias of Object.keys(aliases))if (aliases[alias] === languageName) delete aliases[alias];
    }
    /**
   * @returns {string[]} List of language internal names
   */ function listLanguages() {
        return Object.keys(languages);
    }
    /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */ function getLanguage(name) {
        name = (name || '').toLowerCase();
        return languages[name] || languages[aliases[name]];
    }
    /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */ function registerAliases(aliasList, { languageName: languageName }) {
        if (typeof aliasList === 'string') aliasList = [
            aliasList
        ];
        aliasList.forEach((alias)=>{
            aliases[alias.toLowerCase()] = languageName;
        });
    }
    /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */ function autoDetection(name) {
        const lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
    }
    /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */ function upgradePluginAPI(plugin) {
        // TODO: remove with v12
        if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) plugin["before:highlightElement"] = (data)=>{
            plugin["before:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
        if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) plugin["after:highlightElement"] = (data)=>{
            plugin["after:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function addPlugin(plugin) {
        upgradePluginAPI(plugin);
        plugins.push(plugin);
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function removePlugin(plugin) {
        const index = plugins.indexOf(plugin);
        if (index !== -1) plugins.splice(index, 1);
    }
    /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */ function fire(event, args) {
        const cb = event;
        plugins.forEach(function(plugin) {
            if (plugin[cb]) plugin[cb](args);
        });
    }
    /**
   * DEPRECATED
   * @param {HighlightedHTMLElement} el
   */ function deprecateHighlightBlock(el) {
        $4253b8727c723f00$var$deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
        $4253b8727c723f00$var$deprecated("10.7.0", "Please use highlightElement now.");
        return highlightElement(el);
    }
    /* Interface definition */ Object.assign(hljs, {
        highlight: highlight,
        highlightAuto: highlightAuto,
        highlightAll: highlightAll,
        highlightElement: highlightElement,
        // TODO: Remove with v12 API
        highlightBlock: deprecateHighlightBlock,
        configure: configure,
        initHighlighting: initHighlighting,
        initHighlightingOnLoad: initHighlightingOnLoad,
        registerLanguage: registerLanguage,
        unregisterLanguage: unregisterLanguage,
        listLanguages: listLanguages,
        getLanguage: getLanguage,
        registerAliases: registerAliases,
        autoDetection: autoDetection,
        inherit: $4253b8727c723f00$var$inherit,
        addPlugin: addPlugin,
        removePlugin: removePlugin
    });
    hljs.debugMode = function() {
        SAFE_MODE = false;
    };
    hljs.safeMode = function() {
        SAFE_MODE = true;
    };
    hljs.versionString = $4253b8727c723f00$var$version;
    hljs.regex = {
        concat: $4253b8727c723f00$var$concat,
        lookahead: $4253b8727c723f00$var$lookahead,
        either: $4253b8727c723f00$var$either,
        optional: $4253b8727c723f00$var$optional,
        anyNumberOfTimes: $4253b8727c723f00$var$anyNumberOfTimes
    };
    for(const key in $4253b8727c723f00$var$MODES)// @ts-ignore
    if (typeof $4253b8727c723f00$var$MODES[key] === "object") // @ts-ignore
    $4253b8727c723f00$var$deepFreeze($4253b8727c723f00$var$MODES[key]);
    // merge all the modes/regexes into our main object
    Object.assign(hljs, $4253b8727c723f00$var$MODES);
    return hljs;
};
// Other names for the variable may break build script
const $4253b8727c723f00$var$highlight = $4253b8727c723f00$var$HLJS({});
// returns a new instance of the highlighter to be used for extensions
// check https://github.com/wooorm/lowlight/issues/47
$4253b8727c723f00$var$highlight.newInstance = ()=>$4253b8727c723f00$var$HLJS({});
module.exports = $4253b8727c723f00$var$highlight;
$4253b8727c723f00$var$highlight.HighlightJS = $4253b8727c723f00$var$highlight;
$4253b8727c723f00$var$highlight.default = $4253b8727c723f00$var$highlight;

});

parcelRegister("f8yzZ", function(module, exports) {
/*
Language: AsciiDoc
Requires: xml.js
Author: Dan Allen <dan.j.allen@gmail.com>
Website: http://asciidoc.org
Description: A semantic, text-based document format that can be exported to HTML, DocBook and other backends.
Category: markup
*/ /** @type LanguageFn */ function $b0526d20e4b34dcc$var$asciidoc(hljs) {
    const regex = hljs.regex;
    const HORIZONTAL_RULE = {
        begin: '^\'{3,}[ \\t]*$',
        relevance: 10
    };
    const ESCAPED_FORMATTING = [
        // escaped constrained formatting marks (i.e., \* \_ or \`)
        {
            begin: /\\[*_`]/
        },
        // escaped unconstrained formatting marks (i.e., \\** \\__ or \\``)
        // must ignore until the next formatting marks
        // this rule might not be 100% compliant with Asciidoctor 2.0 but we are entering undefined behavior territory...
        {
            begin: /\\\\\*{2}[^\n]*?\*{2}/
        },
        {
            begin: /\\\\_{2}[^\n]*_{2}/
        },
        {
            begin: /\\\\`{2}[^\n]*`{2}/
        },
        // guard: constrained formatting mark may not be preceded by ":", ";" or
        // "}". match these so the constrained rule doesn't see them
        {
            begin: /[:;}][*_`](?![*_`])/
        }
    ];
    const STRONG = [
        // inline unconstrained strong (single line)
        {
            className: 'strong',
            begin: /\*{2}([^\n]+?)\*{2}/
        },
        // inline unconstrained strong (multi-line)
        {
            className: 'strong',
            begin: regex.concat(/\*\*/, /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/, /(\*(?!\*)|\\[^\n]|[^*\n\\])*/, /\*\*/),
            relevance: 0
        },
        // inline constrained strong (single line)
        {
            className: 'strong',
            // must not precede or follow a word character
            begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
        },
        // inline constrained strong (multi-line)
        {
            className: 'strong',
            // must not precede or follow a word character
            begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
        }
    ];
    const EMPHASIS = [
        // inline unconstrained emphasis (single line)
        {
            className: 'emphasis',
            begin: /_{2}([^\n]+?)_{2}/
        },
        // inline unconstrained emphasis (multi-line)
        {
            className: 'emphasis',
            begin: regex.concat(/__/, /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/, /(_(?!_)|\\[^\n]|[^_\n\\])*/, /__/),
            relevance: 0
        },
        // inline constrained emphasis (single line)
        {
            className: 'emphasis',
            // must not precede or follow a word character
            begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
        },
        // inline constrained emphasis (multi-line)
        {
            className: 'emphasis',
            // must not precede or follow a word character
            begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
        },
        // inline constrained emphasis using single quote (legacy)
        {
            className: 'emphasis',
            // must not follow a word character or be followed by a single quote or space
            begin: '\\B\'(?![\'\\s])',
            end: '(\\n{2}|\')',
            // allow escaped single quote followed by word char
            contains: [
                {
                    begin: '\\\\\'\\w',
                    relevance: 0
                }
            ],
            relevance: 0
        }
    ];
    const ADMONITION = {
        className: 'symbol',
        begin: '^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+',
        relevance: 10
    };
    const BULLET_LIST = {
        className: 'bullet',
        begin: '^(\\*+|-+|\\.+|[^\\n]+?::)\\s+'
    };
    return {
        name: 'AsciiDoc',
        aliases: [
            'adoc'
        ],
        contains: [
            // block comment
            hljs.COMMENT('^/{4,}\\n', '\\n/{4,}$', // can also be done as...
            // '^/{4,}$',
            // '^/{4,}$',
            {
                relevance: 10
            }),
            // line comment
            hljs.COMMENT('^//', '$', {
                relevance: 0
            }),
            // title
            {
                className: 'title',
                begin: '^\\.\\w.*$'
            },
            // example, admonition & sidebar blocks
            {
                begin: '^[=\\*]{4,}\\n',
                end: '\\n^[=\\*]{4,}$',
                relevance: 10
            },
            // headings
            {
                className: 'section',
                relevance: 10,
                variants: [
                    {
                        begin: '^(={1,6})[ \t].+?([ \t]\\1)?$'
                    },
                    {
                        begin: '^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$'
                    }
                ]
            },
            // document attributes
            {
                className: 'meta',
                begin: '^:.+?:',
                end: '\\s',
                excludeEnd: true,
                relevance: 10
            },
            // block attributes
            {
                className: 'meta',
                begin: '^\\[.+?\\]$',
                relevance: 0
            },
            // quoteblocks
            {
                className: 'quote',
                begin: '^_{4,}\\n',
                end: '\\n_{4,}$',
                relevance: 10
            },
            // listing and literal blocks
            {
                className: 'code',
                begin: '^[\\-\\.]{4,}\\n',
                end: '\\n[\\-\\.]{4,}$',
                relevance: 10
            },
            // passthrough blocks
            {
                begin: '^\\+{4,}\\n',
                end: '\\n\\+{4,}$',
                contains: [
                    {
                        begin: '<',
                        end: '>',
                        subLanguage: 'xml',
                        relevance: 0
                    }
                ],
                relevance: 10
            },
            BULLET_LIST,
            ADMONITION,
            ...ESCAPED_FORMATTING,
            ...STRONG,
            ...EMPHASIS,
            // inline smart quotes
            {
                className: 'string',
                variants: [
                    {
                        begin: "``.+?''"
                    },
                    {
                        begin: "`.+?'"
                    }
                ]
            },
            // inline unconstrained emphasis
            {
                className: 'code',
                begin: /`{2}/,
                end: /(\n{2}|`{2})/
            },
            // inline code snippets (TODO should get same treatment as strong and emphasis)
            {
                className: 'code',
                begin: '(`.+?`|\\+.+?\\+)',
                relevance: 0
            },
            // indented literal block
            {
                className: 'code',
                begin: '^[ \\t]',
                end: '$',
                relevance: 0
            },
            HORIZONTAL_RULE,
            // images and links
            {
                begin: '(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]',
                returnBegin: true,
                contains: [
                    {
                        begin: '(link|image:?):',
                        relevance: 0
                    },
                    {
                        className: 'link',
                        begin: '\\w',
                        end: '[^\\[]+',
                        relevance: 0
                    },
                    {
                        className: 'string',
                        begin: '\\[',
                        end: '\\]',
                        excludeBegin: true,
                        excludeEnd: true,
                        relevance: 0
                    }
                ],
                relevance: 10
            }
        ]
    };
}
module.exports = $b0526d20e4b34dcc$var$asciidoc;

});

parcelRegister("8mb6m", function(module, exports) {
/*
Language: Bash
Author: vah <vahtenberg@gmail.com>
Contributrors: Benjamin Pannell <contact@sierrasoftworks.com>
Website: https://www.gnu.org/software/bash/
Category: common, scripting
*/ /** @type LanguageFn */ function $6158fd5bfa51f4eb$var$bash(hljs) {
    const regex = hljs.regex;
    const VAR = {};
    const BRACED_VAR = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    VAR
                ]
            } // default values
        ]
    };
    Object.assign(VAR, {
        className: 'variable',
        variants: [
            {
                begin: regex.concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                `(?![\\w\\d])(?![$])`)
            },
            BRACED_VAR
        ]
    });
    const SUBST = {
        className: 'subst',
        begin: /\$\(/,
        end: /\)/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const COMMENT = hljs.inherit(hljs.COMMENT(), {
        match: [
            /(^|\s)/,
            /#.*$/
        ],
        scope: {
            2: 'comment'
        }
    });
    const HERE_DOC = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                hljs.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: 'string'
                })
            ]
        }
    };
    const QUOTE_STRING = {
        className: 'string',
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            SUBST
        ]
    };
    SUBST.contains.push(QUOTE_STRING);
    const ESCAPED_QUOTE = {
        match: /\\"/
    };
    const APOS_STRING = {
        className: 'string',
        begin: /'/,
        end: /'/
    };
    const ESCAPED_APOS = {
        match: /\\'/
    };
    const ARITHMETIC = {
        begin: /\$?\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            hljs.NUMBER_MODE,
            VAR
        ]
    };
    const SH_LIKE_SHELLS = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ];
    const KNOWN_SHEBANG = hljs.SHEBANG({
        binary: `(${SH_LIKE_SHELLS.join("|")})`,
        relevance: 10
    });
    const FUNCTION = {
        className: 'function',
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    };
    const KEYWORDS = [
        "if",
        "then",
        "else",
        "elif",
        "fi",
        "time",
        "for",
        "while",
        "until",
        "in",
        "do",
        "done",
        "case",
        "esac",
        "coproc",
        "function",
        "select"
    ];
    const LITERALS = [
        "true",
        "false"
    ];
    // to consume paths to prevent keyword matches inside them
    const PATH_MODE = {
        match: /(\/[a-z._-]+)+/
    };
    // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
    const SHELL_BUILT_INS = [
        "break",
        "cd",
        "continue",
        "eval",
        "exec",
        "exit",
        "export",
        "getopts",
        "hash",
        "pwd",
        "readonly",
        "return",
        "shift",
        "test",
        "times",
        "trap",
        "umask",
        "unset"
    ];
    const BASH_BUILT_INS = [
        "alias",
        "bind",
        "builtin",
        "caller",
        "command",
        "declare",
        "echo",
        "enable",
        "help",
        "let",
        "local",
        "logout",
        "mapfile",
        "printf",
        "read",
        "readarray",
        "source",
        "sudo",
        "type",
        "typeset",
        "ulimit",
        "unalias"
    ];
    const ZSH_BUILT_INS = [
        "autoload",
        "bg",
        "bindkey",
        "bye",
        "cap",
        "chdir",
        "clone",
        "comparguments",
        "compcall",
        "compctl",
        "compdescribe",
        "compfiles",
        "compgroups",
        "compquote",
        "comptags",
        "comptry",
        "compvalues",
        "dirs",
        "disable",
        "disown",
        "echotc",
        "echoti",
        "emulate",
        "fc",
        "fg",
        "float",
        "functions",
        "getcap",
        "getln",
        "history",
        "integer",
        "jobs",
        "kill",
        "limit",
        "log",
        "noglob",
        "popd",
        "print",
        "pushd",
        "pushln",
        "rehash",
        "sched",
        "setcap",
        "setopt",
        "stat",
        "suspend",
        "ttyctl",
        "unfunction",
        "unhash",
        "unlimit",
        "unsetopt",
        "vared",
        "wait",
        "whence",
        "where",
        "which",
        "zcompile",
        "zformat",
        "zftp",
        "zle",
        "zmodload",
        "zparseopts",
        "zprof",
        "zpty",
        "zregexparse",
        "zsocket",
        "zstyle",
        "ztcp"
    ];
    const GNU_CORE_UTILS = [
        "chcon",
        "chgrp",
        "chown",
        "chmod",
        "cp",
        "dd",
        "df",
        "dir",
        "dircolors",
        "ln",
        "ls",
        "mkdir",
        "mkfifo",
        "mknod",
        "mktemp",
        "mv",
        "realpath",
        "rm",
        "rmdir",
        "shred",
        "sync",
        "touch",
        "truncate",
        "vdir",
        "b2sum",
        "base32",
        "base64",
        "cat",
        "cksum",
        "comm",
        "csplit",
        "cut",
        "expand",
        "fmt",
        "fold",
        "head",
        "join",
        "md5sum",
        "nl",
        "numfmt",
        "od",
        "paste",
        "ptx",
        "pr",
        "sha1sum",
        "sha224sum",
        "sha256sum",
        "sha384sum",
        "sha512sum",
        "shuf",
        "sort",
        "split",
        "sum",
        "tac",
        "tail",
        "tr",
        "tsort",
        "unexpand",
        "uniq",
        "wc",
        "arch",
        "basename",
        "chroot",
        "date",
        "dirname",
        "du",
        "echo",
        "env",
        "expr",
        "factor",
        // "false", // keyword literal already
        "groups",
        "hostid",
        "id",
        "link",
        "logname",
        "nice",
        "nohup",
        "nproc",
        "pathchk",
        "pinky",
        "printenv",
        "printf",
        "pwd",
        "readlink",
        "runcon",
        "seq",
        "sleep",
        "stat",
        "stdbuf",
        "stty",
        "tee",
        "test",
        "timeout",
        // "true", // keyword literal already
        "tty",
        "uname",
        "unlink",
        "uptime",
        "users",
        "who",
        "whoami",
        "yes"
    ];
    return {
        name: 'Bash',
        aliases: [
            'sh',
            'zsh'
        ],
        keywords: {
            $pattern: /\b[a-z][a-z0-9._-]+\b/,
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: [
                ...SHELL_BUILT_INS,
                ...BASH_BUILT_INS,
                // Shell modifiers
                "set",
                "shopt",
                ...ZSH_BUILT_INS,
                ...GNU_CORE_UTILS
            ]
        },
        contains: [
            KNOWN_SHEBANG,
            hljs.SHEBANG(),
            FUNCTION,
            ARITHMETIC,
            COMMENT,
            HERE_DOC,
            PATH_MODE,
            QUOTE_STRING,
            ESCAPED_QUOTE,
            APOS_STRING,
            ESCAPED_APOS,
            VAR
        ]
    };
}
module.exports = $6158fd5bfa51f4eb$var$bash;

});

parcelRegister("h4vvL", function(module, exports) {
/*
Language: C
Category: common, system
Website: https://en.wikipedia.org/wiki/C_(programming_language)
*/ /** @type LanguageFn */ function $c6db40e778a85785$var$c(hljs) {
    const regex = hljs.regex;
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$', {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = 'decltype\\(auto\\)';
    const NAMESPACE_RE = '[a-zA-Z_]\\w*::';
    const TEMPLATE_ARGUMENT_RE = '<[^<>]+>';
    const FUNCTION_TYPE_RE = '(' + DECLTYPE_AUTO_RE + '|' + regex.optional(NAMESPACE_RE) + '[a-zA-Z_]\\w*' + regex.optional(TEMPLATE_ARGUMENT_RE) + ')';
    const TYPES = {
        className: 'type',
        variants: [
            {
                begin: '\\b[a-z\\d_]*_t\\b'
            },
            {
                match: /\batomic_[a-z]{3,6}\b/
            }
        ]
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = '\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)';
    const STRINGS = {
        className: 'string',
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: '\\n',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '(u8?|U|L)?\'(' + CHARACTER_ESCAPES + "|.)",
                end: '\'',
                illegal: '.'
            },
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                end: /\)([^()\\ ]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: 'number',
        variants: [
            {
                match: /\b(0b[01']+)/
            },
            {
                match: /(-?)\b([\d']+(\.[\d']*)?|\.[\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)/
            },
            {
                match: /(-?)\b(0[xX][a-fA-F0-9]+(?:'[a-fA-F0-9]+)*(?:\.[a-fA-F0-9]*(?:'[a-fA-F0-9]*)*)?(?:[pP][-+]?[0-9]+)?(l|L)?(u|U)?)/
            },
            {
                match: /(-?)\b\d+(?:'\d+)*(?:\.\d*(?:'\d*)*)?(?:[eE][-+]?\d+)?/
            }
        ],
        relevance: 0
    };
    const PREPROCESSOR = {
        className: 'meta',
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef elifdef elifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: 'string'
            }),
            {
                className: 'string',
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const TITLE_MODE = {
        className: 'title',
        begin: regex.optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = regex.optional(NAMESPACE_RE) + hljs.IDENT_RE + '\\s*\\(';
    const C_KEYWORDS = [
        "asm",
        "auto",
        "break",
        "case",
        "continue",
        "default",
        "do",
        "else",
        "enum",
        "extern",
        "for",
        "fortran",
        "goto",
        "if",
        "inline",
        "register",
        "restrict",
        "return",
        "sizeof",
        "typeof",
        "typeof_unqual",
        "struct",
        "switch",
        "typedef",
        "union",
        "volatile",
        "while",
        "_Alignas",
        "_Alignof",
        "_Atomic",
        "_Generic",
        "_Noreturn",
        "_Static_assert",
        "_Thread_local",
        // aliases
        "alignas",
        "alignof",
        "noreturn",
        "static_assert",
        "thread_local",
        // not a C keyword but is, for all intents and purposes, treated exactly like one.
        "_Pragma"
    ];
    const C_TYPES = [
        "float",
        "double",
        "signed",
        "unsigned",
        "int",
        "short",
        "long",
        "char",
        "void",
        "_Bool",
        "_BitInt",
        "_Complex",
        "_Imaginary",
        "_Decimal32",
        "_Decimal64",
        "_Decimal96",
        "_Decimal128",
        "_Decimal64x",
        "_Decimal128x",
        "_Float16",
        "_Float32",
        "_Float64",
        "_Float128",
        "_Float32x",
        "_Float64x",
        "_Float128x",
        // modifiers
        "const",
        "static",
        "constexpr",
        // aliases
        "complex",
        "bool",
        "imaginary"
    ];
    const KEYWORDS = {
        keyword: C_KEYWORDS,
        type: C_TYPES,
        literal: 'true false NULL',
        // TODO: apply hinting work similar to what was done in cpp.js
        built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
    };
    const EXPRESSION_CONTAINS = [
        PREPROCESSOR,
        TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: 'new throw return else',
                end: /;/
            }
        ],
        keywords: KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    'self'
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        begin: '(' + FUNCTION_TYPE_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    hljs.inherit(TITLE_MODE, {
                        className: "title.function"
                    })
                ],
                relevance: 0
            },
            // allow for multiple declarations, e.g.:
            // extern void f(int), g(char);
            {
                relevance: 0,
                match: /,/
            },
            {
                className: 'params',
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            'self',
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            TYPES
                        ]
                    }
                ]
            },
            TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            PREPROCESSOR
        ]
    };
    return {
        name: "C",
        aliases: [
            'h'
        ],
        keywords: KEYWORDS,
        // Until differentiations are added between `c` and `cpp`, `c` will
        // not be auto-detected to avoid auto-detect conflicts between C and C++
        disableAutodetect: true,
        illegal: '</',
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, EXPRESSION_CONTAINS, [
            PREPROCESSOR,
            {
                begin: hljs.IDENT_RE + '::',
                keywords: KEYWORDS
            },
            {
                className: 'class',
                beginKeywords: 'enum class struct union',
                end: /[{;:<>=]/,
                contains: [
                    {
                        beginKeywords: "final class struct"
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: KEYWORDS
        }
    };
}
module.exports = $c6db40e778a85785$var$c;

});

parcelRegister("lx9iJ", function(module, exports) {
/*
Language: C#
Author: Jason Diamond <jason@diamond.name>
Contributor: Nicolas LLOBERA <nllobera@gmail.com>, Pieter Vantorre <pietervantorre@gmail.com>, David Pine <david.pine@microsoft.com>
Website: https://docs.microsoft.com/dotnet/csharp/
Category: common
*/ /** @type LanguageFn */ function $fad3e51343e8c9a2$var$csharp(hljs) {
    const BUILT_IN_KEYWORDS = [
        'bool',
        'byte',
        'char',
        'decimal',
        'delegate',
        'double',
        'dynamic',
        'enum',
        'float',
        'int',
        'long',
        'nint',
        'nuint',
        'object',
        'sbyte',
        'short',
        'string',
        'ulong',
        'uint',
        'ushort'
    ];
    const FUNCTION_MODIFIERS = [
        'public',
        'private',
        'protected',
        'static',
        'internal',
        'protected',
        'abstract',
        'async',
        'extern',
        'override',
        'unsafe',
        'virtual',
        'new',
        'sealed',
        'partial'
    ];
    const LITERAL_KEYWORDS = [
        'default',
        'false',
        'null',
        'true'
    ];
    const NORMAL_KEYWORDS = [
        'abstract',
        'as',
        'base',
        'break',
        'case',
        'catch',
        'class',
        'const',
        'continue',
        'do',
        'else',
        'event',
        'explicit',
        'extern',
        'finally',
        'fixed',
        'for',
        'foreach',
        'goto',
        'if',
        'implicit',
        'in',
        'interface',
        'internal',
        'is',
        'lock',
        'namespace',
        'new',
        'operator',
        'out',
        'override',
        'params',
        'private',
        'protected',
        'public',
        'readonly',
        'record',
        'ref',
        'return',
        'scoped',
        'sealed',
        'sizeof',
        'stackalloc',
        'static',
        'struct',
        'switch',
        'this',
        'throw',
        'try',
        'typeof',
        'unchecked',
        'unsafe',
        'using',
        'virtual',
        'void',
        'volatile',
        'while'
    ];
    const CONTEXTUAL_KEYWORDS = [
        'add',
        'alias',
        'and',
        'ascending',
        'args',
        'async',
        'await',
        'by',
        'descending',
        'dynamic',
        'equals',
        'file',
        'from',
        'get',
        'global',
        'group',
        'init',
        'into',
        'join',
        'let',
        'nameof',
        'not',
        'notnull',
        'on',
        'or',
        'orderby',
        'partial',
        'record',
        'remove',
        'required',
        'scoped',
        'select',
        'set',
        'unmanaged',
        'value|0',
        'var',
        'when',
        'where',
        'with',
        'yield'
    ];
    const KEYWORDS = {
        keyword: NORMAL_KEYWORDS.concat(CONTEXTUAL_KEYWORDS),
        built_in: BUILT_IN_KEYWORDS,
        literal: LITERAL_KEYWORDS
    };
    const TITLE_MODE = hljs.inherit(hljs.TITLE_MODE, {
        begin: '[a-zA-Z](\\.?\\w)*'
    });
    const NUMBERS = {
        className: 'number',
        variants: [
            {
                begin: '\\b(0b[01\']+)'
            },
            {
                begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)'
            },
            {
                begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)'
            }
        ],
        relevance: 0
    };
    const RAW_STRING = {
        className: 'string',
        begin: /"""("*)(?!")(.|\n)*?"""\1/,
        relevance: 1
    };
    const VERBATIM_STRING = {
        className: 'string',
        begin: '@"',
        end: '"',
        contains: [
            {
                begin: '""'
            }
        ]
    };
    const VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {
        illegal: /\n/
    });
    const SUBST = {
        className: 'subst',
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS
    };
    const SUBST_NO_LF = hljs.inherit(SUBST, {
        illegal: /\n/
    });
    const INTERPOLATED_STRING = {
        className: 'string',
        begin: /\$"/,
        end: '"',
        illegal: /\n/,
        contains: [
            {
                begin: /\{\{/
            },
            {
                begin: /\}\}/
            },
            hljs.BACKSLASH_ESCAPE,
            SUBST_NO_LF
        ]
    };
    const INTERPOLATED_VERBATIM_STRING = {
        className: 'string',
        begin: /\$@"/,
        end: '"',
        contains: [
            {
                begin: /\{\{/
            },
            {
                begin: /\}\}/
            },
            {
                begin: '""'
            },
            SUBST
        ]
    };
    const INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
        illegal: /\n/,
        contains: [
            {
                begin: /\{\{/
            },
            {
                begin: /\}\}/
            },
            {
                begin: '""'
            },
            SUBST_NO_LF
        ]
    });
    SUBST.contains = [
        INTERPOLATED_VERBATIM_STRING,
        INTERPOLATED_STRING,
        VERBATIM_STRING,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        NUMBERS,
        hljs.C_BLOCK_COMMENT_MODE
    ];
    SUBST_NO_LF.contains = [
        INTERPOLATED_VERBATIM_STRING_NO_LF,
        INTERPOLATED_STRING,
        VERBATIM_STRING_NO_LF,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        NUMBERS,
        hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {
            illegal: /\n/
        })
    ];
    const STRING = {
        variants: [
            RAW_STRING,
            INTERPOLATED_VERBATIM_STRING,
            INTERPOLATED_STRING,
            VERBATIM_STRING,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    const GENERIC_MODIFIER = {
        begin: "<",
        end: ">",
        contains: [
            {
                beginKeywords: "in out"
            },
            TITLE_MODE
        ]
    };
    const TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';
    const AT_IDENTIFIER = {
        // prevents expressions like `@class` from incorrect flagging
        // `class` as a keyword
        begin: "@" + hljs.IDENT_RE,
        relevance: 0
    };
    return {
        name: 'C#',
        aliases: [
            'cs',
            'c#'
        ],
        keywords: KEYWORDS,
        illegal: /::/,
        contains: [
            hljs.COMMENT('///', '$', {
                returnBegin: true,
                contains: [
                    {
                        className: 'doctag',
                        variants: [
                            {
                                begin: '///',
                                relevance: 0
                            },
                            {
                                begin: '<!--|-->'
                            },
                            {
                                begin: '</?',
                                end: '>'
                            }
                        ]
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: 'meta',
                begin: '#',
                end: '$',
                keywords: {
                    keyword: 'if else elif endif define undef warning error line region endregion pragma checksum'
                }
            },
            STRING,
            NUMBERS,
            {
                beginKeywords: 'class interface',
                relevance: 0,
                end: /[{;=]/,
                illegal: /[^\s:,]/,
                contains: [
                    {
                        beginKeywords: "where class"
                    },
                    TITLE_MODE,
                    GENERIC_MODIFIER,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                beginKeywords: 'namespace',
                relevance: 0,
                end: /[{;=]/,
                illegal: /[^\s:]/,
                contains: [
                    TITLE_MODE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                beginKeywords: 'record',
                relevance: 0,
                end: /[{;=]/,
                illegal: /[^\s:]/,
                contains: [
                    TITLE_MODE,
                    GENERIC_MODIFIER,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                // [Attributes("")]
                className: 'meta',
                begin: '^\\s*\\[(?=[\\w])',
                excludeBegin: true,
                end: '\\]',
                excludeEnd: true,
                contains: [
                    {
                        className: 'string',
                        begin: /"/,
                        end: /"/
                    }
                ]
            },
            {
                // Expression keywords prevent 'keyword Name(...)' from being
                // recognized as a function definition
                beginKeywords: 'new return throw await else',
                relevance: 0
            },
            {
                className: 'function',
                begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*(<[^=]+>\\s*)?\\(',
                returnBegin: true,
                end: /\s*[{;=]/,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    // prevents these from being highlighted `title`
                    {
                        beginKeywords: FUNCTION_MODIFIERS.join(" "),
                        relevance: 0
                    },
                    {
                        begin: hljs.IDENT_RE + '\\s*(<[^=]+>\\s*)?\\(',
                        returnBegin: true,
                        contains: [
                            hljs.TITLE_MODE,
                            GENERIC_MODIFIER
                        ],
                        relevance: 0
                    },
                    {
                        match: /\(\)/
                    },
                    {
                        className: 'params',
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            STRING,
                            NUMBERS,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            AT_IDENTIFIER
        ]
    };
}
module.exports = $fad3e51343e8c9a2$var$csharp;

});

parcelRegister("iXTF6", function(module, exports) {
const $dce8e9f82a077427$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            scope: 'meta',
            begin: '!important'
        },
        BLOCK_COMMENT: hljs.C_BLOCK_COMMENT_MODE,
        HEXCOLOR: {
            scope: 'number',
            begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
        },
        FUNCTION_DISPATCH: {
            className: "built_in",
            begin: /[\w-]+(?=\()/
        },
        ATTRIBUTE_SELECTOR_MODE: {
            scope: 'selector-attr',
            begin: /\[/,
            end: /\]/,
            illegal: '$',
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        },
        CSS_NUMBER_MODE: {
            scope: 'number',
            begin: hljs.NUMBER_RE + '(' + '%|em|ex|ch|rem' + '|vw|vh|vmin|vmax' + '|cm|mm|in|pt|pc|px' + '|deg|grad|rad|turn' + '|s|ms' + '|Hz|kHz' + '|dpi|dpcm|dppx' + ')?',
            relevance: 0
        },
        CSS_VARIABLE: {
            className: "attr",
            begin: /--[A-Za-z_][A-Za-z0-9_-]*/
        }
    };
};
const $dce8e9f82a077427$var$HTML_TAGS = [
    'a',
    'abbr',
    'address',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'dd',
    'del',
    'details',
    'dfn',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'mark',
    'menu',
    'nav',
    'object',
    'ol',
    'optgroup',
    'option',
    'p',
    'picture',
    'q',
    'quote',
    'samp',
    'section',
    'select',
    'source',
    'span',
    'strong',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'ul',
    'var',
    'video'
];
const $dce8e9f82a077427$var$SVG_TAGS = [
    'defs',
    'g',
    'marker',
    'mask',
    'pattern',
    'svg',
    'switch',
    'symbol',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feFlood',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMorphology',
    'feOffset',
    'feSpecularLighting',
    'feTile',
    'feTurbulence',
    'linearGradient',
    'radialGradient',
    'stop',
    'circle',
    'ellipse',
    'image',
    'line',
    'path',
    'polygon',
    'polyline',
    'rect',
    'text',
    'use',
    'textPath',
    'tspan',
    'foreignObject',
    'clipPath'
];
const $dce8e9f82a077427$var$TAGS = [
    ...$dce8e9f82a077427$var$HTML_TAGS,
    ...$dce8e9f82a077427$var$SVG_TAGS
];
// Sorting, then reversing makes sure longer attributes/elements like
// `font-weight` are matched fully instead of getting false positives on say `font`
const $dce8e9f82a077427$var$MEDIA_FEATURES = [
    'any-hover',
    'any-pointer',
    'aspect-ratio',
    'color',
    'color-gamut',
    'color-index',
    'device-aspect-ratio',
    'device-height',
    'device-width',
    'display-mode',
    'forced-colors',
    'grid',
    'height',
    'hover',
    'inverted-colors',
    'monochrome',
    'orientation',
    'overflow-block',
    'overflow-inline',
    'pointer',
    'prefers-color-scheme',
    'prefers-contrast',
    'prefers-reduced-motion',
    'prefers-reduced-transparency',
    'resolution',
    'scan',
    'scripting',
    'update',
    'width',
    // TODO: find a better solution?
    'min-width',
    'max-width',
    'min-height',
    'max-height'
].sort().reverse();
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $dce8e9f82a077427$var$PSEUDO_CLASSES = [
    'active',
    'any-link',
    'blank',
    'checked',
    'current',
    'default',
    'defined',
    'dir',
    'disabled',
    'drop',
    'empty',
    'enabled',
    'first',
    'first-child',
    'first-of-type',
    'fullscreen',
    'future',
    'focus',
    'focus-visible',
    'focus-within',
    'has',
    'host',
    'host-context',
    'hover',
    'indeterminate',
    'in-range',
    'invalid',
    'is',
    'lang',
    'last-child',
    'last-of-type',
    'left',
    'link',
    'local-link',
    'not',
    'nth-child',
    'nth-col',
    'nth-last-child',
    'nth-last-col',
    'nth-last-of-type',
    'nth-of-type',
    'only-child',
    'only-of-type',
    'optional',
    'out-of-range',
    'past',
    'placeholder-shown',
    'read-only',
    'read-write',
    'required',
    'right',
    'root',
    'scope',
    'target',
    'target-within',
    'user-invalid',
    'valid',
    'visited',
    'where' // where()
].sort().reverse();
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $dce8e9f82a077427$var$PSEUDO_ELEMENTS = [
    'after',
    'backdrop',
    'before',
    'cue',
    'cue-region',
    'first-letter',
    'first-line',
    'grammar-error',
    'marker',
    'part',
    'placeholder',
    'selection',
    'slotted',
    'spelling-error'
].sort().reverse();
const $dce8e9f82a077427$var$ATTRIBUTES = [
    'accent-color',
    'align-content',
    'align-items',
    'align-self',
    'alignment-baseline',
    'all',
    'anchor-name',
    'animation',
    'animation-composition',
    'animation-delay',
    'animation-direction',
    'animation-duration',
    'animation-fill-mode',
    'animation-iteration-count',
    'animation-name',
    'animation-play-state',
    'animation-range',
    'animation-range-end',
    'animation-range-start',
    'animation-timeline',
    'animation-timing-function',
    'appearance',
    'aspect-ratio',
    'backdrop-filter',
    'backface-visibility',
    'background',
    'background-attachment',
    'background-blend-mode',
    'background-clip',
    'background-color',
    'background-image',
    'background-origin',
    'background-position',
    'background-position-x',
    'background-position-y',
    'background-repeat',
    'background-size',
    'baseline-shift',
    'block-size',
    'border',
    'border-block',
    'border-block-color',
    'border-block-end',
    'border-block-end-color',
    'border-block-end-style',
    'border-block-end-width',
    'border-block-start',
    'border-block-start-color',
    'border-block-start-style',
    'border-block-start-width',
    'border-block-style',
    'border-block-width',
    'border-bottom',
    'border-bottom-color',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-bottom-style',
    'border-bottom-width',
    'border-collapse',
    'border-color',
    'border-end-end-radius',
    'border-end-start-radius',
    'border-image',
    'border-image-outset',
    'border-image-repeat',
    'border-image-slice',
    'border-image-source',
    'border-image-width',
    'border-inline',
    'border-inline-color',
    'border-inline-end',
    'border-inline-end-color',
    'border-inline-end-style',
    'border-inline-end-width',
    'border-inline-start',
    'border-inline-start-color',
    'border-inline-start-style',
    'border-inline-start-width',
    'border-inline-style',
    'border-inline-width',
    'border-left',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-spacing',
    'border-start-end-radius',
    'border-start-start-radius',
    'border-style',
    'border-top',
    'border-top-color',
    'border-top-left-radius',
    'border-top-right-radius',
    'border-top-style',
    'border-top-width',
    'border-width',
    'bottom',
    'box-align',
    'box-decoration-break',
    'box-direction',
    'box-flex',
    'box-flex-group',
    'box-lines',
    'box-ordinal-group',
    'box-orient',
    'box-pack',
    'box-shadow',
    'box-sizing',
    'break-after',
    'break-before',
    'break-inside',
    'caption-side',
    'caret-color',
    'clear',
    'clip',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'color-scheme',
    'column-count',
    'column-fill',
    'column-gap',
    'column-rule',
    'column-rule-color',
    'column-rule-style',
    'column-rule-width',
    'column-span',
    'column-width',
    'columns',
    'contain',
    'contain-intrinsic-block-size',
    'contain-intrinsic-height',
    'contain-intrinsic-inline-size',
    'contain-intrinsic-size',
    'contain-intrinsic-width',
    'container',
    'container-name',
    'container-type',
    'content',
    'content-visibility',
    'counter-increment',
    'counter-reset',
    'counter-set',
    'cue',
    'cue-after',
    'cue-before',
    'cursor',
    'cx',
    'cy',
    'direction',
    'display',
    'dominant-baseline',
    'empty-cells',
    'enable-background',
    'field-sizing',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'flex',
    'flex-basis',
    'flex-direction',
    'flex-flow',
    'flex-grow',
    'flex-shrink',
    'flex-wrap',
    'float',
    'flood-color',
    'flood-opacity',
    'flow',
    'font',
    'font-display',
    'font-family',
    'font-feature-settings',
    'font-kerning',
    'font-language-override',
    'font-optical-sizing',
    'font-palette',
    'font-size',
    'font-size-adjust',
    'font-smooth',
    'font-smoothing',
    'font-stretch',
    'font-style',
    'font-synthesis',
    'font-synthesis-position',
    'font-synthesis-small-caps',
    'font-synthesis-style',
    'font-synthesis-weight',
    'font-variant',
    'font-variant-alternates',
    'font-variant-caps',
    'font-variant-east-asian',
    'font-variant-emoji',
    'font-variant-ligatures',
    'font-variant-numeric',
    'font-variant-position',
    'font-variation-settings',
    'font-weight',
    'forced-color-adjust',
    'gap',
    'glyph-orientation-horizontal',
    'glyph-orientation-vertical',
    'grid',
    'grid-area',
    'grid-auto-columns',
    'grid-auto-flow',
    'grid-auto-rows',
    'grid-column',
    'grid-column-end',
    'grid-column-start',
    'grid-gap',
    'grid-row',
    'grid-row-end',
    'grid-row-start',
    'grid-template',
    'grid-template-areas',
    'grid-template-columns',
    'grid-template-rows',
    'hanging-punctuation',
    'height',
    'hyphenate-character',
    'hyphenate-limit-chars',
    'hyphens',
    'icon',
    'image-orientation',
    'image-rendering',
    'image-resolution',
    'ime-mode',
    'initial-letter',
    'initial-letter-align',
    'inline-size',
    'inset',
    'inset-area',
    'inset-block',
    'inset-block-end',
    'inset-block-start',
    'inset-inline',
    'inset-inline-end',
    'inset-inline-start',
    'isolation',
    'justify-content',
    'justify-items',
    'justify-self',
    'kerning',
    'left',
    'letter-spacing',
    'lighting-color',
    'line-break',
    'line-height',
    'line-height-step',
    'list-style',
    'list-style-image',
    'list-style-position',
    'list-style-type',
    'margin',
    'margin-block',
    'margin-block-end',
    'margin-block-start',
    'margin-bottom',
    'margin-inline',
    'margin-inline-end',
    'margin-inline-start',
    'margin-left',
    'margin-right',
    'margin-top',
    'margin-trim',
    'marker',
    'marker-end',
    'marker-mid',
    'marker-start',
    'marks',
    'mask',
    'mask-border',
    'mask-border-mode',
    'mask-border-outset',
    'mask-border-repeat',
    'mask-border-slice',
    'mask-border-source',
    'mask-border-width',
    'mask-clip',
    'mask-composite',
    'mask-image',
    'mask-mode',
    'mask-origin',
    'mask-position',
    'mask-repeat',
    'mask-size',
    'mask-type',
    'masonry-auto-flow',
    'math-depth',
    'math-shift',
    'math-style',
    'max-block-size',
    'max-height',
    'max-inline-size',
    'max-width',
    'min-block-size',
    'min-height',
    'min-inline-size',
    'min-width',
    'mix-blend-mode',
    'nav-down',
    'nav-index',
    'nav-left',
    'nav-right',
    'nav-up',
    'none',
    'normal',
    'object-fit',
    'object-position',
    'offset',
    'offset-anchor',
    'offset-distance',
    'offset-path',
    'offset-position',
    'offset-rotate',
    'opacity',
    'order',
    'orphans',
    'outline',
    'outline-color',
    'outline-offset',
    'outline-style',
    'outline-width',
    'overflow',
    'overflow-anchor',
    'overflow-block',
    'overflow-clip-margin',
    'overflow-inline',
    'overflow-wrap',
    'overflow-x',
    'overflow-y',
    'overlay',
    'overscroll-behavior',
    'overscroll-behavior-block',
    'overscroll-behavior-inline',
    'overscroll-behavior-x',
    'overscroll-behavior-y',
    'padding',
    'padding-block',
    'padding-block-end',
    'padding-block-start',
    'padding-bottom',
    'padding-inline',
    'padding-inline-end',
    'padding-inline-start',
    'padding-left',
    'padding-right',
    'padding-top',
    'page',
    'page-break-after',
    'page-break-before',
    'page-break-inside',
    'paint-order',
    'pause',
    'pause-after',
    'pause-before',
    'perspective',
    'perspective-origin',
    'place-content',
    'place-items',
    'place-self',
    'pointer-events',
    'position',
    'position-anchor',
    'position-visibility',
    'print-color-adjust',
    'quotes',
    'r',
    'resize',
    'rest',
    'rest-after',
    'rest-before',
    'right',
    'rotate',
    'row-gap',
    'ruby-align',
    'ruby-position',
    'scale',
    'scroll-behavior',
    'scroll-margin',
    'scroll-margin-block',
    'scroll-margin-block-end',
    'scroll-margin-block-start',
    'scroll-margin-bottom',
    'scroll-margin-inline',
    'scroll-margin-inline-end',
    'scroll-margin-inline-start',
    'scroll-margin-left',
    'scroll-margin-right',
    'scroll-margin-top',
    'scroll-padding',
    'scroll-padding-block',
    'scroll-padding-block-end',
    'scroll-padding-block-start',
    'scroll-padding-bottom',
    'scroll-padding-inline',
    'scroll-padding-inline-end',
    'scroll-padding-inline-start',
    'scroll-padding-left',
    'scroll-padding-right',
    'scroll-padding-top',
    'scroll-snap-align',
    'scroll-snap-stop',
    'scroll-snap-type',
    'scroll-timeline',
    'scroll-timeline-axis',
    'scroll-timeline-name',
    'scrollbar-color',
    'scrollbar-gutter',
    'scrollbar-width',
    'shape-image-threshold',
    'shape-margin',
    'shape-outside',
    'shape-rendering',
    'speak',
    'speak-as',
    'src',
    'stop-color',
    'stop-opacity',
    'stroke',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'tab-size',
    'table-layout',
    'text-align',
    'text-align-all',
    'text-align-last',
    'text-anchor',
    'text-combine-upright',
    'text-decoration',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-skip',
    'text-decoration-skip-ink',
    'text-decoration-style',
    'text-decoration-thickness',
    'text-emphasis',
    'text-emphasis-color',
    'text-emphasis-position',
    'text-emphasis-style',
    'text-indent',
    'text-justify',
    'text-orientation',
    'text-overflow',
    'text-rendering',
    'text-shadow',
    'text-size-adjust',
    'text-transform',
    'text-underline-offset',
    'text-underline-position',
    'text-wrap',
    'text-wrap-mode',
    'text-wrap-style',
    'timeline-scope',
    'top',
    'touch-action',
    'transform',
    'transform-box',
    'transform-origin',
    'transform-style',
    'transition',
    'transition-behavior',
    'transition-delay',
    'transition-duration',
    'transition-property',
    'transition-timing-function',
    'translate',
    'unicode-bidi',
    'user-modify',
    'user-select',
    'vector-effect',
    'vertical-align',
    'view-timeline',
    'view-timeline-axis',
    'view-timeline-inset',
    'view-timeline-name',
    'view-transition-name',
    'visibility',
    'voice-balance',
    'voice-duration',
    'voice-family',
    'voice-pitch',
    'voice-range',
    'voice-rate',
    'voice-stress',
    'voice-volume',
    'white-space',
    'white-space-collapse',
    'widows',
    'width',
    'will-change',
    'word-break',
    'word-spacing',
    'word-wrap',
    'writing-mode',
    'x',
    'y',
    'z-index',
    'zoom'
].sort().reverse();
/*
Language: CSS
Category: common, css, web
Website: https://developer.mozilla.org/en-US/docs/Web/CSS
*/ /** @type LanguageFn */ function $dce8e9f82a077427$var$css(hljs) {
    const regex = hljs.regex;
    const modes = $dce8e9f82a077427$var$MODES(hljs);
    const VENDOR_PREFIX = {
        begin: /-(webkit|moz|ms|o)-(?=[a-z])/
    };
    const AT_MODIFIERS = "and or not only";
    const AT_PROPERTY_RE = /@-?\w[\w]*(-\w+)*/; // @-webkit-keyframes
    const IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
    const STRINGS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
    ];
    return {
        name: 'CSS',
        case_insensitive: true,
        illegal: /[=|'\$]/,
        keywords: {
            keyframePosition: "from to"
        },
        classNameAliases: {
            // for visual continuity with `tag {}` and because we
            // don't have a great class for this?
            keyframePosition: "selector-tag"
        },
        contains: [
            modes.BLOCK_COMMENT,
            VENDOR_PREFIX,
            // to recognize keyframe 40% etc which are outside the scope of our
            // attribute value mode
            modes.CSS_NUMBER_MODE,
            {
                className: 'selector-id',
                begin: /#[A-Za-z0-9_-]+/,
                relevance: 0
            },
            {
                className: 'selector-class',
                begin: '\\.' + IDENT_RE,
                relevance: 0
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: 'selector-pseudo',
                variants: [
                    {
                        begin: ':(' + $dce8e9f82a077427$var$PSEUDO_CLASSES.join('|') + ')'
                    },
                    {
                        begin: ':(:)?(' + $dce8e9f82a077427$var$PSEUDO_ELEMENTS.join('|') + ')'
                    }
                ]
            },
            // we may actually need this (12/2020)
            // { // pseudo-selector params
            //   begin: /\(/,
            //   end: /\)/,
            //   contains: [ hljs.CSS_NUMBER_MODE ]
            // },
            modes.CSS_VARIABLE,
            {
                className: 'attribute',
                begin: '\\b(' + $dce8e9f82a077427$var$ATTRIBUTES.join('|') + ')\\b'
            },
            // attribute values
            {
                begin: /:/,
                end: /[;}{]/,
                contains: [
                    modes.BLOCK_COMMENT,
                    modes.HEXCOLOR,
                    modes.IMPORTANT,
                    modes.CSS_NUMBER_MODE,
                    ...STRINGS,
                    // needed to highlight these as strings and to avoid issues with
                    // illegal characters that might be inside urls that would tigger the
                    // languages illegal stack
                    {
                        begin: /(url|data-uri)\(/,
                        end: /\)/,
                        relevance: 0,
                        keywords: {
                            built_in: "url data-uri"
                        },
                        contains: [
                            ...STRINGS,
                            {
                                className: "string",
                                // any character other than `)` as in `url()` will be the start
                                // of a string, which ends with `)` (from the parent mode)
                                begin: /[^)]/,
                                endsWithParent: true,
                                excludeEnd: true
                            }
                        ]
                    },
                    modes.FUNCTION_DISPATCH
                ]
            },
            {
                begin: regex.lookahead(/@/),
                end: '[{;]',
                relevance: 0,
                illegal: /:/,
                contains: [
                    {
                        className: 'keyword',
                        begin: AT_PROPERTY_RE
                    },
                    {
                        begin: /\s/,
                        endsWithParent: true,
                        excludeEnd: true,
                        relevance: 0,
                        keywords: {
                            $pattern: /[a-z-]+/,
                            keyword: AT_MODIFIERS,
                            attribute: $dce8e9f82a077427$var$MEDIA_FEATURES.join(" ")
                        },
                        contains: [
                            {
                                begin: /[a-z-]+(?=:)/,
                                className: "attribute"
                            },
                            ...STRINGS,
                            modes.CSS_NUMBER_MODE
                        ]
                    }
                ]
            },
            {
                className: 'selector-tag',
                begin: '\\b(' + $dce8e9f82a077427$var$TAGS.join('|') + ')\\b'
            }
        ]
    };
}
module.exports = $dce8e9f82a077427$var$css;

});

parcelRegister("3AIsM", function(module, exports) {
/*
Language: Dockerfile
Requires: bash.js
Author: Alexis Hénaut <alexis@henaut.net>
Description: language definition for Dockerfile files
Website: https://docs.docker.com/engine/reference/builder/
Category: config
*/ /** @type LanguageFn */ function $29d7395c797bc8c4$var$dockerfile(hljs) {
    const KEYWORDS = [
        "from",
        "maintainer",
        "expose",
        "env",
        "arg",
        "user",
        "onbuild",
        "stopsignal"
    ];
    return {
        name: 'Dockerfile',
        aliases: [
            'docker'
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            {
                beginKeywords: 'run cmd entrypoint volume add copy workdir label healthcheck shell',
                starts: {
                    end: /[^\\]$/,
                    subLanguage: 'bash'
                }
            }
        ],
        illegal: '</'
    };
}
module.exports = $29d7395c797bc8c4$var$dockerfile;

});

parcelRegister("hZGrj", function(module, exports) {
/*
Language: Batch file (DOS)
Author: Alexander Makarov <sam@rmcreative.ru>
Contributors: Anton Kochkov <anton.kochkov@gmail.com>
Website: https://en.wikipedia.org/wiki/Batch_file
Category: scripting
*/ /** @type LanguageFn */ function $d1990dc3816dab1c$var$dos(hljs) {
    const COMMENT = hljs.COMMENT(/^\s*@?rem\b/, /$/, {
        relevance: 10
    });
    const LABEL = {
        className: 'symbol',
        begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)',
        relevance: 0
    };
    const KEYWORDS = [
        "if",
        "else",
        "goto",
        "for",
        "in",
        "do",
        "call",
        "exit",
        "not",
        "exist",
        "errorlevel",
        "defined",
        "equ",
        "neq",
        "lss",
        "leq",
        "gtr",
        "geq"
    ];
    const BUILT_INS = [
        "prn",
        "nul",
        "lpt3",
        "lpt2",
        "lpt1",
        "con",
        "com4",
        "com3",
        "com2",
        "com1",
        "aux",
        "shift",
        "cd",
        "dir",
        "echo",
        "setlocal",
        "endlocal",
        "set",
        "pause",
        "copy",
        "append",
        "assoc",
        "at",
        "attrib",
        "break",
        "cacls",
        "cd",
        "chcp",
        "chdir",
        "chkdsk",
        "chkntfs",
        "cls",
        "cmd",
        "color",
        "comp",
        "compact",
        "convert",
        "date",
        "dir",
        "diskcomp",
        "diskcopy",
        "doskey",
        "erase",
        "fs",
        "find",
        "findstr",
        "format",
        "ftype",
        "graftabl",
        "help",
        "keyb",
        "label",
        "md",
        "mkdir",
        "mode",
        "more",
        "move",
        "path",
        "pause",
        "print",
        "popd",
        "pushd",
        "promt",
        "rd",
        "recover",
        "rem",
        "rename",
        "replace",
        "restore",
        "rmdir",
        "shift",
        "sort",
        "start",
        "subst",
        "time",
        "title",
        "tree",
        "type",
        "ver",
        "verify",
        "vol",
        // winutils
        "ping",
        "net",
        "ipconfig",
        "taskkill",
        "xcopy",
        "ren",
        "del"
    ];
    return {
        name: 'Batch file (DOS)',
        aliases: [
            'bat',
            'cmd'
        ],
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: KEYWORDS,
            built_in: BUILT_INS
        },
        contains: [
            {
                className: 'variable',
                begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
            },
            {
                className: 'function',
                begin: LABEL.begin,
                end: 'goto:eof',
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'
                    }),
                    COMMENT
                ]
            },
            {
                className: 'number',
                begin: '\\b\\d+',
                relevance: 0
            },
            COMMENT
        ]
    };
}
module.exports = $d1990dc3816dab1c$var$dos;

});

parcelRegister("5qGNl", function(module, exports) {
/*
Language: Extended Backus-Naur Form
Author: Alex McKibben <alex@nullscope.net>
Website: https://en.wikipedia.org/wiki/Extended_Backus–Naur_form
Category: syntax
*/ /** @type LanguageFn */ function $3f4093a37f902746$var$ebnf(hljs) {
    const commentMode = hljs.COMMENT(/\(\*/, /\*\)/);
    const nonTerminalMode = {
        className: "attribute",
        begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
    };
    const specialSequenceMode = {
        className: "meta",
        begin: /\?.*\?/
    };
    const ruleBodyMode = {
        begin: /=/,
        end: /[.;]/,
        contains: [
            commentMode,
            specialSequenceMode,
            {
                // terminals
                className: 'string',
                variants: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    {
                        begin: '`',
                        end: '`'
                    }
                ]
            }
        ]
    };
    return {
        name: 'Extended Backus-Naur Form',
        illegal: /\S/,
        contains: [
            commentMode,
            nonTerminalMode,
            ruleBodyMode
        ]
    };
}
module.exports = $3f4093a37f902746$var$ebnf;

});

parcelRegister("a3Tks", function(module, exports) {
/*
Language: Go
Author: Stephan Kountso aka StepLg <steplg@gmail.com>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>
Description: Google go language (golang). For info about language
Website: http://golang.org/
Category: common, system
*/ function $75351a5dcc27747b$var$go(hljs) {
    const LITERALS = [
        "true",
        "false",
        "iota",
        "nil"
    ];
    const BUILT_INS = [
        "append",
        "cap",
        "close",
        "complex",
        "copy",
        "imag",
        "len",
        "make",
        "new",
        "panic",
        "print",
        "println",
        "real",
        "recover",
        "delete"
    ];
    const TYPES = [
        "bool",
        "byte",
        "complex64",
        "complex128",
        "error",
        "float32",
        "float64",
        "int8",
        "int16",
        "int32",
        "int64",
        "string",
        "uint8",
        "uint16",
        "uint32",
        "uint64",
        "int",
        "uint",
        "uintptr",
        "rune"
    ];
    const KWS = [
        "break",
        "case",
        "chan",
        "const",
        "continue",
        "default",
        "defer",
        "else",
        "fallthrough",
        "for",
        "func",
        "go",
        "goto",
        "if",
        "import",
        "interface",
        "map",
        "package",
        "range",
        "return",
        "select",
        "struct",
        "switch",
        "type",
        "var"
    ];
    const KEYWORDS = {
        keyword: KWS,
        type: TYPES,
        literal: LITERALS,
        built_in: BUILT_INS
    };
    return {
        name: 'Go',
        aliases: [
            'golang'
        ],
        keywords: KEYWORDS,
        illegal: '</',
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: 'string',
                variants: [
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    {
                        begin: '`',
                        end: '`'
                    }
                ]
            },
            {
                className: 'number',
                variants: [
                    {
                        match: /-?\b0[xX]\.[a-fA-F0-9](_?[a-fA-F0-9])*[pP][+-]?\d(_?\d)*i?/,
                        relevance: 0
                    },
                    {
                        match: /-?\b0[xX](_?[a-fA-F0-9])+((\.([a-fA-F0-9](_?[a-fA-F0-9])*)?)?[pP][+-]?\d(_?\d)*)?i?/,
                        relevance: 0
                    },
                    {
                        match: /-?\b0[oO](_?[0-7])*i?/,
                        relevance: 0
                    },
                    {
                        match: /-?\.\d(_?\d)*([eE][+-]?\d(_?\d)*)?i?/,
                        relevance: 0
                    },
                    {
                        match: /-?\b\d(_?\d)*(\.(\d(_?\d)*)?)?([eE][+-]?\d(_?\d)*)?i?/,
                        relevance: 0
                    }
                ]
            },
            {
                begin: /:=/ // relevance booster
            },
            {
                className: 'function',
                beginKeywords: 'func',
                end: '\\s*(\\{|$)',
                excludeEnd: true,
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: 'params',
                        begin: /\(/,
                        end: /\)/,
                        endsParent: true,
                        keywords: KEYWORDS,
                        illegal: /["']/
                    }
                ]
            }
        ]
    };
}
module.exports = $75351a5dcc27747b$var$go;

});

parcelRegister("4huqg", function(module, exports) {
/*
Language: Gradle
Description: Gradle is an open-source build automation tool focused on flexibility and performance.
Website: https://gradle.org
Author: Damian Mee <mee.damian@gmail.com>
Category: build-system
*/ function $31e0593edfbfe76d$var$gradle(hljs) {
    const KEYWORDS = [
        "task",
        "project",
        "allprojects",
        "subprojects",
        "artifacts",
        "buildscript",
        "configurations",
        "dependencies",
        "repositories",
        "sourceSets",
        "description",
        "delete",
        "from",
        "into",
        "include",
        "exclude",
        "source",
        "classpath",
        "destinationDir",
        "includes",
        "options",
        "sourceCompatibility",
        "targetCompatibility",
        "group",
        "flatDir",
        "doLast",
        "doFirst",
        "flatten",
        "todir",
        "fromdir",
        "ant",
        "def",
        "abstract",
        "break",
        "case",
        "catch",
        "continue",
        "default",
        "do",
        "else",
        "extends",
        "final",
        "finally",
        "for",
        "if",
        "implements",
        "instanceof",
        "native",
        "new",
        "private",
        "protected",
        "public",
        "return",
        "static",
        "switch",
        "synchronized",
        "throw",
        "throws",
        "transient",
        "try",
        "volatile",
        "while",
        "strictfp",
        "package",
        "import",
        "false",
        "null",
        "super",
        "this",
        "true",
        "antlrtask",
        "checkstyle",
        "codenarc",
        "copy",
        "boolean",
        "byte",
        "char",
        "class",
        "double",
        "float",
        "int",
        "interface",
        "long",
        "short",
        "void",
        "compile",
        "runTime",
        "file",
        "fileTree",
        "abs",
        "any",
        "append",
        "asList",
        "asWritable",
        "call",
        "collect",
        "compareTo",
        "count",
        "div",
        "dump",
        "each",
        "eachByte",
        "eachFile",
        "eachLine",
        "every",
        "find",
        "findAll",
        "flatten",
        "getAt",
        "getErr",
        "getIn",
        "getOut",
        "getText",
        "grep",
        "immutable",
        "inject",
        "inspect",
        "intersect",
        "invokeMethods",
        "isCase",
        "join",
        "leftShift",
        "minus",
        "multiply",
        "newInputStream",
        "newOutputStream",
        "newPrintWriter",
        "newReader",
        "newWriter",
        "next",
        "plus",
        "pop",
        "power",
        "previous",
        "print",
        "println",
        "push",
        "putAt",
        "read",
        "readBytes",
        "readLines",
        "reverse",
        "reverseEach",
        "round",
        "size",
        "sort",
        "splitEachLine",
        "step",
        "subMap",
        "times",
        "toInteger",
        "toList",
        "tokenize",
        "upto",
        "waitForOrKill",
        "withPrintWriter",
        "withReader",
        "withStream",
        "withWriter",
        "withWriterAppend",
        "write",
        "writeLine"
    ];
    return {
        name: 'Gradle',
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.REGEXP_MODE
        ]
    };
}
module.exports = $31e0593edfbfe76d$var$gradle;

});

parcelRegister("12CYi", function(module, exports) {
/*
 Language: Groovy
 Author: Guillaume Laforge <glaforge@gmail.com>
 Description: Groovy programming language implementation inspired from Vsevolod's Java mode
 Website: https://groovy-lang.org
 Category: system
 */ function $0c243546043f693a$var$variants(variants1, obj = {}) {
    obj.variants = variants1;
    return obj;
}
function $0c243546043f693a$var$groovy(hljs) {
    const regex = hljs.regex;
    const IDENT_RE = '[A-Za-z0-9_$]+';
    const COMMENT = $0c243546043f693a$var$variants([
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT('/\\*\\*', '\\*/', {
            relevance: 0,
            contains: [
                {
                    // eat up @'s in emails to prevent them to be recognized as doctags
                    begin: /\w+@/,
                    relevance: 0
                },
                {
                    className: 'doctag',
                    begin: '@[A-Za-z]+'
                }
            ]
        })
    ]);
    const REGEXP = {
        className: 'regexp',
        begin: /~?\/[^\/\n]+\//,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const NUMBER = $0c243546043f693a$var$variants([
        hljs.BINARY_NUMBER_MODE,
        hljs.C_NUMBER_MODE
    ]);
    const STRING = $0c243546043f693a$var$variants([
        {
            begin: /"""/,
            end: /"""/
        },
        {
            begin: /'''/,
            end: /'''/
        },
        {
            begin: "\\$/",
            end: "/\\$",
            relevance: 10
        },
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
    ], {
        className: "string"
    });
    const CLASS_DEFINITION = {
        match: [
            /(class|interface|trait|enum|record|extends|implements)/,
            /\s+/,
            hljs.UNDERSCORE_IDENT_RE
        ],
        scope: {
            1: "keyword",
            3: "title.class"
        }
    };
    const TYPES = [
        "byte",
        "short",
        "char",
        "int",
        "long",
        "boolean",
        "float",
        "double",
        "void"
    ];
    const KEYWORDS = [
        // groovy specific keywords
        "def",
        "as",
        "in",
        "assert",
        "trait",
        // common keywords with Java
        "abstract",
        "static",
        "volatile",
        "transient",
        "public",
        "private",
        "protected",
        "synchronized",
        "final",
        "class",
        "interface",
        "enum",
        "if",
        "else",
        "for",
        "while",
        "switch",
        "case",
        "break",
        "default",
        "continue",
        "throw",
        "throws",
        "try",
        "catch",
        "finally",
        "implements",
        "extends",
        "new",
        "import",
        "package",
        "return",
        "instanceof",
        "var"
    ];
    return {
        name: 'Groovy',
        keywords: {
            "variable.language": 'this super',
            literal: 'true false null',
            type: TYPES,
            keyword: KEYWORDS
        },
        contains: [
            hljs.SHEBANG({
                binary: "groovy",
                relevance: 10
            }),
            COMMENT,
            STRING,
            REGEXP,
            NUMBER,
            CLASS_DEFINITION,
            {
                className: 'meta',
                begin: '@[A-Za-z]+',
                relevance: 0
            },
            {
                // highlight map keys and named parameters as attrs
                className: 'attr',
                begin: IDENT_RE + '[ \t]*:',
                relevance: 0
            },
            {
                // catch middle element of the ternary operator
                // to avoid highlight it as a label, named parameter, or map key
                begin: /\?/,
                end: /:/,
                relevance: 0,
                contains: [
                    COMMENT,
                    STRING,
                    REGEXP,
                    NUMBER,
                    'self'
                ]
            },
            {
                // highlight labeled statements
                className: 'symbol',
                begin: '^[ \t]*' + regex.lookahead(IDENT_RE + ':'),
                excludeBegin: true,
                end: IDENT_RE + ':',
                relevance: 0
            }
        ],
        illegal: /#|<\//
    };
}
module.exports = $0c243546043f693a$var$groovy;

});

parcelRegister("6lvAh", function(module, exports) {
/*
Language: Handlebars
Requires: xml.js
Author: Robin Ward <robin.ward@gmail.com>
Description: Matcher for Handlebars as well as EmberJS additions.
Website: https://handlebarsjs.com
Category: template
*/ function $49ed34335d23ac0c$var$handlebars(hljs) {
    const regex = hljs.regex;
    const BUILT_INS = {
        $pattern: /[\w.\/]+/,
        built_in: [
            'action',
            'bindattr',
            'collection',
            'component',
            'concat',
            'debugger',
            'each',
            'each-in',
            'get',
            'hash',
            'if',
            'in',
            'input',
            'link-to',
            'loc',
            'log',
            'lookup',
            'mut',
            'outlet',
            'partial',
            'query-params',
            'render',
            'template',
            'textarea',
            'unbound',
            'unless',
            'view',
            'with',
            'yield'
        ]
    };
    const LITERALS = {
        $pattern: /[\w.\/]+/,
        literal: [
            'true',
            'false',
            'undefined',
            'null'
        ]
    };
    // as defined in https://handlebarsjs.com/guide/expressions.html#literal-segments
    // this regex matches literal segments like ' abc ' or [ abc ] as well as helpers and paths
    // like a/b, ./abc/cde, and abc.bcd
    const DOUBLE_QUOTED_ID_REGEX = /""|"[^"]+"/;
    const SINGLE_QUOTED_ID_REGEX = /''|'[^']+'/;
    const BRACKET_QUOTED_ID_REGEX = /\[\]|\[[^\]]+\]/;
    const PLAIN_ID_REGEX = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/;
    const PATH_DELIMITER_REGEX = /(\.|\/)/;
    const ANY_ID = regex.either(DOUBLE_QUOTED_ID_REGEX, SINGLE_QUOTED_ID_REGEX, BRACKET_QUOTED_ID_REGEX, PLAIN_ID_REGEX);
    const IDENTIFIER_REGEX = regex.concat(regex.optional(/\.|\.\/|\//), ANY_ID, regex.anyNumberOfTimes(regex.concat(PATH_DELIMITER_REGEX, ANY_ID)));
    // identifier followed by a equal-sign (without the equal sign)
    const HASH_PARAM_REGEX = regex.concat('(', BRACKET_QUOTED_ID_REGEX, '|', PLAIN_ID_REGEX, ')(?==)');
    const HELPER_NAME_OR_PATH_EXPRESSION = {
        begin: IDENTIFIER_REGEX
    };
    const HELPER_PARAMETER = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: LITERALS
    });
    const SUB_EXPRESSION = {
        begin: /\(/,
        end: /\)/
    };
    const HASH = {
        // fka "attribute-assignment", parameters of the form 'key=value'
        className: 'attr',
        begin: HASH_PARAM_REGEX,
        relevance: 0,
        starts: {
            begin: /=/,
            end: /=/,
            starts: {
                contains: [
                    hljs.NUMBER_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    HELPER_PARAMETER,
                    SUB_EXPRESSION
                ]
            }
        }
    };
    const BLOCK_PARAMS = {
        // parameters of the form '{{#with x as | y |}}...{{/with}}'
        begin: /as\s+\|/,
        keywords: {
            keyword: 'as'
        },
        end: /\|/,
        contains: [
            {
                // define sub-mode in order to prevent highlighting of block-parameter named "as"
                begin: /\w+/
            }
        ]
    };
    const HELPER_PARAMETERS = {
        contains: [
            hljs.NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            BLOCK_PARAMS,
            HASH,
            HELPER_PARAMETER,
            SUB_EXPRESSION
        ],
        returnEnd: true
    };
    const SUB_EXPRESSION_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        className: 'name',
        keywords: BUILT_INS,
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\)/
        })
    });
    SUB_EXPRESSION.contains = [
        SUB_EXPRESSION_CONTENTS
    ];
    const OPENING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: BUILT_INS,
        className: 'name',
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\}\}/
        })
    });
    const CLOSING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: BUILT_INS,
        className: 'name'
    });
    const BASIC_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        className: 'name',
        keywords: BUILT_INS,
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\}\}/
        })
    });
    const ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH = {
        begin: /\\\{\{/,
        skip: true
    };
    const PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH = {
        begin: /\\\\(?=\{\{)/,
        skip: true
    };
    return {
        name: 'Handlebars',
        aliases: [
            'hbs',
            'html.hbs',
            'html.handlebars',
            'htmlbars'
        ],
        case_insensitive: true,
        subLanguage: 'xml',
        contains: [
            ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH,
            PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH,
            hljs.COMMENT(/\{\{!--/, /--\}\}/),
            hljs.COMMENT(/\{\{!/, /\}\}/),
            {
                // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
                className: 'template-tag',
                begin: /\{\{\{\{(?!\/)/,
                end: /\}\}\}\}/,
                contains: [
                    OPENING_BLOCK_MUSTACHE_CONTENTS
                ],
                starts: {
                    end: /\{\{\{\{\//,
                    returnEnd: true,
                    subLanguage: 'xml'
                }
            },
            {
                // close raw block
                className: 'template-tag',
                begin: /\{\{\{\{\//,
                end: /\}\}\}\}/,
                contains: [
                    CLOSING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // open block statement
                className: 'template-tag',
                begin: /\{\{#/,
                end: /\}\}/,
                contains: [
                    OPENING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                className: 'template-tag',
                begin: /\{\{(?=else\}\})/,
                end: /\}\}/,
                keywords: 'else'
            },
            {
                className: 'template-tag',
                begin: /\{\{(?=else if)/,
                end: /\}\}/,
                keywords: 'else if'
            },
            {
                // closing block statement
                className: 'template-tag',
                begin: /\{\{\//,
                end: /\}\}/,
                contains: [
                    CLOSING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is NOT html-escaped
                className: 'template-variable',
                begin: /\{\{\{/,
                end: /\}\}\}/,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is html-escaped
                className: 'template-variable',
                begin: /\{\{/,
                end: /\}\}/,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            }
        ]
    };
}
module.exports = $49ed34335d23ac0c$var$handlebars;

});

parcelRegister("aLzAh", function(module, exports) {
/*
Language: HTTP
Description: HTTP request and response headers with automatic body highlighting
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Category: protocols, web
Website: https://developer.mozilla.org/en-US/docs/Web/HTTP/Overview
*/ function $7d69e56cc06075bc$var$http(hljs) {
    const regex = hljs.regex;
    const VERSION = 'HTTP/([32]|1\\.[01])';
    const HEADER_NAME = /[A-Za-z][A-Za-z0-9-]*/;
    const HEADER = {
        className: 'attribute',
        begin: regex.concat('^', HEADER_NAME, '(?=\\:\\s)'),
        starts: {
            contains: [
                {
                    className: "punctuation",
                    begin: /: /,
                    relevance: 0,
                    starts: {
                        end: '$',
                        relevance: 0
                    }
                }
            ]
        }
    };
    const HEADERS_AND_BODY = [
        HEADER,
        {
            begin: '\\n\\n',
            starts: {
                subLanguage: [],
                endsWithParent: true
            }
        }
    ];
    return {
        name: 'HTTP',
        aliases: [
            'https'
        ],
        illegal: /\S/,
        contains: [
            // response
            {
                begin: '^(?=' + VERSION + " \\d{3})",
                end: /$/,
                contains: [
                    {
                        className: "meta",
                        begin: VERSION
                    },
                    {
                        className: 'number',
                        begin: '\\b\\d{3}\\b'
                    }
                ],
                starts: {
                    end: /\b\B/,
                    illegal: /\S/,
                    contains: HEADERS_AND_BODY
                }
            },
            // request
            {
                begin: '(?=^[A-Z]+ (.*?) ' + VERSION + '$)',
                end: /$/,
                contains: [
                    {
                        className: 'string',
                        begin: ' ',
                        end: ' ',
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "meta",
                        begin: VERSION
                    },
                    {
                        className: 'keyword',
                        begin: '[A-Z]+'
                    }
                ],
                starts: {
                    end: /\b\B/,
                    illegal: /\S/,
                    contains: HEADERS_AND_BODY
                }
            },
            // to allow headers to work even without a preamble
            hljs.inherit(HEADER, {
                relevance: 0
            })
        ]
    };
}
module.exports = $7d69e56cc06075bc$var$http;

});

parcelRegister("5WypX", function(module, exports) {
/*
Language: TOML, also INI
Description: TOML aims to be a minimal configuration file format that's easy to read due to obvious semantics.
Contributors: Guillaume Gomez <guillaume1.gomez@gmail.com>
Category: common, config
Website: https://github.com/toml-lang/toml
*/ function $453d1124ef05bd9c$var$ini(hljs) {
    const regex = hljs.regex;
    const NUMBERS = {
        className: 'number',
        relevance: 0,
        variants: [
            {
                begin: /([+-]+)?[\d]+_[\d_]+/
            },
            {
                begin: hljs.NUMBER_RE
            }
        ]
    };
    const COMMENTS = hljs.COMMENT();
    COMMENTS.variants = [
        {
            begin: /;/,
            end: /$/
        },
        {
            begin: /#/,
            end: /$/
        }
    ];
    const VARIABLES = {
        className: 'variable',
        variants: [
            {
                begin: /\$[\w\d"][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)\}/
            }
        ]
    };
    const LITERALS = {
        className: 'literal',
        begin: /\bon|off|true|false|yes|no\b/
    };
    const STRINGS = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: "'''",
                end: "'''",
                relevance: 10
            },
            {
                begin: '"""',
                end: '"""',
                relevance: 10
            },
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            }
        ]
    };
    const ARRAY = {
        begin: /\[/,
        end: /\]/,
        contains: [
            COMMENTS,
            LITERALS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            'self'
        ],
        relevance: 0
    };
    const BARE_KEY = /[A-Za-z0-9_-]+/;
    const QUOTED_KEY_DOUBLE_QUOTE = /"(\\"|[^"])*"/;
    const QUOTED_KEY_SINGLE_QUOTE = /'[^']*'/;
    const ANY_KEY = regex.either(BARE_KEY, QUOTED_KEY_DOUBLE_QUOTE, QUOTED_KEY_SINGLE_QUOTE);
    const DOTTED_KEY = regex.concat(ANY_KEY, '(\\s*\\.\\s*', ANY_KEY, ')*', regex.lookahead(/\s*=\s*[^#\s]/));
    return {
        name: 'TOML, also INI',
        aliases: [
            'toml'
        ],
        case_insensitive: true,
        illegal: /\S/,
        contains: [
            COMMENTS,
            {
                className: 'section',
                begin: /\[+/,
                end: /\]+/
            },
            {
                begin: DOTTED_KEY,
                className: 'attr',
                starts: {
                    end: /$/,
                    contains: [
                        COMMENTS,
                        ARRAY,
                        LITERALS,
                        VARIABLES,
                        STRINGS,
                        NUMBERS
                    ]
                }
            }
        ]
    };
}
module.exports = $453d1124ef05bd9c$var$ini;

});

parcelRegister("ajuee", function(module, exports) {
// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var $7823207d050b8222$var$decimalDigits = '[0-9](_*[0-9])*';
var $7823207d050b8222$var$frac = `\\.(${$7823207d050b8222$var$decimalDigits})`;
var $7823207d050b8222$var$hexDigits = '[0-9a-fA-F](_*[0-9a-fA-F])*';
var $7823207d050b8222$var$NUMERIC = {
    className: 'number',
    variants: [
        // DecimalFloatingPointLiteral
        // including ExponentPart
        {
            begin: `(\\b(${$7823207d050b8222$var$decimalDigits})((${$7823207d050b8222$var$frac})|\\.)?|(${$7823207d050b8222$var$frac}))` + `[eE][+-]?(${$7823207d050b8222$var$decimalDigits})[fFdD]?\\b`
        },
        // excluding ExponentPart
        {
            begin: `\\b(${$7823207d050b8222$var$decimalDigits})((${$7823207d050b8222$var$frac})[fFdD]?\\b|\\.([fFdD]\\b)?)`
        },
        {
            begin: `(${$7823207d050b8222$var$frac})[fFdD]?\\b`
        },
        {
            begin: `\\b(${$7823207d050b8222$var$decimalDigits})[fFdD]\\b`
        },
        // HexadecimalFloatingPointLiteral
        {
            begin: `\\b0[xX]((${$7823207d050b8222$var$hexDigits})\\.?|(${$7823207d050b8222$var$hexDigits})?\\.(${$7823207d050b8222$var$hexDigits}))` + `[pP][+-]?(${$7823207d050b8222$var$decimalDigits})[fFdD]?\\b`
        },
        // DecimalIntegerLiteral
        {
            begin: '\\b(0|[1-9](_*[0-9])*)[lL]?\\b'
        },
        // HexIntegerLiteral
        {
            begin: `\\b0[xX](${$7823207d050b8222$var$hexDigits})[lL]?\\b`
        },
        // OctalIntegerLiteral
        {
            begin: '\\b0(_*[0-7])*[lL]?\\b'
        },
        // BinaryIntegerLiteral
        {
            begin: '\\b0[bB][01](_*[01])*[lL]?\\b'
        }
    ],
    relevance: 0
};
/*
Language: Java
Author: Vsevolod Solovyov <vsevolod.solovyov@gmail.com>
Category: common, enterprise
Website: https://www.java.com/
*/ /**
 * Allows recursive regex expressions to a given depth
 *
 * ie: recurRegex("(abc~~~)", /~~~/g, 2) becomes:
 * (abc(abc(abc)))
 *
 * @param {string} re
 * @param {RegExp} substitution (should be a g mode regex)
 * @param {number} depth
 * @returns {string}``
 */ function $7823207d050b8222$var$recurRegex(re, substitution, depth) {
    if (depth === -1) return "";
    return re.replace(substitution, (_)=>{
        return $7823207d050b8222$var$recurRegex(re, substitution, depth - 1);
    });
}
/** @type LanguageFn */ function $7823207d050b8222$var$java(hljs) {
    const regex = hljs.regex;
    const JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
    const GENERIC_IDENT_RE = JAVA_IDENT_RE + $7823207d050b8222$var$recurRegex('(?:<' + JAVA_IDENT_RE + '~~~(?:\\s*,\\s*' + JAVA_IDENT_RE + '~~~)*>)?', /~~~/g, 2);
    const MAIN_KEYWORDS = [
        'synchronized',
        'abstract',
        'private',
        'var',
        'static',
        'if',
        'const ',
        'for',
        'while',
        'strictfp',
        'finally',
        'protected',
        'import',
        'native',
        'final',
        'void',
        'enum',
        'else',
        'break',
        'transient',
        'catch',
        'instanceof',
        'volatile',
        'case',
        'assert',
        'package',
        'default',
        'public',
        'try',
        'switch',
        'continue',
        'throws',
        'protected',
        'public',
        'private',
        'module',
        'requires',
        'exports',
        'do',
        'sealed',
        'yield',
        'permits',
        'goto',
        'when'
    ];
    const BUILT_INS = [
        'super',
        'this'
    ];
    const LITERALS = [
        'false',
        'true',
        'null'
    ];
    const TYPES = [
        'char',
        'boolean',
        'long',
        'float',
        'int',
        'byte',
        'short',
        'double'
    ];
    const KEYWORDS = {
        keyword: MAIN_KEYWORDS,
        literal: LITERALS,
        type: TYPES,
        built_in: BUILT_INS
    };
    const ANNOTATION = {
        className: 'meta',
        begin: '@' + JAVA_IDENT_RE,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    "self"
                ] // allow nested () inside our annotation
            }
        ]
    };
    const PARAMS = {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [
            hljs.C_BLOCK_COMMENT_MODE
        ],
        endsParent: true
    };
    return {
        name: 'Java',
        aliases: [
            'jsp'
        ],
        keywords: KEYWORDS,
        illegal: /<\/|#/,
        contains: [
            hljs.COMMENT('/\\*\\*', '\\*/', {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    }
                ]
            }),
            // relevance boost
            {
                begin: /import java\.[a-z]+\./,
                keywords: "import",
                relevance: 2
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                begin: /"""/,
                end: /"""/,
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                match: [
                    /\b(?:class|interface|enum|extends|implements|new)/,
                    /\s+/,
                    JAVA_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.class"
                }
            },
            {
                // Exceptions for hyphenated keywords
                match: /non-sealed/,
                scope: "keyword"
            },
            {
                begin: [
                    regex.concat(/(?!else)/, JAVA_IDENT_RE),
                    /\s+/,
                    JAVA_IDENT_RE,
                    /\s+/,
                    /=(?!=)/
                ],
                className: {
                    1: "type",
                    3: "variable",
                    5: "operator"
                }
            },
            {
                begin: [
                    /record/,
                    /\s+/,
                    JAVA_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.class"
                },
                contains: [
                    PARAMS,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                // Expression keywords prevent 'keyword Name(...)' from being
                // recognized as a function definition
                beginKeywords: 'new throw return else',
                relevance: 0
            },
            {
                begin: [
                    '(?:' + GENERIC_IDENT_RE + '\\s+)',
                    hljs.UNDERSCORE_IDENT_RE,
                    /\s*(?=\()/
                ],
                className: {
                    2: "title.function"
                },
                keywords: KEYWORDS,
                contains: [
                    {
                        className: 'params',
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            ANNOTATION,
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            $7823207d050b8222$var$NUMERIC,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            $7823207d050b8222$var$NUMERIC,
            ANNOTATION
        ]
    };
}
module.exports = $7823207d050b8222$var$java;

});

parcelRegister("79Fne", function(module, exports) {
const $5359779c5e235a5f$var$IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
const $5359779c5e235a5f$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends",
    // It's reached stage 3, which is "recommended for implementation":
    "using"
];
const $5359779c5e235a5f$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $5359779c5e235a5f$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $5359779c5e235a5f$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $5359779c5e235a5f$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $5359779c5e235a5f$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global" // Node.js
];
const $5359779c5e235a5f$var$BUILT_INS = [].concat($5359779c5e235a5f$var$BUILT_IN_GLOBALS, $5359779c5e235a5f$var$TYPES, $5359779c5e235a5f$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $5359779c5e235a5f$var$javascript(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $5359779c5e235a5f$var$IDENT_RE;
    const FRAGMENT = {
        begin: '<>',
        end: '</>'
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $5359779c5e235a5f$var$IDENT_RE,
        keyword: $5359779c5e235a5f$var$KEYWORDS,
        literal: $5359779c5e235a5f$var$LITERALS,
        built_in: $5359779c5e235a5f$var$BUILT_INS,
        "variable.language": $5359779c5e235a5f$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = '[0-9](_?[0-9])*';
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: 'number',
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: 'subst',
        begin: '\\$\\{',
        end: '\\}',
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: '\.?html`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'xml'
        }
    };
    const CSS_TEMPLATE = {
        begin: '\.?css`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'css'
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: '\.?gql`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'graphql'
        }
    };
    const TEMPLATE_STRING = {
        className: 'string',
        begin: '`',
        end: '`',
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
        relevance: 0,
        contains: [
            {
                begin: '(?=@[A-Za-z]+)',
                relevance: 0,
                contains: [
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    },
                    {
                        className: 'type',
                        begin: '\\{',
                        end: '\\}',
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: 'variable',
                        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /(\s*)\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: 'params',
        // convert this to negative lookbehind in v12
        begin: /(\s*)\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$5359779c5e235a5f$var$TYPES,
                ...$5359779c5e235a5f$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$5359779c5e235a5f$var$BUILT_IN_GLOBALS,
            "super",
            "import"
        ].map((x)=>`${x}\\s*\\(`)), IDENT_RE$1, regex.lookahead(/\s*\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>';
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: 'JavaScript',
        aliases: [
            'js',
            'jsx',
            'mjs',
            'cjs'
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                scope: 'attr',
                match: IDENT_RE$1 + regex.lookahead(':'),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
                keywords: 'return throw case',
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: 'function',
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: '\\s*=>',
                        contains: [
                            {
                                className: 'params',
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /(\s*)\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                'on:begin': XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: 'xml',
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    'self'
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: '\\b(?!function)' + hljs.UNDERSCORE_IDENT_RE + '\\(' + // first parens
                '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: '\\$' + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
module.exports = $5359779c5e235a5f$var$javascript;

});

parcelRegister("4h2Ey", function(module, exports) {
/*
Language: JSON
Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: http://www.json.org
Category: common, protocols, web
*/ function $31cacec9f0c75bfa$var$json(hljs) {
    const ATTRIBUTE = {
        className: 'attr',
        begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
        relevance: 1.01
    };
    const PUNCTUATION = {
        match: /[{}[\],:]/,
        className: "punctuation",
        relevance: 0
    };
    const LITERALS = [
        "true",
        "false",
        "null"
    ];
    // NOTE: normally we would rely on `keywords` for this but using a mode here allows us
    // - to use the very tight `illegal: \S` rule later to flag any other character
    // - as illegal indicating that despite looking like JSON we do not truly have
    // - JSON and thus improve false-positively greatly since JSON will try and claim
    // - all sorts of JSON looking stuff
    const LITERALS_MODE = {
        scope: "literal",
        beginKeywords: LITERALS.join(" ")
    };
    return {
        name: 'JSON',
        aliases: [
            'jsonc'
        ],
        keywords: {
            literal: LITERALS
        },
        contains: [
            ATTRIBUTE,
            PUNCTUATION,
            hljs.QUOTE_STRING_MODE,
            LITERALS_MODE,
            hljs.C_NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ],
        illegal: '\\S'
    };
}
module.exports = $31cacec9f0c75bfa$var$json;

});

parcelRegister("aoBt3", function(module, exports) {
// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var $7919359005021098$var$decimalDigits = '[0-9](_*[0-9])*';
var $7919359005021098$var$frac = `\\.(${$7919359005021098$var$decimalDigits})`;
var $7919359005021098$var$hexDigits = '[0-9a-fA-F](_*[0-9a-fA-F])*';
var $7919359005021098$var$NUMERIC = {
    className: 'number',
    variants: [
        // DecimalFloatingPointLiteral
        // including ExponentPart
        {
            begin: `(\\b(${$7919359005021098$var$decimalDigits})((${$7919359005021098$var$frac})|\\.)?|(${$7919359005021098$var$frac}))` + `[eE][+-]?(${$7919359005021098$var$decimalDigits})[fFdD]?\\b`
        },
        // excluding ExponentPart
        {
            begin: `\\b(${$7919359005021098$var$decimalDigits})((${$7919359005021098$var$frac})[fFdD]?\\b|\\.([fFdD]\\b)?)`
        },
        {
            begin: `(${$7919359005021098$var$frac})[fFdD]?\\b`
        },
        {
            begin: `\\b(${$7919359005021098$var$decimalDigits})[fFdD]\\b`
        },
        // HexadecimalFloatingPointLiteral
        {
            begin: `\\b0[xX]((${$7919359005021098$var$hexDigits})\\.?|(${$7919359005021098$var$hexDigits})?\\.(${$7919359005021098$var$hexDigits}))` + `[pP][+-]?(${$7919359005021098$var$decimalDigits})[fFdD]?\\b`
        },
        // DecimalIntegerLiteral
        {
            begin: '\\b(0|[1-9](_*[0-9])*)[lL]?\\b'
        },
        // HexIntegerLiteral
        {
            begin: `\\b0[xX](${$7919359005021098$var$hexDigits})[lL]?\\b`
        },
        // OctalIntegerLiteral
        {
            begin: '\\b0(_*[0-7])*[lL]?\\b'
        },
        // BinaryIntegerLiteral
        {
            begin: '\\b0[bB][01](_*[01])*[lL]?\\b'
        }
    ],
    relevance: 0
};
/*
 Language: Kotlin
 Description: Kotlin is an OSS statically typed programming language that targets the JVM, Android, JavaScript and Native.
 Author: Sergey Mashkov <cy6erGn0m@gmail.com>
 Website: https://kotlinlang.org
 Category: common
 */ function $7919359005021098$var$kotlin(hljs) {
    const KEYWORDS = {
        keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
        built_in: 'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
        literal: 'true false null'
    };
    const KEYWORDS_WITH_LABEL = {
        className: 'keyword',
        begin: /\b(break|continue|return|this)\b/,
        starts: {
            contains: [
                {
                    className: 'symbol',
                    begin: /@\w+/
                }
            ]
        }
    };
    const LABEL = {
        className: 'symbol',
        begin: hljs.UNDERSCORE_IDENT_RE + '@'
    };
    // for string templates
    const SUBST = {
        className: 'subst',
        begin: /\$\{/,
        end: /\}/,
        contains: [
            hljs.C_NUMBER_MODE
        ]
    };
    const VARIABLE = {
        className: 'variable',
        begin: '\\$' + hljs.UNDERSCORE_IDENT_RE
    };
    const STRING = {
        className: 'string',
        variants: [
            {
                begin: '"""',
                end: '"""(?=[^"])',
                contains: [
                    VARIABLE,
                    SUBST
                ]
            },
            // Can't use built-in modes easily, as we want to use STRING in the meta
            // context as 'meta-string' and there's no syntax to remove explicitly set
            // classNames in built-in modes.
            {
                begin: '\'',
                end: '\'',
                illegal: /\n/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '"',
                end: '"',
                illegal: /\n/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VARIABLE,
                    SUBST
                ]
            }
        ]
    };
    SUBST.contains.push(STRING);
    const ANNOTATION_USE_SITE = {
        className: 'meta',
        begin: '@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*' + hljs.UNDERSCORE_IDENT_RE + ')?'
    };
    const ANNOTATION = {
        className: 'meta',
        begin: '@' + hljs.UNDERSCORE_IDENT_RE,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    hljs.inherit(STRING, {
                        className: 'string'
                    }),
                    "self"
                ]
            }
        ]
    };
    // https://kotlinlang.org/docs/reference/whatsnew11.html#underscores-in-numeric-literals
    // According to the doc above, the number mode of kotlin is the same as java 8,
    // so the code below is copied from java.js
    const KOTLIN_NUMBER_MODE = $7919359005021098$var$NUMERIC;
    const KOTLIN_NESTED_COMMENT = hljs.COMMENT('/\\*', '\\*/', {
        contains: [
            hljs.C_BLOCK_COMMENT_MODE
        ]
    });
    const KOTLIN_PAREN_TYPE = {
        variants: [
            {
                className: 'type',
                begin: hljs.UNDERSCORE_IDENT_RE
            },
            {
                begin: /\(/,
                end: /\)/,
                contains: [] // defined later
            }
        ]
    };
    const KOTLIN_PAREN_TYPE2 = KOTLIN_PAREN_TYPE;
    KOTLIN_PAREN_TYPE2.variants[1].contains = [
        KOTLIN_PAREN_TYPE
    ];
    KOTLIN_PAREN_TYPE.variants[1].contains = [
        KOTLIN_PAREN_TYPE2
    ];
    return {
        name: 'Kotlin',
        aliases: [
            'kt',
            'kts'
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.COMMENT('/\\*\\*', '\\*/', {
                relevance: 0,
                contains: [
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            KOTLIN_NESTED_COMMENT,
            KEYWORDS_WITH_LABEL,
            LABEL,
            ANNOTATION_USE_SITE,
            ANNOTATION,
            {
                className: 'function',
                beginKeywords: 'fun',
                end: '[(]|$',
                returnBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                relevance: 5,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: 'type',
                        begin: /</,
                        end: />/,
                        keywords: 'reified',
                        relevance: 0
                    },
                    {
                        className: 'params',
                        begin: /\(/,
                        end: /\)/,
                        endsParent: true,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            {
                                begin: /:/,
                                end: /[=,\/]/,
                                endsWithParent: true,
                                contains: [
                                    KOTLIN_PAREN_TYPE,
                                    hljs.C_LINE_COMMENT_MODE,
                                    KOTLIN_NESTED_COMMENT
                                ],
                                relevance: 0
                            },
                            hljs.C_LINE_COMMENT_MODE,
                            KOTLIN_NESTED_COMMENT,
                            ANNOTATION_USE_SITE,
                            ANNOTATION,
                            STRING,
                            hljs.C_NUMBER_MODE
                        ]
                    },
                    KOTLIN_NESTED_COMMENT
                ]
            },
            {
                begin: [
                    /class|interface|trait/,
                    /\s+/,
                    hljs.UNDERSCORE_IDENT_RE
                ],
                beginScope: {
                    3: "title.class"
                },
                keywords: 'class interface trait',
                end: /[:\{(]|$/,
                excludeEnd: true,
                illegal: 'extends implements',
                contains: [
                    {
                        beginKeywords: 'public protected internal private constructor'
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: 'type',
                        begin: /</,
                        end: />/,
                        excludeBegin: true,
                        excludeEnd: true,
                        relevance: 0
                    },
                    {
                        className: 'type',
                        begin: /[,:]\s*/,
                        end: /[<\(,){\s]|$/,
                        excludeBegin: true,
                        returnEnd: true
                    },
                    ANNOTATION_USE_SITE,
                    ANNOTATION
                ]
            },
            STRING,
            {
                className: 'meta',
                begin: "^#!/usr/bin/env",
                end: '$',
                illegal: '\n'
            },
            KOTLIN_NUMBER_MODE
        ]
    };
}
module.exports = $7919359005021098$var$kotlin;

});

parcelRegister("kDduH", function(module, exports) {
/*
Language: Markdown
Requires: xml.js
Author: John Crepezzi <john.crepezzi@gmail.com>
Website: https://daringfireball.net/projects/markdown/
Category: common, markup
*/ function $f051ead10c12cbc4$var$markdown(hljs) {
    const regex = hljs.regex;
    const INLINE_HTML = {
        begin: /<\/?[A-Za-z_]/,
        end: '>',
        subLanguage: 'xml',
        relevance: 0
    };
    const HORIZONTAL_RULE = {
        begin: '^[-\\*]{3,}',
        end: '$'
    };
    const CODE = {
        className: 'code',
        variants: [
            // TODO: fix to allow these to work with sublanguage also
            {
                begin: '(`{3,})[^`](.|\\n)*?\\1`*[ ]*'
            },
            {
                begin: '(~{3,})[^~](.|\\n)*?\\1~*[ ]*'
            },
            // needed to allow markdown as a sublanguage to work
            {
                begin: '```',
                end: '```+[ ]*$'
            },
            {
                begin: '~~~',
                end: '~~~+[ ]*$'
            },
            {
                begin: '`.+?`'
            },
            {
                begin: '(?=^( {4}|\\t))',
                // use contains to gobble up multiple lines to allow the block to be whatever size
                // but only have a single open/close tag vs one per line
                contains: [
                    {
                        begin: '^( {4}|\\t)',
                        end: '(\\n)$'
                    }
                ],
                relevance: 0
            }
        ]
    };
    const LIST = {
        className: 'bullet',
        begin: '^[ \t]*([*+-]|(\\d+\\.))(?=\\s+)',
        end: '\\s+',
        excludeEnd: true
    };
    const LINK_REFERENCE = {
        begin: /^\[[^\n]+\]:/,
        returnBegin: true,
        contains: [
            {
                className: 'symbol',
                begin: /\[/,
                end: /\]/,
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: 'link',
                begin: /:\s*/,
                end: /$/,
                excludeBegin: true
            }
        ]
    };
    const URL_SCHEME = /[A-Za-z][A-Za-z0-9+.-]*/;
    const LINK = {
        variants: [
            // too much like nested array access in so many languages
            // to have any real relevance
            {
                begin: /\[.+?\]\[.*?\]/,
                relevance: 0
            },
            // popular internet URLs
            {
                begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
                relevance: 2
            },
            {
                begin: regex.concat(/\[.+?\]\(/, URL_SCHEME, /:\/\/.*?\)/),
                relevance: 2
            },
            // relative urls
            {
                begin: /\[.+?\]\([./?&#].*?\)/,
                relevance: 1
            },
            // whatever else, lower relevance (might not be a link at all)
            {
                begin: /\[.*?\]\(.*?\)/,
                relevance: 0
            }
        ],
        returnBegin: true,
        contains: [
            {
                // empty strings for alt or link text
                match: /\[(?=\])/
            },
            {
                className: 'string',
                relevance: 0,
                begin: '\\[',
                end: '\\]',
                excludeBegin: true,
                returnEnd: true
            },
            {
                className: 'link',
                relevance: 0,
                begin: '\\]\\(',
                end: '\\)',
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: 'symbol',
                relevance: 0,
                begin: '\\]\\[',
                end: '\\]',
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
    const BOLD = {
        className: 'strong',
        contains: [],
        variants: [
            {
                begin: /_{2}(?!\s)/,
                end: /_{2}/
            },
            {
                begin: /\*{2}(?!\s)/,
                end: /\*{2}/
            }
        ]
    };
    const ITALIC = {
        className: 'emphasis',
        contains: [],
        variants: [
            {
                begin: /\*(?![*\s])/,
                end: /\*/
            },
            {
                begin: /_(?![_\s])/,
                end: /_/,
                relevance: 0
            }
        ]
    };
    // 3 level deep nesting is not allowed because it would create confusion
    // in cases like `***testing***` because where we don't know if the last
    // `***` is starting a new bold/italic or finishing the last one
    const BOLD_WITHOUT_ITALIC = hljs.inherit(BOLD, {
        contains: []
    });
    const ITALIC_WITHOUT_BOLD = hljs.inherit(ITALIC, {
        contains: []
    });
    BOLD.contains.push(ITALIC_WITHOUT_BOLD);
    ITALIC.contains.push(BOLD_WITHOUT_ITALIC);
    let CONTAINABLE = [
        INLINE_HTML,
        LINK
    ];
    [
        BOLD,
        ITALIC,
        BOLD_WITHOUT_ITALIC,
        ITALIC_WITHOUT_BOLD
    ].forEach((m)=>{
        m.contains = m.contains.concat(CONTAINABLE);
    });
    CONTAINABLE = CONTAINABLE.concat(BOLD, ITALIC);
    const HEADER = {
        className: 'section',
        variants: [
            {
                begin: '^#{1,6}',
                end: '$',
                contains: CONTAINABLE
            },
            {
                begin: '(?=^.+?\\n[=-]{2,}$)',
                contains: [
                    {
                        begin: '^[=-]*$'
                    },
                    {
                        begin: '^',
                        end: "\\n",
                        contains: CONTAINABLE
                    }
                ]
            }
        ]
    };
    const BLOCKQUOTE = {
        className: 'quote',
        begin: '^>\\s+',
        contains: CONTAINABLE,
        end: '$'
    };
    const ENTITY = {
        //https://spec.commonmark.org/0.31.2/#entity-references
        scope: 'literal',
        match: /&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/
    };
    return {
        name: 'Markdown',
        aliases: [
            'md',
            'mkdown',
            'mkd'
        ],
        contains: [
            HEADER,
            INLINE_HTML,
            LIST,
            BOLD,
            ITALIC,
            BLOCKQUOTE,
            CODE,
            HORIZONTAL_RULE,
            LINK,
            LINK_REFERENCE,
            ENTITY
        ]
    };
}
module.exports = $f051ead10c12cbc4$var$markdown;

});

parcelRegister("5pr0v", function(module, exports) {
/*
Language: Nginx config
Author: Peter Leonov <gojpeg@yandex.ru>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Category: config, web
Website: https://www.nginx.com
*/ /** @type LanguageFn */ function $3f043c9862f75125$var$nginx(hljs) {
    const regex = hljs.regex;
    const VAR = {
        className: 'variable',
        variants: [
            {
                begin: /\$\d+/
            },
            {
                begin: /\$\{\w+\}/
            },
            {
                begin: regex.concat(/[$@]/, hljs.UNDERSCORE_IDENT_RE)
            }
        ]
    };
    const LITERALS = [
        "on",
        "off",
        "yes",
        "no",
        "true",
        "false",
        "none",
        "blocked",
        "debug",
        "info",
        "notice",
        "warn",
        "error",
        "crit",
        "select",
        "break",
        "last",
        "permanent",
        "redirect",
        "kqueue",
        "rtsig",
        "epoll",
        "poll",
        "/dev/poll"
    ];
    const DEFAULT = {
        endsWithParent: true,
        keywords: {
            $pattern: /[a-z_]{2,}|\/dev\/poll/,
            literal: LITERALS
        },
        relevance: 0,
        illegal: '=>',
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                className: 'string',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VAR
                ],
                variants: [
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /'/,
                        end: /'/
                    }
                ]
            },
            // this swallows entire URLs to avoid detecting numbers within
            {
                begin: '([a-z]+):/',
                end: '\\s',
                endsWithParent: true,
                excludeEnd: true,
                contains: [
                    VAR
                ]
            },
            {
                className: 'regexp',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VAR
                ],
                variants: [
                    {
                        begin: "\\s\\^",
                        end: "\\s|\\{|;",
                        returnEnd: true
                    },
                    // regexp locations (~, ~*)
                    {
                        begin: "~\\*?\\s+",
                        end: "\\s|\\{|;",
                        returnEnd: true
                    },
                    // *.example.com
                    {
                        begin: "\\*(\\.[a-z\\-]+)+"
                    },
                    // sub.example.*
                    {
                        begin: "([a-z\\-]+\\.)+\\*"
                    }
                ]
            },
            // IP
            {
                className: 'number',
                begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
            },
            // units
            {
                className: 'number',
                begin: '\\b\\d+[kKmMgGdshdwy]?\\b',
                relevance: 0
            },
            VAR
        ]
    };
    return {
        name: 'Nginx config',
        aliases: [
            'nginxconf'
        ],
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                beginKeywords: "upstream location",
                end: /;|\{/,
                contains: DEFAULT.contains,
                keywords: {
                    section: "upstream location"
                }
            },
            {
                className: 'section',
                begin: regex.concat(hljs.UNDERSCORE_IDENT_RE + regex.lookahead(/\s+\{/)),
                relevance: 0
            },
            {
                begin: regex.lookahead(hljs.UNDERSCORE_IDENT_RE + '\\s'),
                end: ';|\\{',
                contains: [
                    {
                        className: 'attribute',
                        begin: hljs.UNDERSCORE_IDENT_RE,
                        starts: DEFAULT
                    }
                ],
                relevance: 0
            }
        ],
        illegal: '[^\\s\\}\\{]'
    };
}
module.exports = $3f043c9862f75125$var$nginx;

});

parcelRegister("2zmWr", function(module, exports) {
/*
Language: PHP
Author: Victor Karamzin <Victor.Karamzin@enterra-inc.com>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>, Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: https://www.php.net
Category: common
*/ /**
 * @param {HLJSApi} hljs
 * @returns {LanguageDetail}
 * */ function $1df0a55d41298ad2$var$php(hljs) {
    const regex = hljs.regex;
    // negative look-ahead tries to avoid matching patterns that are not
    // Perl at all like $ident$, @ident@, etc.
    const NOT_PERL_ETC = /(?![A-Za-z0-9])(?![$])/;
    const IDENT_RE = regex.concat(/[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/, NOT_PERL_ETC);
    // Will not detect camelCase classes
    const PASCAL_CASE_CLASS_NAME_RE = regex.concat(/(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/, NOT_PERL_ETC);
    const UPCASE_NAME_RE = regex.concat(/[A-Z]+/, NOT_PERL_ETC);
    const VARIABLE = {
        scope: 'variable',
        match: '\\$+' + IDENT_RE
    };
    const PREPROCESSOR = {
        scope: "meta",
        variants: [
            {
                begin: /<\?php/,
                relevance: 10
            },
            {
                begin: /<\?=/
            },
            // less relevant per PSR-1 which says not to use short-tags
            {
                begin: /<\?/,
                relevance: 0.1
            },
            {
                begin: /\?>/
            } // end php tag
        ]
    };
    const SUBST = {
        scope: 'subst',
        variants: [
            {
                begin: /\$\w+/
            },
            {
                begin: /\{\$/,
                end: /\}/
            }
        ]
    };
    const SINGLE_QUOTED = hljs.inherit(hljs.APOS_STRING_MODE, {
        illegal: null
    });
    const DOUBLE_QUOTED = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null,
        contains: hljs.QUOTE_STRING_MODE.contains.concat(SUBST)
    });
    const HEREDOC = {
        begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
        end: /[ \t]*(\w+)\b/,
        contains: hljs.QUOTE_STRING_MODE.contains.concat(SUBST),
        'on:begin': (m, resp)=>{
            resp.data._beginMatch = m[1] || m[2];
        },
        'on:end': (m, resp)=>{
            if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
    };
    const NOWDOC = hljs.END_SAME_AS_BEGIN({
        begin: /<<<[ \t]*'(\w+)'\n/,
        end: /[ \t]*(\w+)\b/
    });
    // list of valid whitespaces because non-breaking space might be part of a IDENT_RE
    const WHITESPACE = '[ \t\n]';
    const STRING = {
        scope: 'string',
        variants: [
            DOUBLE_QUOTED,
            SINGLE_QUOTED,
            HEREDOC,
            NOWDOC
        ]
    };
    const NUMBER = {
        scope: 'number',
        variants: [
            {
                begin: `\\b0[bB][01]+(?:_[01]+)*\\b`
            },
            {
                begin: `\\b0[oO][0-7]+(?:_[0-7]+)*\\b`
            },
            {
                begin: `\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b`
            },
            // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
            {
                begin: `(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?`
            }
        ],
        relevance: 0
    };
    const LITERALS = [
        "false",
        "null",
        "true"
    ];
    const KWS = [
        // Magic constants:
        // <https://www.php.net/manual/en/language.constants.predefined.php>
        "__CLASS__",
        "__DIR__",
        "__FILE__",
        "__FUNCTION__",
        "__COMPILER_HALT_OFFSET__",
        "__LINE__",
        "__METHOD__",
        "__NAMESPACE__",
        "__TRAIT__",
        // Function that look like language construct or language construct that look like function:
        // List of keywords that may not require parenthesis
        "die",
        "echo",
        "exit",
        "include",
        "include_once",
        "print",
        "require",
        "require_once",
        // These are not language construct (function) but operate on the currently-executing function and can access the current symbol table
        // 'compact extract func_get_arg func_get_args func_num_args get_called_class get_parent_class ' +
        // Other keywords:
        // <https://www.php.net/manual/en/reserved.php>
        // <https://www.php.net/manual/en/language.types.type-juggling.php>
        "array",
        "abstract",
        "and",
        "as",
        "binary",
        "bool",
        "boolean",
        "break",
        "callable",
        "case",
        "catch",
        "class",
        "clone",
        "const",
        "continue",
        "declare",
        "default",
        "do",
        "double",
        "else",
        "elseif",
        "empty",
        "enddeclare",
        "endfor",
        "endforeach",
        "endif",
        "endswitch",
        "endwhile",
        "enum",
        "eval",
        "extends",
        "final",
        "finally",
        "float",
        "for",
        "foreach",
        "from",
        "global",
        "goto",
        "if",
        "implements",
        "instanceof",
        "insteadof",
        "int",
        "integer",
        "interface",
        "isset",
        "iterable",
        "list",
        "match|0",
        "mixed",
        "new",
        "never",
        "object",
        "or",
        "private",
        "protected",
        "public",
        "readonly",
        "real",
        "return",
        "string",
        "switch",
        "throw",
        "trait",
        "try",
        "unset",
        "use",
        "var",
        "void",
        "while",
        "xor",
        "yield"
    ];
    const BUILT_INS = [
        // Standard PHP library:
        // <https://www.php.net/manual/en/book.spl.php>
        "Error|0",
        "AppendIterator",
        "ArgumentCountError",
        "ArithmeticError",
        "ArrayIterator",
        "ArrayObject",
        "AssertionError",
        "BadFunctionCallException",
        "BadMethodCallException",
        "CachingIterator",
        "CallbackFilterIterator",
        "CompileError",
        "Countable",
        "DirectoryIterator",
        "DivisionByZeroError",
        "DomainException",
        "EmptyIterator",
        "ErrorException",
        "Exception",
        "FilesystemIterator",
        "FilterIterator",
        "GlobIterator",
        "InfiniteIterator",
        "InvalidArgumentException",
        "IteratorIterator",
        "LengthException",
        "LimitIterator",
        "LogicException",
        "MultipleIterator",
        "NoRewindIterator",
        "OutOfBoundsException",
        "OutOfRangeException",
        "OuterIterator",
        "OverflowException",
        "ParentIterator",
        "ParseError",
        "RangeException",
        "RecursiveArrayIterator",
        "RecursiveCachingIterator",
        "RecursiveCallbackFilterIterator",
        "RecursiveDirectoryIterator",
        "RecursiveFilterIterator",
        "RecursiveIterator",
        "RecursiveIteratorIterator",
        "RecursiveRegexIterator",
        "RecursiveTreeIterator",
        "RegexIterator",
        "RuntimeException",
        "SeekableIterator",
        "SplDoublyLinkedList",
        "SplFileInfo",
        "SplFileObject",
        "SplFixedArray",
        "SplHeap",
        "SplMaxHeap",
        "SplMinHeap",
        "SplObjectStorage",
        "SplObserver",
        "SplPriorityQueue",
        "SplQueue",
        "SplStack",
        "SplSubject",
        "SplTempFileObject",
        "TypeError",
        "UnderflowException",
        "UnexpectedValueException",
        "UnhandledMatchError",
        // Reserved interfaces:
        // <https://www.php.net/manual/en/reserved.interfaces.php>
        "ArrayAccess",
        "BackedEnum",
        "Closure",
        "Fiber",
        "Generator",
        "Iterator",
        "IteratorAggregate",
        "Serializable",
        "Stringable",
        "Throwable",
        "Traversable",
        "UnitEnum",
        "WeakReference",
        "WeakMap",
        // Reserved classes:
        // <https://www.php.net/manual/en/reserved.classes.php>
        "Directory",
        "__PHP_Incomplete_Class",
        "parent",
        "php_user_filter",
        "self",
        "static",
        "stdClass"
    ];
    /** Dual-case keywords
   *
   * ["then","FILE"] =>
   *     ["then", "THEN", "FILE", "file"]
   *
   * @param {string[]} items */ const dualCase = (items)=>{
        /** @type string[] */ const result = [];
        items.forEach((item)=>{
            result.push(item);
            if (item.toLowerCase() === item) result.push(item.toUpperCase());
            else result.push(item.toLowerCase());
        });
        return result;
    };
    const KEYWORDS = {
        keyword: KWS,
        literal: dualCase(LITERALS),
        built_in: BUILT_INS
    };
    /**
   * @param {string[]} items */ const normalizeKeywords = (items)=>{
        return items.map((item)=>{
            return item.replace(/\|\d+$/, "");
        });
    };
    const CONSTRUCTOR_CALL = {
        variants: [
            {
                match: [
                    /new/,
                    regex.concat(WHITESPACE, "+"),
                    // to prevent built ins from being confused as the class constructor call
                    regex.concat("(?!", normalizeKeywords(BUILT_INS).join("\\b|"), "\\b)"),
                    PASCAL_CASE_CLASS_NAME_RE
                ],
                scope: {
                    1: "keyword",
                    4: "title.class"
                }
            }
        ]
    };
    const CONSTANT_REFERENCE = regex.concat(IDENT_RE, "\\b(?!\\()");
    const LEFT_AND_RIGHT_SIDE_OF_DOUBLE_COLON = {
        variants: [
            {
                match: [
                    regex.concat(/::/, regex.lookahead(/(?!class\b)/)),
                    CONSTANT_REFERENCE
                ],
                scope: {
                    2: "variable.constant"
                }
            },
            {
                match: [
                    /::/,
                    /class/
                ],
                scope: {
                    2: "variable.language"
                }
            },
            {
                match: [
                    PASCAL_CASE_CLASS_NAME_RE,
                    regex.concat(/::/, regex.lookahead(/(?!class\b)/)),
                    CONSTANT_REFERENCE
                ],
                scope: {
                    1: "title.class",
                    3: "variable.constant"
                }
            },
            {
                match: [
                    PASCAL_CASE_CLASS_NAME_RE,
                    regex.concat("::", regex.lookahead(/(?!class\b)/))
                ],
                scope: {
                    1: "title.class"
                }
            },
            {
                match: [
                    PASCAL_CASE_CLASS_NAME_RE,
                    /::/,
                    /class/
                ],
                scope: {
                    1: "title.class",
                    3: "variable.language"
                }
            }
        ]
    };
    const NAMED_ARGUMENT = {
        scope: 'attr',
        match: regex.concat(IDENT_RE, regex.lookahead(':'), regex.lookahead(/(?!::)/))
    };
    const PARAMS_MODE = {
        relevance: 0,
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        contains: [
            NAMED_ARGUMENT,
            VARIABLE,
            LEFT_AND_RIGHT_SIDE_OF_DOUBLE_COLON,
            hljs.C_BLOCK_COMMENT_MODE,
            STRING,
            NUMBER,
            CONSTRUCTOR_CALL
        ]
    };
    const FUNCTION_INVOKE = {
        relevance: 0,
        match: [
            /\b/,
            // to prevent keywords from being confused as the function title
            regex.concat("(?!fn\\b|function\\b|", normalizeKeywords(KWS).join("\\b|"), "|", normalizeKeywords(BUILT_INS).join("\\b|"), "\\b)"),
            IDENT_RE,
            regex.concat(WHITESPACE, "*"),
            regex.lookahead(/(?=\()/)
        ],
        scope: {
            3: "title.function.invoke"
        },
        contains: [
            PARAMS_MODE
        ]
    };
    PARAMS_MODE.contains.push(FUNCTION_INVOKE);
    const ATTRIBUTE_CONTAINS = [
        NAMED_ARGUMENT,
        LEFT_AND_RIGHT_SIDE_OF_DOUBLE_COLON,
        hljs.C_BLOCK_COMMENT_MODE,
        STRING,
        NUMBER,
        CONSTRUCTOR_CALL
    ];
    const ATTRIBUTES = {
        begin: regex.concat(/#\[\s*\\?/, regex.either(PASCAL_CASE_CLASS_NAME_RE, UPCASE_NAME_RE)),
        beginScope: "meta",
        end: /]/,
        endScope: "meta",
        keywords: {
            literal: LITERALS,
            keyword: [
                'new',
                'array'
            ]
        },
        contains: [
            {
                begin: /\[/,
                end: /]/,
                keywords: {
                    literal: LITERALS,
                    keyword: [
                        'new',
                        'array'
                    ]
                },
                contains: [
                    'self',
                    ...ATTRIBUTE_CONTAINS
                ]
            },
            ...ATTRIBUTE_CONTAINS,
            {
                scope: 'meta',
                variants: [
                    {
                        match: PASCAL_CASE_CLASS_NAME_RE
                    },
                    {
                        match: UPCASE_NAME_RE
                    }
                ]
            }
        ]
    };
    return {
        case_insensitive: false,
        keywords: KEYWORDS,
        contains: [
            ATTRIBUTES,
            hljs.HASH_COMMENT_MODE,
            hljs.COMMENT('//', '$'),
            hljs.COMMENT('/\\*', '\\*/', {
                contains: [
                    {
                        scope: 'doctag',
                        match: '@[A-Za-z]+'
                    }
                ]
            }),
            {
                match: /__halt_compiler\(\);/,
                keywords: '__halt_compiler',
                starts: {
                    scope: "comment",
                    end: hljs.MATCH_NOTHING_RE,
                    contains: [
                        {
                            match: /\?>/,
                            scope: "meta",
                            endsParent: true
                        }
                    ]
                }
            },
            PREPROCESSOR,
            {
                scope: 'variable.language',
                match: /\$this\b/
            },
            VARIABLE,
            FUNCTION_INVOKE,
            LEFT_AND_RIGHT_SIDE_OF_DOUBLE_COLON,
            {
                match: [
                    /const/,
                    /\s/,
                    IDENT_RE
                ],
                scope: {
                    1: "keyword",
                    3: "variable.constant"
                }
            },
            CONSTRUCTOR_CALL,
            {
                scope: 'function',
                relevance: 0,
                beginKeywords: 'fn function',
                end: /[;{]/,
                excludeEnd: true,
                illegal: '[$%\\[]',
                contains: [
                    {
                        beginKeywords: 'use'
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        begin: '=>',
                        endsParent: true
                    },
                    {
                        scope: 'params',
                        begin: '\\(',
                        end: '\\)',
                        excludeBegin: true,
                        excludeEnd: true,
                        keywords: KEYWORDS,
                        contains: [
                            'self',
                            ATTRIBUTES,
                            VARIABLE,
                            LEFT_AND_RIGHT_SIDE_OF_DOUBLE_COLON,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRING,
                            NUMBER
                        ]
                    }
                ]
            },
            {
                scope: 'class',
                variants: [
                    {
                        beginKeywords: "enum",
                        illegal: /[($"]/
                    },
                    {
                        beginKeywords: "class interface trait",
                        illegal: /[:($"]/
                    }
                ],
                relevance: 0,
                end: /\{/,
                excludeEnd: true,
                contains: [
                    {
                        beginKeywords: 'extends implements'
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            // both use and namespace still use "old style" rules (vs multi-match)
            // because the namespace name can include `\` and we still want each
            // element to be treated as its own *individual* title
            {
                beginKeywords: 'namespace',
                relevance: 0,
                end: ';',
                illegal: /[.']/,
                contains: [
                    hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
                        scope: "title.class"
                    })
                ]
            },
            {
                beginKeywords: 'use',
                relevance: 0,
                end: ';',
                contains: [
                    // TODO: title.function vs title.class
                    {
                        match: /\b(as|const|function)\b/,
                        scope: "keyword"
                    },
                    // TODO: could be title.class or title.function
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            STRING,
            NUMBER
        ]
    };
}
module.exports = $1df0a55d41298ad2$var$php;

});

parcelRegister("aMK1O", function(module, exports) {
/*
Language: Plain text
Author: Egor Rogov (e.rogov@postgrespro.ru)
Description: Plain text without any highlighting.
Category: common
*/ function $7da21750477e36ba$var$plaintext(hljs) {
    return {
        name: 'Plain text',
        aliases: [
            'text',
            'txt'
        ],
        disableAutodetect: true
    };
}
module.exports = $7da21750477e36ba$var$plaintext;

});

parcelRegister("bRjUs", function(module, exports) {
/*
Language: PowerShell
Description: PowerShell is a task-based command-line shell and scripting language built on .NET.
Author: David Mohundro <david@mohundro.com>
Contributors: Nicholas Blumhardt <nblumhardt@nblumhardt.com>, Victor Zhou <OiCMudkips@users.noreply.github.com>, Nicolas Le Gall <contact@nlegall.fr>
Website: https://docs.microsoft.com/en-us/powershell/
Category: scripting
*/ function $8a241696600d0882$var$powershell(hljs) {
    const TYPES = [
        "string",
        "char",
        "byte",
        "int",
        "long",
        "bool",
        "decimal",
        "single",
        "double",
        "DateTime",
        "xml",
        "array",
        "hashtable",
        "void"
    ];
    // https://docs.microsoft.com/en-us/powershell/scripting/developer/cmdlet/approved-verbs-for-windows-powershell-commands
    const VALID_VERBS = "Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where";
    const COMPARISON_OPERATORS = "-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor";
    const KEYWORDS = {
        $pattern: /-?[A-z\.\-]+\b/,
        keyword: "if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",
        // "echo" relevance has been set to 0 to avoid auto-detect conflicts with shell transcripts
        built_in: "ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"
    };
    const TITLE_NAME_RE = /\w[\w\d]*((-)[\w\d]+)*/;
    const BACKTICK_ESCAPE = {
        begin: '`[\\s\\S]',
        relevance: 0
    };
    const VAR = {
        className: 'variable',
        variants: [
            {
                begin: /\$\B/
            },
            {
                className: 'keyword',
                begin: /\$this/
            },
            {
                begin: /\$[\w\d][\w\d_:]*/
            }
        ]
    };
    const LITERAL = {
        className: 'literal',
        begin: /\$(null|true|false)\b/
    };
    const QUOTE_STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /@"/,
                end: /^"@/
            }
        ],
        contains: [
            BACKTICK_ESCAPE,
            VAR,
            {
                className: 'variable',
                begin: /\$[A-z]/,
                end: /[^A-z]/
            }
        ]
    };
    const APOS_STRING = {
        className: 'string',
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /@'/,
                end: /^'@/
            }
        ]
    };
    const PS_HELPTAGS = {
        className: "doctag",
        variants: [
            /* no paramater help tags */ {
                begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/
            },
            /* one parameter help tags */ {
                begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/
            }
        ]
    };
    const PS_COMMENT = hljs.inherit(hljs.COMMENT(null, null), {
        variants: [
            /* single-line comment */ {
                begin: /#/,
                end: /$/
            },
            /* multi-line comment */ {
                begin: /<#/,
                end: /#>/
            }
        ],
        contains: [
            PS_HELPTAGS
        ]
    });
    const CMDLETS = {
        className: 'built_in',
        variants: [
            {
                begin: '('.concat(VALID_VERBS, ')+(-)[\\w\\d]+')
            }
        ]
    };
    const PS_CLASS = {
        className: 'class',
        beginKeywords: 'class enum',
        end: /\s*[{]/,
        excludeEnd: true,
        relevance: 0,
        contains: [
            hljs.TITLE_MODE
        ]
    };
    const PS_FUNCTION = {
        className: 'function',
        begin: /function\s+/,
        end: /\s*\{|$/,
        excludeEnd: true,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                begin: "function",
                relevance: 0,
                className: "keyword"
            },
            {
                className: "title",
                begin: TITLE_NAME_RE,
                relevance: 0
            },
            {
                begin: /\(/,
                end: /\)/,
                className: "params",
                relevance: 0,
                contains: [
                    VAR
                ]
            }
        ]
    };
    // Using statment, plus type, plus assembly name.
    const PS_USING = {
        begin: /using\s/,
        end: /$/,
        returnBegin: true,
        contains: [
            QUOTE_STRING,
            APOS_STRING,
            {
                className: 'keyword',
                begin: /(using|assembly|command|module|namespace|type)/
            }
        ]
    };
    // Comperison operators & function named parameters.
    const PS_ARGUMENTS = {
        variants: [
            // PS literals are pretty verbose so it's a good idea to accent them a bit.
            {
                className: 'operator',
                begin: '('.concat(COMPARISON_OPERATORS, ')\\b')
            },
            {
                className: 'literal',
                begin: /(-){1,2}[\w\d-]+/,
                relevance: 0
            }
        ]
    };
    const HASH_SIGNS = {
        className: 'selector-tag',
        begin: /@\B/,
        relevance: 0
    };
    // It's a very general rule so I'll narrow it a bit with some strict boundaries
    // to avoid any possible false-positive collisions!
    const PS_METHODS = {
        className: 'function',
        begin: /\[.*\]\s*[\w]+[ ]??\(/,
        end: /$/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: 'keyword',
                begin: '('.concat(KEYWORDS.keyword.toString().replace(/\s/g, '|'), ')\\b'),
                endsParent: true,
                relevance: 0
            },
            hljs.inherit(hljs.TITLE_MODE, {
                endsParent: true
            })
        ]
    };
    const GENTLEMANS_SET = [
        // STATIC_MEMBER,
        PS_METHODS,
        PS_COMMENT,
        BACKTICK_ESCAPE,
        hljs.NUMBER_MODE,
        QUOTE_STRING,
        APOS_STRING,
        // PS_NEW_OBJECT_TYPE,
        CMDLETS,
        VAR,
        LITERAL,
        HASH_SIGNS
    ];
    const PS_TYPE = {
        begin: /\[/,
        end: /\]/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [].concat('self', GENTLEMANS_SET, {
            begin: "(" + TYPES.join("|") + ")",
            className: "built_in",
            relevance: 0
        }, {
            className: 'type',
            begin: /[\.\w\d]+/,
            relevance: 0
        })
    };
    PS_METHODS.contains.unshift(PS_TYPE);
    return {
        name: 'PowerShell',
        aliases: [
            "pwsh",
            "ps",
            "ps1"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: GENTLEMANS_SET.concat(PS_CLASS, PS_FUNCTION, PS_USING, PS_ARGUMENTS, PS_TYPE)
    };
}
module.exports = $8a241696600d0882$var$powershell;

});

parcelRegister("daysG", function(module, exports) {
/*
Language: .properties
Contributors: Valentin Aitken <valentin@nalisbg.com>, Egor Rogov <e.rogov@postgrespro.ru>
Website: https://en.wikipedia.org/wiki/.properties
Category: config
*/ /** @type LanguageFn */ function $9966f0e303b2807c$var$properties(hljs) {
    // whitespaces: space, tab, formfeed
    const WS0 = '[ \\t\\f]*';
    const WS1 = '[ \\t\\f]+';
    // delimiter
    const EQUAL_DELIM = WS0 + '[:=]' + WS0;
    const WS_DELIM = WS1;
    const DELIM = '(' + EQUAL_DELIM + '|' + WS_DELIM + ')';
    const KEY = '([^\\\\:= \\t\\f\\n]|\\\\.)+';
    const DELIM_AND_VALUE = {
        // skip DELIM
        end: DELIM,
        relevance: 0,
        starts: {
            // value: everything until end of line (again, taking into account backslashes)
            className: 'string',
            end: /$/,
            relevance: 0,
            contains: [
                {
                    begin: '\\\\\\\\'
                },
                {
                    begin: '\\\\\\n'
                }
            ]
        }
    };
    return {
        name: '.properties',
        disableAutodetect: true,
        case_insensitive: true,
        illegal: /\S/,
        contains: [
            hljs.COMMENT('^\\s*[!#]', '$'),
            // key: everything until whitespace or = or : (taking into account backslashes)
            // case of a key-value pair
            {
                returnBegin: true,
                variants: [
                    {
                        begin: KEY + EQUAL_DELIM
                    },
                    {
                        begin: KEY + WS_DELIM
                    }
                ],
                contains: [
                    {
                        className: 'attr',
                        begin: KEY,
                        endsParent: true
                    }
                ],
                starts: DELIM_AND_VALUE
            },
            // case of an empty key
            {
                className: 'attr',
                begin: KEY + WS0 + '$'
            }
        ]
    };
}
module.exports = $9966f0e303b2807c$var$properties;

});

parcelRegister("gAShk", function(module, exports) {
/*
Language: Python
Description: Python is an interpreted, object-oriented, high-level programming language with dynamic semantics.
Website: https://www.python.org
Category: common
*/ function $c14a1cb25fa87161$var$python(hljs) {
    const regex = hljs.regex;
    const IDENT_RE = /[\p{XID_Start}_]\p{XID_Continue}*/u;
    const RESERVED_WORDS = [
        'and',
        'as',
        'assert',
        'async',
        'await',
        'break',
        'case',
        'class',
        'continue',
        'def',
        'del',
        'elif',
        'else',
        'except',
        'finally',
        'for',
        'from',
        'global',
        'if',
        'import',
        'in',
        'is',
        'lambda',
        'match',
        'nonlocal|10',
        'not',
        'or',
        'pass',
        'raise',
        'return',
        'try',
        'while',
        'with',
        'yield'
    ];
    const BUILT_INS = [
        '__import__',
        'abs',
        'all',
        'any',
        'ascii',
        'bin',
        'bool',
        'breakpoint',
        'bytearray',
        'bytes',
        'callable',
        'chr',
        'classmethod',
        'compile',
        'complex',
        'delattr',
        'dict',
        'dir',
        'divmod',
        'enumerate',
        'eval',
        'exec',
        'filter',
        'float',
        'format',
        'frozenset',
        'getattr',
        'globals',
        'hasattr',
        'hash',
        'help',
        'hex',
        'id',
        'input',
        'int',
        'isinstance',
        'issubclass',
        'iter',
        'len',
        'list',
        'locals',
        'map',
        'max',
        'memoryview',
        'min',
        'next',
        'object',
        'oct',
        'open',
        'ord',
        'pow',
        'print',
        'property',
        'range',
        'repr',
        'reversed',
        'round',
        'set',
        'setattr',
        'slice',
        'sorted',
        'staticmethod',
        'str',
        'sum',
        'super',
        'tuple',
        'type',
        'vars',
        'zip'
    ];
    const LITERALS = [
        '__debug__',
        'Ellipsis',
        'False',
        'None',
        'NotImplemented',
        'True'
    ];
    // https://docs.python.org/3/library/typing.html
    // TODO: Could these be supplemented by a CamelCase matcher in certain
    // contexts, leaving these remaining only for relevance hinting?
    const TYPES = [
        "Any",
        "Callable",
        "Coroutine",
        "Dict",
        "List",
        "Literal",
        "Generic",
        "Optional",
        "Sequence",
        "Set",
        "Tuple",
        "Type",
        "Union"
    ];
    const KEYWORDS = {
        $pattern: /[A-Za-z]\w+|__\w+__/,
        keyword: RESERVED_WORDS,
        built_in: BUILT_INS,
        literal: LITERALS,
        type: TYPES
    };
    const PROMPT = {
        className: 'meta',
        begin: /^(>>>|\.\.\.) /
    };
    const SUBST = {
        className: 'subst',
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS,
        illegal: /#/
    };
    const LITERAL_BRACKET = {
        begin: /\{\{/,
        relevance: 0
    };
    const STRING = {
        className: 'string',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([uU]|[rR])'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /([uU]|[rR])"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])'/,
                end: /'/
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])"/,
                end: /"/
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'/,
                end: /'/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    // https://docs.python.org/3.9/reference/lexical_analysis.html#numeric-literals
    const digitpart = '[0-9](_?[0-9])*';
    const pointfloat = `(\\b(${digitpart}))?\\.(${digitpart})|\\b(${digitpart})\\.`;
    // Whitespace after a number (or any lexical token) is needed only if its absence
    // would change the tokenization
    // https://docs.python.org/3.9/reference/lexical_analysis.html#whitespace-between-tokens
    // We deviate slightly, requiring a word boundary or a keyword
    // to avoid accidentally recognizing *prefixes* (e.g., `0` in `0x41` or `08` or `0__1`)
    const lookahead = `\\b|${RESERVED_WORDS.join('|')}`;
    const NUMBER = {
        className: 'number',
        relevance: 0,
        variants: [
            // exponentfloat, pointfloat
            // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
            // optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            // Note: no leading \b because floats can start with a decimal point
            // and we don't want to mishandle e.g. `fn(.5)`,
            // no trailing \b for pointfloat because it can end with a decimal point
            // and we don't want to mishandle e.g. `0..hex()`; this should be safe
            // because both MUST contain a decimal point and so cannot be confused with
            // the interior part of an identifier
            {
                begin: `(\\b(${digitpart})|(${pointfloat}))[eE][+-]?(${digitpart})[jJ]?(?=${lookahead})`
            },
            {
                begin: `(${pointfloat})[jJ]?`
            },
            // decinteger, bininteger, octinteger, hexinteger
            // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
            // optionally "long" in Python 2
            // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
            // decinteger is optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${lookahead})`
            },
            {
                begin: `\\b0[bB](_?[01])+[lL]?(?=${lookahead})`
            },
            {
                begin: `\\b0[oO](_?[0-7])+[lL]?(?=${lookahead})`
            },
            {
                begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${lookahead})`
            },
            // imagnumber (digitpart-based)
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b(${digitpart})[jJ](?=${lookahead})`
            }
        ]
    };
    const COMMENT_TYPE = {
        className: "comment",
        begin: regex.lookahead(/# type:/),
        end: /$/,
        keywords: KEYWORDS,
        contains: [
            {
                begin: /# type:/
            },
            // comment within a datatype comment includes no keywords
            {
                begin: /#/,
                end: /\b\B/,
                endsWithParent: true
            }
        ]
    };
    const PARAMS = {
        className: 'params',
        variants: [
            // Exclude params in functions without params
            {
                className: "",
                begin: /\(\s*\)/,
                skip: true
            },
            {
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    'self',
                    PROMPT,
                    NUMBER,
                    STRING,
                    hljs.HASH_COMMENT_MODE
                ]
            }
        ]
    };
    SUBST.contains = [
        STRING,
        NUMBER,
        PROMPT
    ];
    return {
        name: 'Python',
        aliases: [
            'py',
            'gyp',
            'ipython'
        ],
        unicodeRegex: true,
        keywords: KEYWORDS,
        illegal: /(<\/|\?)|=>/,
        contains: [
            PROMPT,
            NUMBER,
            {
                // very common convention
                scope: 'variable.language',
                match: /\bself\b/
            },
            {
                // eat "if" prior to string so that it won't accidentally be
                // labeled as an f-string
                beginKeywords: "if",
                relevance: 0
            },
            {
                match: /\bor\b/,
                scope: "keyword"
            },
            STRING,
            COMMENT_TYPE,
            hljs.HASH_COMMENT_MODE,
            {
                match: [
                    /\bdef/,
                    /\s+/,
                    IDENT_RE
                ],
                scope: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            {
                variants: [
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            IDENT_RE,
                            /\s*/,
                            /\(\s*/,
                            IDENT_RE,
                            /\s*\)/
                        ]
                    },
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            IDENT_RE
                        ]
                    }
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    6: "title.class.inherited"
                }
            },
            {
                className: 'meta',
                begin: /^[\t ]*@/,
                end: /(?=#)|$/,
                contains: [
                    NUMBER,
                    PARAMS,
                    STRING
                ]
            }
        ]
    };
}
module.exports = $c14a1cb25fa87161$var$python;

});

parcelRegister("3dIMU", function(module, exports) {
/*
Language: Ruby
Description: Ruby is a dynamic, open source programming language with a focus on simplicity and productivity.
Website: https://www.ruby-lang.org/
Author: Anton Kovalyov <anton@kovalyov.net>
Contributors: Peter Leonov <gojpeg@yandex.ru>, Vasily Polovnyov <vast@whiteants.net>, Loren Segal <lsegal@soen.ca>, Pascal Hurni <phi@ruby-reactive.org>, Cedric Sohrauer <sohrauer@googlemail.com>
Category: common, scripting
*/ function $258553f49b3bddd5$var$ruby(hljs) {
    const regex = hljs.regex;
    const RUBY_METHOD_RE = '([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)';
    // TODO: move concepts like CAMEL_CASE into `modes.js`
    const CLASS_NAME_RE = regex.either(/\b([A-Z]+[a-z0-9]+)+/, // ends in caps
    /\b([A-Z]+[a-z0-9]+)+[A-Z]+/);
    const CLASS_NAME_WITH_NAMESPACE_RE = regex.concat(CLASS_NAME_RE, /(::\w+)*/);
    // very popular ruby built-ins that one might even assume
    // are actual keywords (despite that not being the case)
    const PSEUDO_KWS = [
        "include",
        "extend",
        "prepend",
        "public",
        "private",
        "protected",
        "raise",
        "throw"
    ];
    const RUBY_KEYWORDS = {
        "variable.constant": [
            "__FILE__",
            "__LINE__",
            "__ENCODING__"
        ],
        "variable.language": [
            "self",
            "super"
        ],
        keyword: [
            "alias",
            "and",
            "begin",
            "BEGIN",
            "break",
            "case",
            "class",
            "defined",
            "do",
            "else",
            "elsif",
            "end",
            "END",
            "ensure",
            "for",
            "if",
            "in",
            "module",
            "next",
            "not",
            "or",
            "redo",
            "require",
            "rescue",
            "retry",
            "return",
            "then",
            "undef",
            "unless",
            "until",
            "when",
            "while",
            "yield",
            ...PSEUDO_KWS
        ],
        built_in: [
            "proc",
            "lambda",
            "attr_accessor",
            "attr_reader",
            "attr_writer",
            "define_method",
            "private_constant",
            "module_function"
        ],
        literal: [
            "true",
            "false",
            "nil"
        ]
    };
    const YARDOCTAG = {
        className: 'doctag',
        begin: '@[A-Za-z]+'
    };
    const IRB_OBJECT = {
        begin: '#<',
        end: '>'
    };
    const COMMENT_MODES = [
        hljs.COMMENT('#', '$', {
            contains: [
                YARDOCTAG
            ]
        }),
        hljs.COMMENT('^=begin', '^=end', {
            contains: [
                YARDOCTAG
            ],
            relevance: 10
        }),
        hljs.COMMENT('^__END__', hljs.MATCH_NOTHING_RE)
    ];
    const SUBST = {
        className: 'subst',
        begin: /#\{/,
        end: /\}/,
        keywords: RUBY_KEYWORDS
    };
    const STRING = {
        className: 'string',
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /`/,
                end: /`/
            },
            {
                begin: /%[qQwWx]?\(/,
                end: /\)/
            },
            {
                begin: /%[qQwWx]?\[/,
                end: /\]/
            },
            {
                begin: /%[qQwWx]?\{/,
                end: /\}/
            },
            {
                begin: /%[qQwWx]?</,
                end: />/
            },
            {
                begin: /%[qQwWx]?\//,
                end: /\//
            },
            {
                begin: /%[qQwWx]?%/,
                end: /%/
            },
            {
                begin: /%[qQwWx]?-/,
                end: /-/
            },
            {
                begin: /%[qQwWx]?\|/,
                end: /\|/
            },
            // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
            // where ? is the last character of a preceding identifier, as in: `func?4`
            {
                begin: /\B\?(\\\d{1,3})/
            },
            {
                begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/
            },
            {
                begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/
            },
            {
                begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/
            },
            {
                begin: /\B\?\\(c|C-)[\x20-\x7e]/
            },
            {
                begin: /\B\?\\?\S/
            },
            // heredocs
            {
                // this guard makes sure that we have an entire heredoc and not a false
                // positive (auto-detect, etc.)
                begin: regex.concat(/<<[-~]?'?/, regex.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)),
                contains: [
                    hljs.END_SAME_AS_BEGIN({
                        begin: /(\w+)/,
                        end: /(\w+)/,
                        contains: [
                            hljs.BACKSLASH_ESCAPE,
                            SUBST
                        ]
                    })
                ]
            }
        ]
    };
    // Ruby syntax is underdocumented, but this grammar seems to be accurate
    // as of version 2.7.2 (confirmed with (irb and `Ripper.sexp(...)`)
    // https://docs.ruby-lang.org/en/2.7.0/doc/syntax/literals_rdoc.html#label-Numbers
    const decimal = '[1-9](_?[0-9])*|0';
    const digits = '[0-9](_?[0-9])*';
    const NUMBER = {
        className: 'number',
        relevance: 0,
        variants: [
            // decimal integer/float, optionally exponential or rational, optionally imaginary
            {
                begin: `\\b(${decimal})(\\.(${digits}))?([eE][+-]?(${digits})|r)?i?\\b`
            },
            // explicit decimal/binary/octal/hexadecimal integer,
            // optionally rational and/or imaginary
            {
                begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b"
            },
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b"
            },
            // 0-prefixed implicit octal integer, optionally rational and/or imaginary
            {
                begin: "\\b0(_?[0-7])+r?i?\\b"
            }
        ]
    };
    const PARAMS = {
        variants: [
            {
                match: /\(\)/
            },
            {
                className: 'params',
                begin: /\(/,
                end: /(?=\))/,
                excludeBegin: true,
                endsParent: true,
                keywords: RUBY_KEYWORDS
            }
        ]
    };
    const INCLUDE_EXTEND = {
        match: [
            /(include|extend)\s+/,
            CLASS_NAME_WITH_NAMESPACE_RE
        ],
        scope: {
            2: "title.class"
        },
        keywords: RUBY_KEYWORDS
    };
    const CLASS_DEFINITION = {
        variants: [
            {
                match: [
                    /class\s+/,
                    CLASS_NAME_WITH_NAMESPACE_RE,
                    /\s+<\s+/,
                    CLASS_NAME_WITH_NAMESPACE_RE
                ]
            },
            {
                match: [
                    /\b(class|module)\s+/,
                    CLASS_NAME_WITH_NAMESPACE_RE
                ]
            }
        ],
        scope: {
            2: "title.class",
            4: "title.class.inherited"
        },
        keywords: RUBY_KEYWORDS
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    const METHOD_DEFINITION = {
        match: [
            /def/,
            /\s+/,
            RUBY_METHOD_RE
        ],
        scope: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    const OBJECT_CREATION = {
        relevance: 0,
        match: [
            CLASS_NAME_WITH_NAMESPACE_RE,
            /\.new[. (]/
        ],
        scope: {
            1: "title.class"
        }
    };
    // CamelCase
    const CLASS_REFERENCE = {
        relevance: 0,
        match: CLASS_NAME_RE,
        scope: "title.class"
    };
    const RUBY_DEFAULT_CONTAINS = [
        STRING,
        CLASS_DEFINITION,
        INCLUDE_EXTEND,
        OBJECT_CREATION,
        UPPER_CASE_CONSTANT,
        CLASS_REFERENCE,
        METHOD_DEFINITION,
        {
            // swallow namespace qualifiers before symbols
            begin: hljs.IDENT_RE + '::'
        },
        {
            className: 'symbol',
            begin: hljs.UNDERSCORE_IDENT_RE + '(!|\\?)?:',
            relevance: 0
        },
        {
            className: 'symbol',
            begin: ':(?!\\s)',
            contains: [
                STRING,
                {
                    begin: RUBY_METHOD_RE
                }
            ],
            relevance: 0
        },
        NUMBER,
        {
            // negative-look forward attempts to prevent false matches like:
            // @ident@ or $ident$ that might indicate this is not ruby at all
            className: "variable",
            begin: '(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])' + `(?![A-Za-z])(?![@$?'])`
        },
        {
            className: 'params',
            begin: /\|(?!=)/,
            end: /\|/,
            excludeBegin: true,
            excludeEnd: true,
            relevance: 0,
            keywords: RUBY_KEYWORDS
        },
        {
            begin: '(' + hljs.RE_STARTERS_RE + '|unless)\\s*',
            keywords: 'unless',
            contains: [
                {
                    className: 'regexp',
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ],
                    illegal: /\n/,
                    variants: [
                        {
                            begin: '/',
                            end: '/[a-z]*'
                        },
                        {
                            begin: /%r\{/,
                            end: /\}[a-z]*/
                        },
                        {
                            begin: '%r\\(',
                            end: '\\)[a-z]*'
                        },
                        {
                            begin: '%r!',
                            end: '![a-z]*'
                        },
                        {
                            begin: '%r\\[',
                            end: '\\][a-z]*'
                        }
                    ]
                }
            ].concat(IRB_OBJECT, COMMENT_MODES),
            relevance: 0
        }
    ].concat(IRB_OBJECT, COMMENT_MODES);
    SUBST.contains = RUBY_DEFAULT_CONTAINS;
    PARAMS.contains = RUBY_DEFAULT_CONTAINS;
    // >>
    // ?>
    const SIMPLE_PROMPT = "[>?]>";
    // irb(main):001:0>
    const DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]";
    const RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>";
    const IRB_DEFAULT = [
        {
            begin: /^\s*=>/,
            starts: {
                end: '$',
                contains: RUBY_DEFAULT_CONTAINS
            }
        },
        {
            className: 'meta.prompt',
            begin: '^(' + SIMPLE_PROMPT + "|" + DEFAULT_PROMPT + '|' + RVM_PROMPT + ')(?=[ ])',
            starts: {
                end: '$',
                keywords: RUBY_KEYWORDS,
                contains: RUBY_DEFAULT_CONTAINS
            }
        }
    ];
    COMMENT_MODES.unshift(IRB_OBJECT);
    return {
        name: 'Ruby',
        aliases: [
            'rb',
            'gemspec',
            'podspec',
            'thor',
            'irb'
        ],
        keywords: RUBY_KEYWORDS,
        illegal: /\/\*/,
        contains: [
            hljs.SHEBANG({
                binary: "ruby"
            })
        ].concat(IRB_DEFAULT).concat(COMMENT_MODES).concat(RUBY_DEFAULT_CONTAINS)
    };
}
module.exports = $258553f49b3bddd5$var$ruby;

});

parcelRegister("gbBld", function(module, exports) {
/*
Language: Rust
Author: Andrey Vlasovskikh <andrey.vlasovskikh@gmail.com>
Contributors: Roman Shmatov <romanshmatov@gmail.com>, Kasper Andersen <kma_untrusted@protonmail.com>
Website: https://www.rust-lang.org
Category: common, system
*/ /** @type LanguageFn */ function $bc8aa39bb191ace1$var$rust(hljs) {
    const regex = hljs.regex;
    // ============================================
    // Added to support the r# keyword, which is a raw identifier in Rust.
    const RAW_IDENTIFIER = /(r#)?/;
    const UNDERSCORE_IDENT_RE = regex.concat(RAW_IDENTIFIER, hljs.UNDERSCORE_IDENT_RE);
    const IDENT_RE = regex.concat(RAW_IDENTIFIER, hljs.IDENT_RE);
    // ============================================
    const FUNCTION_INVOKE = {
        className: "title.function.invoke",
        relevance: 0,
        begin: regex.concat(/\b/, /(?!let|for|while|if|else|match\b)/, IDENT_RE, regex.lookahead(/\s*\(/))
    };
    const NUMBER_SUFFIX = '([ui](8|16|32|64|128|size)|f(32|64))\?';
    const KEYWORDS = [
        "abstract",
        "as",
        "async",
        "await",
        "become",
        "box",
        "break",
        "const",
        "continue",
        "crate",
        "do",
        "dyn",
        "else",
        "enum",
        "extern",
        "false",
        "final",
        "fn",
        "for",
        "if",
        "impl",
        "in",
        "let",
        "loop",
        "macro",
        "match",
        "mod",
        "move",
        "mut",
        "override",
        "priv",
        "pub",
        "ref",
        "return",
        "self",
        "Self",
        "static",
        "struct",
        "super",
        "trait",
        "true",
        "try",
        "type",
        "typeof",
        "union",
        "unsafe",
        "unsized",
        "use",
        "virtual",
        "where",
        "while",
        "yield"
    ];
    const LITERALS = [
        "true",
        "false",
        "Some",
        "None",
        "Ok",
        "Err"
    ];
    const BUILTINS = [
        // functions
        'drop ',
        // traits
        "Copy",
        "Send",
        "Sized",
        "Sync",
        "Drop",
        "Fn",
        "FnMut",
        "FnOnce",
        "ToOwned",
        "Clone",
        "Debug",
        "PartialEq",
        "PartialOrd",
        "Eq",
        "Ord",
        "AsRef",
        "AsMut",
        "Into",
        "From",
        "Default",
        "Iterator",
        "Extend",
        "IntoIterator",
        "DoubleEndedIterator",
        "ExactSizeIterator",
        "SliceConcatExt",
        "ToString",
        // macros
        "assert!",
        "assert_eq!",
        "bitflags!",
        "bytes!",
        "cfg!",
        "col!",
        "concat!",
        "concat_idents!",
        "debug_assert!",
        "debug_assert_eq!",
        "env!",
        "eprintln!",
        "panic!",
        "file!",
        "format!",
        "format_args!",
        "include_bytes!",
        "include_str!",
        "line!",
        "local_data_key!",
        "module_path!",
        "option_env!",
        "print!",
        "println!",
        "select!",
        "stringify!",
        "try!",
        "unimplemented!",
        "unreachable!",
        "vec!",
        "write!",
        "writeln!",
        "macro_rules!",
        "assert_ne!",
        "debug_assert_ne!"
    ];
    const TYPES = [
        "i8",
        "i16",
        "i32",
        "i64",
        "i128",
        "isize",
        "u8",
        "u16",
        "u32",
        "u64",
        "u128",
        "usize",
        "f32",
        "f64",
        "str",
        "char",
        "bool",
        "Box",
        "Option",
        "Result",
        "String",
        "Vec"
    ];
    return {
        name: 'Rust',
        aliases: [
            'rs'
        ],
        keywords: {
            $pattern: hljs.IDENT_RE + '!?',
            type: TYPES,
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: BUILTINS
        },
        illegal: '</',
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT('/\\*', '\\*/', {
                contains: [
                    'self'
                ]
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                begin: /b?"/,
                illegal: null
            }),
            {
                className: 'symbol',
                // negative lookahead to avoid matching `'`
                begin: /'[a-zA-Z_][a-zA-Z0-9_]*(?!')/
            },
            {
                scope: 'string',
                variants: [
                    {
                        begin: /b?r(#*)"(.|\n)*?"\1(?!#)/
                    },
                    {
                        begin: /b?'/,
                        end: /'/,
                        contains: [
                            {
                                scope: "char.escape",
                                match: /\\('|\w|x\w{2}|u\w{4}|U\w{8})/
                            }
                        ]
                    }
                ]
            },
            {
                className: 'number',
                variants: [
                    {
                        begin: '\\b0b([01_]+)' + NUMBER_SUFFIX
                    },
                    {
                        begin: '\\b0o([0-7_]+)' + NUMBER_SUFFIX
                    },
                    {
                        begin: '\\b0x([A-Fa-f0-9_]+)' + NUMBER_SUFFIX
                    },
                    {
                        begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' + NUMBER_SUFFIX
                    }
                ],
                relevance: 0
            },
            {
                begin: [
                    /fn/,
                    /\s+/,
                    UNDERSCORE_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.function"
                }
            },
            {
                className: 'meta',
                begin: '#!?\\[',
                end: '\\]',
                contains: [
                    {
                        className: 'string',
                        begin: /"/,
                        end: /"/,
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ]
                    }
                ]
            },
            {
                begin: [
                    /let/,
                    /\s+/,
                    /(?:mut\s+)?/,
                    UNDERSCORE_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "keyword",
                    4: "variable"
                }
            },
            // must come before impl/for rule later
            {
                begin: [
                    /for/,
                    /\s+/,
                    UNDERSCORE_IDENT_RE,
                    /\s+/,
                    /in/
                ],
                className: {
                    1: "keyword",
                    3: "variable",
                    5: "keyword"
                }
            },
            {
                begin: [
                    /type/,
                    /\s+/,
                    UNDERSCORE_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.class"
                }
            },
            {
                begin: [
                    /(?:trait|enum|struct|union|impl|for)/,
                    /\s+/,
                    UNDERSCORE_IDENT_RE
                ],
                className: {
                    1: "keyword",
                    3: "title.class"
                }
            },
            {
                begin: hljs.IDENT_RE + '::',
                keywords: {
                    keyword: "Self",
                    built_in: BUILTINS,
                    type: TYPES
                }
            },
            {
                className: "punctuation",
                begin: '->'
            },
            FUNCTION_INVOKE
        ]
    };
}
module.exports = $bc8aa39bb191ace1$var$rust;

});

parcelRegister("P9VeK", function(module, exports) {
/*
Language: Scala
Category: functional
Author: Jan Berkel <jan.berkel@gmail.com>
Contributors: Erik Osheim <d_m@plastic-idolatry.com>
Website: https://www.scala-lang.org
*/ function $099c75df5d97a1c3$var$scala(hljs) {
    const regex = hljs.regex;
    const ANNOTATION = {
        className: 'meta',
        begin: '@[A-Za-z]+'
    };
    // used in strings for escaping/interpolation/substitution
    const SUBST = {
        className: 'subst',
        variants: [
            {
                begin: '\\$[A-Za-z0-9_]+'
            },
            {
                begin: /\$\{/,
                end: /\}/
            }
        ]
    };
    const STRING = {
        className: 'string',
        variants: [
            {
                begin: '"""',
                end: '"""'
            },
            {
                begin: '"',
                end: '"',
                illegal: '\\n',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '[a-z]+"',
                end: '"',
                illegal: '\\n',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST
                ]
            },
            {
                className: 'string',
                begin: '[a-z]+"""',
                end: '"""',
                contains: [
                    SUBST
                ],
                relevance: 10
            }
        ]
    };
    const TYPE = {
        className: 'type',
        begin: '\\b[A-Z][A-Za-z0-9_]*',
        relevance: 0
    };
    const NAME = {
        className: 'title',
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
        relevance: 0
    };
    const CLASS = {
        className: 'class',
        beginKeywords: 'class object trait type',
        end: /[:={\[\n;]/,
        excludeEnd: true,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                beginKeywords: 'extends with',
                relevance: 10
            },
            {
                begin: /\[/,
                end: /\]/,
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0,
                contains: [
                    TYPE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                className: 'params',
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0,
                contains: [
                    TYPE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            NAME
        ]
    };
    const METHOD = {
        className: 'function',
        beginKeywords: 'def',
        end: regex.lookahead(/[:={\[(\n;]/),
        contains: [
            NAME
        ]
    };
    const EXTENSION = {
        begin: [
            /^\s*/,
            'extension',
            /\s+(?=[[(])/
        ],
        beginScope: {
            2: "keyword"
        }
    };
    const END = {
        begin: [
            /^\s*/,
            /end/,
            /\s+/,
            /(extension\b)?/
        ],
        beginScope: {
            2: "keyword",
            4: "keyword"
        }
    };
    // TODO: use negative look-behind in future
    //       /(?<!\.)\binline(?=\s)/
    const INLINE_MODES = [
        {
            match: /\.inline\b/
        },
        {
            begin: /\binline(?=\s)/,
            keywords: 'inline'
        }
    ];
    const USING_PARAM_CLAUSE = {
        begin: [
            /\(\s*/,
            /using/,
            /\s+(?!\))/
        ],
        beginScope: {
            2: "keyword"
        }
    };
    // glob all non-whitespace characters as a "string"
    // sourced from https://github.com/scala/docs.scala-lang/pull/2845
    const DIRECTIVE_VALUE = {
        className: 'string',
        begin: /\S+/
    };
    // directives
    // sourced from https://github.com/scala/docs.scala-lang/pull/2845
    const USING_DIRECTIVE = {
        begin: [
            '//>',
            /\s+/,
            /using/,
            /\s+/,
            /\S+/
        ],
        beginScope: {
            1: "comment",
            3: "keyword",
            5: "type"
        },
        end: /$/,
        contains: [
            DIRECTIVE_VALUE
        ]
    };
    return {
        name: 'Scala',
        keywords: {
            literal: 'true false null',
            keyword: 'type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given transparent'
        },
        contains: [
            USING_DIRECTIVE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            STRING,
            TYPE,
            METHOD,
            CLASS,
            hljs.C_NUMBER_MODE,
            EXTENSION,
            END,
            ...INLINE_MODES,
            USING_PARAM_CLAUSE,
            ANNOTATION
        ]
    };
}
module.exports = $099c75df5d97a1c3$var$scala;

});

parcelRegister("24si5", function(module, exports) {
/*
Language: Shell Session
Requires: bash.js
Author: TSUYUSATO Kitsune <make.just.on@gmail.com>
Category: common
Audit: 2020
*/ /** @type LanguageFn */ function $1821e674a7393f64$var$shell(hljs) {
    return {
        name: 'Shell Session',
        aliases: [
            'console',
            'shellsession'
        ],
        contains: [
            {
                className: 'meta.prompt',
                // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
                // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
                // echo /path/to/home > t.exe
                begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
                starts: {
                    end: /[^\\](?=\s*$)/,
                    subLanguage: 'bash'
                }
            }
        ]
    };
}
module.exports = $1821e674a7393f64$var$shell;

});

parcelRegister("HOA0M", function(module, exports) {
/*
 Language: SQL
 Website: https://en.wikipedia.org/wiki/SQL
 Category: common, database
 */ /*

Goals:

SQL is intended to highlight basic/common SQL keywords and expressions

- If pretty much every single SQL server includes supports, then it's a canidate.
- It is NOT intended to include tons of vendor specific keywords (Oracle, MySQL,
  PostgreSQL) although the list of data types is purposely a bit more expansive.
- For more specific SQL grammars please see:
  - PostgreSQL and PL/pgSQL - core
  - T-SQL - https://github.com/highlightjs/highlightjs-tsql
  - sql_more (core)

 */ function $083b405e356be4b4$var$sql(hljs) {
    const regex = hljs.regex;
    const COMMENT_MODE = hljs.COMMENT('--', '$');
    const STRING = {
        scope: 'string',
        variants: [
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        match: /''/
                    }
                ]
            }
        ]
    };
    const QUOTED_IDENTIFIER = {
        begin: /"/,
        end: /"/,
        contains: [
            {
                match: /""/
            }
        ]
    };
    const LITERALS = [
        "true",
        "false",
        // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
        // "null",
        "unknown"
    ];
    const MULTI_WORD_TYPES = [
        "double precision",
        "large object",
        "with timezone",
        "without timezone"
    ];
    const TYPES = [
        'bigint',
        'binary',
        'blob',
        'boolean',
        'char',
        'character',
        'clob',
        'date',
        'dec',
        'decfloat',
        'decimal',
        'float',
        'int',
        'integer',
        'interval',
        'nchar',
        'nclob',
        'national',
        'numeric',
        'real',
        'row',
        'smallint',
        'time',
        'timestamp',
        'varchar',
        'varying',
        'varbinary'
    ];
    const NON_RESERVED_WORDS = [
        "add",
        "asc",
        "collation",
        "desc",
        "final",
        "first",
        "last",
        "view"
    ];
    // https://jakewheat.github.io/sql-overview/sql-2016-foundation-grammar.html#reserved-word
    const RESERVED_WORDS = [
        "abs",
        "acos",
        "all",
        "allocate",
        "alter",
        "and",
        "any",
        "are",
        "array",
        "array_agg",
        "array_max_cardinality",
        "as",
        "asensitive",
        "asin",
        "asymmetric",
        "at",
        "atan",
        "atomic",
        "authorization",
        "avg",
        "begin",
        "begin_frame",
        "begin_partition",
        "between",
        "bigint",
        "binary",
        "blob",
        "boolean",
        "both",
        "by",
        "call",
        "called",
        "cardinality",
        "cascaded",
        "case",
        "cast",
        "ceil",
        "ceiling",
        "char",
        "char_length",
        "character",
        "character_length",
        "check",
        "classifier",
        "clob",
        "close",
        "coalesce",
        "collate",
        "collect",
        "column",
        "commit",
        "condition",
        "connect",
        "constraint",
        "contains",
        "convert",
        "copy",
        "corr",
        "corresponding",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "create",
        "cross",
        "cube",
        "cume_dist",
        "current",
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_row",
        "current_schema",
        "current_time",
        "current_timestamp",
        "current_path",
        "current_role",
        "current_transform_group_for_type",
        "current_user",
        "cursor",
        "cycle",
        "date",
        "day",
        "deallocate",
        "dec",
        "decimal",
        "decfloat",
        "declare",
        "default",
        "define",
        "delete",
        "dense_rank",
        "deref",
        "describe",
        "deterministic",
        "disconnect",
        "distinct",
        "double",
        "drop",
        "dynamic",
        "each",
        "element",
        "else",
        "empty",
        "end",
        "end_frame",
        "end_partition",
        "end-exec",
        "equals",
        "escape",
        "every",
        "except",
        "exec",
        "execute",
        "exists",
        "exp",
        "external",
        "extract",
        "false",
        "fetch",
        "filter",
        "first_value",
        "float",
        "floor",
        "for",
        "foreign",
        "frame_row",
        "free",
        "from",
        "full",
        "function",
        "fusion",
        "get",
        "global",
        "grant",
        "group",
        "grouping",
        "groups",
        "having",
        "hold",
        "hour",
        "identity",
        "in",
        "indicator",
        "initial",
        "inner",
        "inout",
        "insensitive",
        "insert",
        "int",
        "integer",
        "intersect",
        "intersection",
        "interval",
        "into",
        "is",
        "join",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "language",
        "large",
        "last_value",
        "lateral",
        "lead",
        "leading",
        "left",
        "like",
        "like_regex",
        "listagg",
        "ln",
        "local",
        "localtime",
        "localtimestamp",
        "log",
        "log10",
        "lower",
        "match",
        "match_number",
        "match_recognize",
        "matches",
        "max",
        "member",
        "merge",
        "method",
        "min",
        "minute",
        "mod",
        "modifies",
        "module",
        "month",
        "multiset",
        "national",
        "natural",
        "nchar",
        "nclob",
        "new",
        "no",
        "none",
        "normalize",
        "not",
        "nth_value",
        "ntile",
        "null",
        "nullif",
        "numeric",
        "octet_length",
        "occurrences_regex",
        "of",
        "offset",
        "old",
        "omit",
        "on",
        "one",
        "only",
        "open",
        "or",
        "order",
        "out",
        "outer",
        "over",
        "overlaps",
        "overlay",
        "parameter",
        "partition",
        "pattern",
        "per",
        "percent",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "period",
        "portion",
        "position",
        "position_regex",
        "power",
        "precedes",
        "precision",
        "prepare",
        "primary",
        "procedure",
        "ptf",
        "range",
        "rank",
        "reads",
        "real",
        "recursive",
        "ref",
        "references",
        "referencing",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "release",
        "result",
        "return",
        "returns",
        "revoke",
        "right",
        "rollback",
        "rollup",
        "row",
        "row_number",
        "rows",
        "running",
        "savepoint",
        "scope",
        "scroll",
        "search",
        "second",
        "seek",
        "select",
        "sensitive",
        "session_user",
        "set",
        "show",
        "similar",
        "sin",
        "sinh",
        "skip",
        "smallint",
        "some",
        "specific",
        "specifictype",
        "sql",
        "sqlexception",
        "sqlstate",
        "sqlwarning",
        "sqrt",
        "start",
        "static",
        "stddev_pop",
        "stddev_samp",
        "submultiset",
        "subset",
        "substring",
        "substring_regex",
        "succeeds",
        "sum",
        "symmetric",
        "system",
        "system_time",
        "system_user",
        "table",
        "tablesample",
        "tan",
        "tanh",
        "then",
        "time",
        "timestamp",
        "timezone_hour",
        "timezone_minute",
        "to",
        "trailing",
        "translate",
        "translate_regex",
        "translation",
        "treat",
        "trigger",
        "trim",
        "trim_array",
        "true",
        "truncate",
        "uescape",
        "union",
        "unique",
        "unknown",
        "unnest",
        "update",
        "upper",
        "user",
        "using",
        "value",
        "values",
        "value_of",
        "var_pop",
        "var_samp",
        "varbinary",
        "varchar",
        "varying",
        "versioning",
        "when",
        "whenever",
        "where",
        "width_bucket",
        "window",
        "with",
        "within",
        "without",
        "year"
    ];
    // these are reserved words we have identified to be functions
    // and should only be highlighted in a dispatch-like context
    // ie, array_agg(...), etc.
    const RESERVED_FUNCTIONS = [
        "abs",
        "acos",
        "array_agg",
        "asin",
        "atan",
        "avg",
        "cast",
        "ceil",
        "ceiling",
        "coalesce",
        "corr",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "cume_dist",
        "dense_rank",
        "deref",
        "element",
        "exp",
        "extract",
        "first_value",
        "floor",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "last_value",
        "lead",
        "listagg",
        "ln",
        "log",
        "log10",
        "lower",
        "max",
        "min",
        "mod",
        "nth_value",
        "ntile",
        "nullif",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "position",
        "position_regex",
        "power",
        "rank",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "row_number",
        "sin",
        "sinh",
        "sqrt",
        "stddev_pop",
        "stddev_samp",
        "substring",
        "substring_regex",
        "sum",
        "tan",
        "tanh",
        "translate",
        "translate_regex",
        "treat",
        "trim",
        "trim_array",
        "unnest",
        "upper",
        "value_of",
        "var_pop",
        "var_samp",
        "width_bucket"
    ];
    // these functions can
    const POSSIBLE_WITHOUT_PARENS = [
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_schema",
        "current_transform_group_for_type",
        "current_user",
        "session_user",
        "system_time",
        "system_user",
        "current_time",
        "localtime",
        "current_timestamp",
        "localtimestamp"
    ];
    // those exist to boost relevance making these very
    // "SQL like" keyword combos worth +1 extra relevance
    const COMBOS = [
        "create table",
        "insert into",
        "primary key",
        "foreign key",
        "not null",
        "alter table",
        "add constraint",
        "grouping sets",
        "on overflow",
        "character set",
        "respect nulls",
        "ignore nulls",
        "nulls first",
        "nulls last",
        "depth first",
        "breadth first"
    ];
    const FUNCTIONS = RESERVED_FUNCTIONS;
    const KEYWORDS = [
        ...RESERVED_WORDS,
        ...NON_RESERVED_WORDS
    ].filter((keyword)=>{
        return !RESERVED_FUNCTIONS.includes(keyword);
    });
    const VARIABLE = {
        scope: "variable",
        match: /@[a-z0-9][a-z0-9_]*/
    };
    const OPERATOR = {
        scope: "operator",
        match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
        relevance: 0
    };
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, regex.either(...FUNCTIONS), /\s*\(/),
        relevance: 0,
        keywords: {
            built_in: FUNCTIONS
        }
    };
    // turns a multi-word keyword combo into a regex that doesn't
    // care about extra whitespace etc.
    // input: "START QUERY"
    // output: /\bSTART\s+QUERY\b/
    function kws_to_regex(list) {
        return regex.concat(/\b/, regex.either(...list.map((kw)=>{
            return kw.replace(/\s+/, "\\s+");
        })), /\b/);
    }
    const MULTI_WORD_KEYWORDS = {
        scope: "keyword",
        match: kws_to_regex(COMBOS),
        relevance: 0
    };
    // keywords with less than 3 letters are reduced in relevancy
    function reduceRelevancy(list, { exceptions: exceptions, when: when } = {}) {
        const qualifyFn = when;
        exceptions = exceptions || [];
        return list.map((item)=>{
            if (item.match(/\|\d+$/) || exceptions.includes(item)) return item;
            else if (qualifyFn(item)) return `${item}|0`;
            else return item;
        });
    }
    return {
        name: 'SQL',
        case_insensitive: true,
        // does not include {} or HTML tags `</`
        illegal: /[{}]|<\//,
        keywords: {
            $pattern: /\b[\w\.]+/,
            keyword: reduceRelevancy(KEYWORDS, {
                when: (x)=>x.length < 3
            }),
            literal: LITERALS,
            type: TYPES,
            built_in: POSSIBLE_WITHOUT_PARENS
        },
        contains: [
            {
                scope: "type",
                match: kws_to_regex(MULTI_WORD_TYPES)
            },
            MULTI_WORD_KEYWORDS,
            FUNCTION_CALL,
            VARIABLE,
            STRING,
            QUOTED_IDENTIFIER,
            hljs.C_NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            OPERATOR
        ]
    };
}
module.exports = $083b405e356be4b4$var$sql;

});

parcelRegister("ga94M", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $bc449ed21aac19d2$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $bc449ed21aac19d2$var$lookahead(re) {
    return $bc449ed21aac19d2$var$concat('(?=', re, ')');
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $bc449ed21aac19d2$var$concat(...args) {
    const joined = args.map((x)=>$bc449ed21aac19d2$var$source(x)).join("");
    return joined;
}
/**
 * @param { Array<string | RegExp | Object> } args
 * @returns {object}
 */ function $bc449ed21aac19d2$var$stripOptionsFromArgs(args) {
    const opts = args[args.length - 1];
    if (typeof opts === 'object' && opts.constructor === Object) {
        args.splice(args.length - 1, 1);
        return opts;
    } else return {};
}
/** @typedef { {capture?: boolean} } RegexEitherOptions */ /**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
 * @returns {string}
 */ function $bc449ed21aac19d2$var$either(...args) {
    /** @type { object & {capture?: boolean} }  */ const opts = $bc449ed21aac19d2$var$stripOptionsFromArgs(args);
    const joined = '(' + (opts.capture ? "" : "?:") + args.map((x)=>$bc449ed21aac19d2$var$source(x)).join("|") + ")";
    return joined;
}
const $bc449ed21aac19d2$var$keywordWrapper = (keyword)=>$bc449ed21aac19d2$var$concat(/\b/, keyword, /\w$/.test(keyword) ? /\b/ : /\B/);
// Keywords that require a leading dot.
const $bc449ed21aac19d2$var$dotKeywords = [
    'Protocol',
    'Type' // contextual
].map($bc449ed21aac19d2$var$keywordWrapper);
// Keywords that may have a leading dot.
const $bc449ed21aac19d2$var$optionalDotKeywords = [
    'init',
    'self'
].map($bc449ed21aac19d2$var$keywordWrapper);
// should register as keyword, not type
const $bc449ed21aac19d2$var$keywordTypes = [
    'Any',
    'Self'
];
// Regular keywords and literals.
const $bc449ed21aac19d2$var$keywords = [
    // strings below will be fed into the regular `keywords` engine while regex
    // will result in additional modes being created to scan for those keywords to
    // avoid conflicts with other rules
    'actor',
    'any',
    'associatedtype',
    'async',
    'await',
    /as\?/,
    /as!/,
    'as',
    'borrowing',
    'break',
    'case',
    'catch',
    'class',
    'consume',
    'consuming',
    'continue',
    'convenience',
    'copy',
    'default',
    'defer',
    'deinit',
    'didSet',
    'distributed',
    'do',
    'dynamic',
    'each',
    'else',
    'enum',
    'extension',
    'fallthrough',
    /fileprivate\(set\)/,
    'fileprivate',
    'final',
    'for',
    'func',
    'get',
    'guard',
    'if',
    'import',
    'indirect',
    'infix',
    /init\?/,
    /init!/,
    'inout',
    /internal\(set\)/,
    'internal',
    'in',
    'is',
    'isolated',
    'nonisolated',
    'lazy',
    'let',
    'macro',
    'mutating',
    'nonmutating',
    /open\(set\)/,
    'open',
    'operator',
    'optional',
    'override',
    'package',
    'postfix',
    'precedencegroup',
    'prefix',
    /private\(set\)/,
    'private',
    'protocol',
    /public\(set\)/,
    'public',
    'repeat',
    'required',
    'rethrows',
    'return',
    'set',
    'some',
    'static',
    'struct',
    'subscript',
    'super',
    'switch',
    'throws',
    'throw',
    /try\?/,
    /try!/,
    'try',
    'typealias',
    /unowned\(safe\)/,
    /unowned\(unsafe\)/,
    'unowned',
    'var',
    'weak',
    'where',
    'while',
    'willSet' // contextual
];
// NOTE: Contextual keywords are reserved only in specific contexts.
// Ideally, these should be matched using modes to avoid false positives.
// Literals.
const $bc449ed21aac19d2$var$literals = [
    'false',
    'nil',
    'true'
];
// Keywords used in precedence groups.
const $bc449ed21aac19d2$var$precedencegroupKeywords = [
    'assignment',
    'associativity',
    'higherThan',
    'left',
    'lowerThan',
    'none',
    'right'
];
// Keywords that start with a number sign (#).
// #(un)available is handled separately.
const $bc449ed21aac19d2$var$numberSignKeywords = [
    '#colorLiteral',
    '#column',
    '#dsohandle',
    '#else',
    '#elseif',
    '#endif',
    '#error',
    '#file',
    '#fileID',
    '#fileLiteral',
    '#filePath',
    '#function',
    '#if',
    '#imageLiteral',
    '#keyPath',
    '#line',
    '#selector',
    '#sourceLocation',
    '#warning'
];
// Global functions in the Standard Library.
const $bc449ed21aac19d2$var$builtIns = [
    'abs',
    'all',
    'any',
    'assert',
    'assertionFailure',
    'debugPrint',
    'dump',
    'fatalError',
    'getVaList',
    'isKnownUniquelyReferenced',
    'max',
    'min',
    'numericCast',
    'pointwiseMax',
    'pointwiseMin',
    'precondition',
    'preconditionFailure',
    'print',
    'readLine',
    'repeatElement',
    'sequence',
    'stride',
    'swap',
    'swift_unboxFromSwiftValueWithType',
    'transcode',
    'type',
    'unsafeBitCast',
    'unsafeDowncast',
    'withExtendedLifetime',
    'withUnsafeMutablePointer',
    'withUnsafePointer',
    'withVaList',
    'withoutActuallyEscaping',
    'zip'
];
// Valid first characters for operators.
const $bc449ed21aac19d2$var$operatorHead = $bc449ed21aac19d2$var$either(/[/=\-+!*%<>&|^~?]/, /[\u00A1-\u00A7]/, /[\u00A9\u00AB]/, /[\u00AC\u00AE]/, /[\u00B0\u00B1]/, /[\u00B6\u00BB\u00BF\u00D7\u00F7]/, /[\u2016-\u2017]/, /[\u2020-\u2027]/, /[\u2030-\u203E]/, /[\u2041-\u2053]/, /[\u2055-\u205E]/, /[\u2190-\u23FF]/, /[\u2500-\u2775]/, /[\u2794-\u2BFF]/, /[\u2E00-\u2E7F]/, /[\u3001-\u3003]/, /[\u3008-\u3020]/, /[\u3030]/);
// Valid characters for operators.
const $bc449ed21aac19d2$var$operatorCharacter = $bc449ed21aac19d2$var$either($bc449ed21aac19d2$var$operatorHead, /[\u0300-\u036F]/, /[\u1DC0-\u1DFF]/, /[\u20D0-\u20FF]/, /[\uFE00-\uFE0F]/, /[\uFE20-\uFE2F]/);
// Valid operator.
const $bc449ed21aac19d2$var$operator = $bc449ed21aac19d2$var$concat($bc449ed21aac19d2$var$operatorHead, $bc449ed21aac19d2$var$operatorCharacter, '*');
// Valid first characters for identifiers.
const $bc449ed21aac19d2$var$identifierHead = $bc449ed21aac19d2$var$either(/[a-zA-Z_]/, /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/, /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/, /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/, /[\u1E00-\u1FFF]/, /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/, /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/, /[\u2C00-\u2DFF\u2E80-\u2FFF]/, /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/, /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/, /[\uFE47-\uFEFE\uFF00-\uFFFD]/ // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
);
// Valid characters for identifiers.
const $bc449ed21aac19d2$var$identifierCharacter = $bc449ed21aac19d2$var$either($bc449ed21aac19d2$var$identifierHead, /\d/, /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/);
// Valid identifier.
const $bc449ed21aac19d2$var$identifier = $bc449ed21aac19d2$var$concat($bc449ed21aac19d2$var$identifierHead, $bc449ed21aac19d2$var$identifierCharacter, '*');
// Valid type identifier.
const $bc449ed21aac19d2$var$typeIdentifier = $bc449ed21aac19d2$var$concat(/[A-Z]/, $bc449ed21aac19d2$var$identifierCharacter, '*');
// Built-in attributes, which are highlighted as keywords.
// @available is handled separately.
// https://docs.swift.org/swift-book/documentation/the-swift-programming-language/attributes
const $bc449ed21aac19d2$var$keywordAttributes = [
    'attached',
    'autoclosure',
    $bc449ed21aac19d2$var$concat(/convention\(/, $bc449ed21aac19d2$var$either('swift', 'block', 'c'), /\)/),
    'discardableResult',
    'dynamicCallable',
    'dynamicMemberLookup',
    'escaping',
    'freestanding',
    'frozen',
    'GKInspectable',
    'IBAction',
    'IBDesignable',
    'IBInspectable',
    'IBOutlet',
    'IBSegueAction',
    'inlinable',
    'main',
    'nonobjc',
    'NSApplicationMain',
    'NSCopying',
    'NSManaged',
    $bc449ed21aac19d2$var$concat(/objc\(/, $bc449ed21aac19d2$var$identifier, /\)/),
    'objc',
    'objcMembers',
    'propertyWrapper',
    'requires_stored_property_inits',
    'resultBuilder',
    'Sendable',
    'testable',
    'UIApplicationMain',
    'unchecked',
    'unknown',
    'usableFromInline',
    'warn_unqualified_access'
];
// Contextual keywords used in @available and #(un)available.
const $bc449ed21aac19d2$var$availabilityKeywords = [
    'iOS',
    'iOSApplicationExtension',
    'macOS',
    'macOSApplicationExtension',
    'macCatalyst',
    'macCatalystApplicationExtension',
    'watchOS',
    'watchOSApplicationExtension',
    'tvOS',
    'tvOSApplicationExtension',
    'swift'
];
/*
Language: Swift
Description: Swift is a general-purpose programming language built using a modern approach to safety, performance, and software design patterns.
Author: Steven Van Impe <steven.vanimpe@icloud.com>
Contributors: Chris Eidhof <chris@eidhof.nl>, Nate Cook <natecook@gmail.com>, Alexander Lichter <manniL@gmx.net>, Richard Gibson <gibson042@github>
Website: https://swift.org
Category: common, system
*/ /** @type LanguageFn */ function $bc449ed21aac19d2$var$swift(hljs) {
    const WHITESPACE = {
        match: /\s+/,
        relevance: 0
    };
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID411
    const BLOCK_COMMENT = hljs.COMMENT('/\\*', '\\*/', {
        contains: [
            'self'
        ]
    });
    const COMMENTS = [
        hljs.C_LINE_COMMENT_MODE,
        BLOCK_COMMENT
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID413
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html
    const DOT_KEYWORD = {
        match: [
            /\./,
            $bc449ed21aac19d2$var$either(...$bc449ed21aac19d2$var$dotKeywords, ...$bc449ed21aac19d2$var$optionalDotKeywords)
        ],
        className: {
            2: "keyword"
        }
    };
    const KEYWORD_GUARD = {
        // Consume .keyword to prevent highlighting properties and methods as keywords.
        match: $bc449ed21aac19d2$var$concat(/\./, $bc449ed21aac19d2$var$either(...$bc449ed21aac19d2$var$keywords)),
        relevance: 0
    };
    const PLAIN_KEYWORDS = $bc449ed21aac19d2$var$keywords.filter((kw)=>typeof kw === 'string').concat([
        "_|0"
    ]); // seems common, so 0 relevance
    const REGEX_KEYWORDS = $bc449ed21aac19d2$var$keywords.filter((kw)=>typeof kw !== 'string') // find regex
    .concat($bc449ed21aac19d2$var$keywordTypes).map($bc449ed21aac19d2$var$keywordWrapper);
    const KEYWORD = {
        variants: [
            {
                className: 'keyword',
                match: $bc449ed21aac19d2$var$either(...REGEX_KEYWORDS, ...$bc449ed21aac19d2$var$optionalDotKeywords)
            }
        ]
    };
    // find all the regular keywords
    const KEYWORDS = {
        $pattern: $bc449ed21aac19d2$var$either(/\b\w+/, /#\w+/ // number keywords
        ),
        keyword: PLAIN_KEYWORDS.concat($bc449ed21aac19d2$var$numberSignKeywords),
        literal: $bc449ed21aac19d2$var$literals
    };
    const KEYWORD_MODES = [
        DOT_KEYWORD,
        KEYWORD_GUARD,
        KEYWORD
    ];
    // https://github.com/apple/swift/tree/main/stdlib/public/core
    const BUILT_IN_GUARD = {
        // Consume .built_in to prevent highlighting properties and methods.
        match: $bc449ed21aac19d2$var$concat(/\./, $bc449ed21aac19d2$var$either(...$bc449ed21aac19d2$var$builtIns)),
        relevance: 0
    };
    const BUILT_IN = {
        className: 'built_in',
        match: $bc449ed21aac19d2$var$concat(/\b/, $bc449ed21aac19d2$var$either(...$bc449ed21aac19d2$var$builtIns), /(?=\()/)
    };
    const BUILT_INS = [
        BUILT_IN_GUARD,
        BUILT_IN
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID418
    const OPERATOR_GUARD = {
        // Prevent -> from being highlighting as an operator.
        match: /->/,
        relevance: 0
    };
    const OPERATOR = {
        className: 'operator',
        relevance: 0,
        variants: [
            {
                match: $bc449ed21aac19d2$var$operator
            },
            {
                // dot-operator: only operators that start with a dot are allowed to use dots as
                // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
                // characters that may also include dots.
                match: `\\.(\\.|${$bc449ed21aac19d2$var$operatorCharacter})+`
            }
        ]
    };
    const OPERATORS = [
        OPERATOR_GUARD,
        OPERATOR
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#grammar_numeric-literal
    // TODO: Update for leading `-` after lookbehind is supported everywhere
    const decimalDigits = '([0-9]_*)+';
    const hexDigits = '([0-9a-fA-F]_*)+';
    const NUMBER = {
        className: 'number',
        relevance: 0,
        variants: [
            // decimal floating-point-literal (subsumes decimal-literal)
            {
                match: `\\b(${decimalDigits})(\\.(${decimalDigits}))?` + `([eE][+-]?(${decimalDigits}))?\\b`
            },
            // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
            {
                match: `\\b0x(${hexDigits})(\\.(${hexDigits}))?` + `([pP][+-]?(${decimalDigits}))?\\b`
            },
            // octal-literal
            {
                match: /\b0o([0-7]_*)+\b/
            },
            // binary-literal
            {
                match: /\b0b([01]_*)+\b/
            }
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#grammar_string-literal
    const ESCAPED_CHARACTER = (rawDelimiter = "")=>({
            className: 'subst',
            variants: [
                {
                    match: $bc449ed21aac19d2$var$concat(/\\/, rawDelimiter, /[0\\tnr"']/)
                },
                {
                    match: $bc449ed21aac19d2$var$concat(/\\/, rawDelimiter, /u\{[0-9a-fA-F]{1,8}\}/)
                }
            ]
        });
    const ESCAPED_NEWLINE = (rawDelimiter = "")=>({
            className: 'subst',
            match: $bc449ed21aac19d2$var$concat(/\\/, rawDelimiter, /[\t ]*(?:[\r\n]|\r\n)/)
        });
    const INTERPOLATION = (rawDelimiter = "")=>({
            className: 'subst',
            label: "interpol",
            begin: $bc449ed21aac19d2$var$concat(/\\/, rawDelimiter, /\(/),
            end: /\)/
        });
    const MULTILINE_STRING = (rawDelimiter = "")=>({
            begin: $bc449ed21aac19d2$var$concat(rawDelimiter, /"""/),
            end: $bc449ed21aac19d2$var$concat(/"""/, rawDelimiter),
            contains: [
                ESCAPED_CHARACTER(rawDelimiter),
                ESCAPED_NEWLINE(rawDelimiter),
                INTERPOLATION(rawDelimiter)
            ]
        });
    const SINGLE_LINE_STRING = (rawDelimiter = "")=>({
            begin: $bc449ed21aac19d2$var$concat(rawDelimiter, /"/),
            end: $bc449ed21aac19d2$var$concat(/"/, rawDelimiter),
            contains: [
                ESCAPED_CHARACTER(rawDelimiter),
                INTERPOLATION(rawDelimiter)
            ]
        });
    const STRING = {
        className: 'string',
        variants: [
            MULTILINE_STRING(),
            MULTILINE_STRING("#"),
            MULTILINE_STRING("##"),
            MULTILINE_STRING("###"),
            SINGLE_LINE_STRING(),
            SINGLE_LINE_STRING("#"),
            SINGLE_LINE_STRING("##"),
            SINGLE_LINE_STRING("###")
        ]
    };
    const REGEXP_CONTENTS = [
        hljs.BACKSLASH_ESCAPE,
        {
            begin: /\[/,
            end: /\]/,
            relevance: 0,
            contains: [
                hljs.BACKSLASH_ESCAPE
            ]
        }
    ];
    const BARE_REGEXP_LITERAL = {
        begin: /\/[^\s](?=[^/\n]*\/)/,
        end: /\//,
        contains: REGEXP_CONTENTS
    };
    const EXTENDED_REGEXP_LITERAL = (rawDelimiter)=>{
        const begin = $bc449ed21aac19d2$var$concat(rawDelimiter, /\//);
        const end = $bc449ed21aac19d2$var$concat(/\//, rawDelimiter);
        return {
            begin: begin,
            end: end,
            contains: [
                ...REGEXP_CONTENTS,
                {
                    scope: "comment",
                    begin: `#(?!.*${end})`,
                    end: /$/
                }
            ]
        };
    };
    // https://docs.swift.org/swift-book/documentation/the-swift-programming-language/lexicalstructure/#Regular-Expression-Literals
    const REGEXP = {
        scope: "regexp",
        variants: [
            EXTENDED_REGEXP_LITERAL('###'),
            EXTENDED_REGEXP_LITERAL('##'),
            EXTENDED_REGEXP_LITERAL('#'),
            BARE_REGEXP_LITERAL
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID412
    const QUOTED_IDENTIFIER = {
        match: $bc449ed21aac19d2$var$concat(/`/, $bc449ed21aac19d2$var$identifier, /`/)
    };
    const IMPLICIT_PARAMETER = {
        className: 'variable',
        match: /\$\d+/
    };
    const PROPERTY_WRAPPER_PROJECTION = {
        className: 'variable',
        match: `\\$${$bc449ed21aac19d2$var$identifierCharacter}+`
    };
    const IDENTIFIERS = [
        QUOTED_IDENTIFIER,
        IMPLICIT_PARAMETER,
        PROPERTY_WRAPPER_PROJECTION
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/Attributes.html
    const AVAILABLE_ATTRIBUTE = {
        match: /(@|#(un)?)available/,
        scope: 'keyword',
        starts: {
            contains: [
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: $bc449ed21aac19d2$var$availabilityKeywords,
                    contains: [
                        ...OPERATORS,
                        NUMBER,
                        STRING
                    ]
                }
            ]
        }
    };
    const KEYWORD_ATTRIBUTE = {
        scope: 'keyword',
        match: $bc449ed21aac19d2$var$concat(/@/, $bc449ed21aac19d2$var$either(...$bc449ed21aac19d2$var$keywordAttributes), $bc449ed21aac19d2$var$lookahead($bc449ed21aac19d2$var$either(/\(/, /\s+/)))
    };
    const USER_DEFINED_ATTRIBUTE = {
        scope: 'meta',
        match: $bc449ed21aac19d2$var$concat(/@/, $bc449ed21aac19d2$var$identifier)
    };
    const ATTRIBUTES = [
        AVAILABLE_ATTRIBUTE,
        KEYWORD_ATTRIBUTE,
        USER_DEFINED_ATTRIBUTE
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/Types.html
    const TYPE = {
        match: $bc449ed21aac19d2$var$lookahead(/\b[A-Z]/),
        relevance: 0,
        contains: [
            {
                className: 'type',
                match: $bc449ed21aac19d2$var$concat(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, $bc449ed21aac19d2$var$identifierCharacter, '+')
            },
            {
                className: 'type',
                match: $bc449ed21aac19d2$var$typeIdentifier,
                relevance: 0
            },
            {
                match: /[?!]+/,
                relevance: 0
            },
            {
                match: /\.\.\./,
                relevance: 0
            },
            {
                match: $bc449ed21aac19d2$var$concat(/\s+&\s+/, $bc449ed21aac19d2$var$lookahead($bc449ed21aac19d2$var$typeIdentifier)),
                relevance: 0
            }
        ]
    };
    const GENERIC_ARGUMENTS = {
        begin: /</,
        end: />/,
        keywords: KEYWORDS,
        contains: [
            ...COMMENTS,
            ...KEYWORD_MODES,
            ...ATTRIBUTES,
            OPERATOR_GUARD,
            TYPE
        ]
    };
    TYPE.contains.push(GENERIC_ARGUMENTS);
    // https://docs.swift.org/swift-book/ReferenceManual/Expressions.html#ID552
    // Prevents element names from being highlighted as keywords.
    const TUPLE_ELEMENT_NAME = {
        match: $bc449ed21aac19d2$var$concat($bc449ed21aac19d2$var$identifier, /\s*:/),
        keywords: "_|0",
        relevance: 0
    };
    // Matches tuples as well as the parameter list of a function type.
    const TUPLE = {
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        keywords: KEYWORDS,
        contains: [
            'self',
            TUPLE_ELEMENT_NAME,
            ...COMMENTS,
            REGEXP,
            ...KEYWORD_MODES,
            ...BUILT_INS,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...IDENTIFIERS,
            ...ATTRIBUTES,
            TYPE
        ]
    };
    const GENERIC_PARAMETERS = {
        begin: /</,
        end: />/,
        keywords: 'repeat each',
        contains: [
            ...COMMENTS,
            TYPE
        ]
    };
    const FUNCTION_PARAMETER_NAME = {
        begin: $bc449ed21aac19d2$var$either($bc449ed21aac19d2$var$lookahead($bc449ed21aac19d2$var$concat($bc449ed21aac19d2$var$identifier, /\s*:/)), $bc449ed21aac19d2$var$lookahead($bc449ed21aac19d2$var$concat($bc449ed21aac19d2$var$identifier, /\s+/, $bc449ed21aac19d2$var$identifier, /\s*:/))),
        end: /:/,
        relevance: 0,
        contains: [
            {
                className: 'keyword',
                match: /\b_\b/
            },
            {
                className: 'params',
                match: $bc449ed21aac19d2$var$identifier
            }
        ]
    };
    const FUNCTION_PARAMETERS = {
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        contains: [
            FUNCTION_PARAMETER_NAME,
            ...COMMENTS,
            ...KEYWORD_MODES,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...ATTRIBUTES,
            TYPE,
            TUPLE
        ],
        endsParent: true,
        illegal: /["']/
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID362
    // https://docs.swift.org/swift-book/documentation/the-swift-programming-language/declarations/#Macro-Declaration
    const FUNCTION_OR_MACRO = {
        match: [
            /(func|macro)/,
            /\s+/,
            $bc449ed21aac19d2$var$either(QUOTED_IDENTIFIER.match, $bc449ed21aac19d2$var$identifier, $bc449ed21aac19d2$var$operator)
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            GENERIC_PARAMETERS,
            FUNCTION_PARAMETERS,
            WHITESPACE
        ],
        illegal: [
            /\[/,
            /%/
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID375
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID379
    const INIT_SUBSCRIPT = {
        match: [
            /\b(?:subscript|init[?!]?)/,
            /\s*(?=[<(])/
        ],
        className: {
            1: "keyword"
        },
        contains: [
            GENERIC_PARAMETERS,
            FUNCTION_PARAMETERS,
            WHITESPACE
        ],
        illegal: /\[|%/
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID380
    const OPERATOR_DECLARATION = {
        match: [
            /operator/,
            /\s+/,
            $bc449ed21aac19d2$var$operator
        ],
        className: {
            1: "keyword",
            3: "title"
        }
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID550
    const PRECEDENCEGROUP = {
        begin: [
            /precedencegroup/,
            /\s+/,
            $bc449ed21aac19d2$var$typeIdentifier
        ],
        className: {
            1: "keyword",
            3: "title"
        },
        contains: [
            TYPE
        ],
        keywords: [
            ...$bc449ed21aac19d2$var$precedencegroupKeywords,
            ...$bc449ed21aac19d2$var$literals
        ],
        end: /}/
    };
    const CLASS_FUNC_DECLARATION = {
        match: [
            /class\b/,
            /\s+/,
            /func\b/,
            /\s+/,
            /\b[A-Za-z_][A-Za-z0-9_]*\b/
        ],
        scope: {
            1: "keyword",
            3: "keyword",
            5: "title.function"
        }
    };
    const CLASS_VAR_DECLARATION = {
        match: [
            /class\b/,
            /\s+/,
            /var\b/
        ],
        scope: {
            1: "keyword",
            3: "keyword"
        }
    };
    const TYPE_DECLARATION = {
        begin: [
            /(struct|protocol|class|extension|enum|actor)/,
            /\s+/,
            $bc449ed21aac19d2$var$identifier,
            /\s*/
        ],
        beginScope: {
            1: "keyword",
            3: "title.class"
        },
        keywords: KEYWORDS,
        contains: [
            GENERIC_PARAMETERS,
            ...KEYWORD_MODES,
            {
                begin: /:/,
                end: /\{/,
                keywords: KEYWORDS,
                contains: [
                    {
                        scope: "title.class.inherited",
                        match: $bc449ed21aac19d2$var$typeIdentifier
                    },
                    ...KEYWORD_MODES
                ],
                relevance: 0
            }
        ]
    };
    // Add supported submodes to string interpolation.
    for (const variant of STRING.variants){
        const interpolation = variant.contains.find((mode)=>mode.label === "interpol");
        // TODO: Interpolation can contain any expression, so there's room for improvement here.
        interpolation.keywords = KEYWORDS;
        const submodes = [
            ...KEYWORD_MODES,
            ...BUILT_INS,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...IDENTIFIERS
        ];
        interpolation.contains = [
            ...submodes,
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    'self',
                    ...submodes
                ]
            }
        ];
    }
    return {
        name: 'Swift',
        keywords: KEYWORDS,
        contains: [
            ...COMMENTS,
            FUNCTION_OR_MACRO,
            INIT_SUBSCRIPT,
            CLASS_FUNC_DECLARATION,
            CLASS_VAR_DECLARATION,
            TYPE_DECLARATION,
            OPERATOR_DECLARATION,
            PRECEDENCEGROUP,
            {
                beginKeywords: 'import',
                end: /$/,
                contains: [
                    ...COMMENTS
                ],
                relevance: 0
            },
            REGEXP,
            ...KEYWORD_MODES,
            ...BUILT_INS,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...IDENTIFIERS,
            ...ATTRIBUTES,
            TYPE,
            TUPLE
        ]
    };
}
module.exports = $bc449ed21aac19d2$var$swift;

});

parcelRegister("drukz", function(module, exports) {
const $9c9553100c759297$var$IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
const $9c9553100c759297$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends",
    // It's reached stage 3, which is "recommended for implementation":
    "using"
];
const $9c9553100c759297$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $9c9553100c759297$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $9c9553100c759297$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $9c9553100c759297$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $9c9553100c759297$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global" // Node.js
];
const $9c9553100c759297$var$BUILT_INS = [].concat($9c9553100c759297$var$BUILT_IN_GLOBALS, $9c9553100c759297$var$TYPES, $9c9553100c759297$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $9c9553100c759297$var$javascript(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $9c9553100c759297$var$IDENT_RE;
    const FRAGMENT = {
        begin: '<>',
        end: '</>'
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $9c9553100c759297$var$IDENT_RE,
        keyword: $9c9553100c759297$var$KEYWORDS,
        literal: $9c9553100c759297$var$LITERALS,
        built_in: $9c9553100c759297$var$BUILT_INS,
        "variable.language": $9c9553100c759297$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = '[0-9](_?[0-9])*';
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: 'number',
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: 'subst',
        begin: '\\$\\{',
        end: '\\}',
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: '\.?html`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'xml'
        }
    };
    const CSS_TEMPLATE = {
        begin: '\.?css`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'css'
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: '\.?gql`',
        end: '',
        starts: {
            end: '`',
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: 'graphql'
        }
    };
    const TEMPLATE_STRING = {
        className: 'string',
        begin: '`',
        end: '`',
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
        relevance: 0,
        contains: [
            {
                begin: '(?=@[A-Za-z]+)',
                relevance: 0,
                contains: [
                    {
                        className: 'doctag',
                        begin: '@[A-Za-z]+'
                    },
                    {
                        className: 'type',
                        begin: '\\{',
                        end: '\\}',
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: 'variable',
                        begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /(\s*)\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: 'params',
        // convert this to negative lookbehind in v12
        begin: /(\s*)\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$9c9553100c759297$var$TYPES,
                ...$9c9553100c759297$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$9c9553100c759297$var$BUILT_IN_GLOBALS,
            "super",
            "import"
        ].map((x)=>`${x}\\s*\\(`)), IDENT_RE$1, regex.lookahead(/\s*\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>';
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: 'JavaScript',
        aliases: [
            'js',
            'jsx',
            'mjs',
            'cjs'
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                scope: 'attr',
                match: IDENT_RE$1 + regex.lookahead(':'),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
                keywords: 'return throw case',
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: 'function',
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: '\\s*=>',
                        contains: [
                            {
                                className: 'params',
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /(\s*)\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                'on:begin': XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: 'xml',
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    'self'
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: '\\b(?!function)' + hljs.UNDERSCORE_IDENT_RE + '\\(' + // first parens
                '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{',
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: '\\$' + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
/*
Language: TypeScript
Author: Panu Horsmalahti <panu.horsmalahti@iki.fi>
Contributors: Ike Ku <dempfi@yahoo.com>
Description: TypeScript is a strict superset of JavaScript
Website: https://www.typescriptlang.org
Category: common, scripting
*/ /** @type LanguageFn */ function $9c9553100c759297$var$typescript(hljs) {
    const regex = hljs.regex;
    const tsLanguage = $9c9553100c759297$var$javascript(hljs);
    const IDENT_RE$1 = $9c9553100c759297$var$IDENT_RE;
    const TYPES = [
        "any",
        "void",
        "number",
        "boolean",
        "string",
        "object",
        "never",
        "symbol",
        "bigint",
        "unknown"
    ];
    const NAMESPACE = {
        begin: [
            /namespace/,
            /\s+/,
            hljs.IDENT_RE
        ],
        beginScope: {
            1: "keyword",
            3: "title.class"
        }
    };
    const INTERFACE = {
        beginKeywords: 'interface',
        end: /\{/,
        excludeEnd: true,
        keywords: {
            keyword: 'interface extends',
            built_in: TYPES
        },
        contains: [
            tsLanguage.exports.CLASS_REFERENCE
        ]
    };
    const USE_STRICT = {
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use strict['"]/
    };
    const TS_SPECIFIC_KEYWORDS = [
        "type",
        // "namespace",
        "interface",
        "public",
        "private",
        "protected",
        "implements",
        "declare",
        "abstract",
        "readonly",
        "enum",
        "override",
        "satisfies"
    ];
    /*
    namespace is a TS keyword but it's fine to use it as a variable name too.
    const message = 'foo';
    const namespace = 'bar';
  */ const KEYWORDS$1 = {
        $pattern: $9c9553100c759297$var$IDENT_RE,
        keyword: $9c9553100c759297$var$KEYWORDS.concat(TS_SPECIFIC_KEYWORDS),
        literal: $9c9553100c759297$var$LITERALS,
        built_in: $9c9553100c759297$var$BUILT_INS.concat(TYPES),
        "variable.language": $9c9553100c759297$var$BUILT_IN_VARIABLES
    };
    const DECORATOR = {
        className: 'meta',
        begin: '@' + IDENT_RE$1
    };
    const swapMode = (mode, label, replacement)=>{
        const indx = mode.contains.findIndex((m)=>m.label === label);
        if (indx === -1) throw new Error("can not find mode to replace");
        mode.contains.splice(indx, 1, replacement);
    };
    // this should update anywhere keywords is used since
    // it will be the same actual JS object
    Object.assign(tsLanguage.keywords, KEYWORDS$1);
    tsLanguage.exports.PARAMS_CONTAINS.push(DECORATOR);
    // highlight the function params
    const ATTRIBUTE_HIGHLIGHT = tsLanguage.contains.find((c)=>c.scope === "attr");
    // take default attr rule and extend it to support optionals
    const OPTIONAL_KEY_OR_ARGUMENT = Object.assign({}, ATTRIBUTE_HIGHLIGHT, {
        match: regex.concat(IDENT_RE$1, regex.lookahead(/\s*\?:/))
    });
    tsLanguage.exports.PARAMS_CONTAINS.push([
        tsLanguage.exports.CLASS_REFERENCE,
        ATTRIBUTE_HIGHLIGHT,
        OPTIONAL_KEY_OR_ARGUMENT
    ]);
    // Add the optional property assignment highlighting for objects or classes
    tsLanguage.contains = tsLanguage.contains.concat([
        DECORATOR,
        NAMESPACE,
        INTERFACE,
        OPTIONAL_KEY_OR_ARGUMENT
    ]);
    // TS gets a simpler shebang rule than JS
    swapMode(tsLanguage, "shebang", hljs.SHEBANG());
    // JS use strict rule purposely excludes `asm` which makes no sense
    swapMode(tsLanguage, "use_strict", USE_STRICT);
    const functionDeclaration = tsLanguage.contains.find((m)=>m.label === "func.def");
    functionDeclaration.relevance = 0; // () => {} is more typical in TypeScript
    Object.assign(tsLanguage, {
        name: 'TypeScript',
        aliases: [
            'ts',
            'tsx',
            'mts',
            'cts'
        ]
    });
    return tsLanguage;
}
module.exports = $9c9553100c759297$var$typescript;

});

parcelRegister("8Fi1u", function(module, exports) {
/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common, web
Audit: 2020
*/ /** @type LanguageFn */ function $64f0220a719f967e$var$xml(hljs) {
    const regex = hljs.regex;
    // XML names can have the following additional letters: https://www.w3.org/TR/xml/#NT-NameChar
    // OTHER_NAME_CHARS = /[:\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]/;
    // Element names start with NAME_START_CHAR followed by optional other Unicode letters, ASCII digits, hyphens, underscores, and periods
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);;
    // const XML_IDENT_RE = /[A-Z_a-z:\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]+/;
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);
    // however, to cater for performance and more Unicode support rely simply on the Unicode letter class
    const TAG_NAME_RE = regex.concat(/[\p{L}_]/u, regex.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u);
    const XML_IDENT_RE = /[\p{L}0-9._:-]+/u;
    const XML_ENTITIES = {
        className: 'symbol',
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    };
    const XML_META_KEYWORDS = {
        begin: /\s/,
        contains: [
            {
                className: 'keyword',
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    };
    const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
        begin: /\(/,
        end: /\)/
    });
    const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
        className: 'string'
    });
    const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: 'string'
    });
    const TAG_INTERNALS = {
        endsWithParent: true,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: 'attr',
                begin: XML_IDENT_RE,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: 'string',
                        endsParent: true,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: 'HTML, XML',
        aliases: [
            'html',
            'xhtml',
            'rss',
            'atom',
            'xjb',
            'xsd',
            'xsl',
            'plist',
            'wsf',
            'svg'
        ],
        case_insensitive: true,
        unicodeRegex: true,
        contains: [
            {
                className: 'meta',
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    XML_META_KEYWORDS,
                    QUOTE_META_STRING_MODE,
                    APOS_META_STRING_MODE,
                    XML_META_PAR_KEYWORDS,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: 'meta',
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    XML_META_KEYWORDS,
                                    XML_META_PAR_KEYWORDS,
                                    QUOTE_META_STRING_MODE,
                                    APOS_META_STRING_MODE
                                ]
                            }
                        ]
                    }
                ]
            },
            hljs.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            XML_ENTITIES,
            // xml processing instructions
            {
                className: 'meta',
                end: /\?>/,
                variants: [
                    {
                        begin: /<\?xml/,
                        relevance: 10,
                        contains: [
                            QUOTE_META_STRING_MODE
                        ]
                    },
                    {
                        begin: /<\?[a-z][a-z0-9]+/
                    }
                ]
            },
            {
                className: 'tag',
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: 'style'
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: true,
                    subLanguage: [
                        'css',
                        'xml'
                    ]
                }
            },
            {
                className: 'tag',
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: 'script'
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: true,
                    subLanguage: [
                        'javascript',
                        'handlebars',
                        'xml'
                    ]
                }
            },
            // we need this for now for jSX
            {
                className: 'tag',
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: 'tag',
                begin: regex.concat(/</, regex.lookahead(regex.concat(TAG_NAME_RE, // <tag/>
                // <tag>
                // <tag ...
                regex.either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: 'name',
                        begin: TAG_NAME_RE,
                        relevance: 0,
                        starts: TAG_INTERNALS
                    }
                ]
            },
            // close tag
            {
                className: 'tag',
                begin: regex.concat(/<\//, regex.lookahead(regex.concat(TAG_NAME_RE, />/))),
                contains: [
                    {
                        className: 'name',
                        begin: TAG_NAME_RE,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: true
                    }
                ]
            }
        ]
    };
}
module.exports = $64f0220a719f967e$var$xml;

});

parcelRegister("1gF76", function(module, exports) {
/*
Language: YAML
Description: Yet Another Markdown Language
Author: Stefan Wienert <stwienert@gmail.com>
Contributors: Carl Baxter <carl@cbax.tech>
Requires: ruby.js
Website: https://yaml.org
Category: common, config
*/ function $0ec72d5adad507c6$var$yaml(hljs) {
    const LITERALS = 'true false yes no null';
    // YAML spec allows non-reserved URI characters in tags.
    const URI_CHARACTERS = '[\\w#;/?:@&=+$,.~*\'()[\\]]+';
    // Define keys as starting with a word character
    // ...containing word chars, spaces, colons, forward-slashes, hyphens and periods
    // ...and ending with a colon followed immediately by a space, tab or newline.
    // The YAML spec allows for much more than this, but this covers most use-cases.
    const KEY = {
        className: 'attr',
        variants: [
            // added brackets support and special char support
            {
                begin: /[\w*@][\w*@ :()\./-]*:(?=[ \t]|$)/
            },
            {
                begin: /"[\w*@][\w*@ :()\./-]*":(?=[ \t]|$)/
            },
            {
                begin: /'[\w*@][\w*@ :()\./-]*':(?=[ \t]|$)/
            }
        ]
    };
    const TEMPLATE_VARIABLES = {
        className: 'template-variable',
        variants: [
            {
                begin: /\{\{/,
                end: /\}\}/
            },
            {
                begin: /%\{/,
                end: /\}/
            }
        ]
    };
    const SINGLE_QUOTE_STRING = {
        className: 'string',
        relevance: 0,
        begin: /'/,
        end: /'/,
        contains: [
            {
                match: /''/,
                scope: 'char.escape',
                relevance: 0
            }
        ]
    };
    const STRING = {
        className: 'string',
        relevance: 0,
        variants: [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /\S+/
            }
        ],
        contains: [
            hljs.BACKSLASH_ESCAPE,
            TEMPLATE_VARIABLES
        ]
    };
    // Strings inside of value containers (objects) can't contain braces,
    // brackets, or commas
    const CONTAINER_STRING = hljs.inherit(STRING, {
        variants: [
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/,
                        relevance: 0
                    }
                ]
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /[^\s,{}[\]]+/
            }
        ]
    });
    const DATE_RE = '[0-9]{4}(-[0-9][0-9]){0,2}';
    const TIME_RE = '([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?';
    const FRACTION_RE = '(\\.[0-9]*)?';
    const ZONE_RE = '([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?';
    const TIMESTAMP = {
        className: 'number',
        begin: '\\b' + DATE_RE + TIME_RE + FRACTION_RE + ZONE_RE + '\\b'
    };
    const VALUE_CONTAINER = {
        end: ',',
        endsWithParent: true,
        excludeEnd: true,
        keywords: LITERALS,
        relevance: 0
    };
    const OBJECT = {
        begin: /\{/,
        end: /\}/,
        contains: [
            VALUE_CONTAINER
        ],
        illegal: '\\n',
        relevance: 0
    };
    const ARRAY = {
        begin: '\\[',
        end: '\\]',
        contains: [
            VALUE_CONTAINER
        ],
        illegal: '\\n',
        relevance: 0
    };
    const MODES = [
        KEY,
        {
            className: 'meta',
            begin: '^---\\s*$',
            relevance: 10
        },
        {
            // Blocks start with a | or > followed by a newline
            //
            // Indentation of subsequent lines must be the same to
            // be considered part of the block
            className: 'string',
            begin: '[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*'
        },
        {
            begin: '<%[%=-]?',
            end: '[%-]?%>',
            subLanguage: 'ruby',
            excludeBegin: true,
            excludeEnd: true,
            relevance: 0
        },
        {
            className: 'type',
            begin: '!\\w+!' + URI_CHARACTERS
        },
        // https://yaml.org/spec/1.2/spec.html#id2784064
        {
            className: 'type',
            begin: '!<' + URI_CHARACTERS + ">"
        },
        {
            className: 'type',
            begin: '!' + URI_CHARACTERS
        },
        {
            className: 'type',
            begin: '!!' + URI_CHARACTERS
        },
        {
            className: 'meta',
            begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$'
        },
        {
            className: 'meta',
            begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
        },
        {
            className: 'bullet',
            // TODO: remove |$ hack when we have proper look-ahead support
            begin: '-(?=[ ]|$)',
            relevance: 0
        },
        hljs.HASH_COMMENT_MODE,
        {
            beginKeywords: LITERALS,
            keywords: {
                literal: LITERALS
            }
        },
        TIMESTAMP,
        // numbers are any valid C-style number that
        // sit isolated from other words
        {
            className: 'number',
            begin: hljs.C_NUMBER_RE + '\\b',
            relevance: 0
        },
        OBJECT,
        ARRAY,
        SINGLE_QUOTE_STRING,
        STRING
    ];
    const VALUE_MODES = [
        ...MODES
    ];
    VALUE_MODES.pop();
    VALUE_MODES.push(CONTAINER_STRING);
    VALUE_CONTAINER.contains = VALUE_MODES;
    return {
        name: 'YAML',
        case_insensitive: true,
        aliases: [
            'yml'
        ],
        contains: MODES
    };
}
module.exports = $0ec72d5adad507c6$var$yaml;

});


parcelRegister("4Bp2X", function(module, exports) {
/* UAParser.js v2.0.6
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   AGPLv3 License */ ((i, c)=>{
    function A(i) {
        for(var e = {}, t = 0; t < i.length; t++)e[i[t].toUpperCase()] = i[t];
        return e;
    }
    var B = "user-agent", d = "", H = "?", l = {
        FUNCTION: "function",
        OBJECT: "object",
        STRING: "string",
        UNDEFINED: "undefined"
    }, u = "browser", h = "cpu", p = "device", m = "engine", f = "os", g = "result", v = "name", k = "type", x = "vendor", y = "version", C = "architecture", j = "major", E = "model", M = "console", N = "mobile", r = "tablet", e = "smarttv", t = "wearable", V = "xr", P = "embedded", o = "inapp", R = "brands", S = "formFactors", G = "fullVersionList", T = "platform", L = "platformVersion", W = "bitness", a = "sec-ch-ua", $ = a + "-full-version-list", J = a + "-arch", X = a + "-" + W, Y = a + "-form-factors", Z = a + "-" + N, Q = a + "-" + E, K = a + "-" + T, ii = K + "-version", ei = [
        R,
        G,
        N,
        E,
        T,
        L,
        C,
        S,
        W
    ], ti = "Amazon", s = "Apple", oi = "ASUS", ri = "BlackBerry", n = "Google", ai = "Huawei", si = "Lenovo", ni = "Honor", wi = "LG", bi = "Microsoft", di = "Motorola", li = "Nvidia", ci = "OnePlus", ui = "OPPO", hi = "Samsung", pi = "Sony", mi = "Xiaomi", fi = "Zebra", gi = "Chromium", w = "Chromecast", vi = "Edge", ki = "Firefox", b = "Opera", xi = "Facebook", I = "Mobile ", yi = " Browser", Ci = "Windows", Ei = typeof i !== l.UNDEFINED, O = Ei && i.navigator ? i.navigator : c, U = O && O.userAgentData ? O.userAgentData : c, Ni = function(i, e) {
        if (typeof i === l.OBJECT && 0 < i.length) {
            for(var t in i)if (_(e) == _(i[t])) return !0;
            return !1;
        }
        return !!Ti(i) && _(e) == _(i);
    }, Si = function(i, e) {
        for(var t in i)return /^(browser|cpu|device|engine|os)$/.test(t) || !!e && Si(i[t]);
    }, Ti = function(i) {
        return typeof i === l.STRING;
    }, Ii = function(i) {
        if (!i) return c;
        for(var e, t = [], o = D(/\\?\"/g, i).split(","), r = 0; r < o.length; r++)-1 < o[r].indexOf(";") ? (e = _i(o[r]).split(";v="), t[r] = {
            brand: e[0],
            version: e[1]
        }) : t[r] = _i(o[r]);
        return t;
    }, _ = function(i) {
        return Ti(i) ? i.toLowerCase() : i;
    }, Oi = function(i) {
        return Ti(i) ? D(/[^\d\.]/g, i).split(".")[0] : c;
    }, q = function(i) {
        for(var e in i)i.hasOwnProperty(e) && (typeof (e = i[e]) == l.OBJECT && 2 == e.length ? this[e[0]] = e[1] : this[e] = c);
        return this;
    }, D = function(i, e) {
        return Ti(e) ? e.replace(i, d) : e;
    }, Ui = function(i) {
        return D(/\\?\"/g, i);
    }, _i = function(i, e) {
        return i = D(/^\s\s*/, String(i)), typeof e === l.UNDEFINED ? i : i.substring(0, e);
    }, qi = function(i, e) {
        if (i && e) for(var t, o, r, a, s, n = 0; n < e.length && !a;){
            for(var w = e[n], b = e[n + 1], d = t = 0; d < w.length && !a && w[d];)if (a = w[d++].exec(i)) for(o = 0; o < b.length; o++)s = a[++t], typeof (r = b[o]) === l.OBJECT && 0 < r.length ? 2 === r.length ? typeof r[1] == l.FUNCTION ? this[r[0]] = r[1].call(this, s) : this[r[0]] = r[1] : 3 <= r.length && (typeof r[1] !== l.FUNCTION || r[1].exec && r[1].test ? 3 == r.length ? this[r[0]] = s ? s.replace(r[1], r[2]) : c : 4 == r.length ? this[r[0]] = s ? r[3].call(this, s.replace(r[1], r[2])) : c : 4 < r.length && (this[r[0]] = s ? r[3].apply(this, [
                s.replace(r[1], r[2])
            ].concat(r.slice(4))) : c) : 3 < r.length ? this[r[0]] = s ? r[1].apply(this, r.slice(2)) : c : this[r[0]] = s ? r[1].call(this, s, r[2]) : c) : this[r] = s || c;
            n += 2;
        }
    }, z = function(i, e) {
        for(var t in e)if (typeof e[t] === l.OBJECT && 0 < e[t].length) {
            for(var o = 0; o < e[t].length; o++)if (Ni(e[t][o], i)) return t === H ? c : t;
        } else if (Ni(e[t], i)) return t === H ? c : t;
        return e.hasOwnProperty("*") ? e["*"] : i;
    }, Di = {
        ME: "4.90",
        "NT 3.51": "3.51",
        "NT 4.0": "4.0",
        2e3: [
            "5.0",
            "5.01"
        ],
        XP: [
            "5.1",
            "5.2"
        ],
        Vista: "6.0",
        7: "6.1",
        8: "6.2",
        8.1: "6.3",
        10: [
            "6.4",
            "10.0"
        ],
        NT: ""
    }, zi = {
        embedded: "Automotive",
        mobile: "Mobile",
        tablet: [
            "Tablet",
            "EInk"
        ],
        smarttv: "TV",
        wearable: "Watch",
        xr: [
            "VR",
            "XR"
        ],
        "?": [
            "Desktop",
            "Unknown"
        ],
        "*": c
    }, Fi = {
        Chrome: "Google Chrome",
        Edge: "Microsoft Edge",
        "Edge WebView2": "Microsoft Edge WebView2",
        "Chrome WebView": "Android WebView",
        "Chrome Headless": "HeadlessChrome",
        "Huawei Browser": "HuaweiBrowser",
        "MIUI Browser": "Miui Browser",
        "Opera Mobi": "OperaMobile",
        Yandex: "YaBrowser"
    }, Ai = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    I + "Chrome"
                ]
            ],
            [
                /webview.+edge\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    vi + " WebView"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                y,
                [
                    v,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser|palemoon)\/([-\w\.]+)/i,
                /(heytap|ovi|115|surf|qwant)browser\/([\d\.]+)/i,
                /(qwant)(?:ios|mobile)\/([\d\.]+)/i,
                /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "UCBrowser"
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                y,
                [
                    v,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Smart " + si + yi
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1 Secure" + yi
                ],
                y
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    ki + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    b + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "MIUI" + yi
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                y,
                [
                    v,
                    I + ki
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                y,
                [
                    v,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1Browser"
                ],
                y
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1" + yi
                ],
                y
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    hi + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    v,
                    "Sogou Mobile"
                ],
                y
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /(lbbrowser|rekonq)/i
            ],
            [
                v
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                y,
                v
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    v,
                    xi
                ],
                y,
                [
                    k,
                    o
                ]
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(bing)(?:web|sapphire)\/([\w\.]+)/i,
                /(instagram|snapchat|klarna)[\/ ]([-\w\.]+)/i
            ],
            [
                v,
                y,
                [
                    k,
                    o
                ]
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                y,
                [
                    v,
                    "GSA"
                ],
                [
                    k,
                    o
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "TikTok"
                ],
                [
                    k,
                    o
                ]
            ],
            [
                /\[(linkedin)app\]/i
            ],
            [
                v,
                [
                    k,
                    o
                ]
            ],
            [
                /(zalo(?:app)?)[\/\sa-z]*([\w\.-]+)/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "Zalo"
                ],
                y,
                [
                    k,
                    o
                ]
            ],
            [
                /(chromium)[\/ ]([-\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                y,
                [
                    v,
                    "Chrome Headless"
                ]
            ],
            [
                /wv\).+chrome\/([\w\.]+).+edgw\//i
            ],
            [
                y,
                [
                    v,
                    vi + " WebView2"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    v,
                    "Chrome WebView"
                ],
                y
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                y,
                [
                    v,
                    "Android" + yi
                ]
            ],
            [
                /chrome\/([\w\.]+) mobile/i
            ],
            [
                y,
                [
                    v,
                    I + "Chrome"
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
            ],
            [
                y,
                [
                    v,
                    I + "Safari"
                ]
            ],
            [
                /iphone .*mobile(?:\/\w+ | ?)safari/i
            ],
            [
                [
                    v,
                    I + "Safari"
                ]
            ],
            [
                /version\/([\w\.\,]+) .*(safari)/i
            ],
            [
                y,
                v
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                v,
                [
                    y,
                    "1"
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
            ],
            [
                [
                    v,
                    I + ki
                ],
                y
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    v,
                    "Netscape"
                ],
                y
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                y,
                [
                    v,
                    ki + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+(?= .+rv\:.+gecko\/\d+)|[0-4][\w\.]+(?!.+compatible))/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                v,
                [
                    y,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                v,
                [
                    y,
                    /[^\d\.]+./,
                    d
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    C,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    C,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    C,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    C,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    C,
                    "arm"
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    C,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i,
                /((ppc|powerpc)(64)?)( mac|;|\))/i,
                /(?:osf1|[freopnt]{3,4}bsd) (alpha)/i
            ],
            [
                [
                    C,
                    /ower/,
                    d,
                    _
                ]
            ],
            [
                /mc680.0/i
            ],
            [
                [
                    C,
                    "68k"
                ]
            ],
            [
                /winnt.+\[axp/i
            ],
            [
                [
                    C,
                    "alpha"
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                E,
                [
                    x,
                    hi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr]|browser)[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                E,
                [
                    x,
                    hi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)[\/\);]/i
            ],
            [
                E,
                [
                    x,
                    s
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b(?:ios|apple\w+)\/.+[\(\/](ipad)/i,
                /\b(ipad)[\d,]*[;\] ].+(mac |i(pad)?)os/i
            ],
            [
                E,
                [
                    x,
                    s
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                E,
                [
                    x,
                    s
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                E,
                [
                    x,
                    "Sharp"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                E,
                [
                    x,
                    ni
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                E,
                [
                    x,
                    ni
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                E,
                [
                    x,
                    ai
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(?:huawei) ?([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][\dc][adnt]?)\b(?!.+d\/s)/i
            ],
            [
                E,
                [
                    x,
                    ai
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b(?:xiao)?((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    E,
                    /_/g,
                    " "
                ],
                [
                    x,
                    mi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note|max|cc)?[_ ]?(?:\d{0,2}\w?)[_ ]?(?:plus|se|lite|pro)?( 5g|lte)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    E,
                    /_/g,
                    " "
                ],
                [
                    x,
                    mi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /droid.+; (cph2[3-6]\d[13579]|((gm|hd)19|(ac|be|in|kb)20|(d[en]|eb|le|mt)21|ne22)[0-2]\d|p[g-k]\w[1m]10)\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                E,
                [
                    x,
                    ci
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                E,
                [
                    x,
                    ui
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                E,
                [
                    x,
                    z,
                    {
                        OnePlus: [
                            "203",
                            "304",
                            "403",
                            "404",
                            "413",
                            "415"
                        ],
                        "*": ui
                    }
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i
            ],
            [
                E,
                [
                    x,
                    "BLU"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                E,
                [
                    x,
                    "Vivo"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                E,
                [
                    x,
                    "Realme"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                E,
                [
                    x,
                    si
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /lenovo[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i
            ],
            [
                E,
                [
                    x,
                    si
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ]([\w\s]+)(\)| bui)/i,
                /((?:moto(?! 360)[-\w\(\) ]+|xt\d{3,4}[cgkosw\+]?[-\d]*|nexus 6)(?= bui|\)))/i
            ],
            [
                E,
                [
                    x,
                    di
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                E,
                [
                    x,
                    di
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                E,
                [
                    x,
                    wi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch|webos))(\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                E,
                [
                    x,
                    wi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                x,
                E,
                [
                    k,
                    r
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*?))( bui|\)|;|\/)/i
            ],
            [
                [
                    E,
                    /_/g,
                    " "
                ],
                [
                    k,
                    N
                ],
                [
                    x,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                E,
                [
                    x,
                    n
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid.+;(?: google)? (g(01[13]a|020[aem]|025[jn]|1b60|1f8f|2ybb|4s1m|576d|5nz6|8hhn|8vou|a02099|c15s|d1yq|e2ae|ec77|gh2x|kv4x|p4bc|pj41|r83y|tt9q|ur25|wvk6)|pixel[\d ]*a?( pro)?( xl)?( fold)?( \(5g\))?)( bui|\))/i
            ],
            [
                E,
                [
                    x,
                    n
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(google) (pixelbook( go)?)/i
            ],
            [
                x,
                E
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-\w\w\d\d)(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                E,
                [
                    x,
                    pi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    E,
                    "Xperia Tablet"
                ],
                [
                    x,
                    pi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                E,
                [
                    x,
                    ti
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    E,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    x,
                    ti
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                E,
                x,
                [
                    k,
                    r
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /(?:blackberry|\(bb10;) (\w+)/i
            ],
            [
                E,
                [
                    x,
                    ri
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                E,
                [
                    x,
                    oi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                E,
                [
                    x,
                    oi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                E,
                [
                    x,
                    "HTC"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                x,
                [
                    E,
                    /_/g,
                    " "
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /tcl (xess p17aa)/i,
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
            ],
            [
                E,
                [
                    x,
                    "TCL"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
            ],
            [
                E,
                [
                    x,
                    "TCL"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    x,
                    _
                ],
                E,
                [
                    k,
                    z,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                E,
                [
                    x,
                    "Acer"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                E,
                [
                    x,
                    "Meizu"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                E,
                [
                    x,
                    "Ulefone"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                E,
                [
                    x,
                    "Energizer"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                E,
                [
                    x,
                    "Cat"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                E,
                [
                    x,
                    "Smartfren"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /droid.+; (a(in)?(0(15|59|6[35])|142)p?)/i
            ],
            [
                E,
                [
                    x,
                    "Nothing"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                E,
                [
                    x,
                    "Archos"
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                E,
                [
                    x,
                    "Archos"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /; (n159v)/i
            ],
            [
                E,
                [
                    x,
                    "HMD"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix|tecno) (x1101b?|p904|dp(7c|8d|10a)( pro)?|p70[1-3]a?|p904|t1101)/i
            ],
            [
                x,
                E,
                [
                    k,
                    r
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (blu|hmd|imo|infinix|lava|oneplus|tcl|wiko)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(oppo) ?([\w ]+) bui/i,
                /(hisense) ([ehv][\w ]+)\)/i,
                /droid[^;]+; (philips)[_ ]([sv-x][\d]{3,4}[xz]?)/i
            ],
            [
                x,
                E,
                [
                    k,
                    N
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i
            ],
            [
                x,
                E,
                [
                    k,
                    r
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                E,
                [
                    x,
                    bi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                E,
                [
                    x,
                    "Fairphone"
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                E,
                [
                    x,
                    li
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                x,
                E,
                [
                    k,
                    N
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    E,
                    /\./g,
                    " "
                ],
                [
                    x,
                    bi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                E,
                [
                    x,
                    fi
                ],
                [
                    k,
                    r
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                E,
                [
                    x,
                    fi
                ],
                [
                    k,
                    N
                ]
            ],
            [
                /(philips)[\w ]+tv/i,
                /smart-tv.+(samsung)/i
            ],
            [
                x,
                [
                    k,
                    e
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    E,
                    /^/,
                    "SmartTV"
                ],
                [
                    x,
                    hi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(vizio)(?: |.+model\/)(\w+-\w+)/i,
                /tcast.+(lg)e?. ([-\w]+)/i
            ],
            [
                x,
                E,
                [
                    k,
                    e
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    x,
                    wi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                x,
                [
                    E,
                    s + " TV"
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /crkey.*devicetype\/chromecast/i
            ],
            [
                [
                    E,
                    w + " Third Generation"
                ],
                [
                    x,
                    n
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /crkey.*devicetype\/([^/]*)/i
            ],
            [
                [
                    E,
                    /^/,
                    "Chromecast "
                ],
                [
                    x,
                    n
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /fuchsia.*crkey/i
            ],
            [
                [
                    E,
                    w + " Nest Hub"
                ],
                [
                    x,
                    n
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    E,
                    w
                ],
                [
                    x,
                    n
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(portaltv)/i
            ],
            [
                E,
                [
                    x,
                    xi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                E,
                [
                    x,
                    ti
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                E,
                [
                    x,
                    li
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                E,
                [
                    x,
                    "Sharp"
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                E,
                [
                    x,
                    pi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                E,
                [
                    x,
                    mi
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                x,
                E,
                [
                    k,
                    e
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    x,
                    /.+\/(\w+)/,
                    "$1",
                    z,
                    {
                        LG: "lge"
                    }
                ],
                [
                    E,
                    _i
                ],
                [
                    k,
                    e
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                E,
                [
                    x,
                    pi
                ],
                [
                    k,
                    M
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                E,
                [
                    x,
                    bi
                ],
                [
                    k,
                    M
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) (\w+)/i,
                /(retroid) (pocket ([^\)]+))/i
            ],
            [
                x,
                E,
                [
                    k,
                    M
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                E,
                [
                    x,
                    li
                ],
                [
                    k,
                    M
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                E,
                [
                    x,
                    hi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                x,
                E,
                [
                    k,
                    t
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                E,
                [
                    x,
                    ui
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                E,
                [
                    x,
                    s
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                E,
                [
                    x,
                    ci
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                E,
                [
                    x,
                    di
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                E,
                [
                    x,
                    pi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                E,
                [
                    x,
                    wi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                E,
                [
                    x,
                    fi
                ],
                [
                    k,
                    t
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                E,
                [
                    x,
                    n
                ],
                [
                    k,
                    V
                ]
            ],
            [
                /(pico) ([\w ]+) os\d/i
            ],
            [
                x,
                E,
                [
                    k,
                    V
                ]
            ],
            [
                /(quest( \d| pro)?s?).+vr/i
            ],
            [
                E,
                [
                    x,
                    xi
                ],
                [
                    k,
                    V
                ]
            ],
            [
                /mobile vr; rv.+firefox/i
            ],
            [
                [
                    k,
                    V
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                x,
                [
                    k,
                    P
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                E,
                [
                    x,
                    ti
                ],
                [
                    k,
                    P
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                E,
                [
                    x,
                    s
                ],
                [
                    k,
                    P
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    k,
                    P
                ]
            ],
            [
                /droid.+; ([\w- ]+) (4k|android|smart|google)[- ]?tv/i
            ],
            [
                E,
                [
                    k,
                    e
                ]
            ],
            [
                /\b((4k|android|smart|opera)[- ]?tv|tv; rv:|large screen[\w ]+safari)\b/i
            ],
            [
                [
                    k,
                    e
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew|; hmsc).+?(mobile|vr|\d) safari/i
            ],
            [
                E,
                [
                    k,
                    z,
                    {
                        mobile: "Mobile",
                        xr: "VR",
                        "*": r
                    }
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    k,
                    r
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    k,
                    N
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                E,
                [
                    x,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    vi + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                v,
                y
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                v,
                y
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    v,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                y,
                v
            ]
        ],
        os: [
            [
                /(windows nt) (6\.[23]); arm/i
            ],
            [
                [
                    v,
                    /N/,
                    "R"
                ],
                [
                    y,
                    z,
                    Di
                ]
            ],
            [
                /(windows (?:phone|mobile|iot))(?: os)?[\/ ]?([\d\.]*( se)?)/i,
                /(windows)[\/ ](1[01]|2000|3\.1|7|8(\.1)?|9[58]|me|server 20\d\d( r2)?|vista|xp)/i
            ],
            [
                v,
                y
            ],
            [
                /windows nt ?([\d\.\)]*)(?!.+xbox)/i,
                /\bwin(?=3| ?9|n)(?:nt| 9x )?([\d\.;]*)/i
            ],
            [
                [
                    y,
                    /(;|\))/g,
                    "",
                    z,
                    Di
                ],
                [
                    v,
                    Ci
                ]
            ],
            [
                /(windows ce)\/?([\d\.]*)/i
            ],
            [
                v,
                y
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv|ios(?=.+ip(?:ad|hone))|ip(?:ad|hone)(?: |.+i(?:pad)?)os)[\/ ]([\w\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    y,
                    /_/g,
                    "."
                ],
                [
                    v,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+(haiku|morphos))/i
            ],
            [
                [
                    v,
                    "macOS"
                ],
                [
                    y,
                    /_/g,
                    "."
                ]
            ],
            [
                /android ([\d\.]+).*crkey/i
            ],
            [
                y,
                [
                    v,
                    w + " Android"
                ]
            ],
            [
                /fuchsia.*crkey\/([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    w + " Fuchsia"
                ]
            ],
            [
                /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
            ],
            [
                y,
                [
                    v,
                    w + " SmartSpeaker"
                ]
            ],
            [
                /linux.*crkey\/([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    w + " Linux"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    w
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86)/i
            ],
            [
                y,
                v
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    v,
                    /(.+)/,
                    "$1 Touch"
                ],
                y
            ],
            [
                /(harmonyos)[\/ ]?([\d\.]*)/i,
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen)\w*[-\/\.; ]?([\d\.]*)/i
            ],
            [
                v,
                y
            ],
            [
                /\(bb(10);/i
            ],
            [
                y,
                [
                    v,
                    ri
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                y,
                [
                    v,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                y,
                [
                    v,
                    ki + " OS"
                ]
            ],
            [
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i,
                /webos(?:[ \/]?|\.tv-20(?=2[2-9]))(\d[\d\.]*)/i
            ],
            [
                y,
                [
                    v,
                    "webOS"
                ]
            ],
            [
                /web0s;.+?(?:chr[o0]me|safari)\/(\d+)/i
            ],
            [
                [
                    y,
                    z,
                    {
                        25: "120",
                        24: "108",
                        23: "94",
                        22: "87",
                        6: "79",
                        5: "68",
                        4: "53",
                        3: "38",
                        2: "538",
                        1: "537",
                        "*": "TV"
                    }
                ],
                [
                    v,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                y,
                [
                    v,
                    "watchOS"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    v,
                    "Chrome OS"
                ],
                y
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) (\w+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /(pico) .+os([\w\.]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /linux.+(mint)[\/\(\) ]?([\w\.]*)/i,
                /(mageia|vectorlinux|fuchsia|arcaos|arch(?= ?linux))[;l ]([\d\.]*)/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire|knoppix)(?: gnu[\/ ]linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /\b(aix)[; ]([1-9\.]{0,4})/i,
                /(hurd|linux|morphos)(?: (?:arm|x86|ppc)\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) ?(r\d)?/i
            ],
            [
                v,
                y
            ],
            [
                /(sunos) ?([\d\.]*)/i
            ],
            [
                [
                    v,
                    "Solaris"
                ],
                y
            ],
            [
                /\b(beos|os\/2|amigaos|openvms|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                v,
                y
            ]
        ]
    }, Bi = (b = {
        init: {},
        isIgnore: {},
        isIgnoreRgx: {},
        toString: {}
    }, q.call(b.init, [
        [
            u,
            [
                v,
                y,
                j,
                k
            ]
        ],
        [
            h,
            [
                C
            ]
        ],
        [
            p,
            [
                k,
                E,
                x
            ]
        ],
        [
            m,
            [
                v,
                y
            ]
        ],
        [
            f,
            [
                v,
                y
            ]
        ]
    ]), q.call(b.isIgnore, [
        [
            u,
            [
                y,
                j
            ]
        ],
        [
            m,
            [
                y
            ]
        ],
        [
            f,
            [
                y
            ]
        ]
    ]), q.call(b.isIgnoreRgx, [
        [
            u,
            / ?browser$/i
        ],
        [
            f,
            / ?os$/i
        ]
    ]), q.call(b.toString, [
        [
            u,
            [
                v,
                y
            ]
        ],
        [
            h,
            [
                C
            ]
        ],
        [
            p,
            [
                x,
                E
            ]
        ],
        [
            m,
            [
                v,
                y
            ]
        ],
        [
            f,
            [
                v,
                y
            ]
        ]
    ]), b), Hi = function(e, i) {
        var t = Bi.init[i], o = Bi.isIgnore[i] || 0, r = Bi.isIgnoreRgx[i] || 0, a = Bi.toString[i] || 0;
        function s() {
            q.call(this, t);
        }
        return s.prototype.getItem = function() {
            return e;
        }, s.prototype.withClientHints = function() {
            return U ? U.getHighEntropyValues(ei).then(function(i) {
                return e.setCH(new ji(i, !1)).parseCH().get();
            }) : e.parseCH().get();
        }, s.prototype.withFeatureCheck = function() {
            return e.detectFeature().get();
        }, i != g && (s.prototype.is = function(i) {
            var e, t = !1;
            for(e in this)if (this.hasOwnProperty(e) && !Ni(o, e) && _(r ? D(r, this[e]) : this[e]) == _(r ? D(r, i) : i)) {
                if (t = !0, i != l.UNDEFINED) break;
            } else if (i == l.UNDEFINED && t) {
                t = !t;
                break;
            }
            return t;
        }, s.prototype.toString = function() {
            var i, e = d;
            for(i in a)typeof this[a[i]] !== l.UNDEFINED && (e += (e ? " " : d) + this[a[i]]);
            return e || l.UNDEFINED;
        }), U || (s.prototype.then = function(i) {
            function e() {
                for(var i in t)t.hasOwnProperty(i) && (this[i] = t[i]);
            }
            var t = this, o = (e.prototype = {
                is: s.prototype.is,
                toString: s.prototype.toString
            }, new e);
            return i(o), o;
        }), new s;
    };
    function ji(i, e) {
        if (i = i || {}, q.call(this, ei), e) q.call(this, [
            [
                R,
                Ii(i[a])
            ],
            [
                G,
                Ii(i[$])
            ],
            [
                N,
                /\?1/.test(i[Z])
            ],
            [
                E,
                Ui(i[Q])
            ],
            [
                T,
                Ui(i[K])
            ],
            [
                L,
                Ui(i[ii])
            ],
            [
                C,
                Ui(i[J])
            ],
            [
                S,
                Ii(i[Y])
            ],
            [
                W,
                Ui(i[X])
            ]
        ]);
        else for(var t in i)this.hasOwnProperty(t) && typeof i[t] !== l.UNDEFINED && (this[t] = i[t]);
    }
    function Mi(i, e, t, o) {
        return this.get = function(i) {
            return i ? this.data.hasOwnProperty(i) ? this.data[i] : c : this.data;
        }, this.set = function(i, e) {
            return this.data[i] = e, this;
        }, this.setCH = function(i) {
            return this.uaCH = i, this;
        }, this.detectFeature = function() {
            if (O && O.userAgent == this.ua) switch(this.itemType){
                case u:
                    O.brave && typeof O.brave.isBrave == l.FUNCTION && this.set(v, "Brave");
                    break;
                case p:
                    !this.get(k) && U && U[N] && this.set(k, N), "Macintosh" == this.get(E) && O && typeof O.standalone !== l.UNDEFINED && O.maxTouchPoints && 2 < O.maxTouchPoints && this.set(E, "iPad").set(k, r);
                    break;
                case f:
                    !this.get(v) && U && U[T] && this.set(v, U[T]);
                    break;
                case g:
                    var e = this.data, i = function(i) {
                        return e[i].getItem().detectFeature().get();
                    };
                    this.set(u, i(u)).set(h, i(h)).set(p, i(p)).set(m, i(m)).set(f, i(f));
            }
            return this;
        }, this.parseUA = function() {
            switch(this.itemType != g && qi.call(this.data, this.ua, this.rgxMap), this.itemType){
                case u:
                    this.set(j, Oi(this.get(y)));
                    break;
                case f:
                    var i;
                    "iOS" == this.get(v) && "18.6" == this.get(y) && (i = /\) Version\/([\d\.]+)/.exec(this.ua)) && 26 <= parseInt(i[1].substring(0, 2), 10) && this.set(y, i[1]);
            }
            return this;
        }, this.parseCH = function() {
            var i, e = this.uaCH, t = this.rgxMap;
            switch(this.itemType){
                case u:
                case m:
                    var o, r = e[G] || e[R];
                    if (r) for(var a = 0; a < r.length; a++){
                        var s = r[a].brand || r[a], n = r[a].version;
                        this.itemType == u && !/not.a.brand/i.test(s) && (!o || /Chrom/.test(o) && s != gi || o == vi && /WebView2/.test(s)) && (s = z(s, Fi), (o = this.get(v)) && !/Chrom/.test(o) && /Chrom/.test(s) || this.set(v, s).set(y, n).set(j, Oi(n)), o = s), this.itemType == m && s == gi && this.set(y, n);
                    }
                    break;
                case h:
                    var w = e[C];
                    w && ("64" == e[W] && (w += "64"), qi.call(this.data, w + ";", t));
                    break;
                case p:
                    if (e[N] && this.set(k, N), e[E] && (this.set(E, e[E]), this.get(k) && this.get(x) || (qi.call(w = {}, "droid 9; " + e[E] + ")", t), !this.get(k) && w.type && this.set(k, w.type), !this.get(x) && w.vendor && this.set(x, w.vendor))), e[S]) {
                        if ("string" != typeof e[S]) for(var b = 0; !i && b < e[S].length;)i = z(e[S][b++], zi);
                        else i = z(e[S], zi);
                        this.set(k, i);
                    }
                    break;
                case f:
                    var d, w = e[T];
                    w && (d = e[L], w == Ci && (d = 13 <= parseInt(Oi(d), 10) ? "11" : "10"), this.set(v, w).set(y, d)), this.get(v) == Ci && "Xbox" == e[E] && this.set(v, "Xbox").set(y, c);
                    break;
                case g:
                    var l = this.data, w = function(i) {
                        return l[i].getItem().setCH(e).parseCH().get();
                    };
                    this.set(u, w(u)).set(h, w(h)).set(p, w(p)).set(m, w(m)).set(f, w(f));
            }
            return this;
        }, q.call(this, [
            [
                "itemType",
                i
            ],
            [
                "ua",
                e
            ],
            [
                "uaCH",
                o
            ],
            [
                "rgxMap",
                t
            ],
            [
                "data",
                Hi(this, i)
            ]
        ]), this;
    }
    function F(i, e, t) {
        if (typeof i === l.OBJECT ? (e = Si(i, !0) ? (typeof e === l.OBJECT && (t = e), i) : (t = i, c), i = c) : typeof i !== l.STRING || Si(e, !0) || (t = e, e = c), t) {
            if (typeof t.append === l.FUNCTION) {
                var o = {};
                t.forEach(function(i, e) {
                    o[String(e).toLowerCase()] = i;
                }), t = o;
            } else {
                var r, a = {};
                for(r in t)t.hasOwnProperty(r) && (a[String(r).toLowerCase()] = t[r]);
                t = a;
            }
        }
        var s, n, w, b;
        return this instanceof F ? (s = typeof i === l.STRING ? i : t && t[B] ? t[B] : O && O.userAgent ? O.userAgent : d, n = new ji(t, !0), w = e ? ((i, e)=>{
            var t, o = {}, r = e;
            if (!Si(e)) for(var a in r = {}, e)for(var s in e[a])r[s] = e[a][s].concat(r[s] || []);
            for(t in i)o[t] = r[t] && r[t].length % 2 == 0 ? r[t].concat(i[t]) : i[t];
            return o;
        })(Ai, e) : Ai, q.call(this, [
            [
                "getBrowser",
                (b = function(i) {
                    return i == g ? function() {
                        return new Mi(i, s, w, n).set("ua", s).set(u, this.getBrowser()).set(h, this.getCPU()).set(p, this.getDevice()).set(m, this.getEngine()).set(f, this.getOS()).get();
                    } : function() {
                        return new Mi(i, s, w[i], n).parseUA().get();
                    };
                })(u)
            ],
            [
                "getCPU",
                b(h)
            ],
            [
                "getDevice",
                b(p)
            ],
            [
                "getEngine",
                b(m)
            ],
            [
                "getOS",
                b(f)
            ],
            [
                "getResult",
                b(g)
            ],
            [
                "getUA",
                function() {
                    return s;
                }
            ],
            [
                "setUA",
                function(i) {
                    return Ti(i) && (s = _i(i, 500)), this;
                }
            ]
        ]).setUA(s), this) : new F(i, e, t).getResult();
    }
    F.VERSION = "2.0.6", F.BROWSER = A([
        v,
        y,
        j,
        k
    ]), F.CPU = A([
        C
    ]), F.DEVICE = A([
        E,
        x,
        k,
        M,
        N,
        e,
        r,
        t,
        P
    ]), F.ENGINE = F.OS = A([
        v,
        y
    ]), "object" !== l.UNDEFINED ? (exports = "object" !== l.UNDEFINED && module.exports ? module.exports = F : exports).UAParser = F : typeof define === l.FUNCTION && define.amd ? define(function() {
        return F;
    }) : Ei && (i.UAParser = F);
    var Vi, Pi = Ei && (i.jQuery || i.Zepto);
    Pi && !Pi.ua && (Vi = new F, Pi.ua = Vi.getResult(), Pi.ua.get = function() {
        return Vi.getUA();
    }, Pi.ua.set = function(i) {
        Vi.setUA(i);
        var e, t = Vi.getResult();
        for(e in t)Pi.ua[e] = t[e];
    });
})("object" == typeof window ? window : this);

});

parcelRegister("6DjHV", function(module, exports) {

$parcel$export(module.exports, "logs", function () { return $4d45ac1ac689e5a1$export$fa0831f497706bad; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aP5EA = parcelRequire("aP5EA");

var $lw0nH = parcelRequire("lw0nH");


var $769FG = parcelRequire("769FG");
const $4d45ac1ac689e5a1$export$fa0831f497706bad = (0, $769FG.LogsAPI).getInstance();

});
parcelRegister("aP5EA", function(module, exports) {

$parcel$export(module.exports, "SeverityNumber", function () { return $7e130d7f0e9b4bb7$export$2428dbfc7b74cb49; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7e130d7f0e9b4bb7$export$2428dbfc7b74cb49;
(function(SeverityNumber) {
    SeverityNumber[SeverityNumber["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SeverityNumber[SeverityNumber["TRACE"] = 1] = "TRACE";
    SeverityNumber[SeverityNumber["TRACE2"] = 2] = "TRACE2";
    SeverityNumber[SeverityNumber["TRACE3"] = 3] = "TRACE3";
    SeverityNumber[SeverityNumber["TRACE4"] = 4] = "TRACE4";
    SeverityNumber[SeverityNumber["DEBUG"] = 5] = "DEBUG";
    SeverityNumber[SeverityNumber["DEBUG2"] = 6] = "DEBUG2";
    SeverityNumber[SeverityNumber["DEBUG3"] = 7] = "DEBUG3";
    SeverityNumber[SeverityNumber["DEBUG4"] = 8] = "DEBUG4";
    SeverityNumber[SeverityNumber["INFO"] = 9] = "INFO";
    SeverityNumber[SeverityNumber["INFO2"] = 10] = "INFO2";
    SeverityNumber[SeverityNumber["INFO3"] = 11] = "INFO3";
    SeverityNumber[SeverityNumber["INFO4"] = 12] = "INFO4";
    SeverityNumber[SeverityNumber["WARN"] = 13] = "WARN";
    SeverityNumber[SeverityNumber["WARN2"] = 14] = "WARN2";
    SeverityNumber[SeverityNumber["WARN3"] = 15] = "WARN3";
    SeverityNumber[SeverityNumber["WARN4"] = 16] = "WARN4";
    SeverityNumber[SeverityNumber["ERROR"] = 17] = "ERROR";
    SeverityNumber[SeverityNumber["ERROR2"] = 18] = "ERROR2";
    SeverityNumber[SeverityNumber["ERROR3"] = 19] = "ERROR3";
    SeverityNumber[SeverityNumber["ERROR4"] = 20] = "ERROR4";
    SeverityNumber[SeverityNumber["FATAL"] = 21] = "FATAL";
    SeverityNumber[SeverityNumber["FATAL2"] = 22] = "FATAL2";
    SeverityNumber[SeverityNumber["FATAL3"] = 23] = "FATAL3";
    SeverityNumber[SeverityNumber["FATAL4"] = 24] = "FATAL4";
})($7e130d7f0e9b4bb7$export$2428dbfc7b74cb49 || ($7e130d7f0e9b4bb7$export$2428dbfc7b74cb49 = {}));

});

parcelRegister("lw0nH", function(module, exports) {

$parcel$export(module.exports, "NoopLogger", function () { return $fa9ce1d0c2c0d54f$export$d16ba98760c74dd5; });
$parcel$export(module.exports, "NOOP_LOGGER", function () { return $fa9ce1d0c2c0d54f$export$f5681b99b7ff4eb3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fa9ce1d0c2c0d54f$export$d16ba98760c74dd5 {
    emit(_logRecord) {}
}
const $fa9ce1d0c2c0d54f$export$f5681b99b7ff4eb3 = new $fa9ce1d0c2c0d54f$export$d16ba98760c74dd5();

});

parcelRegister("769FG", function(module, exports) {

$parcel$export(module.exports, "LogsAPI", function () { return $52b09877f74f4c06$export$f8e63508eb6a0fc1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gI5vs = parcelRequire("gI5vs");

var $4LsWC = parcelRequire("4LsWC");

var $27Kqg = parcelRequire("27Kqg");
class $52b09877f74f4c06$export$f8e63508eb6a0fc1 {
    constructor(){
        this._proxyLoggerProvider = new (0, $27Kqg.ProxyLoggerProvider)();
    }
    static getInstance() {
        if (!this._instance) this._instance = new $52b09877f74f4c06$export$f8e63508eb6a0fc1();
        return this._instance;
    }
    setGlobalLoggerProvider(provider) {
        if ((0, $gI5vs._global)[0, $gI5vs.GLOBAL_LOGS_API_KEY]) return this.getLoggerProvider();
        (0, $gI5vs._global)[0, $gI5vs.GLOBAL_LOGS_API_KEY] = (0, $gI5vs.makeGetter)((0, $gI5vs.API_BACKWARDS_COMPATIBILITY_VERSION), provider, (0, $4LsWC.NOOP_LOGGER_PROVIDER));
        this._proxyLoggerProvider._setDelegate(provider);
        return provider;
    }
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ getLoggerProvider() {
        var _a, _b;
        return (_b = (_a = (0, $gI5vs._global)[0, $gI5vs.GLOBAL_LOGS_API_KEY]) === null || _a === void 0 ? void 0 : _a.call((0, $gI5vs._global), (0, $gI5vs.API_BACKWARDS_COMPATIBILITY_VERSION))) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    }
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ getLogger(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    }
    /** Remove the global logger provider */ disable() {
        delete (0, $gI5vs._global)[0, $gI5vs.GLOBAL_LOGS_API_KEY];
        this._proxyLoggerProvider = new (0, $27Kqg.ProxyLoggerProvider)();
    }
}

});
parcelRegister("gI5vs", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_LOGS_API_KEY", function () { return $c2a506d5d6611049$export$be5e405504011951; });
$parcel$export(module.exports, "_global", function () { return $c2a506d5d6611049$export$fb1208122242c205; });
$parcel$export(module.exports, "makeGetter", function () { return $c2a506d5d6611049$export$bf9e00ce1090794f; });
$parcel$export(module.exports, "API_BACKWARDS_COMPATIBILITY_VERSION", function () { return $c2a506d5d6611049$export$41e8763f7160bb4; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $388Ah = parcelRequire("388Ah");
const $c2a506d5d6611049$export$be5e405504011951 = Symbol.for('io.opentelemetry.js.api.logs');
const $c2a506d5d6611049$export$fb1208122242c205 = (0, $388Ah._globalThis);
function $c2a506d5d6611049$export$bf9e00ce1090794f(requiredVersion, instance, fallback) {
    return (version)=>version === requiredVersion ? instance : fallback;
}
const $c2a506d5d6611049$export$41e8763f7160bb4 = 1;

});
parcelRegister("388Ah", function(module, exports) {

$parcel$export(module.exports, "_globalThis", function () { return $2478c71496c63752$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line n/no-unsupported-features/es-builtins, no-undef
const $2478c71496c63752$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});


parcelRegister("4LsWC", function(module, exports) {

$parcel$export(module.exports, "NOOP_LOGGER_PROVIDER", function () { return $378200fbef206656$export$ade97358fd6ba8df; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lw0nH = parcelRequire("lw0nH");
class $378200fbef206656$export$8d7f6fb42e615208 {
    getLogger(_name, _version, _options) {
        return new (0, $lw0nH.NoopLogger)();
    }
}
const $378200fbef206656$export$ade97358fd6ba8df = new $378200fbef206656$export$8d7f6fb42e615208();

});

parcelRegister("27Kqg", function(module, exports) {

$parcel$export(module.exports, "ProxyLoggerProvider", function () { return $18c03ec39f0f2e97$export$f72276fc3bc2aaa4; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4LsWC = parcelRequire("4LsWC");

var $iV7HL = parcelRequire("iV7HL");
class $18c03ec39f0f2e97$export$f72276fc3bc2aaa4 {
    getLogger(name, version, options) {
        var _a;
        return (_a = this._getDelegateLogger(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $iV7HL.ProxyLogger)(this, name, version, options);
    }
    /**
     * Get the delegate logger provider.
     * Used by tests only.
     * @internal
     */ _getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : (0, $4LsWC.NOOP_LOGGER_PROVIDER);
    }
    /**
     * Set the delegate logger provider
     * @internal
     */ _setDelegate(delegate) {
        this._delegate = delegate;
    }
    /**
     * @internal
     */ _getDelegateLogger(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getLogger(name, version, options);
    }
}

});
parcelRegister("iV7HL", function(module, exports) {

$parcel$export(module.exports, "ProxyLogger", function () { return $dc6386e768cb261e$export$ed6b4cba4dd55d4b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lw0nH = parcelRequire("lw0nH");
class $dc6386e768cb261e$export$ed6b4cba4dd55d4b {
    constructor(_provider, name, version, options){
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
     * Emit a log record. This method should only be used by log appenders.
     *
     * @param logRecord
     */ emit(logRecord) {
        this._getLogger().emit(logRecord);
    }
    /**
     * Try to get a logger from the proxy logger provider.
     * If the proxy logger provider has no delegate, return a noop logger.
     */ _getLogger() {
        if (this._delegate) return this._delegate;
        const logger = this._provider._getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return 0, $lw0nH.NOOP_LOGGER;
        this._delegate = logger;
        return this._delegate;
    }
}

});




parcelRegister("15v9P", function(module, exports) {

$parcel$export(module.exports, "context", function () { return (parcelRequire("3rgEx")).context; });
$parcel$export(module.exports, "diag", function () { return (parcelRequire("aLPFc")).diag; });
$parcel$export(module.exports, "metrics", function () { return (parcelRequire("hAdEB")).metrics; });
$parcel$export(module.exports, "propagation", function () { return (parcelRequire("iN5wJ")).propagation; });
$parcel$export(module.exports, "trace", function () { return (parcelRequire("j5ja1")).trace; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dM071 = parcelRequire("dM071");

var $fJacQ = parcelRequire("fJacQ");








var $83b23 = parcelRequire("83b23");

var $hbJhQ = parcelRequire("hbJhQ");

var $4D9sW = parcelRequire("4D9sW");

var $1iLvl = parcelRequire("1iLvl");


var $dStz2 = parcelRequire("dStz2");

var $2aArX = parcelRequire("2aArX");

var $3rgEx = parcelRequire("3rgEx");

var $aLPFc = parcelRequire("aLPFc");

var $hAdEB = parcelRequire("hAdEB");

var $iN5wJ = parcelRequire("iN5wJ");

var $j5ja1 = parcelRequire("j5ja1");
var // Default export.
$0cae6d4a6f95c8a4$export$2e2bcd8739ae039 = {
    context: (0, $3rgEx.context),
    diag: (0, $aLPFc.diag),
    metrics: (0, $hAdEB.metrics),
    propagation: (0, $iN5wJ.propagation),
    trace: (0, $j5ja1.trace)
};

});
parcelRegister("dM071", function(module, exports) {

$parcel$export(module.exports, "createBaggage", function () { return $a06fd859345358d6$export$1034a425c7384452; });
$parcel$export(module.exports, "baggageEntryMetadataFromString", function () { return $a06fd859345358d6$export$c491cedc1b2b6e9e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b7GWn = parcelRequire("b7GWn");

var $liC1N = parcelRequire("liC1N");

var $jJK6I = parcelRequire("jJK6I");
var $a06fd859345358d6$var$diag = (0, $b7GWn.DiagAPI).instance();
function $a06fd859345358d6$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $liC1N.BaggageImpl)(new Map(Object.entries(entries)));
}
function $a06fd859345358d6$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $a06fd859345358d6$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $jJK6I.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("b7GWn", function(module, exports) {

$parcel$export(module.exports, "DiagAPI", function () { return $8191a8441ce95600$export$5c8937ffc688cfd3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $92VtU = parcelRequire("92VtU");

var $lyVE6 = parcelRequire("lyVE6");

var $kZWR1 = parcelRequire("kZWR1");

var $1w9p6 = parcelRequire("1w9p6");
var $8191a8441ce95600$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8191a8441ce95600$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8191a8441ce95600$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $8191a8441ce95600$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $1w9p6.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $8191a8441ce95600$var$__spreadArray([], $8191a8441ce95600$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $kZWR1.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $1w9p6.getGlobal)('diag');
            var newLogger = (0, $lyVE6.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $kZWR1.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $1w9p6.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $1w9p6.unregisterGlobal)($8191a8441ce95600$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $92VtU.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("92VtU", function(module, exports) {

$parcel$export(module.exports, "DiagComponentLogger", function () { return $6960e393b0ee6b84$export$b4bccc12f5b13129; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1w9p6 = parcelRequire("1w9p6");
var $6960e393b0ee6b84$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6960e393b0ee6b84$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $6960e393b0ee6b84$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $6960e393b0ee6b84$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $6960e393b0ee6b84$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $6960e393b0ee6b84$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $6960e393b0ee6b84$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $6960e393b0ee6b84$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $6960e393b0ee6b84$var$logProxy(funcName, namespace, args) {
    var logger = (0, $1w9p6.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $6960e393b0ee6b84$var$__spreadArray([], $6960e393b0ee6b84$var$__read(args), false));
}

});
parcelRegister("1w9p6", function(module, exports) {

$parcel$export(module.exports, "registerGlobal", function () { return $11b0130669a72634$export$d586ae880b433238; });
$parcel$export(module.exports, "getGlobal", function () { return $11b0130669a72634$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "unregisterGlobal", function () { return $11b0130669a72634$export$d42ac835f38d1fb2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kFaSG = parcelRequire("kFaSG");

var $1qUrN = parcelRequire("1qUrN");

var $iyuRS = parcelRequire("iyuRS");
var $11b0130669a72634$var$major = (0, $1qUrN.VERSION).split('.')[0];
var $11b0130669a72634$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $11b0130669a72634$var$major);
var $11b0130669a72634$var$_global = (0, $kFaSG._globalThis);
function $11b0130669a72634$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $11b0130669a72634$var$_global[$11b0130669a72634$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $11b0130669a72634$var$_global[$11b0130669a72634$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $1qUrN.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $1qUrN.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $1qUrN.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $1qUrN.VERSION) + ".");
    return true;
}
function $11b0130669a72634$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $11b0130669a72634$var$_global[$11b0130669a72634$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $iyuRS.isCompatible)(globalVersion)) return;
    return (_b = $11b0130669a72634$var$_global[$11b0130669a72634$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $11b0130669a72634$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $1qUrN.VERSION) + ".");
    var api = $11b0130669a72634$var$_global[$11b0130669a72634$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("kFaSG", function(module, exports) {

$parcel$export(module.exports, "_globalThis", function () { return $f0b013bad03637a3$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $f0b013bad03637a3$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("1qUrN", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $10b4016e3357de80$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $10b4016e3357de80$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("iyuRS", function(module, exports) {

$parcel$export(module.exports, "isCompatible", function () { return $d82358b51a8713a3$export$7fc0d8c3ab188c4c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1qUrN = parcelRequire("1qUrN");
var $d82358b51a8713a3$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $d82358b51a8713a3$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($d82358b51a8713a3$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($d82358b51a8713a3$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $d82358b51a8713a3$export$7fc0d8c3ab188c4c = $d82358b51a8713a3$export$a5733a4d26a1ec61((0, $1qUrN.VERSION));

});



parcelRegister("lyVE6", function(module, exports) {

$parcel$export(module.exports, "createLogLevelDiagLogger", function () { return $fb297d36d377d6d3$export$9a9cc475abb19689; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kZWR1 = parcelRequire("kZWR1");
function $fb297d36d377d6d3$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $kZWR1.DiagLogLevel).NONE) maxLevel = (0, $kZWR1.DiagLogLevel).NONE;
    else if (maxLevel > (0, $kZWR1.DiagLogLevel).ALL) maxLevel = (0, $kZWR1.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $kZWR1.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $kZWR1.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $kZWR1.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $kZWR1.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $kZWR1.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("kZWR1", function(module, exports) {

$parcel$export(module.exports, "DiagLogLevel", function () { return $f497285936a72ab0$export$b7d7b4c0f3c95263; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $f497285936a72ab0$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($f497285936a72ab0$export$b7d7b4c0f3c95263 || ($f497285936a72ab0$export$b7d7b4c0f3c95263 = {}));

});



parcelRegister("liC1N", function(module, exports) {

$parcel$export(module.exports, "BaggageImpl", function () { return $f818c6fef7a9c72c$export$b8c511fa1a5f4987; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f818c6fef7a9c72c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f818c6fef7a9c72c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $f818c6fef7a9c72c$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $f818c6fef7a9c72c$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $f818c6fef7a9c72c$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("jJK6I", function(module, exports) {

$parcel$export(module.exports, "baggageEntryMetadataSymbol", function () { return $e5e5fc3907b933c0$export$92dd2fe8ddb5cb7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $e5e5fc3907b933c0$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});


parcelRegister("fJacQ", function(module, exports) {

$parcel$export(module.exports, "createContextKey", function () { return $b732f9b6151c8598$export$b8c322c5a7cfce78; });
$parcel$export(module.exports, "ROOT_CONTEXT", function () { return $b732f9b6151c8598$export$78df28f9b2f9a7dc; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $b732f9b6151c8598$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $b732f9b6151c8598$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $b732f9b6151c8598$export$78df28f9b2f9a7dc = new $b732f9b6151c8598$var$BaseContext();

});

parcelRegister("83b23", function(module, exports) {

$parcel$export(module.exports, "SamplingDecision", function () { return $5dc7295126bd294b$export$94df7a7a96a92f7b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $5dc7295126bd294b$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($5dc7295126bd294b$export$94df7a7a96a92f7b || ($5dc7295126bd294b$export$94df7a7a96a92f7b = {}));

});

parcelRegister("hbJhQ", function(module, exports) {

$parcel$export(module.exports, "SpanKind", function () { return $c83697c8733b64ae$export$4da4ea8145910e8b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c83697c8733b64ae$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($c83697c8733b64ae$export$4da4ea8145910e8b || ($c83697c8733b64ae$export$4da4ea8145910e8b = {}));

});

parcelRegister("4D9sW", function(module, exports) {

$parcel$export(module.exports, "SpanStatusCode", function () { return $35f225a5735a804a$export$1e28dd9b5d01db83; });
/**
 * An enumeration of status codes.
 */ var $35f225a5735a804a$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($35f225a5735a804a$export$1e28dd9b5d01db83 || ($35f225a5735a804a$export$1e28dd9b5d01db83 = {}));

});

parcelRegister("1iLvl", function(module, exports) {

$parcel$export(module.exports, "TraceFlags", function () { return $0f2c52480d91f477$export$bf9049ad2b0883ff; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0f2c52480d91f477$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($0f2c52480d91f477$export$bf9049ad2b0883ff || ($0f2c52480d91f477$export$bf9049ad2b0883ff = {}));

});

parcelRegister("dStz2", function(module, exports) {

$parcel$export(module.exports, "isValidTraceId", function () { return $a1a7404e596f4b57$export$29dd34cf1269f6da; });
$parcel$export(module.exports, "isSpanContextValid", function () { return $a1a7404e596f4b57$export$e4373b9a2c09216c; });
$parcel$export(module.exports, "wrapSpanContext", function () { return $a1a7404e596f4b57$export$c19cc0f1911bdb85; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2aArX = parcelRequire("2aArX");

var $1jY3d = parcelRequire("1jY3d");
var $a1a7404e596f4b57$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $a1a7404e596f4b57$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $a1a7404e596f4b57$export$29dd34cf1269f6da(traceId) {
    return $a1a7404e596f4b57$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $2aArX.INVALID_TRACEID);
}
function $a1a7404e596f4b57$export$8e51c6d8f0586aff(spanId) {
    return $a1a7404e596f4b57$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $2aArX.INVALID_SPANID);
}
function $a1a7404e596f4b57$export$e4373b9a2c09216c(spanContext) {
    return $a1a7404e596f4b57$export$29dd34cf1269f6da(spanContext.traceId) && $a1a7404e596f4b57$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $a1a7404e596f4b57$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $1jY3d.NonRecordingSpan)(spanContext);
}

});
parcelRegister("2aArX", function(module, exports) {

$parcel$export(module.exports, "INVALID_SPANID", function () { return $1948ca1d4682b733$export$55cc39fb0d4bb4c0; });
$parcel$export(module.exports, "INVALID_TRACEID", function () { return $1948ca1d4682b733$export$22be96e88d95e128; });
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", function () { return $1948ca1d4682b733$export$8591e4c852b66703; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1iLvl = parcelRequire("1iLvl");
var $1948ca1d4682b733$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $1948ca1d4682b733$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $1948ca1d4682b733$export$8591e4c852b66703 = {
    traceId: $1948ca1d4682b733$export$22be96e88d95e128,
    spanId: $1948ca1d4682b733$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $1iLvl.TraceFlags).NONE
};

});

parcelRegister("1jY3d", function(module, exports) {

$parcel$export(module.exports, "NonRecordingSpan", function () { return $0f66259f5fdf70b4$export$972d28f7c6a8c6c7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2aArX = parcelRequire("2aArX");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $0f66259f5fdf70b4$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $2aArX.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});


parcelRegister("3rgEx", function(module, exports) {

$parcel$export(module.exports, "context", function () { return $2810cfa4578b26a2$export$a078c61943f9dbbe; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $9xFf1 = parcelRequire("9xFf1");
var $2810cfa4578b26a2$export$a078c61943f9dbbe = (0, $9xFf1.ContextAPI).getInstance();

});
parcelRegister("9xFf1", function(module, exports) {

$parcel$export(module.exports, "ContextAPI", function () { return $6f272fc7a76ff640$export$4148866f0a453927; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eR3fw = parcelRequire("eR3fw");

var $1w9p6 = parcelRequire("1w9p6");

var $b7GWn = parcelRequire("b7GWn");
var $6f272fc7a76ff640$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6f272fc7a76ff640$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6f272fc7a76ff640$var$API_NAME = 'context';
var $6f272fc7a76ff640$var$NOOP_CONTEXT_MANAGER = new (0, $eR3fw.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $6f272fc7a76ff640$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $1w9p6.registerGlobal)($6f272fc7a76ff640$var$API_NAME, contextManager, (0, $b7GWn.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $6f272fc7a76ff640$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $6f272fc7a76ff640$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $1w9p6.getGlobal)($6f272fc7a76ff640$var$API_NAME) || $6f272fc7a76ff640$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $1w9p6.unregisterGlobal)($6f272fc7a76ff640$var$API_NAME, (0, $b7GWn.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("eR3fw", function(module, exports) {

$parcel$export(module.exports, "NoopContextManager", function () { return $ad088928fd69cc3f$export$a27e5df35d1539a6; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fJacQ = parcelRequire("fJacQ");
var $ad088928fd69cc3f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ad088928fd69cc3f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ad088928fd69cc3f$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $fJacQ.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $ad088928fd69cc3f$var$__spreadArray([
            thisArg
        ], $ad088928fd69cc3f$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});



parcelRegister("aLPFc", function(module, exports) {

$parcel$export(module.exports, "diag", function () { return $7d765e71095050b6$export$c042e7c2f59bc046; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $b7GWn = parcelRequire("b7GWn");
var $7d765e71095050b6$export$c042e7c2f59bc046 = (0, $b7GWn.DiagAPI).instance();

});

parcelRegister("hAdEB", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $ccd063d9f03b4643$export$b0c5c2fac8144e54; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $uUIyA = parcelRequire("uUIyA");
var $ccd063d9f03b4643$export$b0c5c2fac8144e54 = (0, $uUIyA.MetricsAPI).getInstance();

});
parcelRegister("uUIyA", function(module, exports) {

$parcel$export(module.exports, "MetricsAPI", function () { return $05cecc66fe6a8a0f$export$1339f6eb6111c638; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $ekLNz = parcelRequire("ekLNz");

var $1w9p6 = parcelRequire("1w9p6");

var $b7GWn = parcelRequire("b7GWn");
var $05cecc66fe6a8a0f$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $05cecc66fe6a8a0f$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $1w9p6.registerGlobal)($05cecc66fe6a8a0f$var$API_NAME, provider, (0, $b7GWn.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $1w9p6.getGlobal)($05cecc66fe6a8a0f$var$API_NAME) || (0, $ekLNz.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $1w9p6.unregisterGlobal)($05cecc66fe6a8a0f$var$API_NAME, (0, $b7GWn.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("ekLNz", function(module, exports) {

$parcel$export(module.exports, "NOOP_METER_PROVIDER", function () { return $a6f802b967a89b9e$export$d21fe83355c56e18; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gt2F1 = parcelRequire("gt2F1");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $a6f802b967a89b9e$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $gt2F1.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $a6f802b967a89b9e$export$d21fe83355c56e18 = new $a6f802b967a89b9e$export$51c513ea08316108();

});
parcelRegister("gt2F1", function(module, exports) {

$parcel$export(module.exports, "NOOP_METER", function () { return $bfd16b2553104f6d$export$65e277d35235a01f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $bfd16b2553104f6d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $bfd16b2553104f6d$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $bfd16b2553104f6d$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $bfd16b2553104f6d$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $bfd16b2553104f6d$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $bfd16b2553104f6d$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $bfd16b2553104f6d$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $bfd16b2553104f6d$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $bfd16b2553104f6d$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $bfd16b2553104f6d$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $bfd16b2553104f6d$export$b556ba0f560c45b = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($bfd16b2553104f6d$export$834a616d1cf278b);
var $bfd16b2553104f6d$export$df09a35db160df98 = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($bfd16b2553104f6d$export$834a616d1cf278b);
var $bfd16b2553104f6d$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($bfd16b2553104f6d$export$834a616d1cf278b);
var $bfd16b2553104f6d$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($bfd16b2553104f6d$export$834a616d1cf278b);
var $bfd16b2553104f6d$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $bfd16b2553104f6d$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($bfd16b2553104f6d$export$a5a3e7829c289482);
var $bfd16b2553104f6d$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($bfd16b2553104f6d$export$a5a3e7829c289482);
var $bfd16b2553104f6d$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $bfd16b2553104f6d$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($bfd16b2553104f6d$export$a5a3e7829c289482);
var $bfd16b2553104f6d$export$65e277d35235a01f = new $bfd16b2553104f6d$export$c23c6f85dd4fc1e9();
var $bfd16b2553104f6d$export$e6d19fe5233efc54 = new $bfd16b2553104f6d$export$b556ba0f560c45b();
var $bfd16b2553104f6d$export$dd01300aacbcec1c = new $bfd16b2553104f6d$export$b7f4a3c7ea16c24();
var $bfd16b2553104f6d$export$689c32a6a552e1a6 = new $bfd16b2553104f6d$export$ef064c3e0426c607();
var $bfd16b2553104f6d$export$2f189cd99d2b7429 = new $bfd16b2553104f6d$export$df09a35db160df98();
var $bfd16b2553104f6d$export$163422b94c3edbcb = new $bfd16b2553104f6d$export$7a7e4b169d5c93a8();
var $bfd16b2553104f6d$export$ea67e3c6ff624776 = new $bfd16b2553104f6d$export$6990a2f90809ffc1();
var $bfd16b2553104f6d$export$5b8be9ab17b673b3 = new $bfd16b2553104f6d$export$3ec3555bc6f693a4();
function $bfd16b2553104f6d$export$bc3a498ccbb5c2b5() {
    return $bfd16b2553104f6d$export$65e277d35235a01f;
}

});




parcelRegister("iN5wJ", function(module, exports) {

$parcel$export(module.exports, "propagation", function () { return $dae117257819ac1c$export$3e49040daa9dba20; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $6Q1HK = parcelRequire("6Q1HK");
var $dae117257819ac1c$export$3e49040daa9dba20 = (0, $6Q1HK.PropagationAPI).getInstance();

});
parcelRegister("6Q1HK", function(module, exports) {

$parcel$export(module.exports, "PropagationAPI", function () { return $4fa8ebe9a289c31c$export$471eda0a6213cac9; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1w9p6 = parcelRequire("1w9p6");

var $96T7v = parcelRequire("96T7v");

var $hXHpC = parcelRequire("hXHpC");

var $8CyMr = parcelRequire("8CyMr");

var $dM071 = parcelRequire("dM071");

var $b7GWn = parcelRequire("b7GWn");
var $4fa8ebe9a289c31c$var$API_NAME = 'propagation';
var $4fa8ebe9a289c31c$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $96T7v.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $4fa8ebe9a289c31c$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $dM071.createBaggage);
        this.getBaggage = (0, $8CyMr.getBaggage);
        this.getActiveBaggage = (0, $8CyMr.getActiveBaggage);
        this.setBaggage = (0, $8CyMr.setBaggage);
        this.deleteBaggage = (0, $8CyMr.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $1w9p6.registerGlobal)($4fa8ebe9a289c31c$var$API_NAME, propagator, (0, $b7GWn.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $hXHpC.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $hXHpC.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $1w9p6.unregisterGlobal)($4fa8ebe9a289c31c$var$API_NAME, (0, $b7GWn.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $1w9p6.getGlobal)($4fa8ebe9a289c31c$var$API_NAME) || $4fa8ebe9a289c31c$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("96T7v", function(module, exports) {

$parcel$export(module.exports, "NoopTextMapPropagator", function () { return $6a1f6e4cf1b3924e$export$8356c7eb3af7963b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $6a1f6e4cf1b3924e$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("hXHpC", function(module, exports) {

$parcel$export(module.exports, "defaultTextMapGetter", function () { return $d1399f188ba15b76$export$a0f575f55f38720a; });
$parcel$export(module.exports, "defaultTextMapSetter", function () { return $d1399f188ba15b76$export$f70f1d111fccf1c1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1399f188ba15b76$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $d1399f188ba15b76$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("8CyMr", function(module, exports) {

$parcel$export(module.exports, "getBaggage", function () { return $646cd9fa9dcb701c$export$f3bffa0b5dd10d1e; });
$parcel$export(module.exports, "getActiveBaggage", function () { return $646cd9fa9dcb701c$export$120a1756099436ee; });
$parcel$export(module.exports, "setBaggage", function () { return $646cd9fa9dcb701c$export$adc9ca19eab3f500; });
$parcel$export(module.exports, "deleteBaggage", function () { return $646cd9fa9dcb701c$export$4ca3a8a743c9f633; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9xFf1 = parcelRequire("9xFf1");

var $fJacQ = parcelRequire("fJacQ");
/**
 * Baggage key
 */ var $646cd9fa9dcb701c$var$BAGGAGE_KEY = (0, $fJacQ.createContextKey)('OpenTelemetry Baggage Key');
function $646cd9fa9dcb701c$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($646cd9fa9dcb701c$var$BAGGAGE_KEY) || undefined;
}
function $646cd9fa9dcb701c$export$120a1756099436ee() {
    return $646cd9fa9dcb701c$export$f3bffa0b5dd10d1e((0, $9xFf1.ContextAPI).getInstance().active());
}
function $646cd9fa9dcb701c$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($646cd9fa9dcb701c$var$BAGGAGE_KEY, baggage);
}
function $646cd9fa9dcb701c$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($646cd9fa9dcb701c$var$BAGGAGE_KEY);
}

});



parcelRegister("j5ja1", function(module, exports) {

$parcel$export(module.exports, "trace", function () { return $de4d58de2849a7b4$export$357889f174732d38; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $7KIKN = parcelRequire("7KIKN");
var $de4d58de2849a7b4$export$357889f174732d38 = (0, $7KIKN.TraceAPI).getInstance();

});
parcelRegister("7KIKN", function(module, exports) {

$parcel$export(module.exports, "TraceAPI", function () { return $5a4f8b703adf5291$export$2cccde6fcc7b568a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1w9p6 = parcelRequire("1w9p6");

var $dxUUg = parcelRequire("dxUUg");

var $dStz2 = parcelRequire("dStz2");

var $8svrI = parcelRequire("8svrI");

var $b7GWn = parcelRequire("b7GWn");
var $5a4f8b703adf5291$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $5a4f8b703adf5291$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $dxUUg.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $dStz2.wrapSpanContext);
        this.isSpanContextValid = (0, $dStz2.isSpanContextValid);
        this.deleteSpan = (0, $8svrI.deleteSpan);
        this.getSpan = (0, $8svrI.getSpan);
        this.getActiveSpan = (0, $8svrI.getActiveSpan);
        this.getSpanContext = (0, $8svrI.getSpanContext);
        this.setSpan = (0, $8svrI.setSpan);
        this.setSpanContext = (0, $8svrI.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $1w9p6.registerGlobal)($5a4f8b703adf5291$var$API_NAME, this._proxyTracerProvider, (0, $b7GWn.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $1w9p6.getGlobal)($5a4f8b703adf5291$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $1w9p6.unregisterGlobal)($5a4f8b703adf5291$var$API_NAME, (0, $b7GWn.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $dxUUg.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("dxUUg", function(module, exports) {

$parcel$export(module.exports, "ProxyTracerProvider", function () { return $9dca7fe228a957f2$export$4137aabcb4254962; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5jH99 = parcelRequire("5jH99");

var $dMBYl = parcelRequire("dMBYl");
var $9dca7fe228a957f2$var$NOOP_TRACER_PROVIDER = new (0, $dMBYl.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $9dca7fe228a957f2$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $5jH99.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $9dca7fe228a957f2$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("5jH99", function(module, exports) {

$parcel$export(module.exports, "ProxyTracer", function () { return $3df0322210044176$export$df2c38268c6bb6b3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $284F1 = parcelRequire("284F1");
var $3df0322210044176$var$NOOP_TRACER = new (0, $284F1.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $3df0322210044176$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $3df0322210044176$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("284F1", function(module, exports) {

$parcel$export(module.exports, "NoopTracer", function () { return $18cff19f5984329c$export$714c1036cabcd223; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9xFf1 = parcelRequire("9xFf1");

var $8svrI = parcelRequire("8svrI");

var $1jY3d = parcelRequire("1jY3d");

var $dStz2 = parcelRequire("dStz2");
var $18cff19f5984329c$var$contextApi = (0, $9xFf1.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $18cff19f5984329c$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $18cff19f5984329c$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $1jY3d.NonRecordingSpan)();
        var parentFromContext = context && (0, $8svrI.getSpanContext)(context);
        if ($18cff19f5984329c$var$isSpanContext(parentFromContext) && (0, $dStz2.isSpanContextValid)(parentFromContext)) return new (0, $1jY3d.NonRecordingSpan)(parentFromContext);
        else return new (0, $1jY3d.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $18cff19f5984329c$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $8svrI.setSpan)(parentContext, span);
        return $18cff19f5984329c$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $18cff19f5984329c$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("8svrI", function(module, exports) {

$parcel$export(module.exports, "getSpan", function () { return $628954c80c775225$export$246e04ba06066af1; });
$parcel$export(module.exports, "getActiveSpan", function () { return $628954c80c775225$export$1be426a8e585c83e; });
$parcel$export(module.exports, "setSpan", function () { return $628954c80c775225$export$8ab2f2e6ee8ed0a8; });
$parcel$export(module.exports, "deleteSpan", function () { return $628954c80c775225$export$a6bbfe9a17f7941c; });
$parcel$export(module.exports, "setSpanContext", function () { return $628954c80c775225$export$c90bf5428c14cdb1; });
$parcel$export(module.exports, "getSpanContext", function () { return $628954c80c775225$export$1a635f8f0b912781; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fJacQ = parcelRequire("fJacQ");

var $1jY3d = parcelRequire("1jY3d");

var $9xFf1 = parcelRequire("9xFf1");
/**
 * span key
 */ var $628954c80c775225$var$SPAN_KEY = (0, $fJacQ.createContextKey)('OpenTelemetry Context Key SPAN');
function $628954c80c775225$export$246e04ba06066af1(context) {
    return context.getValue($628954c80c775225$var$SPAN_KEY) || undefined;
}
function $628954c80c775225$export$1be426a8e585c83e() {
    return $628954c80c775225$export$246e04ba06066af1((0, $9xFf1.ContextAPI).getInstance().active());
}
function $628954c80c775225$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($628954c80c775225$var$SPAN_KEY, span);
}
function $628954c80c775225$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($628954c80c775225$var$SPAN_KEY);
}
function $628954c80c775225$export$c90bf5428c14cdb1(context, spanContext) {
    return $628954c80c775225$export$8ab2f2e6ee8ed0a8(context, new (0, $1jY3d.NonRecordingSpan)(spanContext));
}
function $628954c80c775225$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $628954c80c775225$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});



parcelRegister("dMBYl", function(module, exports) {

$parcel$export(module.exports, "NoopTracerProvider", function () { return $a08d368d208b332a$export$87d8e93756f9e86e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $284F1 = parcelRequire("284F1");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $a08d368d208b332a$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $284F1.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("hJ2SO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce78e0236972a2e5$export$2e2bcd8739ae039; });
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.8'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(const key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        // use dummy base URL to allow normalize on path only
        const url = new URL(path, 'http://x');
        if (url) path = url.pathname + url.search;
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const normalizedId = id.replace("'", "\\'");
                const normalizedTag = newNode.tagName.replace(':', '\\:');
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(normalizedTag + "[id='" + normalizedId + "']");
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            const rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            target.classList.remove(htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) elt.classList.add(htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) elt.classList.remove(htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody);
            for(const eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            const btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            const link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            const samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for(const e in extensions){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error);
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            ic.classList.add.call(ic.classList, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            disabledElement.setAttribute('disabled', '');
            disabledElement.setAttribute('data-disabled-by-htmx', '');
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) ic.classList.remove.call(ic.classList, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(const key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for(const key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(const header in headers)if (headers.hasOwnProperty(header)) {
                const headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        const pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        const replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // false indicates no push, return empty object
            if (path === 'false') return {};
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push || 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        const shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            target.classList.add(htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            const indicator = htmx.config.indicatorClass;
            const request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', `<style${nonceAttribute}>` + `.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}` + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $ce78e0236972a2e5$export$2e2bcd8739ae039 = htmx;

});

parcelRegister("8z0uj", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("3WFuy"))($parcel$resolve("1dfj1")),
    (parcelRequire("3WFuy"))($parcel$resolve("7OGkg"))
]).then(()=>parcelRequire('noFWM'));

});
parcelRegister("3WFuy", function(module, exports) {
"use strict";

var $667pM = parcelRequire("667pM");
module.exports = $667pM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("667pM", function(module, exports) {
"use strict";
var $47090e09928e24bd$var$cachedBundles = {};
var $47090e09928e24bd$var$cachedPreloads = {};
var $47090e09928e24bd$var$cachedPrefetches = {};
function $47090e09928e24bd$var$getCache(type) {
    switch(type){
        case 'preload':
            return $47090e09928e24bd$var$cachedPreloads;
        case 'prefetch':
            return $47090e09928e24bd$var$cachedPrefetches;
        default:
            return $47090e09928e24bd$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $47090e09928e24bd$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("055be", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("3WFuy"))($parcel$resolve("iLIG0")),
    (parcelRequire("3WFuy"))($parcel$resolve("1dfj1")),
    (parcelRequire("3WFuy"))($parcel$resolve("4xwns"))
]).then(()=>parcelRequire('23juN'));

});

var $2e55131d64d8f075$exports = {};
$parcel$extendImportMap({
    "7OGkg": "SearchOrAskAi.05ece384.js",
    "3KoKi": "SearchOrAskAiModal.5549532a.js",
    "iLIG0": "SearchOrAskAiModal.2e7a089d.js",
    "1dfj1": "SearchOrAskAi.e456cd8c.js",
    "4xwns": "VersionDropdown.891c7de2.js"
});

// TODO: refactor to typescript. this was copied from the tabs implementation

var $iW1oU = parcelRequire("iW1oU");
// Extra JS capability for selected applies switches to be synced
// The selection is stored in local storage so that it persists across page loads.
const $0e8c0a427244d80b$var$as_id_to_elements = {};
const $0e8c0a427244d80b$var$storageKeyPrefix = 'applies-switch-id-';
function $0e8c0a427244d80b$var$create_key(el) {
    const syncId = el.getAttribute('data-sync-id');
    const syncGroup = el.getAttribute('data-sync-group');
    if (!syncId || !syncGroup) return null;
    return [
        syncGroup,
        syncId,
        syncGroup + '--' + syncId
    ];
}
/**
 * Initialize the applies switch selection.
 *
 */ function $0e8c0a427244d80b$var$ready() {
    // Find all applies switches with sync data
    const groups = [];
    (0, $iW1oU.$$)('.applies-switch-label').forEach((label)=>{
        if (label instanceof HTMLElement) {
            const data = $0e8c0a427244d80b$var$create_key(label);
            if (data) {
                const [group, id, key] = data;
                // add click event listener
                label.addEventListener('click', $0e8c0a427244d80b$var$onAppliesSwitchLabelClick);
                // store map of key to elements
                if (!$0e8c0a427244d80b$var$as_id_to_elements[key]) $0e8c0a427244d80b$var$as_id_to_elements[key] = [];
                $0e8c0a427244d80b$var$as_id_to_elements[key].push(label);
                if (groups.indexOf(group) === -1) {
                    groups.push(group);
                    // Check if a specific switch has been selected via URL parameter
                    const switchParam = new URLSearchParams(window.location.search).get(group);
                    if (switchParam) window.sessionStorage.setItem($0e8c0a427244d80b$var$storageKeyPrefix + group, switchParam);
                }
                // Check is a specific switch has been selected previously
                const previousId = window.sessionStorage.getItem($0e8c0a427244d80b$var$storageKeyPrefix + group);
                if (previousId === id) label.previousElementSibling.checked = true;
            }
        }
    });
}
/**
 *  Activate other switches with the same sync id.
 *
 * @this {HTMLElement} - The element that was clicked.
 */ function $0e8c0a427244d80b$var$onAppliesSwitchLabelClick() {
    const data = $0e8c0a427244d80b$var$create_key(this);
    if (!data) return;
    const [group, id, key] = data;
    for (const label of $0e8c0a427244d80b$var$as_id_to_elements[key]){
        if (label === this) continue;
        if (label.previousElementSibling instanceof HTMLInputElement) label.previousElementSibling.checked = true;
    }
    window.sessionStorage.setItem($0e8c0a427244d80b$var$storageKeyPrefix + group, id);
}
function $0e8c0a427244d80b$export$1bae6a6e343f38b8() {
    $0e8c0a427244d80b$var$ready();
}



var $3RUqz = parcelRequire("3RUqz");

var $j96zz = parcelRequire("j96zz");

var $iW1oU = parcelRequire("iW1oU");
class $034734cddcc39867$var$ImageCarousel {
    constructor(container){
        this.slides = [];
        this.indicators = [];
        this.prevButton = null;
        this.nextButton = null;
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.container = container;
        if (!this.container) {
            console.warn('Carousel container element is null or undefined');
            return;
        }
        this.slides = Array.from(this.container.querySelectorAll('.carousel-slide'));
        // Don't initialize if no slides
        if (this.slides.length === 0) {
            console.warn('No carousel slides found');
            return;
        }
        this.indicators = Array.from(this.container.querySelectorAll('.carousel-indicator'));
        this.prevButton = this.container.querySelector('.carousel-prev');
        this.nextButton = this.container.querySelector('.carousel-next');
        this.initializeSlides();
        this.setupEventListeners();
        this.positionControls();
    }
    initializeSlides() {
        // Initialize all slides as inactive
        this.slides.forEach((slide, index)=>{
            this.setSlideState(slide, index === 0);
        });
        // Initialize indicators
        this.indicators.forEach((indicator, index)=>{
            this.setIndicatorState(indicator, index === 0);
        });
    }
    setSlideState(slide, isActive) {
        slide.setAttribute('data-active', isActive.toString());
        slide.style.display = isActive ? 'block' : 'none';
        slide.style.opacity = isActive ? '1' : '0';
    }
    setIndicatorState(indicator, isActive) {
        indicator.setAttribute('data-active', isActive.toString());
    }
    setupEventListeners() {
        // Navigation controls
        this.prevButton?.addEventListener('click', ()=>this.prevSlide());
        this.nextButton?.addEventListener('click', ()=>this.nextSlide());
        // Indicators
        this.indicators.forEach((indicator, index)=>{
            indicator.addEventListener('click', ()=>this.goToSlide(index));
        });
        // Handle image clicks for modal
        this.slides.forEach((slide)=>{
            const imageLink = slide.querySelector('.carousel-image-reference');
            if (imageLink) imageLink.addEventListener('click', (e)=>{
                e.preventDefault();
                const modalId = imageLink.getAttribute('data-modal-id');
                if (modalId) {
                    const modal = document.getElementById(modalId);
                    if (modal) modal.style.display = 'flex';
                }
            });
        });
        // Keyboard navigation
        document.addEventListener('keydown', (e)=>{
            if (!this.isInViewport()) return;
            if (e.key === 'ArrowLeft') this.prevSlide();
            else if (e.key === 'ArrowRight') this.nextSlide();
        });
        // Touch events
        this.container.addEventListener('touchstart', (e)=>{
            this.touchStartX = e.changedTouches[0].screenX;
        });
        this.container.addEventListener('touchend', (e)=>{
            this.touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
        });
    }
    prevSlide() {
        const newIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.goToSlide(newIndex);
    }
    nextSlide() {
        const newIndex = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(newIndex);
    }
    goToSlide(index) {
        // Update slides
        this.setSlideState(this.slides[this.currentIndex], false);
        this.setSlideState(this.slides[index], true);
        // Update indicators
        if (this.indicators.length > 0) {
            this.setIndicatorState(this.indicators[this.currentIndex], false);
            this.setIndicatorState(this.indicators[index], true);
        }
        this.currentIndex = index;
    }
    handleSwipe() {
        const threshold = 50;
        const diff = this.touchStartX - this.touchEndX;
        if (Math.abs(diff) < threshold) return;
        if (diff > 0) this.nextSlide();
        else this.prevSlide();
    }
    isInViewport() {
        const rect = this.container.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
    positionControls() {
        if (!this.prevButton || !this.nextButton) return;
        // Wait for images to load before positioning
        const images = Array.from(this.container.querySelectorAll('img'));
        if (images.length === 0) return;
        let loadedCount = 0;
        const totalImages = images.length;
        const positionAfterLoad = ()=>{
            loadedCount++;
            if (loadedCount === totalImages) this.calculateControlPosition();
        };
        images.forEach((img)=>{
            if (img.complete) positionAfterLoad();
            else {
                img.addEventListener('load', positionAfterLoad);
                img.addEventListener('error', positionAfterLoad) // Handle failed loads
                ;
            }
        });
    }
    calculateControlPosition() {
        if (!this.prevButton || !this.nextButton) return;
        const images = Array.from(this.container.querySelectorAll('img'));
        let minHeight = Infinity;
        // Find the smallest image height among all images
        images.forEach((img)=>{
            const height = img.offsetHeight;
            if (height > 0 && height < minHeight) minHeight = height;
        });
        // Position controls at 40% the height of the smallest image
        // But ensure a minimum distance from the top (50px) and don't go below 80% of the smallest image
        if (minHeight !== Infinity && minHeight > 0) {
            const fortyPercentHeight = Math.floor(minHeight * 0.4);
            const minTop = 50 // Minimum 50px from top
            ;
            const maxTop = Math.floor(minHeight * 0.8) // Maximum 80% down the smallest image
            ;
            const controlTop = Math.max(minTop, Math.min(fortyPercentHeight, maxTop));
            this.prevButton.style.top = `${controlTop}px`;
            this.nextButton.style.top = `${controlTop}px`;
        }
    }
}
function $034734cddcc39867$export$6c5c949207b4b264() {
    // Find all carousel containers
    const carousels = document.querySelectorAll('.carousel-container');
    // Process each carousel
    carousels.forEach((carouselElement)=>{
        const carousel = carouselElement;
        // Skip if carousel already has slides (server-rendered)
        const existingSlides = carousel.querySelectorAll('.carousel-slide');
        if (existingSlides.length > 0) {
            // Just initialize the existing carousel
            new $034734cddcc39867$var$ImageCarousel(carousel);
            return;
        }
        // Get the existing track for dynamic carousels
        let track = carousel.querySelector('.carousel-track');
        if (!track) {
            track = document.createElement('div');
            track.className = 'carousel-track';
            carousel.appendChild(track);
        }
        // Find all image links that might be related to this carousel
        const section = $034734cddcc39867$var$findSectionForCarousel(carousel);
        if (!section) return;
        // First, collect all images we want in the carousel
        const allImageLinks = (0, $iW1oU.$$)('a[href*="epr.elastic.co"]', section);
        // Track URLs to prevent duplicates
        const processedUrls = new Set();
        // Process the existing slides first
        existingSlides.forEach((slide)=>{
            const imageRef = slide.querySelector('a.carousel-image-reference');
            if (imageRef && imageRef instanceof HTMLAnchorElement) processedUrls.add(imageRef.href);
        });
        // Find standalone images (not already in carousel slides)
        const standaloneImages = allImageLinks.filter((img)=>{
            if (processedUrls.has(img.href)) return false // Skip if already processed
            ;
            // Don't count images already in carousel slides
            const isInCarousel = img.closest('.carousel-slide') !== null;
            if (isInCarousel) {
                processedUrls.add(img.href);
                return false;
            }
            processedUrls.add(img.href);
            return true;
        });
        // Add the standalone images to the carousel
        let slideIndex = existingSlides.length;
        standaloneImages.forEach((imgLink)=>{
            // Find container to hide
            const imgContainer = $034734cddcc39867$var$findClosestContainer(imgLink, carousel);
            // Create a new slide
            const slide = document.createElement('div');
            slide.className = 'carousel-slide';
            slide.setAttribute('data-index', slideIndex.toString());
            if (slideIndex === 0 && existingSlides.length === 0) slide.setAttribute('data-active', 'true');
            // Create a proper carousel image reference wrapper
            const imageRef = document.createElement('a');
            imageRef.className = 'carousel-image-reference';
            imageRef.href = imgLink.href;
            imageRef.target = '_blank';
            // Clone the image
            const img = imgLink.querySelector('img');
            if (img) imageRef.appendChild(img.cloneNode(true));
            slide.appendChild(imageRef);
            track.appendChild(slide);
            // Hide the original container properly
            if (imgContainer) try {
                // Find the parent element that might be a paragraph or div containing the image
                let parent = imgContainer;
                let maxAttempts = 3 // Don't go too far up the tree
                ;
                while(maxAttempts > 0 && parent && parent !== document.body){
                    // If this is one of these elements, hide it
                    if (parent.tagName === 'P' || parent.tagName === 'DIV' && !parent.classList.contains('carousel-container')) {
                        parent.style.display = 'none';
                        break;
                    }
                    if (parent.parentElement) parent = parent.parentElement;
                    maxAttempts--;
                }
                // If we couldn't find a suitable parent, just hide the container itself
                if (maxAttempts === 0) imgContainer.style.display = 'none';
            } catch (e) {
                console.error('Failed to hide original image:', e);
            }
            slideIndex++;
        });
        // Only set up controls if we have multiple slides
        const totalSlides = track.querySelectorAll('.carousel-slide').length;
        if (totalSlides > 1) {
            // Add controls if they don't exist
            if (!carousel.querySelector('.carousel-prev')) {
                const prevButton = document.createElement('button');
                prevButton.type = 'button';
                prevButton.className = 'carousel-control carousel-prev';
                prevButton.setAttribute('aria-label', 'Previous slide');
                prevButton.innerHTML = '<span aria-hidden="true">\u2190</span>';
                carousel.appendChild(prevButton);
            }
            if (!carousel.querySelector('.carousel-next')) {
                const nextButton = document.createElement('button');
                nextButton.type = 'button';
                nextButton.className = 'carousel-control carousel-next';
                nextButton.setAttribute('aria-label', 'Next slide');
                nextButton.innerHTML = '<span aria-hidden="true">\u2192</span>';
                carousel.appendChild(nextButton);
            }
            // Add or update indicators
            let indicators = carousel.querySelector('.carousel-indicators');
            if (!indicators) {
                indicators = document.createElement('div');
                indicators.className = 'carousel-indicators';
                carousel.appendChild(indicators);
            } else indicators.innerHTML = '' // Clear existing indicators
            ;
            for(let i = 0; i < totalSlides; i++){
                const indicator = document.createElement('button');
                indicator.type = 'button';
                indicator.className = 'carousel-indicator';
                indicator.setAttribute('data-index', i.toString());
                if (i === 0) indicator.setAttribute('data-active', 'true');
                indicator.setAttribute('aria-label', `Go to slide ${i + 1}`);
                indicators.appendChild(indicator);
            }
        }
        // Initialize this carousel
        new $034734cddcc39867$var$ImageCarousel(carousel);
    });
}
// Helper to find a suitable container for an image
function $034734cddcc39867$var$findClosestContainer(element, carousel) {
    let current = element;
    while(current && !current.contains(carousel) && current !== document.body){
        // Stop at these elements
        if (current.tagName === 'P' || current.tagName === 'DIV' || current.classList.contains('carousel-container')) return current;
        current = current.parentElement;
    }
    return element;
}
// Helper to find the section containing a carousel
function $034734cddcc39867$var$findSectionForCarousel(carousel) {
    // Look for containing section, article, or main element
    let section = carousel.closest('section, article, main, div.markdown-content');
    if (!section) // Fallback to parent element
    section = carousel.parentElement;
    return section;
}
// Initialize all carousels when DOM is loaded
document.addEventListener('DOMContentLoaded', ()=>{
    $034734cddcc39867$export$6c5c949207b4b264();
});



var $iW1oU = parcelRequire("iW1oU");
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $b053670add32783c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $225372f33665d118$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $67c84f7b9d68974e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $67c84f7b9d68974e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $67c84f7b9d68974e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $89d890c165874cff$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || !(0, $b053670add32783c$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $89d890c165874cff$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || !(0, $b053670add32783c$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $89d890c165874cff$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $89d890c165874cff$var$applyStyles,
    effect: $89d890c165874cff$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $e0beaf1fc26deee3$export$8960430cfd85939f = Math.max;
var $e0beaf1fc26deee3$export$96ec731ed4dcb222 = Math.min;
var $e0beaf1fc26deee3$export$2077e0241d6afd3c = Math.round;



function $6394c1ff52742048$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $df11fd8e9d8c1389$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
}


function $1a6f7dd7003a50a1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? (0, $225372f33665d118$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $df11fd8e9d8c1389$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $1ed31100e25348a7$export$2e2bcd8739ae039(node) {
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $729cc555c22ff063$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $bfa783b4c9ad111f$export$2e2bcd8739ae039(node) {
    if (node === (0, $225372f33665d118$export$2e2bcd8739ae039)(node) || !(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(node)) return (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(node);
    else return (0, $729cc555c22ff063$export$2e2bcd8739ae039)(node);
}






function $1d3b5d4e772ef8d4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $9875449f0bf8dff4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)((0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element)).left + (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $c125cc314f75f1af$export$2e2bcd8739ae039(element) {
    return (0, $225372f33665d118$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $a527afd9af1fd91d$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d861eebf1f8322fe$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d861eebf1f8322fe$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent) && $d861eebf1f8322fe$var$isElementScaled(offsetParent);
    var documentElement = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $bfa783b4c9ad111f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $c0579089f336dea9$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $49c4da5606d9971e$export$2e2bcd8739ae039(element) {
    if ((0, $b053670add32783c$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c2945e92d9880f1c$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(node) && (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(node)) return node;
    return $c2945e92d9880f1c$export$2e2bcd8739ae039((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(node));
}





function $354a82c9e8edb67d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c2945e92d9880f1c$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($354a82c9e8edb67d$export$2e2bcd8739ae039((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(target)));
}







function $d29f6785fa19ef29$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(element)) >= 0;
}




function $1fdd6cf5db426e4d$var$getTrueOffsetParent(element) {
    if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1fdd6cf5db426e4d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
    if (isIE && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $49c4da5606d9971e$export$2e2bcd8739ae039)(element);
    if ((0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1fdd6cf5db426e4d$export$2e2bcd8739ae039(element) {
    var window = (0, $225372f33665d118$export$2e2bcd8739ae039)(element);
    var offsetParent = $1fdd6cf5db426e4d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d29f6785fa19ef29$export$2e2bcd8739ae039)(offsetParent) && (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $1fdd6cf5db426e4d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $1fdd6cf5db426e4d$var$getContainingBlock(element) || window;
}


var $a94704e3133fbe16$export$1e95b668f3b82d = 'top';
var $a94704e3133fbe16$export$40e543e69a8b3fbb = 'bottom';
var $a94704e3133fbe16$export$79ffe56a765070d2 = 'right';
var $a94704e3133fbe16$export$eabcd2c8791e7bf4 = 'left';
var $a94704e3133fbe16$export$dfb5619354ba860 = 'auto';
var $a94704e3133fbe16$export$aec2ce47c367b8c3 = [
    $a94704e3133fbe16$export$1e95b668f3b82d,
    $a94704e3133fbe16$export$40e543e69a8b3fbb,
    $a94704e3133fbe16$export$79ffe56a765070d2,
    $a94704e3133fbe16$export$eabcd2c8791e7bf4
];
var $a94704e3133fbe16$export$b3571188c770cc5a = 'start';
var $a94704e3133fbe16$export$bd5df0f255a350f8 = 'end';
var $a94704e3133fbe16$export$390fd549c5303b4d = 'clippingParents';
var $a94704e3133fbe16$export$d7b7311ec04a3e8f = 'viewport';
var $a94704e3133fbe16$export$ae5ab1c730825774 = 'popper';
var $a94704e3133fbe16$export$ca50aac9f3ba507f = 'reference';
var $a94704e3133fbe16$export$368f9a87e87fa4e1 = /*#__PURE__*/ $a94704e3133fbe16$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $a94704e3133fbe16$export$b3571188c770cc5a,
        placement + "-" + $a94704e3133fbe16$export$bd5df0f255a350f8
    ]);
}, []);
var $a94704e3133fbe16$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($a94704e3133fbe16$export$aec2ce47c367b8c3, [
    $a94704e3133fbe16$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $a94704e3133fbe16$export$b3571188c770cc5a,
        placement + "-" + $a94704e3133fbe16$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $a94704e3133fbe16$export$421679a7c3d56e = 'beforeRead';
var $a94704e3133fbe16$export$aafa59e2e03f2942 = 'read';
var $a94704e3133fbe16$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $a94704e3133fbe16$export$c65e99957a05207c = 'beforeMain';
var $a94704e3133fbe16$export$f22da7240b7add18 = 'main';
var $a94704e3133fbe16$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $a94704e3133fbe16$export$8d4d2d70e7d46032 = 'beforeWrite';
var $a94704e3133fbe16$export$68d8715fc104d294 = 'write';
var $a94704e3133fbe16$export$70a6e5159acce2e6 = 'afterWrite';
var $a94704e3133fbe16$export$d087d3878fdf71d5 = [
    $a94704e3133fbe16$export$421679a7c3d56e,
    $a94704e3133fbe16$export$aafa59e2e03f2942,
    $a94704e3133fbe16$export$6964f6c886723980,
    $a94704e3133fbe16$export$c65e99957a05207c,
    $a94704e3133fbe16$export$f22da7240b7add18,
    $a94704e3133fbe16$export$bab79516f2d662fe,
    $a94704e3133fbe16$export$8d4d2d70e7d46032,
    $a94704e3133fbe16$export$68d8715fc104d294,
    $a94704e3133fbe16$export$70a6e5159acce2e6
];


function $3ba14eba4f91aa83$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3ba14eba4f91aa83$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3ba14eba4f91aa83$var$order(modifiers); // order based on phase
    return (0, $a94704e3133fbe16$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0f1640117aceffba$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $fe67b122da4891e2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $5bebade71559124e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $5bebade71559124e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $5bebade71559124e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $5bebade71559124e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $5bebade71559124e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(reference) ? (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3ba14eba4f91aa83$export$2e2bcd8739ae039)((0, $fe67b122da4891e2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$5bebade71559124e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d861eebf1f8322fe$export$2e2bcd8739ae039)(reference, (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $c0579089f336dea9$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0f1640117aceffba$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$5bebade71559124e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $5bebade71559124e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $5bebade71559124e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $41bc2dfc6eb96248$var$passive = {
    passive: true
};
function $41bc2dfc6eb96248$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $225372f33665d118$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $41bc2dfc6eb96248$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $41bc2dfc6eb96248$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $41bc2dfc6eb96248$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $41bc2dfc6eb96248$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $41bc2dfc6eb96248$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $41bc2dfc6eb96248$var$effect,
    data: {}
};



function $62df636877274c69$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $873b81dce61132cd$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $8cdaee54ad91b509$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $36cc5fd00eec4fbb$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $62df636877274c69$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $a94704e3133fbe16$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $a94704e3133fbe16$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $a94704e3133fbe16$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $a94704e3133fbe16$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $a94704e3133fbe16$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $a94704e3133fbe16$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $13f1c3bc9b36621c$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $36cc5fd00eec4fbb$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $13f1c3bc9b36621c$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $13f1c3bc9b36621c$var$popperOffsets,
    data: {}
};










var $5106537fe02a42d1$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $5106537fe02a42d1$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $5106537fe02a42d1$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
    var sideY = (0, $a94704e3133fbe16$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $225372f33665d118$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(popper);
            if ((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $a94704e3133fbe16$export$1e95b668f3b82d) || (placement === (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) || placement === (0, $a94704e3133fbe16$export$79ffe56a765070d2)) && variation === (0, $a94704e3133fbe16$export$bd5df0f255a350f8)) {
            sideY = (0, $a94704e3133fbe16$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) || (placement === (0, $a94704e3133fbe16$export$1e95b668f3b82d) || placement === (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)) && variation === (0, $a94704e3133fbe16$export$bd5df0f255a350f8)) {
            sideX = (0, $a94704e3133fbe16$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $5106537fe02a42d1$var$unsetSides);
    var _ref4 = roundOffsets === true ? $5106537fe02a42d1$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $225372f33665d118$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $5106537fe02a42d1$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $873b81dce61132cd$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $5106537fe02a42d1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $5106537fe02a42d1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5106537fe02a42d1$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $5106537fe02a42d1$var$computeStyles,
    data: {}
};





function $bea6e8d498694752$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $bea6e8d498694752$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $a94704e3133fbe16$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $bea6e8d498694752$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bea6e8d498694752$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $bea6e8d498694752$var$offset
};


var $d8d1c19fcab8b98a$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d8d1c19fcab8b98a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d8d1c19fcab8b98a$var$hash[matched];
    });
}



var $3d8b1e96ae7b2b33$var$hash = {
    start: 'end',
    end: 'start'
};
function $3d8b1e96ae7b2b33$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3d8b1e96ae7b2b33$var$hash[matched];
    });
}







function $99269cfb0c30a849$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(element);
    var html = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $df11fd8e9d8c1389$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e10e7e39ab68972d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fe95fa72fab69498$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $dec119a2e5377521$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $b15c2dc09d4d708d$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $a94704e3133fbe16$export$d7b7311ec04a3e8f) ? (0, $dec119a2e5377521$export$2e2bcd8739ae039)((0, $99269cfb0c30a849$export$2e2bcd8739ae039)(element, strategy)) : (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clippingParent) ? $b15c2dc09d4d708d$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $dec119a2e5377521$export$2e2bcd8739ae039)((0, $e10e7e39ab68972d$export$2e2bcd8739ae039)((0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b15c2dc09d4d708d$var$getClippingParents(element) {
    var clippingParents = (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) ? (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fe95fa72fab69498$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b053670add32783c$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b15c2dc09d4d708d$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $b15c2dc09d4d708d$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $f7baa3d7766ddfd5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $c11f65b1ae4396ba$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f7baa3d7766ddfd5$export$2e2bcd8739ae039)(), paddingObject);
}


function $8c698fce3c6fce96$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $724adaa25380997c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $a94704e3133fbe16$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $a94704e3133fbe16$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $a94704e3133fbe16$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $c11f65b1ae4396ba$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $8c698fce3c6fce96$export$2e2bcd8739ae039)(padding, (0, $a94704e3133fbe16$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) ? (0, $a94704e3133fbe16$export$ca50aac9f3ba507f) : (0, $a94704e3133fbe16$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $b15c2dc09d4d708d$export$2e2bcd8739ae039)((0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $36cc5fd00eec4fbb$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $dec119a2e5377521$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $a94704e3133fbe16$export$79ffe56a765070d2),
                (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $a94704e3133fbe16$export$1e95b668f3b82d),
                (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $f977f9f0436520a0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $a94704e3133fbe16$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $a94704e3133fbe16$export$368f9a87e87fa4e1) : (0, $a94704e3133fbe16$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $a94704e3133fbe16$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $62df636877274c69$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $5fa2f8fc84eb9429$var$getExpandedFallbackPlacements(placement) {
    if ((0, $62df636877274c69$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3d8b1e96ae7b2b33$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3d8b1e96ae7b2b33$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $5fa2f8fc84eb9429$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $5fa2f8fc84eb9429$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $62df636877274c69$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$dfb5619354ba860) ? (0, $f977f9f0436520a0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$b3571188c770cc5a);
        var isVertical = [
            (0, $a94704e3133fbe16$export$1e95b668f3b82d),
            (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $a94704e3133fbe16$export$79ffe56a765070d2) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5fa2f8fc84eb9429$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $5fa2f8fc84eb9429$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $4f97934e8dbef3cc$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $711bed0e4fb75d3f$export$f28d906d67a997f3(min, value, max) {
    return (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(min, (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(value, max));
}
function $711bed0e4fb75d3f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $711bed0e4fb75d3f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $0598b84f7e68d489$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4f97934e8dbef3cc$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $a94704e3133fbe16$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $a94704e3133fbe16$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c0579089f336dea9$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $f7baa3d7766ddfd5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(tether ? (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $a94704e3133fbe16$export$1e95b668f3b82d),
            (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $711bed0e4fb75d3f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0598b84f7e68d489$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $0598b84f7e68d489$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $671483b845900ee3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $c11f65b1ae4396ba$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $8c698fce3c6fce96$export$2e2bcd8739ae039)(padding, (0, $a94704e3133fbe16$export$aec2ce47c367b8c3)));
};
function $671483b845900ee3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $671483b845900ee3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c0579089f336dea9$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $671483b845900ee3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fe95fa72fab69498$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $671483b845900ee3$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $671483b845900ee3$var$arrow,
    effect: $671483b845900ee3$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $be0e5a97b5c4f0a9$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $a94704e3133fbe16$export$1e95b668f3b82d),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2),
        (0, $a94704e3133fbe16$export$40e543e69a8b3fbb),
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $be0e5a97b5c4f0a9$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $be0e5a97b5c4f0a9$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $be0e5a97b5c4f0a9$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $be0e5a97b5c4f0a9$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $be0e5a97b5c4f0a9$var$hide
};




var $55c7f2385d3e922b$export$d34966752335dd47 = [
    (0, $41bc2dfc6eb96248$export$2e2bcd8739ae039),
    (0, $13f1c3bc9b36621c$export$2e2bcd8739ae039),
    (0, $5106537fe02a42d1$export$2e2bcd8739ae039),
    (0, $89d890c165874cff$export$2e2bcd8739ae039),
    (0, $bea6e8d498694752$export$2e2bcd8739ae039),
    (0, $5fa2f8fc84eb9429$export$2e2bcd8739ae039),
    (0, $0598b84f7e68d489$export$2e2bcd8739ae039),
    (0, $671483b845900ee3$export$2e2bcd8739ae039),
    (0, $be0e5a97b5c4f0a9$export$2e2bcd8739ae039)
];
var $55c7f2385d3e922b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5bebade71559124e$export$ed5e13716264f202)({
    defaultModifiers: $55c7f2385d3e922b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $95051df85825bf2c$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $95051df85825bf2c$var$BOX_CLASS = "tippy-box";
var $95051df85825bf2c$var$CONTENT_CLASS = "tippy-content";
var $95051df85825bf2c$var$BACKDROP_CLASS = "tippy-backdrop";
var $95051df85825bf2c$var$ARROW_CLASS = "tippy-arrow";
var $95051df85825bf2c$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $95051df85825bf2c$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $95051df85825bf2c$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $95051df85825bf2c$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $95051df85825bf2c$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $95051df85825bf2c$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $95051df85825bf2c$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $95051df85825bf2c$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $95051df85825bf2c$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $95051df85825bf2c$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $95051df85825bf2c$var$normalizeToArray(value) {
    return [].concat(value);
}
function $95051df85825bf2c$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $95051df85825bf2c$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $95051df85825bf2c$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $95051df85825bf2c$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $95051df85825bf2c$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $95051df85825bf2c$var$div() {
    return document.createElement('div');
}
function $95051df85825bf2c$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $95051df85825bf2c$var$isType(value, type);
    });
}
function $95051df85825bf2c$var$isNodeList(value) {
    return $95051df85825bf2c$var$isType(value, 'NodeList');
}
function $95051df85825bf2c$var$isMouseEvent(value) {
    return $95051df85825bf2c$var$isType(value, 'MouseEvent');
}
function $95051df85825bf2c$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $95051df85825bf2c$var$getArrayOfElements(value) {
    if ($95051df85825bf2c$var$isElement(value)) return [
        value
    ];
    if ($95051df85825bf2c$var$isNodeList(value)) return $95051df85825bf2c$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $95051df85825bf2c$var$arrayFrom(document.querySelectorAll(value));
}
function $95051df85825bf2c$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $95051df85825bf2c$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $95051df85825bf2c$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $95051df85825bf2c$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $95051df85825bf2c$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $95051df85825bf2c$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $95051df85825bf2c$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $95051df85825bf2c$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $95051df85825bf2c$var$currentInput = {
    isTouch: false
};
var $95051df85825bf2c$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $95051df85825bf2c$var$onDocumentTouchStart() {
    if ($95051df85825bf2c$var$currentInput.isTouch) return;
    $95051df85825bf2c$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $95051df85825bf2c$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $95051df85825bf2c$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $95051df85825bf2c$var$lastMouseMoveTime < 20) {
        $95051df85825bf2c$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $95051df85825bf2c$var$onDocumentMouseMove);
    }
    $95051df85825bf2c$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $95051df85825bf2c$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($95051df85825bf2c$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $95051df85825bf2c$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $95051df85825bf2c$var$onDocumentTouchStart, $95051df85825bf2c$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $95051df85825bf2c$var$onWindowBlur);
}
var $95051df85825bf2c$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $95051df85825bf2c$var$isIE11 = $95051df85825bf2c$var$isBrowser ? !!window.msCrypto : false;
function $95051df85825bf2c$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $95051df85825bf2c$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $95051df85825bf2c$var$getDevMessage(message) {
    return $95051df85825bf2c$var$clean("\n  %ctippy.js\n\n  %c" + $95051df85825bf2c$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $95051df85825bf2c$var$getFormattedMessage(message) {
    return [
        $95051df85825bf2c$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $95051df85825bf2c$var$visitedMessages;
function $95051df85825bf2c$var$resetVisitedMessages() {
    $95051df85825bf2c$var$visitedMessages = new Set();
}
function $95051df85825bf2c$var$warnWhen(condition, message) {
    if (condition && !$95051df85825bf2c$var$visitedMessages.has(message)) {
        var _console;
        $95051df85825bf2c$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $95051df85825bf2c$var$getFormattedMessage(message));
    }
}
function $95051df85825bf2c$var$errorWhen(condition, message) {
    if (condition && !$95051df85825bf2c$var$visitedMessages.has(message)) {
        var _console2;
        $95051df85825bf2c$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $95051df85825bf2c$var$getFormattedMessage(message));
    }
}
function $95051df85825bf2c$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $95051df85825bf2c$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $95051df85825bf2c$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $95051df85825bf2c$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $95051df85825bf2c$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $95051df85825bf2c$var$defaultProps = Object.assign({
    appendTo: $95051df85825bf2c$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $95051df85825bf2c$var$pluginProps, $95051df85825bf2c$var$renderProps);
var $95051df85825bf2c$var$defaultKeys = Object.keys($95051df85825bf2c$var$defaultProps);
var $95051df85825bf2c$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $95051df85825bf2c$var$defaultProps[key] = partialProps[key];
    });
};
function $95051df85825bf2c$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $95051df85825bf2c$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $95051df85825bf2c$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($95051df85825bf2c$var$getExtendedPassedProps(Object.assign({}, $95051df85825bf2c$var$defaultProps, {
        plugins: plugins
    }))) : $95051df85825bf2c$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $95051df85825bf2c$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $95051df85825bf2c$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $95051df85825bf2c$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $95051df85825bf2c$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $95051df85825bf2c$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $95051df85825bf2c$var$removeProperties($95051df85825bf2c$var$defaultProps, Object.keys($95051df85825bf2c$var$pluginProps));
        var didPassUnknownProp = !$95051df85825bf2c$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $95051df85825bf2c$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $95051df85825bf2c$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $95051df85825bf2c$var$dangerouslySetInnerHTML(element, html) {
    element[$95051df85825bf2c$var$innerHTML()] = html;
}
function $95051df85825bf2c$var$createArrowElement(value) {
    var arrow = $95051df85825bf2c$var$div();
    if (value === true) arrow.className = $95051df85825bf2c$var$ARROW_CLASS;
    else {
        arrow.className = $95051df85825bf2c$var$SVG_ARROW_CLASS;
        if ($95051df85825bf2c$var$isElement(value)) arrow.appendChild(value);
        else $95051df85825bf2c$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $95051df85825bf2c$var$setContent(content, props) {
    if ($95051df85825bf2c$var$isElement(props.content)) {
        $95051df85825bf2c$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $95051df85825bf2c$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $95051df85825bf2c$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $95051df85825bf2c$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($95051df85825bf2c$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($95051df85825bf2c$var$ARROW_CLASS) || node.classList.contains($95051df85825bf2c$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($95051df85825bf2c$var$BACKDROP_CLASS);
        })
    };
}
function $95051df85825bf2c$var$render(instance) {
    var popper = $95051df85825bf2c$var$div();
    var box = $95051df85825bf2c$var$div();
    box.className = $95051df85825bf2c$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $95051df85825bf2c$var$div();
    content.className = $95051df85825bf2c$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $95051df85825bf2c$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $95051df85825bf2c$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $95051df85825bf2c$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($95051df85825bf2c$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($95051df85825bf2c$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$95051df85825bf2c$var$render.$$tippy = true;
var $95051df85825bf2c$var$idCounter = 1;
var $95051df85825bf2c$var$mouseMoveListeners = []; // Used by `hideAll()`
var $95051df85825bf2c$var$mountedInstances = [];
function $95051df85825bf2c$var$createTippy(reference, passedProps) {
    var props = $95051df85825bf2c$var$evaluateProps(reference, Object.assign({}, $95051df85825bf2c$var$defaultProps, $95051df85825bf2c$var$getExtendedPassedProps($95051df85825bf2c$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $95051df85825bf2c$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $95051df85825bf2c$var$idCounter++;
    var popperInstance = null;
    var plugins = $95051df85825bf2c$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $95051df85825bf2c$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $95051df85825bf2c$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $95051df85825bf2c$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $95051df85825bf2c$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $95051df85825bf2c$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $95051df85825bf2c$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $95051df85825bf2c$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $95051df85825bf2c$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $95051df85825bf2c$var$mouseMoveListeners = $95051df85825bf2c$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($95051df85825bf2c$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $95051df85825bf2c$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($95051df85825bf2c$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $95051df85825bf2c$var$actualContains(el, actualTarget);
        })) {
            if ($95051df85825bf2c$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $95051df85825bf2c$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $95051df85825bf2c$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $95051df85825bf2c$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $95051df85825bf2c$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $95051df85825bf2c$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $95051df85825bf2c$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $95051df85825bf2c$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $95051df85825bf2c$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $95051df85825bf2c$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $95051df85825bf2c$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $95051df85825bf2c$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($95051df85825bf2c$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $95051df85825bf2c$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $95051df85825bf2c$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($95051df85825bf2c$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $95051df85825bf2c$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $95051df85825bf2c$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $55c7f2385d3e922b$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $95051df85825bf2c$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $95051df85825bf2c$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $95051df85825bf2c$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($95051df85825bf2c$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $95051df85825bf2c$var$evaluateProps(reference, Object.assign({}, prevProps, $95051df85825bf2c$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $95051df85825bf2c$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $95051df85825bf2c$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $95051df85825bf2c$var$currentInput.isTouch && !instance.props.touch;
        var duration = $95051df85825bf2c$var$getValueAtIndexOrReturn(instance.props.duration, 0, $95051df85825bf2c$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $95051df85825bf2c$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $95051df85825bf2c$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $95051df85825bf2c$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $95051df85825bf2c$var$pushIfUnique($95051df85825bf2c$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $95051df85825bf2c$var$getValueAtIndexOrReturn(instance.props.duration, 1, $95051df85825bf2c$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $95051df85825bf2c$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $95051df85825bf2c$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $95051df85825bf2c$var$pushIfUnique($95051df85825bf2c$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $95051df85825bf2c$var$mountedInstances = $95051df85825bf2c$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $95051df85825bf2c$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $95051df85825bf2c$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $95051df85825bf2c$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $95051df85825bf2c$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $95051df85825bf2c$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $95051df85825bf2c$var$isElement(targets) ? instances[0] : instances;
}
$95051df85825bf2c$var$tippy.defaultProps = $95051df85825bf2c$var$defaultProps;
$95051df85825bf2c$var$tippy.setDefaultProps = $95051df85825bf2c$var$setDefaultProps;
$95051df85825bf2c$var$tippy.currentInput = $95051df85825bf2c$var$currentInput;
var $95051df85825bf2c$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $95051df85825bf2c$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $95051df85825bf2c$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $95051df85825bf2c$var$applyStylesModifier = Object.assign({}, (0, $89d890c165874cff$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $95051df85825bf2c$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $95051df85825bf2c$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $95051df85825bf2c$var$tippy($95051df85825bf2c$var$div(), Object.assign({}, $95051df85825bf2c$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $95051df85825bf2c$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $95051df85825bf2c$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $95051df85825bf2c$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $95051df85825bf2c$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $95051df85825bf2c$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $95051df85825bf2c$var$tippy(targets, parentProps);
    var normalizedReturnValue = $95051df85825bf2c$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $95051df85825bf2c$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($95051df85825bf2c$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $95051df85825bf2c$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $95051df85825bf2c$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $95051df85825bf2c$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $95051df85825bf2c$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $95051df85825bf2c$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $95051df85825bf2c$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $95051df85825bf2c$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $95051df85825bf2c$var$createBackdropElement() {
    var backdrop = $95051df85825bf2c$var$div();
    backdrop.className = $95051df85825bf2c$var$BACKDROP_CLASS;
    $95051df85825bf2c$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $95051df85825bf2c$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $95051df85825bf2c$var$activeInstances = [];
function $95051df85825bf2c$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $95051df85825bf2c$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $95051df85825bf2c$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $95051df85825bf2c$var$storeMouseCoords);
}
function $95051df85825bf2c$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $95051df85825bf2c$var$storeMouseCoords);
}
var $95051df85825bf2c$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $95051df85825bf2c$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $95051df85825bf2c$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $95051df85825bf2c$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $95051df85825bf2c$var$activeInstances = $95051df85825bf2c$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($95051df85825bf2c$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $95051df85825bf2c$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($95051df85825bf2c$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($95051df85825bf2c$var$isMouseEvent(event)) $95051df85825bf2c$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $95051df85825bf2c$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $95051df85825bf2c$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $95051df85825bf2c$var$getInlineBoundingClientRect($95051df85825bf2c$var$getBasePlacement(placement), reference.getBoundingClientRect(), $95051df85825bf2c$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($95051df85825bf2c$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($95051df85825bf2c$var$isMouseEvent(event)) {
                    var rects = $95051df85825bf2c$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $95051df85825bf2c$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $95051df85825bf2c$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $95051df85825bf2c$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $95051df85825bf2c$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $95051df85825bf2c$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$95051df85825bf2c$var$tippy.setDefaultProps({
    render: $95051df85825bf2c$var$render
});
var $95051df85825bf2c$export$2e2bcd8739ae039 = $95051df85825bf2c$var$tippy;


document.addEventListener('htmx:load', function() {
    const selector = [
        '.applies [data-tippy-content]:not([data-tippy-content=""])',
        '.applies-inline [data-tippy-content]:not([data-tippy-content=""])'
    ].join(', ');
    const appliesToBadgesWithTooltip = (0, $iW1oU.$$)(selector);
    appliesToBadgesWithTooltip.forEach((badge)=>{
        const content = badge.getAttribute('data-tippy-content');
        if (!content) return;
        (0, $95051df85825bf2c$export$2e2bcd8739ae039)(badge, {
            content: content,
            allowHTML: true,
            delay: [
                400,
                100
            ],
            hideOnClick: false,
            ignoreAttributes: true,
            theme: 'applies-to'
        });
    });
});



var $4Bp2X = parcelRequire("4Bp2X");
const $f4845c9feb6b8f9d$var$parser = new (0, $4Bp2X.UAParser)();
const $f4845c9feb6b8f9d$var$browser = $f4845c9feb6b8f9d$var$parser.getBrowser();
function $f4845c9feb6b8f9d$export$b352f2ce836dda92() {
    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
            const closestDetails = target.closest('details');
            if (closestDetails) {
                if ($f4845c9feb6b8f9d$var$browser.name !== 'Chrome') {
                    closestDetails.open = true;
                    target.scrollIntoView({
                        behavior: 'instant',
                        block: 'start'
                    });
                }
            }
        }
    }
}



var $iW1oU = parcelRequire("iW1oU");
function $382b6492841cb628$var$expandAllParents(navItem) {
    let parent = navItem?.closest('li');
    while(parent){
        const input = parent.querySelector('input');
        if (input instanceof HTMLInputElement) input.checked = true;
        parent = parent.parentElement?.closest('li');
    }
}
function $382b6492841cb628$var$scrollCurrentNaviItemIntoView(nav) {
    const currentNavItem = (0, $iW1oU.$)('.current', nav);
    if (currentNavItem) $382b6492841cb628$var$expandAllParents(currentNavItem);
    if (currentNavItem && !$382b6492841cb628$var$isElementInViewport(nav, currentNavItem)) {
        const navRect = nav.getBoundingClientRect();
        const currentNavItemRect = currentNavItem.getBoundingClientRect();
        // Calculate the offset needed to scroll the current navigation item into view.
        // The offset is determined by the difference between the top of the current navigation item and the top of the navigation container,
        // adjusted by one-third of the height of the navigation container and half the height of the current navigation item.
        const offset = currentNavItemRect.top - navRect.top - navRect.height / 3 + currentNavItemRect.height / 2;
        // Scroll the navigation container by the calculated offset to bring the current navigation item into view.
        nav.scrollTop = nav.scrollTop + offset;
    }
}
function $382b6492841cb628$var$isElementInViewport(parent, child) {
    const childRect = child.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    return childRect.top >= parentRect.top && childRect.left >= parentRect.left && childRect.bottom <= parentRect.bottom && childRect.right <= parentRect.right;
}
function $382b6492841cb628$var$setDropdown(dropdown) {
    if (dropdown) {
        const anchors = (0, $iW1oU.$$)('a', dropdown);
        anchors.forEach((a)=>{
            a.addEventListener('mousedown', (e)=>{
                e.preventDefault();
            });
            a.addEventListener('mouseup', ()=>{
                if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
            });
        });
    }
}
function $382b6492841cb628$export$240cd81d1fa164a8() {
    const pagesNav = (0, $iW1oU.$)('#pages-nav');
    if (!pagesNav) return;
    const pagesDropdown = (0, $iW1oU.$)('#pages-dropdown');
    if (pagesDropdown) $382b6492841cb628$var$setDropdown(pagesDropdown);
    const pageVersionDropdown = (0, $iW1oU.$)('#page-version-dropdown');
    if (pageVersionDropdown) $382b6492841cb628$var$setDropdown(pageVersionDropdown);
    const navItems = (0, $iW1oU.$$)('a[href="' + window.location.pathname + '"], a[href="' + window.location.pathname + '/"]', pagesNav);
    navItems.forEach((el)=>{
        el.classList.add('current');
    });
    $382b6492841cb628$var$scrollCurrentNaviItemIntoView(pagesNav);
}



var $iW1oU = parcelRequire("iW1oU");
function $ca337ca22fc67714$export$22e4029a4c2fac28() {
    (0, $iW1oU.$$)('#markdown-content a[href^="#"]').forEach((el)=>{
        el.addEventListener('click', (e)=>{
            // Using ! because href is guaranteed to be present due to the selector
            const id = el.getAttribute('href').slice(1) // remove the '#' character
            ;
            const target = document.getElementById(id);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth'
                });
                history.pushState(null, '', el.getAttribute('href'));
            }
        });
    });
}


// TODO: refactor to typescript. this was copied from the previous implementation
// @ts-check
// Extra JS capability for selected tabs to be synced
// The selection is stored in local storage so that it persists across page loads.
const $f19041c76187fb4a$var$sd_id_to_elements = {};
const $f19041c76187fb4a$var$storageKeyPrefix = 'tab-id-';
function $f19041c76187fb4a$var$create_key(el) {
    const syncId = el.getAttribute('data-sync-id');
    const syncGroup = el.getAttribute('data-sync-group');
    if (!syncId || !syncGroup) return null;
    return [
        syncGroup,
        syncId,
        syncGroup + '--' + syncId
    ];
}
/**
 * Initialize the tab selection.
 *
 */ function $f19041c76187fb4a$var$ready() {
    // Find all tabs with sync data
    const groups = [];
    document.querySelectorAll('.tabs-label').forEach((label)=>{
        if (label instanceof HTMLElement) {
            const data = $f19041c76187fb4a$var$create_key(label);
            if (data) {
                const [group, id, key] = data;
                // add click event listener
                label.addEventListener('click', $f19041c76187fb4a$var$onSDLabelClick);
                // store map of key to elements
                if (!$f19041c76187fb4a$var$sd_id_to_elements[key]) $f19041c76187fb4a$var$sd_id_to_elements[key] = [];
                $f19041c76187fb4a$var$sd_id_to_elements[key].push(label);
                if (groups.indexOf(group) === -1) {
                    groups.push(group);
                    // Check if a specific tab has been selected via URL parameter
                    const tabParam = new URLSearchParams(window.location.search).get(group);
                    if (tabParam) window.sessionStorage.setItem($f19041c76187fb4a$var$storageKeyPrefix + group, tabParam);
                }
                // Check is a specific tab has been selected previously
                const previousId = window.sessionStorage.getItem($f19041c76187fb4a$var$storageKeyPrefix + group);
                if (previousId === id) label.previousElementSibling.checked = true;
            }
        }
    });
}
/**
 *  Activate other tabs with the same sync id.
 *
 * @this {HTMLElement} - The element that was clicked.
 */ function $f19041c76187fb4a$var$onSDLabelClick() {
    const data = $f19041c76187fb4a$var$create_key(this);
    if (!data) return;
    const [group, id, key] = data;
    for (const label of $f19041c76187fb4a$var$sd_id_to_elements[key]){
        if (label === this) continue;
        if (label.previousElementSibling instanceof HTMLInputElement) label.previousElementSibling.checked = true;
    }
    window.sessionStorage.setItem($f19041c76187fb4a$var$storageKeyPrefix + group, id);
}
function $f19041c76187fb4a$export$c92e8f569ad2976f() {
    $f19041c76187fb4a$var$ready();
}


/**
 * OpenTelemetry configuration for frontend telemetry.
 * Sends traces and logs to the backend OTLP proxy endpoint.
 *
 * This module should be imported once at application startup.
 * All web components will automatically be instrumented once initialized.
 *
 * Inspired by: https://signoz.io/docs/frontend-monitoring/sending-logs-with-opentelemetry/
 */ 
var $6DjHV = parcelRequire("6DjHV");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /// <reference types="zone.js" />

var $fJacQ = parcelRequire("fJacQ");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * check if an object has `addEventListener` and `removeEventListener` functions.
 * Generally only called with a `TargetWithEvents` but may be called with an `unknown` value.
 * @param obj - The object to check.
 */ function $12cb2363344c9b88$export$8b321bf7829ce743(obj) {
    return typeof obj === 'object' && obj !== null && 'addEventListener' in obj && typeof obj.addEventListener === 'function' && 'removeEventListener' in obj && typeof obj.removeEventListener === 'function';
}


/* Key name to be used to save a context reference in Zone */ const $20fe425914a301d6$var$ZONE_CONTEXT_KEY = 'OT_ZONE_CONTEXT';
class $20fe425914a301d6$export$148434e42b84e81c {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Helps to create a unique name for the zones - part of zone name
     */ _zoneCounter = 0;
    /**
     * Returns the active context from certain zone name
     * @param activeZone
     */ _activeContextFromZone(activeZone) {
        return activeZone && activeZone.get($20fe425914a301d6$var$ZONE_CONTEXT_KEY) || (0, $fJacQ.ROOT_CONTEXT);
    }
    /**
     * @param context A context (span) to be executed within target function
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context, target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * @param context A context (span) to be bind to target
     * @param obj target object on which the listeners will be patched
     */ _bindListener(context, obj) {
        const target = obj;
        if (target.__ot_listeners !== undefined) return obj;
        target.__ot_listeners = {};
        if (typeof target.addEventListener === 'function') target.addEventListener = this._patchAddEventListener(target, target.addEventListener, context);
        if (typeof target.removeEventListener === 'function') target.removeEventListener = this._patchRemoveEventListener(target, target.removeEventListener);
        return obj;
    }
    /**
     * Creates a new unique zone name
     */ _createZoneName() {
        this._zoneCounter++;
        const random = Math.random();
        return `${this._zoneCounter}-${random}`;
    }
    /**
     * Creates a new zone
     * @param zoneName zone name
     * @param context A context (span) to be bind with Zone
     */ _createZone(zoneName, context) {
        return Zone.current.fork({
            name: zoneName,
            properties: {
                [$20fe425914a301d6$var$ZONE_CONTEXT_KEY]: context
            }
        });
    }
    /**
     * Returns the active zone
     */ _getActiveZone() {
        return Zone.current;
    }
    /**
     * Patches addEventListener method
     * @param target any target that has "addEventListener" method
     * @param original reference to the patched method
     * @param [context] context to be bind to the listener
     */ _patchAddEventListener(target, original, context) {
        const contextManager = this;
        return function(event, listener, opts) {
            if (target.__ot_listeners === undefined) target.__ot_listeners = {};
            let listeners = target.__ot_listeners[event];
            if (listeners === undefined) {
                listeners = new WeakMap();
                target.__ot_listeners[event] = listeners;
            }
            const patchedListener = contextManager.bind(context, listener);
            // store a weak reference of the user listener to ours
            listeners.set(listener, patchedListener);
            return original.call(this, event, patchedListener, opts);
        };
    }
    /**
     * Patches removeEventListener method
     * @param target any target that has "removeEventListener" method
     * @param original reference to the patched method
     */ _patchRemoveEventListener(target, original) {
        return function(event, listener) {
            if (target.__ot_listeners === undefined || target.__ot_listeners[event] === undefined) return original.call(this, event, listener);
            const events = target.__ot_listeners[event];
            const patchedListener = events.get(listener);
            events.delete(listener);
            return original.call(this, event, patchedListener || listener);
        };
    }
    /**
     * Returns the active context
     */ active() {
        if (!this._enabled) return 0, $fJacQ.ROOT_CONTEXT;
        const activeZone = this._getActiveZone();
        const active = this._activeContextFromZone(activeZone);
        if (active) return active;
        return 0, $fJacQ.ROOT_CONTEXT;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        else if ((0, $12cb2363344c9b88$export$8b321bf7829ce743)(target)) this._bindListener(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears all the contexts)
     */ disable() {
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        this._enabled = true;
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context].
     *     If [context] is undefined then it will use the active context.
     *     The context will be set as active
     * @param context A context (span) to be called with provided callback
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const zoneName = this._createZoneName();
        const newZone = this._createZone(zoneName, context);
        return newZone.run(fn, thisArg, args);
    }
}


'use strict';
/**
 * @license Angular v<unknown>
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */ const $bcf05a352a8cfaff$var$global = globalThis;
// __Zone_symbol_prefix global can be used to override the default zone
// symbol prefix with a custom one if needed.
function $bcf05a352a8cfaff$var$__symbol__(name) {
    const symbolPrefix = $bcf05a352a8cfaff$var$global['__Zone_symbol_prefix'] || '__zone_symbol__';
    return symbolPrefix + name;
}
function $bcf05a352a8cfaff$var$initZone() {
    const performance = $bcf05a352a8cfaff$var$global['performance'];
    function mark(name) {
        performance && performance['mark'] && performance['mark'](name);
    }
    function performanceMeasure(name, label) {
        performance && performance['measure'] && performance['measure'](name, label);
    }
    mark('Zone');
    class ZoneImpl {
        static __symbol__ = $bcf05a352a8cfaff$var$__symbol__;
        static assertZonePatched() {
            if ($bcf05a352a8cfaff$var$global['Promise'] !== patches['ZoneAwarePromise']) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
        }
        static get root() {
            let zone = ZoneImpl.current;
            while(zone.parent)zone = zone.parent;
            return zone;
        }
        static get current() {
            return _currentZoneFrame.zone;
        }
        static get currentTask() {
            return _currentTask;
        }
        static __load_patch(name, fn, ignoreDuplicate = false) {
            if (patches.hasOwnProperty(name)) {
                // `checkDuplicate` option is defined from global variable
                // so it works for all modules.
                // `ignoreDuplicate` can work for the specified module
                const checkDuplicate = $bcf05a352a8cfaff$var$global[$bcf05a352a8cfaff$var$__symbol__('forceDuplicateZoneCheck')] === true;
                if (!ignoreDuplicate && checkDuplicate) throw Error('Already loaded patch: ' + name);
            } else if (!$bcf05a352a8cfaff$var$global['__Zone_disable_' + name]) {
                const perfName = 'Zone:' + name;
                mark(perfName);
                patches[name] = fn($bcf05a352a8cfaff$var$global, ZoneImpl, _api);
                performanceMeasure(perfName, perfName);
            }
        }
        get parent() {
            return this._parent;
        }
        get name() {
            return this._name;
        }
        _parent;
        _name;
        _properties;
        _zoneDelegate;
        constructor(parent, zoneSpec){
            this._parent = parent;
            this._name = zoneSpec ? zoneSpec.name || 'unnamed' : '<root>';
            this._properties = zoneSpec && zoneSpec.properties || {};
            this._zoneDelegate = new _ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
        }
        get(key) {
            const zone = this.getZoneWith(key);
            if (zone) return zone._properties[key];
        }
        getZoneWith(key) {
            let current = this;
            while(current){
                if (current._properties.hasOwnProperty(key)) return current;
                current = current._parent;
            }
            return null;
        }
        fork(zoneSpec) {
            if (!zoneSpec) throw new Error('ZoneSpec required!');
            return this._zoneDelegate.fork(this, zoneSpec);
        }
        wrap(callback, source) {
            if (typeof callback !== 'function') throw new Error('Expecting function got: ' + callback);
            const _callback = this._zoneDelegate.intercept(this, callback, source);
            const zone = this;
            return function() {
                return zone.runGuarded(_callback, this, arguments, source);
            };
        }
        run(callback, applyThis, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runGuarded(callback, applyThis = null, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                try {
                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runTask(task, applyThis, applyArgs) {
            if (task.zone != this) throw new Error('A task can only be run in the zone of creation! (Creation: ' + (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
            const zoneTask = task;
            // https://github.com/angular/zone.js/issues/778, sometimes eventTask
            // will run in notScheduled(canceled) state, we should not try to
            // run such kind of task but just return
            const { type: type, data: { isPeriodic: isPeriodic = false, isRefreshable: isRefreshable = false } = {} } = task;
            if (task.state === notScheduled && (type === eventTask || type === macroTask)) return;
            const reEntryGuard = task.state != running;
            reEntryGuard && zoneTask._transitionTo(running, scheduled);
            const previousTask = _currentTask;
            _currentTask = zoneTask;
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                if (type == macroTask && task.data && !isPeriodic && !isRefreshable) task.cancelFn = undefined;
                try {
                    return this._zoneDelegate.invokeTask(this, zoneTask, applyThis, applyArgs);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                // if the task's state is notScheduled or unknown, then it has already been cancelled
                // we should not reset the state to scheduled
                const state = task.state;
                if (state !== notScheduled && state !== unknown) {
                    if (type == eventTask || isPeriodic || isRefreshable && state === scheduling) reEntryGuard && zoneTask._transitionTo(scheduled, running, scheduling);
                    else {
                        const zoneDelegates = zoneTask._zoneDelegates;
                        this._updateTaskCount(zoneTask, -1);
                        reEntryGuard && zoneTask._transitionTo(notScheduled, running, notScheduled);
                        if (isRefreshable) zoneTask._zoneDelegates = zoneDelegates;
                    }
                }
                _currentZoneFrame = _currentZoneFrame.parent;
                _currentTask = previousTask;
            }
        }
        scheduleTask(task) {
            if (task.zone && task.zone !== this) {
                // check if the task was rescheduled, the newZone
                // should not be the children of the original zone
                let newZone = this;
                while(newZone){
                    if (newZone === task.zone) throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${task.zone.name}`);
                    newZone = newZone.parent;
                }
            }
            task._transitionTo(scheduling, notScheduled);
            const zoneDelegates = [];
            task._zoneDelegates = zoneDelegates;
            task._zone = this;
            try {
                task = this._zoneDelegate.scheduleTask(this, task);
            } catch (err) {
                // should set task's state to unknown when scheduleTask throw error
                // because the err may from reschedule, so the fromState maybe notScheduled
                task._transitionTo(unknown, scheduling, notScheduled);
                // TODO: @JiaLiPassion, should we check the result from handleError?
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            if (task._zoneDelegates === zoneDelegates) // we have to check because internally the delegate can reschedule the task.
            this._updateTaskCount(task, 1);
            if (task.state == scheduling) task._transitionTo(scheduled, scheduling);
            return task;
        }
        scheduleMicroTask(source, callback, data, customSchedule) {
            return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, undefined));
        }
        scheduleMacroTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
        }
        scheduleEventTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
        }
        cancelTask(task) {
            if (task.zone != this) throw new Error('A task can only be cancelled in the zone of creation! (Creation: ' + (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
            if (task.state !== scheduled && task.state !== running) return;
            task._transitionTo(canceling, scheduled, running);
            try {
                this._zoneDelegate.cancelTask(this, task);
            } catch (err) {
                // if error occurs when cancelTask, transit the state to unknown
                task._transitionTo(unknown, canceling);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            this._updateTaskCount(task, -1);
            task._transitionTo(notScheduled, canceling);
            task.runCount = -1;
            return task;
        }
        _updateTaskCount(task, count) {
            const zoneDelegates = task._zoneDelegates;
            if (count == -1) task._zoneDelegates = null;
            for(let i = 0; i < zoneDelegates.length; i++)zoneDelegates[i]._updateTaskCount(task.type, count);
        }
    }
    const DELEGATE_ZS = {
        name: '',
        onHasTask: (delegate, _, target, hasTaskState)=>delegate.hasTask(target, hasTaskState),
        onScheduleTask: (delegate, _, target, task)=>delegate.scheduleTask(target, task),
        onInvokeTask: (delegate, _, target, task, applyThis, applyArgs)=>delegate.invokeTask(target, task, applyThis, applyArgs),
        onCancelTask: (delegate, _, target, task)=>delegate.cancelTask(target, task)
    };
    class _ZoneDelegate {
        get zone() {
            return this._zone;
        }
        _zone;
        _taskCounts = {
            'microTask': 0,
            'macroTask': 0,
            'eventTask': 0
        };
        _parentDelegate;
        _forkDlgt;
        _forkZS;
        _forkCurrZone;
        _interceptDlgt;
        _interceptZS;
        _interceptCurrZone;
        _invokeDlgt;
        _invokeZS;
        _invokeCurrZone;
        _handleErrorDlgt;
        _handleErrorZS;
        _handleErrorCurrZone;
        _scheduleTaskDlgt;
        _scheduleTaskZS;
        _scheduleTaskCurrZone;
        _invokeTaskDlgt;
        _invokeTaskZS;
        _invokeTaskCurrZone;
        _cancelTaskDlgt;
        _cancelTaskZS;
        _cancelTaskCurrZone;
        _hasTaskDlgt;
        _hasTaskDlgtOwner;
        _hasTaskZS;
        _hasTaskCurrZone;
        constructor(zone, parentDelegate, zoneSpec){
            this._zone = zone;
            this._parentDelegate = parentDelegate;
            this._forkZS = zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
            this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
            this._forkCurrZone = zoneSpec && (zoneSpec.onFork ? this._zone : parentDelegate._forkCurrZone);
            this._interceptZS = zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
            this._interceptDlgt = zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
            this._interceptCurrZone = zoneSpec && (zoneSpec.onIntercept ? this._zone : parentDelegate._interceptCurrZone);
            this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
            this._invokeDlgt = zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
            this._invokeCurrZone = zoneSpec && (zoneSpec.onInvoke ? this._zone : parentDelegate._invokeCurrZone);
            this._handleErrorZS = zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
            this._handleErrorDlgt = zoneSpec && (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
            this._handleErrorCurrZone = zoneSpec && (zoneSpec.onHandleError ? this._zone : parentDelegate._handleErrorCurrZone);
            this._scheduleTaskZS = zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
            this._scheduleTaskDlgt = zoneSpec && (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
            this._scheduleTaskCurrZone = zoneSpec && (zoneSpec.onScheduleTask ? this._zone : parentDelegate._scheduleTaskCurrZone);
            this._invokeTaskZS = zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
            this._invokeTaskDlgt = zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
            this._invokeTaskCurrZone = zoneSpec && (zoneSpec.onInvokeTask ? this._zone : parentDelegate._invokeTaskCurrZone);
            this._cancelTaskZS = zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
            this._cancelTaskDlgt = zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
            this._cancelTaskCurrZone = zoneSpec && (zoneSpec.onCancelTask ? this._zone : parentDelegate._cancelTaskCurrZone);
            this._hasTaskZS = null;
            this._hasTaskDlgt = null;
            this._hasTaskDlgtOwner = null;
            this._hasTaskCurrZone = null;
            const zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
            const parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
            if (zoneSpecHasTask || parentHasTask) {
                // If we need to report hasTask, than this ZS needs to do ref counting on tasks. In such
                // a case all task related interceptors must go through this ZD. We can't short circuit it.
                this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                this._hasTaskDlgt = parentDelegate;
                this._hasTaskDlgtOwner = this;
                this._hasTaskCurrZone = this._zone;
                if (!zoneSpec.onScheduleTask) {
                    this._scheduleTaskZS = DELEGATE_ZS;
                    this._scheduleTaskDlgt = parentDelegate;
                    this._scheduleTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onInvokeTask) {
                    this._invokeTaskZS = DELEGATE_ZS;
                    this._invokeTaskDlgt = parentDelegate;
                    this._invokeTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onCancelTask) {
                    this._cancelTaskZS = DELEGATE_ZS;
                    this._cancelTaskDlgt = parentDelegate;
                    this._cancelTaskCurrZone = this._zone;
                }
            }
        }
        fork(targetZone, zoneSpec) {
            return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec) : new ZoneImpl(targetZone, zoneSpec);
        }
        intercept(targetZone, callback, source) {
            return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source) : callback;
        }
        invoke(targetZone, callback, applyThis, applyArgs, source) {
            return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source) : callback.apply(applyThis, applyArgs);
        }
        handleError(targetZone, error) {
            return this._handleErrorZS ? this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error) : true;
        }
        scheduleTask(targetZone, task) {
            let returnTask = task;
            if (this._scheduleTaskZS) {
                if (this._hasTaskZS) returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                if (!returnTask) returnTask = task;
            } else {
                if (task.scheduleFn) task.scheduleFn(task);
                else if (task.type == microTask) scheduleMicroTask(task);
                else throw new Error('Task is missing scheduleFn.');
            }
            return returnTask;
        }
        invokeTask(targetZone, task, applyThis, applyArgs) {
            return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs) : task.callback.apply(applyThis, applyArgs);
        }
        cancelTask(targetZone, task) {
            let value;
            if (this._cancelTaskZS) value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
            else {
                if (!task.cancelFn) throw Error('Task is not cancelable');
                value = task.cancelFn(task);
            }
            return value;
        }
        hasTask(targetZone, isEmpty) {
            // hasTask should not throw error so other ZoneDelegate
            // can still trigger hasTask callback
            try {
                this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
            } catch (err) {
                this.handleError(targetZone, err);
            }
        }
        _updateTaskCount(type, count) {
            const counts = this._taskCounts;
            const prev = counts[type];
            const next = counts[type] = prev + count;
            if (next < 0) throw new Error('More tasks executed then were scheduled.');
            if (prev == 0 || next == 0) {
                const isEmpty = {
                    microTask: counts['microTask'] > 0,
                    macroTask: counts['macroTask'] > 0,
                    eventTask: counts['eventTask'] > 0,
                    change: type
                };
                this.hasTask(this._zone, isEmpty);
            }
        }
    }
    class ZoneTask {
        type;
        source;
        invoke;
        callback;
        data;
        scheduleFn;
        cancelFn;
        _zone = null;
        runCount = 0;
        _zoneDelegates = null;
        _state = 'notScheduled';
        constructor(type, source, callback, options, scheduleFn, cancelFn){
            this.type = type;
            this.source = source;
            this.data = options;
            this.scheduleFn = scheduleFn;
            this.cancelFn = cancelFn;
            if (!callback) throw new Error('callback is not defined');
            this.callback = callback;
            const self1 = this;
            // TODO: @JiaLiPassion options should have interface
            if (type === eventTask && options && options.useG) this.invoke = ZoneTask.invokeTask;
            else this.invoke = function() {
                return ZoneTask.invokeTask.call($bcf05a352a8cfaff$var$global, self1, this, arguments);
            };
        }
        static invokeTask(task, target, args) {
            if (!task) task = this;
            _numberOfNestedTaskFrames++;
            try {
                task.runCount++;
                return task.zone.runTask(task, target, args);
            } finally{
                if (_numberOfNestedTaskFrames == 1) drainMicroTaskQueue();
                _numberOfNestedTaskFrames--;
            }
        }
        get zone() {
            return this._zone;
        }
        get state() {
            return this._state;
        }
        cancelScheduleRequest() {
            this._transitionTo(notScheduled, scheduling);
        }
        _transitionTo(toState, fromState1, fromState2) {
            if (this._state === fromState1 || this._state === fromState2) {
                this._state = toState;
                if (toState == notScheduled) this._zoneDelegates = null;
            } else throw new Error(`${this.type} '${this.source}': can not transition to '${toState}', expecting state '${fromState1}'${fromState2 ? " or '" + fromState2 + "'" : ''}, was '${this._state}'.`);
        }
        toString() {
            if (this.data && typeof this.data.handleId !== 'undefined') return this.data.handleId.toString();
            else return Object.prototype.toString.call(this);
        }
        // add toJSON method to prevent cyclic error when
        // call JSON.stringify(zoneTask)
        toJSON() {
            return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                runCount: this.runCount
            };
        }
    }
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    ///  MICROTASK QUEUE
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    const symbolSetTimeout = $bcf05a352a8cfaff$var$__symbol__('setTimeout');
    const symbolPromise = $bcf05a352a8cfaff$var$__symbol__('Promise');
    const symbolThen = $bcf05a352a8cfaff$var$__symbol__('then');
    let _microTaskQueue = [];
    let _isDrainingMicrotaskQueue = false;
    let nativeMicroTaskQueuePromise;
    function nativeScheduleMicroTask(func) {
        if (!nativeMicroTaskQueuePromise) {
            if ($bcf05a352a8cfaff$var$global[symbolPromise]) nativeMicroTaskQueuePromise = $bcf05a352a8cfaff$var$global[symbolPromise].resolve(0);
        }
        if (nativeMicroTaskQueuePromise) {
            let nativeThen = nativeMicroTaskQueuePromise[symbolThen];
            if (!nativeThen) // native Promise is not patchable, we need to use `then` directly
            // issue 1078
            nativeThen = nativeMicroTaskQueuePromise['then'];
            nativeThen.call(nativeMicroTaskQueuePromise, func);
        } else $bcf05a352a8cfaff$var$global[symbolSetTimeout](func, 0);
    }
    function scheduleMicroTask(task) {
        // if we are not running in any task, and there has not been anything scheduled
        // we must bootstrap the initial task creation by manually scheduling the drain
        if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) // We are not running in Task, so we need to kickstart the microtask queue.
        nativeScheduleMicroTask(drainMicroTaskQueue);
        task && _microTaskQueue.push(task);
    }
    function drainMicroTaskQueue() {
        if (!_isDrainingMicrotaskQueue) {
            _isDrainingMicrotaskQueue = true;
            while(_microTaskQueue.length){
                const queue = _microTaskQueue;
                _microTaskQueue = [];
                for(let i = 0; i < queue.length; i++){
                    const task = queue[i];
                    try {
                        task.zone.runTask(task, null, null);
                    } catch (error) {
                        _api.onUnhandledError(error);
                    }
                }
            }
            _api.microtaskDrainDone();
            _isDrainingMicrotaskQueue = false;
        }
    }
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    ///  BOOTSTRAP
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    const NO_ZONE = {
        name: 'NO ZONE'
    };
    const notScheduled = 'notScheduled', scheduling = 'scheduling', scheduled = 'scheduled', running = 'running', canceling = 'canceling', unknown = 'unknown';
    const microTask = 'microTask', macroTask = 'macroTask', eventTask = 'eventTask';
    const patches = {};
    const _api = {
        symbol: $bcf05a352a8cfaff$var$__symbol__,
        currentZoneFrame: ()=>_currentZoneFrame,
        onUnhandledError: noop,
        microtaskDrainDone: noop,
        scheduleMicroTask: scheduleMicroTask,
        showUncaughtError: ()=>!ZoneImpl[$bcf05a352a8cfaff$var$__symbol__('ignoreConsoleErrorUncaughtError')],
        patchEventTarget: ()=>[],
        patchOnProperties: noop,
        patchMethod: ()=>noop,
        bindArguments: ()=>[],
        patchThen: ()=>noop,
        patchMacroTask: ()=>noop,
        patchEventPrototype: ()=>noop,
        isIEOrEdge: ()=>false,
        getGlobalObjects: ()=>undefined,
        ObjectDefineProperty: ()=>noop,
        ObjectGetOwnPropertyDescriptor: ()=>undefined,
        ObjectCreate: ()=>undefined,
        ArraySlice: ()=>[],
        patchClass: ()=>noop,
        wrapWithCurrentZone: ()=>noop,
        filterProperties: ()=>[],
        attachOriginToPatched: ()=>noop,
        _redefineProperty: ()=>noop,
        patchCallbacks: ()=>noop,
        nativeScheduleMicroTask: nativeScheduleMicroTask
    };
    let _currentZoneFrame = {
        parent: null,
        zone: new ZoneImpl(null, null)
    };
    let _currentTask = null;
    let _numberOfNestedTaskFrames = 0;
    function noop() {}
    performanceMeasure('Zone', 'Zone');
    return ZoneImpl;
}
function $bcf05a352a8cfaff$var$loadZone() {
    // if global['Zone'] already exists (maybe zone.js was already loaded or
    // some other lib also registered a global object named Zone), we may need
    // to throw an error, but sometimes user may not want this error.
    // For example,
    // we have two web pages, page1 includes zone.js, page2 doesn't.
    // and the 1st time user load page1 and page2, everything work fine,
    // but when user load page2 again, error occurs because global['Zone'] already exists.
    // so we add a flag to let user choose whether to throw this error or not.
    // By default, if existing Zone is from zone.js, we will not throw the error.
    const global = globalThis;
    const checkDuplicate = global[$bcf05a352a8cfaff$var$__symbol__('forceDuplicateZoneCheck')] === true;
    if (global['Zone'] && (checkDuplicate || typeof global['Zone'].__symbol__ !== 'function')) throw new Error('Zone already loaded.');
    // Initialize global `Zone` constant.
    global['Zone'] ??= $bcf05a352a8cfaff$var$initZone();
    return global['Zone'];
}
/**
 * Suppress closure compiler errors about unknown 'Zone' variable
 * @fileoverview
 * @suppress {undefinedVars,globalThis,missingRequire}
 */ /// <reference types="node"/>
// issue #989, to reduce bundle size, use short name
/** Object.getOwnPropertyDescriptor */ const $bcf05a352a8cfaff$var$ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
/** Object.defineProperty */ const $bcf05a352a8cfaff$var$ObjectDefineProperty = Object.defineProperty;
/** Object.getPrototypeOf */ const $bcf05a352a8cfaff$var$ObjectGetPrototypeOf = Object.getPrototypeOf;
/** Object.create */ const $bcf05a352a8cfaff$var$ObjectCreate = Object.create;
/** Array.prototype.slice */ const $bcf05a352a8cfaff$var$ArraySlice = Array.prototype.slice;
/** addEventListener string const */ const $bcf05a352a8cfaff$var$ADD_EVENT_LISTENER_STR = 'addEventListener';
/** removeEventListener string const */ const $bcf05a352a8cfaff$var$REMOVE_EVENT_LISTENER_STR = 'removeEventListener';
/** zoneSymbol addEventListener */ const $bcf05a352a8cfaff$var$ZONE_SYMBOL_ADD_EVENT_LISTENER = $bcf05a352a8cfaff$var$__symbol__($bcf05a352a8cfaff$var$ADD_EVENT_LISTENER_STR);
/** zoneSymbol removeEventListener */ const $bcf05a352a8cfaff$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER = $bcf05a352a8cfaff$var$__symbol__($bcf05a352a8cfaff$var$REMOVE_EVENT_LISTENER_STR);
/** true string const */ const $bcf05a352a8cfaff$var$TRUE_STR = 'true';
/** false string const */ const $bcf05a352a8cfaff$var$FALSE_STR = 'false';
/** Zone symbol prefix string const. */ const $bcf05a352a8cfaff$var$ZONE_SYMBOL_PREFIX = $bcf05a352a8cfaff$var$__symbol__('');
function $bcf05a352a8cfaff$var$wrapWithCurrentZone(callback, source) {
    return Zone.current.wrap(callback, source);
}
function $bcf05a352a8cfaff$var$scheduleMacroTaskWithCurrentZone(source, callback, data, customSchedule, customCancel) {
    return Zone.current.scheduleMacroTask(source, callback, data, customSchedule, customCancel);
}
const $bcf05a352a8cfaff$var$zoneSymbol = $bcf05a352a8cfaff$var$__symbol__;
const $bcf05a352a8cfaff$var$isWindowExists = typeof window !== 'undefined';
const $bcf05a352a8cfaff$var$internalWindow = $bcf05a352a8cfaff$var$isWindowExists ? window : undefined;
const $bcf05a352a8cfaff$var$_global = $bcf05a352a8cfaff$var$isWindowExists && $bcf05a352a8cfaff$var$internalWindow || globalThis;
const $bcf05a352a8cfaff$var$REMOVE_ATTRIBUTE = 'removeAttribute';
function $bcf05a352a8cfaff$var$bindArguments(args, source) {
    for(let i = args.length - 1; i >= 0; i--)if (typeof args[i] === 'function') args[i] = $bcf05a352a8cfaff$var$wrapWithCurrentZone(args[i], source + '_' + i);
    return args;
}
function $bcf05a352a8cfaff$var$patchPrototype(prototype, fnNames) {
    const source = prototype.constructor['name'];
    for(let i = 0; i < fnNames.length; i++){
        const name = fnNames[i];
        const delegate = prototype[name];
        if (delegate) {
            const prototypeDesc = $bcf05a352a8cfaff$var$ObjectGetOwnPropertyDescriptor(prototype, name);
            if (!$bcf05a352a8cfaff$var$isPropertyWritable(prototypeDesc)) continue;
            prototype[name] = ((delegate)=>{
                const patched = function() {
                    return delegate.apply(this, $bcf05a352a8cfaff$var$bindArguments(arguments, source + '.' + name));
                };
                $bcf05a352a8cfaff$var$attachOriginToPatched(patched, delegate);
                return patched;
            })(delegate);
        }
    }
}
function $bcf05a352a8cfaff$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
}
const $bcf05a352a8cfaff$var$isWebWorker = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
// Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
// this code.
const $bcf05a352a8cfaff$var$isNode = !('nw' in $bcf05a352a8cfaff$var$_global) && typeof $bcf05a352a8cfaff$var$_global.process !== 'undefined' && $bcf05a352a8cfaff$var$_global.process.toString() === '[object process]';
const $bcf05a352a8cfaff$var$isBrowser = !$bcf05a352a8cfaff$var$isNode && !$bcf05a352a8cfaff$var$isWebWorker && !!($bcf05a352a8cfaff$var$isWindowExists && $bcf05a352a8cfaff$var$internalWindow['HTMLElement']);
// we are in electron of nw, so we are both browser and nodejs
// Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
// this code.
const $bcf05a352a8cfaff$var$isMix = typeof $bcf05a352a8cfaff$var$_global.process !== 'undefined' && $bcf05a352a8cfaff$var$_global.process.toString() === '[object process]' && !$bcf05a352a8cfaff$var$isWebWorker && !!($bcf05a352a8cfaff$var$isWindowExists && $bcf05a352a8cfaff$var$internalWindow['HTMLElement']);
const $bcf05a352a8cfaff$var$zoneSymbolEventNames$1 = {};
const $bcf05a352a8cfaff$var$enableBeforeunloadSymbol = $bcf05a352a8cfaff$var$zoneSymbol('enable_beforeunload');
const $bcf05a352a8cfaff$var$wrapFn = function(event) {
    // https://github.com/angular/zone.js/issues/911, in IE, sometimes
    // event will be undefined, so we need to use window.event
    event = event || $bcf05a352a8cfaff$var$_global.event;
    if (!event) return;
    let eventNameSymbol = $bcf05a352a8cfaff$var$zoneSymbolEventNames$1[event.type];
    if (!eventNameSymbol) eventNameSymbol = $bcf05a352a8cfaff$var$zoneSymbolEventNames$1[event.type] = $bcf05a352a8cfaff$var$zoneSymbol('ON_PROPERTY' + event.type);
    const target = this || event.target || $bcf05a352a8cfaff$var$_global;
    const listener = target[eventNameSymbol];
    let result;
    if ($bcf05a352a8cfaff$var$isBrowser && target === $bcf05a352a8cfaff$var$internalWindow && event.type === 'error') {
        // window.onerror have different signature
        // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#window.onerror
        // and onerror callback will prevent default when callback return true
        const errorEvent = event;
        result = listener && listener.call(this, errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error);
        if (result === true) event.preventDefault();
    } else {
        result = listener && listener.apply(this, arguments);
        if (// https://github.com/angular/angular/issues/47579
        // https://www.w3.org/TR/2011/WD-html5-20110525/history.html#beforeunloadevent
        // This is the only specific case we should check for. The spec defines that the
        // `returnValue` attribute represents the message to show the user. When the event
        // is created, this attribute must be set to the empty string.
        event.type === 'beforeunload' && // To prevent any breaking changes resulting from this change, given that
        // it was already causing a significant number of failures in G3, we have hidden
        // that behavior behind a global configuration flag. Consumers can enable this
        // flag explicitly if they want the `beforeunload` event to be handled as defined
        // in the specification.
        $bcf05a352a8cfaff$var$_global[$bcf05a352a8cfaff$var$enableBeforeunloadSymbol] && // The IDL event definition is `attribute DOMString returnValue`, so we check whether
        // `typeof result` is a string.
        typeof result === 'string') event.returnValue = result;
        else if (result != undefined && !result) event.preventDefault();
    }
    return result;
};
function $bcf05a352a8cfaff$var$patchProperty(obj, prop, prototype) {
    let desc = $bcf05a352a8cfaff$var$ObjectGetOwnPropertyDescriptor(obj, prop);
    if (!desc && prototype) {
        // when patch window object, use prototype to check prop exist or not
        const prototypeDesc = $bcf05a352a8cfaff$var$ObjectGetOwnPropertyDescriptor(prototype, prop);
        if (prototypeDesc) desc = {
            enumerable: true,
            configurable: true
        };
    }
    // if the descriptor not exists or is not configurable
    // just return
    if (!desc || !desc.configurable) return;
    const onPropPatchedSymbol = $bcf05a352a8cfaff$var$zoneSymbol('on' + prop + 'patched');
    if (obj.hasOwnProperty(onPropPatchedSymbol) && obj[onPropPatchedSymbol]) return;
    // A property descriptor cannot have getter/setter and be writable
    // deleting the writable and value properties avoids this error:
    //
    // TypeError: property descriptors must not specify a value or be writable when a
    // getter or setter has been specified
    delete desc.writable;
    delete desc.value;
    const originalDescGet = desc.get;
    const originalDescSet = desc.set;
    // slice(2) cuz 'onclick' -> 'click', etc
    const eventName = prop.slice(2);
    let eventNameSymbol = $bcf05a352a8cfaff$var$zoneSymbolEventNames$1[eventName];
    if (!eventNameSymbol) eventNameSymbol = $bcf05a352a8cfaff$var$zoneSymbolEventNames$1[eventName] = $bcf05a352a8cfaff$var$zoneSymbol('ON_PROPERTY' + eventName);
    desc.set = function(newValue) {
        // In some versions of Windows, the `this` context may be undefined
        // in on-property callbacks.
        // To handle this edge case, we check if `this` is falsy and
        // fallback to `_global` if needed.
        let target = this;
        if (!target && obj === $bcf05a352a8cfaff$var$_global) target = $bcf05a352a8cfaff$var$_global;
        if (!target) return;
        const previousValue = target[eventNameSymbol];
        if (typeof previousValue === 'function') target.removeEventListener(eventName, $bcf05a352a8cfaff$var$wrapFn);
        // https://github.com/angular/zone.js/issues/978
        // If an inline handler (like `onload`) was defined before zone.js was loaded,
        // call the original descriptor's setter to clean it up.
        originalDescSet?.call(target, null);
        target[eventNameSymbol] = newValue;
        if (typeof newValue === 'function') target.addEventListener(eventName, $bcf05a352a8cfaff$var$wrapFn, false);
    };
    // The getter would return undefined for unassigned properties but the default value of an
    // unassigned property is null
    desc.get = function() {
        // in some of windows's onproperty callback, this is undefined
        // so we need to check it
        let target = this;
        if (!target && obj === $bcf05a352a8cfaff$var$_global) target = $bcf05a352a8cfaff$var$_global;
        if (!target) return null;
        const listener = target[eventNameSymbol];
        if (listener) return listener;
        else if (originalDescGet) {
            // result will be null when use inline event attribute,
            // such as <button onclick="func();">OK</button>
            // because the onclick function is internal raw uncompiled handler
            // the onclick will be evaluated when first time event was triggered or
            // the property is accessed, https://github.com/angular/zone.js/issues/525
            // so we should use original native get to retrieve the handler
            let value = originalDescGet.call(this);
            if (value) {
                desc.set.call(this, value);
                if (typeof target[$bcf05a352a8cfaff$var$REMOVE_ATTRIBUTE] === 'function') target.removeAttribute(prop);
                return value;
            }
        }
        return null;
    };
    $bcf05a352a8cfaff$var$ObjectDefineProperty(obj, prop, desc);
    obj[onPropPatchedSymbol] = true;
}
function $bcf05a352a8cfaff$var$patchOnProperties(obj, properties, prototype) {
    if (properties) for(let i = 0; i < properties.length; i++)$bcf05a352a8cfaff$var$patchProperty(obj, 'on' + properties[i], prototype);
    else {
        const onProperties = [];
        for(const prop in obj)if (prop.slice(0, 2) == 'on') onProperties.push(prop);
        for(let j = 0; j < onProperties.length; j++)$bcf05a352a8cfaff$var$patchProperty(obj, onProperties[j], prototype);
    }
}
const $bcf05a352a8cfaff$var$originalInstanceKey = $bcf05a352a8cfaff$var$zoneSymbol('originalInstance');
// wrap some native API on `window`
function $bcf05a352a8cfaff$var$patchClass(className) {
    const OriginalClass = $bcf05a352a8cfaff$var$_global[className];
    if (!OriginalClass) return;
    // keep original class in global
    $bcf05a352a8cfaff$var$_global[$bcf05a352a8cfaff$var$zoneSymbol(className)] = OriginalClass;
    $bcf05a352a8cfaff$var$_global[className] = function() {
        const a = $bcf05a352a8cfaff$var$bindArguments(arguments, className);
        switch(a.length){
            case 0:
                this[$bcf05a352a8cfaff$var$originalInstanceKey] = new OriginalClass();
                break;
            case 1:
                this[$bcf05a352a8cfaff$var$originalInstanceKey] = new OriginalClass(a[0]);
                break;
            case 2:
                this[$bcf05a352a8cfaff$var$originalInstanceKey] = new OriginalClass(a[0], a[1]);
                break;
            case 3:
                this[$bcf05a352a8cfaff$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                break;
            case 4:
                this[$bcf05a352a8cfaff$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                break;
            default:
                throw new Error('Arg list too long.');
        }
    };
    // attach original delegate to patched function
    $bcf05a352a8cfaff$var$attachOriginToPatched($bcf05a352a8cfaff$var$_global[className], OriginalClass);
    const instance = new OriginalClass(function() {});
    let prop;
    for(prop in instance){
        // https://bugs.webkit.org/show_bug.cgi?id=44721
        if (className === 'XMLHttpRequest' && prop === 'responseBlob') continue;
        (function(prop) {
            if (typeof instance[prop] === 'function') $bcf05a352a8cfaff$var$_global[className].prototype[prop] = function() {
                return this[$bcf05a352a8cfaff$var$originalInstanceKey][prop].apply(this[$bcf05a352a8cfaff$var$originalInstanceKey], arguments);
            };
            else $bcf05a352a8cfaff$var$ObjectDefineProperty($bcf05a352a8cfaff$var$_global[className].prototype, prop, {
                set: function(fn) {
                    if (typeof fn === 'function') {
                        this[$bcf05a352a8cfaff$var$originalInstanceKey][prop] = $bcf05a352a8cfaff$var$wrapWithCurrentZone(fn, className + '.' + prop);
                        // keep callback in wrapped function so we can
                        // use it in Function.prototype.toString to return
                        // the native one.
                        $bcf05a352a8cfaff$var$attachOriginToPatched(this[$bcf05a352a8cfaff$var$originalInstanceKey][prop], fn);
                    } else this[$bcf05a352a8cfaff$var$originalInstanceKey][prop] = fn;
                },
                get: function() {
                    return this[$bcf05a352a8cfaff$var$originalInstanceKey][prop];
                }
            });
        })(prop);
    }
    for(prop in OriginalClass)if (prop !== 'prototype' && OriginalClass.hasOwnProperty(prop)) $bcf05a352a8cfaff$var$_global[className][prop] = OriginalClass[prop];
}
function $bcf05a352a8cfaff$var$patchMethod(target, name, patchFn) {
    let proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = $bcf05a352a8cfaff$var$ObjectGetPrototypeOf(proto);
    if (!proto && target[name]) // somehow we did not find it, but we can see it. This happens on IE for Window properties.
    proto = target;
    const delegateName = $bcf05a352a8cfaff$var$zoneSymbol(name);
    let delegate = null;
    if (proto && (!(delegate = proto[delegateName]) || !proto.hasOwnProperty(delegateName))) {
        delegate = proto[delegateName] = proto[name];
        // check whether proto[name] is writable
        // some property is readonly in safari, such as HtmlCanvasElement.prototype.toBlob
        const desc = proto && $bcf05a352a8cfaff$var$ObjectGetOwnPropertyDescriptor(proto, name);
        if ($bcf05a352a8cfaff$var$isPropertyWritable(desc)) {
            const patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $bcf05a352a8cfaff$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
// TODO: @JiaLiPassion, support cancel task later if necessary
function $bcf05a352a8cfaff$var$patchMacroTask(obj, funcName, metaCreator) {
    let setNative = null;
    function scheduleTask(task) {
        const data = task.data;
        data.args[data.cbIdx] = function() {
            task.invoke.apply(this, arguments);
        };
        setNative.apply(data.target, data.args);
        return task;
    }
    setNative = $bcf05a352a8cfaff$var$patchMethod(obj, funcName, (delegate)=>function(self1, args) {
            const meta = metaCreator(self1, args);
            if (meta.cbIdx >= 0 && typeof args[meta.cbIdx] === 'function') return $bcf05a352a8cfaff$var$scheduleMacroTaskWithCurrentZone(meta.name, args[meta.cbIdx], meta, scheduleTask);
            else // cause an error by calling it directly.
            return delegate.apply(self1, args);
        });
}
function $bcf05a352a8cfaff$var$attachOriginToPatched(patched, original) {
    patched[$bcf05a352a8cfaff$var$zoneSymbol('OriginalDelegate')] = original;
}
let $bcf05a352a8cfaff$var$isDetectedIEOrEdge = false;
let $bcf05a352a8cfaff$var$ieOrEdge = false;
function $bcf05a352a8cfaff$var$isIEOrEdge() {
    if ($bcf05a352a8cfaff$var$isDetectedIEOrEdge) return $bcf05a352a8cfaff$var$ieOrEdge;
    $bcf05a352a8cfaff$var$isDetectedIEOrEdge = true;
    try {
        const ua = $bcf05a352a8cfaff$var$internalWindow.navigator.userAgent;
        if (ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1 || ua.indexOf('Edge/') !== -1) $bcf05a352a8cfaff$var$ieOrEdge = true;
    } catch (error) {}
    return $bcf05a352a8cfaff$var$ieOrEdge;
}
function $bcf05a352a8cfaff$var$isFunction(value) {
    return typeof value === 'function';
}
function $bcf05a352a8cfaff$var$isNumber(value) {
    return typeof value === 'number';
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ // an identifier to tell ZoneTask do not create a new invoke closure
const $bcf05a352a8cfaff$var$OPTIMIZED_ZONE_EVENT_TASK_DATA = {
    useG: true
};
const $bcf05a352a8cfaff$var$zoneSymbolEventNames = {};
const $bcf05a352a8cfaff$var$globalSources = {};
const $bcf05a352a8cfaff$var$EVENT_NAME_SYMBOL_REGX = new RegExp('^' + $bcf05a352a8cfaff$var$ZONE_SYMBOL_PREFIX + '(\\w+)(true|false)$');
const $bcf05a352a8cfaff$var$IMMEDIATE_PROPAGATION_SYMBOL = $bcf05a352a8cfaff$var$zoneSymbol('propagationStopped');
function $bcf05a352a8cfaff$var$prepareEventNames(eventName, eventNameToString) {
    const falseEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $bcf05a352a8cfaff$var$FALSE_STR;
    const trueEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $bcf05a352a8cfaff$var$TRUE_STR;
    const symbol = $bcf05a352a8cfaff$var$ZONE_SYMBOL_PREFIX + falseEventName;
    const symbolCapture = $bcf05a352a8cfaff$var$ZONE_SYMBOL_PREFIX + trueEventName;
    $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName] = {};
    $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName][$bcf05a352a8cfaff$var$FALSE_STR] = symbol;
    $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName][$bcf05a352a8cfaff$var$TRUE_STR] = symbolCapture;
}
function $bcf05a352a8cfaff$var$patchEventTarget(_global, api, apis, patchOptions) {
    const ADD_EVENT_LISTENER = patchOptions && patchOptions.add || $bcf05a352a8cfaff$var$ADD_EVENT_LISTENER_STR;
    const REMOVE_EVENT_LISTENER = patchOptions && patchOptions.rm || $bcf05a352a8cfaff$var$REMOVE_EVENT_LISTENER_STR;
    const LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.listeners || 'eventListeners';
    const REMOVE_ALL_LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.rmAll || 'removeAllListeners';
    const zoneSymbolAddEventListener = $bcf05a352a8cfaff$var$zoneSymbol(ADD_EVENT_LISTENER);
    const ADD_EVENT_LISTENER_SOURCE = '.' + ADD_EVENT_LISTENER + ':';
    const PREPEND_EVENT_LISTENER = 'prependListener';
    const PREPEND_EVENT_LISTENER_SOURCE = '.' + PREPEND_EVENT_LISTENER + ':';
    const invokeTask = function(task, target, event) {
        // for better performance, check isRemoved which is set
        // by removeEventListener
        if (task.isRemoved) return;
        const delegate = task.callback;
        if (typeof delegate === 'object' && delegate.handleEvent) {
            // create the bind version of handleEvent when invoke
            task.callback = (event)=>delegate.handleEvent(event);
            task.originalDelegate = delegate;
        }
        // invoke static task.invoke
        // need to try/catch error here, otherwise, the error in one event listener
        // will break the executions of the other event listeners. Also error will
        // not remove the event listener when `once` options is true.
        let error;
        try {
            task.invoke(task, target, [
                event
            ]);
        } catch (err) {
            error = err;
        }
        const options = task.options;
        if (options && typeof options === 'object' && options.once) {
            // if options.once is true, after invoke once remove listener here
            // only browser need to do this, nodejs eventEmitter will cal removeListener
            // inside EventEmitter.once
            const delegate = task.originalDelegate ? task.originalDelegate : task.callback;
            target[REMOVE_EVENT_LISTENER].call(target, event.type, delegate, options);
        }
        return error;
    };
    function globalCallback(context, event, isCapture) {
        // https://github.com/angular/zone.js/issues/911, in IE, sometimes
        // event will be undefined, so we need to use window.event
        event = event || _global.event;
        if (!event) return;
        // event.target is needed for Samsung TV and SourceBuffer
        // || global is needed https://github.com/angular/zone.js/issues/190
        const target = context || event.target || _global;
        const tasks = target[$bcf05a352a8cfaff$var$zoneSymbolEventNames[event.type][isCapture ? $bcf05a352a8cfaff$var$TRUE_STR : $bcf05a352a8cfaff$var$FALSE_STR]];
        if (tasks) {
            const errors = [];
            // invoke all tasks which attached to current target with given event.type and capture = false
            // for performance concern, if task.length === 1, just invoke
            if (tasks.length === 1) {
                const err = invokeTask(tasks[0], target, event);
                err && errors.push(err);
            } else {
                // https://github.com/angular/zone.js/issues/836
                // copy the tasks array before invoke, to avoid
                // the callback will remove itself or other listener
                const copyTasks = tasks.slice();
                for(let i = 0; i < copyTasks.length; i++){
                    if (event && event[$bcf05a352a8cfaff$var$IMMEDIATE_PROPAGATION_SYMBOL] === true) break;
                    const err = invokeTask(copyTasks[i], target, event);
                    err && errors.push(err);
                }
            }
            // Since there is only one error, we don't need to schedule microTask
            // to throw the error.
            if (errors.length === 1) throw errors[0];
            else for(let i = 0; i < errors.length; i++){
                const err = errors[i];
                api.nativeScheduleMicroTask(()=>{
                    throw err;
                });
            }
        }
    }
    // global shared zoneAwareCallback to handle all event callback with capture = false
    const globalZoneAwareCallback = function(event) {
        return globalCallback(this, event, false);
    };
    // global shared zoneAwareCallback to handle all event callback with capture = true
    const globalZoneAwareCaptureCallback = function(event) {
        return globalCallback(this, event, true);
    };
    function patchEventTargetMethods(obj, patchOptions) {
        if (!obj) return false;
        let useGlobalCallback = true;
        if (patchOptions && patchOptions.useG !== undefined) useGlobalCallback = patchOptions.useG;
        const validateHandler = patchOptions && patchOptions.vh;
        let checkDuplicate = true;
        if (patchOptions && patchOptions.chkDup !== undefined) checkDuplicate = patchOptions.chkDup;
        let returnTarget = false;
        if (patchOptions && patchOptions.rt !== undefined) returnTarget = patchOptions.rt;
        let proto = obj;
        while(proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER))proto = $bcf05a352a8cfaff$var$ObjectGetPrototypeOf(proto);
        if (!proto && obj[ADD_EVENT_LISTENER]) // somehow we did not find it, but we can see it. This happens on IE for Window properties.
        proto = obj;
        if (!proto) return false;
        if (proto[zoneSymbolAddEventListener]) return false;
        const eventNameToString = patchOptions && patchOptions.eventNameToString;
        // We use a shared global `taskData` to pass data for `scheduleEventTask`,
        // eliminating the need to create a new object solely for passing data.
        // WARNING: This object has a static lifetime, meaning it is not created
        // each time `addEventListener` is called. It is instantiated only once
        // and captured by reference inside the `addEventListener` and
        // `removeEventListener` functions. Do not add any new properties to this
        // object, as doing so would necessitate maintaining the information
        // between `addEventListener` calls.
        const taskData = {};
        const nativeAddEventListener = proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER];
        const nativeRemoveEventListener = proto[$bcf05a352a8cfaff$var$zoneSymbol(REMOVE_EVENT_LISTENER)] = proto[REMOVE_EVENT_LISTENER];
        const nativeListeners = proto[$bcf05a352a8cfaff$var$zoneSymbol(LISTENERS_EVENT_LISTENER)] = proto[LISTENERS_EVENT_LISTENER];
        const nativeRemoveAllListeners = proto[$bcf05a352a8cfaff$var$zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] = proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER];
        let nativePrependEventListener;
        if (patchOptions && patchOptions.prepend) nativePrependEventListener = proto[$bcf05a352a8cfaff$var$zoneSymbol(patchOptions.prepend)] = proto[patchOptions.prepend];
        /**
         * This util function will build an option object with passive option
         * to handle all possible input from the user.
         */ function buildEventListenerOptions(options, passive) {
            if (!passive) return options;
            if (typeof options === 'boolean') return {
                capture: options,
                passive: true
            };
            if (!options) return {
                passive: true
            };
            if (typeof options === 'object' && options.passive !== false) return {
                ...options,
                passive: true
            };
            return options;
        }
        const customScheduleGlobal = function(task) {
            // if there is already a task for the eventName + capture,
            // just return, because we use the shared globalZoneAwareCallback here.
            if (taskData.isExisting) return;
            return nativeAddEventListener.call(taskData.target, taskData.eventName, taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, taskData.options);
        };
        /**
         * In the context of events and listeners, this function will be
         * called at the end by `cancelTask`, which, in turn, calls `task.cancelFn`.
         * Cancelling a task is primarily used to remove event listeners from
         * the task target.
         */ const customCancelGlobal = function(task) {
            // if task is not marked as isRemoved, this call is directly
            // from Zone.prototype.cancelTask, we should remove the task
            // from tasksList of target first
            if (!task.isRemoved) {
                const symbolEventNames = $bcf05a352a8cfaff$var$zoneSymbolEventNames[task.eventName];
                let symbolEventName;
                if (symbolEventNames) symbolEventName = symbolEventNames[task.capture ? $bcf05a352a8cfaff$var$TRUE_STR : $bcf05a352a8cfaff$var$FALSE_STR];
                const existingTasks = symbolEventName && task.target[symbolEventName];
                if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                    const existingTask = existingTasks[i];
                    if (existingTask === task) {
                        existingTasks.splice(i, 1);
                        // set isRemoved to data for faster invokeTask check
                        task.isRemoved = true;
                        if (task.removeAbortListener) {
                            task.removeAbortListener();
                            task.removeAbortListener = null;
                        }
                        if (existingTasks.length === 0) {
                            // all tasks for the eventName + capture have gone,
                            // remove globalZoneAwareCallback and remove the task cache from target
                            task.allRemoved = true;
                            task.target[symbolEventName] = null;
                        }
                        break;
                    }
                }
            }
            // if all tasks for the eventName + capture have gone,
            // we will really remove the global event callback,
            // if not, return
            if (!task.allRemoved) return;
            return nativeRemoveEventListener.call(task.target, task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, task.options);
        };
        const customScheduleNonGlobal = function(task) {
            return nativeAddEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customSchedulePrepend = function(task) {
            return nativePrependEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customCancelNonGlobal = function(task) {
            return nativeRemoveEventListener.call(task.target, task.eventName, task.invoke, task.options);
        };
        const customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
        const customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
        const compareTaskCallbackVsDelegate = function(task, delegate) {
            const typeOfDelegate = typeof delegate;
            return typeOfDelegate === 'function' && task.callback === delegate || typeOfDelegate === 'object' && task.originalDelegate === delegate;
        };
        const compare = patchOptions?.diff || compareTaskCallbackVsDelegate;
        const unpatchedEvents = Zone[$bcf05a352a8cfaff$var$zoneSymbol('UNPATCHED_EVENTS')];
        const passiveEvents = _global[$bcf05a352a8cfaff$var$zoneSymbol('PASSIVE_EVENTS')];
        function copyEventListenerOptions(options) {
            if (typeof options === 'object' && options !== null) {
                // We need to destructure the target `options` object since it may
                // be frozen or sealed (possibly provided implicitly by a third-party
                // library), or its properties may be readonly.
                const newOptions = {
                    ...options
                };
                // The `signal` option was recently introduced, which caused regressions in
                // third-party scenarios where `AbortController` was directly provided to
                // `addEventListener` as options. For instance, in cases like
                // `document.addEventListener('keydown', callback, abortControllerInstance)`,
                // which is valid because `AbortController` includes a `signal` getter, spreading
                // `{...options}` wouldn't copy the `signal`. Additionally, using `Object.create`
                // isn't feasible since `AbortController` is a built-in object type, and attempting
                // to create a new object directly with it as the prototype might result in
                // unexpected behavior.
                if (options.signal) newOptions.signal = options.signal;
                return newOptions;
            }
            return options;
        }
        const makeAddListener = function(nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget = false, prepend = false) {
            return function() {
                const target = this || _global;
                let eventName = arguments[0];
                if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
                let delegate = arguments[1];
                if (!delegate) return nativeListener.apply(this, arguments);
                if ($bcf05a352a8cfaff$var$isNode && eventName === 'uncaughtException') // don't patch uncaughtException of nodejs to prevent endless loop
                return nativeListener.apply(this, arguments);
                // To improve `addEventListener` performance, we will create the callback
                // for the task later when the task is invoked.
                let isEventListenerObject = false;
                if (typeof delegate !== 'function') {
                    // This checks whether the provided listener argument is an object with
                    // a `handleEvent` method (since we can call `addEventListener` with a
                    // function `event => ...` or with an object `{ handleEvent: event => ... }`).
                    if (!delegate.handleEvent) return nativeListener.apply(this, arguments);
                    isEventListenerObject = true;
                }
                if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) return;
                const passive = !!passiveEvents && passiveEvents.indexOf(eventName) !== -1;
                const options = copyEventListenerOptions(buildEventListenerOptions(arguments[2], passive));
                const signal = options?.signal;
                if (signal?.aborted) // the signal is an aborted one, just return without attaching the event listener.
                return;
                if (unpatchedEvents) {
                    // check unpatched list
                    for(let i = 0; i < unpatchedEvents.length; i++)if (eventName === unpatchedEvents[i]) {
                        if (passive) return nativeListener.call(target, eventName, delegate, options);
                        else return nativeListener.apply(this, arguments);
                    }
                }
                const capture = !options ? false : typeof options === 'boolean' ? true : options.capture;
                const once = options && typeof options === 'object' ? options.once : false;
                const zone = Zone.current;
                let symbolEventNames = $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName];
                if (!symbolEventNames) {
                    $bcf05a352a8cfaff$var$prepareEventNames(eventName, eventNameToString);
                    symbolEventNames = $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName];
                }
                const symbolEventName = symbolEventNames[capture ? $bcf05a352a8cfaff$var$TRUE_STR : $bcf05a352a8cfaff$var$FALSE_STR];
                let existingTasks = target[symbolEventName];
                let isExisting = false;
                if (existingTasks) {
                    // already have task registered
                    isExisting = true;
                    if (checkDuplicate) for(let i = 0; i < existingTasks.length; i++){
                        if (compare(existingTasks[i], delegate)) // same callback, same capture, same event name, just return
                        return;
                    }
                } else existingTasks = target[symbolEventName] = [];
                let source;
                const constructorName = target.constructor['name'];
                const targetSource = $bcf05a352a8cfaff$var$globalSources[constructorName];
                if (targetSource) source = targetSource[eventName];
                if (!source) source = constructorName + addSource + (eventNameToString ? eventNameToString(eventName) : eventName);
                // In the code below, `options` should no longer be reassigned; instead, it
                // should only be mutated. This is because we pass that object to the native
                // `addEventListener`.
                // It's generally recommended to use the same object reference for options.
                // This ensures consistency and avoids potential issues.
                taskData.options = options;
                if (once) // When using `addEventListener` with the `once` option, we don't pass
                // the `once` option directly to the native `addEventListener` method.
                // Instead, we keep the `once` setting and handle it ourselves.
                taskData.options.once = false;
                taskData.target = target;
                taskData.capture = capture;
                taskData.eventName = eventName;
                taskData.isExisting = isExisting;
                const data = useGlobalCallback ? $bcf05a352a8cfaff$var$OPTIMIZED_ZONE_EVENT_TASK_DATA : undefined;
                // keep taskData into data to allow onScheduleEventTask to access the task information
                if (data) data.taskData = taskData;
                if (signal) // When using `addEventListener` with the `signal` option, we don't pass
                // the `signal` option directly to the native `addEventListener` method.
                // Instead, we keep the `signal` setting and handle it ourselves.
                taskData.options.signal = undefined;
                // The `scheduleEventTask` function will ultimately call `customScheduleGlobal`,
                // which in turn calls the native `addEventListener`. This is why `taskData.options`
                // is updated before scheduling the task, as `customScheduleGlobal` uses
                // `taskData.options` to pass it to the native `addEventListener`.
                const task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                if (signal) {
                    // after task is scheduled, we need to store the signal back to task.options
                    taskData.options.signal = signal;
                    // Wrapping `task` in a weak reference would not prevent memory leaks. Weak references are
                    // primarily used for preventing strong references cycles. `onAbort` is always reachable
                    // as it's an event listener, so its closure retains a strong reference to the `task`.
                    const onAbort = ()=>task.zone.cancelTask(task);
                    nativeListener.call(signal, 'abort', onAbort, {
                        once: true
                    });
                    // We need to remove the `abort` listener when the event listener is going to be removed,
                    // as it creates a closure that captures `task`. This closure retains a reference to the
                    // `task` object even after it goes out of scope, preventing `task` from being garbage
                    // collected.
                    task.removeAbortListener = ()=>signal.removeEventListener('abort', onAbort);
                }
                // should clear taskData.target to avoid memory leak
                // issue, https://github.com/angular/angular/issues/20442
                taskData.target = null;
                // need to clear up taskData because it is a global object
                if (data) data.taskData = null;
                // have to save those information to task in case
                // application may call task.zone.cancelTask() directly
                if (once) taskData.options.once = true;
                if (typeof task.options !== 'boolean') // We should save the options on the task (if it's an object) because
                // we'll be using `task.options` later when removing the event listener
                // and passing it back to `removeEventListener`.
                task.options = options;
                task.target = target;
                task.capture = capture;
                task.eventName = eventName;
                if (isEventListenerObject) // save original delegate for compare to check duplicate
                task.originalDelegate = delegate;
                if (!prepend) existingTasks.push(task);
                else existingTasks.unshift(task);
                if (returnTarget) return target;
            };
        };
        proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
        if (nativePrependEventListener) proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
        proto[REMOVE_EVENT_LISTENER] = function() {
            const target = this || _global;
            let eventName = arguments[0];
            if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
            const options = arguments[2];
            const capture = !options ? false : typeof options === 'boolean' ? true : options.capture;
            const delegate = arguments[1];
            if (!delegate) return nativeRemoveEventListener.apply(this, arguments);
            if (validateHandler && !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) return;
            const symbolEventNames = $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName];
            let symbolEventName;
            if (symbolEventNames) symbolEventName = symbolEventNames[capture ? $bcf05a352a8cfaff$var$TRUE_STR : $bcf05a352a8cfaff$var$FALSE_STR];
            const existingTasks = symbolEventName && target[symbolEventName];
            // `existingTasks` may not exist if the `addEventListener` was called before
            // it was patched by zone.js. Please refer to the attached issue for
            // clarification, particularly after the `if` condition, before calling
            // the native `removeEventListener`.
            if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                const existingTask = existingTasks[i];
                if (compare(existingTask, delegate)) {
                    existingTasks.splice(i, 1);
                    // set isRemoved to data for faster invokeTask check
                    existingTask.isRemoved = true;
                    if (existingTasks.length === 0) {
                        // all tasks for the eventName + capture have gone,
                        // remove globalZoneAwareCallback and remove the task cache from target
                        existingTask.allRemoved = true;
                        target[symbolEventName] = null;
                        // in the target, we have an event listener which is added by on_property
                        // such as target.onclick = function() {}, so we need to clear this internal
                        // property too if all delegates with capture=false were removed
                        // https:// github.com/angular/angular/issues/31643
                        // https://github.com/angular/angular/issues/54581
                        if (!capture && typeof eventName === 'string') {
                            const onPropertySymbol = $bcf05a352a8cfaff$var$ZONE_SYMBOL_PREFIX + 'ON_PROPERTY' + eventName;
                            target[onPropertySymbol] = null;
                        }
                    }
                    // In all other conditions, when `addEventListener` is called after being
                    // patched by zone.js, we would always find an event task on the `EventTarget`.
                    // This will trigger `cancelFn` on the `existingTask`, leading to `customCancelGlobal`,
                    // which ultimately removes an event listener and cleans up the abort listener
                    // (if an `AbortSignal` was provided when scheduling a task).
                    existingTask.zone.cancelTask(existingTask);
                    if (returnTarget) return target;
                    return;
                }
            }
            // https://github.com/angular/zone.js/issues/930
            // We may encounter a situation where the `addEventListener` was
            // called on the event target before zone.js is loaded, resulting
            // in no task being stored on the event target due to its invocation
            // of the native implementation. In this scenario, we simply need to
            // invoke the native `removeEventListener`.
            return nativeRemoveEventListener.apply(this, arguments);
        };
        proto[LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global;
            let eventName = arguments[0];
            if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
            const listeners = [];
            const tasks = $bcf05a352a8cfaff$var$findEventTasks(target, eventNameToString ? eventNameToString(eventName) : eventName);
            for(let i = 0; i < tasks.length; i++){
                const task = tasks[i];
                let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                listeners.push(delegate);
            }
            return listeners;
        };
        proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global;
            let eventName = arguments[0];
            if (!eventName) {
                const keys = Object.keys(target);
                for(let i = 0; i < keys.length; i++){
                    const prop = keys[i];
                    const match = $bcf05a352a8cfaff$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
                    let evtName = match && match[1];
                    // in nodejs EventEmitter, removeListener event is
                    // used for monitoring the removeListener call,
                    // so just keep removeListener eventListener until
                    // all other eventListeners are removed
                    if (evtName && evtName !== 'removeListener') this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, evtName);
                }
                // remove removeListener listener finally
                this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, 'removeListener');
            } else {
                if (patchOptions && patchOptions.transferEventName) eventName = patchOptions.transferEventName(eventName);
                const symbolEventNames = $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName];
                if (symbolEventNames) {
                    const symbolEventName = symbolEventNames[$bcf05a352a8cfaff$var$FALSE_STR];
                    const symbolCaptureEventName = symbolEventNames[$bcf05a352a8cfaff$var$TRUE_STR];
                    const tasks = target[symbolEventName];
                    const captureTasks = target[symbolCaptureEventName];
                    if (tasks) {
                        const removeTasks = tasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                    if (captureTasks) {
                        const removeTasks = captureTasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                }
            }
            if (returnTarget) return this;
        };
        // for native toString patch
        $bcf05a352a8cfaff$var$attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
        $bcf05a352a8cfaff$var$attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
        if (nativeRemoveAllListeners) $bcf05a352a8cfaff$var$attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
        if (nativeListeners) $bcf05a352a8cfaff$var$attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
        return true;
    }
    let results = [];
    for(let i = 0; i < apis.length; i++)results[i] = patchEventTargetMethods(apis[i], patchOptions);
    return results;
}
function $bcf05a352a8cfaff$var$findEventTasks(target, eventName) {
    if (!eventName) {
        const foundTasks = [];
        for(let prop in target){
            const match = $bcf05a352a8cfaff$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
            let evtName = match && match[1];
            if (evtName && (!eventName || evtName === eventName)) {
                const tasks = target[prop];
                if (tasks) for(let i = 0; i < tasks.length; i++)foundTasks.push(tasks[i]);
            }
        }
        return foundTasks;
    }
    let symbolEventName = $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName];
    if (!symbolEventName) {
        $bcf05a352a8cfaff$var$prepareEventNames(eventName);
        symbolEventName = $bcf05a352a8cfaff$var$zoneSymbolEventNames[eventName];
    }
    const captureFalseTasks = target[symbolEventName[$bcf05a352a8cfaff$var$FALSE_STR]];
    const captureTrueTasks = target[symbolEventName[$bcf05a352a8cfaff$var$TRUE_STR]];
    if (!captureFalseTasks) return captureTrueTasks ? captureTrueTasks.slice() : [];
    else return captureTrueTasks ? captureFalseTasks.concat(captureTrueTasks) : captureFalseTasks.slice();
}
function $bcf05a352a8cfaff$var$patchEventPrototype(global, api) {
    const Event = global['Event'];
    if (Event && Event.prototype) api.patchMethod(Event.prototype, 'stopImmediatePropagation', (delegate)=>function(self1, args) {
            self1[$bcf05a352a8cfaff$var$IMMEDIATE_PROPAGATION_SYMBOL] = true;
            // we need to call the native stopImmediatePropagation
            // in case in some hybrid application, some part of
            // application will be controlled by zone, some are not
            delegate && delegate.apply(self1, args);
        });
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ function $bcf05a352a8cfaff$var$patchQueueMicrotask(global, api) {
    api.patchMethod(global, 'queueMicrotask', (delegate)=>{
        return function(self1, args) {
            Zone.current.scheduleMicroTask('queueMicrotask', args[0]);
        };
    });
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ const $bcf05a352a8cfaff$var$taskSymbol = $bcf05a352a8cfaff$var$zoneSymbol('zoneTask');
function $bcf05a352a8cfaff$var$patchTimer(window1, setName, cancelName, nameSuffix) {
    let setNative = null;
    let clearNative = null;
    setName += nameSuffix;
    cancelName += nameSuffix;
    const tasksByHandleId = {};
    function scheduleTask(task) {
        const data = task.data;
        data.args[0] = function() {
            return task.invoke.apply(this, arguments);
        };
        const handleOrId = setNative.apply(window1, data.args);
        // Whlist on Node.js when get can the ID by using `[Symbol.toPrimitive]()` we do
        // to this so that we do not cause potentally leaks when using `setTimeout`
        // since this can be periodic when using `.refresh`.
        if ($bcf05a352a8cfaff$var$isNumber(handleOrId)) data.handleId = handleOrId;
        else {
            data.handle = handleOrId;
            // On Node.js a timeout and interval can be restarted over and over again by using the `.refresh` method.
            data.isRefreshable = $bcf05a352a8cfaff$var$isFunction(handleOrId.refresh);
        }
        return task;
    }
    function clearTask(task) {
        const { handle: handle, handleId: handleId } = task.data;
        return clearNative.call(window1, handle ?? handleId);
    }
    setNative = $bcf05a352a8cfaff$var$patchMethod(window1, setName, (delegate)=>function(self1, args) {
            if ($bcf05a352a8cfaff$var$isFunction(args[0])) {
                const options = {
                    isRefreshable: false,
                    isPeriodic: nameSuffix === 'Interval',
                    delay: nameSuffix === 'Timeout' || nameSuffix === 'Interval' ? args[1] || 0 : undefined,
                    args: args
                };
                const callback = args[0];
                args[0] = function timer() {
                    try {
                        return callback.apply(this, arguments);
                    } finally{
                        // issue-934, task will be cancelled
                        // even it is a periodic task such as
                        // setInterval
                        // https://github.com/angular/angular/issues/40387
                        // Cleanup tasksByHandleId should be handled before scheduleTask
                        // Since some zoneSpec may intercept and doesn't trigger
                        // scheduleFn(scheduleTask) provided here.
                        const { handle: handle, handleId: handleId, isPeriodic: isPeriodic, isRefreshable: isRefreshable } = options;
                        if (!isPeriodic && !isRefreshable) {
                            if (handleId) // in non-nodejs env, we remove timerId
                            // from local cache
                            delete tasksByHandleId[handleId];
                            else if (handle) // Node returns complex objects as handleIds
                            // we remove task reference from timer object
                            handle[$bcf05a352a8cfaff$var$taskSymbol] = null;
                        }
                    }
                };
                const task = $bcf05a352a8cfaff$var$scheduleMacroTaskWithCurrentZone(setName, args[0], options, scheduleTask, clearTask);
                if (!task) return task;
                // Node.js must additionally support the ref and unref functions.
                const { handleId: handleId, handle: handle, isRefreshable: isRefreshable, isPeriodic: isPeriodic } = task.data;
                if (handleId) // for non nodejs env, we save handleId: task
                // mapping in local cache for clearTimeout
                tasksByHandleId[handleId] = task;
                else if (handle) {
                    // for nodejs env, we save task
                    // reference in timerId Object for clearTimeout
                    handle[$bcf05a352a8cfaff$var$taskSymbol] = task;
                    if (isRefreshable && !isPeriodic) {
                        const originalRefresh = handle.refresh;
                        handle.refresh = function() {
                            const { zone: zone, state: state } = task;
                            if (state === 'notScheduled') {
                                task._state = 'scheduled';
                                zone._updateTaskCount(task, 1);
                            } else if (state === 'running') task._state = 'scheduling';
                            return originalRefresh.call(this);
                        };
                    }
                }
                return handle ?? handleId ?? task;
            } else // cause an error by calling it directly.
            return delegate.apply(window1, args);
        });
    clearNative = $bcf05a352a8cfaff$var$patchMethod(window1, cancelName, (delegate)=>function(self1, args) {
            const id = args[0];
            let task;
            if ($bcf05a352a8cfaff$var$isNumber(id)) {
                // non nodejs env.
                task = tasksByHandleId[id];
                delete tasksByHandleId[id];
            } else {
                // nodejs env ?? other environments.
                task = id?.[$bcf05a352a8cfaff$var$taskSymbol];
                if (task) id[$bcf05a352a8cfaff$var$taskSymbol] = null;
                else task = id;
            }
            if (task?.type) {
                if (task.cancelFn) // Do not cancel already canceled functions
                task.zone.cancelTask(task);
            } else // cause an error by calling it directly.
            delegate.apply(window1, args);
        });
}
function $bcf05a352a8cfaff$var$patchCustomElements(_global, api) {
    const { isBrowser: isBrowser, isMix: isMix } = api.getGlobalObjects();
    if (!isBrowser && !isMix || !_global['customElements'] || !('customElements' in _global)) return;
    // https://html.spec.whatwg.org/multipage/custom-elements.html#concept-custom-element-definition-lifecycle-callbacks
    const callbacks = [
        'connectedCallback',
        'disconnectedCallback',
        'adoptedCallback',
        'attributeChangedCallback',
        'formAssociatedCallback',
        'formDisabledCallback',
        'formResetCallback',
        'formStateRestoreCallback'
    ];
    api.patchCallbacks(api, _global.customElements, 'customElements', 'define', callbacks);
}
function $bcf05a352a8cfaff$var$eventTargetPatch(_global, api) {
    if (Zone[api.symbol('patchEventTarget')]) // EventTarget is already patched.
    return;
    const { eventNames: eventNames, zoneSymbolEventNames: zoneSymbolEventNames, TRUE_STR: TRUE_STR, FALSE_STR: FALSE_STR, ZONE_SYMBOL_PREFIX: ZONE_SYMBOL_PREFIX } = api.getGlobalObjects();
    //  predefine all __zone_symbol__ + eventName + true/false string
    for(let i = 0; i < eventNames.length; i++){
        const eventName = eventNames[i];
        const falseEventName = eventName + FALSE_STR;
        const trueEventName = eventName + TRUE_STR;
        const symbol = ZONE_SYMBOL_PREFIX + falseEventName;
        const symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
        zoneSymbolEventNames[eventName] = {};
        zoneSymbolEventNames[eventName][FALSE_STR] = symbol;
        zoneSymbolEventNames[eventName][TRUE_STR] = symbolCapture;
    }
    const EVENT_TARGET = _global['EventTarget'];
    if (!EVENT_TARGET || !EVENT_TARGET.prototype) return;
    api.patchEventTarget(_global, api, [
        EVENT_TARGET && EVENT_TARGET.prototype
    ]);
    return true;
}
function $bcf05a352a8cfaff$var$patchEvent(global, api) {
    api.patchEventPrototype(global, api);
}
/**
 * @fileoverview
 * @suppress {globalThis}
 */ function $bcf05a352a8cfaff$var$filterProperties(target, onProperties, ignoreProperties) {
    if (!ignoreProperties || ignoreProperties.length === 0) return onProperties;
    const tip = ignoreProperties.filter((ip)=>ip.target === target);
    if (tip.length === 0) return onProperties;
    const targetIgnoreProperties = tip[0].ignoreProperties;
    return onProperties.filter((op)=>targetIgnoreProperties.indexOf(op) === -1);
}
function $bcf05a352a8cfaff$var$patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
    // check whether target is available, sometimes target will be undefined
    // because different browser or some 3rd party plugin.
    if (!target) return;
    const filteredProperties = $bcf05a352a8cfaff$var$filterProperties(target, onProperties, ignoreProperties);
    $bcf05a352a8cfaff$var$patchOnProperties(target, filteredProperties, prototype);
}
/**
 * Get all event name properties which the event name startsWith `on`
 * from the target object itself, inherited properties are not considered.
 */ function $bcf05a352a8cfaff$var$getOnEventNames(target) {
    return Object.getOwnPropertyNames(target).filter((name)=>name.startsWith('on') && name.length > 2).map((name)=>name.substring(2));
}
function $bcf05a352a8cfaff$var$propertyDescriptorPatch(api, _global) {
    if ($bcf05a352a8cfaff$var$isNode && !$bcf05a352a8cfaff$var$isMix) return;
    if (Zone[api.symbol('patchEvents')]) // events are already been patched by legacy patch.
    return;
    const ignoreProperties = _global['__Zone_ignore_on_properties'];
    // for browsers that we can patch the descriptor:  Chrome & Firefox
    let patchTargets = [];
    if ($bcf05a352a8cfaff$var$isBrowser) {
        const internalWindow = window;
        patchTargets = patchTargets.concat([
            'Document',
            'SVGElement',
            'Element',
            'HTMLElement',
            'HTMLBodyElement',
            'HTMLMediaElement',
            'HTMLFrameSetElement',
            'HTMLFrameElement',
            'HTMLIFrameElement',
            'HTMLMarqueeElement',
            'Worker'
        ]);
        const ignoreErrorProperties = [];
        // In older browsers like IE or Edge, event handler properties (e.g., `onclick`)
        // may not be defined directly on the `window` object but on its prototype (`WindowPrototype`).
        // To ensure complete coverage, we use the prototype when checking
        // for and patching these properties.
        $bcf05a352a8cfaff$var$patchFilteredProperties(internalWindow, $bcf05a352a8cfaff$var$getOnEventNames(internalWindow), ignoreProperties ? ignoreProperties.concat(ignoreErrorProperties) : ignoreProperties, $bcf05a352a8cfaff$var$ObjectGetPrototypeOf(internalWindow));
    }
    patchTargets = patchTargets.concat([
        'XMLHttpRequest',
        'XMLHttpRequestEventTarget',
        'IDBIndex',
        'IDBRequest',
        'IDBOpenDBRequest',
        'IDBDatabase',
        'IDBTransaction',
        'IDBCursor',
        'WebSocket'
    ]);
    for(let i = 0; i < patchTargets.length; i++){
        const target = _global[patchTargets[i]];
        target?.prototype && $bcf05a352a8cfaff$var$patchFilteredProperties(target.prototype, $bcf05a352a8cfaff$var$getOnEventNames(target.prototype), ignoreProperties);
    }
}
/**
 * @fileoverview
 * @suppress {missingRequire}
 */ function $bcf05a352a8cfaff$var$patchBrowser(Zone1) {
    Zone1.__load_patch('legacy', (global)=>{
        const legacyPatch = global[Zone1.__symbol__('legacyPatch')];
        if (legacyPatch) legacyPatch();
    });
    Zone1.__load_patch('timers', (global)=>{
        const set = 'set';
        const clear = 'clear';
        $bcf05a352a8cfaff$var$patchTimer(global, set, clear, 'Timeout');
        $bcf05a352a8cfaff$var$patchTimer(global, set, clear, 'Interval');
        $bcf05a352a8cfaff$var$patchTimer(global, set, clear, 'Immediate');
    });
    Zone1.__load_patch('requestAnimationFrame', (global)=>{
        $bcf05a352a8cfaff$var$patchTimer(global, 'request', 'cancel', 'AnimationFrame');
        $bcf05a352a8cfaff$var$patchTimer(global, 'mozRequest', 'mozCancel', 'AnimationFrame');
        $bcf05a352a8cfaff$var$patchTimer(global, 'webkitRequest', 'webkitCancel', 'AnimationFrame');
    });
    Zone1.__load_patch('blocking', (global, Zone1)=>{
        const blockingMethods = [
            'alert',
            'prompt',
            'confirm'
        ];
        for(let i = 0; i < blockingMethods.length; i++){
            const name = blockingMethods[i];
            $bcf05a352a8cfaff$var$patchMethod(global, name, (delegate, symbol, name)=>{
                return function(s, args) {
                    return Zone1.current.run(delegate, global, args, name);
                };
            });
        }
    });
    Zone1.__load_patch('EventTarget', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$patchEvent(global, api);
        $bcf05a352a8cfaff$var$eventTargetPatch(global, api);
        // patch XMLHttpRequestEventTarget's addEventListener/removeEventListener
        const XMLHttpRequestEventTarget = global['XMLHttpRequestEventTarget'];
        if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) api.patchEventTarget(global, api, [
            XMLHttpRequestEventTarget.prototype
        ]);
    });
    Zone1.__load_patch('MutationObserver', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$patchClass('MutationObserver');
        $bcf05a352a8cfaff$var$patchClass('WebKitMutationObserver');
    });
    Zone1.__load_patch('IntersectionObserver', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$patchClass('IntersectionObserver');
    });
    Zone1.__load_patch('FileReader', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$patchClass('FileReader');
    });
    Zone1.__load_patch('on_property', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$propertyDescriptorPatch(api, global);
    });
    Zone1.__load_patch('customElements', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$patchCustomElements(global, api);
    });
    Zone1.__load_patch('XHR', (global, Zone1)=>{
        // Treat XMLHttpRequest as a macrotask.
        patchXHR(global);
        const XHR_TASK = $bcf05a352a8cfaff$var$zoneSymbol('xhrTask');
        const XHR_SYNC = $bcf05a352a8cfaff$var$zoneSymbol('xhrSync');
        const XHR_LISTENER = $bcf05a352a8cfaff$var$zoneSymbol('xhrListener');
        const XHR_SCHEDULED = $bcf05a352a8cfaff$var$zoneSymbol('xhrScheduled');
        const XHR_URL = $bcf05a352a8cfaff$var$zoneSymbol('xhrURL');
        const XHR_ERROR_BEFORE_SCHEDULED = $bcf05a352a8cfaff$var$zoneSymbol('xhrErrorBeforeScheduled');
        function patchXHR(window1) {
            const XMLHttpRequest = window1['XMLHttpRequest'];
            if (!XMLHttpRequest) // XMLHttpRequest is not available in service worker
            return;
            const XMLHttpRequestPrototype = XMLHttpRequest.prototype;
            function findPendingTask(target) {
                return target[XHR_TASK];
            }
            let oriAddListener = XMLHttpRequestPrototype[$bcf05a352a8cfaff$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
            let oriRemoveListener = XMLHttpRequestPrototype[$bcf05a352a8cfaff$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
            if (!oriAddListener) {
                const XMLHttpRequestEventTarget = window1['XMLHttpRequestEventTarget'];
                if (XMLHttpRequestEventTarget) {
                    const XMLHttpRequestEventTargetPrototype = XMLHttpRequestEventTarget.prototype;
                    oriAddListener = XMLHttpRequestEventTargetPrototype[$bcf05a352a8cfaff$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = XMLHttpRequestEventTargetPrototype[$bcf05a352a8cfaff$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
            }
            const READY_STATE_CHANGE = 'readystatechange';
            const SCHEDULED = 'scheduled';
            function scheduleTask(task) {
                const data = task.data;
                const target = data.target;
                target[XHR_SCHEDULED] = false;
                target[XHR_ERROR_BEFORE_SCHEDULED] = false;
                // remove existing event listener
                const listener = target[XHR_LISTENER];
                if (!oriAddListener) {
                    oriAddListener = target[$bcf05a352a8cfaff$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = target[$bcf05a352a8cfaff$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
                if (listener) oriRemoveListener.call(target, READY_STATE_CHANGE, listener);
                const newListener = target[XHR_LISTENER] = ()=>{
                    if (target.readyState === target.DONE) {
                        // sometimes on some browsers XMLHttpRequest will fire onreadystatechange with
                        // readyState=4 multiple times, so we need to check task state here
                        if (!data.aborted && target[XHR_SCHEDULED] && task.state === SCHEDULED) {
                            // check whether the xhr has registered onload listener
                            // if that is the case, the task should invoke after all
                            // onload listeners finish.
                            // Also if the request failed without response (status = 0), the load event handler
                            // will not be triggered, in that case, we should also invoke the placeholder callback
                            // to close the XMLHttpRequest::send macroTask.
                            // https://github.com/angular/angular/issues/38795
                            const loadTasks = target[Zone1.__symbol__('loadfalse')];
                            if (target.status !== 0 && loadTasks && loadTasks.length > 0) {
                                const oriInvoke = task.invoke;
                                task.invoke = function() {
                                    // need to load the tasks again, because in other
                                    // load listener, they may remove themselves
                                    const loadTasks = target[Zone1.__symbol__('loadfalse')];
                                    for(let i = 0; i < loadTasks.length; i++)if (loadTasks[i] === task) loadTasks.splice(i, 1);
                                    if (!data.aborted && task.state === SCHEDULED) oriInvoke.call(task);
                                };
                                loadTasks.push(task);
                            } else task.invoke();
                        } else if (!data.aborted && target[XHR_SCHEDULED] === false) // error occurs when xhr.send()
                        target[XHR_ERROR_BEFORE_SCHEDULED] = true;
                    }
                };
                oriAddListener.call(target, READY_STATE_CHANGE, newListener);
                const storedTask = target[XHR_TASK];
                if (!storedTask) target[XHR_TASK] = task;
                sendNative.apply(target, data.args);
                target[XHR_SCHEDULED] = true;
                return task;
            }
            function placeholderCallback() {}
            function clearTask(task) {
                const data = task.data;
                // Note - ideally, we would call data.target.removeEventListener here, but it's too late
                // to prevent it from firing. So instead, we store info for the event listener.
                data.aborted = true;
                return abortNative.apply(data.target, data.args);
            }
            const openNative = $bcf05a352a8cfaff$var$patchMethod(XMLHttpRequestPrototype, 'open', ()=>function(self1, args) {
                    self1[XHR_SYNC] = args[2] == false;
                    self1[XHR_URL] = args[1];
                    return openNative.apply(self1, args);
                });
            const XMLHTTPREQUEST_SOURCE = 'XMLHttpRequest.send';
            const fetchTaskAborting = $bcf05a352a8cfaff$var$zoneSymbol('fetchTaskAborting');
            const fetchTaskScheduling = $bcf05a352a8cfaff$var$zoneSymbol('fetchTaskScheduling');
            const sendNative = $bcf05a352a8cfaff$var$patchMethod(XMLHttpRequestPrototype, 'send', ()=>function(self1, args) {
                    if (Zone1.current[fetchTaskScheduling] === true) // a fetch is scheduling, so we are using xhr to polyfill fetch
                    // and because we already schedule macroTask for fetch, we should
                    // not schedule a macroTask for xhr again
                    return sendNative.apply(self1, args);
                    if (self1[XHR_SYNC]) // if the XHR is sync there is no task to schedule, just execute the code.
                    return sendNative.apply(self1, args);
                    else {
                        const options = {
                            target: self1,
                            url: self1[XHR_URL],
                            isPeriodic: false,
                            args: args,
                            aborted: false
                        };
                        const task = $bcf05a352a8cfaff$var$scheduleMacroTaskWithCurrentZone(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
                        if (self1 && self1[XHR_ERROR_BEFORE_SCHEDULED] === true && !options.aborted && task.state === SCHEDULED) // xhr request throw error when send
                        // we should invoke task instead of leaving a scheduled
                        // pending macroTask
                        task.invoke();
                    }
                });
            const abortNative = $bcf05a352a8cfaff$var$patchMethod(XMLHttpRequestPrototype, 'abort', ()=>function(self1, args) {
                    const task = findPendingTask(self1);
                    if (task && typeof task.type == 'string') {
                        // If the XHR has already completed, do nothing.
                        // If the XHR has already been aborted, do nothing.
                        // Fix #569, call abort multiple times before done will cause
                        // macroTask task count be negative number
                        if (task.cancelFn == null || task.data && task.data.aborted) return;
                        task.zone.cancelTask(task);
                    } else if (Zone1.current[fetchTaskAborting] === true) // the abort is called from fetch polyfill, we need to call native abort of XHR.
                    return abortNative.apply(self1, args);
                // Otherwise, we are trying to abort an XHR which has not yet been sent, so there is no
                // task
                // to cancel. Do nothing.
                });
        }
    });
    Zone1.__load_patch('geolocation', (global)=>{
        /// GEO_LOCATION
        if (global['navigator'] && global['navigator'].geolocation) $bcf05a352a8cfaff$var$patchPrototype(global['navigator'].geolocation, [
            'getCurrentPosition',
            'watchPosition'
        ]);
    });
    Zone1.__load_patch('PromiseRejectionEvent', (global, Zone1)=>{
        // handle unhandled promise rejection
        function findPromiseRejectionHandler(evtName) {
            return function(e) {
                const eventTasks = $bcf05a352a8cfaff$var$findEventTasks(global, evtName);
                eventTasks.forEach((eventTask)=>{
                    // windows has added unhandledrejection event listener
                    // trigger the event listener
                    const PromiseRejectionEvent = global['PromiseRejectionEvent'];
                    if (PromiseRejectionEvent) {
                        const evt = new PromiseRejectionEvent(evtName, {
                            promise: e.promise,
                            reason: e.rejection
                        });
                        eventTask.invoke(evt);
                    }
                });
            };
        }
        if (global['PromiseRejectionEvent']) {
            Zone1[$bcf05a352a8cfaff$var$zoneSymbol('unhandledPromiseRejectionHandler')] = findPromiseRejectionHandler('unhandledrejection');
            Zone1[$bcf05a352a8cfaff$var$zoneSymbol('rejectionHandledHandler')] = findPromiseRejectionHandler('rejectionhandled');
        }
    });
    Zone1.__load_patch('queueMicrotask', (global, Zone1, api)=>{
        $bcf05a352a8cfaff$var$patchQueueMicrotask(global, api);
    });
}
function $bcf05a352a8cfaff$var$patchPromise(Zone1) {
    Zone1.__load_patch('ZoneAwarePromise', (global, Zone1, api)=>{
        const ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        const ObjectDefineProperty = Object.defineProperty;
        function readableObjectToString(obj) {
            if (obj && obj.toString === Object.prototype.toString) {
                const className = obj.constructor && obj.constructor.name;
                return (className ? className : '') + ': ' + JSON.stringify(obj);
            }
            return obj ? obj.toString() : Object.prototype.toString.call(obj);
        }
        const __symbol__ = api.symbol;
        const _uncaughtPromiseErrors = [];
        const isDisableWrappingUncaughtPromiseRejection = global[__symbol__('DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION')] !== false;
        const symbolPromise = __symbol__('Promise');
        const symbolThen = __symbol__('then');
        const creationTrace = '__creationTrace__';
        api.onUnhandledError = (e)=>{
            if (api.showUncaughtError()) {
                const rejection = e && e.rejection;
                if (rejection) console.error('Unhandled Promise rejection:', rejection instanceof Error ? rejection.message : rejection, '; Zone:', e.zone.name, '; Task:', e.task && e.task.source, '; Value:', rejection, rejection instanceof Error ? rejection.stack : undefined);
                else console.error(e);
            }
        };
        api.microtaskDrainDone = ()=>{
            while(_uncaughtPromiseErrors.length){
                const uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                try {
                    uncaughtPromiseError.zone.runGuarded(()=>{
                        if (uncaughtPromiseError.throwOriginal) throw uncaughtPromiseError.rejection;
                        throw uncaughtPromiseError;
                    });
                } catch (error) {
                    handleUnhandledRejection(error);
                }
            }
        };
        const UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__('unhandledPromiseRejectionHandler');
        function handleUnhandledRejection(e) {
            api.onUnhandledError(e);
            try {
                const handler = Zone1[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
                if (typeof handler === 'function') handler.call(this, e);
            } catch (err) {}
        }
        function isThenable(value) {
            return value && typeof value.then === 'function';
        }
        function forwardResolution(value) {
            return value;
        }
        function forwardRejection(rejection) {
            return ZoneAwarePromise.reject(rejection);
        }
        const symbolState = __symbol__('state');
        const symbolValue = __symbol__('value');
        const symbolFinally = __symbol__('finally');
        const symbolParentPromiseValue = __symbol__('parentPromiseValue');
        const symbolParentPromiseState = __symbol__('parentPromiseState');
        const source = 'Promise.then';
        const UNRESOLVED = null;
        const RESOLVED = true;
        const REJECTED = false;
        const REJECTED_NO_CATCH = 0;
        function makeResolver(promise, state) {
            return (v)=>{
                try {
                    resolvePromise(promise, state, v);
                } catch (err) {
                    resolvePromise(promise, false, err);
                }
            // Do not return value or you will break the Promise spec.
            };
        }
        const once = function() {
            let wasCalled = false;
            return function wrapper(wrappedFunction) {
                return function() {
                    if (wasCalled) return;
                    wasCalled = true;
                    wrappedFunction.apply(null, arguments);
                };
            };
        };
        const TYPE_ERROR = 'Promise resolved with itself';
        const CURRENT_TASK_TRACE_SYMBOL = __symbol__('currentTaskTrace');
        // Promise Resolution
        function resolvePromise(promise, state, value) {
            const onceWrapper = once();
            if (promise === value) throw new TypeError(TYPE_ERROR);
            if (promise[symbolState] === UNRESOLVED) {
                // should only get value.then once based on promise spec.
                let then = null;
                try {
                    if (typeof value === 'object' || typeof value === 'function') then = value && value.then;
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                    return promise;
                }
                // if (value instanceof ZoneAwarePromise) {
                if (state !== REJECTED && value instanceof ZoneAwarePromise && value.hasOwnProperty(symbolState) && value.hasOwnProperty(symbolValue) && value[symbolState] !== UNRESOLVED) {
                    clearRejectedNoCatch(value);
                    resolvePromise(promise, value[symbolState], value[symbolValue]);
                } else if (state !== REJECTED && typeof then === 'function') try {
                    then.call(value, onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false)));
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                }
                else {
                    promise[symbolState] = state;
                    const queue = promise[symbolValue];
                    promise[symbolValue] = value;
                    if (promise[symbolFinally] === symbolFinally) // the promise is generated by Promise.prototype.finally
                    {
                        if (state === RESOLVED) {
                            // the state is resolved, should ignore the value
                            // and use parent promise value
                            promise[symbolState] = promise[symbolParentPromiseState];
                            promise[symbolValue] = promise[symbolParentPromiseValue];
                        }
                    }
                    // record task information in value when error occurs, so we can
                    // do some additional work such as render longStackTrace
                    if (state === REJECTED && value instanceof Error) {
                        // check if longStackTraceZone is here
                        const trace = Zone1.currentTask && Zone1.currentTask.data && Zone1.currentTask.data[creationTrace];
                        if (trace) // only keep the long stack trace into error when in longStackTraceZone
                        ObjectDefineProperty(value, CURRENT_TASK_TRACE_SYMBOL, {
                            configurable: true,
                            enumerable: false,
                            writable: true,
                            value: trace
                        });
                    }
                    for(let i = 0; i < queue.length;)scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                    if (queue.length == 0 && state == REJECTED) {
                        promise[symbolState] = REJECTED_NO_CATCH;
                        let uncaughtPromiseError = value;
                        try {
                            // Here we throws a new Error to print more readable error log
                            // and if the value is not an error, zone.js builds an `Error`
                            // Object here to attach the stack information.
                            throw new Error('Uncaught (in promise): ' + readableObjectToString(value) + (value && value.stack ? '\n' + value.stack : ''));
                        } catch (err) {
                            uncaughtPromiseError = err;
                        }
                        if (isDisableWrappingUncaughtPromiseRejection) // If disable wrapping uncaught promise reject
                        // use the value instead of wrapping it.
                        uncaughtPromiseError.throwOriginal = true;
                        uncaughtPromiseError.rejection = value;
                        uncaughtPromiseError.promise = promise;
                        uncaughtPromiseError.zone = Zone1.current;
                        uncaughtPromiseError.task = Zone1.currentTask;
                        _uncaughtPromiseErrors.push(uncaughtPromiseError);
                        api.scheduleMicroTask(); // to make sure that it is running
                    }
                }
            }
            // Resolving an already resolved promise is a noop.
            return promise;
        }
        const REJECTION_HANDLED_HANDLER = __symbol__('rejectionHandledHandler');
        function clearRejectedNoCatch(promise) {
            if (promise[symbolState] === REJECTED_NO_CATCH) {
                // if the promise is rejected no catch status
                // and queue.length > 0, means there is a error handler
                // here to handle the rejected promise, we should trigger
                // windows.rejectionhandled eventHandler or nodejs rejectionHandled
                // eventHandler
                try {
                    const handler = Zone1[REJECTION_HANDLED_HANDLER];
                    if (handler && typeof handler === 'function') handler.call(this, {
                        rejection: promise[symbolValue],
                        promise: promise
                    });
                } catch (err) {}
                promise[symbolState] = REJECTED;
                for(let i = 0; i < _uncaughtPromiseErrors.length; i++)if (promise === _uncaughtPromiseErrors[i].promise) _uncaughtPromiseErrors.splice(i, 1);
            }
        }
        function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
            clearRejectedNoCatch(promise);
            const promiseState = promise[symbolState];
            const delegate = promiseState ? typeof onFulfilled === 'function' ? onFulfilled : forwardResolution : typeof onRejected === 'function' ? onRejected : forwardRejection;
            zone.scheduleMicroTask(source, ()=>{
                try {
                    const parentPromiseValue = promise[symbolValue];
                    const isFinallyPromise = !!chainPromise && symbolFinally === chainPromise[symbolFinally];
                    if (isFinallyPromise) {
                        // if the promise is generated from finally call, keep parent promise's state and value
                        chainPromise[symbolParentPromiseValue] = parentPromiseValue;
                        chainPromise[symbolParentPromiseState] = promiseState;
                    }
                    // should not pass value to finally callback
                    const value = zone.run(delegate, undefined, isFinallyPromise && delegate !== forwardRejection && delegate !== forwardResolution ? [] : [
                        parentPromiseValue
                    ]);
                    resolvePromise(chainPromise, true, value);
                } catch (error) {
                    // if error occurs, should always return this error
                    resolvePromise(chainPromise, false, error);
                }
            }, chainPromise);
        }
        const ZONE_AWARE_PROMISE_TO_STRING = 'function ZoneAwarePromise() { [native code] }';
        const noop = function() {};
        const AggregateError = global.AggregateError;
        class ZoneAwarePromise {
            static toString() {
                return ZONE_AWARE_PROMISE_TO_STRING;
            }
            static resolve(value) {
                if (value instanceof ZoneAwarePromise) return value;
                return resolvePromise(new this(null), RESOLVED, value);
            }
            static reject(error) {
                return resolvePromise(new this(null), REJECTED, error);
            }
            static withResolvers() {
                const result = {};
                result.promise = new ZoneAwarePromise((res, rej)=>{
                    result.resolve = res;
                    result.reject = rej;
                });
                return result;
            }
            static any(values) {
                if (!values || typeof values[Symbol.iterator] !== 'function') return Promise.reject(new AggregateError([], 'All promises were rejected'));
                const promises = [];
                let count = 0;
                try {
                    for (let v of values){
                        count++;
                        promises.push(ZoneAwarePromise.resolve(v));
                    }
                } catch (err) {
                    return Promise.reject(new AggregateError([], 'All promises were rejected'));
                }
                if (count === 0) return Promise.reject(new AggregateError([], 'All promises were rejected'));
                let finished = false;
                const errors = [];
                return new ZoneAwarePromise((resolve, reject)=>{
                    for(let i = 0; i < promises.length; i++)promises[i].then((v)=>{
                        if (finished) return;
                        finished = true;
                        resolve(v);
                    }, (err)=>{
                        errors.push(err);
                        count--;
                        if (count === 0) {
                            finished = true;
                            reject(new AggregateError(errors, 'All promises were rejected'));
                        }
                    });
                });
            }
            static race(values) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                function onResolve(value) {
                    resolve(value);
                }
                function onReject(error) {
                    reject(error);
                }
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    value.then(onResolve, onReject);
                }
                return promise;
            }
            static all(values) {
                return ZoneAwarePromise.allWithCallback(values);
            }
            static allSettled(values) {
                const P = this && this.prototype instanceof ZoneAwarePromise ? this : ZoneAwarePromise;
                return P.allWithCallback(values, {
                    thenCallback: (value)=>({
                            status: 'fulfilled',
                            value: value
                        }),
                    errorCallback: (err)=>({
                            status: 'rejected',
                            reason: err
                        })
                });
            }
            static allWithCallback(values, callback) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                // Start at 2 to prevent prematurely resolving if .then is called immediately.
                let unresolvedCount = 2;
                let valueIndex = 0;
                const resolvedValues = [];
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    const curValueIndex = valueIndex;
                    try {
                        value.then((value)=>{
                            resolvedValues[curValueIndex] = callback ? callback.thenCallback(value) : value;
                            unresolvedCount--;
                            if (unresolvedCount === 0) resolve(resolvedValues);
                        }, (err)=>{
                            if (!callback) reject(err);
                            else {
                                resolvedValues[curValueIndex] = callback.errorCallback(err);
                                unresolvedCount--;
                                if (unresolvedCount === 0) resolve(resolvedValues);
                            }
                        });
                    } catch (thenErr) {
                        reject(thenErr);
                    }
                    unresolvedCount++;
                    valueIndex++;
                }
                // Make the unresolvedCount zero-based again.
                unresolvedCount -= 2;
                if (unresolvedCount === 0) resolve(resolvedValues);
                return promise;
            }
            constructor(executor){
                const promise = this;
                if (!(promise instanceof ZoneAwarePromise)) throw new Error('Must be an instanceof Promise.');
                promise[symbolState] = UNRESOLVED;
                promise[symbolValue] = []; // queue;
                try {
                    const onceWrapper = once();
                    executor && executor(onceWrapper(makeResolver(promise, RESOLVED)), onceWrapper(makeResolver(promise, REJECTED)));
                } catch (error) {
                    resolvePromise(promise, false, error);
                }
            }
            get [Symbol.toStringTag]() {
                return 'Promise';
            }
            get [Symbol.species]() {
                return ZoneAwarePromise;
            }
            then(onFulfilled, onRejected) {
                // We must read `Symbol.species` safely because `this` may be anything. For instance, `this`
                // may be an object without a prototype (created through `Object.create(null)`); thus
                // `this.constructor` will be undefined. One of the use cases is SystemJS creating
                // prototype-less objects (modules) via `Object.create(null)`. The SystemJS creates an empty
                // object and copies promise properties into that object (within the `getOrCreateLoad`
                // function). The zone.js then checks if the resolved value has the `then` method and
                // invokes it with the `value` context. Otherwise, this will throw an error: `TypeError:
                // Cannot read properties of undefined (reading 'Symbol(Symbol.species)')`.
                let C = this.constructor?.[Symbol.species];
                if (!C || typeof C !== 'function') C = this.constructor || ZoneAwarePromise;
                const chainPromise = new C(noop);
                const zone = Zone1.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
                else scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
                return chainPromise;
            }
            catch(onRejected) {
                return this.then(null, onRejected);
            }
            finally(onFinally) {
                // See comment on the call to `then` about why thee `Symbol.species` is safely accessed.
                let C = this.constructor?.[Symbol.species];
                if (!C || typeof C !== 'function') C = ZoneAwarePromise;
                const chainPromise = new C(noop);
                chainPromise[symbolFinally] = symbolFinally;
                const zone = Zone1.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFinally, onFinally);
                else scheduleResolveOrReject(this, zone, chainPromise, onFinally, onFinally);
                return chainPromise;
            }
        }
        // Protect against aggressive optimizers dropping seemingly unused properties.
        // E.g. Closure Compiler in advanced mode.
        ZoneAwarePromise['resolve'] = ZoneAwarePromise.resolve;
        ZoneAwarePromise['reject'] = ZoneAwarePromise.reject;
        ZoneAwarePromise['race'] = ZoneAwarePromise.race;
        ZoneAwarePromise['all'] = ZoneAwarePromise.all;
        const NativePromise = global[symbolPromise] = global['Promise'];
        global['Promise'] = ZoneAwarePromise;
        const symbolThenPatched = __symbol__('thenPatched');
        function patchThen(Ctor) {
            const proto = Ctor.prototype;
            const prop = ObjectGetOwnPropertyDescriptor(proto, 'then');
            if (prop && (prop.writable === false || !prop.configurable)) // check Ctor.prototype.then propertyDescriptor is writable or not
            // in meteor env, writable is false, we should ignore such case
            return;
            const originalThen = proto.then;
            // Keep a reference to the original method.
            proto[symbolThen] = originalThen;
            Ctor.prototype.then = function(onResolve, onReject) {
                const wrapped = new ZoneAwarePromise((resolve, reject)=>{
                    originalThen.call(this, resolve, reject);
                });
                return wrapped.then(onResolve, onReject);
            };
            Ctor[symbolThenPatched] = true;
        }
        api.patchThen = patchThen;
        function zoneify(fn) {
            return function(self1, args) {
                let resultPromise = fn.apply(self1, args);
                if (resultPromise instanceof ZoneAwarePromise) return resultPromise;
                let ctor = resultPromise.constructor;
                if (!ctor[symbolThenPatched]) patchThen(ctor);
                return resultPromise;
            };
        }
        if (NativePromise) {
            patchThen(NativePromise);
            $bcf05a352a8cfaff$var$patchMethod(global, 'fetch', (delegate)=>zoneify(delegate));
        }
        // This is not part of public API, but it is useful for tests, so we expose it.
        Promise[Zone1.__symbol__('uncaughtPromiseErrors')] = _uncaughtPromiseErrors;
        return ZoneAwarePromise;
    });
}
function $bcf05a352a8cfaff$var$patchToString(Zone1) {
    // override Function.prototype.toString to make zone.js patched function
    // look like native function
    Zone1.__load_patch('toString', (global)=>{
        // patch Func.prototype.toString to let them look like native
        const originalFunctionToString = Function.prototype.toString;
        const ORIGINAL_DELEGATE_SYMBOL = $bcf05a352a8cfaff$var$zoneSymbol('OriginalDelegate');
        const PROMISE_SYMBOL = $bcf05a352a8cfaff$var$zoneSymbol('Promise');
        const ERROR_SYMBOL = $bcf05a352a8cfaff$var$zoneSymbol('Error');
        const newFunctionToString = function toString() {
            if (typeof this === 'function') {
                const originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
                if (originalDelegate) {
                    if (typeof originalDelegate === 'function') return originalFunctionToString.call(originalDelegate);
                    else return Object.prototype.toString.call(originalDelegate);
                }
                if (this === Promise) {
                    const nativePromise = global[PROMISE_SYMBOL];
                    if (nativePromise) return originalFunctionToString.call(nativePromise);
                }
                if (this === Error) {
                    const nativeError = global[ERROR_SYMBOL];
                    if (nativeError) return originalFunctionToString.call(nativeError);
                }
            }
            return originalFunctionToString.call(this);
        };
        newFunctionToString[ORIGINAL_DELEGATE_SYMBOL] = originalFunctionToString;
        Function.prototype.toString = newFunctionToString;
        // patch Object.prototype.toString to let them look like native
        const originalObjectToString = Object.prototype.toString;
        const PROMISE_OBJECT_TO_STRING = '[object Promise]';
        Object.prototype.toString = function() {
            if (typeof Promise === 'function' && this instanceof Promise) return PROMISE_OBJECT_TO_STRING;
            return originalObjectToString.call(this);
        };
    });
}
function $bcf05a352a8cfaff$var$patchCallbacks(api, target, targetName, method, callbacks) {
    const symbol = Zone.__symbol__(method);
    if (target[symbol]) return;
    const nativeDelegate = target[symbol] = target[method];
    target[method] = function(name, opts, options) {
        if (opts && opts.prototype) callbacks.forEach(function(callback) {
            const source = `${targetName}.${method}::` + callback;
            const prototype = opts.prototype;
            // Note: the `patchCallbacks` is used for patching the `document.registerElement` and
            // `customElements.define`. We explicitly wrap the patching code into try-catch since
            // callbacks may be already patched by other web components frameworks (e.g. LWC), and they
            // make those properties non-writable. This means that patching callback will throw an error
            // `cannot assign to read-only property`. See this code as an example:
            // https://github.com/salesforce/lwc/blob/master/packages/@lwc/engine-core/src/framework/base-bridge-element.ts#L180-L186
            // We don't want to stop the application rendering if we couldn't patch some
            // callback, e.g. `attributeChangedCallback`.
            try {
                if (prototype.hasOwnProperty(callback)) {
                    const descriptor = api.ObjectGetOwnPropertyDescriptor(prototype, callback);
                    if (descriptor && descriptor.value) {
                        descriptor.value = api.wrapWithCurrentZone(descriptor.value, source);
                        api._redefineProperty(opts.prototype, callback, descriptor);
                    } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
            } catch  {
            // Note: we leave the catch block empty since there's no way to handle the error related
            // to non-writable property.
            }
        });
        return nativeDelegate.call(target, name, opts, options);
    };
    api.attachOriginToPatched(target[method], nativeDelegate);
}
function $bcf05a352a8cfaff$var$patchUtil(Zone1) {
    Zone1.__load_patch('util', (global, Zone1, api)=>{
        // Collect native event names by looking at properties
        // on the global namespace, e.g. 'onclick'.
        const eventNames = $bcf05a352a8cfaff$var$getOnEventNames(global);
        api.patchOnProperties = $bcf05a352a8cfaff$var$patchOnProperties;
        api.patchMethod = $bcf05a352a8cfaff$var$patchMethod;
        api.bindArguments = $bcf05a352a8cfaff$var$bindArguments;
        api.patchMacroTask = $bcf05a352a8cfaff$var$patchMacroTask;
        // In earlier version of zone.js (<0.9.0), we use env name `__zone_symbol__BLACK_LISTED_EVENTS`
        // to define which events will not be patched by `Zone.js`. In newer version (>=0.9.0), we
        // change the env name to `__zone_symbol__UNPATCHED_EVENTS` to keep the name consistent with
        // angular repo. The  `__zone_symbol__BLACK_LISTED_EVENTS` is deprecated, but it is still be
        // supported for backwards compatibility.
        const SYMBOL_BLACK_LISTED_EVENTS = Zone1.__symbol__('BLACK_LISTED_EVENTS');
        const SYMBOL_UNPATCHED_EVENTS = Zone1.__symbol__('UNPATCHED_EVENTS');
        if (global[SYMBOL_UNPATCHED_EVENTS]) global[SYMBOL_BLACK_LISTED_EVENTS] = global[SYMBOL_UNPATCHED_EVENTS];
        if (global[SYMBOL_BLACK_LISTED_EVENTS]) Zone1[SYMBOL_BLACK_LISTED_EVENTS] = Zone1[SYMBOL_UNPATCHED_EVENTS] = global[SYMBOL_BLACK_LISTED_EVENTS];
        api.patchEventPrototype = $bcf05a352a8cfaff$var$patchEventPrototype;
        api.patchEventTarget = $bcf05a352a8cfaff$var$patchEventTarget;
        api.isIEOrEdge = $bcf05a352a8cfaff$var$isIEOrEdge;
        api.ObjectDefineProperty = $bcf05a352a8cfaff$var$ObjectDefineProperty;
        api.ObjectGetOwnPropertyDescriptor = $bcf05a352a8cfaff$var$ObjectGetOwnPropertyDescriptor;
        api.ObjectCreate = $bcf05a352a8cfaff$var$ObjectCreate;
        api.ArraySlice = $bcf05a352a8cfaff$var$ArraySlice;
        api.patchClass = $bcf05a352a8cfaff$var$patchClass;
        api.wrapWithCurrentZone = $bcf05a352a8cfaff$var$wrapWithCurrentZone;
        api.filterProperties = $bcf05a352a8cfaff$var$filterProperties;
        api.attachOriginToPatched = $bcf05a352a8cfaff$var$attachOriginToPatched;
        api._redefineProperty = Object.defineProperty;
        api.patchCallbacks = $bcf05a352a8cfaff$var$patchCallbacks;
        api.getGlobalObjects = ()=>({
                globalSources: $bcf05a352a8cfaff$var$globalSources,
                zoneSymbolEventNames: $bcf05a352a8cfaff$var$zoneSymbolEventNames,
                eventNames: eventNames,
                isBrowser: $bcf05a352a8cfaff$var$isBrowser,
                isMix: $bcf05a352a8cfaff$var$isMix,
                isNode: $bcf05a352a8cfaff$var$isNode,
                TRUE_STR: $bcf05a352a8cfaff$var$TRUE_STR,
                FALSE_STR: $bcf05a352a8cfaff$var$FALSE_STR,
                ZONE_SYMBOL_PREFIX: $bcf05a352a8cfaff$var$ZONE_SYMBOL_PREFIX,
                ADD_EVENT_LISTENER_STR: $bcf05a352a8cfaff$var$ADD_EVENT_LISTENER_STR,
                REMOVE_EVENT_LISTENER_STR: $bcf05a352a8cfaff$var$REMOVE_EVENT_LISTENER_STR
            });
    });
}
function $bcf05a352a8cfaff$var$patchCommon(Zone1) {
    $bcf05a352a8cfaff$var$patchPromise(Zone1);
    $bcf05a352a8cfaff$var$patchToString(Zone1);
    $bcf05a352a8cfaff$var$patchUtil(Zone1);
}
const $bcf05a352a8cfaff$var$Zone$1 = $bcf05a352a8cfaff$var$loadZone();
$bcf05a352a8cfaff$var$patchCommon($bcf05a352a8cfaff$var$Zone$1);
$bcf05a352a8cfaff$var$patchBrowser($bcf05a352a8cfaff$var$Zone$1);




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dStz2 = parcelRequire("dStz2");parcelRequire("15v9P");
var $j5ja1 = parcelRequire("j5ja1");
var $1iLvl = parcelRequire("1iLvl");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fJacQ = parcelRequire("fJacQ");
const $8cf02d28c127a3b0$var$SUPPRESS_TRACING_KEY = (0, $fJacQ.createContextKey)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $8cf02d28c127a3b0$export$869298f9835abc68(context) {
    return context.setValue($8cf02d28c127a3b0$var$SUPPRESS_TRACING_KEY, true);
}
function $8cf02d28c127a3b0$export$a8cb26cef1019d30(context) {
    return context.deleteValue($8cf02d28c127a3b0$var$SUPPRESS_TRACING_KEY);
}
function $8cf02d28c127a3b0$export$7d5f2376f7cf513(context) {
    return context.getValue($8cf02d28c127a3b0$var$SUPPRESS_TRACING_KEY) === true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $273e972a2f7c4012$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $273e972a2f7c4012$var$VALID_KEY = `[a-z]${$273e972a2f7c4012$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $273e972a2f7c4012$var$VALID_VENDOR_KEY = `[a-z0-9]${$273e972a2f7c4012$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$273e972a2f7c4012$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $273e972a2f7c4012$var$VALID_KEY_REGEX = new RegExp(`^(?:${$273e972a2f7c4012$var$VALID_KEY}|${$273e972a2f7c4012$var$VALID_VENDOR_KEY})$`);
const $273e972a2f7c4012$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $273e972a2f7c4012$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $273e972a2f7c4012$export$469cc9c479301ba6(key) {
    return $273e972a2f7c4012$var$VALID_KEY_REGEX.test(key);
}
function $273e972a2f7c4012$export$b76e9316566cc26e(value) {
    return $273e972a2f7c4012$var$VALID_VALUE_BASE_REGEX.test(value) && !$273e972a2f7c4012$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $690a3b2b58b5dbbd$var$MAX_TRACE_STATE_ITEMS = 32;
const $690a3b2b58b5dbbd$var$MAX_TRACE_STATE_LEN = 512;
const $690a3b2b58b5dbbd$var$LIST_MEMBERS_SEPARATOR = ',';
const $690a3b2b58b5dbbd$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $690a3b2b58b5dbbd$export$b0addedc390b67c2 {
    _internalState = new Map();
    constructor(rawTraceState){
        if (rawTraceState) this._parse(rawTraceState);
    }
    set(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        const traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys().reduce((agg, key)=>{
            agg.push(key + $690a3b2b58b5dbbd$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, []).join($690a3b2b58b5dbbd$var$LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > $690a3b2b58b5dbbd$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($690a3b2b58b5dbbd$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce((agg, part)=>{
            const listMember = part.trim(); // Optional Whitespace (OWS) handling
            const i = listMember.indexOf($690a3b2b58b5dbbd$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if ((0, $273e972a2f7c4012$export$469cc9c479301ba6)(key) && (0, $273e972a2f7c4012$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $690a3b2b58b5dbbd$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $690a3b2b58b5dbbd$var$MAX_TRACE_STATE_ITEMS));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new $690a3b2b58b5dbbd$export$b0addedc390b67c2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}


const $2450f906c37cbc2d$export$830e05fa2746348 = 'traceparent';
const $2450f906c37cbc2d$export$2b12ed38dcfae2ae = 'tracestate';
const $2450f906c37cbc2d$var$VERSION = '00';
const $2450f906c37cbc2d$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $2450f906c37cbc2d$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $2450f906c37cbc2d$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $2450f906c37cbc2d$var$FLAGS_PART = '[\\da-f]{2}';
const $2450f906c37cbc2d$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$2450f906c37cbc2d$var$VERSION_PART})-(${$2450f906c37cbc2d$var$TRACE_ID_PART})-(${$2450f906c37cbc2d$var$PARENT_ID_PART})-(${$2450f906c37cbc2d$var$FLAGS_PART})(-.*)?\\s?$`);
function $2450f906c37cbc2d$export$f4d87f8901a93f5d(traceParent) {
    const match = $2450f906c37cbc2d$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $2450f906c37cbc2d$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $j5ja1.trace).getSpanContext(context);
        if (!spanContext || (0, $8cf02d28c127a3b0$export$7d5f2376f7cf513)(context) || !(0, $dStz2.isSpanContextValid)(spanContext)) return;
        const traceParent = `${$2450f906c37cbc2d$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $1iLvl.TraceFlags).NONE).toString(16)}`;
        setter.set(carrier, $2450f906c37cbc2d$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $2450f906c37cbc2d$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $2450f906c37cbc2d$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $2450f906c37cbc2d$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $2450f906c37cbc2d$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $690a3b2b58b5dbbd$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $j5ja1.trace).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $2450f906c37cbc2d$export$830e05fa2746348,
            $2450f906c37cbc2d$export$2b12ed38dcfae2ae
        ];
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $10cbcb09243716b2$export$a756c21bf453f1b5 {
    _delegate;
    constructor(_delegate){
        this._delegate = _delegate;
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ export(items, resultCallback) {
        this._delegate.export(items, resultCallback);
    }
    forceFlush() {
        return this._delegate.forceFlush();
    }
    shutdown() {
        return this._delegate.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $68898baf213d5344$export$b22daef4119238cd = performance;


const $c767f1362e0cdd3e$var$NANOSECOND_DIGITS = 9;
const $c767f1362e0cdd3e$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $c767f1362e0cdd3e$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $c767f1362e0cdd3e$var$NANOSECOND_DIGITS_IN_MILLIS);
const $c767f1362e0cdd3e$var$SECOND_TO_NANOSECONDS = Math.pow(10, $c767f1362e0cdd3e$var$NANOSECOND_DIGITS);
function $c767f1362e0cdd3e$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $c767f1362e0cdd3e$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $c767f1362e0cdd3e$export$e752b05e58096a2f() {
    let timeOrigin = (0, $68898baf213d5344$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== 'number') {
        const perf = (0, $68898baf213d5344$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $c767f1362e0cdd3e$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $c767f1362e0cdd3e$export$e7ec5c82995537b1($c767f1362e0cdd3e$export$e752b05e58096a2f());
    const now = $c767f1362e0cdd3e$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $68898baf213d5344$export$b22daef4119238cd).now());
    return $c767f1362e0cdd3e$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $c767f1362e0cdd3e$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($c767f1362e0cdd3e$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $c767f1362e0cdd3e$export$e752b05e58096a2f()) return $c767f1362e0cdd3e$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $c767f1362e0cdd3e$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $c767f1362e0cdd3e$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $c767f1362e0cdd3e$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $c767f1362e0cdd3e$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $c767f1362e0cdd3e$export$973c1c4fad6103e(time) {
    const precision = $c767f1362e0cdd3e$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $c767f1362e0cdd3e$export$2d91441ae30ebcfc(time) {
    return time[0] * $c767f1362e0cdd3e$var$SECOND_TO_NANOSECONDS + time[1];
}
function $c767f1362e0cdd3e$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $c767f1362e0cdd3e$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $c767f1362e0cdd3e$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $c767f1362e0cdd3e$export$a5e58227c317ebb9(value) {
    return $c767f1362e0cdd3e$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $c767f1362e0cdd3e$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $c767f1362e0cdd3e$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $c767f1362e0cdd3e$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $142cdbc8970173a2$var$intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    // a-f
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    // A-F
    return charCode - 55;
}
function $142cdbc8970173a2$export$f7e0d8803cecbdc0(hexStr) {
    const buf = new Uint8Array(hexStr.length / 2);
    let offset = 0;
    for(let i = 0; i < hexStr.length; i += 2){
        const hi = $142cdbc8970173a2$var$intValue(hexStr.charCodeAt(i));
        const lo = $142cdbc8970173a2$var$intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}


function $a6f942675a3f7162$export$93fd2c60d7ab39e5(hrTime) {
    const NANOSECONDS = BigInt(1000000000);
    return BigInt(Math.trunc(hrTime[0])) * NANOSECONDS + BigInt(Math.trunc(hrTime[1]));
}
function $a6f942675a3f7162$export$25fa08d6f84e69de(value) {
    const low = Number(BigInt.asUintN(32, value));
    const high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function $a6f942675a3f7162$export$9aa1c44d160043e3(hrTime) {
    const nanos = $a6f942675a3f7162$export$93fd2c60d7ab39e5(hrTime);
    return $a6f942675a3f7162$export$25fa08d6f84e69de(nanos);
}
function $a6f942675a3f7162$export$91e61e5f118af2ed(hrTime) {
    const nanos = $a6f942675a3f7162$export$93fd2c60d7ab39e5(hrTime);
    return nanos.toString();
}
const $a6f942675a3f7162$var$encodeTimestamp = typeof BigInt !== 'undefined' ? $a6f942675a3f7162$export$91e61e5f118af2ed : (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc);
function $a6f942675a3f7162$var$identity(value) {
    return value;
}
function $a6f942675a3f7162$var$optionalHexToBinary(str) {
    if (str === undefined) return undefined;
    return (0, $142cdbc8970173a2$export$f7e0d8803cecbdc0)(str);
}
const $a6f942675a3f7162$var$DEFAULT_ENCODER = {
    encodeHrTime: $a6f942675a3f7162$export$9aa1c44d160043e3,
    encodeSpanContext: (0, $142cdbc8970173a2$export$f7e0d8803cecbdc0),
    encodeOptionalSpanContext: $a6f942675a3f7162$var$optionalHexToBinary
};
function $a6f942675a3f7162$export$2d50162b78680823(options) {
    if (options === undefined) return $a6f942675a3f7162$var$DEFAULT_ENCODER;
    const useLongBits = options.useLongBits ?? true;
    const useHex = options.useHex ?? false;
    return {
        encodeHrTime: useLongBits ? $a6f942675a3f7162$export$9aa1c44d160043e3 : $a6f942675a3f7162$var$encodeTimestamp,
        encodeSpanContext: useHex ? $a6f942675a3f7162$var$identity : (0, $142cdbc8970173a2$export$f7e0d8803cecbdc0),
        encodeOptionalSpanContext: useHex ? $a6f942675a3f7162$var$identity : $a6f942675a3f7162$var$optionalHexToBinary
    };
}


function $3482adf8683224e2$export$edd172c6c83c39cc(resource) {
    const result = {
        attributes: $3482adf8683224e2$export$b6255b619acd6709(resource.attributes),
        droppedAttributesCount: 0
    };
    const schemaUrl = resource.schemaUrl;
    if (schemaUrl && schemaUrl !== '') result.schemaUrl = schemaUrl;
    return result;
}
function $3482adf8683224e2$export$5a2377b8e90dd1bf(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function $3482adf8683224e2$export$b6255b619acd6709(attributes) {
    return Object.keys(attributes).map((key)=>$3482adf8683224e2$export$155f69accf533147(key, attributes[key]));
}
function $3482adf8683224e2$export$155f69accf533147(key, value) {
    return {
        key: key,
        value: $3482adf8683224e2$export$9544ab3c60b2d8ce(value)
    };
}
function $3482adf8683224e2$export$9544ab3c60b2d8ce(value) {
    const t = typeof value;
    if (t === 'string') return {
        stringValue: value
    };
    if (t === 'number') {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === 'boolean') return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($3482adf8683224e2$export$9544ab3c60b2d8ce)
        }
    };
    if (t === 'object' && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(([k, v])=>$3482adf8683224e2$export$155f69accf533147(k, v))
        }
    };
    return {};
}


function $b1e33e67d56e9d4e$export$5700a2327d5ce50d(logRecords, options) {
    const encoder = (0, $a6f942675a3f7162$export$2d50162b78680823)(options);
    return {
        resourceLogs: $b1e33e67d56e9d4e$var$logRecordsToResourceLogs(logRecords, encoder)
    };
}
function $b1e33e67d56e9d4e$var$createResourceMap(logRecords) {
    const resourceMap = new Map();
    for (const record of logRecords){
        const { resource: resource, instrumentationScope: { name: name, version: version = '', schemaUrl: schemaUrl = '' } } = record;
        let ismMap = resourceMap.get(resource);
        if (!ismMap) {
            ismMap = new Map();
            resourceMap.set(resource, ismMap);
        }
        const ismKey = `${name}@${version}:${schemaUrl}`;
        let records = ismMap.get(ismKey);
        if (!records) {
            records = [];
            ismMap.set(ismKey, records);
        }
        records.push(record);
    }
    return resourceMap;
}
function $b1e33e67d56e9d4e$var$logRecordsToResourceLogs(logRecords, encoder) {
    const resourceMap = $b1e33e67d56e9d4e$var$createResourceMap(logRecords);
    return Array.from(resourceMap, ([resource, ismMap])=>{
        const processedResource = (0, $3482adf8683224e2$export$edd172c6c83c39cc)(resource);
        return {
            resource: processedResource,
            scopeLogs: Array.from(ismMap, ([, scopeLogs])=>{
                return {
                    scope: (0, $3482adf8683224e2$export$5a2377b8e90dd1bf)(scopeLogs[0].instrumentationScope),
                    logRecords: scopeLogs.map((log)=>$b1e33e67d56e9d4e$var$toLogRecord(log, encoder)),
                    schemaUrl: scopeLogs[0].instrumentationScope.schemaUrl
                };
            }),
            schemaUrl: processedResource.schemaUrl
        };
    });
}
function $b1e33e67d56e9d4e$var$toLogRecord(log, encoder) {
    return {
        timeUnixNano: encoder.encodeHrTime(log.hrTime),
        observedTimeUnixNano: encoder.encodeHrTime(log.hrTimeObserved),
        severityNumber: $b1e33e67d56e9d4e$var$toSeverityNumber(log.severityNumber),
        severityText: log.severityText,
        body: (0, $3482adf8683224e2$export$9544ab3c60b2d8ce)(log.body),
        eventName: log.eventName,
        attributes: $b1e33e67d56e9d4e$export$76409c6e9b7f33ec(log.attributes),
        droppedAttributesCount: log.droppedAttributesCount,
        flags: log.spanContext?.traceFlags,
        traceId: encoder.encodeOptionalSpanContext(log.spanContext?.traceId),
        spanId: encoder.encodeOptionalSpanContext(log.spanContext?.spanId)
    };
}
function $b1e33e67d56e9d4e$var$toSeverityNumber(severityNumber) {
    return severityNumber;
}
function $b1e33e67d56e9d4e$export$76409c6e9b7f33ec(attributes) {
    return Object.keys(attributes).map((key)=>(0, $3482adf8683224e2$export$155f69accf533147)(key, attributes[key]));
}


const $ce418e539871f4e7$export$ee58b240ff91dc51 = {
    serializeRequest: (arg)=>{
        const request = (0, $b1e33e67d56e9d4e$export$5700a2327d5ce50d)(arg, {
            useHex: true,
            useLongBits: false
        });
        const encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: (arg)=>{
        if (arg.length === 0) return {};
        const decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $51e4e03b0aaaa4ac$var$MAX_ATTEMPTS = 5;
const $51e4e03b0aaaa4ac$var$INITIAL_BACKOFF = 1000;
const $51e4e03b0aaaa4ac$var$MAX_BACKOFF = 5000;
const $51e4e03b0aaaa4ac$var$BACKOFF_MULTIPLIER = 1.5;
const $51e4e03b0aaaa4ac$var$JITTER = 0.2;
/**
 * Get a pseudo-random jitter that falls in the range of [-JITTER, +JITTER]
 */ function $51e4e03b0aaaa4ac$var$getJitter() {
    return Math.random() * (2 * $51e4e03b0aaaa4ac$var$JITTER) - $51e4e03b0aaaa4ac$var$JITTER;
}
class $51e4e03b0aaaa4ac$var$RetryingTransport {
    _transport;
    constructor(_transport){
        this._transport = _transport;
    }
    retry(data, timeoutMillis, inMillis) {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    }
    async send(data, timeoutMillis) {
        const deadline = Date.now() + timeoutMillis;
        let result = await this._transport.send(data, timeoutMillis);
        let attempts = $51e4e03b0aaaa4ac$var$MAX_ATTEMPTS;
        let nextBackoff = $51e4e03b0aaaa4ac$var$INITIAL_BACKOFF;
        while(result.status === 'retryable' && attempts > 0){
            attempts--;
            // use maximum of computed backoff and 0 to avoid negative timeouts
            const backoff = Math.max(Math.min(nextBackoff, $51e4e03b0aaaa4ac$var$MAX_BACKOFF) + $51e4e03b0aaaa4ac$var$getJitter(), 0);
            nextBackoff = nextBackoff * $51e4e03b0aaaa4ac$var$BACKOFF_MULTIPLIER;
            const retryInMillis = result.retryInMillis ?? backoff;
            // return when expected retry time is after the export deadline.
            const remainingTimeoutMillis = deadline - Date.now();
            if (retryInMillis > remainingTimeoutMillis) return result;
            result = await this.retry(data, remainingTimeoutMillis, retryInMillis);
        }
        return result;
    }
    shutdown() {
        return this._transport.shutdown();
    }
}
function $51e4e03b0aaaa4ac$export$2a8528aedd03b24e(options) {
    return new $51e4e03b0aaaa4ac$var$RetryingTransport(options.transport);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1e161cab698145d0$export$bc409a649b31360b(statusCode) {
    const retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function $1e161cab698145d0$export$4e009558974ad065(retryAfter) {
    if (retryAfter == null) return undefined;
    const seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    const delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}


class $3b996a17dd554cb1$var$XhrTransport {
    _parameters;
    constructor(_parameters){
        this._parameters = _parameters;
    }
    async send(data, timeoutMillis) {
        const headers = await this._parameters.headers();
        const response = await new Promise((resolve)=>{
            const xhr = new XMLHttpRequest();
            xhr.timeout = timeoutMillis;
            xhr.open('POST', this._parameters.url);
            Object.entries(headers).forEach(([k, v])=>{
                xhr.setRequestHeader(k, v);
            });
            xhr.ontimeout = (_)=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request timed out')
                });
            };
            xhr.onreadystatechange = ()=>{
                if (xhr.status >= 200 && xhr.status <= 299) {
                    (0, $aLPFc.diag).debug('XHR success');
                    resolve({
                        status: 'success'
                    });
                } else if (xhr.status && (0, $1e161cab698145d0$export$bc409a649b31360b)(xhr.status)) resolve({
                    status: 'retryable',
                    retryInMillis: (0, $1e161cab698145d0$export$4e009558974ad065)(xhr.getResponseHeader('Retry-After'))
                });
                else if (xhr.status !== 0) resolve({
                    status: 'failure',
                    error: new Error('XHR request failed with non-retryable status')
                });
            };
            xhr.onabort = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request aborted')
                });
            };
            xhr.onerror = ()=>{
                resolve({
                    status: 'failure',
                    error: new Error('XHR request errored')
                });
            };
            xhr.send(data);
        });
        return response;
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $3b996a17dd554cb1$export$8ab960d599ca0ecc(parameters) {
    return new $3b996a17dd554cb1$var$XhrTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
class $0d2ee0cc18fe2771$var$SendBeaconTransport {
    _params;
    constructor(_params){
        this._params = _params;
    }
    async send(data) {
        const blobType = (await this._params.headers())['Content-Type'];
        return new Promise((resolve)=>{
            if (navigator.sendBeacon(this._params.url, new Blob([
                data
            ], {
                type: blobType
            }))) {
                // no way to signal retry, treat everything as success
                (0, $aLPFc.diag).debug('SendBeacon success');
                resolve({
                    status: 'success'
                });
            } else resolve({
                status: 'failure',
                error: new Error('SendBeacon failed')
            });
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $0d2ee0cc18fe2771$export$ef075750bfec2f31(parameters) {
    return new $0d2ee0cc18fe2771$var$SendBeaconTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5d6f8eeebf78c1a1$var$BoundedQueueExportPromiseHandler {
    _concurrencyLimit;
    _sendingPromises = [];
    /**
     * @param concurrencyLimit maximum promises allowed in a queue at the same time.
     */ constructor(concurrencyLimit){
        this._concurrencyLimit = concurrencyLimit;
    }
    pushPromise(promise) {
        if (this.hasReachedLimit()) throw new Error('Concurrency Limit reached');
        this._sendingPromises.push(promise);
        const popPromise = ()=>{
            const index = this._sendingPromises.indexOf(promise);
            this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    }
    hasReachedLimit() {
        return this._sendingPromises.length >= this._concurrencyLimit;
    }
    async awaitAll() {
        await Promise.all(this._sendingPromises);
    }
}
function $5d6f8eeebf78c1a1$export$1de3d1a6b8cb6545(options) {
    return new $5d6f8eeebf78c1a1$var$BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1 || ($ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for handling error
 */ class $a2ff3d4f0ce5ff5a$export$26c718c16cda30c6 extends Error {
    code;
    name = 'OTLPExporterError';
    data;
    constructor(message, code, data){
        super(message);
        this.data = data;
        this.code = code;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
function $4b83ef42d5b19d9b$var$isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, 'partialSuccess');
}
function $4b83ef42d5b19d9b$export$b6a88465884baecf() {
    return {
        handleResponse (response) {
            // Partial success MUST never be an empty object according the specification
            // see https://opentelemetry.io/docs/specs/otlp/#partial-success
            if (response == null || !$4b83ef42d5b19d9b$var$isPartialSuccessResponse(response) || response.partialSuccess == null || Object.keys(response.partialSuccess).length === 0) return;
            (0, $aLPFc.diag).warn('Received Partial Success response:', JSON.stringify(response.partialSuccess));
        }
    };
}


parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
class $0c028144fcad5f9a$var$OTLPExportDelegate {
    _transport;
    _serializer;
    _responseHandler;
    _promiseQueue;
    _timeout;
    _diagLogger;
    constructor(_transport, _serializer, _responseHandler, _promiseQueue, _timeout){
        this._transport = _transport;
        this._serializer = _serializer;
        this._responseHandler = _responseHandler;
        this._promiseQueue = _promiseQueue;
        this._timeout = _timeout;
        this._diagLogger = (0, $aLPFc.diag).createComponentLogger({
            namespace: 'OTLPExportDelegate'
        });
    }
    export(internalRepresentation, resultCallback) {
        this._diagLogger.debug('items to be sent', internalRepresentation);
        // don't do any work if too many exports are in progress.
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Concurrent export limit reached')
            });
            return;
        }
        const serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Nothing to send')
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then((response)=>{
            if (response.status === 'success') {
                if (response.data != null) try {
                    this._responseHandler.handleResponse(this._serializer.deserializeResponse(response.data));
                } catch (e) {
                    this._diagLogger.warn('Export succeeded but could not deserialize response - is the response specification compliant?', e, response.data);
                }
                // No matter the response, we can consider the export still successful.
                resultCallback({
                    code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).SUCCESS
                });
                return;
            } else if (response.status === 'failure' && response.error) {
                resultCallback({
                    code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).FAILED,
                    error: response.error
                });
                return;
            } else if (response.status === 'retryable') resultCallback({
                code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $a2ff3d4f0ce5ff5a$export$26c718c16cda30c6)('Export failed with retryable status')
            });
            else resultCallback({
                code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $a2ff3d4f0ce5ff5a$export$26c718c16cda30c6)('Export failed with unknown error')
            });
        }, (reason)=>resultCallback({
                code: (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).FAILED,
                error: reason
            })));
    }
    forceFlush() {
        return this._promiseQueue.awaitAll();
    }
    async shutdown() {
        this._diagLogger.debug('shutdown started');
        await this.forceFlush();
        this._transport.shutdown();
    }
}
function $0c028144fcad5f9a$export$40ae898156a6d951(components, settings) {
    return new $0c028144fcad5f9a$var$OTLPExportDelegate(components.transport, components.serializer, (0, $4b83ef42d5b19d9b$export$b6a88465884baecf)(), components.promiseHandler, settings.timeout);
}


function $7d9feb5d2b1c3784$export$8874016870239da4(options, serializer, transport) {
    return (0, $0c028144fcad5f9a$export$40ae898156a6d951)({
        transport: transport,
        serializer: serializer,
        promiseHandler: (0, $5d6f8eeebf78c1a1$export$1de3d1a6b8cb6545)(options)
    }, {
        timeout: options.timeoutMillis
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");

class $0f9d00883cad7355$var$FetchTransport {
    _parameters;
    constructor(_parameters){
        this._parameters = _parameters;
    }
    async send(data, timeoutMillis) {
        const abortController = new AbortController();
        const timeout = setTimeout(()=>abortController.abort(), timeoutMillis);
        try {
            const isBrowserEnvironment = !!globalThis.location;
            const url = new URL(this._parameters.url);
            const response = await fetch(url.href, {
                method: 'POST',
                headers: await this._parameters.headers(),
                body: data,
                signal: abortController.signal,
                keepalive: isBrowserEnvironment,
                mode: isBrowserEnvironment ? globalThis.location?.origin === url.origin ? 'same-origin' : 'cors' : 'no-cors'
            });
            if (response.status >= 200 && response.status <= 299) {
                (0, $aLPFc.diag).debug('response success');
                return {
                    status: 'success'
                };
            } else if ((0, $1e161cab698145d0$export$bc409a649b31360b)(response.status)) {
                const retryAfter = response.headers.get('Retry-After');
                const retryInMillis = (0, $1e161cab698145d0$export$4e009558974ad065)(retryAfter);
                return {
                    status: 'retryable',
                    retryInMillis: retryInMillis
                };
            }
            return {
                status: 'failure',
                error: new Error('Fetch request failed with non-retryable status')
            };
        } catch (error) {
            if (error?.name === 'AbortError') return {
                status: 'failure',
                error: new Error('Fetch request timed out', {
                    cause: error
                })
            };
            return {
                status: 'failure',
                error: new Error('Fetch request errored', {
                    cause: error
                })
            };
        } finally{
            clearTimeout(timeout);
        }
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $0f9d00883cad7355$export$9e4ae37cd458911c(parameters) {
    return new $0f9d00883cad7355$var$FetchTransport(parameters);
}


function $a101f94d7361c273$export$f1ed08af29ca92a7(options, serializer) {
    return (0, $7d9feb5d2b1c3784$export$8874016870239da4)(options, serializer, (0, $51e4e03b0aaaa4ac$export$2a8528aedd03b24e)({
        transport: (0, $3b996a17dd554cb1$export$8ab960d599ca0ecc)(options)
    }));
}
function $a101f94d7361c273$export$6ca8051e58a2f94e(options, serializer) {
    return (0, $7d9feb5d2b1c3784$export$8874016870239da4)(options, serializer, (0, $51e4e03b0aaaa4ac$export$2a8528aedd03b24e)({
        transport: (0, $0f9d00883cad7355$export$9e4ae37cd458911c)(options)
    }));
}
function $a101f94d7361c273$export$5b68ba408d750db3(options, serializer) {
    return (0, $7d9feb5d2b1c3784$export$8874016870239da4)(options, serializer, (0, $51e4e03b0aaaa4ac$export$2a8528aedd03b24e)({
        transport: (0, $0d2ee0cc18fe2771$export$ef075750bfec2f31)({
            url: options.url,
            headers: options.headers
        })
    }));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59df24fc8adbd5d4$export$c7dc25f7ba3fe11a(timeoutMillis) {
    if (Number.isFinite(timeoutMillis) && timeoutMillis > 0) return timeoutMillis;
    throw new Error(`Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '${timeoutMillis}')`);
}
function $59df24fc8adbd5d4$export$c37a46ab59261386(headers) {
    if (headers == null) return undefined;
    return async ()=>headers;
}
function $59df24fc8adbd5d4$export$f0204f09cd0066b(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        timeoutMillis: $59df24fc8adbd5d4$export$c7dc25f7ba3fe11a(userProvidedConfiguration.timeoutMillis ?? fallbackConfiguration.timeoutMillis ?? defaultConfiguration.timeoutMillis),
        concurrencyLimit: userProvidedConfiguration.concurrencyLimit ?? fallbackConfiguration.concurrencyLimit ?? defaultConfiguration.concurrencyLimit,
        compression: userProvidedConfiguration.compression ?? fallbackConfiguration.compression ?? defaultConfiguration.compression
    };
}
function $59df24fc8adbd5d4$export$cd8c80b353c895f4() {
    return {
        timeoutMillis: 10000,
        concurrencyLimit: 30,
        compression: 'none'
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
function $5fa10fb251ccaa36$export$4144cc9174bc6a0(partialHeaders) {
    const headers = {};
    Object.entries(partialHeaders ?? {}).forEach(([key, value])=>{
        if (typeof value !== 'undefined') headers[key] = String(value);
        else (0, $aLPFc.diag).warn(`Header "${key}" has invalid value (${value}) and will be ignored`);
    });
    return headers;
}


function $e43c851189c09f68$var$mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    return async ()=>{
        const requiredHeaders = {
            ...await defaultHeaders()
        };
        const headers = {};
        // add fallback ones first
        if (fallbackHeaders != null) Object.assign(headers, await fallbackHeaders());
        // override with user-provided ones
        if (userProvidedHeaders != null) Object.assign(headers, (0, $5fa10fb251ccaa36$export$4144cc9174bc6a0)(await userProvidedHeaders()));
        // override required ones.
        return Object.assign(headers, requiredHeaders);
    };
}
function $e43c851189c09f68$var$validateUserProvidedUrl(url) {
    if (url == null) return undefined;
    try {
        // NOTE: In non-browser environments, `globalThis.location` will be `undefined`.
        const base = globalThis.location?.href;
        return new URL(url, base).href;
    } catch  {
        throw new Error(`Configuration: Could not parse user-provided export URL: '${url}'`);
    }
}
function $e43c851189c09f68$export$dae543ef16d16f76(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        ...(0, $59df24fc8adbd5d4$export$f0204f09cd0066b)(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration),
        headers: $e43c851189c09f68$var$mergeHeaders(userProvidedConfiguration.headers, fallbackConfiguration.headers, defaultConfiguration.headers),
        url: $e43c851189c09f68$var$validateUserProvidedUrl(userProvidedConfiguration.url) ?? fallbackConfiguration.url ?? defaultConfiguration.url
    };
}
function $e43c851189c09f68$export$ed5dc921e0200ace(requiredHeaders, signalResourcePath) {
    return {
        ...(0, $59df24fc8adbd5d4$export$cd8c80b353c895f4)(),
        headers: async ()=>requiredHeaders,
        url: 'http://localhost:4318/' + signalResourcePath
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $03c0c3f490febc70$export$204793d8eaaae015(config) {
    if (typeof config.headers === 'function') return config.headers;
    return (0, $59df24fc8adbd5d4$export$c37a46ab59261386)(config.headers);
}


function $958247c0841c90e5$export$816c85190fdd0ca8(config, signalResourcePath, requiredHeaders) {
    return (0, $e43c851189c09f68$export$dae543ef16d16f76)({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: (0, $03c0c3f490febc70$export$204793d8eaaae015)(config),
        concurrencyLimit: config.concurrencyLimit
    }, {}, (0, $e43c851189c09f68$export$ed5dc921e0200ace)(requiredHeaders, signalResourcePath));
}


function $9f28c339d37aaab4$export$f0b482136e1f7b30(config, serializer, signalResourcePath, requiredHeaders) {
    const createOtlpExportDelegate = $9f28c339d37aaab4$export$20dd511f645ec088(config.headers);
    const options = (0, $958247c0841c90e5$export$816c85190fdd0ca8)(config, signalResourcePath, requiredHeaders);
    return createOtlpExportDelegate(options, serializer);
}
function $9f28c339d37aaab4$export$20dd511f645ec088(configHeaders) {
    if (!configHeaders && typeof navigator.sendBeacon === 'function') return 0, $a101f94d7361c273$export$5b68ba408d750db3;
    else if (typeof globalThis.fetch !== 'undefined') return 0, $a101f94d7361c273$export$6ca8051e58a2f94e;
    else return 0, $a101f94d7361c273$export$f1ed08af29ca92a7;
}


class $d41d2e50903aaf6a$export$acc219307c108b42 extends (0, $10cbcb09243716b2$export$a756c21bf453f1b5) {
    constructor(config = {}){
        super((0, $9f28c339d37aaab4$export$f0b482136e1f7b30)(config, (0, $ce418e539871f4e7$export$ee58b240ff91dc51), 'v1/logs', {
            'Content-Type': 'application/json'
        }));
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


// Span flags constants matching the OTLP specification
const $5e5d50ad3d79ee20$var$SPAN_FLAGS_CONTEXT_HAS_IS_REMOTE_MASK = 0x100;
const $5e5d50ad3d79ee20$var$SPAN_FLAGS_CONTEXT_IS_REMOTE_MASK = 0x200;
/**
 * Builds the 32-bit span flags value combining the low 8-bit W3C TraceFlags
 * with the HAS_IS_REMOTE and IS_REMOTE bits according to the OTLP spec.
 */ function $5e5d50ad3d79ee20$var$buildSpanFlagsFrom(traceFlags, isRemote) {
    // low 8 bits are W3C TraceFlags (e.g., sampled)
    let flags = traceFlags & 0xff | $5e5d50ad3d79ee20$var$SPAN_FLAGS_CONTEXT_HAS_IS_REMOTE_MASK;
    if (isRemote) flags |= $5e5d50ad3d79ee20$var$SPAN_FLAGS_CONTEXT_IS_REMOTE_MASK;
    return flags;
}
function $5e5d50ad3d79ee20$export$8c81c8011901e012(span, encoder) {
    const ctx = span.spanContext();
    const status = span.status;
    const parentSpanId = span.parentSpanContext?.spanId ? encoder.encodeSpanContext(span.parentSpanContext?.spanId) : undefined;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: parentSpanId,
        traceState: ctx.traceState?.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: (0, $3482adf8683224e2$export$b6255b619acd6709)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map((event)=>$5e5d50ad3d79ee20$export$c0221297e49388cc(event, encoder)),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map((link)=>$5e5d50ad3d79ee20$export$d40a678c50e6f4f2(link, encoder)),
        droppedLinksCount: span.droppedLinksCount,
        flags: $5e5d50ad3d79ee20$var$buildSpanFlagsFrom(ctx.traceFlags, span.parentSpanContext?.isRemote)
    };
}
function $5e5d50ad3d79ee20$export$d40a678c50e6f4f2(link, encoder) {
    return {
        attributes: link.attributes ? (0, $3482adf8683224e2$export$b6255b619acd6709)(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: link.context.traceState?.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0,
        flags: $5e5d50ad3d79ee20$var$buildSpanFlagsFrom(link.context.traceFlags, link.context.isRemote)
    };
}
function $5e5d50ad3d79ee20$export$c0221297e49388cc(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? (0, $3482adf8683224e2$export$b6255b619acd6709)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}
function $5e5d50ad3d79ee20$export$4bd5e67fadfa9fe0(spans, options) {
    const encoder = (0, $a6f942675a3f7162$export$2d50162b78680823)(options);
    return {
        resourceSpans: $5e5d50ad3d79ee20$var$spanRecordsToResourceSpans(spans, encoder)
    };
}
function $5e5d50ad3d79ee20$var$createResourceMap(readableSpans) {
    const resourceMap = new Map();
    for (const record of readableSpans){
        let ilsMap = resourceMap.get(record.resource);
        if (!ilsMap) {
            ilsMap = new Map();
            resourceMap.set(record.resource, ilsMap);
        }
        // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
        const instrumentationScopeKey = `${record.instrumentationScope.name}@${record.instrumentationScope.version || ''}:${record.instrumentationScope.schemaUrl || ''}`;
        let records = ilsMap.get(instrumentationScopeKey);
        if (!records) {
            records = [];
            ilsMap.set(instrumentationScopeKey, records);
        }
        records.push(record);
    }
    return resourceMap;
}
function $5e5d50ad3d79ee20$var$spanRecordsToResourceSpans(readableSpans, encoder) {
    const resourceMap = $5e5d50ad3d79ee20$var$createResourceMap(readableSpans);
    const out = [];
    const entryIterator = resourceMap.entries();
    let entry = entryIterator.next();
    while(!entry.done){
        const [resource, ilmMap] = entry.value;
        const scopeResourceSpans = [];
        const ilmIterator = ilmMap.values();
        let ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            const scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                const spans = scopeSpans.map((readableSpan)=>$5e5d50ad3d79ee20$export$8c81c8011901e012(readableSpan, encoder));
                scopeResourceSpans.push({
                    scope: (0, $3482adf8683224e2$export$5a2377b8e90dd1bf)(scopeSpans[0].instrumentationScope),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationScope.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        const processedResource = (0, $3482adf8683224e2$export$edd172c6c83c39cc)(resource);
        const transformedSpans = {
            resource: processedResource,
            scopeSpans: scopeResourceSpans,
            schemaUrl: processedResource.schemaUrl
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}


const $7bb7d40ccc5d6c55$export$dfba2b8376f2d3f5 = {
    serializeRequest: (arg)=>{
        const request = (0, $5e5d50ad3d79ee20$export$4bd5e67fadfa9fe0)(arg, {
            useHex: true,
            useLongBits: false
        });
        const encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: (arg)=>{
        if (arg.length === 0) return {};
        const decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};



class $d5a0bc2c3d7e3b03$export$f73dc942b4b27de3 extends (0, $10cbcb09243716b2$export$a756c21bf453f1b5) {
    constructor(config = {}){
        super((0, $9f28c339d37aaab4$export$f0b482136e1f7b30)(config, (0, $7bb7d40ccc5d6c55$export$dfba2b8376f2d3f5), 'v1/traces', {
            'Content-Type': 'application/json'
        }));
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $hAdEB = parcelRequire("hAdEB");
var $j5ja1 = parcelRequire("j5ja1");

var $6DjHV = parcelRequire("6DjHV");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ function $9d7353d9159da100$export$56a6415128a54b1(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(let i = 0, j = instrumentations.length; i < j; i++){
        const instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $9d7353d9159da100$export$c7d87b302116dc69(instrumentations) {
    instrumentations.forEach((instrumentation)=>instrumentation.disable());
}


function $77ba9ebe7755d8be$export$fc0a1ca5231d826a(options) {
    const tracerProvider = options.tracerProvider || (0, $j5ja1.trace).getTracerProvider();
    const meterProvider = options.meterProvider || (0, $hAdEB.metrics).getMeterProvider();
    const loggerProvider = options.loggerProvider || (0, $6DjHV.logs).getLoggerProvider();
    const instrumentations = options.instrumentations?.flat() ?? [];
    (0, $9d7353d9159da100$export$56a6415128a54b1)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return ()=>{
        (0, $9d7353d9159da100$export$c7d87b302116dc69)(instrumentations);
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $3rgEx = parcelRequire("3rgEx");
var $iN5wJ = parcelRequire("iN5wJ");
var $j5ja1 = parcelRequire("j5ja1");
var $hbJhQ = parcelRequire("hbJhQ");
var $4D9sW = parcelRequire("4D9sW");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
var $hAdEB = parcelRequire("hAdEB");
var $j5ja1 = parcelRequire("j5ja1");

var $6DjHV = parcelRequire("6DjHV");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Default to complaining loudly when things don't go according to plan.
// eslint-disable-next-line no-console
let $83b19fea587117d8$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $83b19fea587117d8$var$defineProperty(obj, name, value) {
    const enumerable = !!obj[name] && Object.prototype.propertyIsEnumerable.call(obj, name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
const $83b19fea587117d8$export$4997ffc0176396a6 = (nodule, name, wrapper)=>{
    if (!nodule || !nodule[name]) {
        $83b19fea587117d8$var$logger('no original function ' + String(name) + ' to wrap');
        return;
    }
    if (!wrapper) {
        $83b19fea587117d8$var$logger('no wrapper function');
        $83b19fea587117d8$var$logger(new Error().stack);
        return;
    }
    const original = nodule[name];
    if (typeof original !== 'function' || typeof wrapper !== 'function') {
        $83b19fea587117d8$var$logger('original object and wrapper must be functions');
        return;
    }
    const wrapped = wrapper(original, name);
    $83b19fea587117d8$var$defineProperty(wrapped, '__original', original);
    $83b19fea587117d8$var$defineProperty(wrapped, '__unwrap', ()=>{
        if (nodule[name] === wrapped) $83b19fea587117d8$var$defineProperty(nodule, name, original);
    });
    $83b19fea587117d8$var$defineProperty(wrapped, '__wrapped', true);
    $83b19fea587117d8$var$defineProperty(nodule, name, wrapped);
    return wrapped;
};
const $83b19fea587117d8$export$358d869541567f31 = (nodules, names, wrapper)=>{
    if (!nodules) {
        $83b19fea587117d8$var$logger('must provide one or more modules to patch');
        $83b19fea587117d8$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $83b19fea587117d8$var$logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach((nodule)=>{
        names.forEach((name)=>{
            $83b19fea587117d8$export$4997ffc0176396a6(nodule, name, wrapper);
        });
    });
};
const $83b19fea587117d8$export$debb760848ca95a = (nodule, name)=>{
    if (!nodule || !nodule[name]) {
        $83b19fea587117d8$var$logger('no function to unwrap.');
        $83b19fea587117d8$var$logger(new Error().stack);
        return;
    }
    const wrapped = nodule[name];
    if (!wrapped.__unwrap) $83b19fea587117d8$var$logger('no original to unwrap to -- has ' + String(name) + ' already been unwrapped?');
    else {
        wrapped.__unwrap();
        return;
    }
};
const $83b19fea587117d8$export$43e13a935e49ecde = (nodules, names)=>{
    if (!nodules) {
        $83b19fea587117d8$var$logger('must provide one or more modules to patch');
        $83b19fea587117d8$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $83b19fea587117d8$var$logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach((nodule)=>{
        names.forEach((name)=>{
            $83b19fea587117d8$export$debb760848ca95a(nodule, name);
        });
    });
};
function $83b19fea587117d8$export$2e2bcd8739ae039(options) {
    if (options && options.logger) {
        if (typeof options.logger !== 'function') $83b19fea587117d8$var$logger("new logger isn't a function, not replacing");
        else $83b19fea587117d8$var$logger = options.logger;
    }
}
$83b19fea587117d8$export$2e2bcd8739ae039.wrap = $83b19fea587117d8$export$4997ffc0176396a6;
$83b19fea587117d8$export$2e2bcd8739ae039.massWrap = $83b19fea587117d8$export$358d869541567f31;
$83b19fea587117d8$export$2e2bcd8739ae039.unwrap = $83b19fea587117d8$export$debb760848ca95a;
$83b19fea587117d8$export$2e2bcd8739ae039.massUnwrap = $83b19fea587117d8$export$43e13a935e49ecde;


class $0da8052c2f5c1bfc$export$74c31cfd4e541b89 {
    instrumentationName;
    instrumentationVersion;
    _config = {};
    _tracer;
    _meter;
    _logger;
    _diag;
    constructor(instrumentationName, instrumentationVersion, config){
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this.setConfig(config);
        this._diag = (0, $aLPFc.diag).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, $j5ja1.trace).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, $hAdEB.metrics).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, $6DjHV.logs).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Api to wrap instrumented method */ _wrap = $83b19fea587117d8$export$4997ffc0176396a6;
    /* Api to unwrap instrumented methods */ _unwrap = $83b19fea587117d8$export$debb760848ca95a;
    /* Api to mass wrap instrumented method */ _massWrap = $83b19fea587117d8$export$358d869541567f31;
    /* Api to mass unwrap instrumented methods */ _massUnwrap = $83b19fea587117d8$export$43e13a935e49ecde;
    /* Returns meter */ get meter() {
        return this._meter;
    }
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns logger */ get logger() {
        return this._logger;
    }
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ setLoggerProvider(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    }
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ getModuleDefinitions() {
        const initResult = this.init() ?? [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    }
    /**
     * Sets the new metric instruments with the current Meter.
     */ _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */ getConfig() {
        return this._config;
    }
    /**
     * Sets InstrumentationConfig to this plugin
     * @param config
     */ setConfig(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = {
            enabled: true,
            ...config
        };
    }
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */ get tracer() {
        return this._tracer;
    }
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error(`Error running span customization hook due to exception in handler`, {
                triggerName: triggerName
            }, e);
        }
    }
}


class $21cb51e8b334af23$export$436b1c2bf7e9756b extends (0, $0da8052c2f5c1bfc$export$74c31cfd4e541b89) {
    constructor(instrumentationName, instrumentationVersion, config){
        super(instrumentationName, instrumentationVersion, config);
        if (this._config.enabled) this.enable();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ function $b67ed1564e468009$export$fdff7e10f8ca069e(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
async function $b67ed1564e468009$export$75852fe3c08f1502(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = await execute();
    } catch (e) {
        error = e;
    } finally{
        await onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function $b67ed1564e468009$export$ec0fd572751979bc(func) {
    return typeof func === 'function' && typeof func.__original === 'function' && typeof func.__unwrap === 'function' && func.__wrapped === true;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0ee39f2d52193b96$export$38c181bcafcf2fa0;
(function(SemconvStability) {
    /** Emit only stable semantic conventions. */ SemconvStability[SemconvStability["STABLE"] = 1] = "STABLE";
    /** Emit only old semantic conventions. */ SemconvStability[SemconvStability["OLD"] = 2] = "OLD";
    /** Emit both stable and old semantic conventions. */ SemconvStability[SemconvStability["DUPLICATE"] = 3] = "DUPLICATE";
})($0ee39f2d52193b96$export$38c181bcafcf2fa0 || ($0ee39f2d52193b96$export$38c181bcafcf2fa0 = {}));
function $0ee39f2d52193b96$export$f9fa4e140bcc07bb(namespace, str) {
    let semconvStability = $0ee39f2d52193b96$export$38c181bcafcf2fa0.OLD;
    // The same parsing of `str` as `getStringListFromEnv` from the core pkg.
    const entries = str?.split(',').map((v)=>v.trim()).filter((s)=>s !== '');
    for (const entry of entries ?? []){
        if (entry.toLowerCase() === namespace + '/dup') {
            // DUPLICATE takes highest precedence.
            semconvStability = $0ee39f2d52193b96$export$38c181bcafcf2fa0.DUPLICATE;
            break;
        } else if (entry.toLowerCase() === namespace) semconvStability = $0ee39f2d52193b96$export$38c181bcafcf2fa0.STABLE;
    }
    return semconvStability;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line n/no-unsupported-features/es-builtins, no-undef
const $7379639a8acff8a3$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $27d1ee50041bb779$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $27d1ee50041bb779$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($27d1ee50041bb779$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c09a8c0f751b5acb$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($c09a8c0f751b5acb$export$74be52df2d6fd28c || ($c09a8c0f751b5acb$export$74be52df2d6fd28c = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.<key>` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.<key>`.
 */ const $a082287f4b3e81b4$export$237bc893b534cd8c = 'http.response_content_length';
const $a082287f4b3e81b4$export$651dae55eea4b228 = 'http.response_content_length_uncompressed';


// Used to normalize relative URLs
let $6e537250b1d76874$var$urlNormalizingAnchor;
function $6e537250b1d76874$var$getUrlNormalizingAnchor() {
    if (!$6e537250b1d76874$var$urlNormalizingAnchor) $6e537250b1d76874$var$urlNormalizingAnchor = document.createElement('a');
    return $6e537250b1d76874$var$urlNormalizingAnchor;
}
function $6e537250b1d76874$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $6e537250b1d76874$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($6e537250b1d76874$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $6e537250b1d76874$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $6e537250b1d76874$export$7e5e8f17966d37d1(span, (0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        // This block adds content-length-related span attributes using the
        // *old* HTTP semconv (v1.7.0).
        const encodedLength = resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
        if (encodedLength !== undefined) span.setAttribute((0, $a082287f4b3e81b4$export$237bc893b534cd8c), encodedLength);
        const decodedLength = resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
        // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
        if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $a082287f4b3e81b4$export$651dae55eea4b228), decodedLength);
    }
}
function $6e537250b1d76874$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $6e537250b1d76874$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $6e537250b1d76874$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $6e537250b1d76874$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $6e537250b1d76874$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $6e537250b1d76874$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $6e537250b1d76874$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $6e537250b1d76874$var$findMainRequest(sorted, corsPreFlightRequest[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $6e537250b1d76874$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)((0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)((0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)((0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $6e537250b1d76874$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)((0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $c767f1362e0cdd3e$export$2d91441ae30ebcfc)((0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(resource[(0, $c09a8c0f751b5acb$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $6e537250b1d76874$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $6e537250b1d76874$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $6e537250b1d76874$export$6535eb414fa2c8b6(url) {
    const urlLike = $6e537250b1d76874$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $6e537250b1d76874$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $6e537250b1d76874$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $6e537250b1d76874$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $6e537250b1d76874$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $6e537250b1d76874$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $6e537250b1d76874$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $6e537250b1d76874$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $6e537250b1d76874$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $6e537250b1d76874$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $27d1ee50041bb779$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $6fbd9743d6931274$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($6fbd9743d6931274$export$668754fb61dd076c || ($6fbd9743d6931274$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use one of `server.address`, `client.address` or `http.request.header.host` instead, depending on the usage.
 *
 * @example www.example.org
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by one of `server.address`, `client.address` or `http.request.header.host`, depending on the usage.
 */ const $13f8f0c2c336e772$export$15464108e35f33c4 = 'http.host';
const $13f8f0c2c336e772$export$cf26e21ee4664adb = 'http.method';
const $13f8f0c2c336e772$export$d65e4dc87162df0a = 'http.request.body.size';
const $13f8f0c2c336e772$export$3cbfc10a128d2cf7 = 'http.request_content_length_uncompressed';
const $13f8f0c2c336e772$export$237bc893b534cd8c = 'http.response_content_length';
const $13f8f0c2c336e772$export$2d7ebf68a433b0fd = 'http.scheme';
const $13f8f0c2c336e772$export$116a6efc1c017b7b = 'http.status_code';
const $13f8f0c2c336e772$export$13e2e9fdaf5f7c2d = 'http.url';
const $13f8f0c2c336e772$export$a4ba95edc60c8ef3 = 'http.user_agent';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ //----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/stable/attributes.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * ASP.NET Core exception middleware handling result.
 *
 * @example handled
 * @example unhandled
 */ const $bb466b14d7a34ad0$export$f82340eb6f7ee4fc = 'aspnetcore.diagnostics.exception.result';
const $bb466b14d7a34ad0$export$cda1f266e1fc5b3f = "aborted";
const $bb466b14d7a34ad0$export$f59ec205fdfe6400 = "handled";
const $bb466b14d7a34ad0$export$b427e935fd6651ab = "skipped";
const $bb466b14d7a34ad0$export$7a0c380cad26f867 = "unhandled";
const $bb466b14d7a34ad0$export$e15ee6ced4b4d793 = 'aspnetcore.diagnostics.handler.type';
const $bb466b14d7a34ad0$export$d6be6e9a073ccba5 = 'aspnetcore.rate_limiting.policy';
const $bb466b14d7a34ad0$export$df376702a339c094 = 'aspnetcore.rate_limiting.result';
const $bb466b14d7a34ad0$export$e160ee3fb23dd21e = "acquired";
const $bb466b14d7a34ad0$export$336cf096763833a3 = "endpoint_limiter";
const $bb466b14d7a34ad0$export$ee99d6c8d66ba053 = "global_limiter";
const $bb466b14d7a34ad0$export$d4525b0bcb1802a6 = "request_canceled";
const $bb466b14d7a34ad0$export$746fc3f900d45c45 = 'aspnetcore.request.is_unhandled';
const $bb466b14d7a34ad0$export$bcd5f0f8484c3bc0 = 'aspnetcore.routing.is_fallback';
const $bb466b14d7a34ad0$export$d181153b8bdfa0b6 = 'aspnetcore.routing.match_status';
const $bb466b14d7a34ad0$export$ca7f093befa342d4 = "failure";
const $bb466b14d7a34ad0$export$ae1a39d3a4050746 = "success";
const $bb466b14d7a34ad0$export$f25890d1e3848156 = 'aspnetcore.user.is_authenticated';
const $bb466b14d7a34ad0$export$d68d146ff79c04a8 = 'client.address';
const $bb466b14d7a34ad0$export$98967a53baad5eec = 'client.port';
const $bb466b14d7a34ad0$export$5285ee03db771e5b = 'code.column.number';
const $bb466b14d7a34ad0$export$ac9d6c9a41211595 = 'code.file.path';
const $bb466b14d7a34ad0$export$fd34f7e1f0c418fc = 'code.function.name';
const $bb466b14d7a34ad0$export$ccc16b040f2d3c68 = 'code.line.number';
const $bb466b14d7a34ad0$export$84cf154ace206984 = 'code.stacktrace';
const $bb466b14d7a34ad0$export$f3ebe872053c9886 = 'db.collection.name';
const $bb466b14d7a34ad0$export$354f27025f67a12d = 'db.namespace';
const $bb466b14d7a34ad0$export$899baaeb75956560 = 'db.operation.batch.size';
const $bb466b14d7a34ad0$export$32ff3b5ea8eeed5d = 'db.operation.name';
const $bb466b14d7a34ad0$export$ebef2908cb0508b2 = 'db.query.summary';
const $bb466b14d7a34ad0$export$dc45382793fd9c73 = 'db.query.text';
const $bb466b14d7a34ad0$export$5f1e82edb68082a5 = 'db.response.status_code';
const $bb466b14d7a34ad0$export$59730bfffb801deb = 'db.stored_procedure.name';
const $bb466b14d7a34ad0$export$e092ac179da1bacb = 'db.system.name';
const $bb466b14d7a34ad0$export$33a9d0e8e2693338 = "mariadb";
const $bb466b14d7a34ad0$export$e0e77e85ab698795 = "microsoft.sql_server";
const $bb466b14d7a34ad0$export$6b580327d217ab17 = "mysql";
const $bb466b14d7a34ad0$export$de5fcd2a0648ea59 = "postgresql";
const $bb466b14d7a34ad0$export$50d2ae8f0fe53654 = 'dotnet.gc.heap.generation';
const $bb466b14d7a34ad0$export$53c7cec226bbc008 = "gen0";
const $bb466b14d7a34ad0$export$16eba2d1cd3c6aae = "gen1";
const $bb466b14d7a34ad0$export$53cbcd4ebe9fed52 = "gen2";
const $bb466b14d7a34ad0$export$73025750a790bd80 = "loh";
const $bb466b14d7a34ad0$export$92f06dbb8b8e4efb = "poh";
const $bb466b14d7a34ad0$export$27bc5d0fa190eb39 = 'error.type';
const $bb466b14d7a34ad0$export$c00e2e224ae81dcc = "_OTHER";
const $bb466b14d7a34ad0$export$5afa65f3c67a6da5 = 'exception.escaped';
const $bb466b14d7a34ad0$export$ab4513c1b55519b5 = 'exception.message';
const $bb466b14d7a34ad0$export$9b74e4928364b671 = 'exception.stacktrace';
const $bb466b14d7a34ad0$export$85da07cb5d867763 = 'exception.type';
const $bb466b14d7a34ad0$export$6dc05c1a4ea7d452 = (key)=>`http.request.header.${key}`;
const $bb466b14d7a34ad0$export$c950c48d651d36f6 = 'http.request.method';
const $bb466b14d7a34ad0$export$475d0b6904c72522 = "_OTHER";
const $bb466b14d7a34ad0$export$1d0475e0429ecc7a = "CONNECT";
const $bb466b14d7a34ad0$export$f5009fc3b2e116f6 = "DELETE";
const $bb466b14d7a34ad0$export$b37eb57f1c0ae17e = "GET";
const $bb466b14d7a34ad0$export$cfad2d23aef0a595 = "HEAD";
const $bb466b14d7a34ad0$export$ffb5e83a22c8414 = "OPTIONS";
const $bb466b14d7a34ad0$export$c4e10ea4e2b3375 = "PATCH";
const $bb466b14d7a34ad0$export$ca259afc8ad50e83 = "POST";
const $bb466b14d7a34ad0$export$a8e9778ce76ecdaa = "PUT";
const $bb466b14d7a34ad0$export$81cc82dc1804c06e = "TRACE";
const $bb466b14d7a34ad0$export$b4706f4398125cd2 = 'http.request.method_original';
const $bb466b14d7a34ad0$export$44a2b6455db2b082 = 'http.request.resend_count';
const $bb466b14d7a34ad0$export$a3227fcde36256b7 = (key)=>`http.response.header.${key}`;
const $bb466b14d7a34ad0$export$4f9cc9c1e7b4e832 = 'http.response.status_code';
const $bb466b14d7a34ad0$export$ee724a749950397e = 'http.route';
const $bb466b14d7a34ad0$export$9633601338584456 = 'jvm.gc.action';
const $bb466b14d7a34ad0$export$81a9f72367df0211 = 'jvm.gc.name';
const $bb466b14d7a34ad0$export$27fb7cfe62c0cad7 = 'jvm.memory.pool.name';
const $bb466b14d7a34ad0$export$c9dfa04abbde6209 = 'jvm.memory.type';
const $bb466b14d7a34ad0$export$5eceb6c6d9c4a2b1 = "heap";
const $bb466b14d7a34ad0$export$fb42d239cc164326 = "non_heap";
const $bb466b14d7a34ad0$export$b9f4735680b4c618 = 'jvm.thread.daemon';
const $bb466b14d7a34ad0$export$49cfe86a143a90f4 = 'jvm.thread.state';
const $bb466b14d7a34ad0$export$4d1c8eb785b37946 = "blocked";
const $bb466b14d7a34ad0$export$438d3b92d604d3c1 = "new";
const $bb466b14d7a34ad0$export$efbf4822176b787e = "runnable";
const $bb466b14d7a34ad0$export$10d62496862243a3 = "terminated";
const $bb466b14d7a34ad0$export$54c3957659069067 = "timed_waiting";
const $bb466b14d7a34ad0$export$97de93f28bd98f0c = "waiting";
const $bb466b14d7a34ad0$export$122a3f3d92b58f2d = 'network.local.address';
const $bb466b14d7a34ad0$export$dd3d00f8681df0ce = 'network.local.port';
const $bb466b14d7a34ad0$export$28b7676252843fab = 'network.peer.address';
const $bb466b14d7a34ad0$export$9fb532b0fee2b1f1 = 'network.peer.port';
const $bb466b14d7a34ad0$export$dee59b686a2846ec = 'network.protocol.name';
const $bb466b14d7a34ad0$export$d98f8d975600c0d0 = 'network.protocol.version';
const $bb466b14d7a34ad0$export$7616c996937a34bc = 'network.transport';
const $bb466b14d7a34ad0$export$f4431576993bcf7a = "pipe";
const $bb466b14d7a34ad0$export$169e124b418d088f = "quic";
const $bb466b14d7a34ad0$export$26ef76391bdfab1b = "tcp";
const $bb466b14d7a34ad0$export$a1d89d523a38f571 = "udp";
const $bb466b14d7a34ad0$export$19b3a90274118dec = "unix";
const $bb466b14d7a34ad0$export$9ce893eda94da085 = 'network.type';
const $bb466b14d7a34ad0$export$1c0032dd042c0036 = "ipv4";
const $bb466b14d7a34ad0$export$2e20616f92e0c61 = "ipv6";
const $bb466b14d7a34ad0$export$c0272561abab91e2 = 'otel.scope.name';
const $bb466b14d7a34ad0$export$f34b883f266e7940 = 'otel.scope.version';
const $bb466b14d7a34ad0$export$1ce3678560a98f66 = 'otel.status_code';
const $bb466b14d7a34ad0$export$91e9746558fdb3eb = "ERROR";
const $bb466b14d7a34ad0$export$88d70046bd134963 = "OK";
const $bb466b14d7a34ad0$export$bb722bc34dbbae55 = 'otel.status_description';
const $bb466b14d7a34ad0$export$a5acaa0dbc823e02 = 'server.address';
const $bb466b14d7a34ad0$export$b7822882ad829476 = 'server.port';
const $bb466b14d7a34ad0$export$84187ab40ae4fa9c = 'service.name';
const $bb466b14d7a34ad0$export$262ef07bab967f36 = 'service.version';
const $bb466b14d7a34ad0$export$d52213f71e0d6fe9 = 'signalr.connection.status';
const $bb466b14d7a34ad0$export$1941a43dd05c1796 = "app_shutdown";
const $bb466b14d7a34ad0$export$339985f783caddd3 = "normal_closure";
const $bb466b14d7a34ad0$export$5dbce0c170853f5d = "timeout";
const $bb466b14d7a34ad0$export$344eec4d4360b8c9 = 'signalr.transport';
const $bb466b14d7a34ad0$export$c9ad321a279e5110 = "long_polling";
const $bb466b14d7a34ad0$export$ade38f22da951337 = "server_sent_events";
const $bb466b14d7a34ad0$export$cb9a023ecee30642 = "web_sockets";
const $bb466b14d7a34ad0$export$f0cc9f40fa472996 = 'telemetry.sdk.language';
const $bb466b14d7a34ad0$export$76253579e9fea8e3 = "cpp";
const $bb466b14d7a34ad0$export$4163d8f19c62acfe = "dotnet";
const $bb466b14d7a34ad0$export$d735f65160d35019 = "erlang";
const $bb466b14d7a34ad0$export$1dde175b7d1c8a44 = "go";
const $bb466b14d7a34ad0$export$73150af2f1f383fa = "java";
const $bb466b14d7a34ad0$export$1b3cb919ea0daa1c = "nodejs";
const $bb466b14d7a34ad0$export$1a3ac4d13e9292be = "php";
const $bb466b14d7a34ad0$export$5734868f06d7b5c8 = "python";
const $bb466b14d7a34ad0$export$b7bb3f8171ef2aa3 = "ruby";
const $bb466b14d7a34ad0$export$713f4fffa2875054 = "rust";
const $bb466b14d7a34ad0$export$8d08f2cb0d9fd722 = "swift";
const $bb466b14d7a34ad0$export$2f063992689fdf64 = "webjs";
const $bb466b14d7a34ad0$export$8f719441032e7a01 = 'telemetry.sdk.name';
const $bb466b14d7a34ad0$export$5fe5e8dd061ec635 = 'telemetry.sdk.version';
const $bb466b14d7a34ad0$export$f00e0b7bc579cfe4 = 'url.fragment';
const $bb466b14d7a34ad0$export$ef7da4fb774e8a84 = 'url.full';
const $bb466b14d7a34ad0$export$36f670b9709ab2f8 = 'url.path';
const $bb466b14d7a34ad0$export$55ce97b387061dd1 = 'url.query';
const $bb466b14d7a34ad0$export$d1d5ca1ca02801e6 = 'url.scheme';
const $bb466b14d7a34ad0$export$11d4f8ef7be26b3d = 'user_agent.original';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-xml-http-request
// These may be unified in the future.
parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ed36a0392602b24$export$c1cd528968868329(_) {
    return undefined;
}
function $5ed36a0392602b24$export$9d8f36a7ac8db58c(_) {
    return undefined;
}
function $5ed36a0392602b24$export$9d6c13e44580559c(_) {
    return undefined;
}
function $5ed36a0392602b24$export$a18720db12f89f06(_) {
    return undefined;
}


const $eb4f2b4d7a4e93cd$var$DIAG_LOGGER = $aLPFc.diag.createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-fetch/utils'
});
function $eb4f2b4d7a4e93cd$export$71d292fa56cdb7b9(...args) {
    if (args[0] instanceof URL || typeof args[0] === 'string') {
        const requestInit = args[1];
        if (!requestInit?.body) return Promise.resolve();
        if (requestInit.body instanceof ReadableStream) {
            const { body: body, length: length } = $eb4f2b4d7a4e93cd$var$_getBodyNonDestructively(requestInit.body);
            requestInit.body = body;
            return length;
        } else return Promise.resolve($eb4f2b4d7a4e93cd$export$e6a57dee760266dc(requestInit.body));
    } else {
        const info = args[0];
        if (!info?.body) return Promise.resolve();
        return info.clone().text().then((t)=>$eb4f2b4d7a4e93cd$var$getByteLength(t));
    }
}
function $eb4f2b4d7a4e93cd$var$_getBodyNonDestructively(body) {
    // can't read a ReadableStream without destroying it
    // but we CAN pipe it through and return a new ReadableStream
    // some (older) platforms don't expose the pipeThrough method and in that scenario, we're out of luck;
    //   there's no way to read the stream without consuming it.
    if (!body.pipeThrough) {
        $eb4f2b4d7a4e93cd$var$DIAG_LOGGER.warn('Platform has ReadableStream but not pipeThrough!');
        return {
            body: body,
            length: Promise.resolve(undefined)
        };
    }
    let length = 0;
    let resolveLength;
    const lengthPromise = new Promise((resolve)=>{
        resolveLength = resolve;
    });
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            const bytearray = await chunk;
            length += bytearray.byteLength;
            controller.enqueue(chunk);
        },
        flush () {
            resolveLength(length);
        }
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise
    };
}
function $eb4f2b4d7a4e93cd$var$isDocument(value) {
    return typeof Document !== 'undefined' && value instanceof Document;
}
function $eb4f2b4d7a4e93cd$export$e6a57dee760266dc(body) {
    if ($eb4f2b4d7a4e93cd$var$isDocument(body)) return new XMLSerializer().serializeToString(document).length;
    // XMLHttpRequestBodyInit expands to the following:
    if (typeof body === 'string') return $eb4f2b4d7a4e93cd$var$getByteLength(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $eb4f2b4d7a4e93cd$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $eb4f2b4d7a4e93cd$var$getByteLength(body.toString());
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) return body.byteLength;
    $eb4f2b4d7a4e93cd$var$DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
const $eb4f2b4d7a4e93cd$var$TEXT_ENCODER = new TextEncoder();
function $eb4f2b4d7a4e93cd$var$getByteLength(s) {
    return $eb4f2b4d7a4e93cd$var$TEXT_ENCODER.encode(s).byteLength;
}
function $eb4f2b4d7a4e93cd$var$getFormDataSize(formData) {
    let size = 0;
    for (const [key, value] of formData.entries()){
        size += key.length;
        if (value instanceof Blob) size += value.size;
        else size += value.length;
    }
    return size;
}
function $eb4f2b4d7a4e93cd$export$873c02bc543800b4(method) {
    const knownMethods = $eb4f2b4d7a4e93cd$var$getKnownMethods();
    const methUpper = method.toUpperCase();
    if (methUpper in knownMethods) return methUpper;
    else return '_OTHER';
}
const $eb4f2b4d7a4e93cd$var$DEFAULT_KNOWN_METHODS = {
    CONNECT: true,
    DELETE: true,
    GET: true,
    HEAD: true,
    OPTIONS: true,
    PATCH: true,
    POST: true,
    PUT: true,
    TRACE: true
};
let $eb4f2b4d7a4e93cd$var$knownMethods;
function $eb4f2b4d7a4e93cd$var$getKnownMethods() {
    if ($eb4f2b4d7a4e93cd$var$knownMethods === undefined) {
        const cfgMethods = (0, $5ed36a0392602b24$export$a18720db12f89f06)('OTEL_INSTRUMENTATION_HTTP_KNOWN_METHODS');
        if (cfgMethods && cfgMethods.length > 0) {
            $eb4f2b4d7a4e93cd$var$knownMethods = {};
            cfgMethods.forEach((m)=>{
                $eb4f2b4d7a4e93cd$var$knownMethods[m] = true;
            });
        } else $eb4f2b4d7a4e93cd$var$knownMethods = $eb4f2b4d7a4e93cd$var$DEFAULT_KNOWN_METHODS;
    }
    return $eb4f2b4d7a4e93cd$var$knownMethods;
}
const $eb4f2b4d7a4e93cd$var$HTTP_PORT_FROM_PROTOCOL = {
    'https:': '443',
    'http:': '80'
};
function $eb4f2b4d7a4e93cd$export$ba627727eda86738(url) {
    const serverPort = Number(url.port || $eb4f2b4d7a4e93cd$var$HTTP_PORT_FROM_PROTOCOL[url.protocol]);
    // Guard with `if (serverPort)` because `Number('') === 0`.
    if (serverPort && !isNaN(serverPort)) return serverPort;
    else return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $ad26d0ea863b402b$export$a4ad2735b021c132 = '0.208.0';


// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
const $f2616c48e892e2a9$var$OBSERVER_WAIT_TIME_MS = 300;
const $f2616c48e892e2a9$var$isNode = false;
class $f2616c48e892e2a9$export$f922a490458c98a8 extends (0, $21cb51e8b334af23$export$436b1c2bf7e9756b) {
    component = 'fetch';
    version = (0, $ad26d0ea863b402b$export$a4ad2735b021c132);
    moduleName = this.component;
    _usedResources = new WeakSet();
    _tasksCount = 0;
    _semconvStability;
    constructor(config = {}){
        super('@opentelemetry/instrumentation-fetch', (0, $ad26d0ea863b402b$export$a4ad2735b021c132), config);
        this._semconvStability = (0, $0ee39f2d52193b96$export$f9fa4e140bcc07bb)('http', config?.semconvStabilityOptIn);
    }
    init() {}
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */ _addChildSpan(span, corsPreFlightRequest) {
        const childSpan = this.tracer.startSpan('CORS Preflight', {
            startTime: corsPreFlightRequest[$c09a8c0f751b5acb$export$74be52df2d6fd28c.FETCH_START]
        }, $j5ja1.trace.setSpan($3rgEx.context.active(), span));
        const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).OLD);
        $6e537250b1d76874$export$e2385716cf129455(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
        childSpan.end(corsPreFlightRequest[$c09a8c0f751b5acb$export$74be52df2d6fd28c.RESPONSE_END]);
    }
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */ _addFinalSpanAttributes(span, response) {
        const parsedUrl = $6e537250b1d76874$export$7a5253c0f62e0150(response.url);
        if (this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).OLD) {
            span.setAttribute((0, $13f8f0c2c336e772$export$116a6efc1c017b7b), response.status);
            if (response.statusText != null) span.setAttribute((0, $6fbd9743d6931274$export$668754fb61dd076c).HTTP_STATUS_TEXT, response.statusText);
            span.setAttribute((0, $13f8f0c2c336e772$export$15464108e35f33c4), parsedUrl.host);
            span.setAttribute((0, $13f8f0c2c336e772$export$2d7ebf68a433b0fd), parsedUrl.protocol.replace(':', ''));
            if (typeof navigator !== 'undefined') span.setAttribute((0, $13f8f0c2c336e772$export$a4ba95edc60c8ef3), navigator.userAgent);
        }
        if (this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).STABLE) {
            span.setAttribute((0, $bb466b14d7a34ad0$export$4f9cc9c1e7b4e832), response.status);
            // TODO: Set server.{address,port} at span creation for sampling decisions
            // (a "SHOULD" requirement in semconv).
            span.setAttribute((0, $bb466b14d7a34ad0$export$a5acaa0dbc823e02), parsedUrl.hostname);
            const serverPort = (0, $eb4f2b4d7a4e93cd$export$ba627727eda86738)(parsedUrl);
            if (serverPort) span.setAttribute((0, $bb466b14d7a34ad0$export$b7822882ad829476), serverPort);
        }
    }
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */ _addHeaders(options, spanUrl) {
        if (!$6e537250b1d76874$export$c6501d7e56a5b40a(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            const headers = {};
            $iN5wJ.propagation.inject($3rgEx.context.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        if (options instanceof Request) $iN5wJ.propagation.inject($3rgEx.context.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Headers) $iN5wJ.propagation.inject($3rgEx.context.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else if (options.headers instanceof Map) $iN5wJ.propagation.inject($3rgEx.context.active(), options.headers, {
            set: (h, k, v)=>h.set(k, typeof v === 'string' ? v : String(v))
        });
        else {
            const headers = {};
            $iN5wJ.propagation.inject($3rgEx.context.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    }
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ _clearResources() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    }
    /**
     * Creates a new span
     * @param url
     * @param options
     */ _createSpan(url, options = {}) {
        if ($27d1ee50041bb779$export$172b5a1c42a6f83d(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        let name = '';
        const attributes = {};
        if (this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).OLD) {
            const method = (options.method || 'GET').toUpperCase();
            name = `HTTP ${method}`;
            attributes[(0, $6fbd9743d6931274$export$668754fb61dd076c).COMPONENT] = this.moduleName;
            attributes[0, $13f8f0c2c336e772$export$cf26e21ee4664adb] = method;
            attributes[0, $13f8f0c2c336e772$export$13e2e9fdaf5f7c2d] = url;
        }
        if (this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).STABLE) {
            const origMethod = options.method;
            const normMethod = (0, $eb4f2b4d7a4e93cd$export$873c02bc543800b4)(options.method || 'GET');
            if (!name) // The "old" span name wins if emitting both old and stable semconv
            // ('http/dup').
            name = normMethod;
            attributes[0, $bb466b14d7a34ad0$export$c950c48d651d36f6] = normMethod;
            if (normMethod !== origMethod) attributes[0, $bb466b14d7a34ad0$export$b4706f4398125cd2] = origMethod;
            attributes[0, $bb466b14d7a34ad0$export$ef7da4fb774e8a84] = url;
        }
        return this.tracer.startSpan(name, {
            kind: $hbJhQ.SpanKind.CLIENT,
            attributes: attributes
        });
    }
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */ _findResourceAndAddNetworkEvents(span, resourcesObserver, endTime) {
        let resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType('resource');
        }
        const resource = $6e537250b1d76874$export$cdcba7438a7553e8(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, 'fetch');
        if (resource.mainRequest) {
            const mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            const corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).OLD);
            $6e537250b1d76874$export$e2385716cf129455(span, mainRequest, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
        }
    }
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */ _markResourceAsUsed(resource) {
        this._usedResources.add(resource);
    }
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */ _endSpan(span, spanData, response) {
        const endTime = $c767f1362e0cdd3e$export$e7ec5c82995537b1(Date.now());
        const performanceEndTime = $c767f1362e0cdd3e$export$24b3f7dcd2848fa8();
        this._addFinalSpanAttributes(span, response);
        if (this._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).STABLE) // https://github.com/open-telemetry/semantic-conventions/blob/main/docs/http/http-spans.md#status
        {
            if (response.status >= 400) {
                span.setStatus({
                    code: $4D9sW.SpanStatusCode.ERROR
                });
                span.setAttribute((0, $bb466b14d7a34ad0$export$27bc5d0fa190eb39), String(response.status));
            }
        }
        setTimeout(()=>{
            spanData.observer?.disconnect();
            this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            this._tasksCount--;
            this._clearResources();
            span.end(endTime);
        }, $f2616c48e892e2a9$var$OBSERVER_WAIT_TIME_MS);
    }
    /**
     * Patches the constructor of fetch
     */ _patchConstructor() {
        return (original)=>{
            const plugin = this;
            return function patchConstructor(...args) {
                const self = this;
                const url = $6e537250b1d76874$export$7a5253c0f62e0150(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                const options = args[0] instanceof Request ? args[0] : args[1] || {};
                const createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                const spanData = plugin._prepareSpanData(url);
                if (plugin.getConfig().measureRequestSize) (0, $eb4f2b4d7a4e93cd$export$71d292fa56cdb7b9)(...args).then((bodyLength)=>{
                    if (!bodyLength) return;
                    if (plugin._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).OLD) createdSpan.setAttribute((0, $13f8f0c2c336e772$export$3cbfc10a128d2cf7), bodyLength);
                    if (plugin._semconvStability & (0, $0ee39f2d52193b96$export$38c181bcafcf2fa0).STABLE) createdSpan.setAttribute((0, $13f8f0c2c336e772$export$d65e4dc87162df0a), bodyLength);
                }).catch((error)=>{
                    plugin._diag.warn('getFetchBodyLength', error);
                });
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function withCancelPropagation(body, readerClone) {
                    if (!body) return null;
                    const reader = body.getReader();
                    return new ReadableStream({
                        async pull (controller) {
                            try {
                                const { value: value, done: done } = await reader.read();
                                if (done) {
                                    reader.releaseLock();
                                    controller.close();
                                } else controller.enqueue(value);
                            } catch (err) {
                                controller.error(err);
                                reader.cancel(err).catch((_)=>{});
                                try {
                                    reader.releaseLock();
                                } catch  {
                                // Spec reference:
                                // https://streams.spec.whatwg.org/#default-reader-release-lock
                                //
                                // releaseLock() only throws if called on an invalid reader
                                // (i.e. reader.[[stream]] is undefined, meaning the lock is already released
                                // or the reader was never associated). In normal use this cannot happen.
                                // This catch is defensive only.
                                }
                            }
                        },
                        cancel (reason) {
                            readerClone.cancel(reason).catch((_)=>{});
                            return reader.cancel(reason);
                        }
                    });
                }
                function onSuccess(span, resolve, response) {
                    let proxiedResponse = null;
                    try {
                        // TODO: Switch to a consumer-driven model and drop `resClone`.
                        // Keeping eager consumption here to preserve current behavior and avoid breaking existing tests.
                        // Context: discussion in PR #5894 → https://github.com/open-telemetry/opentelemetry-js/pull/5894
                        const resClone = response.clone();
                        const body = resClone.body;
                        if (body) {
                            const reader = body.getReader();
                            const isNullBodyStatus = // 101 responses and protocol upgrading is handled internally by the browser
                            response.status === 204 || response.status === 205 || response.status === 304;
                            const wrappedBody = isNullBodyStatus ? null : withCancelPropagation(response.body, reader);
                            proxiedResponse = new Response(wrappedBody, {
                                status: response.status,
                                statusText: response.statusText,
                                headers: response.headers
                            });
                            const read = ()=>{
                                reader.read().then(({ done: done })=>{
                                    if (done) endSpanOnSuccess(span, response);
                                    else read();
                                }, (error)=>{
                                    endSpanOnError(span, error);
                                });
                            };
                            read();
                        } else // some older browsers don't have .body implemented
                        endSpanOnSuccess(span, response);
                    } finally{
                        resolve(proxiedResponse ?? response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise((resolve, reject)=>{
                    return $3rgEx.context.with($j5ja1.trace.setSpan($3rgEx.context.active(), createdSpan), ()=>{
                        plugin._addHeaders(options, url);
                        plugin._callRequestHook(createdSpan, options);
                        plugin._tasksCount++;
                        return original.apply(self, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    }
    _applyAttributesAfterFetch(span, request, result) {
        const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) (0, $b67ed1564e468009$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, request, result), (error)=>{
            if (!error) return;
            this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    }
    _callRequestHook(span, request) {
        const requestHook = this.getConfig().requestHook;
        if (requestHook) (0, $b67ed1564e468009$export$fdff7e10f8ca069e)(()=>requestHook(span, request), (error)=>{
            if (!error) return;
            this._diag.error('requestHook', error);
        }, true);
    }
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */ _prepareSpanData(spanUrl) {
        const startTime = $c767f1362e0cdd3e$export$24b3f7dcd2848fa8();
        const entries = [];
        if (typeof PerformanceObserver !== 'function') return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        const observer = new PerformanceObserver((list)=>{
            const perfObsEntries = list.getEntries();
            perfObsEntries.forEach((entry)=>{
                if (entry.initiatorType === 'fetch' && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                'resource'
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    }
    /**
     * implements enable function
     */ enable() {
        if ($f2616c48e892e2a9$var$isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ((0, $b67ed1564e468009$export$ec0fd572751979bc)(fetch)) {
            this._unwrap((0, $7379639a8acff8a3$export$5c524ddf7208c00c), 'fetch');
            this._diag.debug('removing previous patch for constructor');
        }
        this._wrap((0, $7379639a8acff8a3$export$5c524ddf7208c00c), 'fetch', this._patchConstructor());
    }
    /**
     * implements unpatch function
     */ disable() {
        if ($f2616c48e892e2a9$var$isNode) return;
        this._unwrap((0, $7379639a8acff8a3$export$5c524ddf7208c00c), 'fetch');
        this._usedResources = new WeakSet();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $bb70a1934594da53$export$a4ad2735b021c132 = '2.2.0';



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * The name of the runtime of this process.
 *
 * @example OpenJDK Runtime Environment
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 */ const $c86ae366d419542d$export$ad06ab84cf3d9d79 = 'process.runtime.name';


const $d93cce2b4a6918af$export$3c44663382dce232 = {
    [(0, $bb466b14d7a34ad0$export$8f719441032e7a01)]: 'opentelemetry',
    [(0, $c86ae366d419542d$export$ad06ab84cf3d9d79)]: 'browser',
    [(0, $bb466b14d7a34ad0$export$f0cc9f40fa472996)]: (0, $bb466b14d7a34ad0$export$2f063992689fdf64),
    [(0, $bb466b14d7a34ad0$export$5fe5e8dd061ec635)]: (0, $bb70a1934594da53$export$a4ad2735b021c132)
};



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1e6290ea6e85fbf0$export$b8c2abd2a6cf7c10() {
    return 'unknown_service';
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ac8d5783dc00e44d$export$ae936b9d47e5870e = (val)=>{
    return val !== null && typeof val === 'object' && typeof val.then === 'function';
};
function $ac8d5783dc00e44d$export$f0954fd7d5368655(_) {
    return _;
}


class $98f21beccee030f6$var$ResourceImpl {
    _rawAttributes;
    _asyncAttributesPending = false;
    _schemaUrl;
    _memoizedAttributes;
    static FromAttributeList(attributes, options) {
        const res = new $98f21beccee030f6$var$ResourceImpl({}, options);
        res._rawAttributes = $98f21beccee030f6$var$guardedRawAttributes(attributes);
        res._asyncAttributesPending = attributes.filter(([_, val])=>(0, $ac8d5783dc00e44d$export$ae936b9d47e5870e)(val)).length > 0;
        return res;
    }
    constructor(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ resource, options){
        const attributes = resource.attributes ?? {};
        this._rawAttributes = Object.entries(attributes).map(([k, v])=>{
            if ((0, $ac8d5783dc00e44d$export$ae936b9d47e5870e)(v)) // side-effect
            this._asyncAttributesPending = true;
            return [
                k,
                v
            ];
        });
        this._rawAttributes = $98f21beccee030f6$var$guardedRawAttributes(this._rawAttributes);
        this._schemaUrl = $98f21beccee030f6$var$validateSchemaUrl(options?.schemaUrl);
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (!this.asyncAttributesPending) return;
        for(let i = 0; i < this._rawAttributes.length; i++){
            const [k, v] = this._rawAttributes[i];
            this._rawAttributes[i] = [
                k,
                (0, $ac8d5783dc00e44d$export$ae936b9d47e5870e)(v) ? await v : v
            ];
        }
        this._asyncAttributesPending = false;
    }
    get attributes() {
        if (this.asyncAttributesPending) (0, $aLPFc.diag).error('Accessing resource attributes before async attributes settled');
        if (this._memoizedAttributes) return this._memoizedAttributes;
        const attrs = {};
        for (const [k, v] of this._rawAttributes){
            if ((0, $ac8d5783dc00e44d$export$ae936b9d47e5870e)(v)) {
                (0, $aLPFc.diag).debug(`Unsettled resource attribute ${k} skipped`);
                continue;
            }
            if (v != null) attrs[k] ??= v;
        }
        // only memoize output if all attributes are settled
        if (!this._asyncAttributesPending) this._memoizedAttributes = attrs;
        return attrs;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    get schemaUrl() {
        return this._schemaUrl;
    }
    merge(resource) {
        if (resource == null) return this;
        // Order is important
        // Spec states incoming attributes override existing attributes
        const mergedSchemaUrl = $98f21beccee030f6$var$mergeSchemaUrl(this, resource);
        const mergedOptions = mergedSchemaUrl ? {
            schemaUrl: mergedSchemaUrl
        } : undefined;
        return $98f21beccee030f6$var$ResourceImpl.FromAttributeList([
            ...resource.getRawAttributes(),
            ...this.getRawAttributes()
        ], mergedOptions);
    }
}
function $98f21beccee030f6$export$bb0fe4e7060febbf(attributes, options) {
    return $98f21beccee030f6$var$ResourceImpl.FromAttributeList(Object.entries(attributes), options);
}
function $98f21beccee030f6$export$4d462f2e58ee368a(detectedResource, options) {
    return new $98f21beccee030f6$var$ResourceImpl(detectedResource, options);
}
function $98f21beccee030f6$export$6ed870441802d126() {
    return $98f21beccee030f6$export$bb0fe4e7060febbf({});
}
function $98f21beccee030f6$export$522a862cad1b0abc() {
    return $98f21beccee030f6$export$bb0fe4e7060febbf({
        [(0, $bb466b14d7a34ad0$export$84187ab40ae4fa9c)]: (0, $1e6290ea6e85fbf0$export$b8c2abd2a6cf7c10)(),
        [(0, $bb466b14d7a34ad0$export$f0cc9f40fa472996)]: (0, $d93cce2b4a6918af$export$3c44663382dce232)[0, $bb466b14d7a34ad0$export$f0cc9f40fa472996],
        [(0, $bb466b14d7a34ad0$export$8f719441032e7a01)]: (0, $d93cce2b4a6918af$export$3c44663382dce232)[0, $bb466b14d7a34ad0$export$8f719441032e7a01],
        [(0, $bb466b14d7a34ad0$export$5fe5e8dd061ec635)]: (0, $d93cce2b4a6918af$export$3c44663382dce232)[0, $bb466b14d7a34ad0$export$5fe5e8dd061ec635]
    });
}
function $98f21beccee030f6$var$guardedRawAttributes(attributes) {
    return attributes.map(([k, v])=>{
        if ((0, $ac8d5783dc00e44d$export$ae936b9d47e5870e)(v)) return [
            k,
            v.catch((err)=>{
                (0, $aLPFc.diag).debug('promise rejection for resource attribute: %s - %s', k, err);
                return undefined;
            })
        ];
        return [
            k,
            v
        ];
    });
}
function $98f21beccee030f6$var$validateSchemaUrl(schemaUrl) {
    if (typeof schemaUrl === 'string' || schemaUrl === undefined) return schemaUrl;
    (0, $aLPFc.diag).warn('Schema URL must be string or undefined, got %s. Schema URL will be ignored.', schemaUrl);
    return undefined;
}
function $98f21beccee030f6$var$mergeSchemaUrl(old, updating) {
    const oldSchemaUrl = old?.schemaUrl;
    const updatingSchemaUrl = updating?.schemaUrl;
    const isOldEmpty = oldSchemaUrl === undefined || oldSchemaUrl === '';
    const isUpdatingEmpty = updatingSchemaUrl === undefined || updatingSchemaUrl === '';
    if (isOldEmpty) return updatingSchemaUrl;
    if (isUpdatingEmpty) return oldSchemaUrl;
    if (oldSchemaUrl === updatingSchemaUrl) return oldSchemaUrl;
    (0, $aLPFc.diag).warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', oldSchemaUrl, updatingSchemaUrl);
    return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8deff90f8044664b$export$85f6557964517f1a {
    _promise;
    _resolve;
    _reject;
    constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(val) {
        this._resolve(val);
    }
    reject(err) {
        this._reject(err);
    }
}


class $fbc9a6a8496c0149$export$c1f52ab4952184cd {
    _callback;
    _that;
    _isCalled = false;
    _deferred = new (0, $8deff90f8044664b$export$85f6557964517f1a)();
    constructor(_callback, _that){
        this._callback = _callback;
        this._that = _that;
    }
    get isCalled() {
        return this._isCalled;
    }
    get promise() {
        return this._deferred.promise;
    }
    call(...args) {
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve(this._callback.call(this._that, ...args)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error that is thrown on timeouts.
 */ class $81c7dd26e099880d$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        // manually adjust prototype to retain `instanceof` functionality when targeting ES5, see:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $81c7dd26e099880d$export$66d311bf29d5c89c.prototype);
    }
}
function $81c7dd26e099880d$export$f373139ba5555dc3(promise, timeout) {
    let timeoutHandle;
    const timeoutPromise = new Promise(function timeoutFunction(_resolve, reject) {
        timeoutHandle = setTimeout(function timeoutHandler() {
            reject(new $81c7dd26e099880d$export$66d311bf29d5c89c('Operation timed out.'));
        }, timeout);
    });
    return Promise.race([
        promise,
        timeoutPromise
    ]).then((result)=>{
        clearTimeout(timeoutHandle);
        return result;
    }, (reason)=>{
        clearTimeout(timeoutHandle);
        throw reason;
    });
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
function $2d4205ebf36f1dc2$export$cd67a16f6d11e5bd() {
    return (ex)=>{
        (0, $aLPFc.diag).error($2d4205ebf36f1dc2$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $2d4205ebf36f1dc2$var$stringifyException(ex) {
    if (typeof ex === 'string') return ex;
    else return JSON.stringify($2d4205ebf36f1dc2$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $2d4205ebf36f1dc2$var$flattenException(ex) {
    const result = {};
    let current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach((propertyName)=>{
            if (result[propertyName]) return;
            const value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}


/** The global error handler delegate */ let $fd2ddffad4c94da7$var$delegateHandler = (0, $2d4205ebf36f1dc2$export$cd67a16f6d11e5bd)();
function $fd2ddffad4c94da7$export$bdff946829732435(handler) {
    $fd2ddffad4c94da7$var$delegateHandler = handler;
}
function $fd2ddffad4c94da7$export$54c6946fc34b7cc2(ex) {
    try {
        $fd2ddffad4c94da7$var$delegateHandler(ex);
    } catch  {} // eslint-disable-line no-empty
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $iN5wJ = parcelRequire("iN5wJ");

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $dcc7b063f453fc65$export$3043215ef908d54f = '=';
const $dcc7b063f453fc65$export$393a3f9e6e76438 = ';';
const $dcc7b063f453fc65$export$1ab471785c2cf557 = ',';
const $dcc7b063f453fc65$export$a6199dd4fe419e69 = 'baggage';
const $dcc7b063f453fc65$export$9a50757016085e99 = 180;
const $dcc7b063f453fc65$export$c7d9e39bb295c1f = 4096;
const $dcc7b063f453fc65$export$dd0527bee1f518e7 = 8192;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dM071 = parcelRequire("dM071");

function $f8a0cb0d30ba7cb6$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce((hValue, current)=>{
        const value = `${hValue}${hValue !== '' ? (0, $dcc7b063f453fc65$export$1ab471785c2cf557) : ''}${current}`;
        return value.length > (0, $dcc7b063f453fc65$export$dd0527bee1f518e7) ? hValue : value;
    }, '');
}
function $f8a0cb0d30ba7cb6$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(([key, value])=>{
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value.value)}`;
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $dcc7b063f453fc65$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $f8a0cb0d30ba7cb6$export$62659c450b08e504(entry) {
    const valueProps = entry.split((0, $dcc7b063f453fc65$export$393a3f9e6e76438));
    if (valueProps.length <= 0) return;
    const keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    const separatorIndex = keyPairPart.indexOf((0, $dcc7b063f453fc65$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    const key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    const value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    let metadata;
    if (valueProps.length > 0) metadata = (0, $dM071.baggageEntryMetadataFromString)(valueProps.join((0, $dcc7b063f453fc65$export$393a3f9e6e76438)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $f8a0cb0d30ba7cb6$export$1259660ed6830e21(value) {
    const result = {};
    if (typeof value === 'string' && value.length > 0) value.split((0, $dcc7b063f453fc65$export$1ab471785c2cf557)).forEach((entry)=>{
        const keyPair = $f8a0cb0d30ba7cb6$export$62659c450b08e504(entry);
        if (keyPair !== undefined && keyPair.value.length > 0) result[keyPair.key] = keyPair.value;
    });
    return result;
}


class $f2954aac21ca826d$export$604bcc7f2bff6bb {
    inject(context, carrier, setter) {
        const baggage = (0, $iN5wJ.propagation).getBaggage(context);
        if (!baggage || (0, $8cf02d28c127a3b0$export$7d5f2376f7cf513)(context)) return;
        const keyPairs = (0, $f8a0cb0d30ba7cb6$export$ed4c06f0919b1951)(baggage).filter((pair)=>{
            return pair.length <= (0, $dcc7b063f453fc65$export$c7d9e39bb295c1f);
        }).slice(0, (0, $dcc7b063f453fc65$export$9a50757016085e99));
        const headerValue = (0, $f8a0cb0d30ba7cb6$export$790fc82b2ff5bf87)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $dcc7b063f453fc65$export$a6199dd4fe419e69), headerValue);
    }
    extract(context, carrier, getter) {
        const headerValue = getter.get(carrier, (0, $dcc7b063f453fc65$export$a6199dd4fe419e69));
        const baggageString = Array.isArray(headerValue) ? headerValue.join((0, $dcc7b063f453fc65$export$1ab471785c2cf557)) : headerValue;
        if (!baggageString) return context;
        const baggage = {};
        if (baggageString.length === 0) return context;
        const pairs = baggageString.split((0, $dcc7b063f453fc65$export$1ab471785c2cf557));
        pairs.forEach((entry)=>{
            const keyPair = (0, $f8a0cb0d30ba7cb6$export$62659c450b08e504)(entry);
            if (keyPair) {
                const baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $iN5wJ.propagation).setBaggage(context, (0, $iN5wJ.propagation).createBaggage(baggage));
    }
    fields() {
        return [
            (0, $dcc7b063f453fc65$export$a6199dd4fe419e69)
        ];
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
function $4b6df80d0fda7491$export$b0663eba150d60c9(attributes) {
    const out = {};
    if (typeof attributes !== 'object' || attributes == null) return out;
    for(const key in attributes){
        if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
        if (!$4b6df80d0fda7491$export$d3dd8ead6a0318c3(key)) {
            (0, $aLPFc.diag).warn(`Invalid attribute key: ${key}`);
            continue;
        }
        const val = attributes[key];
        if (!$4b6df80d0fda7491$export$1daad3d2aacf48c5(val)) {
            (0, $aLPFc.diag).warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) out[key] = val.slice();
        else out[key] = val;
    }
    return out;
}
function $4b6df80d0fda7491$export$d3dd8ead6a0318c3(key) {
    return typeof key === 'string' && key !== '';
}
function $4b6df80d0fda7491$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $4b6df80d0fda7491$var$isHomogeneousAttributeValueArray(val);
    return $4b6df80d0fda7491$var$isValidPrimitiveAttributeValueType(typeof val);
}
function $4b6df80d0fda7491$var$isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element of arr){
        // null/undefined elements are allowed
        if (element == null) continue;
        const elementType = typeof element;
        if (elementType === type) continue;
        if (!type) {
            if ($4b6df80d0fda7491$var$isValidPrimitiveAttributeValueType(elementType)) {
                type = elementType;
                continue;
            }
            // encountered an invalid primitive
            return false;
        }
        return false;
    }
    return true;
}
function $4b6df80d0fda7491$var$isValidPrimitiveAttributeValueType(valType) {
    switch(valType){
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}









/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
class $3f3da7459cebbc03$export$4beb26f46770357f {
    _propagators;
    _fields;
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ constructor(config = {}){
        this._propagators = config.propagators ?? [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map((p)=>typeof p.fields === 'function' ? p.fields() : []).reduce((x, y)=>x.concat(y), [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ inject(context, carrier, setter) {
        for (const propagator of this._propagators)try {
            propagator.inject(context, carrier, setter);
        } catch (err) {
            (0, $aLPFc.diag).warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
        }
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ extract(context, carrier, getter) {
        return this._propagators.reduce((ctx, propagator)=>{
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $aLPFc.diag).warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
            }
            return ctx;
        }, context);
    }
    fields() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    }
}






/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ const $9f9174222a7f3496$var$objectTag = '[object Object]';
const $9f9174222a7f3496$var$nullTag = '[object Null]';
const $9f9174222a7f3496$var$undefinedTag = '[object Undefined]';
const $9f9174222a7f3496$var$funcProto = Function.prototype;
const $9f9174222a7f3496$var$funcToString = $9f9174222a7f3496$var$funcProto.toString;
const $9f9174222a7f3496$var$objectCtorString = $9f9174222a7f3496$var$funcToString.call(Object);
const $9f9174222a7f3496$var$getPrototypeOf = Object.getPrototypeOf;
const $9f9174222a7f3496$var$objectProto = Object.prototype;
const $9f9174222a7f3496$var$hasOwnProperty = $9f9174222a7f3496$var$objectProto.hasOwnProperty;
const $9f9174222a7f3496$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
const $9f9174222a7f3496$var$nativeObjectToString = $9f9174222a7f3496$var$objectProto.toString;
function $9f9174222a7f3496$export$53b83ca8eaab0383(value) {
    if (!$9f9174222a7f3496$var$isObjectLike(value) || $9f9174222a7f3496$var$baseGetTag(value) !== $9f9174222a7f3496$var$objectTag) return false;
    const proto = $9f9174222a7f3496$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = $9f9174222a7f3496$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $9f9174222a7f3496$var$funcToString.call(Ctor) === $9f9174222a7f3496$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9f9174222a7f3496$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $9f9174222a7f3496$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $9f9174222a7f3496$var$undefinedTag : $9f9174222a7f3496$var$nullTag;
    return $9f9174222a7f3496$var$symToStringTag && $9f9174222a7f3496$var$symToStringTag in Object(value) ? $9f9174222a7f3496$var$getRawTag(value) : $9f9174222a7f3496$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9f9174222a7f3496$var$getRawTag(value) {
    const isOwn = $9f9174222a7f3496$var$hasOwnProperty.call(value, $9f9174222a7f3496$var$symToStringTag), tag = value[$9f9174222a7f3496$var$symToStringTag];
    let unmasked = false;
    try {
        value[$9f9174222a7f3496$var$symToStringTag] = undefined;
        unmasked = true;
    } catch  {
    // silence
    }
    const result = $9f9174222a7f3496$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9f9174222a7f3496$var$symToStringTag] = tag;
        else delete value[$9f9174222a7f3496$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9f9174222a7f3496$var$objectToString(value) {
    return $9f9174222a7f3496$var$nativeObjectToString.call(value);
}


const $2d4910c9b5a4c06a$var$MAX_LEVEL = 20;
function $2d4910c9b5a4c06a$export$4950aa0f605343fb(...args) {
    let result = args.shift();
    const objects = new WeakMap();
    while(args.length > 0)result = $2d4910c9b5a4c06a$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $2d4910c9b5a4c06a$var$takeValue(value) {
    if ($2d4910c9b5a4c06a$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $2d4910c9b5a4c06a$var$mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > $2d4910c9b5a4c06a$var$MAX_LEVEL) return undefined;
    level++;
    if ($2d4910c9b5a4c06a$var$isPrimitive(one) || $2d4910c9b5a4c06a$var$isPrimitive(two) || $2d4910c9b5a4c06a$var$isFunction(two)) result = $2d4910c9b5a4c06a$var$takeValue(two);
    else if ($2d4910c9b5a4c06a$var$isArray(one)) {
        result = one.slice();
        if ($2d4910c9b5a4c06a$var$isArray(two)) for(let i = 0, j = two.length; i < j; i++)result.push($2d4910c9b5a4c06a$var$takeValue(two[i]));
        else if ($2d4910c9b5a4c06a$var$isObject(two)) {
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                result[key] = $2d4910c9b5a4c06a$var$takeValue(two[key]);
            }
        }
    } else if ($2d4910c9b5a4c06a$var$isObject(one)) {
        if ($2d4910c9b5a4c06a$var$isObject(two)) {
            if (!$2d4910c9b5a4c06a$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                const twoValue = two[key];
                if ($2d4910c9b5a4c06a$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if ($2d4910c9b5a4c06a$var$wasObjectReferenced(one, key, objects) || $2d4910c9b5a4c06a$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($2d4910c9b5a4c06a$var$isObject(obj1) && $2d4910c9b5a4c06a$var$isObject(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $2d4910c9b5a4c06a$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $2d4910c9b5a4c06a$var$wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for(let i = 0, j = arr.length; i < j; i++){
        const info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $2d4910c9b5a4c06a$var$isArray(value) {
    return Array.isArray(value);
}
function $2d4910c9b5a4c06a$var$isFunction(value) {
    return typeof value === 'function';
}
function $2d4910c9b5a4c06a$var$isObject(value) {
    return !$2d4910c9b5a4c06a$var$isPrimitive(value) && !$2d4910c9b5a4c06a$var$isArray(value) && !$2d4910c9b5a4c06a$var$isFunction(value) && typeof value === 'object';
}
function $2d4910c9b5a4c06a$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' || value instanceof Date || value instanceof RegExp || value === null;
}
function $2d4910c9b5a4c06a$var$shouldMerge(one, two) {
    if (!(0, $9f9174222a7f3496$export$53b83ca8eaab0383)(one) || !(0, $9f9174222a7f3496$export$53b83ca8eaab0383)(two)) return false;
    return true;
}






/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $3rgEx = parcelRequire("3rgEx");

function $297a42fed3eac0d7$export$886cca8df9d108ed(exporter, arg) {
    return new Promise((resolve)=>{
        // prevent downstream exporter calls from generating spans
        (0, $3rgEx.context).with((0, $8cf02d28c127a3b0$export$869298f9835abc68)((0, $3rgEx.context).active()), ()=>{
            exporter.export(arg, (result)=>{
                resolve(result);
            });
        });
    });
}


const $35ea4d3dae55346b$export$454b5eaffc99ebf6 = {
    _export: $297a42fed3eac0d7$export$886cca8df9d108ed
};


class $d52def938800505a$export$8362931f04937a92 {
    _exporter;
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _isExporting = false;
    _finishedLogRecords = [];
    _timer;
    _shutdownOnce;
    constructor(_exporter, config){
        this._exporter = _exporter;
        this._maxExportBatchSize = config?.maxExportBatchSize ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BLRP_MAX_EXPORT_BATCH_SIZE') ?? 512;
        this._maxQueueSize = config?.maxQueueSize ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BLRP_MAX_QUEUE_SIZE') ?? 2048;
        this._scheduledDelayMillis = config?.scheduledDelayMillis ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BLRP_SCHEDULE_DELAY') ?? 5000;
        this._exportTimeoutMillis = config?.exportTimeoutMillis ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BLRP_EXPORT_TIMEOUT') ?? 30000;
        this._shutdownOnce = new (0, $fbc9a6a8496c0149$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $aLPFc.diag).warn('BatchLogRecordProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    onEmit(logRecord) {
        if (this._shutdownOnce.isCalled) return;
        this._addToBuffer(logRecord);
    }
    forceFlush() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    async _shutdown() {
        this.onShutdown();
        await this._flushAll();
        await this._exporter.shutdown();
    }
    /** Add a LogRecord in the buffer. */ _addToBuffer(logRecord) {
        if (this._finishedLogRecords.length >= this._maxQueueSize) return;
        this._finishedLogRecords.push(logRecord);
        this._maybeStartTimer();
    }
    /**
     * Send all LogRecords to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ _flushAll() {
        return new Promise((resolve, reject)=>{
            const promises = [];
            const batchCount = Math.ceil(this._finishedLogRecords.length / this._maxExportBatchSize);
            for(let i = 0; i < batchCount; i++)promises.push(this._flushOneBatch());
            Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    _flushOneBatch() {
        this._clearTimer();
        if (this._finishedLogRecords.length === 0) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            (0, $81c7dd26e099880d$export$f373139ba5555dc3)(this._export(this._finishedLogRecords.splice(0, this._maxExportBatchSize)), this._exportTimeoutMillis).then(()=>resolve()).catch(reject);
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const flush = ()=>{
            this._isExporting = true;
            this._flushOneBatch().then(()=>{
                this._isExporting = false;
                if (this._finishedLogRecords.length > 0) {
                    this._clearTimer();
                    this._maybeStartTimer();
                }
            }).catch((e)=>{
                this._isExporting = false;
                (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedLogRecords.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
        // depending on runtime, this may be a 'number' or NodeJS.Timeout
        if (typeof this._timer !== 'number') this._timer.unref();
    }
    _clearTimer() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    }
    _export(logRecords) {
        const doExport = ()=>(0, $35ea4d3dae55346b$export$454b5eaffc99ebf6)._export(this._exporter, logRecords).then((result)=>{
                if (result.code !== (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).SUCCESS) (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(result.error ?? new Error(`BatchLogRecordProcessor: log record export failed (status ${result})`));
            }).catch((0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2));
        const pendingResources = logRecords.map((logRecord)=>logRecord.resource).filter((resource)=>resource.asyncAttributesPending);
        // Avoid scheduling a promise to make the behavior more predictable and easier to test
        if (pendingResources.length === 0) return doExport();
        else return Promise.all(pendingResources.map((resource)=>resource.waitForAsyncAttributes?.())).then(doExport, (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2));
    }
}


class $833be4621bb390b5$export$d6c3e5cb1a84420b extends (0, $d52def938800505a$export$8362931f04937a92) {
    _visibilityChangeListener;
    _pageHideListener;
    constructor(exporter, config){
        super(exporter, config);
        this._onInit(config);
    }
    onShutdown() {
        if (typeof document === 'undefined') return;
        if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
        if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
    }
    _onInit(config) {
        if (config?.disableAutoFlushOnDocumentHide === true || typeof document === 'undefined') return;
        this._visibilityChangeListener = ()=>{
            if (document.visibilityState === 'hidden') this.forceFlush();
        };
        this._pageHideListener = ()=>{
            this.forceFlush();
        };
        document.addEventListener('visibilitychange', this._visibilityChangeListener);
        // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
        document.addEventListener('pagehide', this._pageHideListener);
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");

var $lw0nH = parcelRequire("lw0nH");


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $3rgEx = parcelRequire("3rgEx");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
var $j5ja1 = parcelRequire("j5ja1");
var $dStz2 = parcelRequire("dStz2");

class $2f9fc7b7785be79f$export$db80ed5a71312c1f {
    hrTime;
    hrTimeObserved;
    spanContext;
    resource;
    instrumentationScope;
    attributes = {};
    _severityText;
    _severityNumber;
    _body;
    _eventName;
    totalAttributesCount = 0;
    _isReadonly = false;
    _logRecordLimits;
    set severityText(severityText) {
        if (this._isLogRecordReadonly()) return;
        this._severityText = severityText;
    }
    get severityText() {
        return this._severityText;
    }
    set severityNumber(severityNumber) {
        if (this._isLogRecordReadonly()) return;
        this._severityNumber = severityNumber;
    }
    get severityNumber() {
        return this._severityNumber;
    }
    set body(body) {
        if (this._isLogRecordReadonly()) return;
        this._body = body;
    }
    get body() {
        return this._body;
    }
    get eventName() {
        return this._eventName;
    }
    set eventName(eventName) {
        if (this._isLogRecordReadonly()) return;
        this._eventName = eventName;
    }
    get droppedAttributesCount() {
        return this.totalAttributesCount - Object.keys(this.attributes).length;
    }
    constructor(_sharedState, instrumentationScope, logRecord){
        const { timestamp: timestamp, observedTimestamp: observedTimestamp, eventName: eventName, severityNumber: severityNumber, severityText: severityText, body: body, attributes: attributes = {}, context: context } = logRecord;
        const now = Date.now();
        this.hrTime = (0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(timestamp ?? now);
        this.hrTimeObserved = (0, $c767f1362e0cdd3e$export$5f4c8a8ba0e36226)(observedTimestamp ?? now);
        if (context) {
            const spanContext = $j5ja1.trace.getSpanContext(context);
            if (spanContext && $dStz2.isSpanContextValid(spanContext)) this.spanContext = spanContext;
        }
        this.severityNumber = severityNumber;
        this.severityText = severityText;
        this.body = body;
        this.resource = _sharedState.resource;
        this.instrumentationScope = instrumentationScope;
        this._logRecordLimits = _sharedState.logRecordLimits;
        this._eventName = eventName;
        this.setAttributes(attributes);
    }
    setAttribute(key, value) {
        if (this._isLogRecordReadonly()) return this;
        if (value === null) return this;
        if (key.length === 0) {
            $aLPFc.diag.warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!(0, $4b6df80d0fda7491$export$1daad3d2aacf48c5)(value) && !(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0)) {
            $aLPFc.diag.warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        this.totalAttributesCount += 1;
        if (Object.keys(this.attributes).length >= this._logRecordLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            // This logic is to create drop message at most once per LogRecord to prevent excessive logging.
            if (this.droppedAttributesCount === 1) $aLPFc.diag.warn('Dropping extra attributes.');
            return this;
        }
        if ((0, $4b6df80d0fda7491$export$1daad3d2aacf48c5)(value)) this.attributes[key] = this._truncateToSize(value);
        else this.attributes[key] = value;
        return this;
    }
    setAttributes(attributes) {
        for (const [k, v] of Object.entries(attributes))this.setAttribute(k, v);
        return this;
    }
    setBody(body) {
        this.body = body;
        return this;
    }
    setEventName(eventName) {
        this.eventName = eventName;
        return this;
    }
    setSeverityNumber(severityNumber) {
        this.severityNumber = severityNumber;
        return this;
    }
    setSeverityText(severityText) {
        this.severityText = severityText;
        return this;
    }
    /**
     * @internal
     * A LogRecordProcessor may freely modify logRecord for the duration of the OnEmit call.
     * If logRecord is needed after OnEmit returns (i.e. for asynchronous processing) only reads are permitted.
     */ _makeReadonly() {
        this._isReadonly = true;
    }
    _truncateToSize(value) {
        const limit = this._logRecordLimits.attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            $aLPFc.diag.warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map((val)=>typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        // Other types, no need to apply value length limit
        return value;
    }
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    }
    _isLogRecordReadonly() {
        if (this._isReadonly) $aLPFc.diag.warn('Can not execute the operation on emitted log record');
        return this._isReadonly;
    }
}


class $5a7e27a5fbc88706$export$efa9a398d6368992 {
    instrumentationScope;
    _sharedState;
    constructor(instrumentationScope, _sharedState){
        this.instrumentationScope = instrumentationScope;
        this._sharedState = _sharedState;
    }
    emit(logRecord) {
        const currentContext = logRecord.context || (0, $3rgEx.context).active();
        /**
         * If a Logger was obtained with include_trace_context=true,
         * the LogRecords it emits MUST automatically include the Trace Context from the active Context,
         * if Context has not been explicitly set.
         */ const logRecordInstance = new (0, $2f9fc7b7785be79f$export$db80ed5a71312c1f)(this._sharedState, this.instrumentationScope, {
            context: currentContext,
            ...logRecord
        });
        /**
         * the explicitly passed Context,
         * the current Context, or an empty Context if the Logger was obtained with include_trace_context=false
         */ this._sharedState.activeProcessor.onEmit(logRecordInstance, currentContext);
        /**
         * A LogRecordProcessor may freely modify logRecord for the duration of the OnEmit call.
         * If logRecord is needed after OnEmit returns (i.e. for asynchronous processing) only reads are permitted.
         */ logRecordInstance._makeReadonly();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $a06b8eb6cef000ac$export$d25a2c2f78a5e968() {
    return {
        forceFlushTimeoutMillis: 30000,
        logRecordLimits: {
            attributeValueLengthLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT') ?? 128
        },
        includeTraceContext: true
    };
}
function $a06b8eb6cef000ac$export$9f9fb435f8494555(logRecordLimits) {
    return {
        /**
         * Reassign log record attribute count limit to use first non null value defined by user or use default value
         */ attributeCountLimit: logRecordLimits.attributeCountLimit ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT') ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128,
        /**
         * Reassign log record attribute value length limit to use first non null value defined by user or use default value
         */ attributeValueLengthLimit: logRecordLimits.attributeValueLengthLimit ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6d58777fb523ba6f$export$63af61ee3692923b {
    forceFlush() {
        return Promise.resolve();
    }
    onEmit(_logRecord, _context) {}
    shutdown() {
        return Promise.resolve();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $5c1950741bd1da66$export$42a89870aece9ced {
    processors;
    forceFlushTimeoutMillis;
    constructor(processors, forceFlushTimeoutMillis){
        this.processors = processors;
        this.forceFlushTimeoutMillis = forceFlushTimeoutMillis;
    }
    async forceFlush() {
        const timeout = this.forceFlushTimeoutMillis;
        await Promise.all(this.processors.map((processor)=>(0, $81c7dd26e099880d$export$f373139ba5555dc3)(processor.forceFlush(), timeout)));
    }
    onEmit(logRecord, context) {
        this.processors.forEach((processors)=>processors.onEmit(logRecord, context));
    }
    async shutdown() {
        await Promise.all(this.processors.map((processor)=>processor.shutdown()));
    }
}


class $618762d2ca36db59$export$cc05ae12b34e2131 {
    resource;
    forceFlushTimeoutMillis;
    logRecordLimits;
    processors;
    loggers = new Map();
    activeProcessor;
    registeredLogRecordProcessors = [];
    constructor(resource, forceFlushTimeoutMillis, logRecordLimits, processors){
        this.resource = resource;
        this.forceFlushTimeoutMillis = forceFlushTimeoutMillis;
        this.logRecordLimits = logRecordLimits;
        this.processors = processors;
        if (processors.length > 0) {
            this.registeredLogRecordProcessors = processors;
            this.activeProcessor = new (0, $5c1950741bd1da66$export$42a89870aece9ced)(this.registeredLogRecordProcessors, this.forceFlushTimeoutMillis);
        } else this.activeProcessor = new (0, $6d58777fb523ba6f$export$63af61ee3692923b)();
    }
}


const $17cb3e2e868b808c$export$c11b742e51b8ab53 = 'unknown';
class $17cb3e2e868b808c$export$23fb4edab0a7f904 {
    _shutdownOnce;
    _sharedState;
    constructor(config = {}){
        const mergedConfig = (0, $2d4910c9b5a4c06a$export$4950aa0f605343fb)({}, (0, $a06b8eb6cef000ac$export$d25a2c2f78a5e968)(), config);
        const resource = config.resource ?? (0, $98f21beccee030f6$export$522a862cad1b0abc)();
        this._sharedState = new (0, $618762d2ca36db59$export$cc05ae12b34e2131)(resource, mergedConfig.forceFlushTimeoutMillis, (0, $a06b8eb6cef000ac$export$9f9fb435f8494555)(mergedConfig.logRecordLimits), config?.processors ?? []);
        this._shutdownOnce = new (0, $fbc9a6a8496c0149$export$c1f52ab4952184cd)(this._shutdown, this);
    }
    /**
     * Get a logger with the configuration of the LoggerProvider.
     */ getLogger(name, version, options) {
        if (this._shutdownOnce.isCalled) {
            (0, $aLPFc.diag).warn('A shutdown LoggerProvider cannot provide a Logger');
            return 0, $lw0nH.NOOP_LOGGER;
        }
        if (!name) (0, $aLPFc.diag).warn('Logger requested without instrumentation scope name.');
        const loggerName = name || $17cb3e2e868b808c$export$c11b742e51b8ab53;
        const key = `${loggerName}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._sharedState.loggers.has(key)) this._sharedState.loggers.set(key, new (0, $5a7e27a5fbc88706$export$efa9a398d6368992)({
            name: loggerName,
            version: version,
            schemaUrl: options?.schemaUrl
        }, this._sharedState));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._sharedState.loggers.get(key);
    }
    /**
     * Notifies all registered LogRecordProcessor to flush any buffered data.
     *
     * Returns a promise which is resolved when all flushes are complete.
     */ forceFlush() {
        // do not flush after shutdown
        if (this._shutdownOnce.isCalled) {
            (0, $aLPFc.diag).warn('invalid attempt to force flush after LoggerProvider shutdown');
            return this._shutdownOnce.promise;
        }
        return this._sharedState.activeProcessor.forceFlush();
    }
    /**
     * Flush all buffered data and shut down the LoggerProvider and all registered
     * LogRecordProcessor.
     *
     * Returns a promise which is resolved when all flushes are complete.
     */ shutdown() {
        if (this._shutdownOnce.isCalled) {
            (0, $aLPFc.diag).warn('shutdown may only be called once per LoggerProvider');
            return this._shutdownOnce.promise;
        }
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return this._sharedState.activeProcessor.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $3rgEx = parcelRequire("3rgEx");
var $aLPFc = parcelRequire("aLPFc");
var $1iLvl = parcelRequire("1iLvl");

class $4dc5d9b2a31abaf0$export$54ea939f5d39e8a2 {
    _exporter;
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _isExporting = false;
    _finishedSpans = [];
    _timer;
    _shutdownOnce;
    _droppedSpansCount = 0;
    constructor(_exporter, config){
        this._exporter = _exporter;
        this._maxExportBatchSize = typeof config?.maxExportBatchSize === 'number' ? config.maxExportBatchSize : (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BSP_MAX_EXPORT_BATCH_SIZE') ?? 512;
        this._maxQueueSize = typeof config?.maxQueueSize === 'number' ? config.maxQueueSize : (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BSP_MAX_QUEUE_SIZE') ?? 2048;
        this._scheduledDelayMillis = typeof config?.scheduledDelayMillis === 'number' ? config.scheduledDelayMillis : (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BSP_SCHEDULE_DELAY') ?? 5000;
        this._exportTimeoutMillis = typeof config?.exportTimeoutMillis === 'number' ? config.exportTimeoutMillis : (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_BSP_EXPORT_TIMEOUT') ?? 30000;
        this._shutdownOnce = new (0, $fbc9a6a8496c0149$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $aLPFc.diag).warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    forceFlush() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    }
    // does nothing.
    onStart(_span, _parentContext) {}
    onEnd(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $1iLvl.TraceFlags).SAMPLED) === 0) return;
        this._addToBuffer(span);
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return Promise.resolve().then(()=>{
            return this.onShutdown();
        }).then(()=>{
            return this._flushAll();
        }).then(()=>{
            return this._exporter.shutdown();
        });
    }
    /** Add a span in the buffer. */ _addToBuffer(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $aLPFc.diag).debug('maxQueueSize reached, dropping spans');
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $aLPFc.diag).warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`);
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    }
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ _flushAll() {
        return new Promise((resolve, reject)=>{
            const promises = [];
            // calculate number of batches
            const count = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
            for(let i = 0, j = count; i < j; i++)promises.push(this._flushOneBatch());
            Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    _flushOneBatch() {
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            const timer = setTimeout(()=>{
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $3rgEx.context).with((0, $8cf02d28c127a3b0$export$869298f9835abc68)((0, $3rgEx.context).active()), ()=>{
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                let spans;
                if (this._finishedSpans.length <= this._maxExportBatchSize) {
                    spans = this._finishedSpans;
                    this._finishedSpans = [];
                } else spans = this._finishedSpans.splice(0, this._maxExportBatchSize);
                const doExport = ()=>this._exporter.export(spans, (result)=>{
                        clearTimeout(timer);
                        if (result.code === (0, $ae21f965a4f28f7c$export$ee0fe4df4ef0f3a1).SUCCESS) resolve();
                        else reject(result.error ?? new Error('BatchSpanProcessor: span export failed'));
                    });
                let pendingResources = null;
                for(let i = 0, len = spans.length; i < len; i++){
                    const span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources ??= [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, (err)=>{
                    (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(err);
                    reject(err);
                });
            });
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const flush = ()=>{
            this._isExporting = true;
            this._flushOneBatch().finally(()=>{
                this._isExporting = false;
                if (this._finishedSpans.length > 0) {
                    this._clearTimer();
                    this._maybeStartTimer();
                }
            }).catch((e)=>{
                this._isExporting = false;
                (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
        // depending on runtime, this may be a 'number' or NodeJS.Timeout
        if (typeof this._timer !== 'number') this._timer.unref();
    }
    _clearTimer() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    }
}



class $a2aefef0c0da04ad$export$237547059fd543f9 extends (0, $4dc5d9b2a31abaf0$export$54ea939f5d39e8a2) {
    _visibilityChangeListener;
    _pageHideListener;
    constructor(_exporter, config){
        super(_exporter, config);
        this.onInit(config);
    }
    onInit(config) {
        if (config?.disableAutoFlushOnDocumentHide !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = ()=>{
                if (document.visibilityState === 'hidden') this.forceFlush().catch((error)=>{
                    (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(error);
                });
            };
            this._pageHideListener = ()=>{
                this.forceFlush().catch((error)=>{
                    (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(error);
                });
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    }
    onShutdown() {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
        }
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $3rgEx = parcelRequire("3rgEx");
var $aLPFc = parcelRequire("aLPFc");
var $j5ja1 = parcelRequire("j5ja1");
var $2aArX = parcelRequire("2aArX");
var $83b23 = parcelRequire("83b23");
var $hbJhQ = parcelRequire("hbJhQ");
var $1iLvl = parcelRequire("1iLvl");

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");
var $4D9sW = parcelRequire("4D9sW");


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
const $919ffd4294b16129$export$a0fff09a5370d06f = 'exception';


class $cea0dae0ecce5f21$export$7b15d0c2dba75760 {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    name;
    status = {
        code: (0, $4D9sW.SpanStatusCode).UNSET
    };
    endTime = [
        0,
        0
    ];
    _ended = false;
    _duration = [
        -1,
        -1
    ];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    /**
     * Constructs a new SpanImpl instance.
     */ constructor(opts){
        const now = Date.now();
        this._spanContext = opts.spanContext;
        this._performanceStartTime = (0, $68898baf213d5344$export$b22daef4119238cd).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $c767f1362e0cdd3e$export$e752b05e58096a2f)());
        this._startTimeProvided = opts.startTime != null;
        this._spanLimits = opts.spanLimits;
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        this._spanProcessor = opts.spanProcessor;
        this.name = opts.name;
        this.parentSpanContext = opts.parentSpanContext;
        this.kind = opts.kind;
        this.links = opts.links || [];
        this.startTime = this._getTime(opts.startTime ?? now);
        this.resource = opts.resource;
        this.instrumentationScope = opts.scope;
        if (opts.attributes != null) this.setAttributes(opts.attributes);
        this._spanProcessor.onStart(this, opts.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $aLPFc.diag).warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!(0, $4b6df80d0fda7491$export$1daad3d2aacf48c5)(value)) {
            (0, $aLPFc.diag).warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        const { attributeCountLimit: attributeCountLimit } = this._spanLimits;
        if (attributeCountLimit !== undefined && Object.keys(this.attributes).length >= attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    }
    setAttributes(attributes) {
        for (const [k, v] of Object.entries(attributes))this.setAttribute(k, v);
        return this;
    }
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ addEvent(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        const { eventCountLimit: eventCountLimit } = this._spanLimits;
        if (eventCountLimit === 0) {
            (0, $aLPFc.diag).warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (eventCountLimit !== undefined && this.events.length >= eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $aLPFc.diag).debug('Dropping extra events.');
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $c767f1362e0cdd3e$export$a5e58227c317ebb9)(attributesOrStartTime)) {
            if (!(0, $c767f1362e0cdd3e$export$a5e58227c317ebb9)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        const attributes = (0, $4b6df80d0fda7491$export$b0663eba150d60c9)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    }
    addLink(link) {
        this.links.push(link);
        return this;
    }
    addLinks(links) {
        this.links.push(...links);
        return this;
    }
    setStatus(status) {
        if (this._isSpanEnded()) return this;
        this.status = {
            ...status
        };
        // When using try-catch, the caught "error" is of type `any`. When then assigning `any` to `status.message`,
        // TypeScript will not error. While this can happen during use of any API, it is more common on Span#setStatus()
        // as it's likely used in a catch-block. Therefore, we validate if `status.message` is actually a string, null, or
        // undefined to avoid an incorrect type causing issues downstream.
        if (this.status.message != null && typeof status.message !== 'string') {
            (0, $aLPFc.diag).warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
            delete this.status.message;
        }
        return this;
    }
    updateName(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    }
    end(endTime) {
        if (this._isSpanEnded()) {
            (0, $aLPFc.diag).error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = (0, $c767f1362e0cdd3e$export$b783ad6617389e3e)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $aLPFc.diag).warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $aLPFc.diag).warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
        this._spanProcessor.onEnd(this);
    }
    _getTime(inp) {
        if (typeof inp === 'number' && inp <= (0, $68898baf213d5344$export$b22daef4119238cd).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $c767f1362e0cdd3e$export$24b3f7dcd2848fa8)(inp + this._performanceOffset);
        if (typeof inp === 'number') return (0, $c767f1362e0cdd3e$export$e7ec5c82995537b1)(inp);
        if (inp instanceof Date) return (0, $c767f1362e0cdd3e$export$e7ec5c82995537b1)(inp.getTime());
        if ((0, $c767f1362e0cdd3e$export$390c59432f173a9f)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $c767f1362e0cdd3e$export$e7ec5c82995537b1)(Date.now());
        const msDuration = (0, $68898baf213d5344$export$b22daef4119238cd).now() - this._performanceStartTime;
        return (0, $c767f1362e0cdd3e$export$f07bb1dbc72184c3)(this.startTime, (0, $c767f1362e0cdd3e$export$e7ec5c82995537b1)(msDuration));
    }
    isRecording() {
        return this._ended === false;
    }
    recordException(exception, time) {
        const attributes = {};
        if (typeof exception === 'string') attributes[0, $bb466b14d7a34ad0$export$ab4513c1b55519b5] = exception;
        else if (exception) {
            if (exception.code) attributes[0, $bb466b14d7a34ad0$export$85da07cb5d867763] = exception.code.toString();
            else if (exception.name) attributes[0, $bb466b14d7a34ad0$export$85da07cb5d867763] = exception.name;
            if (exception.message) attributes[0, $bb466b14d7a34ad0$export$ab4513c1b55519b5] = exception.message;
            if (exception.stack) attributes[0, $bb466b14d7a34ad0$export$9b74e4928364b671] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, $bb466b14d7a34ad0$export$85da07cb5d867763] || attributes[0, $bb466b14d7a34ad0$export$ab4513c1b55519b5]) this.addEvent((0, $919ffd4294b16129$export$a0fff09a5370d06f), attributes, time);
        else (0, $aLPFc.diag).warn(`Failed to record an exception ${exception}`);
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            (0, $aLPFc.diag).warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
        }
        return this._ended;
    }
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    }
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ _truncateToSize(value) {
        const limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $aLPFc.diag).warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map((val)=>typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        // Other types, no need to apply value length limit
        return value;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("15v9P");
var $aLPFc = parcelRequire("aLPFc");

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $3e880b2920d30171$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($3e880b2920d30171$export$94df7a7a96a92f7b || ($3e880b2920d30171$export$94df7a7a96a92f7b = {}));


class $8cd19e6633cf8ff4$export$abc5f11618c4d6a3 {
    shouldSample() {
        return {
            decision: (0, $3e880b2920d30171$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return 'AlwaysOffSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $e25c61b98e057bd5$export$653f832afb4ffa27 {
    shouldSample() {
        return {
            decision: (0, $3e880b2920d30171$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED
        };
    }
    toString() {
        return 'AlwaysOnSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dStz2 = parcelRequire("dStz2");parcelRequire("15v9P");
var $j5ja1 = parcelRequire("j5ja1");
var $1iLvl = parcelRequire("1iLvl");



class $f269bea9cf16b3f7$export$2bc0b1b09c2e3b47 {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(config){
        this._root = config.root;
        if (!this._root) {
            (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new (0, $e25c61b98e057bd5$export$653f832afb4ffa27)();
        }
        this._remoteParentSampled = config.remoteParentSampled ?? new (0, $e25c61b98e057bd5$export$653f832afb4ffa27)();
        this._remoteParentNotSampled = config.remoteParentNotSampled ?? new (0, $8cd19e6633cf8ff4$export$abc5f11618c4d6a3)();
        this._localParentSampled = config.localParentSampled ?? new (0, $e25c61b98e057bd5$export$653f832afb4ffa27)();
        this._localParentNotSampled = config.localParentNotSampled ?? new (0, $8cd19e6633cf8ff4$export$abc5f11618c4d6a3)();
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const parentContext = (0, $j5ja1.trace).getSpanContext(context);
        if (!parentContext || !(0, $dStz2.isSpanContextValid)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $1iLvl.TraceFlags).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $1iLvl.TraceFlags).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dStz2 = parcelRequire("dStz2");

class $ae016ef76055c221$export$f1624f887f708bbf {
    _ratio;
    _upperBound;
    constructor(_ratio = 0){
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    shouldSample(context, traceId) {
        return {
            decision: (0, $dStz2.isValidTraceId)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $3e880b2920d30171$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED : (0, $3e880b2920d30171$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    }
    _accumulate(traceId) {
        let accumulation = 0;
        for(let i = 0; i < traceId.length / 8; i++){
            const pos = i * 8;
            const part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    }
}


var $25208f0f32813c0e$var$TracesSamplerValues;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($25208f0f32813c0e$var$TracesSamplerValues || ($25208f0f32813c0e$var$TracesSamplerValues = {}));
const $25208f0f32813c0e$var$DEFAULT_RATIO = 1;
function $25208f0f32813c0e$export$d25a2c2f78a5e968() {
    return {
        sampler: $25208f0f32813c0e$export$534308d7e73f0e71(),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? 128,
            linkCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_LINK_COUNT_LIMIT') ?? 128,
            eventCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_EVENT_COUNT_LIMIT') ?? 128,
            attributePerEventCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT') ?? 128,
            attributePerLinkCountLimit: (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT') ?? 128
        }
    };
}
function $25208f0f32813c0e$export$534308d7e73f0e71() {
    const sampler = (0, $5ed36a0392602b24$export$c1cd528968868329)('OTEL_TRACES_SAMPLER') ?? $25208f0f32813c0e$var$TracesSamplerValues.ParentBasedAlwaysOn;
    switch(sampler){
        case $25208f0f32813c0e$var$TracesSamplerValues.AlwaysOn:
            return new (0, $e25c61b98e057bd5$export$653f832afb4ffa27)();
        case $25208f0f32813c0e$var$TracesSamplerValues.AlwaysOff:
            return new (0, $8cd19e6633cf8ff4$export$abc5f11618c4d6a3)();
        case $25208f0f32813c0e$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new (0, $f269bea9cf16b3f7$export$2bc0b1b09c2e3b47)({
                root: new (0, $e25c61b98e057bd5$export$653f832afb4ffa27)()
            });
        case $25208f0f32813c0e$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new (0, $f269bea9cf16b3f7$export$2bc0b1b09c2e3b47)({
                root: new (0, $8cd19e6633cf8ff4$export$abc5f11618c4d6a3)()
            });
        case $25208f0f32813c0e$var$TracesSamplerValues.TraceIdRatio:
            return new (0, $ae016ef76055c221$export$f1624f887f708bbf)($25208f0f32813c0e$var$getSamplerProbabilityFromEnv());
        case $25208f0f32813c0e$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new (0, $f269bea9cf16b3f7$export$2bc0b1b09c2e3b47)({
                root: new (0, $ae016ef76055c221$export$f1624f887f708bbf)($25208f0f32813c0e$var$getSamplerProbabilityFromEnv())
            });
        default:
            (0, $aLPFc.diag).error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${$25208f0f32813c0e$var$TracesSamplerValues.ParentBasedAlwaysOn}".`);
            return new (0, $f269bea9cf16b3f7$export$2bc0b1b09c2e3b47)({
                root: new (0, $e25c61b98e057bd5$export$653f832afb4ffa27)()
            });
    }
}
function $25208f0f32813c0e$var$getSamplerProbabilityFromEnv() {
    const probability = (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_TRACES_SAMPLER_ARG');
    if (probability == null) {
        (0, $aLPFc.diag).error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${$25208f0f32813c0e$var$DEFAULT_RATIO}.`);
        return $25208f0f32813c0e$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $aLPFc.diag).error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${$25208f0f32813c0e$var$DEFAULT_RATIO}.`);
        return $25208f0f32813c0e$var$DEFAULT_RATIO;
    }
    return probability;
}



const $e87659f03fed82a3$export$6ad612be99f9ed48 = 128;
const $e87659f03fed82a3$export$d9446f3c1c12def1 = Infinity;
function $e87659f03fed82a3$export$7ec1ebcfa9d8bd6a(userConfig) {
    const perInstanceDefaults = {
        sampler: (0, $25208f0f32813c0e$export$534308d7e73f0e71)()
    };
    const DEFAULT_CONFIG = (0, $25208f0f32813c0e$export$d25a2c2f78a5e968)();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $e87659f03fed82a3$export$9f9fb435f8494555(userConfig) {
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = userConfig.spanLimits?.attributeCountLimit ?? userConfig.generalLimits?.attributeCountLimit ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? $e87659f03fed82a3$export$6ad612be99f9ed48;
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = userConfig.spanLimits?.attributeValueLengthLimit ?? userConfig.generalLimits?.attributeValueLengthLimit ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? (0, $5ed36a0392602b24$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? $e87659f03fed82a3$export$d9446f3c1c12def1;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $aaeeb0dbc4c3f9b3$var$SPAN_ID_BYTES = 8;
const $aaeeb0dbc4c3f9b3$var$TRACE_ID_BYTES = 16;
class $aaeeb0dbc4c3f9b3$export$97307207ef48da75 {
    /**
     * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
     * characters corresponding to 128 bits.
     */ generateTraceId = $aaeeb0dbc4c3f9b3$var$getIdGenerator($aaeeb0dbc4c3f9b3$var$TRACE_ID_BYTES);
    /**
     * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
     * characters corresponding to 64 bits.
     */ generateSpanId = $aaeeb0dbc4c3f9b3$var$getIdGenerator($aaeeb0dbc4c3f9b3$var$SPAN_ID_BYTES);
}
const $aaeeb0dbc4c3f9b3$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $aaeeb0dbc4c3f9b3$var$getIdGenerator(bytes) {
    return function generateId() {
        for(let i = 0; i < bytes * 2; i++){
            $aaeeb0dbc4c3f9b3$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if ($aaeeb0dbc4c3f9b3$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $aaeeb0dbc4c3f9b3$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $aaeeb0dbc4c3f9b3$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}


class $2d0d7707555fd1ef$export$c4b9363e2fc65361 {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    /**
     * Constructs a new Tracer instance.
     */ constructor(instrumentationScope, config, resource, spanProcessor){
        const localConfig = (0, $e87659f03fed82a3$export$7ec1ebcfa9d8bd6a)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $aaeeb0dbc4c3f9b3$export$97307207ef48da75)();
        this._resource = resource;
        this._spanProcessor = spanProcessor;
        this.instrumentationScope = instrumentationScope;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ startSpan(name, options = {}, context = $3rgEx.context.active()) {
        // remove span from context in case a root span is requested via options
        if (options.root) context = $j5ja1.trace.deleteSpan(context);
        const parentSpan = $j5ja1.trace.getSpan(context);
        if ((0, $8cf02d28c127a3b0$export$7d5f2376f7cf513)(context)) {
            $aLPFc.diag.debug('Instrumentation suppressed, returning Noop Span');
            const nonRecordingSpan = $j5ja1.trace.wrapSpanContext($2aArX.INVALID_SPAN_CONTEXT);
            return nonRecordingSpan;
        }
        const parentSpanContext = parentSpan?.spanContext();
        const spanId = this._idGenerator.generateSpanId();
        let validParentSpanContext;
        let traceId;
        let traceState;
        if (!parentSpanContext || !$j5ja1.trace.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            validParentSpanContext = parentSpanContext;
        }
        const spanKind = options.kind ?? $hbJhQ.SpanKind.INTERNAL;
        const links = (options.links ?? []).map((link)=>{
            return {
                context: link.context,
                attributes: (0, $4b6df80d0fda7491$export$b0663eba150d60c9)(link.attributes)
            };
        });
        const attributes = (0, $4b6df80d0fda7491$export$b0663eba150d60c9)(options.attributes);
        // make sampling decision
        const samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = samplingResult.traceState ?? traceState;
        const traceFlags = samplingResult.decision === $83b23.SamplingDecision.RECORD_AND_SAMPLED ? $1iLvl.TraceFlags.SAMPLED : $1iLvl.TraceFlags.NONE;
        const spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $83b23.SamplingDecision.NOT_RECORD) {
            $aLPFc.diag.debug('Recording is off, propagating context in a non-recording span');
            const nonRecordingSpan = $j5ja1.trace.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        const initAttributes = (0, $4b6df80d0fda7491$export$b0663eba150d60c9)(Object.assign(attributes, samplingResult.attributes));
        const span = new (0, $cea0dae0ecce5f21$export$7b15d0c2dba75760)({
            resource: this._resource,
            scope: this.instrumentationScope,
            context: context,
            spanContext: spanContext,
            name: name,
            kind: spanKind,
            links: links,
            parentSpanContext: validParentSpanContext,
            attributes: initAttributes,
            startTime: options.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits
        });
        return span;
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx ?? $3rgEx.context.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = $j5ja1.trace.setSpan(parentContext, span);
        return $3rgEx.context.with(contextWithSpanSet, fn, undefined, span);
    }
    /** Returns the active {@link GeneralLimits}. */ getGeneralLimits() {
        return this._generalLimits;
    }
    /** Returns the active {@link SpanLimits}. */ getSpanLimits() {
        return this._spanLimits;
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $6dc7fc6d882ab8a5$export$3012fe5a49154394 {
    _spanProcessors;
    constructor(_spanProcessors){
        this._spanProcessors = _spanProcessors;
    }
    forceFlush() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.forceFlush());
        return new Promise((resolve)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }).catch((error)=>{
                (0, $fd2ddffad4c94da7$export$54c6946fc34b7cc2)(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    }
    onStart(span, context) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onStart(span, context);
    }
    onEnd(span) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onEnd(span);
    }
    shutdown() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.shutdown());
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }, reject);
        });
    }
}



var $e0c66daea5d876f8$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($e0c66daea5d876f8$export$11a85395fcf5a7f0 || ($e0c66daea5d876f8$export$11a85395fcf5a7f0 = {}));
class $e0c66daea5d876f8$export$1f2f0f67f5ecff3b {
    _config;
    _tracers = new Map();
    _resource;
    _activeSpanProcessor;
    constructor(config = {}){
        const mergedConfig = (0, $2d4910c9b5a4c06a$export$4950aa0f605343fb)({}, (0, $25208f0f32813c0e$export$d25a2c2f78a5e968)(), (0, $e87659f03fed82a3$export$9f9fb435f8494555)(config));
        this._resource = mergedConfig.resource ?? (0, $98f21beccee030f6$export$522a862cad1b0abc)();
        this._config = Object.assign({}, mergedConfig, {
            resource: this._resource
        });
        const spanProcessors = [];
        if (config.spanProcessors?.length) spanProcessors.push(...config.spanProcessors);
        this._activeSpanProcessor = new (0, $6dc7fc6d882ab8a5$export$3012fe5a49154394)(spanProcessors);
    }
    getTracer(name, version, options) {
        const key = `${name}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $2d0d7707555fd1ef$export$c4b9363e2fc65361)({
            name: name,
            version: version,
            schemaUrl: options?.schemaUrl
        }, this._config, this._resource, this._activeSpanProcessor));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    }
    forceFlush() {
        const timeout = this._config.forceFlushTimeoutMillis;
        const promises = this._activeSpanProcessor['_spanProcessors'].map((spanProcessor)=>{
            return new Promise((resolve)=>{
                let state;
                const timeoutInterval = setTimeout(()=>{
                    resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                    state = $e0c66daea5d876f8$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(()=>{
                    clearTimeout(timeoutInterval);
                    if (state !== $e0c66daea5d876f8$export$11a85395fcf5a7f0.timeout) {
                        state = $e0c66daea5d876f8$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch((error)=>{
                    clearTimeout(timeoutInterval);
                    state = $e0c66daea5d876f8$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then((results)=>{
                const errors = results.filter((result)=>result !== $e0c66daea5d876f8$export$11a85395fcf5a7f0.resolved);
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch((error)=>reject([
                    error
                ]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fJacQ = parcelRequire("fJacQ");
class $c7044600db971a73$export$3dfe62dd209faf13 {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Keeps the reference to current context
     */ _currentContext = (0, $fJacQ.ROOT_CONTEXT);
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $fJacQ.ROOT_CONTEXT), target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * Returns the active context
     */ active() {
        return this._currentContext;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears the current context)
     */ disable() {
        this._currentContext = (0, $fJacQ.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $fJacQ.ROOT_CONTEXT);
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $fJacQ.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
}


parcelRequire("15v9P");
var $3rgEx = parcelRequire("3rgEx");
var $iN5wJ = parcelRequire("iN5wJ");
var $j5ja1 = parcelRequire("j5ja1");

function $8358be86bd79fe73$var$setupContextManager(contextManager) {
    // null means 'do not register'
    if (contextManager === null) return;
    // undefined means 'register default'
    if (contextManager === undefined) {
        const defaultContextManager = new (0, $c7044600db971a73$export$3dfe62dd209faf13)();
        defaultContextManager.enable();
        (0, $3rgEx.context).setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    (0, $3rgEx.context).setGlobalContextManager(contextManager);
}
function $8358be86bd79fe73$var$setupPropagator(propagator) {
    // null means 'do not register'
    if (propagator === null) return;
    // undefined means 'register default'
    if (propagator === undefined) {
        (0, $iN5wJ.propagation).setGlobalPropagator(new (0, $3f3da7459cebbc03$export$4beb26f46770357f)({
            propagators: [
                new (0, $2450f906c37cbc2d$export$737c747d043a1f7b)(),
                new (0, $f2954aac21ca826d$export$604bcc7f2bff6bb)()
            ]
        }));
        return;
    }
    (0, $iN5wJ.propagation).setGlobalPropagator(propagator);
}
class $8358be86bd79fe73$export$a785009afeee3453 extends (0, $e0c66daea5d876f8$export$1f2f0f67f5ecff3b) {
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ constructor(config = {}){
        super(config);
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ register(config = {}) {
        (0, $j5ja1.trace).setGlobalTracerProvider(this);
        $8358be86bd79fe73$var$setupPropagator(config.propagator);
        $8358be86bd79fe73$var$setupContextManager(config.contextManager);
    }
}



let $7f8e6f5dc962e0e1$var$isInitialized = false;
let $7f8e6f5dc962e0e1$var$traceProvider = null;
let $7f8e6f5dc962e0e1$var$loggerProvider = null;
function $7f8e6f5dc962e0e1$export$ddb438a168ec5ead(options = {}) {
    if ($7f8e6f5dc962e0e1$var$isAlreadyInitialized()) return false;
    $7f8e6f5dc962e0e1$var$markAsInitialized();
    const config = $7f8e6f5dc962e0e1$var$resolveConfiguration(options);
    $7f8e6f5dc962e0e1$var$logInitializationStart(config);
    try {
        const resource = $7f8e6f5dc962e0e1$var$createSharedResource(config);
        const commonHeaders = $7f8e6f5dc962e0e1$var$createCommonHeaders();
        $7f8e6f5dc962e0e1$var$initializeTracing(resource, config, commonHeaders);
        $7f8e6f5dc962e0e1$var$initializeLogging(resource, config, commonHeaders);
        $7f8e6f5dc962e0e1$var$setupAutoFlush(config.debug);
        $7f8e6f5dc962e0e1$var$logInitializationSuccess(config);
        return true;
    } catch (error) {
        $7f8e6f5dc962e0e1$var$logInitializationError(error);
        $7f8e6f5dc962e0e1$var$isInitialized = false;
        return false;
    }
}
function $7f8e6f5dc962e0e1$var$isAlreadyInitialized() {
    if ($7f8e6f5dc962e0e1$var$isInitialized) {
        console.warn('OpenTelemetry already initialized. Skipping re-initialization.');
        return true;
    }
    return false;
}
function $7f8e6f5dc962e0e1$var$markAsInitialized() {
    $7f8e6f5dc962e0e1$var$isInitialized = true;
}
function $7f8e6f5dc962e0e1$var$resolveConfiguration(options) {
    return {
        serviceName: options.serviceName ?? 'docs-frontend',
        serviceVersion: options.serviceVersion ?? '1.0.0',
        deploymentEnvironment: $7f8e6f5dc962e0e1$var$detectEnvironment(),
        baseUrl: options.baseUrl ?? window.location.origin,
        debug: options.debug ?? false
    };
}
function $7f8e6f5dc962e0e1$var$logInitializationStart(config) {
    if (config.debug) // eslint-disable-next-line no-console
    console.log('[OTEL] Initializing OpenTelemetry with config:', config);
}
function $7f8e6f5dc962e0e1$var$createSharedResource(config) {
    const resourceAttributes = {
        [(0, $bb466b14d7a34ad0$export$84187ab40ae4fa9c)]: config.serviceName,
        [(0, $bb466b14d7a34ad0$export$262ef07bab967f36)]: config.serviceVersion,
        ['deployment.environment']: config.deploymentEnvironment,
        ['service.language.name']: 'javascript'
    };
    // Merge with default resource to preserve telemetry.sdk.* attributes
    return (0, $98f21beccee030f6$export$522a862cad1b0abc)().merge((0, $98f21beccee030f6$export$bb0fe4e7060febbf)(resourceAttributes));
}
function $7f8e6f5dc962e0e1$var$createCommonHeaders() {
    return {
        'X-Docs-Session': 'active'
    };
}
function $7f8e6f5dc962e0e1$var$initializeTracing(resource, config, commonHeaders) {
    const traceExporter = new (0, $d5a0bc2c3d7e3b03$export$f73dc942b4b27de3)({
        url: `${config.baseUrl}/_api/v1/o/t`,
        headers: {
            ...commonHeaders
        }
    });
    const spanProcessor = new (0, $a2aefef0c0da04ad$export$237547059fd543f9)(traceExporter);
    const euidProcessor = new $7f8e6f5dc962e0e1$var$EuidSpanProcessor();
    $7f8e6f5dc962e0e1$var$traceProvider = new (0, $8358be86bd79fe73$export$a785009afeee3453)({
        resource: resource,
        spanProcessors: [
            euidProcessor,
            spanProcessor
        ]
    });
    $7f8e6f5dc962e0e1$var$traceProvider.register({
        contextManager: new (0, $20fe425914a301d6$export$148434e42b84e81c)(),
        propagator: new (0, $2450f906c37cbc2d$export$737c747d043a1f7b)()
    });
    $7f8e6f5dc962e0e1$var$registerFetchInstrumentation();
}
function $7f8e6f5dc962e0e1$var$registerFetchInstrumentation() {
    (0, $77ba9ebe7755d8be$export$fc0a1ca5231d826a)({
        instrumentations: [
            new (0, $f2616c48e892e2a9$export$f922a490458c98a8)({
                propagateTraceHeaderCorsUrls: [
                    new RegExp(`${window.location.origin}/.*`)
                ],
                ignoreUrls: [
                    /_api\/v1\/o\/.*/,
                    /_api\/v1\/?$/,
                    /__parcel_code_frame$/
                ]
            })
        ]
    });
}
function $7f8e6f5dc962e0e1$var$initializeLogging(resource, config, commonHeaders) {
    const logExporter = new (0, $d41d2e50903aaf6a$export$acc219307c108b42)({
        url: `${config.baseUrl}/_api/v1/o/l`,
        headers: {
            ...commonHeaders
        }
    });
    const logProcessor = new (0, $833be4621bb390b5$export$d6c3e5cb1a84420b)(logExporter);
    $7f8e6f5dc962e0e1$var$loggerProvider = new (0, $17cb3e2e868b808c$export$23fb4edab0a7f904)({
        resource: resource,
        processors: [
            logProcessor
        ]
    });
    (0, $6DjHV.logs).setGlobalLoggerProvider($7f8e6f5dc962e0e1$var$loggerProvider);
}
function $7f8e6f5dc962e0e1$var$setupAutoFlush(debug = false) {
    let isFlushing = false;
    const performFlush = async ()=>{
        if (isFlushing || !$7f8e6f5dc962e0e1$var$isInitialized) return;
        isFlushing = true;
        if (debug) // eslint-disable-next-line no-console
        console.log('[OTEL] Auto-flushing telemetry (visibilitychange or pagehide)');
        try {
            await $7f8e6f5dc962e0e1$var$flushTelemetry();
        } catch (error) {
            if (debug) console.warn('[OTEL] Error during auto-flush:', error);
        } finally{
            isFlushing = false;
        }
    };
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'hidden') performFlush();
    });
    window.addEventListener('pagehide', performFlush);
    if (debug) {
        // eslint-disable-next-line no-console
        console.log('[OTEL] Auto-flush event listeners registered');
        // eslint-disable-next-line no-console
        console.log('[OTEL] Using OTLP HTTP exporters with keepalive for guaranteed delivery');
    }
}
async function $7f8e6f5dc962e0e1$var$flushTelemetry(timeoutMs = 1000) {
    if (!$7f8e6f5dc962e0e1$var$isInitialized) return;
    const flushPromises = [];
    if ($7f8e6f5dc962e0e1$var$traceProvider) flushPromises.push($7f8e6f5dc962e0e1$var$traceProvider.forceFlush().catch((err)=>{
        console.warn('[OTEL] Failed to flush traces:', err);
    }));
    if ($7f8e6f5dc962e0e1$var$loggerProvider) flushPromises.push($7f8e6f5dc962e0e1$var$loggerProvider.forceFlush().catch((err)=>{
        console.warn('[OTEL] Failed to flush logs:', err);
    }));
    await Promise.race([
        Promise.all(flushPromises),
        new Promise((resolve)=>setTimeout(resolve, timeoutMs))
    ]);
}
function $7f8e6f5dc962e0e1$var$logInitializationSuccess(config) {
    if (config.debug) // eslint-disable-next-line no-console
    console.log('[OTEL] OpenTelemetry initialized successfully', {
        serviceName: config.serviceName,
        serviceVersion: config.serviceVersion,
        deploymentEnvironment: config.deploymentEnvironment,
        traceEndpoint: `${config.baseUrl}/_api/v1/o/t`,
        logEndpoint: `${config.baseUrl}/_api/v1/o/l`,
        autoFlushOnUnload: true
    });
}
function $7f8e6f5dc962e0e1$var$logInitializationError(error) {
    console.error('[OTEL] Failed to initialize OpenTelemetry:', error);
}
function $7f8e6f5dc962e0e1$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
}
class $7f8e6f5dc962e0e1$var$EuidSpanProcessor {
    onStart(span) {
        const euid = $7f8e6f5dc962e0e1$var$getCookie('euid');
        if (euid) span.setAttribute('user.euid', euid);
    }
    onEnd() {}
    shutdown() {
        return Promise.resolve();
    }
    forceFlush() {
        return Promise.resolve();
    }
}
/**
 * Detects the deployment environment from the hostname at runtime.
 *
 * Since the JavaScript is pre-built and bundled into docs-builder CLI,
 * we detect the environment purely from the runtime hostname in the browser.
 */ function $7f8e6f5dc962e0e1$var$detectEnvironment() {
    const hostname = window.location.hostname;
    switch(hostname){
        case 'www.elastic.co':
        case 'elastic.co':
            return 'prod';
        case 'staging-website.elastic.co':
            return 'staging';
        case 'd34ipnu52o64md.cloudfront.net':
            return 'edge';
        case 'localhost':
        case '127.0.0.1':
            return 'local';
        default:
            return 'unknown';
    }
}



var $iW1oU = parcelRequire("iW1oU");
// 34 is the height of the header + some padding
// 4 is the base spacing unit
const $6b0015b9256b446f$var$HEADING_OFFSET = 136;
function $6b0015b9256b446f$var$initializeTocElements() {
    const headings = (0, $iW1oU.$$)('#markdown-content h2, #markdown-content h3');
    const tocLinks = (0, $iW1oU.$$)('#toc-nav li>a');
    const tocContainer = (0, $iW1oU.$)('#toc-nav .toc-progress-container');
    const progressIndicator = (0, $iW1oU.$)('.toc-progress-indicator', tocContainer);
    return {
        headings: headings,
        tocLinks: tocLinks,
        tocContainer: tocContainer,
        progressIndicator: progressIndicator
    };
}
// Find the current TOC links based on visible headings
// It can return multiple links because headings in a tab can have the same position
function $6b0015b9256b446f$var$findCurrentTocLinks(elements) {
    let currentTocLinks = [];
    let currentTop = null;
    for (const heading of elements.headings){
        const rect = heading.getBoundingClientRect();
        if (rect.top <= $6b0015b9256b446f$var$HEADING_OFFSET) {
            if (currentTop !== null && Math.abs(rect.top - currentTop) > 1) currentTocLinks = [];
            currentTop = rect.top;
            const foundLink = elements.tocLinks.find((link)=>link.getAttribute('href') === `#${heading.closest('.heading-wrapper')?.id}`);
            if (foundLink) currentTocLinks.push(foundLink);
        }
    }
    return currentTocLinks;
}
// Get visible headings in viewport
function $6b0015b9256b446f$var$getVisibleHeadings(elements) {
    return elements.headings.filter((heading)=>{
        const rect = heading.getBoundingClientRect();
        return rect.top - $6b0015b9256b446f$var$HEADING_OFFSET + 64 >= 0 && rect.top <= window.innerHeight;
    });
}
// If the user has scrolled to the bottom of the page,
// and there are still multiple headings visible, we need to
// handle the progress indicator differently.
// In this case it sets the indicator for all visible headings.
function $6b0015b9256b446f$var$handleBottomScroll(elements) {
    const visibleHeadings = $6b0015b9256b446f$var$getVisibleHeadings(elements);
    if (visibleHeadings.length === 0) return;
    const firstHeading = visibleHeadings[0];
    const lastHeading = visibleHeadings[visibleHeadings.length - 1];
    const firstLink = elements.tocLinks.find((link)=>link.getAttribute('href') === `#${firstHeading.parentElement?.id}`)?.closest('li');
    const lastLink = elements.tocLinks.find((link)=>link.getAttribute('href') === `#${lastHeading.parentElement?.id}`)?.closest('li');
    if (firstLink && lastLink && elements.tocContainer) {
        const tocRect = elements.tocContainer.getBoundingClientRect();
        const firstRect = firstLink.getBoundingClientRect();
        const lastRect = lastLink.getBoundingClientRect();
        $6b0015b9256b446f$var$updateProgressIndicatorPosition(elements.progressIndicator, firstRect.top - tocRect.top, lastRect.top + lastRect.height - firstRect.top);
    }
}
function $6b0015b9256b446f$var$updateProgressIndicatorPosition(indicator, top, height) {
    indicator.style.top = `${top}px`;
    indicator.style.height = `${height}px`;
}
function $6b0015b9256b446f$var$updateIndicator(elements) {
    if (!elements.tocContainer) return;
    const isAtBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 10;
    const currentTocLinks = $6b0015b9256b446f$var$findCurrentTocLinks(elements);
    if (isAtBottom) $6b0015b9256b446f$var$handleBottomScroll(elements);
    else if (currentTocLinks.length > 0) {
        const tocRect = elements.tocContainer.getBoundingClientRect();
        const linkElements = currentTocLinks.map((link)=>link.closest('li')).filter((li)=>li !== null);
        if (linkElements.length === 0) return;
        const firstLinkRect = linkElements[0].getBoundingClientRect();
        const lastLinkRect = linkElements[linkElements.length - 1].getBoundingClientRect();
        $6b0015b9256b446f$var$updateProgressIndicatorPosition(elements.progressIndicator, firstLinkRect.top - tocRect.top, lastLinkRect.top + lastLinkRect.height - firstLinkRect.top);
    }
}
function $6b0015b9256b446f$var$setupSmoothScrolling(elements) {
    elements.tocLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const href = link.getAttribute('href');
            if (href?.charAt(0) === '#') {
                const target = document.getElementById(href.slice(1));
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                    history.pushState(null, '', href);
                }
            }
        });
    });
}
function $6b0015b9256b446f$export$770b3efc01f13311() {
    const elements = $6b0015b9256b446f$var$initializeTocElements();
    if (elements.progressIndicator != null) {
        elements.progressIndicator.style.height = '0';
        elements.progressIndicator.style.top = '0';
    }
    const update = ()=>$6b0015b9256b446f$var$updateIndicator(elements);
    update();
    window.addEventListener('scroll', update, {
        passive: true
    });
    window.addEventListener('resize', update, {
        passive: true
    });
    $6b0015b9256b446f$var$setupSmoothScrolling(elements);
}



var $hJ2SO = parcelRequire("hJ2SO");
//==========================================================
// head-support.js
//
// An extension to add head tag merging.
//==========================================================
(function() {
    var api = null;
    function log() {
    //console.log(arguments);
    }
    function mergeHead(newContent, defaultMergeStrategy) {
        if (newContent && newContent.indexOf('<head') > -1) {
            const htmlDoc = document.createElement("html");
            // remove svgs to avoid conflicts
            var contentWithSvgsRemoved = newContent.replace(/<svg(\s[^>]*>|>)([\s\S]*?)<\/svg>/gim, '');
            // extract head tag
            var headTag = contentWithSvgsRemoved.match(/(<head(\s[^>]*>|>)([\s\S]*?)<\/head>)/im);
            // if the  head tag exists...
            if (headTag) {
                var added = [];
                var removed = [];
                var preserved = [];
                var nodesToAppend = [];
                htmlDoc.innerHTML = headTag;
                var newHeadTag = htmlDoc.querySelector("head");
                var currentHead = document.head;
                if (newHeadTag == null) return;
                else {
                    // put all new head elements into a Map, by their outerHTML
                    var srcToNewHeadNodes = new Map();
                    for (const newHeadChild of newHeadTag.children)srcToNewHeadNodes.set(newHeadChild.outerHTML, newHeadChild);
                }
                // determine merge strategy
                var mergeStrategy = api.getAttributeValue(newHeadTag, "hx-head") || defaultMergeStrategy;
                // get the current head
                for (const currentHeadElt of currentHead.children){
                    // If the current head element is in the map
                    var inNewContent = srcToNewHeadNodes.has(currentHeadElt.outerHTML);
                    var isReAppended = currentHeadElt.getAttribute("hx-head") === "re-eval";
                    var isPreserved = api.getAttributeValue(currentHeadElt, "hx-preserve") === "true";
                    if (inNewContent || isPreserved) {
                        if (isReAppended) // remove the current version and let the new version replace it and re-execute
                        removed.push(currentHeadElt);
                        else {
                            // this element already exists and should not be re-appended, so remove it from
                            // the new content map, preserving it in the DOM
                            srcToNewHeadNodes.delete(currentHeadElt.outerHTML);
                            preserved.push(currentHeadElt);
                        }
                    } else {
                        if (mergeStrategy === "append") // we are appending and this existing element is not new content
                        // so if and only if it is marked for re-append do we do anything
                        {
                            if (isReAppended) {
                                removed.push(currentHeadElt);
                                nodesToAppend.push(currentHeadElt);
                            }
                        } else // if this is a merge, we remove this content since it is not in the new head
                        if (api.triggerEvent(document.body, "htmx:removingHeadElement", {
                            headElement: currentHeadElt
                        }) !== false) removed.push(currentHeadElt);
                    }
                }
                // Push the tremaining new head elements in the Map into the
                // nodes to append to the head tag
                nodesToAppend.push(...srcToNewHeadNodes.values());
                log("to append: ", nodesToAppend);
                for (const newNode of nodesToAppend){
                    log("adding: ", newNode);
                    var newElt = document.createRange().createContextualFragment(newNode.outerHTML);
                    log(newElt);
                    if (api.triggerEvent(document.body, "htmx:addingHeadElement", {
                        headElement: newElt
                    }) !== false) {
                        currentHead.appendChild(newElt);
                        added.push(newElt);
                    }
                }
                // remove all removed elements, after we have appended the new elements to avoid
                // additional network requests for things like style sheets
                for (const removedElement of removed)if (api.triggerEvent(document.body, "htmx:removingHeadElement", {
                    headElement: removedElement
                }) !== false) currentHead.removeChild(removedElement);
                api.triggerEvent(document.body, "htmx:afterHeadMerge", {
                    added: added,
                    kept: preserved,
                    removed: removed
                });
            }
        }
    }
    (0, $hJ2SO.default).defineExtension("head-support", {
        init: function(apiRef) {
            // store a reference to the internal API.
            api = apiRef;
            (0, $hJ2SO.default).on('htmx:afterSwap', function(evt) {
                let xhr = evt.detail.xhr;
                if (xhr) {
                    var serverResponse = xhr.response;
                    if (api.triggerEvent(document.body, "htmx:beforeHeadMerge", evt.detail)) mergeHead(serverResponse, evt.detail.boosted ? "merge" : "append");
                }
            });
            (0, $hJ2SO.default).on('htmx:historyRestore', function(evt) {
                if (api.triggerEvent(document.body, "htmx:beforeHeadMerge", evt.detail)) {
                    if (evt.detail.cacheMiss) mergeHead(evt.detail.serverResponse, "merge");
                    else mergeHead(evt.detail.item.head, "merge");
                }
            });
            (0, $hJ2SO.default).on('htmx:historyItemCreated', function(evt) {
                var historyItem = evt.detail.item;
                historyItem.head = document.head.outerHTML;
            });
        }
    });
})();



var $hJ2SO = parcelRequire("hJ2SO");
(function() {
    /**
   * This adds the "preload" extension to htmx. The extension will 
    * preload the targets of elements with "preload" attribute if:
    * - they also have `href`, `hx-get` or `data-hx-get` attributes
    * - they are radio buttons, checkboxes, select elements and submit
    *   buttons of forms with `method="get"` or `hx-get` attributes
    * The extension relies on browser cache and for it to work
    * server response must include `Cache-Control` header
    * e.g. `Cache-Control: private, max-age=60`.
    * For more details @see https://htmx.org/extensions/preload/
  */ (0, $hJ2SO.default).defineExtension('preload', {
        onEvent: function(name, event) {
            // Process preload attributes on `htmx:afterProcessNode`
            if (name === 'htmx:afterProcessNode') {
                // Initialize all nodes with `preload` attribute
                const parent = event.target || event.detail.elt;
                const preloadNodes = [
                    ...parent.hasAttribute("preload") ? [
                        parent
                    ] : [],
                    ...parent.querySelectorAll("[preload]")
                ];
                preloadNodes.forEach(function(node) {
                    // Initialize the node with the `preload` attribute
                    init(node);
                    // Initialize all child elements which has
                    // `href`, `hx-get` or `data-hx-get` attributes
                    node.querySelectorAll('[href],[hx-get],[data-hx-get]').forEach(init);
                });
                return;
            }
            // Intercept HTMX preload requests on `htmx:beforeRequest` and
            // send them as XHR requests instead to avoid side-effects,
            // such as showing loading indicators while preloading data. 
            if (name === 'htmx:beforeRequest') {
                const requestHeaders = event.detail.requestConfig.headers;
                if (!("HX-Preloaded" in requestHeaders && requestHeaders["HX-Preloaded"] === "true")) return;
                event.preventDefault();
                // Reuse XHR created by HTMX with replaced callbacks
                const xhr = event.detail.xhr;
                xhr.onload = function() {
                    processResponse(event.detail.elt, xhr.responseText);
                };
                xhr.onerror = null;
                xhr.onabort = null;
                xhr.ontimeout = null;
                xhr.send();
            }
        }
    });
    /**
   * Initialize `node`, set up event handlers based on own or inherited
   * `preload` attributes and set `node.preloadState` to `READY`.
   * 
   * `node.preloadState` can have these values:
   * - `READY` - event handlers have been set up and node is ready to preload
   * - `TIMEOUT` - a triggering event has been fired, but `node` is not
   *   yet being loaded because some time need to pass first e.g. user
   *   has to keep hovering over an element for 100ms for preload to start
   * - `LOADING` means that `node` is in the process of being preloaded
   * - `DONE` means that the preloading process is complete and `node`
   *    doesn't need a repeated preload (indicated by preload="always")
   * @param {Node} node
   */ function init(node) {
        // Guarantee that each node is initialized only once
        if (node.preloadState !== undefined) return;
        if (!isValidNodeForPreloading(node)) return;
        // Initialize form element preloading
        if (node instanceof HTMLFormElement) {
            const form = node;
            // Only initialize forms with `method="get"` or `hx-get` attributes
            if (!(form.hasAttribute('method') && form.method === 'get' || form.hasAttribute('hx-get') || form.hasAttribute('hx-data-get'))) return;
            for(let i = 0; i < form.elements.length; i++){
                const element = form.elements.item(i);
                init(element);
                if ("labels" in element) element.labels.forEach(init);
            }
            return;
        }
        // Process node configuration from preload attribute
        let preloadAttr = getClosestAttribute(node, 'preload');
        node.preloadAlways = preloadAttr && preloadAttr.includes('always');
        if (node.preloadAlways) preloadAttr = preloadAttr.replace('always', '').trim();
        let triggerEventName = preloadAttr || 'mousedown';
        // Set up event handlers listening for triggering events
        const needsTimeout = triggerEventName === 'mouseover';
        node.addEventListener(triggerEventName, getEventHandler(node, needsTimeout), {
            passive: true
        });
        // Add `touchstart` listener for touchscreen support
        // if `mousedown` or `mouseover` is used
        if (triggerEventName === 'mousedown' || triggerEventName === 'mouseover') node.addEventListener('touchstart', getEventHandler(node), {
            passive: true
        });
        // If `mouseover` is used, set up `mouseout` listener,
        // which will abort preloading if user moves mouse outside
        // the element in less than 100ms after hovering over it
        if (triggerEventName === 'mouseover') node.addEventListener('mouseout', function(evt) {
            if (evt.target === node && node.preloadState === 'TIMEOUT') node.preloadState = 'READY';
        }, {
            passive: true
        });
        // Mark the node as ready to be preloaded
        node.preloadState = 'READY';
        // This event can be used to load content immediately
        (0, $hJ2SO.default).trigger(node, 'preload:init');
    }
    /**
   * Return event handler which can be called by event listener to start
   * the preloading process of `node` with or without a timeout
   * @param {Node} node 
   * @param {boolean=} needsTimeout 
   * @returns {function(): void}
   */ function getEventHandler(node, needsTimeout = false) {
        return function() {
            // Do not preload uninitialized nodes, nodes which are in process
            // of being preloaded or have been preloaded and don't need repeat
            if (node.preloadState !== 'READY') return;
            if (needsTimeout) {
                node.preloadState = 'TIMEOUT';
                const timeoutMs = 100;
                window.setTimeout(function() {
                    if (node.preloadState === 'TIMEOUT') {
                        node.preloadState = 'READY';
                        load(node);
                    }
                }, timeoutMs);
                return;
            }
            load(node);
        };
    }
    /**
   * Preload the target of node, which can be:
   *  - hx-get or data-hx-get attribute
   *  - href or form action attribute
   * @param {Node} node 
   */ function load(node) {
        // Do not preload uninitialized nodes, nodes which are in process
        // of being preloaded or have been preloaded and don't need repeat
        if (node.preloadState !== 'READY') return;
        node.preloadState = 'LOADING';
        // Load nodes with `hx-get` or `data-hx-get` attribute
        // Forms don't reach this because only their elements are initialized
        const hxGet = node.getAttribute('hx-get') || node.getAttribute('data-hx-get');
        if (hxGet) {
            sendHxGetRequest(hxGet, node);
            return;
        }
        // Load nodes with `href` attribute
        const hxBoost = getClosestAttribute(node, "hx-boost") === "true";
        if (node.hasAttribute('href')) {
            const url = node.getAttribute('href');
            if (hxBoost) sendHxGetRequest(url, node);
            else sendXmlGetRequest(url, node);
            return;
        }
        // Load form elements
        if (isPreloadableFormElement(node)) {
            const url = node.form.getAttribute('action') || node.form.getAttribute('hx-get') || node.form.getAttribute('data-hx-get');
            const formData = (0, $hJ2SO.default).values(node.form);
            const isStandardForm = !(node.form.getAttribute('hx-get') || node.form.getAttribute('data-hx-get') || hxBoost);
            const sendGetRequest = isStandardForm ? sendXmlGetRequest : sendHxGetRequest;
            // submit button
            if (node.type === 'submit') {
                sendGetRequest(url, node.form, formData);
                return;
            }
            // select
            const inputName = node.name || node.control.name;
            if (node.tagName === 'SELECT') {
                Array.from(node.options).forEach((option)=>{
                    if (option.selected) return;
                    formData.set(inputName, option.value);
                    const formDataOrdered = forceFormDataInOrder(node.form, formData);
                    sendGetRequest(url, node.form, formDataOrdered);
                });
                return;
            }
            // radio and checkbox
            const inputType = node.getAttribute("type") || node.control.getAttribute("type");
            const nodeValue = node.value || node.control?.value;
            if (inputType === 'radio') formData.set(inputName, nodeValue);
            else if (inputType === 'checkbox') {
                const inputValues = formData.getAll(inputName);
                if (inputValues.includes(nodeValue)) formData[inputName] = inputValues.filter((value)=>value !== nodeValue);
                else formData.append(inputName, nodeValue);
            }
            const formDataOrdered = forceFormDataInOrder(node.form, formData);
            sendGetRequest(url, node.form, formDataOrdered);
            return;
        }
    }
    /**
   * Force formData values to be in the order of form elements.
   * This is useful to apply after alternating formData values
   * and before passing them to a HTTP request because cache is
   * sensitive to GET parameter order e.g., cached `/link?a=1&b=2`
   * will not be used for `/link?b=2&a=1`.
   * @param {HTMLFormElement} form 
   * @param {FormData} formData 
   * @returns {FormData}
   */ function forceFormDataInOrder(form, formData) {
        const formElements = form.elements;
        const orderedFormData = new FormData();
        for(let i = 0; i < formElements.length; i++){
            const element = formElements.item(i);
            if (formData.has(element.name) && element.tagName === 'SELECT') {
                orderedFormData.append(element.name, formData.get(element.name));
                continue;
            }
            if (formData.has(element.name) && formData.getAll(element.name).includes(element.value)) orderedFormData.append(element.name, element.value);
        }
        return orderedFormData;
    }
    /**
   * Send GET request with `hx-request` headers as if `sourceNode`
   * target was loaded. Send alternated values if `formData` is set.
   * 
   * Note that this request is intercepted and sent as XMLHttpRequest.
   * It is necessary to use `htmx.ajax` to acquire correct headers which
   * HTMX and extensions add based on `sourceNode`. But it cannot be used
   * to perform the request due to side-effects e.g. loading indicators. 
   * @param {string} url 
   * @param {Node} sourceNode 
   * @param {FormData=} formData
   */ function sendHxGetRequest(url, sourceNode, formData) {
        (0, $hJ2SO.default).ajax('GET', url, {
            source: sourceNode,
            values: formData,
            headers: {
                "HX-Preloaded": "true"
            }
        });
    }
    /**
   * Send XML GET request to `url`. Send `formData` as URL params if set.
   * @param {string} url
   * @param {Node} sourceNode
   * @param {FormData=} formData
   */ function sendXmlGetRequest(url, sourceNode, formData) {
        const xhr = new XMLHttpRequest();
        if (formData) url += '?' + new URLSearchParams(formData.entries()).toString();
        xhr.open('GET', url);
        xhr.setRequestHeader("HX-Preloaded", "true");
        xhr.onload = function() {
            processResponse(sourceNode, xhr.responseText);
        };
        xhr.send();
    }
    /**
   * Process request response by marking node `DONE` to prevent repeated
   * requests, except if preload attribute contains `always`,
   * and load linked resources (e.g. images) returned in the response 
   * if `preload-images` attribute is `true`
   * @param {Node} node 
   * @param {string} responseText 
   */ function processResponse(node, responseText) {
        node.preloadState = node.preloadAlways ? 'READY' : 'DONE';
        if (getClosestAttribute(node, 'preload-images') === 'true') // Load linked resources
        document.createElement('div').innerHTML = responseText;
    }
    /**
   * Gets attribute value from node or one of its parents
   * @param {Node} node 
   * @param {string} attribute 
   * @returns { string | undefined }
   */ function getClosestAttribute(node, attribute) {
        if (node == undefined) return undefined;
        return node.getAttribute(attribute) || node.getAttribute('data-' + attribute) || getClosestAttribute(node.parentElement, attribute);
    }
    /**
   * Determines if node is valid for preloading and should be
   * initialized by setting up event listeners and handlers
   * @param {Node} node 
   * @returns {boolean}
   */ function isValidNodeForPreloading(node) {
        // Add listeners only to nodes which include "GET" transactions
        // or preloadable "GET" form elements
        const getReqAttrs = [
            'href',
            'hx-get',
            'data-hx-get'
        ];
        const includesGetRequest = (node)=>getReqAttrs.some((a)=>node.hasAttribute(a)) || node.method === 'get';
        const isPreloadableGetFormElement = node.form instanceof HTMLFormElement && includesGetRequest(node.form) && isPreloadableFormElement(node);
        if (!includesGetRequest(node) && !isPreloadableGetFormElement) return false;
        // Don't preload <input> elements contained in <label>
        // to prevent sending two requests. Interaction on <input> in a
        // <label><input></input></label> situation activates <label> too.
        if (node instanceof HTMLInputElement && node.closest('label')) return false;
        return true;
    }
    /**
   * Determine if node is a form element which can be preloaded,
   * i.e., `radio`, `checkbox`, `select` or `submit` button
   * or a `label` of a form element which can be preloaded.
   * @param {Node} node 
   * @returns {boolean}
   */ function isPreloadableFormElement(node) {
        if (node instanceof HTMLInputElement || node instanceof HTMLButtonElement) {
            const type = node.getAttribute('type');
            return [
                'checkbox',
                'radio',
                'submit'
            ].includes(type);
        }
        if (node instanceof HTMLLabelElement) return node.control && isPreloadableFormElement(node.control);
        return node instanceof HTMLSelectElement;
    }
})();


var $e633ba29072e4dc2$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $e633ba29072e4dc2$exports = factory();
})(typeof self !== 'undefined' ? self : $e633ba29072e4dc2$exports, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ // The require scope
        /******/ var __webpack_require__ = {};
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // EXPORTS
        __webpack_require__.d(__webpack_exports__, {
            "default": function() {
                return /* binding */ katex_webpack;
            }
        });
        /**
 * This is the ParseError class, which is the main error thrown by KaTeX
 * functions when something has gone wrong. This is used to distinguish internal
 * errors from errors in the expression that the user provided.
 *
 * If possible, a caller should provide a Token or ParseNode with information
 * about where in the source string the problem occurred.
 */ class ParseError {
            // Error start position based on passed-in Token or ParseNode.
            // Length of affected text based on passed-in Token or ParseNode.
            // The underlying error message without any context added.
            constructor(message, token // An object providing position information
            ){
                this.name = void 0;
                this.position = void 0;
                this.length = void 0;
                this.rawMessage = void 0;
                let error = "KaTeX parse error: " + message;
                let start;
                let end;
                const loc = token && token.loc;
                if (loc && loc.start <= loc.end) {
                    // If we have the input and a position, make the error a bit fancier
                    // Get the input
                    const input = loc.lexer.input; // Prepend some information
                    start = loc.start;
                    end = loc.end;
                    if (start === input.length) error += " at end of input: ";
                    else error += " at position " + (start + 1) + ": ";
                     // Underline token in question using combining underscores
                    const underlined = input.slice(start, end).replace(/[^]/g, "$&\u0332"); // Extract some context from the input and add it to the error
                    let left;
                    if (start > 15) left = "\u2026" + input.slice(start - 15, start);
                    else left = input.slice(0, start);
                    let right;
                    if (end + 15 < input.length) right = input.slice(end, end + 15) + "\u2026";
                    else right = input.slice(end);
                    error += left + underlined + right;
                } // Some hackery to make ParseError a prototype of Error
                // See http://stackoverflow.com/a/8460753
                // $FlowFixMe
                const self1 = new Error(error);
                self1.name = "ParseError"; // $FlowFixMe
                self1.__proto__ = ParseError.prototype;
                self1.position = start;
                if (start != null && end != null) self1.length = end - start;
                self1.rawMessage = message;
                return self1;
            }
        } // $FlowFixMe More hackery
        ParseError.prototype.__proto__ = Error.prototype;
        /* harmony default export */ var src_ParseError = ParseError;
        /**
 * This file contains a list of utility functions which are useful in other
 * files.
 */ /**
 * Provide a default value if a setting is undefined
 * NOTE: Couldn't use `T` as the output type due to facebook/flow#5022.
 */ const deflt = function(setting, defaultIfUndefined) {
            return setting === undefined ? defaultIfUndefined : setting;
        }; // hyphenate and escape adapted from Facebook's React under Apache 2 license
        const uppercase = /([A-Z])/g;
        const hyphenate = function(str) {
            return str.replace(uppercase, "-$1").toLowerCase();
        };
        const ESCAPE_LOOKUP = {
            "&": "&amp;",
            ">": "&gt;",
            "<": "&lt;",
            "\"": "&quot;",
            "'": "&#x27;"
        };
        const ESCAPE_REGEX = /[&><"']/g;
        /**
 * Escapes text to prevent scripting attacks.
 */ function utils_escape(text) {
            return String(text).replace(ESCAPE_REGEX, (match)=>ESCAPE_LOOKUP[match]);
        }
        /**
 * Sometimes we want to pull out the innermost element of a group. In most
 * cases, this will just be the group itself, but when ordgroups and colors have
 * a single element, we want to pull that out.
 */ const getBaseElem = function(group) {
            if (group.type === "ordgroup") {
                if (group.body.length === 1) return getBaseElem(group.body[0]);
                else return group;
            } else if (group.type === "color") {
                if (group.body.length === 1) return getBaseElem(group.body[0]);
                else return group;
            } else if (group.type === "font") return getBaseElem(group.body);
            else return group;
        };
        /**
 * TeXbook algorithms often reference "character boxes", which are simply groups
 * with a single character in them. To decide if something is a character box,
 * we find its innermost group, and see if it is a single character.
 */ const isCharacterBox = function(group) {
            const baseElem = getBaseElem(group); // These are all they types of groups which hold single characters
            return baseElem.type === "mathord" || baseElem.type === "textord" || baseElem.type === "atom";
        };
        const assert = function(value) {
            if (!value) throw new Error('Expected non-null, but got ' + String(value));
            return value;
        };
        /**
 * Return the protocol of a URL, or "_relative" if the URL does not specify a
 * protocol (and thus is relative), or `null` if URL has invalid protocol
 * (so should be outright rejected).
 */ const protocolFromUrl = function(url) {
            // Check for possible leading protocol.
            // https://url.spec.whatwg.org/#url-parsing strips leading whitespace
            // (U+20) or C0 control (U+00-U+1F) characters.
            // eslint-disable-next-line no-control-regex
            const protocol = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(url);
            if (!protocol) return "_relative";
             // Reject weird colons
            if (protocol[2] !== ":") return null;
             // Reject invalid characters in scheme according to
            // https://datatracker.ietf.org/doc/html/rfc3986#section-3.1
            if (!/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(protocol[1])) return null;
             // Lowercase the protocol
            return protocol[1].toLowerCase();
        };
        /* harmony default export */ var utils = {
            deflt: deflt,
            escape: utils_escape,
            hyphenate: hyphenate,
            getBaseElem: getBaseElem,
            isCharacterBox: isCharacterBox,
            protocolFromUrl: protocolFromUrl
        };
        /* eslint no-console:0 */ /**
 * This is a module for storing settings passed into KaTeX. It correctly handles
 * default settings.
 */ // TODO: automatically generate documentation
        // TODO: check all properties on Settings exist
        // TODO: check the type of a property on Settings matches
        const SETTINGS_SCHEMA = {
            displayMode: {
                type: "boolean",
                description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
                cli: "-d, --display-mode"
            },
            output: {
                type: {
                    enum: [
                        "htmlAndMathml",
                        "html",
                        "mathml"
                    ]
                },
                description: "Determines the markup language of the output.",
                cli: "-F, --format <type>"
            },
            leqno: {
                type: "boolean",
                description: "Render display math in leqno style (left-justified tags)."
            },
            fleqn: {
                type: "boolean",
                description: "Render display math flush left."
            },
            throwOnError: {
                type: "boolean",
                default: true,
                cli: "-t, --no-throw-on-error",
                cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
            },
            errorColor: {
                type: "string",
                default: "#cc0000",
                cli: "-c, --error-color <color>",
                cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
                cliProcessor: (color)=>"#" + color
            },
            macros: {
                type: "object",
                cli: "-m, --macro <def>",
                cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
                cliDefault: [],
                cliProcessor: (def, defs)=>{
                    defs.push(def);
                    return defs;
                }
            },
            minRuleThickness: {
                type: "number",
                description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
                processor: (t)=>Math.max(0, t),
                cli: "--min-rule-thickness <size>",
                cliProcessor: parseFloat
            },
            colorIsTextColor: {
                type: "boolean",
                description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
                cli: "-b, --color-is-text-color"
            },
            strict: {
                type: [
                    {
                        enum: [
                            "warn",
                            "ignore",
                            "error"
                        ]
                    },
                    "boolean",
                    "function"
                ],
                description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
                cli: "-S, --strict",
                cliDefault: false
            },
            trust: {
                type: [
                    "boolean",
                    "function"
                ],
                description: "Trust the input, enabling all HTML features such as \\url.",
                cli: "-T, --trust"
            },
            maxSize: {
                type: "number",
                default: Infinity,
                description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
                processor: (s)=>Math.max(0, s),
                cli: "-s, --max-size <n>",
                cliProcessor: parseInt
            },
            maxExpand: {
                type: "number",
                default: 1000,
                description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
                processor: (n)=>Math.max(0, n),
                cli: "-e, --max-expand <n>",
                cliProcessor: (n)=>n === "Infinity" ? Infinity : parseInt(n)
            },
            globalGroup: {
                type: "boolean",
                cli: false
            }
        };
        function getDefaultValue(schema) {
            if (schema.default) return schema.default;
            const type = schema.type;
            const defaultType = Array.isArray(type) ? type[0] : type;
            if (typeof defaultType !== 'string') return defaultType.enum[0];
            switch(defaultType){
                case 'boolean':
                    return false;
                case 'string':
                    return '';
                case 'number':
                    return 0;
                case 'object':
                    return {};
            }
        }
        /**
 * The main Settings object
 *
 * The current options stored are:
 *  - displayMode: Whether the expression should be typeset as inline math
 *                 (false, the default), meaning that the math starts in
 *                 \textstyle and is placed in an inline-block); or as display
 *                 math (true), meaning that the math starts in \displaystyle
 *                 and is placed in a block with vertical margin.
 */ class Settings {
            constructor(options){
                this.displayMode = void 0;
                this.output = void 0;
                this.leqno = void 0;
                this.fleqn = void 0;
                this.throwOnError = void 0;
                this.errorColor = void 0;
                this.macros = void 0;
                this.minRuleThickness = void 0;
                this.colorIsTextColor = void 0;
                this.strict = void 0;
                this.trust = void 0;
                this.maxSize = void 0;
                this.maxExpand = void 0;
                this.globalGroup = void 0;
                // allow null options
                options = options || {};
                for(const prop in SETTINGS_SCHEMA)if (SETTINGS_SCHEMA.hasOwnProperty(prop)) {
                    // $FlowFixMe
                    const schema = SETTINGS_SCHEMA[prop]; // TODO: validate options
                    // $FlowFixMe
                    this[prop] = options[prop] !== undefined ? schema.processor ? schema.processor(options[prop]) : options[prop] : getDefaultValue(schema);
                }
            }
            /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */ reportNonstrict(errorCode, errorMsg, token) {
                let strict = this.strict;
                if (typeof strict === "function") // Allow return value of strict function to be boolean or string
                // (or null/undefined, meaning no further processing).
                strict = strict(errorCode, errorMsg, token);
                if (!strict || strict === "ignore") return;
                else if (strict === true || strict === "error") throw new src_ParseError("LaTeX-incompatible input and strict mode is set to 'error': " + (errorMsg + " [" + errorCode + "]"), token);
                else if (strict === "warn") typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (errorMsg + " [" + errorCode + "]"));
                else // won't happen in type-safe code
                typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + strict + "': " + errorMsg + " [" + errorCode + "]"));
            }
            /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */ useStrictBehavior(errorCode, errorMsg, token) {
                let strict = this.strict;
                if (typeof strict === "function") // Allow return value of strict function to be boolean or string
                // (or null/undefined, meaning no further processing).
                // But catch any exceptions thrown by function, treating them
                // like "error".
                try {
                    strict = strict(errorCode, errorMsg, token);
                } catch (error) {
                    strict = "error";
                }
                if (!strict || strict === "ignore") return false;
                else if (strict === true || strict === "error") return true;
                else if (strict === "warn") {
                    typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (errorMsg + " [" + errorCode + "]"));
                    return false;
                } else {
                    // won't happen in type-safe code
                    typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + strict + "': " + errorMsg + " [" + errorCode + "]"));
                    return false;
                }
            }
            /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */ isTrusted(context) {
                if (context.url && !context.protocol) {
                    const protocol = utils.protocolFromUrl(context.url);
                    if (protocol == null) return false;
                    context.protocol = protocol;
                }
                const trust = typeof this.trust === "function" ? this.trust(context) : this.trust;
                return Boolean(trust);
            }
        }
        /**
 * This file contains information and classes for the various kinds of styles
 * used in TeX. It provides a generic `Style` class, which holds information
 * about a specific style. It then provides instances of all the different kinds
 * of styles possible, and provides functions to move between them and get
 * information about them.
 */ /**
 * The main style class. Contains a unique id for the style, a size (which is
 * the same for cramped and uncramped version of a style), and a cramped flag.
 */ class Style {
            constructor(id, size, cramped){
                this.id = void 0;
                this.size = void 0;
                this.cramped = void 0;
                this.id = id;
                this.size = size;
                this.cramped = cramped;
            }
            /**
   * Get the style of a superscript given a base in the current style.
   */ sup() {
                return styles[sup[this.id]];
            }
            /**
   * Get the style of a subscript given a base in the current style.
   */ sub() {
                return styles[sub[this.id]];
            }
            /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */ fracNum() {
                return styles[fracNum[this.id]];
            }
            /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */ fracDen() {
                return styles[fracDen[this.id]];
            }
            /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */ cramp() {
                return styles[cramp[this.id]];
            }
            /**
   * Get a text or display version of this style.
   */ text() {
                return styles[Style_text[this.id]];
            }
            /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */ isTight() {
                return this.size >= 2;
            }
        } // Export an interface for type checking, but don't expose the implementation.
        // This way, no more styles can be generated.
        // IDs of the different styles
        const D = 0;
        const Dc = 1;
        const T = 2;
        const Tc = 3;
        const S = 4;
        const Sc = 5;
        const SS = 6;
        const SSc = 7; // Instances of the different styles
        const styles = [
            new Style(D, 0, false),
            new Style(Dc, 0, true),
            new Style(T, 1, false),
            new Style(Tc, 1, true),
            new Style(S, 2, false),
            new Style(Sc, 2, true),
            new Style(SS, 3, false),
            new Style(SSc, 3, true)
        ]; // Lookup tables for switching from one style to another
        const sup = [
            S,
            Sc,
            S,
            Sc,
            SS,
            SSc,
            SS,
            SSc
        ];
        const sub = [
            Sc,
            Sc,
            Sc,
            Sc,
            SSc,
            SSc,
            SSc,
            SSc
        ];
        const fracNum = [
            T,
            Tc,
            S,
            Sc,
            SS,
            SSc,
            SS,
            SSc
        ];
        const fracDen = [
            Tc,
            Tc,
            Sc,
            Sc,
            SSc,
            SSc,
            SSc,
            SSc
        ];
        const cramp = [
            Dc,
            Dc,
            Tc,
            Tc,
            Sc,
            Sc,
            SSc,
            SSc
        ];
        const Style_text = [
            D,
            Dc,
            T,
            Tc,
            T,
            Tc,
            T,
            Tc
        ]; // We only export some of the styles.
        /* harmony default export */ var src_Style = {
            DISPLAY: styles[D],
            TEXT: styles[T],
            SCRIPT: styles[S],
            SCRIPTSCRIPT: styles[SS]
        };
        /*
 * This file defines the Unicode scripts and script families that we
 * support. To add new scripts or families, just add a new entry to the
 * scriptData array below. Adding scripts to the scriptData array allows
 * characters from that script to appear in \text{} environments.
 */ /**
 * Each script or script family has a name and an array of blocks.
 * Each block is an array of two numbers which specify the start and
 * end points (inclusive) of a block of Unicode codepoints.
 */ /**
 * Unicode block data for the families of scripts we support in \text{}.
 * Scripts only need to appear here if they do not have font metrics.
 */ const scriptData = [
            {
                // Latin characters beyond the Latin-1 characters we have metrics for.
                // Needed for Czech, Hungarian and Turkish text, for example.
                name: 'latin',
                blocks: [
                    [
                        0x0100,
                        0x024f
                    ],
                    [
                        0x0300,
                        0x036f
                    ] // Combining Diacritical marks
                ]
            },
            {
                // The Cyrillic script used by Russian and related languages.
                // A Cyrillic subset used to be supported as explicitly defined
                // symbols in symbols.js
                name: 'cyrillic',
                blocks: [
                    [
                        0x0400,
                        0x04ff
                    ]
                ]
            },
            {
                // Armenian
                name: 'armenian',
                blocks: [
                    [
                        0x0530,
                        0x058F
                    ]
                ]
            },
            {
                // The Brahmic scripts of South and Southeast Asia
                // Devanagari (0900–097F)
                // Bengali (0980–09FF)
                // Gurmukhi (0A00–0A7F)
                // Gujarati (0A80–0AFF)
                // Oriya (0B00–0B7F)
                // Tamil (0B80–0BFF)
                // Telugu (0C00–0C7F)
                // Kannada (0C80–0CFF)
                // Malayalam (0D00–0D7F)
                // Sinhala (0D80–0DFF)
                // Thai (0E00–0E7F)
                // Lao (0E80–0EFF)
                // Tibetan (0F00–0FFF)
                // Myanmar (1000–109F)
                name: 'brahmic',
                blocks: [
                    [
                        0x0900,
                        0x109F
                    ]
                ]
            },
            {
                name: 'georgian',
                blocks: [
                    [
                        0x10A0,
                        0x10ff
                    ]
                ]
            },
            {
                // Chinese and Japanese.
                // The "k" in cjk is for Korean, but we've separated Korean out
                name: "cjk",
                blocks: [
                    [
                        0x3000,
                        0x30FF
                    ],
                    [
                        0x4E00,
                        0x9FAF
                    ],
                    [
                        0xFF00,
                        0xFF60
                    ] // Fullwidth punctuation
                ]
            },
            {
                // Korean
                name: 'hangul',
                blocks: [
                    [
                        0xAC00,
                        0xD7AF
                    ]
                ]
            }
        ];
        /**
 * Given a codepoint, return the name of the script or script family
 * it is from, or null if it is not part of a known block
 */ function scriptFromCodepoint(codepoint) {
            for(let i = 0; i < scriptData.length; i++){
                const script = scriptData[i];
                for(let i = 0; i < script.blocks.length; i++){
                    const block = script.blocks[i];
                    if (codepoint >= block[0] && codepoint <= block[1]) return script.name;
                }
            }
            return null;
        }
        /**
 * A flattened version of all the supported blocks in a single array.
 * This is an optimization to make supportedCodepoint() fast.
 */ const allBlocks = [];
        scriptData.forEach((s)=>s.blocks.forEach((b)=>allBlocks.push(...b)));
        /**
 * Given a codepoint, return true if it falls within one of the
 * scripts or script families defined above and false otherwise.
 *
 * Micro benchmarks shows that this is faster than
 * /[\u3000-\u30FF\u4E00-\u9FAF\uFF00-\uFF60\uAC00-\uD7AF\u0900-\u109F]/.test()
 * in Firefox, Chrome and Node.
 */ function supportedCodepoint(codepoint) {
            for(let i = 0; i < allBlocks.length; i += 2){
                if (codepoint >= allBlocks[i] && codepoint <= allBlocks[i + 1]) return true;
            }
            return false;
        }
        /**
 * This file provides support to domTree.js and delimiter.js.
 * It's a storehouse of path geometry for SVG images.
 */ // In all paths below, the viewBox-to-em scale is 1000:1.
        const hLinePad = 80; // padding above a sqrt vinculum. Prevents image cropping.
        // The vinculum of a \sqrt can be made thicker by a KaTeX rendering option.
        // Think of variable extraVinculum as two detours in the SVG path.
        // The detour begins at the lower left of the area labeled extraVinculum below.
        // The detour proceeds one extraVinculum distance up and slightly to the right,
        // displacing the radiused corner between surd and vinculum. The radius is
        // traversed as usual, then the detour resumes. It goes right, to the end of
        // the very long vinculum, then down one extraVinculum distance,
        // after which it resumes regular path geometry for the radical.
        /*                                                  vinculum
                                                   /
         /▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒←extraVinculum
        / █████████████████████←0.04em (40 unit) std vinculum thickness
       / /
      / /
     / /\
    / / surd
*/ const sqrtMain = function(extraVinculum, hLinePad) {
            // sqrtMain path geometry is from glyph U221A in the font KaTeX Main
            return "M95," + (622 + extraVinculum + hLinePad) + "\nc-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14\nc0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54\nc44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10\ns173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429\nc69,-144,104.5,-217.7,106.5,-221\nl" + extraVinculum / 2.075 + " -" + extraVinculum + "\nc5.3,-9.3,12,-14,20,-14\nH400000v" + (40 + extraVinculum) + "H845.2724\ns-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7\nc-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z\nM" + (834 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
        };
        const sqrtSize1 = function(extraVinculum, hLinePad) {
            // size1 is from glyph U221A in the font KaTeX_Size1-Regular
            return "M263," + (601 + extraVinculum + hLinePad) + "c0.7,0,18,39.7,52,119\nc34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120\nc340,-704.7,510.7,-1060.3,512,-1067\nl" + extraVinculum / 2.084 + " -" + extraVinculum + "\nc4.7,-7.3,11,-11,19,-11\nH40000v" + (40 + extraVinculum) + "H1012.3\ns-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232\nc-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1\ns-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26\nc-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z\nM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
        };
        const sqrtSize2 = function(extraVinculum, hLinePad) {
            // size2 is from glyph U221A in the font KaTeX_Size2-Regular
            return "M983 " + (10 + extraVinculum + hLinePad) + "\nl" + extraVinculum / 3.13 + " -" + extraVinculum + "\nc4,-6.7,10,-10,18,-10 H400000v" + (40 + extraVinculum) + "\nH1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7\ns-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744\nc-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30\nc26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722\nc56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5\nc53.7,-170.3,84.5,-266.8,92.5,-289.5z\nM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
        };
        const sqrtSize3 = function(extraVinculum, hLinePad) {
            // size3 is from glyph U221A in the font KaTeX_Size3-Regular
            return "M424," + (2398 + extraVinculum + hLinePad) + "\nc-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514\nc0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20\ns-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121\ns209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081\nl" + extraVinculum / 4.223 + " -" + extraVinculum + "c4,-6.7,10,-10,18,-10 H400000\nv" + (40 + extraVinculum) + "H1014.6\ns-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185\nc-2,6,-10,9,-24,9\nc-8,0,-12,-0.7,-12,-2z M" + (1001 + extraVinculum) + " " + hLinePad + "\nh400000v" + (40 + extraVinculum) + "h-400000z";
        };
        const sqrtSize4 = function(extraVinculum, hLinePad) {
            // size4 is from glyph U221A in the font KaTeX_Size4-Regular
            return "M473," + (2713 + extraVinculum + hLinePad) + "\nc339.3,-1799.3,509.3,-2700,510,-2702 l" + extraVinculum / 5.298 + " -" + extraVinculum + "\nc3.3,-7.3,9.3,-11,18,-11 H400000v" + (40 + extraVinculum) + "H1017.7\ns-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9\nc-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200\nc0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26\ns76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,\n606zM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "H1017.7z";
        };
        const phasePath = function(y) {
            const x = y / 2; // x coordinate at top of angle
            return "M400000 " + y + " H0 L" + x + " 0 l65 45 L145 " + (y - 80) + " H400000z";
        };
        const sqrtTall = function(extraVinculum, hLinePad, viewBoxHeight) {
            // sqrtTall is from glyph U23B7 in the font KaTeX_Size4-Regular
            // One path edge has a variable length. It runs vertically from the vinculum
            // to a point near (14 units) the bottom of the surd. The vinculum
            // is normally 40 units thick. So the length of the line in question is:
            const vertSegment = viewBoxHeight - 54 - hLinePad - extraVinculum;
            return "M702 " + (extraVinculum + hLinePad) + "H400000" + (40 + extraVinculum) + "\nH742v" + vertSegment + "l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1\nh-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170\nc-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667\n219 661 l218 661zM702 " + hLinePad + "H400000v" + (40 + extraVinculum) + "H742z";
        };
        const sqrtPath = function(size, extraVinculum, viewBoxHeight) {
            extraVinculum = 1000 * extraVinculum; // Convert from document ems to viewBox.
            let path = "";
            switch(size){
                case "sqrtMain":
                    path = sqrtMain(extraVinculum, hLinePad);
                    break;
                case "sqrtSize1":
                    path = sqrtSize1(extraVinculum, hLinePad);
                    break;
                case "sqrtSize2":
                    path = sqrtSize2(extraVinculum, hLinePad);
                    break;
                case "sqrtSize3":
                    path = sqrtSize3(extraVinculum, hLinePad);
                    break;
                case "sqrtSize4":
                    path = sqrtSize4(extraVinculum, hLinePad);
                    break;
                case "sqrtTall":
                    path = sqrtTall(extraVinculum, hLinePad, viewBoxHeight);
            }
            return path;
        };
        const innerPath = function(name, height) {
            // The inner part of stretchy tall delimiters
            switch(name){
                case "\u239c":
                    return "M291 0 H417 V" + height + " H291z M291 0 H417 V" + height + " H291z";
                case "\u2223":
                    return "M145 0 H188 V" + height + " H145z M145 0 H188 V" + height + " H145z";
                case "\u2225":
                    return "M145 0 H188 V" + height + " H145z M145 0 H188 V" + height + " H145z" + ("M367 0 H410 V" + height + " H367z M367 0 H410 V" + height + " H367z");
                case "\u239f":
                    return "M457 0 H583 V" + height + " H457z M457 0 H583 V" + height + " H457z";
                case "\u23a2":
                    return "M319 0 H403 V" + height + " H319z M319 0 H403 V" + height + " H319z";
                case "\u23a5":
                    return "M263 0 H347 V" + height + " H263z M263 0 H347 V" + height + " H263z";
                case "\u23aa":
                    return "M384 0 H504 V" + height + " H384z M384 0 H504 V" + height + " H384z";
                case "\u23d0":
                    return "M312 0 H355 V" + height + " H312z M312 0 H355 V" + height + " H312z";
                case "\u2016":
                    return "M257 0 H300 V" + height + " H257z M257 0 H300 V" + height + " H257z" + ("M478 0 H521 V" + height + " H478z M478 0 H521 V" + height + " H478z");
                default:
                    return "";
            }
        };
        const path = {
            // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
            doubleleftarrow: "M262 157\nl10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3\n 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28\n 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5\nc2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5\n 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87\n-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7\n-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z\nm8 0v40h399730v-40zm0 194v40h399730v-40z",
            // doublerightarrow is from glyph U+21D2 in font KaTeX Main
            doublerightarrow: "M399738 392l\n-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5\n 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88\n-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68\n-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18\n-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782\nc-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3\n-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z",
            // leftarrow is from glyph U+2190 in font KaTeX Main
            leftarrow: "M400000 241H110l3-3c68.7-52.7 113.7-120\n 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8\n-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247\nc-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208\n 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3\n 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202\n l-3-3h399890zM100 241v40h399900v-40z",
            // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
            leftbrace: "M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117\n-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7\n 5-6 9-10 13-.7 1-7.3 1-20 1H6z",
            leftbraceunder: "M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13\n 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688\n 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7\n-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z",
            // overgroup is from the MnSymbol package (public domain)
            leftgroup: "M400000 80\nH435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0\n 435 0h399565z",
            leftgroupunder: "M400000 262\nH435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219\n 435 219h399565z",
            // Harpoons are from glyph U+21BD in font KaTeX Main
            leftharpoon: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3\n-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5\n-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7\n-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z",
            leftharpoonplus: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5\n 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3\n-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7\n-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z\nm0 0v40h400000v-40z",
            leftharpoondown: "M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333\n 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5\n 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667\n-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z",
            leftharpoondownplus: "M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12\n 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7\n-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0\nv40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z",
            // hook is from glyph U+21A9 in font KaTeX Main
            lefthook: "M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5\n-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3\n-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21\n 71.5 23h399859zM103 281v-40h399897v40z",
            leftlinesegment: "M40 281 V428 H0 V94 H40 V241 H400000 v40z\nM40 281 V428 H0 V94 H40 V241 H400000 v40z",
            leftmapsto: "M40 281 V448H0V74H40V241H400000v40z\nM40 281 V448H0V74H40V241H400000v40z",
            // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
            leftToFrom: "M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23\n-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8\nc28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3\n 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z",
            longequal: "M0 50 h400000 v40H0z m0 194h40000v40H0z\nM0 50 h400000 v40H0z m0 194h40000v40H0z",
            midbrace: "M200428 334\nc-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14\n-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7\n 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11\n 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z",
            midbraceunder: "M199572 214\nc100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14\n 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3\n 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0\n-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z",
            oiintSize1: "M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6\n-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z\nm368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8\n60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z",
            oiintSize2: "M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8\n-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z\nm502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2\nc0 110 84 276 504 276s502.4-166 502.4-276z",
            oiiintSize1: "M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6\n-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z\nm525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0\n85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z",
            oiiintSize2: "M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8\n-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z\nm770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1\nc0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z",
            rightarrow: "M0 241v40h399891c-47.3 35.3-84 78-110 128\n-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20\n 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7\n 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85\n-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n 151.7 139 205zm0 0v40h399900v-40z",
            rightbrace: "M400000 542l\n-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5\ns-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1\nc124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z",
            rightbraceunder: "M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3\n 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237\n-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z",
            rightgroup: "M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0\n 3-1 3-3v-38c-76-158-257-219-435-219H0z",
            rightgroupunder: "M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18\n 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z",
            rightharpoon: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3\n-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2\n-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58\n 69.2 92 94.5zm0 0v40h399900v-40z",
            rightharpoonplus: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11\n-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7\n 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z\nm0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z",
            rightharpoondown: "M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8\n 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5\n-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95\n-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z",
            rightharpoondownplus: "M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8\n 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3\n 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3\n-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z\nm0-194v40h400000v-40zm0 0v40h400000v-40z",
            righthook: "M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3\n 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0\n-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21\n 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z",
            rightlinesegment: "M399960 241 V94 h40 V428 h-40 V281 H0 v-40z\nM399960 241 V94 h40 V428 h-40 V281 H0 v-40z",
            rightToFrom: "M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23\n 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32\n-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142\n-167z M100 147v40h399900v-40zM0 341v40h399900v-40z",
            // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
            twoheadleftarrow: "M0 167c68 40\n 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69\n-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3\n-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19\n-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101\n 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z",
            twoheadrightarrow: "M400000 167\nc-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3\n 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42\n 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333\n-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70\n 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z",
            // tilde1 is a modified version of a glyph from the MnSymbol package
            tilde1: "M200 55.538c-77 0-168 73.953-177 73.953-3 0-7\n-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0\n 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0\n 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128\n-68.267.847-113-73.952-191-73.952z",
            // ditto tilde2, tilde3, & tilde4
            tilde2: "M344 55.266c-142 0-300.638 81.316-311.5 86.418\n-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9\n 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114\nc1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751\n 181.476 676 181.476c-149 0-189-126.21-332-126.21z",
            tilde3: "M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457\n-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0\n 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697\n 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696\n -338 0-409-156.573-744-156.573z",
            tilde4: "M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345\n-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409\n 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9\n 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409\n -175.236-744-175.236z",
            // vec is from glyph U+20D7 in font KaTeX Main
            vec: "M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5\n3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11\n10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63\n-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1\n-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59\nH213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359\nc-16-25.333-24-45-24-59z",
            // widehat1 is a modified version of a glyph from the MnSymbol package
            widehat1: "M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22\nc-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z",
            // ditto widehat2, widehat3, & widehat4
            widehat2: "M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
            widehat3: "M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
            widehat4: "M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
            // widecheck paths are all inverted versions of widehat
            widecheck1: "M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,\n-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z",
            widecheck2: "M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
            widecheck3: "M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
            widecheck4: "M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
            // The next ten paths support reaction arrows from the mhchem package.
            // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
            // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
            baraboveleftarrow: "M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202\nc4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5\nc-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130\ns-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47\n121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6\ns2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11\nc0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z\nM100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z",
            // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
            rightarrowabovebar: "M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32\n-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0\n13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39\n-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5\n-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z",
            // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
            // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
            baraboveshortleftharpoon: "M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17\nc2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21\nc-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40\nc-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z\nM0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z",
            rightharpoonaboveshortbar: "M0,241 l0,40c399126,0,399993,0,399993,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z",
            shortbaraboveleftharpoon: "M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,\n1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,\n-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z\nM93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z",
            shortrightharpoonabovebar: "M53,241l0,40c398570,0,399437,0,399437,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z"
        };
        const tallDelim = function(label, midHeight) {
            switch(label){
                case "lbrack":
                    return "M403 1759 V84 H666 V0 H319 V1759 v" + midHeight + " v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v" + midHeight + " v1759 h84z";
                case "rbrack":
                    return "M347 1759 V0 H0 V84 H263 V1759 v" + midHeight + " v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v" + midHeight + " v1759 h84z";
                case "vert":
                    return "M145 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M188 15 H145 v585 v" + midHeight + " v585 h43z";
                case "doublevert":
                    return "M145 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M188 15 H145 v585 v" + midHeight + " v585 h43z\nM367 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M410 15 H367 v585 v" + midHeight + " v585 h43z";
                case "lfloor":
                    return "M319 602 V0 H403 V602 v" + midHeight + " v1715 h263 v84 H319z\nMM319 602 V0 H403 V602 v" + midHeight + " v1715 H319z";
                case "rfloor":
                    return "M319 602 V0 H403 V602 v" + midHeight + " v1799 H0 v-84 H319z\nMM319 602 V0 H403 V602 v" + midHeight + " v1715 H319z";
                case "lceil":
                    return "M403 1759 V84 H666 V0 H319 V1759 v" + midHeight + " v602 h84z\nM403 1759 V0 H319 V1759 v" + midHeight + " v602 h84z";
                case "rceil":
                    return "M347 1759 V0 H0 V84 H263 V1759 v" + midHeight + " v602 h84z\nM347 1759 V0 h-84 V1759 v" + midHeight + " v602 h84z";
                case "lparen":
                    return "M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1\nc-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,\n-36,557 l0," + (midHeight + 84) + "c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,\n949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9\nc0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,\n-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189\nl0,-" + (midHeight + 92) + "c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,\n-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z";
                case "rparen":
                    return "M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,\n63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5\nc11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0," + (midHeight + 9) + "\nc-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664\nc-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11\nc0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17\nc242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558\nl0,-" + (midHeight + 144) + "c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,\n-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z";
                default:
                    // We should not ever get here.
                    throw new Error("Unknown stretchy delimiter.");
            }
        };
        // This file is GENERATED by buildMetrics.sh. DO NOT MODIFY.
        /* harmony default export */ var fontMetricsData = {
            "AMS-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "65": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "66": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "67": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "68": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "69": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "70": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.61111
                ],
                "71": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.77778
                ],
                "72": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.77778
                ],
                "73": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.38889
                ],
                "74": [
                    0.16667,
                    0.68889,
                    0,
                    0,
                    0.5
                ],
                "75": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.77778
                ],
                "76": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "77": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.94445
                ],
                "78": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "79": [
                    0.16667,
                    0.68889,
                    0,
                    0,
                    0.77778
                ],
                "80": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.61111
                ],
                "81": [
                    0.16667,
                    0.68889,
                    0,
                    0,
                    0.77778
                ],
                "82": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "83": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.55556
                ],
                "84": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "85": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "86": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "87": [
                    0,
                    0.68889,
                    0,
                    0,
                    1.0
                ],
                "88": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "89": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "90": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "107": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.55556
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "165": [
                    0,
                    0.675,
                    0.025,
                    0,
                    0.75
                ],
                "174": [
                    0.15559,
                    0.69224,
                    0,
                    0,
                    0.94666
                ],
                "240": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.55556
                ],
                "295": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.54028
                ],
                "710": [
                    0,
                    0.825,
                    0,
                    0,
                    2.33334
                ],
                "732": [
                    0,
                    0.9,
                    0,
                    0,
                    2.33334
                ],
                "770": [
                    0,
                    0.825,
                    0,
                    0,
                    2.33334
                ],
                "771": [
                    0,
                    0.9,
                    0,
                    0,
                    2.33334
                ],
                "989": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "1008": [
                    0,
                    0.43056,
                    0.04028,
                    0,
                    0.66667
                ],
                "8245": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.275
                ],
                "8463": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.54028
                ],
                "8487": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "8498": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.55556
                ],
                "8502": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "8503": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.44445
                ],
                "8504": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.66667
                ],
                "8513": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.63889
                ],
                "8592": [
                    -0.03598,
                    0.46402,
                    0,
                    0,
                    0.5
                ],
                "8594": [
                    -0.03598,
                    0.46402,
                    0,
                    0,
                    0.5
                ],
                "8602": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8603": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8606": [
                    0.01354,
                    0.52239,
                    0,
                    0,
                    1.0
                ],
                "8608": [
                    0.01354,
                    0.52239,
                    0,
                    0,
                    1.0
                ],
                "8610": [
                    0.01354,
                    0.52239,
                    0,
                    0,
                    1.11111
                ],
                "8611": [
                    0.01354,
                    0.52239,
                    0,
                    0,
                    1.11111
                ],
                "8619": [
                    0,
                    0.54986,
                    0,
                    0,
                    1.0
                ],
                "8620": [
                    0,
                    0.54986,
                    0,
                    0,
                    1.0
                ],
                "8621": [
                    -0.13313,
                    0.37788,
                    0,
                    0,
                    1.38889
                ],
                "8622": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8624": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.5
                ],
                "8625": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.5
                ],
                "8630": [
                    0,
                    0.43056,
                    0,
                    0,
                    1.0
                ],
                "8631": [
                    0,
                    0.43056,
                    0,
                    0,
                    1.0
                ],
                "8634": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8635": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8638": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.41667
                ],
                "8639": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.41667
                ],
                "8642": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.41667
                ],
                "8643": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.41667
                ],
                "8644": [
                    0.1808,
                    0.675,
                    0,
                    0,
                    1.0
                ],
                "8646": [
                    0.1808,
                    0.675,
                    0,
                    0,
                    1.0
                ],
                "8647": [
                    0.1808,
                    0.675,
                    0,
                    0,
                    1.0
                ],
                "8648": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.83334
                ],
                "8649": [
                    0.1808,
                    0.675,
                    0,
                    0,
                    1.0
                ],
                "8650": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.83334
                ],
                "8651": [
                    0.01354,
                    0.52239,
                    0,
                    0,
                    1.0
                ],
                "8652": [
                    0.01354,
                    0.52239,
                    0,
                    0,
                    1.0
                ],
                "8653": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8654": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8655": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8666": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    1.0
                ],
                "8667": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    1.0
                ],
                "8669": [
                    -0.13313,
                    0.37788,
                    0,
                    0,
                    1.0
                ],
                "8672": [
                    -0.064,
                    0.437,
                    0,
                    0,
                    1.334
                ],
                "8674": [
                    -0.064,
                    0.437,
                    0,
                    0,
                    1.334
                ],
                "8705": [
                    0,
                    0.825,
                    0,
                    0,
                    0.5
                ],
                "8708": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.55556
                ],
                "8709": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "8717": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.42917
                ],
                "8722": [
                    -0.03598,
                    0.46402,
                    0,
                    0,
                    0.5
                ],
                "8724": [
                    0.08198,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "8726": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "8733": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "8736": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.72222
                ],
                "8737": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.72222
                ],
                "8738": [
                    0.03517,
                    0.52239,
                    0,
                    0,
                    0.72222
                ],
                "8739": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.22222
                ],
                "8740": [
                    0.25142,
                    0.74111,
                    0,
                    0,
                    0.27778
                ],
                "8741": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.38889
                ],
                "8742": [
                    0.25142,
                    0.74111,
                    0,
                    0,
                    0.5
                ],
                "8756": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.66667
                ],
                "8757": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.66667
                ],
                "8764": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    0.77778
                ],
                "8765": [
                    -0.13313,
                    0.37788,
                    0,
                    0,
                    0.77778
                ],
                "8769": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    0.77778
                ],
                "8770": [
                    -0.03625,
                    0.46375,
                    0,
                    0,
                    0.77778
                ],
                "8774": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8776": [
                    -0.01688,
                    0.48312,
                    0,
                    0,
                    0.77778
                ],
                "8778": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "8782": [
                    0.06062,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8783": [
                    0.06062,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8785": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8786": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8787": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8790": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "8791": [
                    0.22958,
                    0.72958,
                    0,
                    0,
                    0.77778
                ],
                "8796": [
                    0.08198,
                    0.91667,
                    0,
                    0,
                    0.77778
                ],
                "8806": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.77778
                ],
                "8807": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.77778
                ],
                "8808": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "8809": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "8812": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.5
                ],
                "8814": [
                    0.20576,
                    0.70576,
                    0,
                    0,
                    0.77778
                ],
                "8815": [
                    0.20576,
                    0.70576,
                    0,
                    0,
                    0.77778
                ],
                "8816": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8817": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8818": [
                    0.22958,
                    0.72958,
                    0,
                    0,
                    0.77778
                ],
                "8819": [
                    0.22958,
                    0.72958,
                    0,
                    0,
                    0.77778
                ],
                "8822": [
                    0.1808,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "8823": [
                    0.1808,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "8828": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "8829": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "8830": [
                    0.22958,
                    0.72958,
                    0,
                    0,
                    0.77778
                ],
                "8831": [
                    0.22958,
                    0.72958,
                    0,
                    0,
                    0.77778
                ],
                "8832": [
                    0.20576,
                    0.70576,
                    0,
                    0,
                    0.77778
                ],
                "8833": [
                    0.20576,
                    0.70576,
                    0,
                    0,
                    0.77778
                ],
                "8840": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8841": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8842": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8843": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8847": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8848": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8858": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8859": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8861": [
                    0.08198,
                    0.58198,
                    0,
                    0,
                    0.77778
                ],
                "8862": [
                    0,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "8863": [
                    0,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "8864": [
                    0,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "8865": [
                    0,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "8872": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.61111
                ],
                "8873": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.72222
                ],
                "8874": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.88889
                ],
                "8876": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.61111
                ],
                "8877": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.61111
                ],
                "8878": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "8879": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.72222
                ],
                "8882": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8883": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8884": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "8885": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "8888": [
                    0,
                    0.54986,
                    0,
                    0,
                    1.11111
                ],
                "8890": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.55556
                ],
                "8891": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.61111
                ],
                "8892": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.61111
                ],
                "8901": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.27778
                ],
                "8903": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "8905": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "8906": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "8907": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "8908": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "8909": [
                    -0.03598,
                    0.46402,
                    0,
                    0,
                    0.77778
                ],
                "8910": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.76042
                ],
                "8911": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.76042
                ],
                "8912": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8913": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "8914": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.66667
                ],
                "8915": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.66667
                ],
                "8916": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.66667
                ],
                "8918": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "8919": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "8920": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    1.33334
                ],
                "8921": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    1.33334
                ],
                "8922": [
                    0.38569,
                    0.88569,
                    0,
                    0,
                    0.77778
                ],
                "8923": [
                    0.38569,
                    0.88569,
                    0,
                    0,
                    0.77778
                ],
                "8926": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "8927": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "8928": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8929": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8934": [
                    0.23222,
                    0.74111,
                    0,
                    0,
                    0.77778
                ],
                "8935": [
                    0.23222,
                    0.74111,
                    0,
                    0,
                    0.77778
                ],
                "8936": [
                    0.23222,
                    0.74111,
                    0,
                    0,
                    0.77778
                ],
                "8937": [
                    0.23222,
                    0.74111,
                    0,
                    0,
                    0.77778
                ],
                "8938": [
                    0.20576,
                    0.70576,
                    0,
                    0,
                    0.77778
                ],
                "8939": [
                    0.20576,
                    0.70576,
                    0,
                    0,
                    0.77778
                ],
                "8940": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8941": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "8994": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "8995": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.77778
                ],
                "9416": [
                    0.15559,
                    0.69224,
                    0,
                    0,
                    0.90222
                ],
                "9484": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.5
                ],
                "9488": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.5
                ],
                "9492": [
                    0,
                    0.37788,
                    0,
                    0,
                    0.5
                ],
                "9496": [
                    0,
                    0.37788,
                    0,
                    0,
                    0.5
                ],
                "9585": [
                    0.19444,
                    0.68889,
                    0,
                    0,
                    0.88889
                ],
                "9586": [
                    0.19444,
                    0.74111,
                    0,
                    0,
                    0.88889
                ],
                "9632": [
                    0,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "9633": [
                    0,
                    0.675,
                    0,
                    0,
                    0.77778
                ],
                "9650": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.72222
                ],
                "9651": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.72222
                ],
                "9654": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "9660": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.72222
                ],
                "9661": [
                    0,
                    0.54986,
                    0,
                    0,
                    0.72222
                ],
                "9664": [
                    0.03517,
                    0.54986,
                    0,
                    0,
                    0.77778
                ],
                "9674": [
                    0.11111,
                    0.69224,
                    0,
                    0,
                    0.66667
                ],
                "9733": [
                    0.19444,
                    0.69224,
                    0,
                    0,
                    0.94445
                ],
                "10003": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.83334
                ],
                "10016": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.83334
                ],
                "10731": [
                    0.11111,
                    0.69224,
                    0,
                    0,
                    0.66667
                ],
                "10846": [
                    0.19444,
                    0.75583,
                    0,
                    0,
                    0.61111
                ],
                "10877": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "10878": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "10885": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.77778
                ],
                "10886": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.77778
                ],
                "10887": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "10888": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "10889": [
                    0.26167,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10890": [
                    0.26167,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10891": [
                    0.48256,
                    0.98256,
                    0,
                    0,
                    0.77778
                ],
                "10892": [
                    0.48256,
                    0.98256,
                    0,
                    0,
                    0.77778
                ],
                "10901": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "10902": [
                    0.13667,
                    0.63667,
                    0,
                    0,
                    0.77778
                ],
                "10933": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10934": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10935": [
                    0.26167,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10936": [
                    0.26167,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10937": [
                    0.26167,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10938": [
                    0.26167,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "10949": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.77778
                ],
                "10950": [
                    0.25583,
                    0.75583,
                    0,
                    0,
                    0.77778
                ],
                "10955": [
                    0.28481,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "10956": [
                    0.28481,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "57350": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.22222
                ],
                "57351": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.38889
                ],
                "57352": [
                    0.08167,
                    0.58167,
                    0,
                    0,
                    0.77778
                ],
                "57353": [
                    0,
                    0.43056,
                    0.04028,
                    0,
                    0.66667
                ],
                "57356": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "57357": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "57358": [
                    0.41951,
                    0.91951,
                    0,
                    0,
                    0.77778
                ],
                "57359": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "57360": [
                    0.30274,
                    0.79383,
                    0,
                    0,
                    0.77778
                ],
                "57361": [
                    0.41951,
                    0.91951,
                    0,
                    0,
                    0.77778
                ],
                "57366": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "57367": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "57368": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "57369": [
                    0.25142,
                    0.75726,
                    0,
                    0,
                    0.77778
                ],
                "57370": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "57371": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ]
            },
            "Caligraphic-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "65": [
                    0,
                    0.68333,
                    0,
                    0.19445,
                    0.79847
                ],
                "66": [
                    0,
                    0.68333,
                    0.03041,
                    0.13889,
                    0.65681
                ],
                "67": [
                    0,
                    0.68333,
                    0.05834,
                    0.13889,
                    0.52653
                ],
                "68": [
                    0,
                    0.68333,
                    0.02778,
                    0.08334,
                    0.77139
                ],
                "69": [
                    0,
                    0.68333,
                    0.08944,
                    0.11111,
                    0.52778
                ],
                "70": [
                    0,
                    0.68333,
                    0.09931,
                    0.11111,
                    0.71875
                ],
                "71": [
                    0.09722,
                    0.68333,
                    0.0593,
                    0.11111,
                    0.59487
                ],
                "72": [
                    0,
                    0.68333,
                    0.00965,
                    0.11111,
                    0.84452
                ],
                "73": [
                    0,
                    0.68333,
                    0.07382,
                    0,
                    0.54452
                ],
                "74": [
                    0.09722,
                    0.68333,
                    0.18472,
                    0.16667,
                    0.67778
                ],
                "75": [
                    0,
                    0.68333,
                    0.01445,
                    0.05556,
                    0.76195
                ],
                "76": [
                    0,
                    0.68333,
                    0,
                    0.13889,
                    0.68972
                ],
                "77": [
                    0,
                    0.68333,
                    0,
                    0.13889,
                    1.2009
                ],
                "78": [
                    0,
                    0.68333,
                    0.14736,
                    0.08334,
                    0.82049
                ],
                "79": [
                    0,
                    0.68333,
                    0.02778,
                    0.11111,
                    0.79611
                ],
                "80": [
                    0,
                    0.68333,
                    0.08222,
                    0.08334,
                    0.69556
                ],
                "81": [
                    0.09722,
                    0.68333,
                    0,
                    0.11111,
                    0.81667
                ],
                "82": [
                    0,
                    0.68333,
                    0,
                    0.08334,
                    0.8475
                ],
                "83": [
                    0,
                    0.68333,
                    0.075,
                    0.13889,
                    0.60556
                ],
                "84": [
                    0,
                    0.68333,
                    0.25417,
                    0,
                    0.54464
                ],
                "85": [
                    0,
                    0.68333,
                    0.09931,
                    0.08334,
                    0.62583
                ],
                "86": [
                    0,
                    0.68333,
                    0.08222,
                    0,
                    0.61278
                ],
                "87": [
                    0,
                    0.68333,
                    0.08222,
                    0.08334,
                    0.98778
                ],
                "88": [
                    0,
                    0.68333,
                    0.14643,
                    0.13889,
                    0.7133
                ],
                "89": [
                    0.09722,
                    0.68333,
                    0.08222,
                    0.08334,
                    0.66834
                ],
                "90": [
                    0,
                    0.68333,
                    0.07944,
                    0.13889,
                    0.72473
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ]
            },
            "Fraktur-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.29574
                ],
                "34": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.21471
                ],
                "38": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.73786
                ],
                "39": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.21201
                ],
                "40": [
                    0.24982,
                    0.74947,
                    0,
                    0,
                    0.38865
                ],
                "41": [
                    0.24982,
                    0.74947,
                    0,
                    0,
                    0.38865
                ],
                "42": [
                    0,
                    0.62119,
                    0,
                    0,
                    0.27764
                ],
                "43": [
                    0.08319,
                    0.58283,
                    0,
                    0,
                    0.75623
                ],
                "44": [
                    0,
                    0.10803,
                    0,
                    0,
                    0.27764
                ],
                "45": [
                    0.08319,
                    0.58283,
                    0,
                    0,
                    0.75623
                ],
                "46": [
                    0,
                    0.10803,
                    0,
                    0,
                    0.27764
                ],
                "47": [
                    0.24982,
                    0.74947,
                    0,
                    0,
                    0.50181
                ],
                "48": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "49": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "50": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "51": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "52": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "53": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "54": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.50181
                ],
                "55": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "56": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.50181
                ],
                "57": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.50181
                ],
                "58": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.21606
                ],
                "59": [
                    0.12604,
                    0.47534,
                    0,
                    0,
                    0.21606
                ],
                "61": [
                    -0.13099,
                    0.36866,
                    0,
                    0,
                    0.75623
                ],
                "63": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.36245
                ],
                "65": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.7176
                ],
                "66": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.88397
                ],
                "67": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.61254
                ],
                "68": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.83158
                ],
                "69": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.66278
                ],
                "70": [
                    0.12604,
                    0.69141,
                    0,
                    0,
                    0.61119
                ],
                "71": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.78539
                ],
                "72": [
                    0.06302,
                    0.69141,
                    0,
                    0,
                    0.7203
                ],
                "73": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.55448
                ],
                "74": [
                    0.12604,
                    0.69141,
                    0,
                    0,
                    0.55231
                ],
                "75": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.66845
                ],
                "76": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.66602
                ],
                "77": [
                    0,
                    0.69141,
                    0,
                    0,
                    1.04953
                ],
                "78": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.83212
                ],
                "79": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.82699
                ],
                "80": [
                    0.18906,
                    0.69141,
                    0,
                    0,
                    0.82753
                ],
                "81": [
                    0.03781,
                    0.69141,
                    0,
                    0,
                    0.82699
                ],
                "82": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.82807
                ],
                "83": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.82861
                ],
                "84": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.66899
                ],
                "85": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.64576
                ],
                "86": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.83131
                ],
                "87": [
                    0,
                    0.69141,
                    0,
                    0,
                    1.04602
                ],
                "88": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.71922
                ],
                "89": [
                    0.18906,
                    0.69141,
                    0,
                    0,
                    0.83293
                ],
                "90": [
                    0.12604,
                    0.69141,
                    0,
                    0,
                    0.60201
                ],
                "91": [
                    0.24982,
                    0.74947,
                    0,
                    0,
                    0.27764
                ],
                "93": [
                    0.24982,
                    0.74947,
                    0,
                    0,
                    0.27764
                ],
                "94": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.49965
                ],
                "97": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.50046
                ],
                "98": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.51315
                ],
                "99": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.38946
                ],
                "100": [
                    0,
                    0.62119,
                    0,
                    0,
                    0.49857
                ],
                "101": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.40053
                ],
                "102": [
                    0.18906,
                    0.69141,
                    0,
                    0,
                    0.32626
                ],
                "103": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.5037
                ],
                "104": [
                    0.18906,
                    0.69141,
                    0,
                    0,
                    0.52126
                ],
                "105": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.27899
                ],
                "106": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.28088
                ],
                "107": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.38946
                ],
                "108": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.27953
                ],
                "109": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.76676
                ],
                "110": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.52666
                ],
                "111": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.48885
                ],
                "112": [
                    0.18906,
                    0.52396,
                    0,
                    0,
                    0.50046
                ],
                "113": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.48912
                ],
                "114": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.38919
                ],
                "115": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.44266
                ],
                "116": [
                    0,
                    0.62119,
                    0,
                    0,
                    0.33301
                ],
                "117": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.5172
                ],
                "118": [
                    0,
                    0.52396,
                    0,
                    0,
                    0.5118
                ],
                "119": [
                    0,
                    0.52396,
                    0,
                    0,
                    0.77351
                ],
                "120": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.38865
                ],
                "121": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.49884
                ],
                "122": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.39054
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "8216": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.21471
                ],
                "8217": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.21471
                ],
                "58112": [
                    0,
                    0.62119,
                    0,
                    0,
                    0.49749
                ],
                "58113": [
                    0,
                    0.62119,
                    0,
                    0,
                    0.4983
                ],
                "58114": [
                    0.18906,
                    0.69141,
                    0,
                    0,
                    0.33328
                ],
                "58115": [
                    0.18906,
                    0.69141,
                    0,
                    0,
                    0.32923
                ],
                "58116": [
                    0.18906,
                    0.47534,
                    0,
                    0,
                    0.50343
                ],
                "58117": [
                    0,
                    0.69141,
                    0,
                    0,
                    0.33301
                ],
                "58118": [
                    0,
                    0.62119,
                    0,
                    0,
                    0.33409
                ],
                "58119": [
                    0,
                    0.47534,
                    0,
                    0,
                    0.50073
                ]
            },
            "Main-Bold": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.35
                ],
                "34": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.60278
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.95833
                ],
                "36": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "37": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.95833
                ],
                "38": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "39": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "40": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44722
                ],
                "41": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44722
                ],
                "42": [
                    0,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "43": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "44": [
                    0.19444,
                    0.15556,
                    0,
                    0,
                    0.31944
                ],
                "45": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.38333
                ],
                "46": [
                    0,
                    0.15556,
                    0,
                    0,
                    0.31944
                ],
                "47": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "48": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "49": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "50": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "51": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "52": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "53": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "54": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "55": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "56": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "57": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "58": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.31944
                ],
                "59": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.31944
                ],
                "60": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.89444
                ],
                "61": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    0.89444
                ],
                "62": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.89444
                ],
                "63": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.54305
                ],
                "64": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "65": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.86944
                ],
                "66": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.81805
                ],
                "67": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.83055
                ],
                "68": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.88194
                ],
                "69": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.75555
                ],
                "70": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.72361
                ],
                "71": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.90416
                ],
                "72": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.9
                ],
                "73": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.43611
                ],
                "74": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.59444
                ],
                "75": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.90138
                ],
                "76": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.69166
                ],
                "77": [
                    0,
                    0.68611,
                    0,
                    0,
                    1.09166
                ],
                "78": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.9
                ],
                "79": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.86388
                ],
                "80": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.78611
                ],
                "81": [
                    0.19444,
                    0.68611,
                    0,
                    0,
                    0.86388
                ],
                "82": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.8625
                ],
                "83": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.63889
                ],
                "84": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.8
                ],
                "85": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.88472
                ],
                "86": [
                    0,
                    0.68611,
                    0.01597,
                    0,
                    0.86944
                ],
                "87": [
                    0,
                    0.68611,
                    0.01597,
                    0,
                    1.18888
                ],
                "88": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.86944
                ],
                "89": [
                    0,
                    0.68611,
                    0.02875,
                    0,
                    0.86944
                ],
                "90": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.70277
                ],
                "91": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.31944
                ],
                "92": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "93": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.31944
                ],
                "94": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "95": [
                    0.31,
                    0.13444,
                    0.03194,
                    0,
                    0.575
                ],
                "97": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.55902
                ],
                "98": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "99": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.51111
                ],
                "100": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "101": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.52708
                ],
                "102": [
                    0,
                    0.69444,
                    0.10903,
                    0,
                    0.35139
                ],
                "103": [
                    0.19444,
                    0.44444,
                    0.01597,
                    0,
                    0.575
                ],
                "104": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "105": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "106": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.35139
                ],
                "107": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.60694
                ],
                "108": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "109": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.95833
                ],
                "110": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.63889
                ],
                "111": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "112": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.63889
                ],
                "113": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.60694
                ],
                "114": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.47361
                ],
                "115": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.45361
                ],
                "116": [
                    0,
                    0.63492,
                    0,
                    0,
                    0.44722
                ],
                "117": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.63889
                ],
                "118": [
                    0,
                    0.44444,
                    0.01597,
                    0,
                    0.60694
                ],
                "119": [
                    0,
                    0.44444,
                    0.01597,
                    0,
                    0.83055
                ],
                "120": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.60694
                ],
                "121": [
                    0.19444,
                    0.44444,
                    0.01597,
                    0,
                    0.60694
                ],
                "122": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.51111
                ],
                "123": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "124": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.31944
                ],
                "125": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "126": [
                    0.35,
                    0.34444,
                    0,
                    0,
                    0.575
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "163": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.86853
                ],
                "168": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "172": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.76666
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.86944
                ],
                "177": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.51111
                ],
                "198": [
                    0,
                    0.68611,
                    0,
                    0,
                    1.04166
                ],
                "215": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "216": [
                    0.04861,
                    0.73472,
                    0,
                    0,
                    0.89444
                ],
                "223": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.59722
                ],
                "230": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.83055
                ],
                "247": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "248": [
                    0.09722,
                    0.54167,
                    0,
                    0,
                    0.575
                ],
                "305": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.31944
                ],
                "338": [
                    0,
                    0.68611,
                    0,
                    0,
                    1.16944
                ],
                "339": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.89444
                ],
                "567": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.35139
                ],
                "710": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "711": [
                    0,
                    0.63194,
                    0,
                    0,
                    0.575
                ],
                "713": [
                    0,
                    0.59611,
                    0,
                    0,
                    0.575
                ],
                "714": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "715": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "728": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "729": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.86944
                ],
                "732": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "733": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "915": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.69166
                ],
                "916": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.95833
                ],
                "920": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.89444
                ],
                "923": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.80555
                ],
                "926": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.76666
                ],
                "928": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.9
                ],
                "931": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.83055
                ],
                "933": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.89444
                ],
                "934": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.83055
                ],
                "936": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.89444
                ],
                "937": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.83055
                ],
                "8211": [
                    0,
                    0.44444,
                    0.03194,
                    0,
                    0.575
                ],
                "8212": [
                    0,
                    0.44444,
                    0.03194,
                    0,
                    1.14999
                ],
                "8216": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "8217": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "8220": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.60278
                ],
                "8221": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.60278
                ],
                "8224": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.51111
                ],
                "8225": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.51111
                ],
                "8242": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.34444
                ],
                "8407": [
                    0,
                    0.72444,
                    0.15486,
                    0,
                    0.575
                ],
                "8463": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66759
                ],
                "8465": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83055
                ],
                "8467": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.47361
                ],
                "8472": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.74027
                ],
                "8476": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83055
                ],
                "8501": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70277
                ],
                "8592": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8593": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "8594": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8595": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.575
                ],
                "8596": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8597": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "8598": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.14999
                ],
                "8599": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.14999
                ],
                "8600": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.14999
                ],
                "8601": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.14999
                ],
                "8636": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8637": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8640": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8641": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8656": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8657": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.70277
                ],
                "8658": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8659": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.70277
                ],
                "8660": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    1.14999
                ],
                "8661": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.70277
                ],
                "8704": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "8706": [
                    0,
                    0.69444,
                    0.06389,
                    0,
                    0.62847
                ],
                "8707": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "8709": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "8711": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.95833
                ],
                "8712": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.76666
                ],
                "8715": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.76666
                ],
                "8722": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8723": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8725": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "8726": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "8727": [
                    -0.02778,
                    0.47222,
                    0,
                    0,
                    0.575
                ],
                "8728": [
                    -0.02639,
                    0.47361,
                    0,
                    0,
                    0.575
                ],
                "8729": [
                    -0.02639,
                    0.47361,
                    0,
                    0,
                    0.575
                ],
                "8730": [
                    0.18,
                    0.82,
                    0,
                    0,
                    0.95833
                ],
                "8733": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.89444
                ],
                "8734": [
                    0,
                    0.44444,
                    0,
                    0,
                    1.14999
                ],
                "8736": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.72222
                ],
                "8739": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.31944
                ],
                "8741": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.575
                ],
                "8743": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8744": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8745": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8746": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8747": [
                    0.19444,
                    0.69444,
                    0.12778,
                    0,
                    0.56875
                ],
                "8764": [
                    -0.10889,
                    0.39111,
                    0,
                    0,
                    0.89444
                ],
                "8768": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.31944
                ],
                "8771": [
                    0.00222,
                    0.50222,
                    0,
                    0,
                    0.89444
                ],
                "8773": [
                    0.027,
                    0.638,
                    0,
                    0,
                    0.894
                ],
                "8776": [
                    0.02444,
                    0.52444,
                    0,
                    0,
                    0.89444
                ],
                "8781": [
                    0.00222,
                    0.50222,
                    0,
                    0,
                    0.89444
                ],
                "8801": [
                    0.00222,
                    0.50222,
                    0,
                    0,
                    0.89444
                ],
                "8804": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "8805": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "8810": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    1.14999
                ],
                "8811": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    1.14999
                ],
                "8826": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.89444
                ],
                "8827": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.89444
                ],
                "8834": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.89444
                ],
                "8835": [
                    0.08556,
                    0.58556,
                    0,
                    0,
                    0.89444
                ],
                "8838": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "8839": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "8846": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8849": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "8850": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "8851": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8852": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.76666
                ],
                "8853": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8854": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8855": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8856": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8857": [
                    0.13333,
                    0.63333,
                    0,
                    0,
                    0.89444
                ],
                "8866": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70277
                ],
                "8867": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70277
                ],
                "8868": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "8869": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "8900": [
                    -0.02639,
                    0.47361,
                    0,
                    0,
                    0.575
                ],
                "8901": [
                    -0.02639,
                    0.47361,
                    0,
                    0,
                    0.31944
                ],
                "8902": [
                    -0.02778,
                    0.47222,
                    0,
                    0,
                    0.575
                ],
                "8968": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.51111
                ],
                "8969": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.51111
                ],
                "8970": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.51111
                ],
                "8971": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.51111
                ],
                "8994": [
                    -0.13889,
                    0.36111,
                    0,
                    0,
                    1.14999
                ],
                "8995": [
                    -0.13889,
                    0.36111,
                    0,
                    0,
                    1.14999
                ],
                "9651": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.02222
                ],
                "9657": [
                    -0.02778,
                    0.47222,
                    0,
                    0,
                    0.575
                ],
                "9661": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.02222
                ],
                "9667": [
                    -0.02778,
                    0.47222,
                    0,
                    0,
                    0.575
                ],
                "9711": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.14999
                ],
                "9824": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "9825": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "9826": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "9827": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.89444
                ],
                "9837": [
                    0,
                    0.75,
                    0,
                    0,
                    0.44722
                ],
                "9838": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.44722
                ],
                "9839": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.44722
                ],
                "10216": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44722
                ],
                "10217": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44722
                ],
                "10815": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.9
                ],
                "10927": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "10928": [
                    0.19667,
                    0.69667,
                    0,
                    0,
                    0.89444
                ],
                "57376": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0
                ]
            },
            "Main-BoldItalic": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0.11417,
                    0,
                    0.38611
                ],
                "34": [
                    0,
                    0.69444,
                    0.07939,
                    0,
                    0.62055
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0.06833,
                    0,
                    0.94444
                ],
                "37": [
                    0.05556,
                    0.75,
                    0.12861,
                    0,
                    0.94444
                ],
                "38": [
                    0,
                    0.69444,
                    0.08528,
                    0,
                    0.88555
                ],
                "39": [
                    0,
                    0.69444,
                    0.12945,
                    0,
                    0.35555
                ],
                "40": [
                    0.25,
                    0.75,
                    0.15806,
                    0,
                    0.47333
                ],
                "41": [
                    0.25,
                    0.75,
                    0.03306,
                    0,
                    0.47333
                ],
                "42": [
                    0,
                    0.75,
                    0.14333,
                    0,
                    0.59111
                ],
                "43": [
                    0.10333,
                    0.60333,
                    0.03306,
                    0,
                    0.88555
                ],
                "44": [
                    0.19444,
                    0.14722,
                    0,
                    0,
                    0.35555
                ],
                "45": [
                    0,
                    0.44444,
                    0.02611,
                    0,
                    0.41444
                ],
                "46": [
                    0,
                    0.14722,
                    0,
                    0,
                    0.35555
                ],
                "47": [
                    0.25,
                    0.75,
                    0.15806,
                    0,
                    0.59111
                ],
                "48": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "49": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "50": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "51": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "52": [
                    0.19444,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "53": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "54": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "55": [
                    0.19444,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "56": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "57": [
                    0,
                    0.64444,
                    0.13167,
                    0,
                    0.59111
                ],
                "58": [
                    0,
                    0.44444,
                    0.06695,
                    0,
                    0.35555
                ],
                "59": [
                    0.19444,
                    0.44444,
                    0.06695,
                    0,
                    0.35555
                ],
                "61": [
                    -0.10889,
                    0.39111,
                    0.06833,
                    0,
                    0.88555
                ],
                "63": [
                    0,
                    0.69444,
                    0.11472,
                    0,
                    0.59111
                ],
                "64": [
                    0,
                    0.69444,
                    0.09208,
                    0,
                    0.88555
                ],
                "65": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.86555
                ],
                "66": [
                    0,
                    0.68611,
                    0.0992,
                    0,
                    0.81666
                ],
                "67": [
                    0,
                    0.68611,
                    0.14208,
                    0,
                    0.82666
                ],
                "68": [
                    0,
                    0.68611,
                    0.09062,
                    0,
                    0.87555
                ],
                "69": [
                    0,
                    0.68611,
                    0.11431,
                    0,
                    0.75666
                ],
                "70": [
                    0,
                    0.68611,
                    0.12903,
                    0,
                    0.72722
                ],
                "71": [
                    0,
                    0.68611,
                    0.07347,
                    0,
                    0.89527
                ],
                "72": [
                    0,
                    0.68611,
                    0.17208,
                    0,
                    0.8961
                ],
                "73": [
                    0,
                    0.68611,
                    0.15681,
                    0,
                    0.47166
                ],
                "74": [
                    0,
                    0.68611,
                    0.145,
                    0,
                    0.61055
                ],
                "75": [
                    0,
                    0.68611,
                    0.14208,
                    0,
                    0.89499
                ],
                "76": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.69777
                ],
                "77": [
                    0,
                    0.68611,
                    0.17208,
                    0,
                    1.07277
                ],
                "78": [
                    0,
                    0.68611,
                    0.17208,
                    0,
                    0.8961
                ],
                "79": [
                    0,
                    0.68611,
                    0.09062,
                    0,
                    0.85499
                ],
                "80": [
                    0,
                    0.68611,
                    0.0992,
                    0,
                    0.78721
                ],
                "81": [
                    0.19444,
                    0.68611,
                    0.09062,
                    0,
                    0.85499
                ],
                "82": [
                    0,
                    0.68611,
                    0.02559,
                    0,
                    0.85944
                ],
                "83": [
                    0,
                    0.68611,
                    0.11264,
                    0,
                    0.64999
                ],
                "84": [
                    0,
                    0.68611,
                    0.12903,
                    0,
                    0.7961
                ],
                "85": [
                    0,
                    0.68611,
                    0.17208,
                    0,
                    0.88083
                ],
                "86": [
                    0,
                    0.68611,
                    0.18625,
                    0,
                    0.86555
                ],
                "87": [
                    0,
                    0.68611,
                    0.18625,
                    0,
                    1.15999
                ],
                "88": [
                    0,
                    0.68611,
                    0.15681,
                    0,
                    0.86555
                ],
                "89": [
                    0,
                    0.68611,
                    0.19803,
                    0,
                    0.86555
                ],
                "90": [
                    0,
                    0.68611,
                    0.14208,
                    0,
                    0.70888
                ],
                "91": [
                    0.25,
                    0.75,
                    0.1875,
                    0,
                    0.35611
                ],
                "93": [
                    0.25,
                    0.75,
                    0.09972,
                    0,
                    0.35611
                ],
                "94": [
                    0,
                    0.69444,
                    0.06709,
                    0,
                    0.59111
                ],
                "95": [
                    0.31,
                    0.13444,
                    0.09811,
                    0,
                    0.59111
                ],
                "97": [
                    0,
                    0.44444,
                    0.09426,
                    0,
                    0.59111
                ],
                "98": [
                    0,
                    0.69444,
                    0.07861,
                    0,
                    0.53222
                ],
                "99": [
                    0,
                    0.44444,
                    0.05222,
                    0,
                    0.53222
                ],
                "100": [
                    0,
                    0.69444,
                    0.10861,
                    0,
                    0.59111
                ],
                "101": [
                    0,
                    0.44444,
                    0.085,
                    0,
                    0.53222
                ],
                "102": [
                    0.19444,
                    0.69444,
                    0.21778,
                    0,
                    0.4
                ],
                "103": [
                    0.19444,
                    0.44444,
                    0.105,
                    0,
                    0.53222
                ],
                "104": [
                    0,
                    0.69444,
                    0.09426,
                    0,
                    0.59111
                ],
                "105": [
                    0,
                    0.69326,
                    0.11387,
                    0,
                    0.35555
                ],
                "106": [
                    0.19444,
                    0.69326,
                    0.1672,
                    0,
                    0.35555
                ],
                "107": [
                    0,
                    0.69444,
                    0.11111,
                    0,
                    0.53222
                ],
                "108": [
                    0,
                    0.69444,
                    0.10861,
                    0,
                    0.29666
                ],
                "109": [
                    0,
                    0.44444,
                    0.09426,
                    0,
                    0.94444
                ],
                "110": [
                    0,
                    0.44444,
                    0.09426,
                    0,
                    0.64999
                ],
                "111": [
                    0,
                    0.44444,
                    0.07861,
                    0,
                    0.59111
                ],
                "112": [
                    0.19444,
                    0.44444,
                    0.07861,
                    0,
                    0.59111
                ],
                "113": [
                    0.19444,
                    0.44444,
                    0.105,
                    0,
                    0.53222
                ],
                "114": [
                    0,
                    0.44444,
                    0.11111,
                    0,
                    0.50167
                ],
                "115": [
                    0,
                    0.44444,
                    0.08167,
                    0,
                    0.48694
                ],
                "116": [
                    0,
                    0.63492,
                    0.09639,
                    0,
                    0.385
                ],
                "117": [
                    0,
                    0.44444,
                    0.09426,
                    0,
                    0.62055
                ],
                "118": [
                    0,
                    0.44444,
                    0.11111,
                    0,
                    0.53222
                ],
                "119": [
                    0,
                    0.44444,
                    0.11111,
                    0,
                    0.76777
                ],
                "120": [
                    0,
                    0.44444,
                    0.12583,
                    0,
                    0.56055
                ],
                "121": [
                    0.19444,
                    0.44444,
                    0.105,
                    0,
                    0.56166
                ],
                "122": [
                    0,
                    0.44444,
                    0.13889,
                    0,
                    0.49055
                ],
                "126": [
                    0.35,
                    0.34444,
                    0.11472,
                    0,
                    0.59111
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "168": [
                    0,
                    0.69444,
                    0.11473,
                    0,
                    0.59111
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.94888
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.53222
                ],
                "198": [
                    0,
                    0.68611,
                    0.11431,
                    0,
                    1.02277
                ],
                "216": [
                    0.04861,
                    0.73472,
                    0.09062,
                    0,
                    0.88555
                ],
                "223": [
                    0.19444,
                    0.69444,
                    0.09736,
                    0,
                    0.665
                ],
                "230": [
                    0,
                    0.44444,
                    0.085,
                    0,
                    0.82666
                ],
                "248": [
                    0.09722,
                    0.54167,
                    0.09458,
                    0,
                    0.59111
                ],
                "305": [
                    0,
                    0.44444,
                    0.09426,
                    0,
                    0.35555
                ],
                "338": [
                    0,
                    0.68611,
                    0.11431,
                    0,
                    1.14054
                ],
                "339": [
                    0,
                    0.44444,
                    0.085,
                    0,
                    0.82666
                ],
                "567": [
                    0.19444,
                    0.44444,
                    0.04611,
                    0,
                    0.385
                ],
                "710": [
                    0,
                    0.69444,
                    0.06709,
                    0,
                    0.59111
                ],
                "711": [
                    0,
                    0.63194,
                    0.08271,
                    0,
                    0.59111
                ],
                "713": [
                    0,
                    0.59444,
                    0.10444,
                    0,
                    0.59111
                ],
                "714": [
                    0,
                    0.69444,
                    0.08528,
                    0,
                    0.59111
                ],
                "715": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.59111
                ],
                "728": [
                    0,
                    0.69444,
                    0.10333,
                    0,
                    0.59111
                ],
                "729": [
                    0,
                    0.69444,
                    0.12945,
                    0,
                    0.35555
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.94888
                ],
                "732": [
                    0,
                    0.69444,
                    0.11472,
                    0,
                    0.59111
                ],
                "733": [
                    0,
                    0.69444,
                    0.11472,
                    0,
                    0.59111
                ],
                "915": [
                    0,
                    0.68611,
                    0.12903,
                    0,
                    0.69777
                ],
                "916": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.94444
                ],
                "920": [
                    0,
                    0.68611,
                    0.09062,
                    0,
                    0.88555
                ],
                "923": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.80666
                ],
                "926": [
                    0,
                    0.68611,
                    0.15092,
                    0,
                    0.76777
                ],
                "928": [
                    0,
                    0.68611,
                    0.17208,
                    0,
                    0.8961
                ],
                "931": [
                    0,
                    0.68611,
                    0.11431,
                    0,
                    0.82666
                ],
                "933": [
                    0,
                    0.68611,
                    0.10778,
                    0,
                    0.88555
                ],
                "934": [
                    0,
                    0.68611,
                    0.05632,
                    0,
                    0.82666
                ],
                "936": [
                    0,
                    0.68611,
                    0.10778,
                    0,
                    0.88555
                ],
                "937": [
                    0,
                    0.68611,
                    0.0992,
                    0,
                    0.82666
                ],
                "8211": [
                    0,
                    0.44444,
                    0.09811,
                    0,
                    0.59111
                ],
                "8212": [
                    0,
                    0.44444,
                    0.09811,
                    0,
                    1.18221
                ],
                "8216": [
                    0,
                    0.69444,
                    0.12945,
                    0,
                    0.35555
                ],
                "8217": [
                    0,
                    0.69444,
                    0.12945,
                    0,
                    0.35555
                ],
                "8220": [
                    0,
                    0.69444,
                    0.16772,
                    0,
                    0.62055
                ],
                "8221": [
                    0,
                    0.69444,
                    0.07939,
                    0,
                    0.62055
                ]
            },
            "Main-Italic": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0.12417,
                    0,
                    0.30667
                ],
                "34": [
                    0,
                    0.69444,
                    0.06961,
                    0,
                    0.51444
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0.06616,
                    0,
                    0.81777
                ],
                "37": [
                    0.05556,
                    0.75,
                    0.13639,
                    0,
                    0.81777
                ],
                "38": [
                    0,
                    0.69444,
                    0.09694,
                    0,
                    0.76666
                ],
                "39": [
                    0,
                    0.69444,
                    0.12417,
                    0,
                    0.30667
                ],
                "40": [
                    0.25,
                    0.75,
                    0.16194,
                    0,
                    0.40889
                ],
                "41": [
                    0.25,
                    0.75,
                    0.03694,
                    0,
                    0.40889
                ],
                "42": [
                    0,
                    0.75,
                    0.14917,
                    0,
                    0.51111
                ],
                "43": [
                    0.05667,
                    0.56167,
                    0.03694,
                    0,
                    0.76666
                ],
                "44": [
                    0.19444,
                    0.10556,
                    0,
                    0,
                    0.30667
                ],
                "45": [
                    0,
                    0.43056,
                    0.02826,
                    0,
                    0.35778
                ],
                "46": [
                    0,
                    0.10556,
                    0,
                    0,
                    0.30667
                ],
                "47": [
                    0.25,
                    0.75,
                    0.16194,
                    0,
                    0.51111
                ],
                "48": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "49": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "50": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "51": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "52": [
                    0.19444,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "53": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "54": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "55": [
                    0.19444,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "56": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "57": [
                    0,
                    0.64444,
                    0.13556,
                    0,
                    0.51111
                ],
                "58": [
                    0,
                    0.43056,
                    0.0582,
                    0,
                    0.30667
                ],
                "59": [
                    0.19444,
                    0.43056,
                    0.0582,
                    0,
                    0.30667
                ],
                "61": [
                    -0.13313,
                    0.36687,
                    0.06616,
                    0,
                    0.76666
                ],
                "63": [
                    0,
                    0.69444,
                    0.1225,
                    0,
                    0.51111
                ],
                "64": [
                    0,
                    0.69444,
                    0.09597,
                    0,
                    0.76666
                ],
                "65": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.74333
                ],
                "66": [
                    0,
                    0.68333,
                    0.10257,
                    0,
                    0.70389
                ],
                "67": [
                    0,
                    0.68333,
                    0.14528,
                    0,
                    0.71555
                ],
                "68": [
                    0,
                    0.68333,
                    0.09403,
                    0,
                    0.755
                ],
                "69": [
                    0,
                    0.68333,
                    0.12028,
                    0,
                    0.67833
                ],
                "70": [
                    0,
                    0.68333,
                    0.13305,
                    0,
                    0.65277
                ],
                "71": [
                    0,
                    0.68333,
                    0.08722,
                    0,
                    0.77361
                ],
                "72": [
                    0,
                    0.68333,
                    0.16389,
                    0,
                    0.74333
                ],
                "73": [
                    0,
                    0.68333,
                    0.15806,
                    0,
                    0.38555
                ],
                "74": [
                    0,
                    0.68333,
                    0.14028,
                    0,
                    0.525
                ],
                "75": [
                    0,
                    0.68333,
                    0.14528,
                    0,
                    0.76888
                ],
                "76": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.62722
                ],
                "77": [
                    0,
                    0.68333,
                    0.16389,
                    0,
                    0.89666
                ],
                "78": [
                    0,
                    0.68333,
                    0.16389,
                    0,
                    0.74333
                ],
                "79": [
                    0,
                    0.68333,
                    0.09403,
                    0,
                    0.76666
                ],
                "80": [
                    0,
                    0.68333,
                    0.10257,
                    0,
                    0.67833
                ],
                "81": [
                    0.19444,
                    0.68333,
                    0.09403,
                    0,
                    0.76666
                ],
                "82": [
                    0,
                    0.68333,
                    0.03868,
                    0,
                    0.72944
                ],
                "83": [
                    0,
                    0.68333,
                    0.11972,
                    0,
                    0.56222
                ],
                "84": [
                    0,
                    0.68333,
                    0.13305,
                    0,
                    0.71555
                ],
                "85": [
                    0,
                    0.68333,
                    0.16389,
                    0,
                    0.74333
                ],
                "86": [
                    0,
                    0.68333,
                    0.18361,
                    0,
                    0.74333
                ],
                "87": [
                    0,
                    0.68333,
                    0.18361,
                    0,
                    0.99888
                ],
                "88": [
                    0,
                    0.68333,
                    0.15806,
                    0,
                    0.74333
                ],
                "89": [
                    0,
                    0.68333,
                    0.19383,
                    0,
                    0.74333
                ],
                "90": [
                    0,
                    0.68333,
                    0.14528,
                    0,
                    0.61333
                ],
                "91": [
                    0.25,
                    0.75,
                    0.1875,
                    0,
                    0.30667
                ],
                "93": [
                    0.25,
                    0.75,
                    0.10528,
                    0,
                    0.30667
                ],
                "94": [
                    0,
                    0.69444,
                    0.06646,
                    0,
                    0.51111
                ],
                "95": [
                    0.31,
                    0.12056,
                    0.09208,
                    0,
                    0.51111
                ],
                "97": [
                    0,
                    0.43056,
                    0.07671,
                    0,
                    0.51111
                ],
                "98": [
                    0,
                    0.69444,
                    0.06312,
                    0,
                    0.46
                ],
                "99": [
                    0,
                    0.43056,
                    0.05653,
                    0,
                    0.46
                ],
                "100": [
                    0,
                    0.69444,
                    0.10333,
                    0,
                    0.51111
                ],
                "101": [
                    0,
                    0.43056,
                    0.07514,
                    0,
                    0.46
                ],
                "102": [
                    0.19444,
                    0.69444,
                    0.21194,
                    0,
                    0.30667
                ],
                "103": [
                    0.19444,
                    0.43056,
                    0.08847,
                    0,
                    0.46
                ],
                "104": [
                    0,
                    0.69444,
                    0.07671,
                    0,
                    0.51111
                ],
                "105": [
                    0,
                    0.65536,
                    0.1019,
                    0,
                    0.30667
                ],
                "106": [
                    0.19444,
                    0.65536,
                    0.14467,
                    0,
                    0.30667
                ],
                "107": [
                    0,
                    0.69444,
                    0.10764,
                    0,
                    0.46
                ],
                "108": [
                    0,
                    0.69444,
                    0.10333,
                    0,
                    0.25555
                ],
                "109": [
                    0,
                    0.43056,
                    0.07671,
                    0,
                    0.81777
                ],
                "110": [
                    0,
                    0.43056,
                    0.07671,
                    0,
                    0.56222
                ],
                "111": [
                    0,
                    0.43056,
                    0.06312,
                    0,
                    0.51111
                ],
                "112": [
                    0.19444,
                    0.43056,
                    0.06312,
                    0,
                    0.51111
                ],
                "113": [
                    0.19444,
                    0.43056,
                    0.08847,
                    0,
                    0.46
                ],
                "114": [
                    0,
                    0.43056,
                    0.10764,
                    0,
                    0.42166
                ],
                "115": [
                    0,
                    0.43056,
                    0.08208,
                    0,
                    0.40889
                ],
                "116": [
                    0,
                    0.61508,
                    0.09486,
                    0,
                    0.33222
                ],
                "117": [
                    0,
                    0.43056,
                    0.07671,
                    0,
                    0.53666
                ],
                "118": [
                    0,
                    0.43056,
                    0.10764,
                    0,
                    0.46
                ],
                "119": [
                    0,
                    0.43056,
                    0.10764,
                    0,
                    0.66444
                ],
                "120": [
                    0,
                    0.43056,
                    0.12042,
                    0,
                    0.46389
                ],
                "121": [
                    0.19444,
                    0.43056,
                    0.08847,
                    0,
                    0.48555
                ],
                "122": [
                    0,
                    0.43056,
                    0.12292,
                    0,
                    0.40889
                ],
                "126": [
                    0.35,
                    0.31786,
                    0.11585,
                    0,
                    0.51111
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "168": [
                    0,
                    0.66786,
                    0.10474,
                    0,
                    0.51111
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83129
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.46
                ],
                "198": [
                    0,
                    0.68333,
                    0.12028,
                    0,
                    0.88277
                ],
                "216": [
                    0.04861,
                    0.73194,
                    0.09403,
                    0,
                    0.76666
                ],
                "223": [
                    0.19444,
                    0.69444,
                    0.10514,
                    0,
                    0.53666
                ],
                "230": [
                    0,
                    0.43056,
                    0.07514,
                    0,
                    0.71555
                ],
                "248": [
                    0.09722,
                    0.52778,
                    0.09194,
                    0,
                    0.51111
                ],
                "338": [
                    0,
                    0.68333,
                    0.12028,
                    0,
                    0.98499
                ],
                "339": [
                    0,
                    0.43056,
                    0.07514,
                    0,
                    0.71555
                ],
                "710": [
                    0,
                    0.69444,
                    0.06646,
                    0,
                    0.51111
                ],
                "711": [
                    0,
                    0.62847,
                    0.08295,
                    0,
                    0.51111
                ],
                "713": [
                    0,
                    0.56167,
                    0.10333,
                    0,
                    0.51111
                ],
                "714": [
                    0,
                    0.69444,
                    0.09694,
                    0,
                    0.51111
                ],
                "715": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.51111
                ],
                "728": [
                    0,
                    0.69444,
                    0.10806,
                    0,
                    0.51111
                ],
                "729": [
                    0,
                    0.66786,
                    0.11752,
                    0,
                    0.30667
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83129
                ],
                "732": [
                    0,
                    0.66786,
                    0.11585,
                    0,
                    0.51111
                ],
                "733": [
                    0,
                    0.69444,
                    0.1225,
                    0,
                    0.51111
                ],
                "915": [
                    0,
                    0.68333,
                    0.13305,
                    0,
                    0.62722
                ],
                "916": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.81777
                ],
                "920": [
                    0,
                    0.68333,
                    0.09403,
                    0,
                    0.76666
                ],
                "923": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.69222
                ],
                "926": [
                    0,
                    0.68333,
                    0.15294,
                    0,
                    0.66444
                ],
                "928": [
                    0,
                    0.68333,
                    0.16389,
                    0,
                    0.74333
                ],
                "931": [
                    0,
                    0.68333,
                    0.12028,
                    0,
                    0.71555
                ],
                "933": [
                    0,
                    0.68333,
                    0.11111,
                    0,
                    0.76666
                ],
                "934": [
                    0,
                    0.68333,
                    0.05986,
                    0,
                    0.71555
                ],
                "936": [
                    0,
                    0.68333,
                    0.11111,
                    0,
                    0.76666
                ],
                "937": [
                    0,
                    0.68333,
                    0.10257,
                    0,
                    0.71555
                ],
                "8211": [
                    0,
                    0.43056,
                    0.09208,
                    0,
                    0.51111
                ],
                "8212": [
                    0,
                    0.43056,
                    0.09208,
                    0,
                    1.02222
                ],
                "8216": [
                    0,
                    0.69444,
                    0.12417,
                    0,
                    0.30667
                ],
                "8217": [
                    0,
                    0.69444,
                    0.12417,
                    0,
                    0.30667
                ],
                "8220": [
                    0,
                    0.69444,
                    0.1685,
                    0,
                    0.51444
                ],
                "8221": [
                    0,
                    0.69444,
                    0.06961,
                    0,
                    0.51444
                ],
                "8463": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.54028
                ]
            },
            "Main-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "34": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.83334
                ],
                "36": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "37": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "38": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "39": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "40": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "41": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "42": [
                    0,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "43": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "44": [
                    0.19444,
                    0.10556,
                    0,
                    0,
                    0.27778
                ],
                "45": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.33333
                ],
                "46": [
                    0,
                    0.10556,
                    0,
                    0,
                    0.27778
                ],
                "47": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "48": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "49": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "50": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "51": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "52": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "53": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "54": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "55": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "56": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "57": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "58": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.27778
                ],
                "59": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.27778
                ],
                "60": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "61": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    0.77778
                ],
                "62": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "63": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.47222
                ],
                "64": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "65": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "66": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.70834
                ],
                "67": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.72222
                ],
                "68": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.76389
                ],
                "69": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.68056
                ],
                "70": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.65278
                ],
                "71": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.78472
                ],
                "72": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "73": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.36111
                ],
                "74": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.51389
                ],
                "75": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.77778
                ],
                "76": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.625
                ],
                "77": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.91667
                ],
                "78": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "79": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.77778
                ],
                "80": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.68056
                ],
                "81": [
                    0.19444,
                    0.68333,
                    0,
                    0,
                    0.77778
                ],
                "82": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.73611
                ],
                "83": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.55556
                ],
                "84": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.72222
                ],
                "85": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "86": [
                    0,
                    0.68333,
                    0.01389,
                    0,
                    0.75
                ],
                "87": [
                    0,
                    0.68333,
                    0.01389,
                    0,
                    1.02778
                ],
                "88": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "89": [
                    0,
                    0.68333,
                    0.025,
                    0,
                    0.75
                ],
                "90": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.61111
                ],
                "91": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.27778
                ],
                "92": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "93": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.27778
                ],
                "94": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "95": [
                    0.31,
                    0.12056,
                    0.02778,
                    0,
                    0.5
                ],
                "97": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "98": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55556
                ],
                "99": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.44445
                ],
                "100": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55556
                ],
                "101": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.44445
                ],
                "102": [
                    0,
                    0.69444,
                    0.07778,
                    0,
                    0.30556
                ],
                "103": [
                    0.19444,
                    0.43056,
                    0.01389,
                    0,
                    0.5
                ],
                "104": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55556
                ],
                "105": [
                    0,
                    0.66786,
                    0,
                    0,
                    0.27778
                ],
                "106": [
                    0.19444,
                    0.66786,
                    0,
                    0,
                    0.30556
                ],
                "107": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.52778
                ],
                "108": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "109": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.83334
                ],
                "110": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.55556
                ],
                "111": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "112": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.55556
                ],
                "113": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.52778
                ],
                "114": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.39167
                ],
                "115": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.39445
                ],
                "116": [
                    0,
                    0.61508,
                    0,
                    0,
                    0.38889
                ],
                "117": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.55556
                ],
                "118": [
                    0,
                    0.43056,
                    0.01389,
                    0,
                    0.52778
                ],
                "119": [
                    0,
                    0.43056,
                    0.01389,
                    0,
                    0.72222
                ],
                "120": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.52778
                ],
                "121": [
                    0.19444,
                    0.43056,
                    0.01389,
                    0,
                    0.52778
                ],
                "122": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.44445
                ],
                "123": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "124": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.27778
                ],
                "125": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "126": [
                    0.35,
                    0.31786,
                    0,
                    0,
                    0.5
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "163": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.76909
                ],
                "167": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.44445
                ],
                "168": [
                    0,
                    0.66786,
                    0,
                    0,
                    0.5
                ],
                "172": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.66667
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.75
                ],
                "177": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "182": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.44445
                ],
                "198": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.90278
                ],
                "215": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "216": [
                    0.04861,
                    0.73194,
                    0,
                    0,
                    0.77778
                ],
                "223": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "230": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.72222
                ],
                "247": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "248": [
                    0.09722,
                    0.52778,
                    0,
                    0,
                    0.5
                ],
                "305": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.27778
                ],
                "338": [
                    0,
                    0.68333,
                    0,
                    0,
                    1.01389
                ],
                "339": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.77778
                ],
                "567": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.30556
                ],
                "710": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "711": [
                    0,
                    0.62847,
                    0,
                    0,
                    0.5
                ],
                "713": [
                    0,
                    0.56778,
                    0,
                    0,
                    0.5
                ],
                "714": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "715": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "728": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "729": [
                    0,
                    0.66786,
                    0,
                    0,
                    0.27778
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.75
                ],
                "732": [
                    0,
                    0.66786,
                    0,
                    0,
                    0.5
                ],
                "733": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "915": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.625
                ],
                "916": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.83334
                ],
                "920": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.77778
                ],
                "923": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.69445
                ],
                "926": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.66667
                ],
                "928": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "931": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.72222
                ],
                "933": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.77778
                ],
                "934": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.72222
                ],
                "936": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.77778
                ],
                "937": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.72222
                ],
                "8211": [
                    0,
                    0.43056,
                    0.02778,
                    0,
                    0.5
                ],
                "8212": [
                    0,
                    0.43056,
                    0.02778,
                    0,
                    1.0
                ],
                "8216": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "8217": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "8220": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "8221": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "8224": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.44445
                ],
                "8225": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.44445
                ],
                "8230": [
                    0,
                    0.123,
                    0,
                    0,
                    1.172
                ],
                "8242": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.275
                ],
                "8407": [
                    0,
                    0.71444,
                    0.15382,
                    0,
                    0.5
                ],
                "8463": [
                    0,
                    0.68889,
                    0,
                    0,
                    0.54028
                ],
                "8465": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.72222
                ],
                "8467": [
                    0,
                    0.69444,
                    0,
                    0.11111,
                    0.41667
                ],
                "8472": [
                    0.19444,
                    0.43056,
                    0,
                    0.11111,
                    0.63646
                ],
                "8476": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.72222
                ],
                "8501": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "8592": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8593": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "8594": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8595": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "8596": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8597": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "8598": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.0
                ],
                "8599": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.0
                ],
                "8600": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.0
                ],
                "8601": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.0
                ],
                "8614": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.0
                ],
                "8617": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.126
                ],
                "8618": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.126
                ],
                "8636": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8637": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8640": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8641": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8652": [
                    0.011,
                    0.671,
                    0,
                    0,
                    1.0
                ],
                "8656": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8657": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "8658": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8659": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "8660": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    1.0
                ],
                "8661": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.61111
                ],
                "8704": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55556
                ],
                "8706": [
                    0,
                    0.69444,
                    0.05556,
                    0.08334,
                    0.5309
                ],
                "8707": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55556
                ],
                "8709": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "8711": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.83334
                ],
                "8712": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.66667
                ],
                "8715": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.66667
                ],
                "8722": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8723": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8725": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "8726": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "8727": [
                    -0.03472,
                    0.46528,
                    0,
                    0,
                    0.5
                ],
                "8728": [
                    -0.05555,
                    0.44445,
                    0,
                    0,
                    0.5
                ],
                "8729": [
                    -0.05555,
                    0.44445,
                    0,
                    0,
                    0.5
                ],
                "8730": [
                    0.2,
                    0.8,
                    0,
                    0,
                    0.83334
                ],
                "8733": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.77778
                ],
                "8734": [
                    0,
                    0.43056,
                    0,
                    0,
                    1.0
                ],
                "8736": [
                    0,
                    0.69224,
                    0,
                    0,
                    0.72222
                ],
                "8739": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.27778
                ],
                "8741": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "8743": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8744": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8745": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8746": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8747": [
                    0.19444,
                    0.69444,
                    0.11111,
                    0,
                    0.41667
                ],
                "8764": [
                    -0.13313,
                    0.36687,
                    0,
                    0,
                    0.77778
                ],
                "8768": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "8771": [
                    -0.03625,
                    0.46375,
                    0,
                    0,
                    0.77778
                ],
                "8773": [
                    -0.022,
                    0.589,
                    0,
                    0,
                    0.778
                ],
                "8776": [
                    -0.01688,
                    0.48312,
                    0,
                    0,
                    0.77778
                ],
                "8781": [
                    -0.03625,
                    0.46375,
                    0,
                    0,
                    0.77778
                ],
                "8784": [
                    -0.133,
                    0.673,
                    0,
                    0,
                    0.778
                ],
                "8801": [
                    -0.03625,
                    0.46375,
                    0,
                    0,
                    0.77778
                ],
                "8804": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8805": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8810": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    1.0
                ],
                "8811": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    1.0
                ],
                "8826": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "8827": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "8834": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "8835": [
                    0.0391,
                    0.5391,
                    0,
                    0,
                    0.77778
                ],
                "8838": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8839": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8846": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8849": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8850": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "8851": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8852": [
                    0,
                    0.55556,
                    0,
                    0,
                    0.66667
                ],
                "8853": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8854": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8855": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8856": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8857": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "8866": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "8867": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "8868": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "8869": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "8872": [
                    0.249,
                    0.75,
                    0,
                    0,
                    0.867
                ],
                "8900": [
                    -0.05555,
                    0.44445,
                    0,
                    0,
                    0.5
                ],
                "8901": [
                    -0.05555,
                    0.44445,
                    0,
                    0,
                    0.27778
                ],
                "8902": [
                    -0.03472,
                    0.46528,
                    0,
                    0,
                    0.5
                ],
                "8904": [
                    0.005,
                    0.505,
                    0,
                    0,
                    0.9
                ],
                "8942": [
                    0.03,
                    0.903,
                    0,
                    0,
                    0.278
                ],
                "8943": [
                    -0.19,
                    0.313,
                    0,
                    0,
                    1.172
                ],
                "8945": [
                    -0.1,
                    0.823,
                    0,
                    0,
                    1.282
                ],
                "8968": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44445
                ],
                "8969": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44445
                ],
                "8970": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44445
                ],
                "8971": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.44445
                ],
                "8994": [
                    -0.14236,
                    0.35764,
                    0,
                    0,
                    1.0
                ],
                "8995": [
                    -0.14236,
                    0.35764,
                    0,
                    0,
                    1.0
                ],
                "9136": [
                    0.244,
                    0.744,
                    0,
                    0,
                    0.412
                ],
                "9137": [
                    0.244,
                    0.745,
                    0,
                    0,
                    0.412
                ],
                "9651": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.88889
                ],
                "9657": [
                    -0.03472,
                    0.46528,
                    0,
                    0,
                    0.5
                ],
                "9661": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.88889
                ],
                "9667": [
                    -0.03472,
                    0.46528,
                    0,
                    0,
                    0.5
                ],
                "9711": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    1.0
                ],
                "9824": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "9825": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "9826": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "9827": [
                    0.12963,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "9837": [
                    0,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "9838": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.38889
                ],
                "9839": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.38889
                ],
                "10216": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "10217": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "10222": [
                    0.244,
                    0.744,
                    0,
                    0,
                    0.412
                ],
                "10223": [
                    0.244,
                    0.745,
                    0,
                    0,
                    0.412
                ],
                "10229": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.609
                ],
                "10230": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.638
                ],
                "10231": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.859
                ],
                "10232": [
                    0.024,
                    0.525,
                    0,
                    0,
                    1.609
                ],
                "10233": [
                    0.024,
                    0.525,
                    0,
                    0,
                    1.638
                ],
                "10234": [
                    0.024,
                    0.525,
                    0,
                    0,
                    1.858
                ],
                "10236": [
                    0.011,
                    0.511,
                    0,
                    0,
                    1.638
                ],
                "10815": [
                    0,
                    0.68333,
                    0,
                    0,
                    0.75
                ],
                "10927": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "10928": [
                    0.13597,
                    0.63597,
                    0,
                    0,
                    0.77778
                ],
                "57376": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0
                ]
            },
            "Math-BoldItalic": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "48": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "49": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "50": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "51": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "52": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "53": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "54": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "55": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "56": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.575
                ],
                "57": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.575
                ],
                "65": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.86944
                ],
                "66": [
                    0,
                    0.68611,
                    0.04835,
                    0,
                    0.8664
                ],
                "67": [
                    0,
                    0.68611,
                    0.06979,
                    0,
                    0.81694
                ],
                "68": [
                    0,
                    0.68611,
                    0.03194,
                    0,
                    0.93812
                ],
                "69": [
                    0,
                    0.68611,
                    0.05451,
                    0,
                    0.81007
                ],
                "70": [
                    0,
                    0.68611,
                    0.15972,
                    0,
                    0.68889
                ],
                "71": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.88673
                ],
                "72": [
                    0,
                    0.68611,
                    0.08229,
                    0,
                    0.98229
                ],
                "73": [
                    0,
                    0.68611,
                    0.07778,
                    0,
                    0.51111
                ],
                "74": [
                    0,
                    0.68611,
                    0.10069,
                    0,
                    0.63125
                ],
                "75": [
                    0,
                    0.68611,
                    0.06979,
                    0,
                    0.97118
                ],
                "76": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.75555
                ],
                "77": [
                    0,
                    0.68611,
                    0.11424,
                    0,
                    1.14201
                ],
                "78": [
                    0,
                    0.68611,
                    0.11424,
                    0,
                    0.95034
                ],
                "79": [
                    0,
                    0.68611,
                    0.03194,
                    0,
                    0.83666
                ],
                "80": [
                    0,
                    0.68611,
                    0.15972,
                    0,
                    0.72309
                ],
                "81": [
                    0.19444,
                    0.68611,
                    0,
                    0,
                    0.86861
                ],
                "82": [
                    0,
                    0.68611,
                    0.00421,
                    0,
                    0.87235
                ],
                "83": [
                    0,
                    0.68611,
                    0.05382,
                    0,
                    0.69271
                ],
                "84": [
                    0,
                    0.68611,
                    0.15972,
                    0,
                    0.63663
                ],
                "85": [
                    0,
                    0.68611,
                    0.11424,
                    0,
                    0.80027
                ],
                "86": [
                    0,
                    0.68611,
                    0.25555,
                    0,
                    0.67778
                ],
                "87": [
                    0,
                    0.68611,
                    0.15972,
                    0,
                    1.09305
                ],
                "88": [
                    0,
                    0.68611,
                    0.07778,
                    0,
                    0.94722
                ],
                "89": [
                    0,
                    0.68611,
                    0.25555,
                    0,
                    0.67458
                ],
                "90": [
                    0,
                    0.68611,
                    0.06979,
                    0,
                    0.77257
                ],
                "97": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.63287
                ],
                "98": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.52083
                ],
                "99": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.51342
                ],
                "100": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.60972
                ],
                "101": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.55361
                ],
                "102": [
                    0.19444,
                    0.69444,
                    0.11042,
                    0,
                    0.56806
                ],
                "103": [
                    0.19444,
                    0.44444,
                    0.03704,
                    0,
                    0.5449
                ],
                "104": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66759
                ],
                "105": [
                    0,
                    0.69326,
                    0,
                    0,
                    0.4048
                ],
                "106": [
                    0.19444,
                    0.69326,
                    0.0622,
                    0,
                    0.47083
                ],
                "107": [
                    0,
                    0.69444,
                    0.01852,
                    0,
                    0.6037
                ],
                "108": [
                    0,
                    0.69444,
                    0.0088,
                    0,
                    0.34815
                ],
                "109": [
                    0,
                    0.44444,
                    0,
                    0,
                    1.0324
                ],
                "110": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.71296
                ],
                "111": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.58472
                ],
                "112": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.60092
                ],
                "113": [
                    0.19444,
                    0.44444,
                    0.03704,
                    0,
                    0.54213
                ],
                "114": [
                    0,
                    0.44444,
                    0.03194,
                    0,
                    0.5287
                ],
                "115": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.53125
                ],
                "116": [
                    0,
                    0.63492,
                    0,
                    0,
                    0.41528
                ],
                "117": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.68102
                ],
                "118": [
                    0,
                    0.44444,
                    0.03704,
                    0,
                    0.56666
                ],
                "119": [
                    0,
                    0.44444,
                    0.02778,
                    0,
                    0.83148
                ],
                "120": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.65903
                ],
                "121": [
                    0.19444,
                    0.44444,
                    0.03704,
                    0,
                    0.59028
                ],
                "122": [
                    0,
                    0.44444,
                    0.04213,
                    0,
                    0.55509
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "915": [
                    0,
                    0.68611,
                    0.15972,
                    0,
                    0.65694
                ],
                "916": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.95833
                ],
                "920": [
                    0,
                    0.68611,
                    0.03194,
                    0,
                    0.86722
                ],
                "923": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.80555
                ],
                "926": [
                    0,
                    0.68611,
                    0.07458,
                    0,
                    0.84125
                ],
                "928": [
                    0,
                    0.68611,
                    0.08229,
                    0,
                    0.98229
                ],
                "931": [
                    0,
                    0.68611,
                    0.05451,
                    0,
                    0.88507
                ],
                "933": [
                    0,
                    0.68611,
                    0.15972,
                    0,
                    0.67083
                ],
                "934": [
                    0,
                    0.68611,
                    0,
                    0,
                    0.76666
                ],
                "936": [
                    0,
                    0.68611,
                    0.11653,
                    0,
                    0.71402
                ],
                "937": [
                    0,
                    0.68611,
                    0.04835,
                    0,
                    0.8789
                ],
                "945": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.76064
                ],
                "946": [
                    0.19444,
                    0.69444,
                    0.03403,
                    0,
                    0.65972
                ],
                "947": [
                    0.19444,
                    0.44444,
                    0.06389,
                    0,
                    0.59003
                ],
                "948": [
                    0,
                    0.69444,
                    0.03819,
                    0,
                    0.52222
                ],
                "949": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.52882
                ],
                "950": [
                    0.19444,
                    0.69444,
                    0.06215,
                    0,
                    0.50833
                ],
                "951": [
                    0.19444,
                    0.44444,
                    0.03704,
                    0,
                    0.6
                ],
                "952": [
                    0,
                    0.69444,
                    0.03194,
                    0,
                    0.5618
                ],
                "953": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.41204
                ],
                "954": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.66759
                ],
                "955": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.67083
                ],
                "956": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.70787
                ],
                "957": [
                    0,
                    0.44444,
                    0.06898,
                    0,
                    0.57685
                ],
                "958": [
                    0.19444,
                    0.69444,
                    0.03021,
                    0,
                    0.50833
                ],
                "959": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.58472
                ],
                "960": [
                    0,
                    0.44444,
                    0.03704,
                    0,
                    0.68241
                ],
                "961": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.6118
                ],
                "962": [
                    0.09722,
                    0.44444,
                    0.07917,
                    0,
                    0.42361
                ],
                "963": [
                    0,
                    0.44444,
                    0.03704,
                    0,
                    0.68588
                ],
                "964": [
                    0,
                    0.44444,
                    0.13472,
                    0,
                    0.52083
                ],
                "965": [
                    0,
                    0.44444,
                    0.03704,
                    0,
                    0.63055
                ],
                "966": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.74722
                ],
                "967": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.71805
                ],
                "968": [
                    0.19444,
                    0.69444,
                    0.03704,
                    0,
                    0.75833
                ],
                "969": [
                    0,
                    0.44444,
                    0.03704,
                    0,
                    0.71782
                ],
                "977": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.69155
                ],
                "981": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.7125
                ],
                "982": [
                    0,
                    0.44444,
                    0.03194,
                    0,
                    0.975
                ],
                "1009": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.6118
                ],
                "1013": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.48333
                ],
                "57649": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.39352
                ],
                "57911": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.43889
                ]
            },
            "Math-Italic": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "48": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "49": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "50": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "51": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "52": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "53": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "54": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "55": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "56": [
                    0,
                    0.64444,
                    0,
                    0,
                    0.5
                ],
                "57": [
                    0.19444,
                    0.43056,
                    0,
                    0,
                    0.5
                ],
                "65": [
                    0,
                    0.68333,
                    0,
                    0.13889,
                    0.75
                ],
                "66": [
                    0,
                    0.68333,
                    0.05017,
                    0.08334,
                    0.75851
                ],
                "67": [
                    0,
                    0.68333,
                    0.07153,
                    0.08334,
                    0.71472
                ],
                "68": [
                    0,
                    0.68333,
                    0.02778,
                    0.05556,
                    0.82792
                ],
                "69": [
                    0,
                    0.68333,
                    0.05764,
                    0.08334,
                    0.7382
                ],
                "70": [
                    0,
                    0.68333,
                    0.13889,
                    0.08334,
                    0.64306
                ],
                "71": [
                    0,
                    0.68333,
                    0,
                    0.08334,
                    0.78625
                ],
                "72": [
                    0,
                    0.68333,
                    0.08125,
                    0.05556,
                    0.83125
                ],
                "73": [
                    0,
                    0.68333,
                    0.07847,
                    0.11111,
                    0.43958
                ],
                "74": [
                    0,
                    0.68333,
                    0.09618,
                    0.16667,
                    0.55451
                ],
                "75": [
                    0,
                    0.68333,
                    0.07153,
                    0.05556,
                    0.84931
                ],
                "76": [
                    0,
                    0.68333,
                    0,
                    0.02778,
                    0.68056
                ],
                "77": [
                    0,
                    0.68333,
                    0.10903,
                    0.08334,
                    0.97014
                ],
                "78": [
                    0,
                    0.68333,
                    0.10903,
                    0.08334,
                    0.80347
                ],
                "79": [
                    0,
                    0.68333,
                    0.02778,
                    0.08334,
                    0.76278
                ],
                "80": [
                    0,
                    0.68333,
                    0.13889,
                    0.08334,
                    0.64201
                ],
                "81": [
                    0.19444,
                    0.68333,
                    0,
                    0.08334,
                    0.79056
                ],
                "82": [
                    0,
                    0.68333,
                    0.00773,
                    0.08334,
                    0.75929
                ],
                "83": [
                    0,
                    0.68333,
                    0.05764,
                    0.08334,
                    0.6132
                ],
                "84": [
                    0,
                    0.68333,
                    0.13889,
                    0.08334,
                    0.58438
                ],
                "85": [
                    0,
                    0.68333,
                    0.10903,
                    0.02778,
                    0.68278
                ],
                "86": [
                    0,
                    0.68333,
                    0.22222,
                    0,
                    0.58333
                ],
                "87": [
                    0,
                    0.68333,
                    0.13889,
                    0,
                    0.94445
                ],
                "88": [
                    0,
                    0.68333,
                    0.07847,
                    0.08334,
                    0.82847
                ],
                "89": [
                    0,
                    0.68333,
                    0.22222,
                    0,
                    0.58056
                ],
                "90": [
                    0,
                    0.68333,
                    0.07153,
                    0.08334,
                    0.68264
                ],
                "97": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.52859
                ],
                "98": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.42917
                ],
                "99": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.43276
                ],
                "100": [
                    0,
                    0.69444,
                    0,
                    0.16667,
                    0.52049
                ],
                "101": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.46563
                ],
                "102": [
                    0.19444,
                    0.69444,
                    0.10764,
                    0.16667,
                    0.48959
                ],
                "103": [
                    0.19444,
                    0.43056,
                    0.03588,
                    0.02778,
                    0.47697
                ],
                "104": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.57616
                ],
                "105": [
                    0,
                    0.65952,
                    0,
                    0,
                    0.34451
                ],
                "106": [
                    0.19444,
                    0.65952,
                    0.05724,
                    0,
                    0.41181
                ],
                "107": [
                    0,
                    0.69444,
                    0.03148,
                    0,
                    0.5206
                ],
                "108": [
                    0,
                    0.69444,
                    0.01968,
                    0.08334,
                    0.29838
                ],
                "109": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.87801
                ],
                "110": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.60023
                ],
                "111": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.48472
                ],
                "112": [
                    0.19444,
                    0.43056,
                    0,
                    0.08334,
                    0.50313
                ],
                "113": [
                    0.19444,
                    0.43056,
                    0.03588,
                    0.08334,
                    0.44641
                ],
                "114": [
                    0,
                    0.43056,
                    0.02778,
                    0.05556,
                    0.45116
                ],
                "115": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.46875
                ],
                "116": [
                    0,
                    0.61508,
                    0,
                    0.08334,
                    0.36111
                ],
                "117": [
                    0,
                    0.43056,
                    0,
                    0.02778,
                    0.57246
                ],
                "118": [
                    0,
                    0.43056,
                    0.03588,
                    0.02778,
                    0.48472
                ],
                "119": [
                    0,
                    0.43056,
                    0.02691,
                    0.08334,
                    0.71592
                ],
                "120": [
                    0,
                    0.43056,
                    0,
                    0.02778,
                    0.57153
                ],
                "121": [
                    0.19444,
                    0.43056,
                    0.03588,
                    0.05556,
                    0.49028
                ],
                "122": [
                    0,
                    0.43056,
                    0.04398,
                    0.05556,
                    0.46505
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "915": [
                    0,
                    0.68333,
                    0.13889,
                    0.08334,
                    0.61528
                ],
                "916": [
                    0,
                    0.68333,
                    0,
                    0.16667,
                    0.83334
                ],
                "920": [
                    0,
                    0.68333,
                    0.02778,
                    0.08334,
                    0.76278
                ],
                "923": [
                    0,
                    0.68333,
                    0,
                    0.16667,
                    0.69445
                ],
                "926": [
                    0,
                    0.68333,
                    0.07569,
                    0.08334,
                    0.74236
                ],
                "928": [
                    0,
                    0.68333,
                    0.08125,
                    0.05556,
                    0.83125
                ],
                "931": [
                    0,
                    0.68333,
                    0.05764,
                    0.08334,
                    0.77986
                ],
                "933": [
                    0,
                    0.68333,
                    0.13889,
                    0.05556,
                    0.58333
                ],
                "934": [
                    0,
                    0.68333,
                    0,
                    0.08334,
                    0.66667
                ],
                "936": [
                    0,
                    0.68333,
                    0.11,
                    0.05556,
                    0.61222
                ],
                "937": [
                    0,
                    0.68333,
                    0.05017,
                    0.08334,
                    0.7724
                ],
                "945": [
                    0,
                    0.43056,
                    0.0037,
                    0.02778,
                    0.6397
                ],
                "946": [
                    0.19444,
                    0.69444,
                    0.05278,
                    0.08334,
                    0.56563
                ],
                "947": [
                    0.19444,
                    0.43056,
                    0.05556,
                    0,
                    0.51773
                ],
                "948": [
                    0,
                    0.69444,
                    0.03785,
                    0.05556,
                    0.44444
                ],
                "949": [
                    0,
                    0.43056,
                    0,
                    0.08334,
                    0.46632
                ],
                "950": [
                    0.19444,
                    0.69444,
                    0.07378,
                    0.08334,
                    0.4375
                ],
                "951": [
                    0.19444,
                    0.43056,
                    0.03588,
                    0.05556,
                    0.49653
                ],
                "952": [
                    0,
                    0.69444,
                    0.02778,
                    0.08334,
                    0.46944
                ],
                "953": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.35394
                ],
                "954": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.57616
                ],
                "955": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.58334
                ],
                "956": [
                    0.19444,
                    0.43056,
                    0,
                    0.02778,
                    0.60255
                ],
                "957": [
                    0,
                    0.43056,
                    0.06366,
                    0.02778,
                    0.49398
                ],
                "958": [
                    0.19444,
                    0.69444,
                    0.04601,
                    0.11111,
                    0.4375
                ],
                "959": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.48472
                ],
                "960": [
                    0,
                    0.43056,
                    0.03588,
                    0,
                    0.57003
                ],
                "961": [
                    0.19444,
                    0.43056,
                    0,
                    0.08334,
                    0.51702
                ],
                "962": [
                    0.09722,
                    0.43056,
                    0.07986,
                    0.08334,
                    0.36285
                ],
                "963": [
                    0,
                    0.43056,
                    0.03588,
                    0,
                    0.57141
                ],
                "964": [
                    0,
                    0.43056,
                    0.1132,
                    0.02778,
                    0.43715
                ],
                "965": [
                    0,
                    0.43056,
                    0.03588,
                    0.02778,
                    0.54028
                ],
                "966": [
                    0.19444,
                    0.43056,
                    0,
                    0.08334,
                    0.65417
                ],
                "967": [
                    0.19444,
                    0.43056,
                    0,
                    0.05556,
                    0.62569
                ],
                "968": [
                    0.19444,
                    0.69444,
                    0.03588,
                    0.11111,
                    0.65139
                ],
                "969": [
                    0,
                    0.43056,
                    0.03588,
                    0,
                    0.62245
                ],
                "977": [
                    0,
                    0.69444,
                    0,
                    0.08334,
                    0.59144
                ],
                "981": [
                    0.19444,
                    0.69444,
                    0,
                    0.08334,
                    0.59583
                ],
                "982": [
                    0,
                    0.43056,
                    0.02778,
                    0,
                    0.82813
                ],
                "1009": [
                    0.19444,
                    0.43056,
                    0,
                    0.08334,
                    0.51702
                ],
                "1013": [
                    0,
                    0.43056,
                    0,
                    0.05556,
                    0.4059
                ],
                "57649": [
                    0,
                    0.43056,
                    0,
                    0.02778,
                    0.32246
                ],
                "57911": [
                    0.19444,
                    0.43056,
                    0,
                    0.08334,
                    0.38403
                ]
            },
            "SansSerif-Bold": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.36667
                ],
                "34": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55834
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.91667
                ],
                "36": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.55
                ],
                "37": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    1.02912
                ],
                "38": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83056
                ],
                "39": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.30556
                ],
                "40": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.42778
                ],
                "41": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.42778
                ],
                "42": [
                    0,
                    0.75,
                    0,
                    0,
                    0.55
                ],
                "43": [
                    0.11667,
                    0.61667,
                    0,
                    0,
                    0.85556
                ],
                "44": [
                    0.10556,
                    0.13056,
                    0,
                    0,
                    0.30556
                ],
                "45": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.36667
                ],
                "46": [
                    0,
                    0.13056,
                    0,
                    0,
                    0.30556
                ],
                "47": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.55
                ],
                "48": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "49": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "50": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "51": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "52": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "53": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "54": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "55": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "56": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "57": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "58": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.30556
                ],
                "59": [
                    0.10556,
                    0.45833,
                    0,
                    0,
                    0.30556
                ],
                "61": [
                    -0.09375,
                    0.40625,
                    0,
                    0,
                    0.85556
                ],
                "63": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.51945
                ],
                "64": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "65": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "66": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "67": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70278
                ],
                "68": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "69": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.64167
                ],
                "70": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "71": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "72": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "73": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.33056
                ],
                "74": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.51945
                ],
                "75": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.76389
                ],
                "76": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.58056
                ],
                "77": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.97778
                ],
                "78": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "79": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "80": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70278
                ],
                "81": [
                    0.10556,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "82": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70278
                ],
                "83": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "84": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "85": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.76389
                ],
                "86": [
                    0,
                    0.69444,
                    0.01528,
                    0,
                    0.73334
                ],
                "87": [
                    0,
                    0.69444,
                    0.01528,
                    0,
                    1.03889
                ],
                "88": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "89": [
                    0,
                    0.69444,
                    0.0275,
                    0,
                    0.73334
                ],
                "90": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.67223
                ],
                "91": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.34306
                ],
                "93": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.34306
                ],
                "94": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "95": [
                    0.35,
                    0.10833,
                    0.03056,
                    0,
                    0.55
                ],
                "97": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.525
                ],
                "98": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.56111
                ],
                "99": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.48889
                ],
                "100": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.56111
                ],
                "101": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.51111
                ],
                "102": [
                    0,
                    0.69444,
                    0.07639,
                    0,
                    0.33611
                ],
                "103": [
                    0.19444,
                    0.45833,
                    0.01528,
                    0,
                    0.55
                ],
                "104": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.56111
                ],
                "105": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.25556
                ],
                "106": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.28611
                ],
                "107": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.53056
                ],
                "108": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.25556
                ],
                "109": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.86667
                ],
                "110": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.56111
                ],
                "111": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.55
                ],
                "112": [
                    0.19444,
                    0.45833,
                    0,
                    0,
                    0.56111
                ],
                "113": [
                    0.19444,
                    0.45833,
                    0,
                    0,
                    0.56111
                ],
                "114": [
                    0,
                    0.45833,
                    0.01528,
                    0,
                    0.37222
                ],
                "115": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.42167
                ],
                "116": [
                    0,
                    0.58929,
                    0,
                    0,
                    0.40417
                ],
                "117": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.56111
                ],
                "118": [
                    0,
                    0.45833,
                    0.01528,
                    0,
                    0.5
                ],
                "119": [
                    0,
                    0.45833,
                    0.01528,
                    0,
                    0.74445
                ],
                "120": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.5
                ],
                "121": [
                    0.19444,
                    0.45833,
                    0.01528,
                    0,
                    0.5
                ],
                "122": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.47639
                ],
                "126": [
                    0.35,
                    0.34444,
                    0,
                    0,
                    0.55
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "168": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "180": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.48889
                ],
                "305": [
                    0,
                    0.45833,
                    0,
                    0,
                    0.25556
                ],
                "567": [
                    0.19444,
                    0.45833,
                    0,
                    0,
                    0.28611
                ],
                "710": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "711": [
                    0,
                    0.63542,
                    0,
                    0,
                    0.55
                ],
                "713": [
                    0,
                    0.63778,
                    0,
                    0,
                    0.55
                ],
                "728": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "729": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.30556
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "732": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "733": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55
                ],
                "915": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.58056
                ],
                "916": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.91667
                ],
                "920": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.85556
                ],
                "923": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.67223
                ],
                "926": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73334
                ],
                "928": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "931": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "933": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.85556
                ],
                "934": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "936": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.85556
                ],
                "937": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.79445
                ],
                "8211": [
                    0,
                    0.45833,
                    0.03056,
                    0,
                    0.55
                ],
                "8212": [
                    0,
                    0.45833,
                    0.03056,
                    0,
                    1.10001
                ],
                "8216": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.30556
                ],
                "8217": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.30556
                ],
                "8220": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55834
                ],
                "8221": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55834
                ]
            },
            "SansSerif-Italic": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0.05733,
                    0,
                    0.31945
                ],
                "34": [
                    0,
                    0.69444,
                    0.00316,
                    0,
                    0.5
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0.05087,
                    0,
                    0.83334
                ],
                "36": [
                    0.05556,
                    0.75,
                    0.11156,
                    0,
                    0.5
                ],
                "37": [
                    0.05556,
                    0.75,
                    0.03126,
                    0,
                    0.83334
                ],
                "38": [
                    0,
                    0.69444,
                    0.03058,
                    0,
                    0.75834
                ],
                "39": [
                    0,
                    0.69444,
                    0.07816,
                    0,
                    0.27778
                ],
                "40": [
                    0.25,
                    0.75,
                    0.13164,
                    0,
                    0.38889
                ],
                "41": [
                    0.25,
                    0.75,
                    0.02536,
                    0,
                    0.38889
                ],
                "42": [
                    0,
                    0.75,
                    0.11775,
                    0,
                    0.5
                ],
                "43": [
                    0.08333,
                    0.58333,
                    0.02536,
                    0,
                    0.77778
                ],
                "44": [
                    0.125,
                    0.08333,
                    0,
                    0,
                    0.27778
                ],
                "45": [
                    0,
                    0.44444,
                    0.01946,
                    0,
                    0.33333
                ],
                "46": [
                    0,
                    0.08333,
                    0,
                    0,
                    0.27778
                ],
                "47": [
                    0.25,
                    0.75,
                    0.13164,
                    0,
                    0.5
                ],
                "48": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "49": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "50": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "51": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "52": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "53": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "54": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "55": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "56": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "57": [
                    0,
                    0.65556,
                    0.11156,
                    0,
                    0.5
                ],
                "58": [
                    0,
                    0.44444,
                    0.02502,
                    0,
                    0.27778
                ],
                "59": [
                    0.125,
                    0.44444,
                    0.02502,
                    0,
                    0.27778
                ],
                "61": [
                    -0.13,
                    0.37,
                    0.05087,
                    0,
                    0.77778
                ],
                "63": [
                    0,
                    0.69444,
                    0.11809,
                    0,
                    0.47222
                ],
                "64": [
                    0,
                    0.69444,
                    0.07555,
                    0,
                    0.66667
                ],
                "65": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "66": [
                    0,
                    0.69444,
                    0.08293,
                    0,
                    0.66667
                ],
                "67": [
                    0,
                    0.69444,
                    0.11983,
                    0,
                    0.63889
                ],
                "68": [
                    0,
                    0.69444,
                    0.07555,
                    0,
                    0.72223
                ],
                "69": [
                    0,
                    0.69444,
                    0.11983,
                    0,
                    0.59722
                ],
                "70": [
                    0,
                    0.69444,
                    0.13372,
                    0,
                    0.56945
                ],
                "71": [
                    0,
                    0.69444,
                    0.11983,
                    0,
                    0.66667
                ],
                "72": [
                    0,
                    0.69444,
                    0.08094,
                    0,
                    0.70834
                ],
                "73": [
                    0,
                    0.69444,
                    0.13372,
                    0,
                    0.27778
                ],
                "74": [
                    0,
                    0.69444,
                    0.08094,
                    0,
                    0.47222
                ],
                "75": [
                    0,
                    0.69444,
                    0.11983,
                    0,
                    0.69445
                ],
                "76": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.54167
                ],
                "77": [
                    0,
                    0.69444,
                    0.08094,
                    0,
                    0.875
                ],
                "78": [
                    0,
                    0.69444,
                    0.08094,
                    0,
                    0.70834
                ],
                "79": [
                    0,
                    0.69444,
                    0.07555,
                    0,
                    0.73611
                ],
                "80": [
                    0,
                    0.69444,
                    0.08293,
                    0,
                    0.63889
                ],
                "81": [
                    0.125,
                    0.69444,
                    0.07555,
                    0,
                    0.73611
                ],
                "82": [
                    0,
                    0.69444,
                    0.08293,
                    0,
                    0.64584
                ],
                "83": [
                    0,
                    0.69444,
                    0.09205,
                    0,
                    0.55556
                ],
                "84": [
                    0,
                    0.69444,
                    0.13372,
                    0,
                    0.68056
                ],
                "85": [
                    0,
                    0.69444,
                    0.08094,
                    0,
                    0.6875
                ],
                "86": [
                    0,
                    0.69444,
                    0.1615,
                    0,
                    0.66667
                ],
                "87": [
                    0,
                    0.69444,
                    0.1615,
                    0,
                    0.94445
                ],
                "88": [
                    0,
                    0.69444,
                    0.13372,
                    0,
                    0.66667
                ],
                "89": [
                    0,
                    0.69444,
                    0.17261,
                    0,
                    0.66667
                ],
                "90": [
                    0,
                    0.69444,
                    0.11983,
                    0,
                    0.61111
                ],
                "91": [
                    0.25,
                    0.75,
                    0.15942,
                    0,
                    0.28889
                ],
                "93": [
                    0.25,
                    0.75,
                    0.08719,
                    0,
                    0.28889
                ],
                "94": [
                    0,
                    0.69444,
                    0.0799,
                    0,
                    0.5
                ],
                "95": [
                    0.35,
                    0.09444,
                    0.08616,
                    0,
                    0.5
                ],
                "97": [
                    0,
                    0.44444,
                    0.00981,
                    0,
                    0.48056
                ],
                "98": [
                    0,
                    0.69444,
                    0.03057,
                    0,
                    0.51667
                ],
                "99": [
                    0,
                    0.44444,
                    0.08336,
                    0,
                    0.44445
                ],
                "100": [
                    0,
                    0.69444,
                    0.09483,
                    0,
                    0.51667
                ],
                "101": [
                    0,
                    0.44444,
                    0.06778,
                    0,
                    0.44445
                ],
                "102": [
                    0,
                    0.69444,
                    0.21705,
                    0,
                    0.30556
                ],
                "103": [
                    0.19444,
                    0.44444,
                    0.10836,
                    0,
                    0.5
                ],
                "104": [
                    0,
                    0.69444,
                    0.01778,
                    0,
                    0.51667
                ],
                "105": [
                    0,
                    0.67937,
                    0.09718,
                    0,
                    0.23889
                ],
                "106": [
                    0.19444,
                    0.67937,
                    0.09162,
                    0,
                    0.26667
                ],
                "107": [
                    0,
                    0.69444,
                    0.08336,
                    0,
                    0.48889
                ],
                "108": [
                    0,
                    0.69444,
                    0.09483,
                    0,
                    0.23889
                ],
                "109": [
                    0,
                    0.44444,
                    0.01778,
                    0,
                    0.79445
                ],
                "110": [
                    0,
                    0.44444,
                    0.01778,
                    0,
                    0.51667
                ],
                "111": [
                    0,
                    0.44444,
                    0.06613,
                    0,
                    0.5
                ],
                "112": [
                    0.19444,
                    0.44444,
                    0.0389,
                    0,
                    0.51667
                ],
                "113": [
                    0.19444,
                    0.44444,
                    0.04169,
                    0,
                    0.51667
                ],
                "114": [
                    0,
                    0.44444,
                    0.10836,
                    0,
                    0.34167
                ],
                "115": [
                    0,
                    0.44444,
                    0.0778,
                    0,
                    0.38333
                ],
                "116": [
                    0,
                    0.57143,
                    0.07225,
                    0,
                    0.36111
                ],
                "117": [
                    0,
                    0.44444,
                    0.04169,
                    0,
                    0.51667
                ],
                "118": [
                    0,
                    0.44444,
                    0.10836,
                    0,
                    0.46111
                ],
                "119": [
                    0,
                    0.44444,
                    0.10836,
                    0,
                    0.68334
                ],
                "120": [
                    0,
                    0.44444,
                    0.09169,
                    0,
                    0.46111
                ],
                "121": [
                    0.19444,
                    0.44444,
                    0.10836,
                    0,
                    0.46111
                ],
                "122": [
                    0,
                    0.44444,
                    0.08752,
                    0,
                    0.43472
                ],
                "126": [
                    0.35,
                    0.32659,
                    0.08826,
                    0,
                    0.5
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "168": [
                    0,
                    0.67937,
                    0.06385,
                    0,
                    0.5
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73752
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.44445
                ],
                "305": [
                    0,
                    0.44444,
                    0.04169,
                    0,
                    0.23889
                ],
                "567": [
                    0.19444,
                    0.44444,
                    0.04169,
                    0,
                    0.26667
                ],
                "710": [
                    0,
                    0.69444,
                    0.0799,
                    0,
                    0.5
                ],
                "711": [
                    0,
                    0.63194,
                    0.08432,
                    0,
                    0.5
                ],
                "713": [
                    0,
                    0.60889,
                    0.08776,
                    0,
                    0.5
                ],
                "714": [
                    0,
                    0.69444,
                    0.09205,
                    0,
                    0.5
                ],
                "715": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "728": [
                    0,
                    0.69444,
                    0.09483,
                    0,
                    0.5
                ],
                "729": [
                    0,
                    0.67937,
                    0.07774,
                    0,
                    0.27778
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73752
                ],
                "732": [
                    0,
                    0.67659,
                    0.08826,
                    0,
                    0.5
                ],
                "733": [
                    0,
                    0.69444,
                    0.09205,
                    0,
                    0.5
                ],
                "915": [
                    0,
                    0.69444,
                    0.13372,
                    0,
                    0.54167
                ],
                "916": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83334
                ],
                "920": [
                    0,
                    0.69444,
                    0.07555,
                    0,
                    0.77778
                ],
                "923": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "926": [
                    0,
                    0.69444,
                    0.12816,
                    0,
                    0.66667
                ],
                "928": [
                    0,
                    0.69444,
                    0.08094,
                    0,
                    0.70834
                ],
                "931": [
                    0,
                    0.69444,
                    0.11983,
                    0,
                    0.72222
                ],
                "933": [
                    0,
                    0.69444,
                    0.09031,
                    0,
                    0.77778
                ],
                "934": [
                    0,
                    0.69444,
                    0.04603,
                    0,
                    0.72222
                ],
                "936": [
                    0,
                    0.69444,
                    0.09031,
                    0,
                    0.77778
                ],
                "937": [
                    0,
                    0.69444,
                    0.08293,
                    0,
                    0.72222
                ],
                "8211": [
                    0,
                    0.44444,
                    0.08616,
                    0,
                    0.5
                ],
                "8212": [
                    0,
                    0.44444,
                    0.08616,
                    0,
                    1.0
                ],
                "8216": [
                    0,
                    0.69444,
                    0.07816,
                    0,
                    0.27778
                ],
                "8217": [
                    0,
                    0.69444,
                    0.07816,
                    0,
                    0.27778
                ],
                "8220": [
                    0,
                    0.69444,
                    0.14205,
                    0,
                    0.5
                ],
                "8221": [
                    0,
                    0.69444,
                    0.00316,
                    0,
                    0.5
                ]
            },
            "SansSerif-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "33": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.31945
                ],
                "34": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "35": [
                    0.19444,
                    0.69444,
                    0,
                    0,
                    0.83334
                ],
                "36": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "37": [
                    0.05556,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "38": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.75834
                ],
                "39": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "40": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "41": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.38889
                ],
                "42": [
                    0,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "43": [
                    0.08333,
                    0.58333,
                    0,
                    0,
                    0.77778
                ],
                "44": [
                    0.125,
                    0.08333,
                    0,
                    0,
                    0.27778
                ],
                "45": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.33333
                ],
                "46": [
                    0,
                    0.08333,
                    0,
                    0,
                    0.27778
                ],
                "47": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.5
                ],
                "48": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "49": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "50": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "51": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "52": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "53": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "54": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "55": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "56": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "57": [
                    0,
                    0.65556,
                    0,
                    0,
                    0.5
                ],
                "58": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.27778
                ],
                "59": [
                    0.125,
                    0.44444,
                    0,
                    0,
                    0.27778
                ],
                "61": [
                    -0.13,
                    0.37,
                    0,
                    0,
                    0.77778
                ],
                "63": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.47222
                ],
                "64": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "65": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "66": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "67": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "68": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.72223
                ],
                "69": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.59722
                ],
                "70": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.56945
                ],
                "71": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "72": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70834
                ],
                "73": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "74": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.47222
                ],
                "75": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.69445
                ],
                "76": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.54167
                ],
                "77": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.875
                ],
                "78": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70834
                ],
                "79": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.73611
                ],
                "80": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.63889
                ],
                "81": [
                    0.125,
                    0.69444,
                    0,
                    0,
                    0.73611
                ],
                "82": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.64584
                ],
                "83": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.55556
                ],
                "84": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.68056
                ],
                "85": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.6875
                ],
                "86": [
                    0,
                    0.69444,
                    0.01389,
                    0,
                    0.66667
                ],
                "87": [
                    0,
                    0.69444,
                    0.01389,
                    0,
                    0.94445
                ],
                "88": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "89": [
                    0,
                    0.69444,
                    0.025,
                    0,
                    0.66667
                ],
                "90": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "91": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.28889
                ],
                "93": [
                    0.25,
                    0.75,
                    0,
                    0,
                    0.28889
                ],
                "94": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "95": [
                    0.35,
                    0.09444,
                    0.02778,
                    0,
                    0.5
                ],
                "97": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.48056
                ],
                "98": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.51667
                ],
                "99": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.44445
                ],
                "100": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.51667
                ],
                "101": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.44445
                ],
                "102": [
                    0,
                    0.69444,
                    0.06944,
                    0,
                    0.30556
                ],
                "103": [
                    0.19444,
                    0.44444,
                    0.01389,
                    0,
                    0.5
                ],
                "104": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.51667
                ],
                "105": [
                    0,
                    0.67937,
                    0,
                    0,
                    0.23889
                ],
                "106": [
                    0.19444,
                    0.67937,
                    0,
                    0,
                    0.26667
                ],
                "107": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.48889
                ],
                "108": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.23889
                ],
                "109": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.79445
                ],
                "110": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.51667
                ],
                "111": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.5
                ],
                "112": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.51667
                ],
                "113": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.51667
                ],
                "114": [
                    0,
                    0.44444,
                    0.01389,
                    0,
                    0.34167
                ],
                "115": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.38333
                ],
                "116": [
                    0,
                    0.57143,
                    0,
                    0,
                    0.36111
                ],
                "117": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.51667
                ],
                "118": [
                    0,
                    0.44444,
                    0.01389,
                    0,
                    0.46111
                ],
                "119": [
                    0,
                    0.44444,
                    0.01389,
                    0,
                    0.68334
                ],
                "120": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.46111
                ],
                "121": [
                    0.19444,
                    0.44444,
                    0.01389,
                    0,
                    0.46111
                ],
                "122": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.43472
                ],
                "126": [
                    0.35,
                    0.32659,
                    0,
                    0,
                    0.5
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "168": [
                    0,
                    0.67937,
                    0,
                    0,
                    0.5
                ],
                "176": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "184": [
                    0.17014,
                    0,
                    0,
                    0,
                    0.44445
                ],
                "305": [
                    0,
                    0.44444,
                    0,
                    0,
                    0.23889
                ],
                "567": [
                    0.19444,
                    0.44444,
                    0,
                    0,
                    0.26667
                ],
                "710": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "711": [
                    0,
                    0.63194,
                    0,
                    0,
                    0.5
                ],
                "713": [
                    0,
                    0.60889,
                    0,
                    0,
                    0.5
                ],
                "714": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "715": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "728": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "729": [
                    0,
                    0.67937,
                    0,
                    0,
                    0.27778
                ],
                "730": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "732": [
                    0,
                    0.67659,
                    0,
                    0,
                    0.5
                ],
                "733": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "915": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.54167
                ],
                "916": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.83334
                ],
                "920": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "923": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.61111
                ],
                "926": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.66667
                ],
                "928": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.70834
                ],
                "931": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.72222
                ],
                "933": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "934": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.72222
                ],
                "936": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.77778
                ],
                "937": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.72222
                ],
                "8211": [
                    0,
                    0.44444,
                    0.02778,
                    0,
                    0.5
                ],
                "8212": [
                    0,
                    0.44444,
                    0.02778,
                    0,
                    1.0
                ],
                "8216": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "8217": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.27778
                ],
                "8220": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ],
                "8221": [
                    0,
                    0.69444,
                    0,
                    0,
                    0.5
                ]
            },
            "Script-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "65": [
                    0,
                    0.7,
                    0.22925,
                    0,
                    0.80253
                ],
                "66": [
                    0,
                    0.7,
                    0.04087,
                    0,
                    0.90757
                ],
                "67": [
                    0,
                    0.7,
                    0.1689,
                    0,
                    0.66619
                ],
                "68": [
                    0,
                    0.7,
                    0.09371,
                    0,
                    0.77443
                ],
                "69": [
                    0,
                    0.7,
                    0.18583,
                    0,
                    0.56162
                ],
                "70": [
                    0,
                    0.7,
                    0.13634,
                    0,
                    0.89544
                ],
                "71": [
                    0,
                    0.7,
                    0.17322,
                    0,
                    0.60961
                ],
                "72": [
                    0,
                    0.7,
                    0.29694,
                    0,
                    0.96919
                ],
                "73": [
                    0,
                    0.7,
                    0.19189,
                    0,
                    0.80907
                ],
                "74": [
                    0.27778,
                    0.7,
                    0.19189,
                    0,
                    1.05159
                ],
                "75": [
                    0,
                    0.7,
                    0.31259,
                    0,
                    0.91364
                ],
                "76": [
                    0,
                    0.7,
                    0.19189,
                    0,
                    0.87373
                ],
                "77": [
                    0,
                    0.7,
                    0.15981,
                    0,
                    1.08031
                ],
                "78": [
                    0,
                    0.7,
                    0.3525,
                    0,
                    0.9015
                ],
                "79": [
                    0,
                    0.7,
                    0.08078,
                    0,
                    0.73787
                ],
                "80": [
                    0,
                    0.7,
                    0.08078,
                    0,
                    1.01262
                ],
                "81": [
                    0,
                    0.7,
                    0.03305,
                    0,
                    0.88282
                ],
                "82": [
                    0,
                    0.7,
                    0.06259,
                    0,
                    0.85
                ],
                "83": [
                    0,
                    0.7,
                    0.19189,
                    0,
                    0.86767
                ],
                "84": [
                    0,
                    0.7,
                    0.29087,
                    0,
                    0.74697
                ],
                "85": [
                    0,
                    0.7,
                    0.25815,
                    0,
                    0.79996
                ],
                "86": [
                    0,
                    0.7,
                    0.27523,
                    0,
                    0.62204
                ],
                "87": [
                    0,
                    0.7,
                    0.27523,
                    0,
                    0.80532
                ],
                "88": [
                    0,
                    0.7,
                    0.26006,
                    0,
                    0.94445
                ],
                "89": [
                    0,
                    0.7,
                    0.2939,
                    0,
                    0.70961
                ],
                "90": [
                    0,
                    0.7,
                    0.24037,
                    0,
                    0.8212
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ]
            },
            "Size1-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "40": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.45834
                ],
                "41": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.45834
                ],
                "47": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.57778
                ],
                "91": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.41667
                ],
                "92": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.57778
                ],
                "93": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.41667
                ],
                "123": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.58334
                ],
                "125": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.58334
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "710": [
                    0,
                    0.72222,
                    0,
                    0,
                    0.55556
                ],
                "732": [
                    0,
                    0.72222,
                    0,
                    0,
                    0.55556
                ],
                "770": [
                    0,
                    0.72222,
                    0,
                    0,
                    0.55556
                ],
                "771": [
                    0,
                    0.72222,
                    0,
                    0,
                    0.55556
                ],
                "8214": [
                    -0.00099,
                    0.601,
                    0,
                    0,
                    0.77778
                ],
                "8593": [
                    1e-05,
                    0.6,
                    0,
                    0,
                    0.66667
                ],
                "8595": [
                    1e-05,
                    0.6,
                    0,
                    0,
                    0.66667
                ],
                "8657": [
                    1e-05,
                    0.6,
                    0,
                    0,
                    0.77778
                ],
                "8659": [
                    1e-05,
                    0.6,
                    0,
                    0,
                    0.77778
                ],
                "8719": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.94445
                ],
                "8720": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.94445
                ],
                "8721": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    1.05556
                ],
                "8730": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    1.0
                ],
                "8739": [
                    -0.00599,
                    0.606,
                    0,
                    0,
                    0.33333
                ],
                "8741": [
                    -0.00599,
                    0.606,
                    0,
                    0,
                    0.55556
                ],
                "8747": [
                    0.30612,
                    0.805,
                    0.19445,
                    0,
                    0.47222
                ],
                "8748": [
                    0.306,
                    0.805,
                    0.19445,
                    0,
                    0.47222
                ],
                "8749": [
                    0.306,
                    0.805,
                    0.19445,
                    0,
                    0.47222
                ],
                "8750": [
                    0.30612,
                    0.805,
                    0.19445,
                    0,
                    0.47222
                ],
                "8896": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "8897": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "8898": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "8899": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "8968": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.47222
                ],
                "8969": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.47222
                ],
                "8970": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.47222
                ],
                "8971": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.47222
                ],
                "9168": [
                    -0.00099,
                    0.601,
                    0,
                    0,
                    0.66667
                ],
                "10216": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.47222
                ],
                "10217": [
                    0.35001,
                    0.85,
                    0,
                    0,
                    0.47222
                ],
                "10752": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    1.11111
                ],
                "10753": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    1.11111
                ],
                "10754": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    1.11111
                ],
                "10756": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.83334
                ],
                "10758": [
                    0.25001,
                    0.75,
                    0,
                    0,
                    0.83334
                ]
            },
            "Size2-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "40": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.59722
                ],
                "41": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.59722
                ],
                "47": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.81111
                ],
                "91": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.47222
                ],
                "92": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.81111
                ],
                "93": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.47222
                ],
                "123": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.66667
                ],
                "125": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.66667
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "710": [
                    0,
                    0.75,
                    0,
                    0,
                    1.0
                ],
                "732": [
                    0,
                    0.75,
                    0,
                    0,
                    1.0
                ],
                "770": [
                    0,
                    0.75,
                    0,
                    0,
                    1.0
                ],
                "771": [
                    0,
                    0.75,
                    0,
                    0,
                    1.0
                ],
                "8719": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.27778
                ],
                "8720": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.27778
                ],
                "8721": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.44445
                ],
                "8730": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    1.0
                ],
                "8747": [
                    0.86225,
                    1.36,
                    0.44445,
                    0,
                    0.55556
                ],
                "8748": [
                    0.862,
                    1.36,
                    0.44445,
                    0,
                    0.55556
                ],
                "8749": [
                    0.862,
                    1.36,
                    0.44445,
                    0,
                    0.55556
                ],
                "8750": [
                    0.86225,
                    1.36,
                    0.44445,
                    0,
                    0.55556
                ],
                "8896": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.11111
                ],
                "8897": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.11111
                ],
                "8898": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.11111
                ],
                "8899": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.11111
                ],
                "8968": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.52778
                ],
                "8969": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.52778
                ],
                "8970": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.52778
                ],
                "8971": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.52778
                ],
                "10216": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.61111
                ],
                "10217": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.61111
                ],
                "10752": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.51112
                ],
                "10753": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.51112
                ],
                "10754": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.51112
                ],
                "10756": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.11111
                ],
                "10758": [
                    0.55001,
                    1.05,
                    0,
                    0,
                    1.11111
                ]
            },
            "Size3-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "40": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.73611
                ],
                "41": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.73611
                ],
                "47": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    1.04445
                ],
                "91": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.52778
                ],
                "92": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    1.04445
                ],
                "93": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.52778
                ],
                "123": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.75
                ],
                "125": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.75
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "710": [
                    0,
                    0.75,
                    0,
                    0,
                    1.44445
                ],
                "732": [
                    0,
                    0.75,
                    0,
                    0,
                    1.44445
                ],
                "770": [
                    0,
                    0.75,
                    0,
                    0,
                    1.44445
                ],
                "771": [
                    0,
                    0.75,
                    0,
                    0,
                    1.44445
                ],
                "8730": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    1.0
                ],
                "8968": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.58334
                ],
                "8969": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.58334
                ],
                "8970": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.58334
                ],
                "8971": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.58334
                ],
                "10216": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.75
                ],
                "10217": [
                    0.95003,
                    1.45,
                    0,
                    0,
                    0.75
                ]
            },
            "Size4-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "40": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.79167
                ],
                "41": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.79167
                ],
                "47": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    1.27778
                ],
                "91": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.58334
                ],
                "92": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    1.27778
                ],
                "93": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.58334
                ],
                "123": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.80556
                ],
                "125": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.80556
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.25
                ],
                "710": [
                    0,
                    0.825,
                    0,
                    0,
                    1.8889
                ],
                "732": [
                    0,
                    0.825,
                    0,
                    0,
                    1.8889
                ],
                "770": [
                    0,
                    0.825,
                    0,
                    0,
                    1.8889
                ],
                "771": [
                    0,
                    0.825,
                    0,
                    0,
                    1.8889
                ],
                "8730": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    1.0
                ],
                "8968": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.63889
                ],
                "8969": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.63889
                ],
                "8970": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.63889
                ],
                "8971": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.63889
                ],
                "9115": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.875
                ],
                "9116": [
                    1e-05,
                    0.6,
                    0,
                    0,
                    0.875
                ],
                "9117": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.875
                ],
                "9118": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.875
                ],
                "9119": [
                    1e-05,
                    0.6,
                    0,
                    0,
                    0.875
                ],
                "9120": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.875
                ],
                "9121": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.66667
                ],
                "9122": [
                    -0.00099,
                    0.601,
                    0,
                    0,
                    0.66667
                ],
                "9123": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.66667
                ],
                "9124": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.66667
                ],
                "9125": [
                    -0.00099,
                    0.601,
                    0,
                    0,
                    0.66667
                ],
                "9126": [
                    0.64502,
                    1.155,
                    0,
                    0,
                    0.66667
                ],
                "9127": [
                    1e-05,
                    0.9,
                    0,
                    0,
                    0.88889
                ],
                "9128": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.88889
                ],
                "9129": [
                    0.90001,
                    0,
                    0,
                    0,
                    0.88889
                ],
                "9130": [
                    0,
                    0.3,
                    0,
                    0,
                    0.88889
                ],
                "9131": [
                    1e-05,
                    0.9,
                    0,
                    0,
                    0.88889
                ],
                "9132": [
                    0.65002,
                    1.15,
                    0,
                    0,
                    0.88889
                ],
                "9133": [
                    0.90001,
                    0,
                    0,
                    0,
                    0.88889
                ],
                "9143": [
                    0.88502,
                    0.915,
                    0,
                    0,
                    1.05556
                ],
                "10216": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.80556
                ],
                "10217": [
                    1.25003,
                    1.75,
                    0,
                    0,
                    0.80556
                ],
                "57344": [
                    -0.00499,
                    0.605,
                    0,
                    0,
                    1.05556
                ],
                "57345": [
                    -0.00499,
                    0.605,
                    0,
                    0,
                    1.05556
                ],
                "57680": [
                    0,
                    0.12,
                    0,
                    0,
                    0.45
                ],
                "57681": [
                    0,
                    0.12,
                    0,
                    0,
                    0.45
                ],
                "57682": [
                    0,
                    0.12,
                    0,
                    0,
                    0.45
                ],
                "57683": [
                    0,
                    0.12,
                    0,
                    0,
                    0.45
                ]
            },
            "Typewriter-Regular": {
                "32": [
                    0,
                    0,
                    0,
                    0,
                    0.525
                ],
                "33": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "34": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "35": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "36": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "37": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "38": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "39": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "40": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "41": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "42": [
                    0,
                    0.52083,
                    0,
                    0,
                    0.525
                ],
                "43": [
                    -0.08056,
                    0.53055,
                    0,
                    0,
                    0.525
                ],
                "44": [
                    0.13889,
                    0.125,
                    0,
                    0,
                    0.525
                ],
                "45": [
                    -0.08056,
                    0.53055,
                    0,
                    0,
                    0.525
                ],
                "46": [
                    0,
                    0.125,
                    0,
                    0,
                    0.525
                ],
                "47": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "48": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "49": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "50": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "51": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "52": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "53": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "54": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "55": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "56": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "57": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "58": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "59": [
                    0.13889,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "60": [
                    -0.05556,
                    0.55556,
                    0,
                    0,
                    0.525
                ],
                "61": [
                    -0.19549,
                    0.41562,
                    0,
                    0,
                    0.525
                ],
                "62": [
                    -0.05556,
                    0.55556,
                    0,
                    0,
                    0.525
                ],
                "63": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "64": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "65": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "66": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "67": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "68": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "69": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "70": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "71": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "72": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "73": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "74": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "75": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "76": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "77": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "78": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "79": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "80": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "81": [
                    0.13889,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "82": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "83": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "84": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "85": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "86": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "87": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "88": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "89": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "90": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "91": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "92": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "93": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "94": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "95": [
                    0.09514,
                    0,
                    0,
                    0,
                    0.525
                ],
                "96": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "97": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "98": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "99": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "100": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "101": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "102": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "103": [
                    0.22222,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "104": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "105": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "106": [
                    0.22222,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "107": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "108": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "109": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "110": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "111": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "112": [
                    0.22222,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "113": [
                    0.22222,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "114": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "115": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "116": [
                    0,
                    0.55358,
                    0,
                    0,
                    0.525
                ],
                "117": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "118": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "119": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "120": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "121": [
                    0.22222,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "122": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "123": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "124": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "125": [
                    0.08333,
                    0.69444,
                    0,
                    0,
                    0.525
                ],
                "126": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "127": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "160": [
                    0,
                    0,
                    0,
                    0,
                    0.525
                ],
                "176": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "184": [
                    0.19445,
                    0,
                    0,
                    0,
                    0.525
                ],
                "305": [
                    0,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "567": [
                    0.22222,
                    0.43056,
                    0,
                    0,
                    0.525
                ],
                "711": [
                    0,
                    0.56597,
                    0,
                    0,
                    0.525
                ],
                "713": [
                    0,
                    0.56555,
                    0,
                    0,
                    0.525
                ],
                "714": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "715": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "728": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "730": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "770": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "771": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "776": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "915": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "916": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "920": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "923": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "926": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "928": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "931": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "933": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "934": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "936": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "937": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "8216": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "8217": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "8242": [
                    0,
                    0.61111,
                    0,
                    0,
                    0.525
                ],
                "9251": [
                    0.11111,
                    0.21944,
                    0,
                    0,
                    0.525
                ]
            }
        };
        /**
 * This file contains metrics regarding fonts and individual symbols. The sigma
 * and xi variables, as well as the metricMap map contain data extracted from
 * TeX, TeX font metrics, and the TTF files. These data are then exposed via the
 * `metrics` variable and the getCharacterMetrics function.
 */ // In TeX, there are actually three sets of dimensions, one for each of
        // textstyle (size index 5 and higher: >=9pt), scriptstyle (size index 3 and 4:
        // 7-8pt), and scriptscriptstyle (size index 1 and 2: 5-6pt).  These are
        // provided in the arrays below, in that order.
        //
        // The font metrics are stored in fonts cmsy10, cmsy7, and cmsy5 respectively.
        // This was determined by running the following script:
        //
        //     latex -interaction=nonstopmode \
        //     '\documentclass{article}\usepackage{amsmath}\begin{document}' \
        //     '$a$ \expandafter\show\the\textfont2' \
        //     '\expandafter\show\the\scriptfont2' \
        //     '\expandafter\show\the\scriptscriptfont2' \
        //     '\stop'
        //
        // The metrics themselves were retrieved using the following commands:
        //
        //     tftopl cmsy10
        //     tftopl cmsy7
        //     tftopl cmsy5
        //
        // The output of each of these commands is quite lengthy.  The only part we
        // care about is the FONTDIMEN section. Each value is measured in EMs.
        const sigmasAndXis = {
            slant: [
                0.250,
                0.250,
                0.250
            ],
            // sigma1
            space: [
                0.000,
                0.000,
                0.000
            ],
            // sigma2
            stretch: [
                0.000,
                0.000,
                0.000
            ],
            // sigma3
            shrink: [
                0.000,
                0.000,
                0.000
            ],
            // sigma4
            xHeight: [
                0.431,
                0.431,
                0.431
            ],
            // sigma5
            quad: [
                1.000,
                1.171,
                1.472
            ],
            // sigma6
            extraSpace: [
                0.000,
                0.000,
                0.000
            ],
            // sigma7
            num1: [
                0.677,
                0.732,
                0.925
            ],
            // sigma8
            num2: [
                0.394,
                0.384,
                0.387
            ],
            // sigma9
            num3: [
                0.444,
                0.471,
                0.504
            ],
            // sigma10
            denom1: [
                0.686,
                0.752,
                1.025
            ],
            // sigma11
            denom2: [
                0.345,
                0.344,
                0.532
            ],
            // sigma12
            sup1: [
                0.413,
                0.503,
                0.504
            ],
            // sigma13
            sup2: [
                0.363,
                0.431,
                0.404
            ],
            // sigma14
            sup3: [
                0.289,
                0.286,
                0.294
            ],
            // sigma15
            sub1: [
                0.150,
                0.143,
                0.200
            ],
            // sigma16
            sub2: [
                0.247,
                0.286,
                0.400
            ],
            // sigma17
            supDrop: [
                0.386,
                0.353,
                0.494
            ],
            // sigma18
            subDrop: [
                0.050,
                0.071,
                0.100
            ],
            // sigma19
            delim1: [
                2.390,
                1.700,
                1.980
            ],
            // sigma20
            delim2: [
                1.010,
                1.157,
                1.420
            ],
            // sigma21
            axisHeight: [
                0.250,
                0.250,
                0.250
            ],
            // sigma22
            // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
            // they correspond to the font parameters of the extension fonts (family 3).
            // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
            // match cmex7, we'd use cmex7.tfm values for script and scriptscript
            // values.
            defaultRuleThickness: [
                0.04,
                0.049,
                0.049
            ],
            // xi8; cmex7: 0.049
            bigOpSpacing1: [
                0.111,
                0.111,
                0.111
            ],
            // xi9
            bigOpSpacing2: [
                0.166,
                0.166,
                0.166
            ],
            // xi10
            bigOpSpacing3: [
                0.2,
                0.2,
                0.2
            ],
            // xi11
            bigOpSpacing4: [
                0.6,
                0.611,
                0.611
            ],
            // xi12; cmex7: 0.611
            bigOpSpacing5: [
                0.1,
                0.143,
                0.143
            ],
            // xi13; cmex7: 0.143
            // The \sqrt rule width is taken from the height of the surd character.
            // Since we use the same font at all sizes, this thickness doesn't scale.
            sqrtRuleThickness: [
                0.04,
                0.04,
                0.04
            ],
            // This value determines how large a pt is, for metrics which are defined
            // in terms of pts.
            // This value is also used in katex.scss; if you change it make sure the
            // values match.
            ptPerEm: [
                10.0,
                10.0,
                10.0
            ],
            // The space between adjacent `|` columns in an array definition. From
            // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
            doubleRuleSep: [
                0.2,
                0.2,
                0.2
            ],
            // The width of separator lines in {array} environments. From
            // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
            arrayRuleWidth: [
                0.04,
                0.04,
                0.04
            ],
            // Two values from LaTeX source2e:
            fboxsep: [
                0.3,
                0.3,
                0.3
            ],
            //        3 pt / ptPerEm
            fboxrule: [
                0.04,
                0.04,
                0.04
            ] // 0.4 pt / ptPerEm
        }; // This map contains a mapping from font name and character code to character
        // metrics, including height, depth, italic correction, and skew (kern from the
        // character to the corresponding \skewchar)
        // This map is generated via `make metrics`. It should not be changed manually.
        // These are very rough approximations.  We default to Times New Roman which
        // should have Latin-1 and Cyrillic characters, but may not depending on the
        // operating system.  The metrics do not account for extra height from the
        // accents.  In the case of Cyrillic characters which have both ascenders and
        // descenders we prefer approximations with ascenders, primarily to prevent
        // the fraction bar or root line from intersecting the glyph.
        // TODO(kevinb) allow union of multiple glyph metrics for better accuracy.
        const extraCharacterMap = {
            // Latin-1
            "\xc5": 'A',
            "\xd0": 'D',
            "\xde": 'o',
            "\xe5": 'a',
            "\xf0": 'd',
            "\xfe": 'o',
            // Cyrillic
            "\u0410": 'A',
            "\u0411": 'B',
            "\u0412": 'B',
            "\u0413": 'F',
            "\u0414": 'A',
            "\u0415": 'E',
            "\u0416": 'K',
            "\u0417": '3',
            "\u0418": 'N',
            "\u0419": 'N',
            "\u041A": 'K',
            "\u041B": 'N',
            "\u041C": 'M',
            "\u041D": 'H',
            "\u041E": 'O',
            "\u041F": 'N',
            "\u0420": 'P',
            "\u0421": 'C',
            "\u0422": 'T',
            "\u0423": 'y',
            "\u0424": 'O',
            "\u0425": 'X',
            "\u0426": 'U',
            "\u0427": 'h',
            "\u0428": 'W',
            "\u0429": 'W',
            "\u042A": 'B',
            "\u042B": 'X',
            "\u042C": 'B',
            "\u042D": '3',
            "\u042E": 'X',
            "\u042F": 'R',
            "\u0430": 'a',
            "\u0431": 'b',
            "\u0432": 'a',
            "\u0433": 'r',
            "\u0434": 'y',
            "\u0435": 'e',
            "\u0436": 'm',
            "\u0437": 'e',
            "\u0438": 'n',
            "\u0439": 'n',
            "\u043A": 'n',
            "\u043B": 'n',
            "\u043C": 'm',
            "\u043D": 'n',
            "\u043E": 'o',
            "\u043F": 'n',
            "\u0440": 'p',
            "\u0441": 'c',
            "\u0442": 'o',
            "\u0443": 'y',
            "\u0444": 'b',
            "\u0445": 'x',
            "\u0446": 'n',
            "\u0447": 'n',
            "\u0448": 'w',
            "\u0449": 'w',
            "\u044A": 'a',
            "\u044B": 'm',
            "\u044C": 'a',
            "\u044D": 'e',
            "\u044E": 'm',
            "\u044F": 'r'
        };
        /**
 * This function adds new font metrics to default metricMap
 * It can also override existing metrics
 */ function setFontMetrics(fontName, metrics) {
            fontMetricsData[fontName] = metrics;
        }
        /**
 * This function is a convenience function for looking up information in the
 * metricMap table. It takes a character as a string, and a font.
 *
 * Note: the `width` property may be undefined if fontMetricsData.js wasn't
 * built using `Make extended_metrics`.
 */ function getCharacterMetrics(character, font, mode) {
            if (!fontMetricsData[font]) throw new Error("Font metrics not found for font: " + font + ".");
            let ch = character.charCodeAt(0);
            let metrics = fontMetricsData[font][ch];
            if (!metrics && character[0] in extraCharacterMap) {
                ch = extraCharacterMap[character[0]].charCodeAt(0);
                metrics = fontMetricsData[font][ch];
            }
            if (!metrics && mode === 'text') // We don't typically have font metrics for Asian scripts.
            // But since we support them in text mode, we need to return
            // some sort of metrics.
            // So if the character is in a script we support but we
            // don't have metrics for it, just use the metrics for
            // the Latin capital letter M. This is close enough because
            // we (currently) only care about the height of the glyph
            // not its width.
            {
                if (supportedCodepoint(ch)) metrics = fontMetricsData[font][77]; // 77 is the charcode for 'M'
            }
            if (metrics) return {
                depth: metrics[0],
                height: metrics[1],
                italic: metrics[2],
                skew: metrics[3],
                width: metrics[4]
            };
        }
        const fontMetricsBySizeIndex = {};
        /**
 * Get the font metrics for a given size.
 */ function getGlobalMetrics(size) {
            let sizeIndex;
            if (size >= 5) sizeIndex = 0;
            else if (size >= 3) sizeIndex = 1;
            else sizeIndex = 2;
            if (!fontMetricsBySizeIndex[sizeIndex]) {
                const metrics = fontMetricsBySizeIndex[sizeIndex] = {
                    cssEmPerMu: sigmasAndXis.quad[sizeIndex] / 18
                };
                for(const key in sigmasAndXis)if (sigmasAndXis.hasOwnProperty(key)) metrics[key] = sigmasAndXis[key][sizeIndex];
            }
            return fontMetricsBySizeIndex[sizeIndex];
        }
        /**
 * This file contains information about the options that the Parser carries
 * around with it while parsing. Data is held in an `Options` object, and when
 * recursing, a new `Options` object can be created with the `.with*` and
 * `.reset` functions.
 */ const sizeStyleMap = [
            // The size mappings are taken from TeX with \normalsize=10pt.
            [
                1,
                1,
                1
            ],
            [
                2,
                1,
                1
            ],
            [
                3,
                1,
                1
            ],
            [
                4,
                2,
                1
            ],
            [
                5,
                2,
                1
            ],
            [
                6,
                3,
                1
            ],
            [
                7,
                4,
                2
            ],
            [
                8,
                6,
                3
            ],
            [
                9,
                7,
                6
            ],
            [
                10,
                8,
                7
            ],
            [
                11,
                10,
                9
            ] // size11: [24.88, 20.74, 17.28] \HUGE
        ];
        const sizeMultipliers = [
            // you change size indexes, change that function.
            0.5,
            0.6,
            0.7,
            0.8,
            0.9,
            1.0,
            1.2,
            1.44,
            1.728,
            2.074,
            2.488
        ];
        const sizeAtStyle = function(size, style) {
            return style.size < 2 ? size : sizeStyleMap[size - 1][style.size - 1];
        }; // In these types, "" (empty string) means "no change".
        /**
 * This is the main options class. It contains the current style, size, color,
 * and font.
 *
 * Options objects should not be modified. To create a new Options with
 * different properties, call a `.having*` method.
 */ class Options {
            // A font family applies to a group of fonts (i.e. SansSerif), while a font
            // represents a specific font (i.e. SansSerif Bold).
            // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
            /**
   * The base size index.
   */ constructor(data){
                this.style = void 0;
                this.color = void 0;
                this.size = void 0;
                this.textSize = void 0;
                this.phantom = void 0;
                this.font = void 0;
                this.fontFamily = void 0;
                this.fontWeight = void 0;
                this.fontShape = void 0;
                this.sizeMultiplier = void 0;
                this.maxSize = void 0;
                this.minRuleThickness = void 0;
                this._fontMetrics = void 0;
                this.style = data.style;
                this.color = data.color;
                this.size = data.size || Options.BASESIZE;
                this.textSize = data.textSize || this.size;
                this.phantom = !!data.phantom;
                this.font = data.font || "";
                this.fontFamily = data.fontFamily || "";
                this.fontWeight = data.fontWeight || '';
                this.fontShape = data.fontShape || '';
                this.sizeMultiplier = sizeMultipliers[this.size - 1];
                this.maxSize = data.maxSize;
                this.minRuleThickness = data.minRuleThickness;
                this._fontMetrics = undefined;
            }
            /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */ extend(extension) {
                const data = {
                    style: this.style,
                    size: this.size,
                    textSize: this.textSize,
                    color: this.color,
                    phantom: this.phantom,
                    font: this.font,
                    fontFamily: this.fontFamily,
                    fontWeight: this.fontWeight,
                    fontShape: this.fontShape,
                    maxSize: this.maxSize,
                    minRuleThickness: this.minRuleThickness
                };
                for(const key in extension)if (extension.hasOwnProperty(key)) data[key] = extension[key];
                return new Options(data);
            }
            /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */ havingStyle(style) {
                if (this.style === style) return this;
                else return this.extend({
                    style: style,
                    size: sizeAtStyle(this.textSize, style)
                });
            }
            /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */ havingCrampedStyle() {
                return this.havingStyle(this.style.cramp());
            }
            /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */ havingSize(size) {
                if (this.size === size && this.textSize === size) return this;
                else return this.extend({
                    style: this.style.text(),
                    size: size,
                    textSize: size,
                    sizeMultiplier: sizeMultipliers[size - 1]
                });
            }
            /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */ havingBaseStyle(style) {
                style = style || this.style.text();
                const wantSize = sizeAtStyle(Options.BASESIZE, style);
                if (this.size === wantSize && this.textSize === Options.BASESIZE && this.style === style) return this;
                else return this.extend({
                    style: style,
                    size: wantSize
                });
            }
            /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */ havingBaseSizing() {
                let size;
                switch(this.style.id){
                    case 4:
                    case 5:
                        size = 3; // normalsize in scriptstyle
                        break;
                    case 6:
                    case 7:
                        size = 1; // normalsize in scriptscriptstyle
                        break;
                    default:
                        size = 6;
                }
                return this.extend({
                    style: this.style.text(),
                    size: size
                });
            }
            /**
   * Create a new options object with the given color.
   */ withColor(color) {
                return this.extend({
                    color: color
                });
            }
            /**
   * Create a new options object with "phantom" set to true.
   */ withPhantom() {
                return this.extend({
                    phantom: true
                });
            }
            /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */ withFont(font) {
                return this.extend({
                    font: font
                });
            }
            /**
   * Create a new options objects with the given fontFamily.
   */ withTextFontFamily(fontFamily) {
                return this.extend({
                    fontFamily: fontFamily,
                    font: ""
                });
            }
            /**
   * Creates a new options object with the given font weight
   */ withTextFontWeight(fontWeight) {
                return this.extend({
                    fontWeight: fontWeight,
                    font: ""
                });
            }
            /**
   * Creates a new options object with the given font weight
   */ withTextFontShape(fontShape) {
                return this.extend({
                    fontShape: fontShape,
                    font: ""
                });
            }
            /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */ sizingClasses(oldOptions) {
                if (oldOptions.size !== this.size) return [
                    "sizing",
                    "reset-size" + oldOptions.size,
                    "size" + this.size
                ];
                else return [];
            }
            /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */ baseSizingClasses() {
                if (this.size !== Options.BASESIZE) return [
                    "sizing",
                    "reset-size" + this.size,
                    "size" + Options.BASESIZE
                ];
                else return [];
            }
            /**
   * Return the font metrics for this size.
   */ fontMetrics() {
                if (!this._fontMetrics) this._fontMetrics = getGlobalMetrics(this.size);
                return this._fontMetrics;
            }
            /**
   * Gets the CSS color of the current options object
   */ getColor() {
                if (this.phantom) return "transparent";
                else return this.color;
            }
        }
        Options.BASESIZE = 6;
        /* harmony default export */ var src_Options = Options;
        /**
 * This file does conversion between units.  In particular, it provides
 * calculateSize to convert other units into ems.
 */ // This table gives the number of TeX pts in one of each *absolute* TeX unit.
        // Thus, multiplying a length by this number converts the length from units
        // into pts.  Dividing the result by ptPerEm gives the number of ems
        // *assuming* a font size of ptPerEm (normal size, normal style).
        const ptPerUnit = {
            // https://en.wikibooks.org/wiki/LaTeX/Lengths and
            // https://tex.stackexchange.com/a/8263
            "pt": 1,
            // TeX point
            "mm": 7227 / 2540,
            // millimeter
            "cm": 7227 / 254,
            // centimeter
            "in": 72.27,
            // inch
            "bp": 1.00375,
            // big (PostScript) points
            "pc": 12,
            // pica
            "dd": 1238 / 1157,
            // didot
            "cc": 14856 / 1157,
            // cicero (12 didot)
            "nd": 685 / 642,
            // new didot
            "nc": 1370 / 107,
            // new cicero (12 new didot)
            "sp": 1 / 65536,
            // scaled point (TeX's internal smallest unit)
            // https://tex.stackexchange.com/a/41371
            "px": 1.00375 // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
        }; // Dictionary of relative units, for fast validity testing.
        const relativeUnit = {
            "ex": true,
            "em": true,
            "mu": true
        };
        /**
 * Determine whether the specified unit (either a string defining the unit
 * or a "size" parse node containing a unit field) is valid.
 */ const validUnit = function(unit) {
            if (typeof unit !== "string") unit = unit.unit;
            return unit in ptPerUnit || unit in relativeUnit || unit === "ex";
        };
        /*
 * Convert a "size" parse node (with numeric "number" and string "unit" fields,
 * as parsed by functions.js argType "size") into a CSS em value for the
 * current style/scale.  `options` gives the current options.
 */ const calculateSize = function(sizeValue, options) {
            let scale;
            if (sizeValue.unit in ptPerUnit) // Absolute units
            scale = ptPerUnit[sizeValue.unit] // Convert unit to pt
             / options.fontMetrics().ptPerEm // Convert pt to CSS em
             / options.sizeMultiplier; // Unscale to make absolute units
            else if (sizeValue.unit === "mu") // `mu` units scale with scriptstyle/scriptscriptstyle.
            scale = options.fontMetrics().cssEmPerMu;
            else {
                // Other relative units always refer to the *textstyle* font
                // in the current size.
                let unitOptions;
                if (options.style.isTight()) // isTight() means current style is script/scriptscript.
                unitOptions = options.havingStyle(options.style.text());
                else unitOptions = options;
                 // TODO: In TeX these units are relative to the quad of the current
                // *text* font, e.g. cmr10. KaTeX instead uses values from the
                // comparably-sized *Computer Modern symbol* font. At 10pt, these
                // match. At 7pt and 5pt, they differ: cmr7=1.138894, cmsy7=1.170641;
                // cmr5=1.361133, cmsy5=1.472241. Consider $\scriptsize a\kern1emb$.
                // TeX \showlists shows a kern of 1.13889 * fontsize;
                // KaTeX shows a kern of 1.171 * fontsize.
                if (sizeValue.unit === "ex") scale = unitOptions.fontMetrics().xHeight;
                else if (sizeValue.unit === "em") scale = unitOptions.fontMetrics().quad;
                else throw new src_ParseError("Invalid unit: '" + sizeValue.unit + "'");
                if (unitOptions !== options) scale *= unitOptions.sizeMultiplier / options.sizeMultiplier;
            }
            return Math.min(sizeValue.number * scale, options.maxSize);
        };
        /**
 * Round `n` to 4 decimal places, or to the nearest 1/10,000th em. See
 * https://github.com/KaTeX/KaTeX/pull/2460.
 */ const makeEm = function(n) {
            return +n.toFixed(4) + "em";
        };
        /**
 * These objects store the data about the DOM nodes we create, as well as some
 * extra data. They can then be transformed into real DOM nodes with the
 * `toNode` function or HTML markup using `toMarkup`. They are useful for both
 * storing extra properties on the nodes, as well as providing a way to easily
 * work with the DOM.
 *
 * Similar functions for working with MathML nodes exist in mathMLTree.js.
 *
 * TODO: refactor `span` and `anchor` into common superclass when
 * target environments support class inheritance
 */ /**
 * Create an HTML className based on a list of classes. In addition to joining
 * with spaces, we also remove empty classes.
 */ const createClass = function(classes) {
            return classes.filter((cls)=>cls).join(" ");
        };
        const initNode = function(classes, options, style) {
            this.classes = classes || [];
            this.attributes = {};
            this.height = 0;
            this.depth = 0;
            this.maxFontSize = 0;
            this.style = style || {};
            if (options) {
                if (options.style.isTight()) this.classes.push("mtight");
                const color = options.getColor();
                if (color) this.style.color = color;
            }
        };
        /**
 * Convert into an HTML node
 */ const toNode = function(tagName) {
            const node = document.createElement(tagName); // Apply the class
            node.className = createClass(this.classes); // Apply inline styles
            for(const style in this.style)if (this.style.hasOwnProperty(style)) // $FlowFixMe Flow doesn't seem to understand span.style's type.
            node.style[style] = this.style[style];
             // Apply attributes
            for(const attr in this.attributes)if (this.attributes.hasOwnProperty(attr)) node.setAttribute(attr, this.attributes[attr]);
             // Append the children, also as HTML nodes
            for(let i = 0; i < this.children.length; i++)node.appendChild(this.children[i].toNode());
            return node;
        };
        /**
 * https://w3c.github.io/html-reference/syntax.html#syntax-attributes
 *
 * > Attribute Names must consist of one or more characters
 * other than the space characters, U+0000 NULL,
 * '"', "'", ">", "/", "=", the control characters,
 * and any characters that are not defined by Unicode.
 */ const invalidAttributeNameRegex = /[\s"'>/=\x00-\x1f]/;
        /**
 * Convert into an HTML markup string
 */ const toMarkup = function(tagName) {
            let markup = "<" + tagName; // Add the class
            if (this.classes.length) markup += " class=\"" + utils.escape(createClass(this.classes)) + "\"";
            let styles = ""; // Add the styles, after hyphenation
            for(const style in this.style)if (this.style.hasOwnProperty(style)) styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
            if (styles) markup += " style=\"" + utils.escape(styles) + "\"";
             // Add the attributes
            for(const attr in this.attributes)if (this.attributes.hasOwnProperty(attr)) {
                if (invalidAttributeNameRegex.test(attr)) throw new src_ParseError("Invalid attribute name '" + attr + "'");
                markup += " " + attr + "=\"" + utils.escape(this.attributes[attr]) + "\"";
            }
            markup += ">"; // Add the markup of the children, also as markup
            for(let i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
            markup += "</" + tagName + ">";
            return markup;
        }; // Making the type below exact with all optional fields doesn't work due to
        // - https://github.com/facebook/flow/issues/4582
        // - https://github.com/facebook/flow/issues/5688
        // However, since *all* fields are optional, $Shape<> works as suggested in 5688
        // above.
        // This type does not include all CSS properties. Additional properties should
        // be added as needed.
        /**
 * This node represents a span node, with a className, a list of children, and
 * an inline style. It also contains information about its height, depth, and
 * maxFontSize.
 *
 * Represents two types with different uses: SvgSpan to wrap an SVG and DomSpan
 * otherwise. This typesafety is important when HTML builders access a span's
 * children.
 */ class Span {
            constructor(classes, children, options, style){
                this.children = void 0;
                this.attributes = void 0;
                this.classes = void 0;
                this.height = void 0;
                this.depth = void 0;
                this.width = void 0;
                this.maxFontSize = void 0;
                this.style = void 0;
                initNode.call(this, classes, options, style);
                this.children = children || [];
            }
            /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */ setAttribute(attribute, value) {
                this.attributes[attribute] = value;
            }
            hasClass(className) {
                return this.classes.includes(className);
            }
            toNode() {
                return toNode.call(this, "span");
            }
            toMarkup() {
                return toMarkup.call(this, "span");
            }
        }
        /**
 * This node represents an anchor (<a>) element with a hyperlink.  See `span`
 * for further details.
 */ class Anchor {
            constructor(href, classes, children, options){
                this.children = void 0;
                this.attributes = void 0;
                this.classes = void 0;
                this.height = void 0;
                this.depth = void 0;
                this.maxFontSize = void 0;
                this.style = void 0;
                initNode.call(this, classes, options);
                this.children = children || [];
                this.setAttribute('href', href);
            }
            setAttribute(attribute, value) {
                this.attributes[attribute] = value;
            }
            hasClass(className) {
                return this.classes.includes(className);
            }
            toNode() {
                return toNode.call(this, "a");
            }
            toMarkup() {
                return toMarkup.call(this, "a");
            }
        }
        /**
 * This node represents an image embed (<img>) element.
 */ class Img {
            constructor(src, alt, style){
                this.src = void 0;
                this.alt = void 0;
                this.classes = void 0;
                this.height = void 0;
                this.depth = void 0;
                this.maxFontSize = void 0;
                this.style = void 0;
                this.alt = alt;
                this.src = src;
                this.classes = [
                    "mord"
                ];
                this.style = style;
            }
            hasClass(className) {
                return this.classes.includes(className);
            }
            toNode() {
                const node = document.createElement("img");
                node.src = this.src;
                node.alt = this.alt;
                node.className = "mord"; // Apply inline styles
                for(const style in this.style)if (this.style.hasOwnProperty(style)) // $FlowFixMe
                node.style[style] = this.style[style];
                return node;
            }
            toMarkup() {
                let markup = "<img src=\"" + utils.escape(this.src) + "\"" + (" alt=\"" + utils.escape(this.alt) + "\""); // Add the styles, after hyphenation
                let styles = "";
                for(const style in this.style)if (this.style.hasOwnProperty(style)) styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
                if (styles) markup += " style=\"" + utils.escape(styles) + "\"";
                markup += "'/>";
                return markup;
            }
        }
        const iCombinations = {
            "\xee": '\u0131\u0302',
            "\xef": '\u0131\u0308',
            "\xed": '\u0131\u0301',
            // 'ī': '\u0131\u0304', // enable when we add Extended Latin
            "\xec": '\u0131\u0300'
        };
        /**
 * A symbol node contains information about a single symbol. It either renders
 * to a single text node, or a span with a single text node in it, depending on
 * whether it has CSS classes, styles, or needs italic correction.
 */ class SymbolNode {
            constructor(text, height, depth, italic, skew, width, classes, style){
                this.text = void 0;
                this.height = void 0;
                this.depth = void 0;
                this.italic = void 0;
                this.skew = void 0;
                this.width = void 0;
                this.maxFontSize = void 0;
                this.classes = void 0;
                this.style = void 0;
                this.text = text;
                this.height = height || 0;
                this.depth = depth || 0;
                this.italic = italic || 0;
                this.skew = skew || 0;
                this.width = width || 0;
                this.classes = classes || [];
                this.style = style || {};
                this.maxFontSize = 0; // Mark text from non-Latin scripts with specific classes so that we
                // can specify which fonts to use.  This allows us to render these
                // characters with a serif font in situations where the browser would
                // either default to a sans serif or render a placeholder character.
                // We use CSS class names like cjk_fallback, hangul_fallback and
                // brahmic_fallback. See ./unicodeScripts.js for the set of possible
                // script names
                const script = scriptFromCodepoint(this.text.charCodeAt(0));
                if (script) this.classes.push(script + "_fallback");
                if (/[îïíì]/.test(this.text)) // add ī when we add Extended Latin
                this.text = iCombinations[this.text];
            }
            hasClass(className) {
                return this.classes.includes(className);
            }
            /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */ toNode() {
                const node = document.createTextNode(this.text);
                let span = null;
                if (this.italic > 0) {
                    span = document.createElement("span");
                    span.style.marginRight = makeEm(this.italic);
                }
                if (this.classes.length > 0) {
                    span = span || document.createElement("span");
                    span.className = createClass(this.classes);
                }
                for(const style in this.style)if (this.style.hasOwnProperty(style)) {
                    span = span || document.createElement("span"); // $FlowFixMe Flow doesn't seem to understand span.style's type.
                    span.style[style] = this.style[style];
                }
                if (span) {
                    span.appendChild(node);
                    return span;
                } else return node;
            }
            /**
   * Creates markup for a symbol node.
   */ toMarkup() {
                // TODO(alpert): More duplication than I'd like from
                // span.prototype.toMarkup and symbolNode.prototype.toNode...
                let needsSpan = false;
                let markup = "<span";
                if (this.classes.length) {
                    needsSpan = true;
                    markup += " class=\"";
                    markup += utils.escape(createClass(this.classes));
                    markup += "\"";
                }
                let styles = "";
                if (this.italic > 0) styles += "margin-right:" + this.italic + "em;";
                for(const style in this.style)if (this.style.hasOwnProperty(style)) styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
                if (styles) {
                    needsSpan = true;
                    markup += " style=\"" + utils.escape(styles) + "\"";
                }
                const escaped = utils.escape(this.text);
                if (needsSpan) {
                    markup += ">";
                    markup += escaped;
                    markup += "</span>";
                    return markup;
                } else return escaped;
            }
        }
        /**
 * SVG nodes are used to render stretchy wide elements.
 */ class SvgNode {
            constructor(children, attributes){
                this.children = void 0;
                this.attributes = void 0;
                this.children = children || [];
                this.attributes = attributes || {};
            }
            toNode() {
                const svgNS = "http://www.w3.org/2000/svg";
                const node = document.createElementNS(svgNS, "svg"); // Apply attributes
                for(const attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
                for(let i = 0; i < this.children.length; i++)node.appendChild(this.children[i].toNode());
                return node;
            }
            toMarkup() {
                let markup = "<svg xmlns=\"http://www.w3.org/2000/svg\""; // Apply attributes
                for(const attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) markup += " " + attr + "=\"" + utils.escape(this.attributes[attr]) + "\"";
                markup += ">";
                for(let i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
                markup += "</svg>";
                return markup;
            }
        }
        class PathNode {
            constructor(pathName, alternate){
                this.pathName = void 0;
                this.alternate = void 0;
                this.pathName = pathName;
                this.alternate = alternate; // Used only for \sqrt, \phase, & tall delims
            }
            toNode() {
                const svgNS = "http://www.w3.org/2000/svg";
                const node = document.createElementNS(svgNS, "path");
                if (this.alternate) node.setAttribute("d", this.alternate);
                else node.setAttribute("d", path[this.pathName]);
                return node;
            }
            toMarkup() {
                if (this.alternate) return "<path d=\"" + utils.escape(this.alternate) + "\"/>";
                else return "<path d=\"" + utils.escape(path[this.pathName]) + "\"/>";
            }
        }
        class LineNode {
            constructor(attributes){
                this.attributes = void 0;
                this.attributes = attributes || {};
            }
            toNode() {
                const svgNS = "http://www.w3.org/2000/svg";
                const node = document.createElementNS(svgNS, "line"); // Apply attributes
                for(const attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
                return node;
            }
            toMarkup() {
                let markup = "<line";
                for(const attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) markup += " " + attr + "=\"" + utils.escape(this.attributes[attr]) + "\"";
                markup += "/>";
                return markup;
            }
        }
        function assertSymbolDomNode(group) {
            if (group instanceof SymbolNode) return group;
            else throw new Error("Expected symbolNode but got " + String(group) + ".");
        }
        function assertSpan(group) {
            if (group instanceof Span) return group;
            else throw new Error("Expected span<HtmlDomNode> but got " + String(group) + ".");
        }
        /**
 * This file holds a list of all no-argument functions and single-character
 * symbols (like 'a' or ';').
 *
 * For each of the symbols, there are three properties they can have:
 * - font (required): the font to be used for this symbol. Either "main" (the
     normal font), or "ams" (the ams fonts).
 * - group (required): the ParseNode group type the symbol should have (i.e.
     "textord", "mathord", etc).
     See https://github.com/KaTeX/KaTeX/wiki/Examining-TeX#group-types
 * - replace: the character that this symbol or function should be
 *   replaced with (i.e. "\phi" has a replace value of "\u03d5", the phi
 *   character in the main font).
 *
 * The outermost map in the table indicates what mode the symbols should be
 * accepted in (e.g. "math" or "text").
 */ // Some of these have a "-token" suffix since these are also used as `ParseNode`
        // types for raw text tokens, and we want to avoid conflicts with higher-level
        // `ParseNode` types. These `ParseNode`s are constructed within `Parser` by
        // looking up the `symbols` map.
        const ATOMS = {
            "bin": 1,
            "close": 1,
            "inner": 1,
            "open": 1,
            "punct": 1,
            "rel": 1
        };
        const NON_ATOMS = {
            "accent-token": 1,
            "mathord": 1,
            "op-token": 1,
            "spacing": 1,
            "textord": 1
        };
        const symbols = {
            "math": {},
            "text": {}
        };
        /* harmony default export */ var src_symbols = symbols;
        /** `acceptUnicodeChar = true` is only applicable if `replace` is set. */ function defineSymbol(mode, font, group, replace, name, acceptUnicodeChar) {
            symbols[mode][name] = {
                font: font,
                group: group,
                replace: replace
            };
            if (acceptUnicodeChar && replace) symbols[mode][replace] = symbols[mode][name];
        } // Some abbreviations for commonly used strings.
        // This helps minify the code, and also spotting typos using jshint.
        // modes:
        const math = "math";
        const symbols_text = "text"; // fonts:
        const main = "main";
        const ams = "ams"; // groups:
        const accent = "accent-token";
        const bin = "bin";
        const symbols_close = "close";
        const inner = "inner";
        const mathord = "mathord";
        const op = "op-token";
        const symbols_open = "open";
        const punct = "punct";
        const rel = "rel";
        const spacing = "spacing";
        const textord = "textord"; // Now comes the symbol table
        // Relation Symbols
        defineSymbol(math, main, rel, "\u2261", "\\equiv", true);
        defineSymbol(math, main, rel, "\u227a", "\\prec", true);
        defineSymbol(math, main, rel, "\u227b", "\\succ", true);
        defineSymbol(math, main, rel, "\u223c", "\\sim", true);
        defineSymbol(math, main, rel, "\u22a5", "\\perp");
        defineSymbol(math, main, rel, "\u2aaf", "\\preceq", true);
        defineSymbol(math, main, rel, "\u2ab0", "\\succeq", true);
        defineSymbol(math, main, rel, "\u2243", "\\simeq", true);
        defineSymbol(math, main, rel, "\u2223", "\\mid", true);
        defineSymbol(math, main, rel, "\u226a", "\\ll", true);
        defineSymbol(math, main, rel, "\u226b", "\\gg", true);
        defineSymbol(math, main, rel, "\u224d", "\\asymp", true);
        defineSymbol(math, main, rel, "\u2225", "\\parallel");
        defineSymbol(math, main, rel, "\u22c8", "\\bowtie", true);
        defineSymbol(math, main, rel, "\u2323", "\\smile", true);
        defineSymbol(math, main, rel, "\u2291", "\\sqsubseteq", true);
        defineSymbol(math, main, rel, "\u2292", "\\sqsupseteq", true);
        defineSymbol(math, main, rel, "\u2250", "\\doteq", true);
        defineSymbol(math, main, rel, "\u2322", "\\frown", true);
        defineSymbol(math, main, rel, "\u220b", "\\ni", true);
        defineSymbol(math, main, rel, "\u221d", "\\propto", true);
        defineSymbol(math, main, rel, "\u22a2", "\\vdash", true);
        defineSymbol(math, main, rel, "\u22a3", "\\dashv", true);
        defineSymbol(math, main, rel, "\u220b", "\\owns"); // Punctuation
        defineSymbol(math, main, punct, "\u002e", "\\ldotp");
        defineSymbol(math, main, punct, "\u22c5", "\\cdotp"); // Misc Symbols
        defineSymbol(math, main, textord, "\u0023", "\\#");
        defineSymbol(symbols_text, main, textord, "\u0023", "\\#");
        defineSymbol(math, main, textord, "\u0026", "\\&");
        defineSymbol(symbols_text, main, textord, "\u0026", "\\&");
        defineSymbol(math, main, textord, "\u2135", "\\aleph", true);
        defineSymbol(math, main, textord, "\u2200", "\\forall", true);
        defineSymbol(math, main, textord, "\u210f", "\\hbar", true);
        defineSymbol(math, main, textord, "\u2203", "\\exists", true);
        defineSymbol(math, main, textord, "\u2207", "\\nabla", true);
        defineSymbol(math, main, textord, "\u266d", "\\flat", true);
        defineSymbol(math, main, textord, "\u2113", "\\ell", true);
        defineSymbol(math, main, textord, "\u266e", "\\natural", true);
        defineSymbol(math, main, textord, "\u2663", "\\clubsuit", true);
        defineSymbol(math, main, textord, "\u2118", "\\wp", true);
        defineSymbol(math, main, textord, "\u266f", "\\sharp", true);
        defineSymbol(math, main, textord, "\u2662", "\\diamondsuit", true);
        defineSymbol(math, main, textord, "\u211c", "\\Re", true);
        defineSymbol(math, main, textord, "\u2661", "\\heartsuit", true);
        defineSymbol(math, main, textord, "\u2111", "\\Im", true);
        defineSymbol(math, main, textord, "\u2660", "\\spadesuit", true);
        defineSymbol(math, main, textord, "\u00a7", "\\S", true);
        defineSymbol(symbols_text, main, textord, "\u00a7", "\\S");
        defineSymbol(math, main, textord, "\u00b6", "\\P", true);
        defineSymbol(symbols_text, main, textord, "\u00b6", "\\P"); // Math and Text
        defineSymbol(math, main, textord, "\u2020", "\\dag");
        defineSymbol(symbols_text, main, textord, "\u2020", "\\dag");
        defineSymbol(symbols_text, main, textord, "\u2020", "\\textdagger");
        defineSymbol(math, main, textord, "\u2021", "\\ddag");
        defineSymbol(symbols_text, main, textord, "\u2021", "\\ddag");
        defineSymbol(symbols_text, main, textord, "\u2021", "\\textdaggerdbl"); // Large Delimiters
        defineSymbol(math, main, symbols_close, "\u23b1", "\\rmoustache", true);
        defineSymbol(math, main, symbols_open, "\u23b0", "\\lmoustache", true);
        defineSymbol(math, main, symbols_close, "\u27ef", "\\rgroup", true);
        defineSymbol(math, main, symbols_open, "\u27ee", "\\lgroup", true); // Binary Operators
        defineSymbol(math, main, bin, "\u2213", "\\mp", true);
        defineSymbol(math, main, bin, "\u2296", "\\ominus", true);
        defineSymbol(math, main, bin, "\u228e", "\\uplus", true);
        defineSymbol(math, main, bin, "\u2293", "\\sqcap", true);
        defineSymbol(math, main, bin, "\u2217", "\\ast");
        defineSymbol(math, main, bin, "\u2294", "\\sqcup", true);
        defineSymbol(math, main, bin, "\u25ef", "\\bigcirc", true);
        defineSymbol(math, main, bin, "\u2219", "\\bullet", true);
        defineSymbol(math, main, bin, "\u2021", "\\ddagger");
        defineSymbol(math, main, bin, "\u2240", "\\wr", true);
        defineSymbol(math, main, bin, "\u2a3f", "\\amalg");
        defineSymbol(math, main, bin, "\u0026", "\\And"); // from amsmath
        // Arrow Symbols
        defineSymbol(math, main, rel, "\u27f5", "\\longleftarrow", true);
        defineSymbol(math, main, rel, "\u21d0", "\\Leftarrow", true);
        defineSymbol(math, main, rel, "\u27f8", "\\Longleftarrow", true);
        defineSymbol(math, main, rel, "\u27f6", "\\longrightarrow", true);
        defineSymbol(math, main, rel, "\u21d2", "\\Rightarrow", true);
        defineSymbol(math, main, rel, "\u27f9", "\\Longrightarrow", true);
        defineSymbol(math, main, rel, "\u2194", "\\leftrightarrow", true);
        defineSymbol(math, main, rel, "\u27f7", "\\longleftrightarrow", true);
        defineSymbol(math, main, rel, "\u21d4", "\\Leftrightarrow", true);
        defineSymbol(math, main, rel, "\u27fa", "\\Longleftrightarrow", true);
        defineSymbol(math, main, rel, "\u21a6", "\\mapsto", true);
        defineSymbol(math, main, rel, "\u27fc", "\\longmapsto", true);
        defineSymbol(math, main, rel, "\u2197", "\\nearrow", true);
        defineSymbol(math, main, rel, "\u21a9", "\\hookleftarrow", true);
        defineSymbol(math, main, rel, "\u21aa", "\\hookrightarrow", true);
        defineSymbol(math, main, rel, "\u2198", "\\searrow", true);
        defineSymbol(math, main, rel, "\u21bc", "\\leftharpoonup", true);
        defineSymbol(math, main, rel, "\u21c0", "\\rightharpoonup", true);
        defineSymbol(math, main, rel, "\u2199", "\\swarrow", true);
        defineSymbol(math, main, rel, "\u21bd", "\\leftharpoondown", true);
        defineSymbol(math, main, rel, "\u21c1", "\\rightharpoondown", true);
        defineSymbol(math, main, rel, "\u2196", "\\nwarrow", true);
        defineSymbol(math, main, rel, "\u21cc", "\\rightleftharpoons", true); // AMS Negated Binary Relations
        defineSymbol(math, ams, rel, "\u226e", "\\nless", true); // Symbol names preceded by "@" each have a corresponding macro.
        defineSymbol(math, ams, rel, "\ue010", "\\@nleqslant");
        defineSymbol(math, ams, rel, "\ue011", "\\@nleqq");
        defineSymbol(math, ams, rel, "\u2a87", "\\lneq", true);
        defineSymbol(math, ams, rel, "\u2268", "\\lneqq", true);
        defineSymbol(math, ams, rel, "\ue00c", "\\@lvertneqq");
        defineSymbol(math, ams, rel, "\u22e6", "\\lnsim", true);
        defineSymbol(math, ams, rel, "\u2a89", "\\lnapprox", true);
        defineSymbol(math, ams, rel, "\u2280", "\\nprec", true); // unicode-math maps \u22e0 to \npreccurlyeq. We'll use the AMS synonym.
        defineSymbol(math, ams, rel, "\u22e0", "\\npreceq", true);
        defineSymbol(math, ams, rel, "\u22e8", "\\precnsim", true);
        defineSymbol(math, ams, rel, "\u2ab9", "\\precnapprox", true);
        defineSymbol(math, ams, rel, "\u2241", "\\nsim", true);
        defineSymbol(math, ams, rel, "\ue006", "\\@nshortmid");
        defineSymbol(math, ams, rel, "\u2224", "\\nmid", true);
        defineSymbol(math, ams, rel, "\u22ac", "\\nvdash", true);
        defineSymbol(math, ams, rel, "\u22ad", "\\nvDash", true);
        defineSymbol(math, ams, rel, "\u22ea", "\\ntriangleleft");
        defineSymbol(math, ams, rel, "\u22ec", "\\ntrianglelefteq", true);
        defineSymbol(math, ams, rel, "\u228a", "\\subsetneq", true);
        defineSymbol(math, ams, rel, "\ue01a", "\\@varsubsetneq");
        defineSymbol(math, ams, rel, "\u2acb", "\\subsetneqq", true);
        defineSymbol(math, ams, rel, "\ue017", "\\@varsubsetneqq");
        defineSymbol(math, ams, rel, "\u226f", "\\ngtr", true);
        defineSymbol(math, ams, rel, "\ue00f", "\\@ngeqslant");
        defineSymbol(math, ams, rel, "\ue00e", "\\@ngeqq");
        defineSymbol(math, ams, rel, "\u2a88", "\\gneq", true);
        defineSymbol(math, ams, rel, "\u2269", "\\gneqq", true);
        defineSymbol(math, ams, rel, "\ue00d", "\\@gvertneqq");
        defineSymbol(math, ams, rel, "\u22e7", "\\gnsim", true);
        defineSymbol(math, ams, rel, "\u2a8a", "\\gnapprox", true);
        defineSymbol(math, ams, rel, "\u2281", "\\nsucc", true); // unicode-math maps \u22e1 to \nsucccurlyeq. We'll use the AMS synonym.
        defineSymbol(math, ams, rel, "\u22e1", "\\nsucceq", true);
        defineSymbol(math, ams, rel, "\u22e9", "\\succnsim", true);
        defineSymbol(math, ams, rel, "\u2aba", "\\succnapprox", true); // unicode-math maps \u2246 to \simneqq. We'll use the AMS synonym.
        defineSymbol(math, ams, rel, "\u2246", "\\ncong", true);
        defineSymbol(math, ams, rel, "\ue007", "\\@nshortparallel");
        defineSymbol(math, ams, rel, "\u2226", "\\nparallel", true);
        defineSymbol(math, ams, rel, "\u22af", "\\nVDash", true);
        defineSymbol(math, ams, rel, "\u22eb", "\\ntriangleright");
        defineSymbol(math, ams, rel, "\u22ed", "\\ntrianglerighteq", true);
        defineSymbol(math, ams, rel, "\ue018", "\\@nsupseteqq");
        defineSymbol(math, ams, rel, "\u228b", "\\supsetneq", true);
        defineSymbol(math, ams, rel, "\ue01b", "\\@varsupsetneq");
        defineSymbol(math, ams, rel, "\u2acc", "\\supsetneqq", true);
        defineSymbol(math, ams, rel, "\ue019", "\\@varsupsetneqq");
        defineSymbol(math, ams, rel, "\u22ae", "\\nVdash", true);
        defineSymbol(math, ams, rel, "\u2ab5", "\\precneqq", true);
        defineSymbol(math, ams, rel, "\u2ab6", "\\succneqq", true);
        defineSymbol(math, ams, rel, "\ue016", "\\@nsubseteqq");
        defineSymbol(math, ams, bin, "\u22b4", "\\unlhd");
        defineSymbol(math, ams, bin, "\u22b5", "\\unrhd"); // AMS Negated Arrows
        defineSymbol(math, ams, rel, "\u219a", "\\nleftarrow", true);
        defineSymbol(math, ams, rel, "\u219b", "\\nrightarrow", true);
        defineSymbol(math, ams, rel, "\u21cd", "\\nLeftarrow", true);
        defineSymbol(math, ams, rel, "\u21cf", "\\nRightarrow", true);
        defineSymbol(math, ams, rel, "\u21ae", "\\nleftrightarrow", true);
        defineSymbol(math, ams, rel, "\u21ce", "\\nLeftrightarrow", true); // AMS Misc
        defineSymbol(math, ams, rel, "\u25b3", "\\vartriangle");
        defineSymbol(math, ams, textord, "\u210f", "\\hslash");
        defineSymbol(math, ams, textord, "\u25bd", "\\triangledown");
        defineSymbol(math, ams, textord, "\u25ca", "\\lozenge");
        defineSymbol(math, ams, textord, "\u24c8", "\\circledS");
        defineSymbol(math, ams, textord, "\u00ae", "\\circledR");
        defineSymbol(symbols_text, ams, textord, "\u00ae", "\\circledR");
        defineSymbol(math, ams, textord, "\u2221", "\\measuredangle", true);
        defineSymbol(math, ams, textord, "\u2204", "\\nexists");
        defineSymbol(math, ams, textord, "\u2127", "\\mho");
        defineSymbol(math, ams, textord, "\u2132", "\\Finv", true);
        defineSymbol(math, ams, textord, "\u2141", "\\Game", true);
        defineSymbol(math, ams, textord, "\u2035", "\\backprime");
        defineSymbol(math, ams, textord, "\u25b2", "\\blacktriangle");
        defineSymbol(math, ams, textord, "\u25bc", "\\blacktriangledown");
        defineSymbol(math, ams, textord, "\u25a0", "\\blacksquare");
        defineSymbol(math, ams, textord, "\u29eb", "\\blacklozenge");
        defineSymbol(math, ams, textord, "\u2605", "\\bigstar");
        defineSymbol(math, ams, textord, "\u2222", "\\sphericalangle", true);
        defineSymbol(math, ams, textord, "\u2201", "\\complement", true); // unicode-math maps U+F0 to \matheth. We map to AMS function \eth
        defineSymbol(math, ams, textord, "\u00f0", "\\eth", true);
        defineSymbol(symbols_text, main, textord, "\u00f0", "\u00f0");
        defineSymbol(math, ams, textord, "\u2571", "\\diagup");
        defineSymbol(math, ams, textord, "\u2572", "\\diagdown");
        defineSymbol(math, ams, textord, "\u25a1", "\\square");
        defineSymbol(math, ams, textord, "\u25a1", "\\Box");
        defineSymbol(math, ams, textord, "\u25ca", "\\Diamond"); // unicode-math maps U+A5 to \mathyen. We map to AMS function \yen
        defineSymbol(math, ams, textord, "\u00a5", "\\yen", true);
        defineSymbol(symbols_text, ams, textord, "\u00a5", "\\yen", true);
        defineSymbol(math, ams, textord, "\u2713", "\\checkmark", true);
        defineSymbol(symbols_text, ams, textord, "\u2713", "\\checkmark"); // AMS Hebrew
        defineSymbol(math, ams, textord, "\u2136", "\\beth", true);
        defineSymbol(math, ams, textord, "\u2138", "\\daleth", true);
        defineSymbol(math, ams, textord, "\u2137", "\\gimel", true); // AMS Greek
        defineSymbol(math, ams, textord, "\u03dd", "\\digamma", true);
        defineSymbol(math, ams, textord, "\u03f0", "\\varkappa"); // AMS Delimiters
        defineSymbol(math, ams, symbols_open, "\u250c", "\\@ulcorner", true);
        defineSymbol(math, ams, symbols_close, "\u2510", "\\@urcorner", true);
        defineSymbol(math, ams, symbols_open, "\u2514", "\\@llcorner", true);
        defineSymbol(math, ams, symbols_close, "\u2518", "\\@lrcorner", true); // AMS Binary Relations
        defineSymbol(math, ams, rel, "\u2266", "\\leqq", true);
        defineSymbol(math, ams, rel, "\u2a7d", "\\leqslant", true);
        defineSymbol(math, ams, rel, "\u2a95", "\\eqslantless", true);
        defineSymbol(math, ams, rel, "\u2272", "\\lesssim", true);
        defineSymbol(math, ams, rel, "\u2a85", "\\lessapprox", true);
        defineSymbol(math, ams, rel, "\u224a", "\\approxeq", true);
        defineSymbol(math, ams, bin, "\u22d6", "\\lessdot");
        defineSymbol(math, ams, rel, "\u22d8", "\\lll", true);
        defineSymbol(math, ams, rel, "\u2276", "\\lessgtr", true);
        defineSymbol(math, ams, rel, "\u22da", "\\lesseqgtr", true);
        defineSymbol(math, ams, rel, "\u2a8b", "\\lesseqqgtr", true);
        defineSymbol(math, ams, rel, "\u2251", "\\doteqdot");
        defineSymbol(math, ams, rel, "\u2253", "\\risingdotseq", true);
        defineSymbol(math, ams, rel, "\u2252", "\\fallingdotseq", true);
        defineSymbol(math, ams, rel, "\u223d", "\\backsim", true);
        defineSymbol(math, ams, rel, "\u22cd", "\\backsimeq", true);
        defineSymbol(math, ams, rel, "\u2ac5", "\\subseteqq", true);
        defineSymbol(math, ams, rel, "\u22d0", "\\Subset", true);
        defineSymbol(math, ams, rel, "\u228f", "\\sqsubset", true);
        defineSymbol(math, ams, rel, "\u227c", "\\preccurlyeq", true);
        defineSymbol(math, ams, rel, "\u22de", "\\curlyeqprec", true);
        defineSymbol(math, ams, rel, "\u227e", "\\precsim", true);
        defineSymbol(math, ams, rel, "\u2ab7", "\\precapprox", true);
        defineSymbol(math, ams, rel, "\u22b2", "\\vartriangleleft");
        defineSymbol(math, ams, rel, "\u22b4", "\\trianglelefteq");
        defineSymbol(math, ams, rel, "\u22a8", "\\vDash", true);
        defineSymbol(math, ams, rel, "\u22aa", "\\Vvdash", true);
        defineSymbol(math, ams, rel, "\u2323", "\\smallsmile");
        defineSymbol(math, ams, rel, "\u2322", "\\smallfrown");
        defineSymbol(math, ams, rel, "\u224f", "\\bumpeq", true);
        defineSymbol(math, ams, rel, "\u224e", "\\Bumpeq", true);
        defineSymbol(math, ams, rel, "\u2267", "\\geqq", true);
        defineSymbol(math, ams, rel, "\u2a7e", "\\geqslant", true);
        defineSymbol(math, ams, rel, "\u2a96", "\\eqslantgtr", true);
        defineSymbol(math, ams, rel, "\u2273", "\\gtrsim", true);
        defineSymbol(math, ams, rel, "\u2a86", "\\gtrapprox", true);
        defineSymbol(math, ams, bin, "\u22d7", "\\gtrdot");
        defineSymbol(math, ams, rel, "\u22d9", "\\ggg", true);
        defineSymbol(math, ams, rel, "\u2277", "\\gtrless", true);
        defineSymbol(math, ams, rel, "\u22db", "\\gtreqless", true);
        defineSymbol(math, ams, rel, "\u2a8c", "\\gtreqqless", true);
        defineSymbol(math, ams, rel, "\u2256", "\\eqcirc", true);
        defineSymbol(math, ams, rel, "\u2257", "\\circeq", true);
        defineSymbol(math, ams, rel, "\u225c", "\\triangleq", true);
        defineSymbol(math, ams, rel, "\u223c", "\\thicksim");
        defineSymbol(math, ams, rel, "\u2248", "\\thickapprox");
        defineSymbol(math, ams, rel, "\u2ac6", "\\supseteqq", true);
        defineSymbol(math, ams, rel, "\u22d1", "\\Supset", true);
        defineSymbol(math, ams, rel, "\u2290", "\\sqsupset", true);
        defineSymbol(math, ams, rel, "\u227d", "\\succcurlyeq", true);
        defineSymbol(math, ams, rel, "\u22df", "\\curlyeqsucc", true);
        defineSymbol(math, ams, rel, "\u227f", "\\succsim", true);
        defineSymbol(math, ams, rel, "\u2ab8", "\\succapprox", true);
        defineSymbol(math, ams, rel, "\u22b3", "\\vartriangleright");
        defineSymbol(math, ams, rel, "\u22b5", "\\trianglerighteq");
        defineSymbol(math, ams, rel, "\u22a9", "\\Vdash", true);
        defineSymbol(math, ams, rel, "\u2223", "\\shortmid");
        defineSymbol(math, ams, rel, "\u2225", "\\shortparallel");
        defineSymbol(math, ams, rel, "\u226c", "\\between", true);
        defineSymbol(math, ams, rel, "\u22d4", "\\pitchfork", true);
        defineSymbol(math, ams, rel, "\u221d", "\\varpropto");
        defineSymbol(math, ams, rel, "\u25c0", "\\blacktriangleleft"); // unicode-math says that \therefore is a mathord atom.
        // We kept the amssymb atom type, which is rel.
        defineSymbol(math, ams, rel, "\u2234", "\\therefore", true);
        defineSymbol(math, ams, rel, "\u220d", "\\backepsilon");
        defineSymbol(math, ams, rel, "\u25b6", "\\blacktriangleright"); // unicode-math says that \because is a mathord atom.
        // We kept the amssymb atom type, which is rel.
        defineSymbol(math, ams, rel, "\u2235", "\\because", true);
        defineSymbol(math, ams, rel, "\u22d8", "\\llless");
        defineSymbol(math, ams, rel, "\u22d9", "\\gggtr");
        defineSymbol(math, ams, bin, "\u22b2", "\\lhd");
        defineSymbol(math, ams, bin, "\u22b3", "\\rhd");
        defineSymbol(math, ams, rel, "\u2242", "\\eqsim", true);
        defineSymbol(math, main, rel, "\u22c8", "\\Join");
        defineSymbol(math, ams, rel, "\u2251", "\\Doteq", true); // AMS Binary Operators
        defineSymbol(math, ams, bin, "\u2214", "\\dotplus", true);
        defineSymbol(math, ams, bin, "\u2216", "\\smallsetminus");
        defineSymbol(math, ams, bin, "\u22d2", "\\Cap", true);
        defineSymbol(math, ams, bin, "\u22d3", "\\Cup", true);
        defineSymbol(math, ams, bin, "\u2a5e", "\\doublebarwedge", true);
        defineSymbol(math, ams, bin, "\u229f", "\\boxminus", true);
        defineSymbol(math, ams, bin, "\u229e", "\\boxplus", true);
        defineSymbol(math, ams, bin, "\u22c7", "\\divideontimes", true);
        defineSymbol(math, ams, bin, "\u22c9", "\\ltimes", true);
        defineSymbol(math, ams, bin, "\u22ca", "\\rtimes", true);
        defineSymbol(math, ams, bin, "\u22cb", "\\leftthreetimes", true);
        defineSymbol(math, ams, bin, "\u22cc", "\\rightthreetimes", true);
        defineSymbol(math, ams, bin, "\u22cf", "\\curlywedge", true);
        defineSymbol(math, ams, bin, "\u22ce", "\\curlyvee", true);
        defineSymbol(math, ams, bin, "\u229d", "\\circleddash", true);
        defineSymbol(math, ams, bin, "\u229b", "\\circledast", true);
        defineSymbol(math, ams, bin, "\u22c5", "\\centerdot");
        defineSymbol(math, ams, bin, "\u22ba", "\\intercal", true);
        defineSymbol(math, ams, bin, "\u22d2", "\\doublecap");
        defineSymbol(math, ams, bin, "\u22d3", "\\doublecup");
        defineSymbol(math, ams, bin, "\u22a0", "\\boxtimes", true); // AMS Arrows
        // Note: unicode-math maps \u21e2 to their own function \rightdasharrow.
        // We'll map it to AMS function \dashrightarrow. It produces the same atom.
        defineSymbol(math, ams, rel, "\u21e2", "\\dashrightarrow", true); // unicode-math maps \u21e0 to \leftdasharrow. We'll use the AMS synonym.
        defineSymbol(math, ams, rel, "\u21e0", "\\dashleftarrow", true);
        defineSymbol(math, ams, rel, "\u21c7", "\\leftleftarrows", true);
        defineSymbol(math, ams, rel, "\u21c6", "\\leftrightarrows", true);
        defineSymbol(math, ams, rel, "\u21da", "\\Lleftarrow", true);
        defineSymbol(math, ams, rel, "\u219e", "\\twoheadleftarrow", true);
        defineSymbol(math, ams, rel, "\u21a2", "\\leftarrowtail", true);
        defineSymbol(math, ams, rel, "\u21ab", "\\looparrowleft", true);
        defineSymbol(math, ams, rel, "\u21cb", "\\leftrightharpoons", true);
        defineSymbol(math, ams, rel, "\u21b6", "\\curvearrowleft", true); // unicode-math maps \u21ba to \acwopencirclearrow. We'll use the AMS synonym.
        defineSymbol(math, ams, rel, "\u21ba", "\\circlearrowleft", true);
        defineSymbol(math, ams, rel, "\u21b0", "\\Lsh", true);
        defineSymbol(math, ams, rel, "\u21c8", "\\upuparrows", true);
        defineSymbol(math, ams, rel, "\u21bf", "\\upharpoonleft", true);
        defineSymbol(math, ams, rel, "\u21c3", "\\downharpoonleft", true);
        defineSymbol(math, main, rel, "\u22b6", "\\origof", true); // not in font
        defineSymbol(math, main, rel, "\u22b7", "\\imageof", true); // not in font
        defineSymbol(math, ams, rel, "\u22b8", "\\multimap", true);
        defineSymbol(math, ams, rel, "\u21ad", "\\leftrightsquigarrow", true);
        defineSymbol(math, ams, rel, "\u21c9", "\\rightrightarrows", true);
        defineSymbol(math, ams, rel, "\u21c4", "\\rightleftarrows", true);
        defineSymbol(math, ams, rel, "\u21a0", "\\twoheadrightarrow", true);
        defineSymbol(math, ams, rel, "\u21a3", "\\rightarrowtail", true);
        defineSymbol(math, ams, rel, "\u21ac", "\\looparrowright", true);
        defineSymbol(math, ams, rel, "\u21b7", "\\curvearrowright", true); // unicode-math maps \u21bb to \cwopencirclearrow. We'll use the AMS synonym.
        defineSymbol(math, ams, rel, "\u21bb", "\\circlearrowright", true);
        defineSymbol(math, ams, rel, "\u21b1", "\\Rsh", true);
        defineSymbol(math, ams, rel, "\u21ca", "\\downdownarrows", true);
        defineSymbol(math, ams, rel, "\u21be", "\\upharpoonright", true);
        defineSymbol(math, ams, rel, "\u21c2", "\\downharpoonright", true);
        defineSymbol(math, ams, rel, "\u21dd", "\\rightsquigarrow", true);
        defineSymbol(math, ams, rel, "\u21dd", "\\leadsto");
        defineSymbol(math, ams, rel, "\u21db", "\\Rrightarrow", true);
        defineSymbol(math, ams, rel, "\u21be", "\\restriction");
        defineSymbol(math, main, textord, "\u2018", "`");
        defineSymbol(math, main, textord, "$", "\\$");
        defineSymbol(symbols_text, main, textord, "$", "\\$");
        defineSymbol(symbols_text, main, textord, "$", "\\textdollar");
        defineSymbol(math, main, textord, "%", "\\%");
        defineSymbol(symbols_text, main, textord, "%", "\\%");
        defineSymbol(math, main, textord, "_", "\\_");
        defineSymbol(symbols_text, main, textord, "_", "\\_");
        defineSymbol(symbols_text, main, textord, "_", "\\textunderscore");
        defineSymbol(math, main, textord, "\u2220", "\\angle", true);
        defineSymbol(math, main, textord, "\u221e", "\\infty", true);
        defineSymbol(math, main, textord, "\u2032", "\\prime");
        defineSymbol(math, main, textord, "\u25b3", "\\triangle");
        defineSymbol(math, main, textord, "\u0393", "\\Gamma", true);
        defineSymbol(math, main, textord, "\u0394", "\\Delta", true);
        defineSymbol(math, main, textord, "\u0398", "\\Theta", true);
        defineSymbol(math, main, textord, "\u039b", "\\Lambda", true);
        defineSymbol(math, main, textord, "\u039e", "\\Xi", true);
        defineSymbol(math, main, textord, "\u03a0", "\\Pi", true);
        defineSymbol(math, main, textord, "\u03a3", "\\Sigma", true);
        defineSymbol(math, main, textord, "\u03a5", "\\Upsilon", true);
        defineSymbol(math, main, textord, "\u03a6", "\\Phi", true);
        defineSymbol(math, main, textord, "\u03a8", "\\Psi", true);
        defineSymbol(math, main, textord, "\u03a9", "\\Omega", true);
        defineSymbol(math, main, textord, "A", "\u0391");
        defineSymbol(math, main, textord, "B", "\u0392");
        defineSymbol(math, main, textord, "E", "\u0395");
        defineSymbol(math, main, textord, "Z", "\u0396");
        defineSymbol(math, main, textord, "H", "\u0397");
        defineSymbol(math, main, textord, "I", "\u0399");
        defineSymbol(math, main, textord, "K", "\u039A");
        defineSymbol(math, main, textord, "M", "\u039C");
        defineSymbol(math, main, textord, "N", "\u039D");
        defineSymbol(math, main, textord, "O", "\u039F");
        defineSymbol(math, main, textord, "P", "\u03A1");
        defineSymbol(math, main, textord, "T", "\u03A4");
        defineSymbol(math, main, textord, "X", "\u03A7");
        defineSymbol(math, main, textord, "\u00ac", "\\neg", true);
        defineSymbol(math, main, textord, "\u00ac", "\\lnot");
        defineSymbol(math, main, textord, "\u22a4", "\\top");
        defineSymbol(math, main, textord, "\u22a5", "\\bot");
        defineSymbol(math, main, textord, "\u2205", "\\emptyset");
        defineSymbol(math, ams, textord, "\u2205", "\\varnothing");
        defineSymbol(math, main, mathord, "\u03b1", "\\alpha", true);
        defineSymbol(math, main, mathord, "\u03b2", "\\beta", true);
        defineSymbol(math, main, mathord, "\u03b3", "\\gamma", true);
        defineSymbol(math, main, mathord, "\u03b4", "\\delta", true);
        defineSymbol(math, main, mathord, "\u03f5", "\\epsilon", true);
        defineSymbol(math, main, mathord, "\u03b6", "\\zeta", true);
        defineSymbol(math, main, mathord, "\u03b7", "\\eta", true);
        defineSymbol(math, main, mathord, "\u03b8", "\\theta", true);
        defineSymbol(math, main, mathord, "\u03b9", "\\iota", true);
        defineSymbol(math, main, mathord, "\u03ba", "\\kappa", true);
        defineSymbol(math, main, mathord, "\u03bb", "\\lambda", true);
        defineSymbol(math, main, mathord, "\u03bc", "\\mu", true);
        defineSymbol(math, main, mathord, "\u03bd", "\\nu", true);
        defineSymbol(math, main, mathord, "\u03be", "\\xi", true);
        defineSymbol(math, main, mathord, "\u03bf", "\\omicron", true);
        defineSymbol(math, main, mathord, "\u03c0", "\\pi", true);
        defineSymbol(math, main, mathord, "\u03c1", "\\rho", true);
        defineSymbol(math, main, mathord, "\u03c3", "\\sigma", true);
        defineSymbol(math, main, mathord, "\u03c4", "\\tau", true);
        defineSymbol(math, main, mathord, "\u03c5", "\\upsilon", true);
        defineSymbol(math, main, mathord, "\u03d5", "\\phi", true);
        defineSymbol(math, main, mathord, "\u03c7", "\\chi", true);
        defineSymbol(math, main, mathord, "\u03c8", "\\psi", true);
        defineSymbol(math, main, mathord, "\u03c9", "\\omega", true);
        defineSymbol(math, main, mathord, "\u03b5", "\\varepsilon", true);
        defineSymbol(math, main, mathord, "\u03d1", "\\vartheta", true);
        defineSymbol(math, main, mathord, "\u03d6", "\\varpi", true);
        defineSymbol(math, main, mathord, "\u03f1", "\\varrho", true);
        defineSymbol(math, main, mathord, "\u03c2", "\\varsigma", true);
        defineSymbol(math, main, mathord, "\u03c6", "\\varphi", true);
        defineSymbol(math, main, bin, "\u2217", "*", true);
        defineSymbol(math, main, bin, "+", "+");
        defineSymbol(math, main, bin, "\u2212", "-", true);
        defineSymbol(math, main, bin, "\u22c5", "\\cdot", true);
        defineSymbol(math, main, bin, "\u2218", "\\circ", true);
        defineSymbol(math, main, bin, "\u00f7", "\\div", true);
        defineSymbol(math, main, bin, "\u00b1", "\\pm", true);
        defineSymbol(math, main, bin, "\u00d7", "\\times", true);
        defineSymbol(math, main, bin, "\u2229", "\\cap", true);
        defineSymbol(math, main, bin, "\u222a", "\\cup", true);
        defineSymbol(math, main, bin, "\u2216", "\\setminus", true);
        defineSymbol(math, main, bin, "\u2227", "\\land");
        defineSymbol(math, main, bin, "\u2228", "\\lor");
        defineSymbol(math, main, bin, "\u2227", "\\wedge", true);
        defineSymbol(math, main, bin, "\u2228", "\\vee", true);
        defineSymbol(math, main, textord, "\u221a", "\\surd");
        defineSymbol(math, main, symbols_open, "\u27e8", "\\langle", true);
        defineSymbol(math, main, symbols_open, "\u2223", "\\lvert");
        defineSymbol(math, main, symbols_open, "\u2225", "\\lVert");
        defineSymbol(math, main, symbols_close, "?", "?");
        defineSymbol(math, main, symbols_close, "!", "!");
        defineSymbol(math, main, symbols_close, "\u27e9", "\\rangle", true);
        defineSymbol(math, main, symbols_close, "\u2223", "\\rvert");
        defineSymbol(math, main, symbols_close, "\u2225", "\\rVert");
        defineSymbol(math, main, rel, "=", "=");
        defineSymbol(math, main, rel, ":", ":");
        defineSymbol(math, main, rel, "\u2248", "\\approx", true);
        defineSymbol(math, main, rel, "\u2245", "\\cong", true);
        defineSymbol(math, main, rel, "\u2265", "\\ge");
        defineSymbol(math, main, rel, "\u2265", "\\geq", true);
        defineSymbol(math, main, rel, "\u2190", "\\gets");
        defineSymbol(math, main, rel, ">", "\\gt", true);
        defineSymbol(math, main, rel, "\u2208", "\\in", true);
        defineSymbol(math, main, rel, "\ue020", "\\@not");
        defineSymbol(math, main, rel, "\u2282", "\\subset", true);
        defineSymbol(math, main, rel, "\u2283", "\\supset", true);
        defineSymbol(math, main, rel, "\u2286", "\\subseteq", true);
        defineSymbol(math, main, rel, "\u2287", "\\supseteq", true);
        defineSymbol(math, ams, rel, "\u2288", "\\nsubseteq", true);
        defineSymbol(math, ams, rel, "\u2289", "\\nsupseteq", true);
        defineSymbol(math, main, rel, "\u22a8", "\\models");
        defineSymbol(math, main, rel, "\u2190", "\\leftarrow", true);
        defineSymbol(math, main, rel, "\u2264", "\\le");
        defineSymbol(math, main, rel, "\u2264", "\\leq", true);
        defineSymbol(math, main, rel, "<", "\\lt", true);
        defineSymbol(math, main, rel, "\u2192", "\\rightarrow", true);
        defineSymbol(math, main, rel, "\u2192", "\\to");
        defineSymbol(math, ams, rel, "\u2271", "\\ngeq", true);
        defineSymbol(math, ams, rel, "\u2270", "\\nleq", true);
        defineSymbol(math, main, spacing, "\u00a0", "\\ ");
        defineSymbol(math, main, spacing, "\u00a0", "\\space"); // Ref: LaTeX Source 2e: \DeclareRobustCommand{\nobreakspace}{%
        defineSymbol(math, main, spacing, "\u00a0", "\\nobreakspace");
        defineSymbol(symbols_text, main, spacing, "\u00a0", "\\ ");
        defineSymbol(symbols_text, main, spacing, "\u00a0", " ");
        defineSymbol(symbols_text, main, spacing, "\u00a0", "\\space");
        defineSymbol(symbols_text, main, spacing, "\u00a0", "\\nobreakspace");
        defineSymbol(math, main, spacing, null, "\\nobreak");
        defineSymbol(math, main, spacing, null, "\\allowbreak");
        defineSymbol(math, main, punct, ",", ",");
        defineSymbol(math, main, punct, ";", ";");
        defineSymbol(math, ams, bin, "\u22bc", "\\barwedge", true);
        defineSymbol(math, ams, bin, "\u22bb", "\\veebar", true);
        defineSymbol(math, main, bin, "\u2299", "\\odot", true);
        defineSymbol(math, main, bin, "\u2295", "\\oplus", true);
        defineSymbol(math, main, bin, "\u2297", "\\otimes", true);
        defineSymbol(math, main, textord, "\u2202", "\\partial", true);
        defineSymbol(math, main, bin, "\u2298", "\\oslash", true);
        defineSymbol(math, ams, bin, "\u229a", "\\circledcirc", true);
        defineSymbol(math, ams, bin, "\u22a1", "\\boxdot", true);
        defineSymbol(math, main, bin, "\u25b3", "\\bigtriangleup");
        defineSymbol(math, main, bin, "\u25bd", "\\bigtriangledown");
        defineSymbol(math, main, bin, "\u2020", "\\dagger");
        defineSymbol(math, main, bin, "\u22c4", "\\diamond");
        defineSymbol(math, main, bin, "\u22c6", "\\star");
        defineSymbol(math, main, bin, "\u25c3", "\\triangleleft");
        defineSymbol(math, main, bin, "\u25b9", "\\triangleright");
        defineSymbol(math, main, symbols_open, "{", "\\{");
        defineSymbol(symbols_text, main, textord, "{", "\\{");
        defineSymbol(symbols_text, main, textord, "{", "\\textbraceleft");
        defineSymbol(math, main, symbols_close, "}", "\\}");
        defineSymbol(symbols_text, main, textord, "}", "\\}");
        defineSymbol(symbols_text, main, textord, "}", "\\textbraceright");
        defineSymbol(math, main, symbols_open, "{", "\\lbrace");
        defineSymbol(math, main, symbols_close, "}", "\\rbrace");
        defineSymbol(math, main, symbols_open, "[", "\\lbrack", true);
        defineSymbol(symbols_text, main, textord, "[", "\\lbrack", true);
        defineSymbol(math, main, symbols_close, "]", "\\rbrack", true);
        defineSymbol(symbols_text, main, textord, "]", "\\rbrack", true);
        defineSymbol(math, main, symbols_open, "(", "\\lparen", true);
        defineSymbol(math, main, symbols_close, ")", "\\rparen", true);
        defineSymbol(symbols_text, main, textord, "<", "\\textless", true); // in T1 fontenc
        defineSymbol(symbols_text, main, textord, ">", "\\textgreater", true); // in T1 fontenc
        defineSymbol(math, main, symbols_open, "\u230a", "\\lfloor", true);
        defineSymbol(math, main, symbols_close, "\u230b", "\\rfloor", true);
        defineSymbol(math, main, symbols_open, "\u2308", "\\lceil", true);
        defineSymbol(math, main, symbols_close, "\u2309", "\\rceil", true);
        defineSymbol(math, main, textord, "\\", "\\backslash");
        defineSymbol(math, main, textord, "\u2223", "|");
        defineSymbol(math, main, textord, "\u2223", "\\vert");
        defineSymbol(symbols_text, main, textord, "|", "\\textbar", true); // in T1 fontenc
        defineSymbol(math, main, textord, "\u2225", "\\|");
        defineSymbol(math, main, textord, "\u2225", "\\Vert");
        defineSymbol(symbols_text, main, textord, "\u2225", "\\textbardbl");
        defineSymbol(symbols_text, main, textord, "~", "\\textasciitilde");
        defineSymbol(symbols_text, main, textord, "\\", "\\textbackslash");
        defineSymbol(symbols_text, main, textord, "^", "\\textasciicircum");
        defineSymbol(math, main, rel, "\u2191", "\\uparrow", true);
        defineSymbol(math, main, rel, "\u21d1", "\\Uparrow", true);
        defineSymbol(math, main, rel, "\u2193", "\\downarrow", true);
        defineSymbol(math, main, rel, "\u21d3", "\\Downarrow", true);
        defineSymbol(math, main, rel, "\u2195", "\\updownarrow", true);
        defineSymbol(math, main, rel, "\u21d5", "\\Updownarrow", true);
        defineSymbol(math, main, op, "\u2210", "\\coprod");
        defineSymbol(math, main, op, "\u22c1", "\\bigvee");
        defineSymbol(math, main, op, "\u22c0", "\\bigwedge");
        defineSymbol(math, main, op, "\u2a04", "\\biguplus");
        defineSymbol(math, main, op, "\u22c2", "\\bigcap");
        defineSymbol(math, main, op, "\u22c3", "\\bigcup");
        defineSymbol(math, main, op, "\u222b", "\\int");
        defineSymbol(math, main, op, "\u222b", "\\intop");
        defineSymbol(math, main, op, "\u222c", "\\iint");
        defineSymbol(math, main, op, "\u222d", "\\iiint");
        defineSymbol(math, main, op, "\u220f", "\\prod");
        defineSymbol(math, main, op, "\u2211", "\\sum");
        defineSymbol(math, main, op, "\u2a02", "\\bigotimes");
        defineSymbol(math, main, op, "\u2a01", "\\bigoplus");
        defineSymbol(math, main, op, "\u2a00", "\\bigodot");
        defineSymbol(math, main, op, "\u222e", "\\oint");
        defineSymbol(math, main, op, "\u222f", "\\oiint");
        defineSymbol(math, main, op, "\u2230", "\\oiiint");
        defineSymbol(math, main, op, "\u2a06", "\\bigsqcup");
        defineSymbol(math, main, op, "\u222b", "\\smallint");
        defineSymbol(symbols_text, main, inner, "\u2026", "\\textellipsis");
        defineSymbol(math, main, inner, "\u2026", "\\mathellipsis");
        defineSymbol(symbols_text, main, inner, "\u2026", "\\ldots", true);
        defineSymbol(math, main, inner, "\u2026", "\\ldots", true);
        defineSymbol(math, main, inner, "\u22ef", "\\@cdots", true);
        defineSymbol(math, main, inner, "\u22f1", "\\ddots", true); // \vdots is a macro that uses one of these two symbols (with made-up names):
        defineSymbol(math, main, textord, "\u22ee", "\\varvdots");
        defineSymbol(symbols_text, main, textord, "\u22ee", "\\varvdots");
        defineSymbol(math, main, accent, "\u02ca", "\\acute");
        defineSymbol(math, main, accent, "\u02cb", "\\grave");
        defineSymbol(math, main, accent, "\u00a8", "\\ddot");
        defineSymbol(math, main, accent, "\u007e", "\\tilde");
        defineSymbol(math, main, accent, "\u02c9", "\\bar");
        defineSymbol(math, main, accent, "\u02d8", "\\breve");
        defineSymbol(math, main, accent, "\u02c7", "\\check");
        defineSymbol(math, main, accent, "\u005e", "\\hat");
        defineSymbol(math, main, accent, "\u20d7", "\\vec");
        defineSymbol(math, main, accent, "\u02d9", "\\dot");
        defineSymbol(math, main, accent, "\u02da", "\\mathring"); // \imath and \jmath should be invariant to \mathrm, \mathbf, etc., so use PUA
        defineSymbol(math, main, mathord, "\ue131", "\\@imath");
        defineSymbol(math, main, mathord, "\ue237", "\\@jmath");
        defineSymbol(math, main, textord, "\u0131", "\u0131");
        defineSymbol(math, main, textord, "\u0237", "\u0237");
        defineSymbol(symbols_text, main, textord, "\u0131", "\\i", true);
        defineSymbol(symbols_text, main, textord, "\u0237", "\\j", true);
        defineSymbol(symbols_text, main, textord, "\u00df", "\\ss", true);
        defineSymbol(symbols_text, main, textord, "\u00e6", "\\ae", true);
        defineSymbol(symbols_text, main, textord, "\u0153", "\\oe", true);
        defineSymbol(symbols_text, main, textord, "\u00f8", "\\o", true);
        defineSymbol(symbols_text, main, textord, "\u00c6", "\\AE", true);
        defineSymbol(symbols_text, main, textord, "\u0152", "\\OE", true);
        defineSymbol(symbols_text, main, textord, "\u00d8", "\\O", true);
        defineSymbol(symbols_text, main, accent, "\u02ca", "\\'"); // acute
        defineSymbol(symbols_text, main, accent, "\u02cb", "\\`"); // grave
        defineSymbol(symbols_text, main, accent, "\u02c6", "\\^"); // circumflex
        defineSymbol(symbols_text, main, accent, "\u02dc", "\\~"); // tilde
        defineSymbol(symbols_text, main, accent, "\u02c9", "\\="); // macron
        defineSymbol(symbols_text, main, accent, "\u02d8", "\\u"); // breve
        defineSymbol(symbols_text, main, accent, "\u02d9", "\\."); // dot above
        defineSymbol(symbols_text, main, accent, "\u00b8", "\\c"); // cedilla
        defineSymbol(symbols_text, main, accent, "\u02da", "\\r"); // ring above
        defineSymbol(symbols_text, main, accent, "\u02c7", "\\v"); // caron
        defineSymbol(symbols_text, main, accent, "\u00a8", '\\"'); // diaeresis
        defineSymbol(symbols_text, main, accent, "\u02dd", "\\H"); // double acute
        defineSymbol(symbols_text, main, accent, "\u25ef", "\\textcircled"); // \bigcirc glyph
        // These ligatures are detected and created in Parser.js's `formLigatures`.
        const ligatures = {
            "--": true,
            "---": true,
            "``": true,
            "''": true
        };
        defineSymbol(symbols_text, main, textord, "\u2013", "--", true);
        defineSymbol(symbols_text, main, textord, "\u2013", "\\textendash");
        defineSymbol(symbols_text, main, textord, "\u2014", "---", true);
        defineSymbol(symbols_text, main, textord, "\u2014", "\\textemdash");
        defineSymbol(symbols_text, main, textord, "\u2018", "`", true);
        defineSymbol(symbols_text, main, textord, "\u2018", "\\textquoteleft");
        defineSymbol(symbols_text, main, textord, "\u2019", "'", true);
        defineSymbol(symbols_text, main, textord, "\u2019", "\\textquoteright");
        defineSymbol(symbols_text, main, textord, "\u201c", "``", true);
        defineSymbol(symbols_text, main, textord, "\u201c", "\\textquotedblleft");
        defineSymbol(symbols_text, main, textord, "\u201d", "''", true);
        defineSymbol(symbols_text, main, textord, "\u201d", "\\textquotedblright"); //  \degree from gensymb package
        defineSymbol(math, main, textord, "\u00b0", "\\degree", true);
        defineSymbol(symbols_text, main, textord, "\u00b0", "\\degree"); // \textdegree from inputenc package
        defineSymbol(symbols_text, main, textord, "\u00b0", "\\textdegree", true); // TODO: In LaTeX, \pounds can generate a different character in text and math
        // mode, but among our fonts, only Main-Regular defines this character "163".
        defineSymbol(math, main, textord, "\u00a3", "\\pounds");
        defineSymbol(math, main, textord, "\u00a3", "\\mathsterling", true);
        defineSymbol(symbols_text, main, textord, "\u00a3", "\\pounds");
        defineSymbol(symbols_text, main, textord, "\u00a3", "\\textsterling", true);
        defineSymbol(math, ams, textord, "\u2720", "\\maltese");
        defineSymbol(symbols_text, ams, textord, "\u2720", "\\maltese"); // There are lots of symbols which are the same, so we add them in afterwards.
        // All of these are textords in math mode
        const mathTextSymbols = "0123456789/@.\"";
        for(let i = 0; i < mathTextSymbols.length; i++){
            const ch = mathTextSymbols.charAt(i);
            defineSymbol(math, main, textord, ch, ch);
        } // All of these are textords in text mode
        const textSymbols = "0123456789!@*()-=+\";:?/.,";
        for(let i = 0; i < textSymbols.length; i++){
            const ch = textSymbols.charAt(i);
            defineSymbol(symbols_text, main, textord, ch, ch);
        } // All of these are textords in text mode, and mathords in math mode
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        for(let i = 0; i < letters.length; i++){
            const ch = letters.charAt(i);
            defineSymbol(math, main, mathord, ch, ch);
            defineSymbol(symbols_text, main, textord, ch, ch);
        } // Blackboard bold and script letters in Unicode range
        defineSymbol(math, ams, textord, "C", "\u2102"); // blackboard bold
        defineSymbol(symbols_text, ams, textord, "C", "\u2102");
        defineSymbol(math, ams, textord, "H", "\u210D");
        defineSymbol(symbols_text, ams, textord, "H", "\u210D");
        defineSymbol(math, ams, textord, "N", "\u2115");
        defineSymbol(symbols_text, ams, textord, "N", "\u2115");
        defineSymbol(math, ams, textord, "P", "\u2119");
        defineSymbol(symbols_text, ams, textord, "P", "\u2119");
        defineSymbol(math, ams, textord, "Q", "\u211A");
        defineSymbol(symbols_text, ams, textord, "Q", "\u211A");
        defineSymbol(math, ams, textord, "R", "\u211D");
        defineSymbol(symbols_text, ams, textord, "R", "\u211D");
        defineSymbol(math, ams, textord, "Z", "\u2124");
        defineSymbol(symbols_text, ams, textord, "Z", "\u2124");
        defineSymbol(math, main, mathord, "h", "\u210E"); // italic h, Planck constant
        defineSymbol(symbols_text, main, mathord, "h", "\u210E"); // The next loop loads wide (surrogate pair) characters.
        // We support some letters in the Unicode range U+1D400 to U+1D7FF,
        // Mathematical Alphanumeric Symbols.
        // Some editors do not deal well with wide characters. So don't write the
        // string into this file. Instead, create the string from the surrogate pair.
        let wideChar = "";
        for(let i = 0; i < letters.length; i++){
            const ch = letters.charAt(i); // The hex numbers in the next line are a surrogate pair.
            // 0xD835 is the high surrogate for all letters in the range we support.
            // 0xDC00 is the low surrogate for bold A.
            wideChar = String.fromCharCode(0xD835, 0xDC00 + i); // A-Z a-z bold
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDC34 + i); // A-Z a-z italic
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDC68 + i); // A-Z a-z bold italic
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDD04 + i); // A-Z a-z Fraktur
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDD6C + i); // A-Z a-z bold Fraktur
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDDA0 + i); // A-Z a-z sans-serif
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDDD4 + i); // A-Z a-z sans bold
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDE08 + i); // A-Z a-z sans italic
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDE70 + i); // A-Z a-z monospace
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            if (i < 26) {
                // KaTeX fonts have only capital letters for blackboard bold and script.
                // See exception for k below.
                wideChar = String.fromCharCode(0xD835, 0xDD38 + i); // A-Z double struck
                defineSymbol(math, main, mathord, ch, wideChar);
                defineSymbol(symbols_text, main, textord, ch, wideChar);
                wideChar = String.fromCharCode(0xD835, 0xDC9C + i); // A-Z script
                defineSymbol(math, main, mathord, ch, wideChar);
                defineSymbol(symbols_text, main, textord, ch, wideChar);
            } // TODO: Add bold script when it is supported by a KaTeX font.
        } // "k" is the only double struck lower case letter in the KaTeX fonts.
        wideChar = String.fromCharCode(0xD835, 0xDD5C); // k double struck
        defineSymbol(math, main, mathord, "k", wideChar);
        defineSymbol(symbols_text, main, textord, "k", wideChar); // Next, some wide character numerals
        for(let i = 0; i < 10; i++){
            const ch = i.toString();
            wideChar = String.fromCharCode(0xD835, 0xDFCE + i); // 0-9 bold
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDFE2 + i); // 0-9 sans serif
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDFEC + i); // 0-9 bold sans
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
            wideChar = String.fromCharCode(0xD835, 0xDFF6 + i); // 0-9 monospace
            defineSymbol(math, main, mathord, ch, wideChar);
            defineSymbol(symbols_text, main, textord, ch, wideChar);
        } // We add these Latin-1 letters as symbols for backwards-compatibility,
        // but they are not actually in the font, nor are they supported by the
        // Unicode accent mechanism, so they fall back to Times font and look ugly.
        // TODO(edemaine): Fix this.
        const extraLatin = "\u00d0\u00de\u00fe";
        for(let i = 0; i < extraLatin.length; i++){
            const ch = extraLatin.charAt(i);
            defineSymbol(math, main, mathord, ch, ch);
            defineSymbol(symbols_text, main, textord, ch, ch);
        }
        /**
 * This file provides support for Unicode range U+1D400 to U+1D7FF,
 * Mathematical Alphanumeric Symbols.
 *
 * Function wideCharacterFont takes a wide character as input and returns
 * the font information necessary to render it properly.
 */ /**
 * Data below is from https://www.unicode.org/charts/PDF/U1D400.pdf
 * That document sorts characters into groups by font type, say bold or italic.
 *
 * In the arrays below, each subarray consists three elements:
 *      * The CSS class of that group when in math mode.
 *      * The CSS class of that group when in text mode.
 *      * The font name, so that KaTeX can get font metrics.
 */ const wideLatinLetterData = [
            [
                "mathbf",
                "textbf",
                "Main-Bold"
            ],
            [
                "mathbf",
                "textbf",
                "Main-Bold"
            ],
            [
                "mathnormal",
                "textit",
                "Math-Italic"
            ],
            [
                "mathnormal",
                "textit",
                "Math-Italic"
            ],
            [
                "boldsymbol",
                "boldsymbol",
                "Main-BoldItalic"
            ],
            [
                "boldsymbol",
                "boldsymbol",
                "Main-BoldItalic"
            ],
            // Map fancy A-Z letters to script, not calligraphic.
            // This aligns with unicode-math and math fonts (except Cambria Math).
            [
                "mathscr",
                "textscr",
                "Script-Regular"
            ],
            [
                "",
                "",
                ""
            ],
            [
                "",
                "",
                ""
            ],
            [
                "",
                "",
                ""
            ],
            [
                "mathfrak",
                "textfrak",
                "Fraktur-Regular"
            ],
            [
                "mathfrak",
                "textfrak",
                "Fraktur-Regular"
            ],
            [
                "mathbb",
                "textbb",
                "AMS-Regular"
            ],
            [
                "mathbb",
                "textbb",
                "AMS-Regular"
            ],
            // Note that we are using a bold font, but font metrics for regular Fraktur.
            [
                "mathboldfrak",
                "textboldfrak",
                "Fraktur-Regular"
            ],
            [
                "mathboldfrak",
                "textboldfrak",
                "Fraktur-Regular"
            ],
            [
                "mathsf",
                "textsf",
                "SansSerif-Regular"
            ],
            [
                "mathsf",
                "textsf",
                "SansSerif-Regular"
            ],
            [
                "mathboldsf",
                "textboldsf",
                "SansSerif-Bold"
            ],
            [
                "mathboldsf",
                "textboldsf",
                "SansSerif-Bold"
            ],
            [
                "mathitsf",
                "textitsf",
                "SansSerif-Italic"
            ],
            [
                "mathitsf",
                "textitsf",
                "SansSerif-Italic"
            ],
            [
                "",
                "",
                ""
            ],
            [
                "",
                "",
                ""
            ],
            [
                "mathtt",
                "texttt",
                "Typewriter-Regular"
            ],
            [
                "mathtt",
                "texttt",
                "Typewriter-Regular"
            ] // a-z monospace
        ];
        const wideNumeralData = [
            [
                "mathbf",
                "textbf",
                "Main-Bold"
            ],
            [
                "",
                "",
                ""
            ],
            [
                "mathsf",
                "textsf",
                "SansSerif-Regular"
            ],
            [
                "mathboldsf",
                "textboldsf",
                "SansSerif-Bold"
            ],
            [
                "mathtt",
                "texttt",
                "Typewriter-Regular"
            ] // 0-9 monospace
        ];
        const wideCharacterFont = function(wideChar, mode) {
            // IE doesn't support codePointAt(). So work with the surrogate pair.
            const H = wideChar.charCodeAt(0); // high surrogate
            const L = wideChar.charCodeAt(1); // low surrogate
            const codePoint = (H - 0xD800) * 0x400 + (L - 0xDC00) + 0x10000;
            const j = mode === "math" ? 0 : 1; // column index for CSS class.
            if (0x1D400 <= codePoint && codePoint < 0x1D6A4) {
                // wideLatinLetterData contains exactly 26 chars on each row.
                // So we can calculate the relevant row. No traverse necessary.
                const i = Math.floor((codePoint - 0x1D400) / 26);
                return [
                    wideLatinLetterData[i][2],
                    wideLatinLetterData[i][j]
                ];
            } else if (0x1D7CE <= codePoint && codePoint <= 0x1D7FF) {
                // Numerals, ten per row.
                const i = Math.floor((codePoint - 0x1D7CE) / 10);
                return [
                    wideNumeralData[i][2],
                    wideNumeralData[i][j]
                ];
            } else if (codePoint === 0x1D6A5 || codePoint === 0x1D6A6) // dotless i or j
            return [
                wideLatinLetterData[0][2],
                wideLatinLetterData[0][j]
            ];
            else if (0x1D6A6 < codePoint && codePoint < 0x1D7CE) // Greek letters. Not supported, yet.
            return [
                "",
                ""
            ];
            else // We don't support any wide characters outside 1D400–1D7FF.
            throw new src_ParseError("Unsupported character: " + wideChar);
        };
        // To ensure that all nodes have compatible signatures for these methods.
        /**
 * This node represents a document fragment, which contains elements, but when
 * placed into the DOM doesn't have any representation itself. It only contains
 * children and doesn't have any DOM node properties.
 */ class DocumentFragment {
            // Never used; needed for satisfying interface.
            constructor(children){
                this.children = void 0;
                this.classes = void 0;
                this.height = void 0;
                this.depth = void 0;
                this.maxFontSize = void 0;
                this.style = void 0;
                this.children = children;
                this.classes = [];
                this.height = 0;
                this.depth = 0;
                this.maxFontSize = 0;
                this.style = {};
            }
            hasClass(className) {
                return this.classes.includes(className);
            }
            /** Convert the fragment into a node. */ toNode() {
                const frag = document.createDocumentFragment();
                for(let i = 0; i < this.children.length; i++)frag.appendChild(this.children[i].toNode());
                return frag;
            }
            /** Convert the fragment into HTML markup. */ toMarkup() {
                let markup = ""; // Simply concatenate the markup for the children together.
                for(let i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
                return markup;
            }
            /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */ toText() {
                // To avoid this, we would subclass documentFragment separately for
                // MathML, but polyfills for subclassing is expensive per PR 1469.
                // $FlowFixMe: Only works for ChildType = MathDomNode.
                const toText = (child)=>child.toText();
                return this.children.map(toText).join("");
            }
        }
        /* eslint no-console:0 */ /**
 * This module contains general functions that can be used for building
 * different kinds of domTree nodes in a consistent manner.
 */ /**
 * Looks up the given symbol in fontMetrics, after applying any symbol
 * replacements defined in symbol.js
 */ const lookupSymbol = function(value, fontName, mode) {
            // Replace the value with its replaced value from symbol.js
            if (src_symbols[mode][value] && src_symbols[mode][value].replace) value = src_symbols[mode][value].replace;
            return {
                value: value,
                metrics: getCharacterMetrics(value, fontName, mode)
            };
        };
        /**
 * Makes a symbolNode after translation via the list of symbols in symbols.js.
 * Correctly pulls out metrics for the character, and optionally takes a list of
 * classes to be attached to the node.
 *
 * TODO: make argument order closer to makeSpan
 * TODO: add a separate argument for math class (e.g. `mop`, `mbin`), which
 * should if present come first in `classes`.
 * TODO(#953): Make `options` mandatory and always pass it in.
 */ const makeSymbol = function(value, fontName, mode, options, classes) {
            const lookup = lookupSymbol(value, fontName, mode);
            const metrics = lookup.metrics;
            value = lookup.value;
            let symbolNode;
            if (metrics) {
                let italic = metrics.italic;
                if (mode === "text" || options && options.font === "mathit") italic = 0;
                symbolNode = new SymbolNode(value, metrics.height, metrics.depth, italic, metrics.skew, metrics.width, classes);
            } else {
                // TODO(emily): Figure out a good way to only print this in development
                typeof console !== "undefined" && console.warn("No character metrics " + ("for '" + value + "' in style '" + fontName + "' and mode '" + mode + "'"));
                symbolNode = new SymbolNode(value, 0, 0, 0, 0, 0, classes);
            }
            if (options) {
                symbolNode.maxFontSize = options.sizeMultiplier;
                if (options.style.isTight()) symbolNode.classes.push("mtight");
                const color = options.getColor();
                if (color) symbolNode.style.color = color;
            }
            return symbolNode;
        };
        /**
 * Makes a symbol in Main-Regular or AMS-Regular.
 * Used for rel, bin, open, close, inner, and punct.
 */ const mathsym = function(value, mode, options, classes) {
            if (classes === void 0) classes = [];
            // Decide what font to render the symbol in by its entry in the symbols
            // table.
            // Have a special case for when the value = \ because the \ is used as a
            // textord in unsupported command errors but cannot be parsed as a regular
            // text ordinal and is therefore not present as a symbol in the symbols
            // table for text, as well as a special case for boldsymbol because it
            // can be used for bold + and -
            if (options.font === "boldsymbol" && lookupSymbol(value, "Main-Bold", mode).metrics) return makeSymbol(value, "Main-Bold", mode, options, classes.concat([
                "mathbf"
            ]));
            else if (value === "\\" || src_symbols[mode][value].font === "main") return makeSymbol(value, "Main-Regular", mode, options, classes);
            else return makeSymbol(value, "AMS-Regular", mode, options, classes.concat([
                "amsrm"
            ]));
        };
        /**
 * Determines which of the two font names (Main-Bold and Math-BoldItalic) and
 * corresponding style tags (mathbf or boldsymbol) to use for font "boldsymbol",
 * depending on the symbol.  Use this function instead of fontMap for font
 * "boldsymbol".
 */ const boldsymbol = function(value, mode, options, classes, type) {
            if (type !== "textord" && lookupSymbol(value, "Math-BoldItalic", mode).metrics) return {
                fontName: "Math-BoldItalic",
                fontClass: "boldsymbol"
            };
            else // Some glyphs do not exist in Math-BoldItalic so we need to use
            // Main-Bold instead.
            return {
                fontName: "Main-Bold",
                fontClass: "mathbf"
            };
        };
        /**
 * Makes either a mathord or textord in the correct font and color.
 */ const makeOrd = function(group, options, type) {
            const mode = group.mode;
            const text = group.text;
            const classes = [
                "mord"
            ]; // Math mode or Old font (i.e. \rm)
            const isFont = mode === "math" || mode === "text" && options.font;
            const fontOrFamily = isFont ? options.font : options.fontFamily;
            let wideFontName = "";
            let wideFontClass = "";
            if (text.charCodeAt(0) === 0xD835) [wideFontName, wideFontClass] = wideCharacterFont(text, mode);
            if (wideFontName.length > 0) // surrogate pairs get special treatment
            return makeSymbol(text, wideFontName, mode, options, classes.concat(wideFontClass));
            else if (fontOrFamily) {
                let fontName;
                let fontClasses;
                if (fontOrFamily === "boldsymbol") {
                    const fontData = boldsymbol(text, mode, options, classes, type);
                    fontName = fontData.fontName;
                    fontClasses = [
                        fontData.fontClass
                    ];
                } else if (isFont) {
                    fontName = fontMap[fontOrFamily].fontName;
                    fontClasses = [
                        fontOrFamily
                    ];
                } else {
                    fontName = retrieveTextFontName(fontOrFamily, options.fontWeight, options.fontShape);
                    fontClasses = [
                        fontOrFamily,
                        options.fontWeight,
                        options.fontShape
                    ];
                }
                if (lookupSymbol(text, fontName, mode).metrics) return makeSymbol(text, fontName, mode, options, classes.concat(fontClasses));
                else if (ligatures.hasOwnProperty(text) && fontName.slice(0, 10) === "Typewriter") {
                    // Deconstruct ligatures in monospace fonts (\texttt, \tt).
                    const parts = [];
                    for(let i = 0; i < text.length; i++)parts.push(makeSymbol(text[i], fontName, mode, options, classes.concat(fontClasses)));
                    return makeFragment(parts);
                }
            } // Makes a symbol in the default font for mathords and textords.
            if (type === "mathord") return makeSymbol(text, "Math-Italic", mode, options, classes.concat([
                "mathnormal"
            ]));
            else if (type === "textord") {
                const font = src_symbols[mode][text] && src_symbols[mode][text].font;
                if (font === "ams") {
                    const fontName = retrieveTextFontName("amsrm", options.fontWeight, options.fontShape);
                    return makeSymbol(text, fontName, mode, options, classes.concat("amsrm", options.fontWeight, options.fontShape));
                } else if (font === "main" || !font) {
                    const fontName = retrieveTextFontName("textrm", options.fontWeight, options.fontShape);
                    return makeSymbol(text, fontName, mode, options, classes.concat(options.fontWeight, options.fontShape));
                } else {
                    // fonts added by plugins
                    const fontName = retrieveTextFontName(font, options.fontWeight, options.fontShape); // We add font name as a css class
                    return makeSymbol(text, fontName, mode, options, classes.concat(fontName, options.fontWeight, options.fontShape));
                }
            } else throw new Error("unexpected type: " + type + " in makeOrd");
        };
        /**
 * Returns true if subsequent symbolNodes have the same classes, skew, maxFont,
 * and styles.
 */ const canCombine = (prev, next)=>{
            if (createClass(prev.classes) !== createClass(next.classes) || prev.skew !== next.skew || prev.maxFontSize !== next.maxFontSize) return false;
             // If prev and next both are just "mbin"s or "mord"s we don't combine them
            // so that the proper spacing can be preserved.
            if (prev.classes.length === 1) {
                const cls = prev.classes[0];
                if (cls === "mbin" || cls === "mord") return false;
            }
            for(const style in prev.style){
                if (prev.style.hasOwnProperty(style) && prev.style[style] !== next.style[style]) return false;
            }
            for(const style in next.style){
                if (next.style.hasOwnProperty(style) && prev.style[style] !== next.style[style]) return false;
            }
            return true;
        };
        /**
 * Combine consecutive domTree.symbolNodes into a single symbolNode.
 * Note: this function mutates the argument.
 */ const tryCombineChars = (chars)=>{
            for(let i = 0; i < chars.length - 1; i++){
                const prev = chars[i];
                const next = chars[i + 1];
                if (prev instanceof SymbolNode && next instanceof SymbolNode && canCombine(prev, next)) {
                    prev.text += next.text;
                    prev.height = Math.max(prev.height, next.height);
                    prev.depth = Math.max(prev.depth, next.depth); // Use the last character's italic correction since we use
                    // it to add padding to the right of the span created from
                    // the combined characters.
                    prev.italic = next.italic;
                    chars.splice(i + 1, 1);
                    i--;
                }
            }
            return chars;
        };
        /**
 * Calculate the height, depth, and maxFontSize of an element based on its
 * children.
 */ const sizeElementFromChildren = function(elem) {
            let height = 0;
            let depth = 0;
            let maxFontSize = 0;
            for(let i = 0; i < elem.children.length; i++){
                const child = elem.children[i];
                if (child.height > height) height = child.height;
                if (child.depth > depth) depth = child.depth;
                if (child.maxFontSize > maxFontSize) maxFontSize = child.maxFontSize;
            }
            elem.height = height;
            elem.depth = depth;
            elem.maxFontSize = maxFontSize;
        };
        /**
 * Makes a span with the given list of classes, list of children, and options.
 *
 * TODO(#953): Ensure that `options` is always provided (currently some call
 * sites don't pass it) and make the type below mandatory.
 * TODO: add a separate argument for math class (e.g. `mop`, `mbin`), which
 * should if present come first in `classes`.
 */ const makeSpan = function(classes, children, options, style) {
            const span = new Span(classes, children, options, style);
            sizeElementFromChildren(span);
            return span;
        }; // SVG one is simpler -- doesn't require height, depth, max-font setting.
        // This is also a separate method for typesafety.
        const makeSvgSpan = (classes, children, options, style)=>new Span(classes, children, options, style);
        const makeLineSpan = function(className, options, thickness) {
            const line = makeSpan([
                className
            ], [], options);
            line.height = Math.max(thickness || options.fontMetrics().defaultRuleThickness, options.minRuleThickness);
            line.style.borderBottomWidth = makeEm(line.height);
            line.maxFontSize = 1.0;
            return line;
        };
        /**
 * Makes an anchor with the given href, list of classes, list of children,
 * and options.
 */ const makeAnchor = function(href, classes, children, options) {
            const anchor = new Anchor(href, classes, children, options);
            sizeElementFromChildren(anchor);
            return anchor;
        };
        /**
 * Makes a document fragment with the given list of children.
 */ const makeFragment = function(children) {
            const fragment = new DocumentFragment(children);
            sizeElementFromChildren(fragment);
            return fragment;
        };
        /**
 * Wraps group in a span if it's a document fragment, allowing to apply classes
 * and styles
 */ const wrapFragment = function(group, options) {
            if (group instanceof DocumentFragment) return makeSpan([], [
                group
            ], options);
            return group;
        }; // These are exact object types to catch typos in the names of the optional fields.
        // Computes the updated `children` list and the overall depth.
        //
        // This helper function for makeVList makes it easier to enforce type safety by
        // allowing early exits (returns) in the logic.
        const getVListChildrenAndDepth = function(params) {
            if (params.positionType === "individualShift") {
                const oldChildren = params.children;
                const children = [
                    oldChildren[0]
                ]; // Add in kerns to the list of params.children to get each element to be
                // shifted to the correct specified shift
                const depth = -oldChildren[0].shift - oldChildren[0].elem.depth;
                let currPos = depth;
                for(let i = 1; i < oldChildren.length; i++){
                    const diff = -oldChildren[i].shift - currPos - oldChildren[i].elem.depth;
                    const size = diff - (oldChildren[i - 1].elem.height + oldChildren[i - 1].elem.depth);
                    currPos = currPos + diff;
                    children.push({
                        type: "kern",
                        size: size
                    });
                    children.push(oldChildren[i]);
                }
                return {
                    children: children,
                    depth: depth
                };
            }
            let depth;
            if (params.positionType === "top") {
                // We always start at the bottom, so calculate the bottom by adding up
                // all the sizes
                let bottom = params.positionData;
                for(let i = 0; i < params.children.length; i++){
                    const child = params.children[i];
                    bottom -= child.type === "kern" ? child.size : child.elem.height + child.elem.depth;
                }
                depth = bottom;
            } else if (params.positionType === "bottom") depth = -params.positionData;
            else {
                const firstChild = params.children[0];
                if (firstChild.type !== "elem") throw new Error('First child must have type "elem".');
                if (params.positionType === "shift") depth = -firstChild.elem.depth - params.positionData;
                else if (params.positionType === "firstBaseline") depth = -firstChild.elem.depth;
                else throw new Error("Invalid positionType " + params.positionType + ".");
            }
            return {
                children: params.children,
                depth: depth
            };
        };
        /**
 * Makes a vertical list by stacking elements and kerns on top of each other.
 * Allows for many different ways of specifying the positioning method.
 *
 * See VListParam documentation above.
 */ const makeVList = function(params, options) {
            const { children: children, depth: depth } = getVListChildrenAndDepth(params); // Create a strut that is taller than any list item. The strut is added to
            // each item, where it will determine the item's baseline. Since it has
            // `overflow:hidden`, the strut's top edge will sit on the item's line box's
            // top edge and the strut's bottom edge will sit on the item's baseline,
            // with no additional line-height spacing. This allows the item baseline to
            // be positioned precisely without worrying about font ascent and
            // line-height.
            let pstrutSize = 0;
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.type === "elem") {
                    const elem = child.elem;
                    pstrutSize = Math.max(pstrutSize, elem.maxFontSize, elem.height);
                }
            }
            pstrutSize += 2;
            const pstrut = makeSpan([
                "pstrut"
            ], []);
            pstrut.style.height = makeEm(pstrutSize); // Create a new list of actual children at the correct offsets
            const realChildren = [];
            let minPos = depth;
            let maxPos = depth;
            let currPos = depth;
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.type === "kern") currPos += child.size;
                else {
                    const elem = child.elem;
                    const classes = child.wrapperClasses || [];
                    const style = child.wrapperStyle || {};
                    const childWrap = makeSpan(classes, [
                        pstrut,
                        elem
                    ], undefined, style);
                    childWrap.style.top = makeEm(-pstrutSize - currPos - elem.depth);
                    if (child.marginLeft) childWrap.style.marginLeft = child.marginLeft;
                    if (child.marginRight) childWrap.style.marginRight = child.marginRight;
                    realChildren.push(childWrap);
                    currPos += elem.height + elem.depth;
                }
                minPos = Math.min(minPos, currPos);
                maxPos = Math.max(maxPos, currPos);
            } // The vlist contents go in a table-cell with `vertical-align:bottom`.
            // This cell's bottom edge will determine the containing table's baseline
            // without overly expanding the containing line-box.
            const vlist = makeSpan([
                "vlist"
            ], realChildren);
            vlist.style.height = makeEm(maxPos); // A second row is used if necessary to represent the vlist's depth.
            let rows;
            if (minPos < 0) {
                // We will define depth in an empty span with display: table-cell.
                // It should render with the height that we define. But Chrome, in
                // contenteditable mode only, treats that span as if it contains some
                // text content. And that min-height over-rides our desired height.
                // So we put another empty span inside the depth strut span.
                const emptySpan = makeSpan([], []);
                const depthStrut = makeSpan([
                    "vlist"
                ], [
                    emptySpan
                ]);
                depthStrut.style.height = makeEm(-minPos); // Safari wants the first row to have inline content; otherwise it
                // puts the bottom of the *second* row on the baseline.
                const topStrut = makeSpan([
                    "vlist-s"
                ], [
                    new SymbolNode("\u200b")
                ]);
                rows = [
                    makeSpan([
                        "vlist-r"
                    ], [
                        vlist,
                        topStrut
                    ]),
                    makeSpan([
                        "vlist-r"
                    ], [
                        depthStrut
                    ])
                ];
            } else rows = [
                makeSpan([
                    "vlist-r"
                ], [
                    vlist
                ])
            ];
            const vtable = makeSpan([
                "vlist-t"
            ], rows);
            if (rows.length === 2) vtable.classes.push("vlist-t2");
            vtable.height = maxPos;
            vtable.depth = -minPos;
            return vtable;
        }; // Glue is a concept from TeX which is a flexible space between elements in
        // either a vertical or horizontal list. In KaTeX, at least for now, it's
        // static space between elements in a horizontal layout.
        const makeGlue = (measurement, options)=>{
            // Make an empty span for the space
            const rule = makeSpan([
                "mspace"
            ], [], options);
            const size = calculateSize(measurement, options);
            rule.style.marginRight = makeEm(size);
            return rule;
        }; // Takes font options, and returns the appropriate fontLookup name
        const retrieveTextFontName = function(fontFamily, fontWeight, fontShape) {
            let baseFontName = "";
            switch(fontFamily){
                case "amsrm":
                    baseFontName = "AMS";
                    break;
                case "textrm":
                    baseFontName = "Main";
                    break;
                case "textsf":
                    baseFontName = "SansSerif";
                    break;
                case "texttt":
                    baseFontName = "Typewriter";
                    break;
                default:
                    baseFontName = fontFamily;
            }
            let fontStylesName;
            if (fontWeight === "textbf" && fontShape === "textit") fontStylesName = "BoldItalic";
            else if (fontWeight === "textbf") fontStylesName = "Bold";
            else if (fontWeight === "textit") fontStylesName = "Italic";
            else fontStylesName = "Regular";
            return baseFontName + "-" + fontStylesName;
        };
        /**
 * Maps TeX font commands to objects containing:
 * - variant: string used for "mathvariant" attribute in buildMathML.js
 * - fontName: the "style" parameter to fontMetrics.getCharacterMetrics
 */ // A map between tex font commands an MathML mathvariant attribute values
        const fontMap = {
            // styles
            "mathbf": {
                variant: "bold",
                fontName: "Main-Bold"
            },
            "mathrm": {
                variant: "normal",
                fontName: "Main-Regular"
            },
            "textit": {
                variant: "italic",
                fontName: "Main-Italic"
            },
            "mathit": {
                variant: "italic",
                fontName: "Main-Italic"
            },
            "mathnormal": {
                variant: "italic",
                fontName: "Math-Italic"
            },
            "mathsfit": {
                variant: "sans-serif-italic",
                fontName: "SansSerif-Italic"
            },
            // "boldsymbol" is missing because they require the use of multiple fonts:
            // Math-BoldItalic and Main-Bold.  This is handled by a special case in
            // makeOrd which ends up calling boldsymbol.
            // families
            "mathbb": {
                variant: "double-struck",
                fontName: "AMS-Regular"
            },
            "mathcal": {
                variant: "script",
                fontName: "Caligraphic-Regular"
            },
            "mathfrak": {
                variant: "fraktur",
                fontName: "Fraktur-Regular"
            },
            "mathscr": {
                variant: "script",
                fontName: "Script-Regular"
            },
            "mathsf": {
                variant: "sans-serif",
                fontName: "SansSerif-Regular"
            },
            "mathtt": {
                variant: "monospace",
                fontName: "Typewriter-Regular"
            }
        };
        const svgData = {
            //   path, width, height
            vec: [
                "vec",
                0.471,
                0.714
            ],
            // values from the font glyph
            oiintSize1: [
                "oiintSize1",
                0.957,
                0.499
            ],
            // oval to overlay the integrand
            oiintSize2: [
                "oiintSize2",
                1.472,
                0.659
            ],
            oiiintSize1: [
                "oiiintSize1",
                1.304,
                0.499
            ],
            oiiintSize2: [
                "oiiintSize2",
                1.98,
                0.659
            ]
        };
        const staticSvg = function(value, options) {
            // Create a span with inline SVG for the element.
            const [pathName, width, height] = svgData[value];
            const path = new PathNode(pathName);
            const svgNode = new SvgNode([
                path
            ], {
                "width": makeEm(width),
                "height": makeEm(height),
                // Override CSS rule `.katex svg { width: 100% }`
                "style": "width:" + makeEm(width),
                "viewBox": "0 0 " + 1000 * width + " " + 1000 * height,
                "preserveAspectRatio": "xMinYMin"
            });
            const span = makeSvgSpan([
                "overlay"
            ], [
                svgNode
            ], options);
            span.height = height;
            span.style.height = makeEm(height);
            span.style.width = makeEm(width);
            return span;
        };
        /* harmony default export */ var buildCommon = {
            fontMap: fontMap,
            makeSymbol: makeSymbol,
            mathsym: mathsym,
            makeSpan: makeSpan,
            makeSvgSpan: makeSvgSpan,
            makeLineSpan: makeLineSpan,
            makeAnchor: makeAnchor,
            makeFragment: makeFragment,
            wrapFragment: wrapFragment,
            makeVList: makeVList,
            makeOrd: makeOrd,
            makeGlue: makeGlue,
            staticSvg: staticSvg,
            svgData: svgData,
            tryCombineChars: tryCombineChars
        };
        /**
 * Describes spaces between different classes of atoms.
 */ const thinspace = {
            number: 3,
            unit: "mu"
        };
        const mediumspace = {
            number: 4,
            unit: "mu"
        };
        const thickspace = {
            number: 5,
            unit: "mu"
        }; // Making the type below exact with all optional fields doesn't work due to
        // - https://github.com/facebook/flow/issues/4582
        // - https://github.com/facebook/flow/issues/5688
        // However, since *all* fields are optional, $Shape<> works as suggested in 5688
        // above.
        // Spacing relationships for display and text styles
        const spacings = {
            mord: {
                mop: thinspace,
                mbin: mediumspace,
                mrel: thickspace,
                minner: thinspace
            },
            mop: {
                mord: thinspace,
                mop: thinspace,
                mrel: thickspace,
                minner: thinspace
            },
            mbin: {
                mord: mediumspace,
                mop: mediumspace,
                mopen: mediumspace,
                minner: mediumspace
            },
            mrel: {
                mord: thickspace,
                mop: thickspace,
                mopen: thickspace,
                minner: thickspace
            },
            mopen: {},
            mclose: {
                mop: thinspace,
                mbin: mediumspace,
                mrel: thickspace,
                minner: thinspace
            },
            mpunct: {
                mord: thinspace,
                mop: thinspace,
                mrel: thickspace,
                mopen: thinspace,
                mclose: thinspace,
                mpunct: thinspace,
                minner: thinspace
            },
            minner: {
                mord: thinspace,
                mop: thinspace,
                mbin: mediumspace,
                mrel: thickspace,
                mopen: thinspace,
                mpunct: thinspace,
                minner: thinspace
            }
        }; // Spacing relationships for script and scriptscript styles
        const tightSpacings = {
            mord: {
                mop: thinspace
            },
            mop: {
                mord: thinspace,
                mop: thinspace
            },
            mbin: {},
            mrel: {},
            mopen: {},
            mclose: {
                mop: thinspace
            },
            mpunct: {},
            minner: {
                mop: thinspace
            }
        };
        /** Context provided to function handlers for error messages. */ // Note: reverse the order of the return type union will cause a flow error.
        // See https://github.com/facebook/flow/issues/3663.
        // More general version of `HtmlBuilder` for nodes (e.g. \sum, accent types)
        // whose presence impacts super/subscripting. In this case, ParseNode<"supsub">
        // delegates its HTML building to the HtmlBuilder corresponding to these nodes.
        /**
 * Final function spec for use at parse time.
 * This is almost identical to `FunctionPropSpec`, except it
 * 1. includes the function handler, and
 * 2. requires all arguments except argTypes.
 * It is generated by `defineFunction()` below.
 */ /**
 * All registered functions.
 * `functions.js` just exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary.
 */ const _functions = {};
        /**
 * All HTML builders. Should be only used in the `define*` and the `build*ML`
 * functions.
 */ const _htmlGroupBuilders = {};
        /**
 * All MathML builders. Should be only used in the `define*` and the `build*ML`
 * functions.
 */ const _mathmlGroupBuilders = {};
        function defineFunction(_ref) {
            let { type: type, names: names, props: props, handler: handler, htmlBuilder: htmlBuilder, mathmlBuilder: mathmlBuilder } = _ref;
            // Set default values of functions
            const data = {
                type: type,
                numArgs: props.numArgs,
                argTypes: props.argTypes,
                allowedInArgument: !!props.allowedInArgument,
                allowedInText: !!props.allowedInText,
                allowedInMath: props.allowedInMath === undefined ? true : props.allowedInMath,
                numOptionalArgs: props.numOptionalArgs || 0,
                infix: !!props.infix,
                primitive: !!props.primitive,
                handler: handler
            };
            for(let i = 0; i < names.length; ++i)_functions[names[i]] = data;
            if (type) {
                if (htmlBuilder) _htmlGroupBuilders[type] = htmlBuilder;
                if (mathmlBuilder) _mathmlGroupBuilders[type] = mathmlBuilder;
            }
        }
        /**
 * Use this to register only the HTML and MathML builders for a function (e.g.
 * if the function's ParseNode is generated in Parser.js rather than via a
 * stand-alone handler provided to `defineFunction`).
 */ function defineFunctionBuilders(_ref2) {
            let { type: type, htmlBuilder: htmlBuilder, mathmlBuilder: mathmlBuilder } = _ref2;
            defineFunction({
                type: type,
                names: [],
                props: {
                    numArgs: 0
                },
                handler () {
                    throw new Error('Should never be called.');
                },
                htmlBuilder: htmlBuilder,
                mathmlBuilder: mathmlBuilder
            });
        }
        const normalizeArgument = function(arg) {
            return arg.type === "ordgroup" && arg.body.length === 1 ? arg.body[0] : arg;
        }; // Since the corresponding buildHTML/buildMathML function expects a
        // list of elements, we normalize for different kinds of arguments
        const ordargument = function(arg) {
            return arg.type === "ordgroup" ? arg.body : [
                arg
            ];
        };
        /**
 * This file does the main work of building a domTree structure from a parse
 * tree. The entry point is the `buildHTML` function, which takes a parse tree.
 * Then, the buildExpression, buildGroup, and various groupBuilders functions
 * are called, to produce a final HTML tree.
 */ const buildHTML_makeSpan = buildCommon.makeSpan; // Binary atoms (first class `mbin`) change into ordinary atoms (`mord`)
        // depending on their surroundings. See TeXbook pg. 442-446, Rules 5 and 6,
        // and the text before Rule 19.
        const binLeftCanceller = [
            "leftmost",
            "mbin",
            "mopen",
            "mrel",
            "mop",
            "mpunct"
        ];
        const binRightCanceller = [
            "rightmost",
            "mrel",
            "mclose",
            "mpunct"
        ];
        const styleMap = {
            "display": src_Style.DISPLAY,
            "text": src_Style.TEXT,
            "script": src_Style.SCRIPT,
            "scriptscript": src_Style.SCRIPTSCRIPT
        };
        const DomEnum = {
            mord: "mord",
            mop: "mop",
            mbin: "mbin",
            mrel: "mrel",
            mopen: "mopen",
            mclose: "mclose",
            mpunct: "mpunct",
            minner: "minner"
        };
        /**
 * Take a list of nodes, build them in order, and return a list of the built
 * nodes. documentFragments are flattened into their contents, so the
 * returned list contains no fragments. `isRealGroup` is true if `expression`
 * is a real group (no atoms will be added on either side), as opposed to
 * a partial group (e.g. one created by \color). `surrounding` is an array
 * consisting type of nodes that will be added to the left and right.
 */ const buildExpression = function(expression, options, isRealGroup, surrounding) {
            if (surrounding === void 0) surrounding = [
                null,
                null
            ];
            // Parse expressions into `groups`.
            const groups = [];
            for(let i = 0; i < expression.length; i++){
                const output = buildGroup(expression[i], options);
                if (output instanceof DocumentFragment) {
                    const children = output.children;
                    groups.push(...children);
                } else groups.push(output);
            } // Combine consecutive domTree.symbolNodes into a single symbolNode.
            buildCommon.tryCombineChars(groups); // If `expression` is a partial group, let the parent handle spacings
            // to avoid processing groups multiple times.
            if (!isRealGroup) return groups;
            let glueOptions = options;
            if (expression.length === 1) {
                const node = expression[0];
                if (node.type === "sizing") glueOptions = options.havingSize(node.size);
                else if (node.type === "styling") glueOptions = options.havingStyle(styleMap[node.style]);
            } // Dummy spans for determining spacings between surrounding atoms.
            // If `expression` has no atoms on the left or right, class "leftmost"
            // or "rightmost", respectively, is used to indicate it.
            const dummyPrev = buildHTML_makeSpan([
                surrounding[0] || "leftmost"
            ], [], options);
            const dummyNext = buildHTML_makeSpan([
                surrounding[1] || "rightmost"
            ], [], options); // TODO: These code assumes that a node's math class is the first element
            // of its `classes` array. A later cleanup should ensure this, for
            // instance by changing the signature of `makeSpan`.
            // Before determining what spaces to insert, perform bin cancellation.
            // Binary operators change to ordinary symbols in some contexts.
            const isRoot = isRealGroup === "root";
            traverseNonSpaceNodes(groups, (node, prev)=>{
                const prevType = prev.classes[0];
                const type = node.classes[0];
                if (prevType === "mbin" && binRightCanceller.includes(type)) prev.classes[0] = "mord";
                else if (type === "mbin" && binLeftCanceller.includes(prevType)) node.classes[0] = "mord";
            }, {
                node: dummyPrev
            }, dummyNext, isRoot);
            traverseNonSpaceNodes(groups, (node, prev)=>{
                const prevType = getTypeOfDomTree(prev);
                const type = getTypeOfDomTree(node); // 'mtight' indicates that the node is script or scriptscript style.
                const space = prevType && type ? node.hasClass("mtight") ? tightSpacings[prevType][type] : spacings[prevType][type] : null;
                if (space) // Insert glue (spacing) after the `prev`.
                return buildCommon.makeGlue(space, glueOptions);
            }, {
                node: dummyPrev
            }, dummyNext, isRoot);
            return groups;
        }; // Depth-first traverse non-space `nodes`, calling `callback` with the current and
        // previous node as arguments, optionally returning a node to insert after the
        // previous node. `prev` is an object with the previous node and `insertAfter`
        // function to insert after it. `next` is a node that will be added to the right.
        // Used for bin cancellation and inserting spacings.
        const traverseNonSpaceNodes = function(nodes, callback, prev, next, isRoot) {
            if (next) // temporarily append the right node, if exists
            nodes.push(next);
            let i = 0;
            for(; i < nodes.length; i++){
                const node = nodes[i];
                const partialGroup = checkPartialGroup(node);
                if (partialGroup) {
                    // Recursive DFS
                    // $FlowFixMe: make nodes a $ReadOnlyArray by returning a new array
                    traverseNonSpaceNodes(partialGroup.children, callback, prev, null, isRoot);
                    continue;
                } // Ignore explicit spaces (e.g., \;, \,) when determining what implicit
                // spacing should go between atoms of different classes
                const nonspace = !node.hasClass("mspace");
                if (nonspace) {
                    const result = callback(node, prev.node);
                    if (result) {
                        if (prev.insertAfter) prev.insertAfter(result);
                        else {
                            // insert at front
                            nodes.unshift(result);
                            i++;
                        }
                    }
                }
                if (nonspace) prev.node = node;
                else if (isRoot && node.hasClass("newline")) prev.node = buildHTML_makeSpan([
                    "leftmost"
                ]); // treat like beginning of line
                prev.insertAfter = ((index)=>(n)=>{
                        nodes.splice(index + 1, 0, n);
                        i++;
                    })(i);
            }
            if (next) nodes.pop();
        }; // Check if given node is a partial group, i.e., does not affect spacing around.
        const checkPartialGroup = function(node) {
            if (node instanceof DocumentFragment || node instanceof Anchor || node instanceof Span && node.hasClass("enclosing")) return node;
            return null;
        }; // Return the outermost node of a domTree.
        const getOutermostNode = function(node, side) {
            const partialGroup = checkPartialGroup(node);
            if (partialGroup) {
                const children = partialGroup.children;
                if (children.length) {
                    if (side === "right") return getOutermostNode(children[children.length - 1], "right");
                    else if (side === "left") return getOutermostNode(children[0], "left");
                }
            }
            return node;
        }; // Return math atom class (mclass) of a domTree.
        // If `side` is given, it will get the type of the outermost node at given side.
        const getTypeOfDomTree = function(node, side) {
            if (!node) return null;
            if (side) node = getOutermostNode(node, side);
             // This makes a lot of assumptions as to where the type of atom
            // appears.  We should do a better job of enforcing this.
            return DomEnum[node.classes[0]] || null;
        };
        const makeNullDelimiter = function(options, classes) {
            const moreClasses = [
                "nulldelimiter"
            ].concat(options.baseSizingClasses());
            return buildHTML_makeSpan(classes.concat(moreClasses));
        };
        /**
 * buildGroup is the function that takes a group and calls the correct groupType
 * function for it. It also handles the interaction of size and style changes
 * between parents and children.
 */ const buildGroup = function(group, options, baseOptions) {
            if (!group) return buildHTML_makeSpan();
            if (_htmlGroupBuilders[group.type]) {
                // Call the groupBuilders function
                // $FlowFixMe
                let groupNode = _htmlGroupBuilders[group.type](group, options); // If the size changed between the parent and the current group, account
                // for that size difference.
                if (baseOptions && options.size !== baseOptions.size) {
                    groupNode = buildHTML_makeSpan(options.sizingClasses(baseOptions), [
                        groupNode
                    ], options);
                    const multiplier = options.sizeMultiplier / baseOptions.sizeMultiplier;
                    groupNode.height *= multiplier;
                    groupNode.depth *= multiplier;
                }
                return groupNode;
            } else throw new src_ParseError("Got group of unknown type: '" + group.type + "'");
        };
        /**
 * Combine an array of HTML DOM nodes (e.g., the output of `buildExpression`)
 * into an unbreakable HTML node of class .base, with proper struts to
 * guarantee correct vertical extent.  `buildHTML` calls this repeatedly to
 * make up the entire expression as a sequence of unbreakable units.
 */ function buildHTMLUnbreakable(children, options) {
            // Compute height and depth of this chunk.
            const body = buildHTML_makeSpan([
                "base"
            ], children, options); // Add strut, which ensures that the top of the HTML element falls at
            // the height of the expression, and the bottom of the HTML element
            // falls at the depth of the expression.
            const strut = buildHTML_makeSpan([
                "strut"
            ]);
            strut.style.height = makeEm(body.height + body.depth);
            if (body.depth) strut.style.verticalAlign = makeEm(-body.depth);
            body.children.unshift(strut);
            return body;
        }
        /**
 * Take an entire parse tree, and build it into an appropriate set of HTML
 * nodes.
 */ function buildHTML(tree, options) {
            // Strip off outer tag wrapper for processing below.
            let tag = null;
            if (tree.length === 1 && tree[0].type === "tag") {
                tag = tree[0].tag;
                tree = tree[0].body;
            } // Build the expression contained in the tree
            const expression = buildExpression(tree, options, "root");
            let eqnNum;
            if (expression.length === 2 && expression[1].hasClass("tag")) // An environment with automatic equation numbers, e.g. {gather}.
            eqnNum = expression.pop();
            const children = []; // Create one base node for each chunk between potential line breaks.
            // The TeXBook [p.173] says "A formula will be broken only after a
            // relation symbol like $=$ or $<$ or $\rightarrow$, or after a binary
            // operation symbol like $+$ or $-$ or $\times$, where the relation or
            // binary operation is on the ``outer level'' of the formula (i.e., not
            // enclosed in {...} and not part of an \over construction)."
            let parts = [];
            for(let i = 0; i < expression.length; i++){
                parts.push(expression[i]);
                if (expression[i].hasClass("mbin") || expression[i].hasClass("mrel") || expression[i].hasClass("allowbreak")) {
                    // Put any post-operator glue on same line as operator.
                    // Watch for \nobreak along the way, and stop at \newline.
                    let nobreak = false;
                    while(i < expression.length - 1 && expression[i + 1].hasClass("mspace") && !expression[i + 1].hasClass("newline")){
                        i++;
                        parts.push(expression[i]);
                        if (expression[i].hasClass("nobreak")) nobreak = true;
                    } // Don't allow break if \nobreak among the post-operator glue.
                    if (!nobreak) {
                        children.push(buildHTMLUnbreakable(parts, options));
                        parts = [];
                    }
                } else if (expression[i].hasClass("newline")) {
                    // Write the line except the newline
                    parts.pop();
                    if (parts.length > 0) {
                        children.push(buildHTMLUnbreakable(parts, options));
                        parts = [];
                    } // Put the newline at the top level
                    children.push(expression[i]);
                }
            }
            if (parts.length > 0) children.push(buildHTMLUnbreakable(parts, options));
             // Now, if there was a tag, build it too and append it as a final child.
            let tagChild;
            if (tag) {
                tagChild = buildHTMLUnbreakable(buildExpression(tag, options, true));
                tagChild.classes = [
                    "tag"
                ];
                children.push(tagChild);
            } else if (eqnNum) children.push(eqnNum);
            const htmlNode = buildHTML_makeSpan([
                "katex-html"
            ], children);
            htmlNode.setAttribute("aria-hidden", "true"); // Adjust the strut of the tag to be the maximum height of all children
            // (the height of the enclosing htmlNode) for proper vertical alignment.
            if (tagChild) {
                const strut = tagChild.children[0];
                strut.style.height = makeEm(htmlNode.height + htmlNode.depth);
                if (htmlNode.depth) strut.style.verticalAlign = makeEm(-htmlNode.depth);
            }
            return htmlNode;
        }
        /**
 * These objects store data about MathML nodes. This is the MathML equivalent
 * of the types in domTree.js. Since MathML handles its own rendering, and
 * since we're mainly using MathML to improve accessibility, we don't manage
 * any of the styling state that the plain DOM nodes do.
 *
 * The `toNode` and `toMarkup` functions work similarly to how they do in
 * domTree.js, creating namespaced DOM nodes and HTML text markup respectively.
 */ function newDocumentFragment(children) {
            return new DocumentFragment(children);
        }
        /**
 * This node represents a general purpose MathML node of any type. The
 * constructor requires the type of node to create (for example, `"mo"` or
 * `"mspace"`, corresponding to `<mo>` and `<mspace>` tags).
 */ class MathNode {
            constructor(type, children, classes){
                this.type = void 0;
                this.attributes = void 0;
                this.children = void 0;
                this.classes = void 0;
                this.type = type;
                this.attributes = {};
                this.children = children || [];
                this.classes = classes || [];
            }
            /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */ setAttribute(name, value) {
                this.attributes[name] = value;
            }
            /**
   * Gets an attribute on a MathML node.
   */ getAttribute(name) {
                return this.attributes[name];
            }
            /**
   * Converts the math node into a MathML-namespaced DOM element.
   */ toNode() {
                const node = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
                for(const attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
                if (this.classes.length > 0) node.className = createClass(this.classes);
                for(let i = 0; i < this.children.length; i++)// Combine multiple TextNodes into one TextNode, to prevent
                // screen readers from reading each as a separate word [#3995]
                if (this.children[i] instanceof TextNode && this.children[i + 1] instanceof TextNode) {
                    let text = this.children[i].toText() + this.children[++i].toText();
                    while(this.children[i + 1] instanceof TextNode)text += this.children[++i].toText();
                    node.appendChild(new TextNode(text).toNode());
                } else node.appendChild(this.children[i].toNode());
                return node;
            }
            /**
   * Converts the math node into an HTML markup string.
   */ toMarkup() {
                let markup = "<" + this.type; // Add the attributes
                for(const attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
                    markup += " " + attr + "=\"";
                    markup += utils.escape(this.attributes[attr]);
                    markup += "\"";
                }
                if (this.classes.length > 0) markup += " class =\"" + utils.escape(createClass(this.classes)) + "\"";
                markup += ">";
                for(let i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
                markup += "</" + this.type + ">";
                return markup;
            }
            /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */ toText() {
                return this.children.map((child)=>child.toText()).join("");
            }
        }
        /**
 * This node represents a piece of text.
 */ class TextNode {
            constructor(text){
                this.text = void 0;
                this.text = text;
            }
            /**
   * Converts the text node into a DOM text node.
   */ toNode() {
                return document.createTextNode(this.text);
            }
            /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */ toMarkup() {
                return utils.escape(this.toText());
            }
            /**
   * Converts the text node into a string
   * (representing the text itself).
   */ toText() {
                return this.text;
            }
        }
        /**
 * This node represents a space, but may render as <mspace.../> or as text,
 * depending on the width.
 */ class SpaceNode {
            /**
   * Create a Space node with width given in CSS ems.
   */ constructor(width){
                this.width = void 0;
                this.character = void 0;
                this.width = width; // See https://www.w3.org/TR/2000/WD-MathML2-20000328/chapter6.html
                // for a table of space-like characters.  We use Unicode
                // representations instead of &LongNames; as it's not clear how to
                // make the latter via document.createTextNode.
                if (width >= 0.05555 && width <= 0.05556) this.character = "\u200a"; // &VeryThinSpace;
                else if (width >= 0.1666 && width <= 0.1667) this.character = "\u2009"; // &ThinSpace;
                else if (width >= 0.2222 && width <= 0.2223) this.character = "\u2005"; // &MediumSpace;
                else if (width >= 0.2777 && width <= 0.2778) this.character = "\u2005\u200a"; // &ThickSpace;
                else if (width >= -0.05556 && width <= -0.05555) this.character = "\u200a\u2063"; // &NegativeVeryThinSpace;
                else if (width >= -0.1667 && width <= -0.1666) this.character = "\u2009\u2063"; // &NegativeThinSpace;
                else if (width >= -0.2223 && width <= -0.2222) this.character = "\u205f\u2063"; // &NegativeMediumSpace;
                else if (width >= -0.2778 && width <= -0.2777) this.character = "\u2005\u2063"; // &NegativeThickSpace;
                else this.character = null;
            }
            /**
   * Converts the math node into a MathML-namespaced DOM element.
   */ toNode() {
                if (this.character) return document.createTextNode(this.character);
                else {
                    const node = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
                    node.setAttribute("width", makeEm(this.width));
                    return node;
                }
            }
            /**
   * Converts the math node into an HTML markup string.
   */ toMarkup() {
                if (this.character) return "<mtext>" + this.character + "</mtext>";
                else return "<mspace width=\"" + makeEm(this.width) + "\"/>";
            }
            /**
   * Converts the math node into a string, similar to innerText.
   */ toText() {
                if (this.character) return this.character;
                else return " ";
            }
        }
        /* harmony default export */ var mathMLTree = {
            MathNode: MathNode,
            TextNode: TextNode,
            SpaceNode: SpaceNode,
            newDocumentFragment: newDocumentFragment
        };
        /**
 * This file converts a parse tree into a corresponding MathML tree. The main
 * entry point is the `buildMathML` function, which takes a parse tree from the
 * parser.
 */ /**
 * Takes a symbol and converts it into a MathML text node after performing
 * optional replacement from symbols.js.
 */ const makeText = function(text, mode, options) {
            if (src_symbols[mode][text] && src_symbols[mode][text].replace && text.charCodeAt(0) !== 0xD835 && !(ligatures.hasOwnProperty(text) && options && (options.fontFamily && options.fontFamily.slice(4, 6) === "tt" || options.font && options.font.slice(4, 6) === "tt"))) text = src_symbols[mode][text].replace;
            return new mathMLTree.TextNode(text);
        };
        /**
 * Wrap the given array of nodes in an <mrow> node if needed, i.e.,
 * unless the array has length 1.  Always returns a single node.
 */ const makeRow = function(body) {
            if (body.length === 1) return body[0];
            else return new mathMLTree.MathNode("mrow", body);
        };
        /**
 * Returns the math variant as a string or null if none is required.
 */ const getVariant = function(group, options) {
            // Handle \text... font specifiers as best we can.
            // MathML has a limited list of allowable mathvariant specifiers; see
            // https://www.w3.org/TR/MathML3/chapter3.html#presm.commatt
            if (options.fontFamily === "texttt") return "monospace";
            else if (options.fontFamily === "textsf") {
                if (options.fontShape === "textit" && options.fontWeight === "textbf") return "sans-serif-bold-italic";
                else if (options.fontShape === "textit") return "sans-serif-italic";
                else if (options.fontWeight === "textbf") return "bold-sans-serif";
                else return "sans-serif";
            } else if (options.fontShape === "textit" && options.fontWeight === "textbf") return "bold-italic";
            else if (options.fontShape === "textit") return "italic";
            else if (options.fontWeight === "textbf") return "bold";
            const font = options.font;
            if (!font || font === "mathnormal") return null;
            const mode = group.mode;
            if (font === "mathit") return "italic";
            else if (font === "boldsymbol") return group.type === "textord" ? "bold" : "bold-italic";
            else if (font === "mathbf") return "bold";
            else if (font === "mathbb") return "double-struck";
            else if (font === "mathsfit") return "sans-serif-italic";
            else if (font === "mathfrak") return "fraktur";
            else if (font === "mathscr" || font === "mathcal") // MathML makes no distinction between script and calligraphic
            return "script";
            else if (font === "mathsf") return "sans-serif";
            else if (font === "mathtt") return "monospace";
            let text = group.text;
            if ([
                "\\imath",
                "\\jmath"
            ].includes(text)) return null;
            if (src_symbols[mode][text] && src_symbols[mode][text].replace) text = src_symbols[mode][text].replace;
            const fontName = buildCommon.fontMap[font].fontName;
            if (getCharacterMetrics(text, fontName, mode)) return buildCommon.fontMap[font].variant;
            return null;
        };
        /**
 * Check for <mi>.</mi> which is how a dot renders in MathML,
 * or <mo separator="true" lspace="0em" rspace="0em">,</mo>
 * which is how a braced comma {,} renders in MathML
 */ function isNumberPunctuation(group) {
            if (!group) return false;
            if (group.type === 'mi' && group.children.length === 1) {
                const child = group.children[0];
                return child instanceof TextNode && child.text === '.';
            } else if (group.type === 'mo' && group.children.length === 1 && group.getAttribute('separator') === 'true' && group.getAttribute('lspace') === '0em' && group.getAttribute('rspace') === '0em') {
                const child = group.children[0];
                return child instanceof TextNode && child.text === ',';
            } else return false;
        }
        /**
 * Takes a list of nodes, builds them, and returns a list of the generated
 * MathML nodes.  Also combine consecutive <mtext> outputs into a single
 * <mtext> tag.
 */ const buildMathML_buildExpression = function(expression, options, isOrdgroup) {
            if (expression.length === 1) {
                const group = buildMathML_buildGroup(expression[0], options);
                if (isOrdgroup && group instanceof MathNode && group.type === "mo") {
                    // When TeX writers want to suppress spacing on an operator,
                    // they often put the operator by itself inside braces.
                    group.setAttribute("lspace", "0em");
                    group.setAttribute("rspace", "0em");
                }
                return [
                    group
                ];
            }
            const groups = [];
            let lastGroup;
            for(let i = 0; i < expression.length; i++){
                const group = buildMathML_buildGroup(expression[i], options);
                if (group instanceof MathNode && lastGroup instanceof MathNode) {
                    // Concatenate adjacent <mtext>s
                    if (group.type === 'mtext' && lastGroup.type === 'mtext' && group.getAttribute('mathvariant') === lastGroup.getAttribute('mathvariant')) {
                        lastGroup.children.push(...group.children);
                        continue; // Concatenate adjacent <mn>s
                    } else if (group.type === 'mn' && lastGroup.type === 'mn') {
                        lastGroup.children.push(...group.children);
                        continue; // Concatenate <mn>...</mn> followed by <mi>.</mi>
                    } else if (isNumberPunctuation(group) && lastGroup.type === 'mn') {
                        lastGroup.children.push(...group.children);
                        continue; // Concatenate <mi>.</mi> followed by <mn>...</mn>
                    } else if (group.type === 'mn' && isNumberPunctuation(lastGroup)) {
                        group.children = [
                            ...lastGroup.children,
                            ...group.children
                        ];
                        groups.pop(); // Put preceding <mn>...</mn> or <mi>.</mi> inside base of
                    // <msup><mn>...base...</mn>...exponent...</msup> (or <msub>)
                    } else if ((group.type === 'msup' || group.type === 'msub') && group.children.length >= 1 && (lastGroup.type === 'mn' || isNumberPunctuation(lastGroup))) {
                        const base = group.children[0];
                        if (base instanceof MathNode && base.type === 'mn') {
                            base.children = [
                                ...lastGroup.children,
                                ...base.children
                            ];
                            groups.pop();
                        } // \not
                    } else if (lastGroup.type === 'mi' && lastGroup.children.length === 1) {
                        const lastChild = lastGroup.children[0];
                        if (lastChild instanceof TextNode && lastChild.text === '\u0338' && (group.type === 'mo' || group.type === 'mi' || group.type === 'mn')) {
                            const child = group.children[0];
                            if (child instanceof TextNode && child.text.length > 0) {
                                // Overlay with combining character long solidus
                                child.text = child.text.slice(0, 1) + "\u0338" + child.text.slice(1);
                                groups.pop();
                            }
                        }
                    }
                }
                groups.push(group);
                lastGroup = group;
            }
            return groups;
        };
        /**
 * Equivalent to buildExpression, but wraps the elements in an <mrow>
 * if there's more than one.  Returns a single node instead of an array.
 */ const buildExpressionRow = function(expression, options, isOrdgroup) {
            return makeRow(buildMathML_buildExpression(expression, options, isOrdgroup));
        };
        /**
 * Takes a group from the parser and calls the appropriate groupBuilders function
 * on it to produce a MathML node.
 */ const buildMathML_buildGroup = function(group, options) {
            if (!group) return new mathMLTree.MathNode("mrow");
            if (_mathmlGroupBuilders[group.type]) {
                // Call the groupBuilders function
                // $FlowFixMe
                const result = _mathmlGroupBuilders[group.type](group, options); // $FlowFixMe
                return result;
            } else throw new src_ParseError("Got group of unknown type: '" + group.type + "'");
        };
        /**
 * Takes a full parse tree and settings and builds a MathML representation of
 * it. In particular, we put the elements from building the parse tree into a
 * <semantics> tag so we can also include that TeX source as an annotation.
 *
 * Note that we actually return a domTree element with a `<math>` inside it so
 * we can do appropriate styling.
 */ function buildMathML(tree, texExpression, options, isDisplayMode, forMathmlOnly) {
            const expression = buildMathML_buildExpression(tree, options); // TODO: Make a pass thru the MathML similar to buildHTML.traverseNonSpaceNodes
            // and add spacing nodes. This is necessary only adjacent to math operators
            // like \sin or \lim or to subsup elements that contain math operators.
            // MathML takes care of the other spacing issues.
            // Wrap up the expression in an mrow so it is presented in the semantics
            // tag correctly, unless it's a single <mrow> or <mtable>.
            let wrapper;
            if (expression.length === 1 && expression[0] instanceof MathNode && [
                "mrow",
                "mtable"
            ].includes(expression[0].type)) wrapper = expression[0];
            else wrapper = new mathMLTree.MathNode("mrow", expression);
             // Build a TeX annotation of the source
            const annotation = new mathMLTree.MathNode("annotation", [
                new mathMLTree.TextNode(texExpression)
            ]);
            annotation.setAttribute("encoding", "application/x-tex");
            const semantics = new mathMLTree.MathNode("semantics", [
                wrapper,
                annotation
            ]);
            const math = new mathMLTree.MathNode("math", [
                semantics
            ]);
            math.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML");
            if (isDisplayMode) math.setAttribute("display", "block");
             // You can't style <math> nodes, so we wrap the node in a span.
            // NOTE: The span class is not typed to have <math> nodes as children, and
            // we don't want to make the children type more generic since the children
            // of span are expected to have more fields in `buildHtml` contexts.
            const wrapperClass = forMathmlOnly ? "katex" : "katex-mathml"; // $FlowFixMe
            return buildCommon.makeSpan([
                wrapperClass
            ], [
                math
            ]);
        }
        const optionsFromSettings = function(settings) {
            return new src_Options({
                style: settings.displayMode ? src_Style.DISPLAY : src_Style.TEXT,
                maxSize: settings.maxSize,
                minRuleThickness: settings.minRuleThickness
            });
        };
        const displayWrap = function(node, settings) {
            if (settings.displayMode) {
                const classes = [
                    "katex-display"
                ];
                if (settings.leqno) classes.push("leqno");
                if (settings.fleqn) classes.push("fleqn");
                node = buildCommon.makeSpan(classes, [
                    node
                ]);
            }
            return node;
        };
        const buildTree = function(tree, expression, settings) {
            const options = optionsFromSettings(settings);
            let katexNode;
            if (settings.output === "mathml") return buildMathML(tree, expression, options, settings.displayMode, true);
            else if (settings.output === "html") {
                const htmlNode = buildHTML(tree, options);
                katexNode = buildCommon.makeSpan([
                    "katex"
                ], [
                    htmlNode
                ]);
            } else {
                const mathMLNode = buildMathML(tree, expression, options, settings.displayMode, false);
                const htmlNode = buildHTML(tree, options);
                katexNode = buildCommon.makeSpan([
                    "katex"
                ], [
                    mathMLNode,
                    htmlNode
                ]);
            }
            return displayWrap(katexNode, settings);
        };
        const buildHTMLTree = function(tree, expression, settings) {
            const options = optionsFromSettings(settings);
            const htmlNode = buildHTML(tree, options);
            const katexNode = buildCommon.makeSpan([
                "katex"
            ], [
                htmlNode
            ]);
            return displayWrap(katexNode, settings);
        };
        /* harmony default export */ var src_buildTree = /* unused pure expression or super */ null;
        /**
 * This file provides support to buildMathML.js and buildHTML.js
 * for stretchy wide elements rendered from SVG files
 * and other CSS trickery.
 */ const stretchyCodePoint = {
            widehat: "^",
            widecheck: "\u02C7",
            widetilde: "~",
            utilde: "~",
            overleftarrow: "\u2190",
            underleftarrow: "\u2190",
            xleftarrow: "\u2190",
            overrightarrow: "\u2192",
            underrightarrow: "\u2192",
            xrightarrow: "\u2192",
            underbrace: "\u23df",
            overbrace: "\u23de",
            overgroup: "\u23e0",
            undergroup: "\u23e1",
            overleftrightarrow: "\u2194",
            underleftrightarrow: "\u2194",
            xleftrightarrow: "\u2194",
            Overrightarrow: "\u21d2",
            xRightarrow: "\u21d2",
            overleftharpoon: "\u21bc",
            xleftharpoonup: "\u21bc",
            overrightharpoon: "\u21c0",
            xrightharpoonup: "\u21c0",
            xLeftarrow: "\u21d0",
            xLeftrightarrow: "\u21d4",
            xhookleftarrow: "\u21a9",
            xhookrightarrow: "\u21aa",
            xmapsto: "\u21a6",
            xrightharpoondown: "\u21c1",
            xleftharpoondown: "\u21bd",
            xrightleftharpoons: "\u21cc",
            xleftrightharpoons: "\u21cb",
            xtwoheadleftarrow: "\u219e",
            xtwoheadrightarrow: "\u21a0",
            xlongequal: "=",
            xtofrom: "\u21c4",
            xrightleftarrows: "\u21c4",
            xrightequilibrium: "\u21cc",
            // Not a perfect match.
            xleftequilibrium: "\u21cb",
            // None better available.
            "\\cdrightarrow": "\u2192",
            "\\cdleftarrow": "\u2190",
            "\\cdlongequal": "="
        };
        const mathMLnode = function(label) {
            const node = new mathMLTree.MathNode("mo", [
                new mathMLTree.TextNode(stretchyCodePoint[label.replace(/^\\/, '')])
            ]);
            node.setAttribute("stretchy", "true");
            return node;
        }; // Many of the KaTeX SVG images have been adapted from glyphs in KaTeX fonts.
        // Copyright (c) 2009-2010, Design Science, Inc. (<www.mathjax.org>)
        // Copyright (c) 2014-2017 Khan Academy (<www.khanacademy.org>)
        // Licensed under the SIL Open Font License, Version 1.1.
        // See \nhttp://scripts.sil.org/OFL
        // Very Long SVGs
        //    Many of the KaTeX stretchy wide elements use a long SVG image and an
        //    overflow: hidden tactic to achieve a stretchy image while avoiding
        //    distortion of arrowheads or brace corners.
        //    The SVG typically contains a very long (400 em) arrow.
        //    The SVG is in a container span that has overflow: hidden, so the span
        //    acts like a window that exposes only part of the  SVG.
        //    The SVG always has a longer, thinner aspect ratio than the container span.
        //    After the SVG fills 100% of the height of the container span,
        //    there is a long arrow shaft left over. That left-over shaft is not shown.
        //    Instead, it is sliced off because the span's CSS has overflow: hidden.
        //    Thus, the reader sees an arrow that matches the subject matter width
        //    without distortion.
        //    Some functions, such as \cancel, need to vary their aspect ratio. These
        //    functions do not get the overflow SVG treatment.
        // Second Brush Stroke
        //    Low resolution monitors struggle to display images in fine detail.
        //    So browsers apply anti-aliasing. A long straight arrow shaft therefore
        //    will sometimes appear as if it has a blurred edge.
        //    To mitigate this, these SVG files contain a second "brush-stroke" on the
        //    arrow shafts. That is, a second long thin rectangular SVG path has been
        //    written directly on top of each arrow shaft. This reinforcement causes
        //    some of the screen pixels to display as black instead of the anti-aliased
        //    gray pixel that a  single path would generate. So we get arrow shafts
        //    whose edges appear to be sharper.
        // In the katexImagesData object just below, the dimensions all
        // correspond to path geometry inside the relevant SVG.
        // For example, \overrightarrow uses the same arrowhead as glyph U+2192
        // from the KaTeX Main font. The scaling factor is 1000.
        // That is, inside the font, that arrowhead is 522 units tall, which
        // corresponds to 0.522 em inside the document.
        const katexImagesData = {
            //   path(s), minWidth, height, align
            overrightarrow: [
                [
                    "rightarrow"
                ],
                0.888,
                522,
                "xMaxYMin"
            ],
            overleftarrow: [
                [
                    "leftarrow"
                ],
                0.888,
                522,
                "xMinYMin"
            ],
            underrightarrow: [
                [
                    "rightarrow"
                ],
                0.888,
                522,
                "xMaxYMin"
            ],
            underleftarrow: [
                [
                    "leftarrow"
                ],
                0.888,
                522,
                "xMinYMin"
            ],
            xrightarrow: [
                [
                    "rightarrow"
                ],
                1.469,
                522,
                "xMaxYMin"
            ],
            "\\cdrightarrow": [
                [
                    "rightarrow"
                ],
                3.0,
                522,
                "xMaxYMin"
            ],
            // CD minwwidth2.5pc
            xleftarrow: [
                [
                    "leftarrow"
                ],
                1.469,
                522,
                "xMinYMin"
            ],
            "\\cdleftarrow": [
                [
                    "leftarrow"
                ],
                3.0,
                522,
                "xMinYMin"
            ],
            Overrightarrow: [
                [
                    "doublerightarrow"
                ],
                0.888,
                560,
                "xMaxYMin"
            ],
            xRightarrow: [
                [
                    "doublerightarrow"
                ],
                1.526,
                560,
                "xMaxYMin"
            ],
            xLeftarrow: [
                [
                    "doubleleftarrow"
                ],
                1.526,
                560,
                "xMinYMin"
            ],
            overleftharpoon: [
                [
                    "leftharpoon"
                ],
                0.888,
                522,
                "xMinYMin"
            ],
            xleftharpoonup: [
                [
                    "leftharpoon"
                ],
                0.888,
                522,
                "xMinYMin"
            ],
            xleftharpoondown: [
                [
                    "leftharpoondown"
                ],
                0.888,
                522,
                "xMinYMin"
            ],
            overrightharpoon: [
                [
                    "rightharpoon"
                ],
                0.888,
                522,
                "xMaxYMin"
            ],
            xrightharpoonup: [
                [
                    "rightharpoon"
                ],
                0.888,
                522,
                "xMaxYMin"
            ],
            xrightharpoondown: [
                [
                    "rightharpoondown"
                ],
                0.888,
                522,
                "xMaxYMin"
            ],
            xlongequal: [
                [
                    "longequal"
                ],
                0.888,
                334,
                "xMinYMin"
            ],
            "\\cdlongequal": [
                [
                    "longequal"
                ],
                3.0,
                334,
                "xMinYMin"
            ],
            xtwoheadleftarrow: [
                [
                    "twoheadleftarrow"
                ],
                0.888,
                334,
                "xMinYMin"
            ],
            xtwoheadrightarrow: [
                [
                    "twoheadrightarrow"
                ],
                0.888,
                334,
                "xMaxYMin"
            ],
            overleftrightarrow: [
                [
                    "leftarrow",
                    "rightarrow"
                ],
                0.888,
                522
            ],
            overbrace: [
                [
                    "leftbrace",
                    "midbrace",
                    "rightbrace"
                ],
                1.6,
                548
            ],
            underbrace: [
                [
                    "leftbraceunder",
                    "midbraceunder",
                    "rightbraceunder"
                ],
                1.6,
                548
            ],
            underleftrightarrow: [
                [
                    "leftarrow",
                    "rightarrow"
                ],
                0.888,
                522
            ],
            xleftrightarrow: [
                [
                    "leftarrow",
                    "rightarrow"
                ],
                1.75,
                522
            ],
            xLeftrightarrow: [
                [
                    "doubleleftarrow",
                    "doublerightarrow"
                ],
                1.75,
                560
            ],
            xrightleftharpoons: [
                [
                    "leftharpoondownplus",
                    "rightharpoonplus"
                ],
                1.75,
                716
            ],
            xleftrightharpoons: [
                [
                    "leftharpoonplus",
                    "rightharpoondownplus"
                ],
                1.75,
                716
            ],
            xhookleftarrow: [
                [
                    "leftarrow",
                    "righthook"
                ],
                1.08,
                522
            ],
            xhookrightarrow: [
                [
                    "lefthook",
                    "rightarrow"
                ],
                1.08,
                522
            ],
            overlinesegment: [
                [
                    "leftlinesegment",
                    "rightlinesegment"
                ],
                0.888,
                522
            ],
            underlinesegment: [
                [
                    "leftlinesegment",
                    "rightlinesegment"
                ],
                0.888,
                522
            ],
            overgroup: [
                [
                    "leftgroup",
                    "rightgroup"
                ],
                0.888,
                342
            ],
            undergroup: [
                [
                    "leftgroupunder",
                    "rightgroupunder"
                ],
                0.888,
                342
            ],
            xmapsto: [
                [
                    "leftmapsto",
                    "rightarrow"
                ],
                1.5,
                522
            ],
            xtofrom: [
                [
                    "leftToFrom",
                    "rightToFrom"
                ],
                1.75,
                528
            ],
            // The next three arrows are from the mhchem package.
            // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
            // document as \xrightarrow or \xrightleftharpoons. Those have
            // min-length = 1.75em, so we set min-length on these next three to match.
            xrightleftarrows: [
                [
                    "baraboveleftarrow",
                    "rightarrowabovebar"
                ],
                1.75,
                901
            ],
            xrightequilibrium: [
                [
                    "baraboveshortleftharpoon",
                    "rightharpoonaboveshortbar"
                ],
                1.75,
                716
            ],
            xleftequilibrium: [
                [
                    "shortbaraboveleftharpoon",
                    "shortrightharpoonabovebar"
                ],
                1.75,
                716
            ]
        };
        const groupLength = function(arg) {
            if (arg.type === "ordgroup") return arg.body.length;
            else return 1;
        };
        const svgSpan = function(group, options) {
            // Create a span with inline SVG for the element.
            function buildSvgSpan_() {
                let viewBoxWidth = 400000; // default
                const label = group.label.slice(1);
                if ([
                    "widehat",
                    "widecheck",
                    "widetilde",
                    "utilde"
                ].includes(label)) {
                    // Each type in the `if` statement corresponds to one of the ParseNode
                    // types below. This narrowing is required to access `grp.base`.
                    // $FlowFixMe
                    const grp = group; // There are four SVG images available for each function.
                    // Choose a taller image when there are more characters.
                    const numChars = groupLength(grp.base);
                    let viewBoxHeight;
                    let pathName;
                    let height;
                    if (numChars > 5) {
                        if (label === "widehat" || label === "widecheck") {
                            viewBoxHeight = 420;
                            viewBoxWidth = 2364;
                            height = 0.42;
                            pathName = label + "4";
                        } else {
                            viewBoxHeight = 312;
                            viewBoxWidth = 2340;
                            height = 0.34;
                            pathName = "tilde4";
                        }
                    } else {
                        const imgIndex = [
                            1,
                            1,
                            2,
                            2,
                            3,
                            3
                        ][numChars];
                        if (label === "widehat" || label === "widecheck") {
                            viewBoxWidth = [
                                0,
                                1062,
                                2364,
                                2364,
                                2364
                            ][imgIndex];
                            viewBoxHeight = [
                                0,
                                239,
                                300,
                                360,
                                420
                            ][imgIndex];
                            height = [
                                0,
                                0.24,
                                0.3,
                                0.3,
                                0.36,
                                0.42
                            ][imgIndex];
                            pathName = label + imgIndex;
                        } else {
                            viewBoxWidth = [
                                0,
                                600,
                                1033,
                                2339,
                                2340
                            ][imgIndex];
                            viewBoxHeight = [
                                0,
                                260,
                                286,
                                306,
                                312
                            ][imgIndex];
                            height = [
                                0,
                                0.26,
                                0.286,
                                0.3,
                                0.306,
                                0.34
                            ][imgIndex];
                            pathName = "tilde" + imgIndex;
                        }
                    }
                    const path = new PathNode(pathName);
                    const svgNode = new SvgNode([
                        path
                    ], {
                        "width": "100%",
                        "height": makeEm(height),
                        "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight,
                        "preserveAspectRatio": "none"
                    });
                    return {
                        span: buildCommon.makeSvgSpan([], [
                            svgNode
                        ], options),
                        minWidth: 0,
                        height: height
                    };
                } else {
                    const spans = [];
                    const data = katexImagesData[label];
                    const [paths, minWidth, viewBoxHeight] = data;
                    const height = viewBoxHeight / 1000;
                    const numSvgChildren = paths.length;
                    let widthClasses;
                    let aligns;
                    if (numSvgChildren === 1) {
                        // $FlowFixMe: All these cases must be of the 4-tuple type.
                        const align1 = data[3];
                        widthClasses = [
                            "hide-tail"
                        ];
                        aligns = [
                            align1
                        ];
                    } else if (numSvgChildren === 2) {
                        widthClasses = [
                            "halfarrow-left",
                            "halfarrow-right"
                        ];
                        aligns = [
                            "xMinYMin",
                            "xMaxYMin"
                        ];
                    } else if (numSvgChildren === 3) {
                        widthClasses = [
                            "brace-left",
                            "brace-center",
                            "brace-right"
                        ];
                        aligns = [
                            "xMinYMin",
                            "xMidYMin",
                            "xMaxYMin"
                        ];
                    } else throw new Error("Correct katexImagesData or update code here to support\n                    " + numSvgChildren + " children.");
                    for(let i = 0; i < numSvgChildren; i++){
                        const path = new PathNode(paths[i]);
                        const svgNode = new SvgNode([
                            path
                        ], {
                            "width": "400em",
                            "height": makeEm(height),
                            "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight,
                            "preserveAspectRatio": aligns[i] + " slice"
                        });
                        const span = buildCommon.makeSvgSpan([
                            widthClasses[i]
                        ], [
                            svgNode
                        ], options);
                        if (numSvgChildren === 1) return {
                            span: span,
                            minWidth: minWidth,
                            height: height
                        };
                        else {
                            span.style.height = makeEm(height);
                            spans.push(span);
                        }
                    }
                    return {
                        span: buildCommon.makeSpan([
                            "stretchy"
                        ], spans, options),
                        minWidth: minWidth,
                        height: height
                    };
                }
            } // buildSvgSpan_()
            const { span: span, minWidth: minWidth, height: height } = buildSvgSpan_(); // Note that we are returning span.depth = 0.
            // Any adjustments relative to the baseline must be done in buildHTML.
            span.height = height;
            span.style.height = makeEm(height);
            if (minWidth > 0) span.style.minWidth = makeEm(minWidth);
            return span;
        };
        const encloseSpan = function(inner, label, topPad, bottomPad, options) {
            // Return an image span for \cancel, \bcancel, \xcancel, \fbox, or \angl
            let img;
            const totalHeight = inner.height + inner.depth + topPad + bottomPad;
            if (/fbox|color|angl/.test(label)) {
                img = buildCommon.makeSpan([
                    "stretchy",
                    label
                ], [], options);
                if (label === "fbox") {
                    const color = options.color && options.getColor();
                    if (color) img.style.borderColor = color;
                }
            } else {
                // \cancel, \bcancel, or \xcancel
                // Since \cancel's SVG is inline and it omits the viewBox attribute,
                // its stroke-width will not vary with span area.
                const lines = [];
                if (/^[bx]cancel$/.test(label)) lines.push(new LineNode({
                    "x1": "0",
                    "y1": "0",
                    "x2": "100%",
                    "y2": "100%",
                    "stroke-width": "0.046em"
                }));
                if (/^x?cancel$/.test(label)) lines.push(new LineNode({
                    "x1": "0",
                    "y1": "100%",
                    "x2": "100%",
                    "y2": "0",
                    "stroke-width": "0.046em"
                }));
                const svgNode = new SvgNode(lines, {
                    "width": "100%",
                    "height": makeEm(totalHeight)
                });
                img = buildCommon.makeSvgSpan([], [
                    svgNode
                ], options);
            }
            img.height = totalHeight;
            img.style.height = makeEm(totalHeight);
            return img;
        };
        /* harmony default export */ var stretchy = {
            encloseSpan: encloseSpan,
            mathMLnode: mathMLnode,
            svgSpan: svgSpan
        };
        /**
 * Asserts that the node is of the given type and returns it with stricter
 * typing. Throws if the node's type does not match.
 */ function assertNodeType(node, type) {
            if (!node || node.type !== type) throw new Error("Expected node of type " + type + ", but got " + (node ? "node of type " + node.type : String(node)));
             // $FlowFixMe, >=0.125
            return node;
        }
        /**
 * Returns the node more strictly typed iff it is of the given type. Otherwise,
 * returns null.
 */ function assertSymbolNodeType(node) {
            const typedNode = checkSymbolNodeType(node);
            if (!typedNode) throw new Error("Expected node of symbol group type, but got " + (node ? "node of type " + node.type : String(node)));
            return typedNode;
        }
        /**
 * Returns the node more strictly typed iff it is of the given type. Otherwise,
 * returns null.
 */ function checkSymbolNodeType(node) {
            if (node && (node.type === "atom" || NON_ATOMS.hasOwnProperty(node.type))) // $FlowFixMe
            return node;
            return null;
        }
        // NOTE: Unlike most `htmlBuilder`s, this one handles not only "accent", but
        // also "supsub" since an accent can affect super/subscripting.
        const htmlBuilder = (grp, options)=>{
            // Accents are handled in the TeXbook pg. 443, rule 12.
            let base;
            let group;
            let supSubGroup;
            if (grp && grp.type === "supsub") {
                // If our base is a character box, and we have superscripts and
                // subscripts, the supsub will defer to us. In particular, we want
                // to attach the superscripts and subscripts to the inner body (so
                // that the position of the superscripts and subscripts won't be
                // affected by the height of the accent). We accomplish this by
                // sticking the base of the accent into the base of the supsub, and
                // rendering that, while keeping track of where the accent is.
                // The real accent group is the base of the supsub group
                group = assertNodeType(grp.base, "accent"); // The character box is the base of the accent group
                base = group.base; // Stick the character box into the base of the supsub group
                grp.base = base; // Rerender the supsub group with its new base, and store that
                // result.
                supSubGroup = assertSpan(buildGroup(grp, options)); // reset original base
                grp.base = group;
            } else {
                group = assertNodeType(grp, "accent");
                base = group.base;
            } // Build the base group
            const body = buildGroup(base, options.havingCrampedStyle()); // Does the accent need to shift for the skew of a character?
            const mustShift = group.isShifty && utils.isCharacterBox(base); // Calculate the skew of the accent. This is based on the line "If the
            // nucleus is not a single character, let s = 0; otherwise set s to the
            // kern amount for the nucleus followed by the \skewchar of its font."
            // Note that our skew metrics are just the kern between each character
            // and the skewchar.
            let skew = 0;
            if (mustShift) {
                // If the base is a character box, then we want the skew of the
                // innermost character. To do that, we find the innermost character:
                const baseChar = utils.getBaseElem(base); // Then, we render its group to get the symbol inside it
                const baseGroup = buildGroup(baseChar, options.havingCrampedStyle()); // Finally, we pull the skew off of the symbol.
                skew = assertSymbolDomNode(baseGroup).skew; // Note that we now throw away baseGroup, because the layers we
            // removed with getBaseElem might contain things like \color which
            // we can't get rid of.
            // TODO(emily): Find a better way to get the skew
            }
            const accentBelow = group.label === "\\c"; // calculate the amount of space between the body and the accent
            let clearance = accentBelow ? body.height + body.depth : Math.min(body.height, options.fontMetrics().xHeight); // Build the accent
            let accentBody;
            if (!group.isStretchy) {
                let accent;
                let width;
                if (group.label === "\\vec") {
                    // Before version 0.9, \vec used the combining font glyph U+20D7.
                    // But browsers, especially Safari, are not consistent in how they
                    // render combining characters when not preceded by a character.
                    // So now we use an SVG.
                    // If Safari reforms, we should consider reverting to the glyph.
                    accent = buildCommon.staticSvg("vec", options);
                    width = buildCommon.svgData.vec[1];
                } else {
                    accent = buildCommon.makeOrd({
                        mode: group.mode,
                        text: group.label
                    }, options, "textord");
                    accent = assertSymbolDomNode(accent); // Remove the italic correction of the accent, because it only serves to
                    // shift the accent over to a place we don't want.
                    accent.italic = 0;
                    width = accent.width;
                    if (accentBelow) clearance += accent.depth;
                }
                accentBody = buildCommon.makeSpan([
                    "accent-body"
                ], [
                    accent
                ]); // "Full" accents expand the width of the resulting symbol to be
                // at least the width of the accent, and overlap directly onto the
                // character without any vertical offset.
                const accentFull = group.label === "\\textcircled";
                if (accentFull) {
                    accentBody.classes.push('accent-full');
                    clearance = body.height;
                } // Shift the accent over by the skew.
                let left = skew; // CSS defines `.katex .accent .accent-body:not(.accent-full) { width: 0 }`
                // so that the accent doesn't contribute to the bounding box.
                // We need to shift the character by its width (effectively half
                // its width) to compensate.
                if (!accentFull) left -= width / 2;
                accentBody.style.left = makeEm(left); // \textcircled uses the \bigcirc glyph, so it needs some
                // vertical adjustment to match LaTeX.
                if (group.label === "\\textcircled") accentBody.style.top = ".2em";
                accentBody = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: body
                        },
                        {
                            type: "kern",
                            size: -clearance
                        },
                        {
                            type: "elem",
                            elem: accentBody
                        }
                    ]
                }, options);
            } else {
                accentBody = stretchy.svgSpan(group, options);
                accentBody = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: body
                        },
                        {
                            type: "elem",
                            elem: accentBody,
                            wrapperClasses: [
                                "svg-align"
                            ],
                            wrapperStyle: skew > 0 ? {
                                width: "calc(100% - " + makeEm(2 * skew) + ")",
                                marginLeft: makeEm(2 * skew)
                            } : undefined
                        }
                    ]
                }, options);
            }
            const accentWrap = buildCommon.makeSpan([
                "mord",
                "accent"
            ], [
                accentBody
            ], options);
            if (supSubGroup) {
                // Here, we replace the "base" child of the supsub with our newly
                // generated accent.
                supSubGroup.children[0] = accentWrap; // Since we don't rerun the height calculation after replacing the
                // accent, we manually recalculate height.
                supSubGroup.height = Math.max(accentWrap.height, supSubGroup.height); // Accents should always be ords, even when their innards are not.
                supSubGroup.classes[0] = "mord";
                return supSubGroup;
            } else return accentWrap;
        };
        const mathmlBuilder = (group, options)=>{
            const accentNode = group.isStretchy ? stretchy.mathMLnode(group.label) : new mathMLTree.MathNode("mo", [
                makeText(group.label, group.mode)
            ]);
            const node = new mathMLTree.MathNode("mover", [
                buildMathML_buildGroup(group.base, options),
                accentNode
            ]);
            node.setAttribute("accent", "true");
            return node;
        };
        const NON_STRETCHY_ACCENT_REGEX = new RegExp([
            "\\acute",
            "\\grave",
            "\\ddot",
            "\\tilde",
            "\\bar",
            "\\breve",
            "\\check",
            "\\hat",
            "\\vec",
            "\\dot",
            "\\mathring"
        ].map((accent)=>"\\" + accent).join("|")); // Accents
        defineFunction({
            type: "accent",
            names: [
                "\\acute",
                "\\grave",
                "\\ddot",
                "\\tilde",
                "\\bar",
                "\\breve",
                "\\check",
                "\\hat",
                "\\vec",
                "\\dot",
                "\\mathring",
                "\\widecheck",
                "\\widehat",
                "\\widetilde",
                "\\overrightarrow",
                "\\overleftarrow",
                "\\Overrightarrow",
                "\\overleftrightarrow",
                "\\overgroup",
                "\\overlinesegment",
                "\\overleftharpoon",
                "\\overrightharpoon"
            ],
            props: {
                numArgs: 1
            },
            handler: (context, args)=>{
                const base = normalizeArgument(args[0]);
                const isStretchy = !NON_STRETCHY_ACCENT_REGEX.test(context.funcName);
                const isShifty = !isStretchy || context.funcName === "\\widehat" || context.funcName === "\\widetilde" || context.funcName === "\\widecheck";
                return {
                    type: "accent",
                    mode: context.parser.mode,
                    label: context.funcName,
                    isStretchy: isStretchy,
                    isShifty: isShifty,
                    base: base
                };
            },
            htmlBuilder: htmlBuilder,
            mathmlBuilder: mathmlBuilder
        }); // Text-mode accents
        defineFunction({
            type: "accent",
            names: [
                "\\'",
                "\\`",
                "\\^",
                "\\~",
                "\\=",
                "\\u",
                "\\.",
                '\\"',
                "\\c",
                "\\r",
                "\\H",
                "\\v",
                "\\textcircled"
            ],
            props: {
                numArgs: 1,
                allowedInText: true,
                allowedInMath: true,
                // unless in strict mode
                argTypes: [
                    "primitive"
                ]
            },
            handler: (context, args)=>{
                const base = args[0];
                let mode = context.parser.mode;
                if (mode === "math") {
                    context.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + context.funcName + " works only in text mode");
                    mode = "text";
                }
                return {
                    type: "accent",
                    mode: mode,
                    label: context.funcName,
                    isStretchy: false,
                    isShifty: true,
                    base: base
                };
            },
            htmlBuilder: htmlBuilder,
            mathmlBuilder: mathmlBuilder
        });
        // Horizontal overlap functions
        defineFunction({
            type: "accentUnder",
            names: [
                "\\underleftarrow",
                "\\underrightarrow",
                "\\underleftrightarrow",
                "\\undergroup",
                "\\underlinesegment",
                "\\utilde"
            ],
            props: {
                numArgs: 1
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName } = _ref;
                const base = args[0];
                return {
                    type: "accentUnder",
                    mode: parser.mode,
                    label: funcName,
                    base: base
                };
            },
            htmlBuilder: (group, options)=>{
                // Treat under accents much like underlines.
                const innerGroup = buildGroup(group.base, options);
                const accentBody = stretchy.svgSpan(group, options);
                const kern = group.label === "\\utilde" ? 0.12 : 0; // Generate the vlist, with the appropriate kerns
                const vlist = buildCommon.makeVList({
                    positionType: "top",
                    positionData: innerGroup.height,
                    children: [
                        {
                            type: "elem",
                            elem: accentBody,
                            wrapperClasses: [
                                "svg-align"
                            ]
                        },
                        {
                            type: "kern",
                            size: kern
                        },
                        {
                            type: "elem",
                            elem: innerGroup
                        }
                    ]
                }, options);
                return buildCommon.makeSpan([
                    "mord",
                    "accentunder"
                ], [
                    vlist
                ], options);
            },
            mathmlBuilder: (group, options)=>{
                const accentNode = stretchy.mathMLnode(group.label);
                const node = new mathMLTree.MathNode("munder", [
                    buildMathML_buildGroup(group.base, options),
                    accentNode
                ]);
                node.setAttribute("accentunder", "true");
                return node;
            }
        });
        // Helper function
        const paddedNode = (group)=>{
            const node = new mathMLTree.MathNode("mpadded", group ? [
                group
            ] : []);
            node.setAttribute("width", "+0.6em");
            node.setAttribute("lspace", "0.3em");
            return node;
        }; // Stretchy arrows with an optional argument
        defineFunction({
            type: "xArrow",
            names: [
                "\\xleftarrow",
                "\\xrightarrow",
                "\\xLeftarrow",
                "\\xRightarrow",
                "\\xleftrightarrow",
                "\\xLeftrightarrow",
                "\\xhookleftarrow",
                "\\xhookrightarrow",
                "\\xmapsto",
                "\\xrightharpoondown",
                "\\xrightharpoonup",
                "\\xleftharpoondown",
                "\\xleftharpoonup",
                "\\xrightleftharpoons",
                "\\xleftrightharpoons",
                "\\xlongequal",
                "\\xtwoheadrightarrow",
                "\\xtwoheadleftarrow",
                "\\xtofrom",
                // Direct use of these functions is discouraged and may break someday.
                "\\xrightleftarrows",
                "\\xrightequilibrium",
                "\\xleftequilibrium",
                "\\\\cdrightarrow",
                "\\\\cdleftarrow",
                "\\\\cdlongequal"
            ],
            props: {
                numArgs: 1,
                numOptionalArgs: 1
            },
            handler (_ref, args, optArgs) {
                let { parser: parser, funcName: funcName } = _ref;
                return {
                    type: "xArrow",
                    mode: parser.mode,
                    label: funcName,
                    body: args[0],
                    below: optArgs[0]
                };
            },
            // Flow is unable to correctly infer the type of `group`, even though it's
            // unambiguously determined from the passed-in `type` above.
            htmlBuilder (group, options) {
                const style = options.style; // Build the argument groups in the appropriate style.
                // Ref: amsmath.dtx:   \hbox{$\scriptstyle\mkern#3mu{#6}\mkern#4mu$}%
                // Some groups can return document fragments.  Handle those by wrapping
                // them in a span.
                let newOptions = options.havingStyle(style.sup());
                const upperGroup = buildCommon.wrapFragment(buildGroup(group.body, newOptions, options), options);
                const arrowPrefix = group.label.slice(0, 2) === "\\x" ? "x" : "cd";
                upperGroup.classes.push(arrowPrefix + "-arrow-pad");
                let lowerGroup;
                if (group.below) {
                    // Build the lower group
                    newOptions = options.havingStyle(style.sub());
                    lowerGroup = buildCommon.wrapFragment(buildGroup(group.below, newOptions, options), options);
                    lowerGroup.classes.push(arrowPrefix + "-arrow-pad");
                }
                const arrowBody = stretchy.svgSpan(group, options); // Re shift: Note that stretchy.svgSpan returned arrowBody.depth = 0.
                // The point we want on the math axis is at 0.5 * arrowBody.height.
                const arrowShift = -options.fontMetrics().axisHeight + 0.5 * arrowBody.height; // 2 mu kern. Ref: amsmath.dtx: #7\if0#2\else\mkern#2mu\fi
                let upperShift = -options.fontMetrics().axisHeight - 0.5 * arrowBody.height - 0.111; // 0.111 em = 2 mu
                if (upperGroup.depth > 0.25 || group.label === "\\xleftequilibrium") upperShift -= upperGroup.depth; // shift up if depth encroaches
                 // Generate the vlist
                let vlist;
                if (lowerGroup) {
                    const lowerShift = -options.fontMetrics().axisHeight + lowerGroup.height + 0.5 * arrowBody.height + 0.111;
                    vlist = buildCommon.makeVList({
                        positionType: "individualShift",
                        children: [
                            {
                                type: "elem",
                                elem: upperGroup,
                                shift: upperShift
                            },
                            {
                                type: "elem",
                                elem: arrowBody,
                                shift: arrowShift
                            },
                            {
                                type: "elem",
                                elem: lowerGroup,
                                shift: lowerShift
                            }
                        ]
                    }, options);
                } else vlist = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: [
                        {
                            type: "elem",
                            elem: upperGroup,
                            shift: upperShift
                        },
                        {
                            type: "elem",
                            elem: arrowBody,
                            shift: arrowShift
                        }
                    ]
                }, options);
                 // $FlowFixMe: Replace this with passing "svg-align" into makeVList.
                vlist.children[0].children[0].children[1].classes.push("svg-align");
                return buildCommon.makeSpan([
                    "mrel",
                    "x-arrow"
                ], [
                    vlist
                ], options);
            },
            mathmlBuilder (group, options) {
                const arrowNode = stretchy.mathMLnode(group.label);
                arrowNode.setAttribute("minsize", group.label.charAt(0) === "x" ? "1.75em" : "3.0em");
                let node;
                if (group.body) {
                    const upperNode = paddedNode(buildMathML_buildGroup(group.body, options));
                    if (group.below) {
                        const lowerNode = paddedNode(buildMathML_buildGroup(group.below, options));
                        node = new mathMLTree.MathNode("munderover", [
                            arrowNode,
                            lowerNode,
                            upperNode
                        ]);
                    } else node = new mathMLTree.MathNode("mover", [
                        arrowNode,
                        upperNode
                    ]);
                } else if (group.below) {
                    const lowerNode = paddedNode(buildMathML_buildGroup(group.below, options));
                    node = new mathMLTree.MathNode("munder", [
                        arrowNode,
                        lowerNode
                    ]);
                } else {
                    // This should never happen.
                    // Parser.js throws an error if there is no argument.
                    node = paddedNode();
                    node = new mathMLTree.MathNode("mover", [
                        arrowNode,
                        node
                    ]);
                }
                return node;
            }
        });
        const mclass_makeSpan = buildCommon.makeSpan;
        function mclass_htmlBuilder(group, options) {
            const elements = buildExpression(group.body, options, true);
            return mclass_makeSpan([
                group.mclass
            ], elements, options);
        }
        function mclass_mathmlBuilder(group, options) {
            let node;
            const inner = buildMathML_buildExpression(group.body, options);
            if (group.mclass === "minner") node = new mathMLTree.MathNode("mpadded", inner);
            else if (group.mclass === "mord") {
                if (group.isCharacterBox) {
                    node = inner[0];
                    node.type = "mi";
                } else node = new mathMLTree.MathNode("mi", inner);
            } else {
                if (group.isCharacterBox) {
                    node = inner[0];
                    node.type = "mo";
                } else node = new mathMLTree.MathNode("mo", inner);
                 // Set spacing based on what is the most likely adjacent atom type.
                // See TeXbook p170.
                if (group.mclass === "mbin") {
                    node.attributes.lspace = "0.22em"; // medium space
                    node.attributes.rspace = "0.22em";
                } else if (group.mclass === "mpunct") {
                    node.attributes.lspace = "0em";
                    node.attributes.rspace = "0.17em"; // thinspace
                } else if (group.mclass === "mopen" || group.mclass === "mclose") {
                    node.attributes.lspace = "0em";
                    node.attributes.rspace = "0em";
                } else if (group.mclass === "minner") {
                    node.attributes.lspace = "0.0556em"; // 1 mu is the most likely option
                    node.attributes.width = "+0.1111em";
                } // MathML <mo> default space is 5/18 em, so <mrel> needs no action.
            // Ref: https://developer.mozilla.org/en-US/docs/Web/MathML/Element/mo
            }
            return node;
        } // Math class commands except \mathop
        defineFunction({
            type: "mclass",
            names: [
                "\\mathord",
                "\\mathbin",
                "\\mathrel",
                "\\mathopen",
                "\\mathclose",
                "\\mathpunct",
                "\\mathinner"
            ],
            props: {
                numArgs: 1,
                primitive: true
            },
            handler (_ref, args) {
                let { parser: parser, funcName: funcName } = _ref;
                const body = args[0];
                return {
                    type: "mclass",
                    mode: parser.mode,
                    mclass: "m" + funcName.slice(5),
                    // TODO(kevinb): don't prefix with 'm'
                    body: ordargument(body),
                    isCharacterBox: utils.isCharacterBox(body)
                };
            },
            htmlBuilder: mclass_htmlBuilder,
            mathmlBuilder: mclass_mathmlBuilder
        });
        const binrelClass = (arg)=>{
            // \binrel@ spacing varies with (bin|rel|ord) of the atom in the argument.
            // (by rendering separately and with {}s before and after, and measuring
            // the change in spacing).  We'll do roughly the same by detecting the
            // atom type directly.
            const atom = arg.type === "ordgroup" && arg.body.length ? arg.body[0] : arg;
            if (atom.type === "atom" && (atom.family === "bin" || atom.family === "rel")) return "m" + atom.family;
            else return "mord";
        }; // \@binrel{x}{y} renders like y but as mbin/mrel/mord if x is mbin/mrel/mord.
        // This is equivalent to \binrel@{x}\binrel@@{y} in AMSTeX.
        defineFunction({
            type: "mclass",
            names: [
                "\\@binrel"
            ],
            props: {
                numArgs: 2
            },
            handler (_ref2, args) {
                let { parser: parser } = _ref2;
                return {
                    type: "mclass",
                    mode: parser.mode,
                    mclass: binrelClass(args[0]),
                    body: ordargument(args[1]),
                    isCharacterBox: utils.isCharacterBox(args[1])
                };
            }
        }); // Build a relation or stacked op by placing one symbol on top of another
        defineFunction({
            type: "mclass",
            names: [
                "\\stackrel",
                "\\overset",
                "\\underset"
            ],
            props: {
                numArgs: 2
            },
            handler (_ref3, args) {
                let { parser: parser, funcName: funcName } = _ref3;
                const baseArg = args[1];
                const shiftedArg = args[0];
                let mclass;
                if (funcName !== "\\stackrel") // LaTeX applies \binrel spacing to \overset and \underset.
                mclass = binrelClass(baseArg);
                else mclass = "mrel"; // for \stackrel
                const baseOp = {
                    type: "op",
                    mode: baseArg.mode,
                    limits: true,
                    alwaysHandleSupSub: true,
                    parentIsSupSub: false,
                    symbol: false,
                    suppressBaseShift: funcName !== "\\stackrel",
                    body: ordargument(baseArg)
                };
                const supsub = {
                    type: "supsub",
                    mode: shiftedArg.mode,
                    base: baseOp,
                    sup: funcName === "\\underset" ? null : shiftedArg,
                    sub: funcName === "\\underset" ? shiftedArg : null
                };
                return {
                    type: "mclass",
                    mode: parser.mode,
                    mclass: mclass,
                    body: [
                        supsub
                    ],
                    isCharacterBox: utils.isCharacterBox(supsub)
                };
            },
            htmlBuilder: mclass_htmlBuilder,
            mathmlBuilder: mclass_mathmlBuilder
        });
        // \pmb is a simulation of bold font.
        // The version of \pmb in ambsy.sty works by typesetting three copies
        // with small offsets. We use CSS text-shadow.
        // It's a hack. Not as good as a real bold font. Better than nothing.
        defineFunction({
            type: "pmb",
            names: [
                "\\pmb"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                return {
                    type: "pmb",
                    mode: parser.mode,
                    mclass: binrelClass(args[0]),
                    body: ordargument(args[0])
                };
            },
            htmlBuilder (group, options) {
                const elements = buildExpression(group.body, options, true);
                const node = buildCommon.makeSpan([
                    group.mclass
                ], elements, options);
                node.style.textShadow = "0.02em 0.01em 0.04px";
                return node;
            },
            mathmlBuilder (group, style) {
                const inner = buildMathML_buildExpression(group.body, style); // Wrap with an <mstyle> element.
                const node = new mathMLTree.MathNode("mstyle", inner);
                node.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px");
                return node;
            }
        });
        const cdArrowFunctionName = {
            ">": "\\\\cdrightarrow",
            "<": "\\\\cdleftarrow",
            "=": "\\\\cdlongequal",
            "A": "\\uparrow",
            "V": "\\downarrow",
            "|": "\\Vert",
            ".": "no arrow"
        };
        const newCell = ()=>{
            // Create an empty cell, to be filled below with parse nodes.
            // The parseTree from this module must be constructed like the
            // one created by parseArray(), so an empty CD cell must
            // be a ParseNode<"styling">. And CD is always displaystyle.
            // So these values are fixed and flow can do implicit typing.
            return {
                type: "styling",
                body: [],
                mode: "math",
                style: "display"
            };
        };
        const isStartOfArrow = (node)=>{
            return node.type === "textord" && node.text === "@";
        };
        const isLabelEnd = (node, endChar)=>{
            return (node.type === "mathord" || node.type === "atom") && node.text === endChar;
        };
        function cdArrow(arrowChar, labels, parser) {
            // Return a parse tree of an arrow and its labels.
            // This acts in a way similar to a macro expansion.
            const funcName = cdArrowFunctionName[arrowChar];
            switch(funcName){
                case "\\\\cdrightarrow":
                case "\\\\cdleftarrow":
                    return parser.callFunction(funcName, [
                        labels[0]
                    ], [
                        labels[1]
                    ]);
                case "\\uparrow":
                case "\\downarrow":
                    {
                        const leftLabel = parser.callFunction("\\\\cdleft", [
                            labels[0]
                        ], []);
                        const bareArrow = {
                            type: "atom",
                            text: funcName,
                            mode: "math",
                            family: "rel"
                        };
                        const sizedArrow = parser.callFunction("\\Big", [
                            bareArrow
                        ], []);
                        const rightLabel = parser.callFunction("\\\\cdright", [
                            labels[1]
                        ], []);
                        const arrowGroup = {
                            type: "ordgroup",
                            mode: "math",
                            body: [
                                leftLabel,
                                sizedArrow,
                                rightLabel
                            ]
                        };
                        return parser.callFunction("\\\\cdparent", [
                            arrowGroup
                        ], []);
                    }
                case "\\\\cdlongequal":
                    return parser.callFunction("\\\\cdlongequal", [], []);
                case "\\Vert":
                    {
                        const arrow = {
                            type: "textord",
                            text: "\\Vert",
                            mode: "math"
                        };
                        return parser.callFunction("\\Big", [
                            arrow
                        ], []);
                    }
                default:
                    return {
                        type: "textord",
                        text: " ",
                        mode: "math"
                    };
            }
        }
        function parseCD(parser) {
            // Get the array's parse nodes with \\ temporarily mapped to \cr.
            const parsedRows = [];
            parser.gullet.beginGroup();
            parser.gullet.macros.set("\\cr", "\\\\\\relax");
            parser.gullet.beginGroup();
            while(true){
                // eslint-disable-line no-constant-condition
                // Get the parse nodes for the next row.
                parsedRows.push(parser.parseExpression(false, "\\\\"));
                parser.gullet.endGroup();
                parser.gullet.beginGroup();
                const next = parser.fetch().text;
                if (next === "&" || next === "\\\\") parser.consume();
                else if (next === "\\end") {
                    if (parsedRows[parsedRows.length - 1].length === 0) parsedRows.pop(); // final row ended in \\
                    break;
                } else throw new src_ParseError("Expected \\\\ or \\cr or \\end", parser.nextToken);
            }
            let row = [];
            const body = [
                row
            ]; // Loop thru the parse nodes. Collect them into cells and arrows.
            for(let i = 0; i < parsedRows.length; i++){
                // Start a new row.
                const rowNodes = parsedRows[i]; // Create the first cell.
                let cell = newCell();
                for(let j = 0; j < rowNodes.length; j++)if (!isStartOfArrow(rowNodes[j])) // If a parseNode is not an arrow, it goes into a cell.
                cell.body.push(rowNodes[j]);
                else {
                    // Parse node j is an "@", the start of an arrow.
                    // Before starting on the arrow, push the cell into `row`.
                    row.push(cell); // Now collect parseNodes into an arrow.
                    // The character after "@" defines the arrow type.
                    j += 1;
                    const arrowChar = assertSymbolNodeType(rowNodes[j]).text; // Create two empty label nodes. We may or may not use them.
                    const labels = new Array(2);
                    labels[0] = {
                        type: "ordgroup",
                        mode: "math",
                        body: []
                    };
                    labels[1] = {
                        type: "ordgroup",
                        mode: "math",
                        body: []
                    }; // Process the arrow.
                    if ("=|.".indexOf(arrowChar) > -1) ;
                    else if ("<>AV".indexOf(arrowChar) > -1) // Four arrows, `@>>>`, `@<<<`, `@AAA`, and `@VVV`, each take
                    // two optional labels. E.g. the right-point arrow syntax is
                    // really:  @>{optional label}>{optional label}>
                    // Collect parseNodes into labels.
                    for(let labelNum = 0; labelNum < 2; labelNum++){
                        let inLabel = true;
                        for(let k = j + 1; k < rowNodes.length; k++){
                            if (isLabelEnd(rowNodes[k], arrowChar)) {
                                inLabel = false;
                                j = k;
                                break;
                            }
                            if (isStartOfArrow(rowNodes[k])) throw new src_ParseError("Missing a " + arrowChar + " character to complete a CD arrow.", rowNodes[k]);
                            labels[labelNum].body.push(rowNodes[k]);
                        }
                        if (inLabel) // isLabelEnd never returned a true.
                        throw new src_ParseError("Missing a " + arrowChar + " character to complete a CD arrow.", rowNodes[j]);
                    }
                    else throw new src_ParseError("Expected one of \"<>AV=|.\" after @", rowNodes[j]);
                     // Now join the arrow to its labels.
                    const arrow = cdArrow(arrowChar, labels, parser); // Wrap the arrow in  ParseNode<"styling">.
                    // This is done to match parseArray() behavior.
                    const wrappedArrow = {
                        type: "styling",
                        body: [
                            arrow
                        ],
                        mode: "math",
                        style: "display" // CD is always displaystyle.
                    };
                    row.push(wrappedArrow); // In CD's syntax, cells are implicit. That is, everything that
                    // is not an arrow gets collected into a cell. So create an empty
                    // cell now. It will collect upcoming parseNodes.
                    cell = newCell();
                }
                if (i % 2 === 0) // Even-numbered rows consist of: cell, arrow, cell, arrow, ... cell
                // The last cell is not yet pushed into `row`, so:
                row.push(cell);
                else // Odd-numbered rows consist of: vert arrow, empty cell, ... vert arrow
                // Remove the empty cell that was placed at the beginning of `row`.
                row.shift();
                row = [];
                body.push(row);
            } // End row group
            parser.gullet.endGroup(); // End array group defining \\
            parser.gullet.endGroup(); // define column separation.
            const cols = new Array(body[0].length).fill({
                type: "align",
                align: "c",
                pregap: 0.25,
                // CD package sets \enskip between columns.
                postgap: 0.25 // So pre and post each get half an \enskip, i.e. 0.25em.
            });
            return {
                type: "array",
                mode: "math",
                body: body,
                arraystretch: 1,
                addJot: true,
                rowGaps: [
                    null
                ],
                cols: cols,
                colSeparationType: "CD",
                hLinesBeforeRow: new Array(body.length + 1).fill([])
            };
        } // The functions below are not available for general use.
        // They are here only for internal use by the {CD} environment in placing labels
        // next to vertical arrows.
        // We don't need any such functions for horizontal arrows because we can reuse
        // the functionality that already exists for extensible arrows.
        defineFunction({
            type: "cdlabel",
            names: [
                "\\\\cdleft",
                "\\\\cdright"
            ],
            props: {
                numArgs: 1
            },
            handler (_ref, args) {
                let { parser: parser, funcName: funcName } = _ref;
                return {
                    type: "cdlabel",
                    mode: parser.mode,
                    side: funcName.slice(4),
                    label: args[0]
                };
            },
            htmlBuilder (group, options) {
                const newOptions = options.havingStyle(options.style.sup());
                const label = buildCommon.wrapFragment(buildGroup(group.label, newOptions, options), options);
                label.classes.push("cd-label-" + group.side);
                label.style.bottom = makeEm(0.8 - label.depth); // Zero out label height & depth, so vertical align of arrow is set
                // by the arrow height, not by the label.
                label.height = 0;
                label.depth = 0;
                return label;
            },
            mathmlBuilder (group, options) {
                let label = new mathMLTree.MathNode("mrow", [
                    buildMathML_buildGroup(group.label, options)
                ]);
                label = new mathMLTree.MathNode("mpadded", [
                    label
                ]);
                label.setAttribute("width", "0");
                if (group.side === "left") label.setAttribute("lspace", "-1width");
                 // We have to guess at vertical alignment. We know the arrow is 1.8em tall,
                // But we don't know the height or depth of the label.
                label.setAttribute("voffset", "0.7em");
                label = new mathMLTree.MathNode("mstyle", [
                    label
                ]);
                label.setAttribute("displaystyle", "false");
                label.setAttribute("scriptlevel", "1");
                return label;
            }
        });
        defineFunction({
            type: "cdlabelparent",
            names: [
                "\\\\cdparent"
            ],
            props: {
                numArgs: 1
            },
            handler (_ref2, args) {
                let { parser: parser } = _ref2;
                return {
                    type: "cdlabelparent",
                    mode: parser.mode,
                    fragment: args[0]
                };
            },
            htmlBuilder (group, options) {
                // Wrap the vertical arrow and its labels.
                // The parent gets position: relative. The child gets position: absolute.
                // So CSS can locate the label correctly.
                const parent = buildCommon.wrapFragment(buildGroup(group.fragment, options), options);
                parent.classes.push("cd-vert-arrow");
                return parent;
            },
            mathmlBuilder (group, options) {
                return new mathMLTree.MathNode("mrow", [
                    buildMathML_buildGroup(group.fragment, options)
                ]);
            }
        });
        // \@char is an internal function that takes a grouped decimal argument like
        // {123} and converts into symbol with code 123.  It is used by the *macro*
        // \char defined in macros.js.
        defineFunction({
            type: "textord",
            names: [
                "\\@char"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                const arg = assertNodeType(args[0], "ordgroup");
                const group = arg.body;
                let number = "";
                for(let i = 0; i < group.length; i++){
                    const node = assertNodeType(group[i], "textord");
                    number += node.text;
                }
                let code = parseInt(number);
                let text;
                if (isNaN(code)) throw new src_ParseError("\\@char has non-numeric argument " + number); // If we drop IE support, the following code could be replaced with
                else if (code < 0 || code >= 0x10ffff) throw new src_ParseError("\\@char with invalid code point " + number);
                else if (code <= 0xffff) text = String.fromCharCode(code);
                else {
                    // Astral code point; split into surrogate halves
                    code -= 0x10000;
                    text = String.fromCharCode((code >> 10) + 0xd800, (code & 0x3ff) + 0xdc00);
                }
                return {
                    type: "textord",
                    mode: parser.mode,
                    text: text
                };
            }
        });
        const color_htmlBuilder = (group, options)=>{
            const elements = buildExpression(group.body, options.withColor(group.color), false); // \color isn't supposed to affect the type of the elements it contains.
            // To accomplish this, we wrap the results in a fragment, so the inner
            // elements will be able to directly interact with their neighbors. For
            // example, `\color{red}{2 +} 3` has the same spacing as `2 + 3`
            return buildCommon.makeFragment(elements);
        };
        const color_mathmlBuilder = (group, options)=>{
            const inner = buildMathML_buildExpression(group.body, options.withColor(group.color));
            const node = new mathMLTree.MathNode("mstyle", inner);
            node.setAttribute("mathcolor", group.color);
            return node;
        };
        defineFunction({
            type: "color",
            names: [
                "\\textcolor"
            ],
            props: {
                numArgs: 2,
                allowedInText: true,
                argTypes: [
                    "color",
                    "original"
                ]
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                const color = assertNodeType(args[0], "color-token").color;
                const body = args[1];
                return {
                    type: "color",
                    mode: parser.mode,
                    color: color,
                    body: ordargument(body)
                };
            },
            htmlBuilder: color_htmlBuilder,
            mathmlBuilder: color_mathmlBuilder
        });
        defineFunction({
            type: "color",
            names: [
                "\\color"
            ],
            props: {
                numArgs: 1,
                allowedInText: true,
                argTypes: [
                    "color"
                ]
            },
            handler (_ref2, args) {
                let { parser: parser, breakOnTokenText: breakOnTokenText } = _ref2;
                const color = assertNodeType(args[0], "color-token").color; // Set macro \current@color in current namespace to store the current
                // color, mimicking the behavior of color.sty.
                // This is currently used just to correctly color a \right
                // that follows a \color command.
                parser.gullet.macros.set("\\current@color", color); // Parse out the implicit body that should be colored.
                const body = parser.parseExpression(true, breakOnTokenText);
                return {
                    type: "color",
                    mode: parser.mode,
                    color: color,
                    body: body
                };
            },
            htmlBuilder: color_htmlBuilder,
            mathmlBuilder: color_mathmlBuilder
        });
        // Row breaks within tabular environments, and line breaks at top level
        // \DeclareRobustCommand\\{...\@xnewline}
        defineFunction({
            type: "cr",
            names: [
                "\\\\"
            ],
            props: {
                numArgs: 0,
                numOptionalArgs: 0,
                allowedInText: true
            },
            handler (_ref, args, optArgs) {
                let { parser: parser } = _ref;
                const size = parser.gullet.future().text === "[" ? parser.parseSizeGroup(true) : null;
                const newLine = !parser.settings.displayMode || !parser.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
                return {
                    type: "cr",
                    mode: parser.mode,
                    newLine: newLine,
                    size: size && assertNodeType(size, "size").value
                };
            },
            // The following builders are called only at the top level,
            // not within tabular/array environments.
            htmlBuilder (group, options) {
                const span = buildCommon.makeSpan([
                    "mspace"
                ], [], options);
                if (group.newLine) {
                    span.classes.push("newline");
                    if (group.size) span.style.marginTop = makeEm(calculateSize(group.size, options));
                }
                return span;
            },
            mathmlBuilder (group, options) {
                const node = new mathMLTree.MathNode("mspace");
                if (group.newLine) {
                    node.setAttribute("linebreak", "newline");
                    if (group.size) node.setAttribute("height", makeEm(calculateSize(group.size, options)));
                }
                return node;
            }
        });
        const globalMap = {
            "\\global": "\\global",
            "\\long": "\\\\globallong",
            "\\\\globallong": "\\\\globallong",
            "\\def": "\\gdef",
            "\\gdef": "\\gdef",
            "\\edef": "\\xdef",
            "\\xdef": "\\xdef",
            "\\let": "\\\\globallet",
            "\\futurelet": "\\\\globalfuture"
        };
        const checkControlSequence = (tok)=>{
            const name = tok.text;
            if (/^(?:[\\{}$&#^_]|EOF)$/.test(name)) throw new src_ParseError("Expected a control sequence", tok);
            return name;
        };
        const getRHS = (parser)=>{
            let tok = parser.gullet.popToken();
            if (tok.text === "=") {
                // consume optional equals
                tok = parser.gullet.popToken();
                if (tok.text === " ") // consume one optional space
                tok = parser.gullet.popToken();
            }
            return tok;
        };
        const letCommand = (parser, name, tok, global)=>{
            let macro = parser.gullet.macros.get(tok.text);
            if (macro == null) {
                // don't expand it later even if a macro with the same name is defined
                // e.g., \let\foo=\frac \def\frac{\relax} \frac12
                tok.noexpand = true;
                macro = {
                    tokens: [
                        tok
                    ],
                    numArgs: 0,
                    // reproduce the same behavior in expansion
                    unexpandable: !parser.gullet.isExpandable(tok.text)
                };
            }
            parser.gullet.macros.set(name, macro, global);
        }; // <assignment> -> <non-macro assignment>|<macro assignment>
        // <non-macro assignment> -> <simple assignment>|\global<non-macro assignment>
        // <macro assignment> -> <definition>|<prefix><macro assignment>
        // <prefix> -> \global|\long|\outer
        defineFunction({
            type: "internal",
            names: [
                "\\global",
                "\\long",
                "\\\\globallong" // can’t be entered directly
            ],
            props: {
                numArgs: 0,
                allowedInText: true
            },
            handler (_ref) {
                let { parser: parser, funcName: funcName } = _ref;
                parser.consumeSpaces();
                const token = parser.fetch();
                if (globalMap[token.text]) {
                    // KaTeX doesn't have \par, so ignore \long
                    if (funcName === "\\global" || funcName === "\\\\globallong") token.text = globalMap[token.text];
                    return assertNodeType(parser.parseFunction(), "internal");
                }
                throw new src_ParseError("Invalid token after macro prefix", token);
            }
        }); // Basic support for macro definitions: \def, \gdef, \edef, \xdef
        // <definition> -> <def><control sequence><definition text>
        // <def> -> \def|\gdef|\edef|\xdef
        // <definition text> -> <parameter text><left brace><balanced text><right brace>
        defineFunction({
            type: "internal",
            names: [
                "\\def",
                "\\gdef",
                "\\edef",
                "\\xdef"
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                primitive: true
            },
            handler (_ref2) {
                let { parser: parser, funcName: funcName } = _ref2;
                let tok = parser.gullet.popToken();
                const name = tok.text;
                if (/^(?:[\\{}$&#^_]|EOF)$/.test(name)) throw new src_ParseError("Expected a control sequence", tok);
                let numArgs = 0;
                let insert;
                const delimiters = [
                    []
                ]; // <parameter text> contains no braces
                while(parser.gullet.future().text !== "{"){
                    tok = parser.gullet.popToken();
                    if (tok.text === "#") {
                        // If the very last character of the <parameter text> is #, so that
                        // this # is immediately followed by {, TeX will behave as if the {
                        // had been inserted at the right end of both the parameter text
                        // and the replacement text.
                        if (parser.gullet.future().text === "{") {
                            insert = parser.gullet.future();
                            delimiters[numArgs].push("{");
                            break;
                        } // A parameter, the first appearance of # must be followed by 1,
                        // the next by 2, and so on; up to nine #’s are allowed
                        tok = parser.gullet.popToken();
                        if (!/^[1-9]$/.test(tok.text)) throw new src_ParseError("Invalid argument number \"" + tok.text + "\"");
                        if (parseInt(tok.text) !== numArgs + 1) throw new src_ParseError("Argument number \"" + tok.text + "\" out of order");
                        numArgs++;
                        delimiters.push([]);
                    } else if (tok.text === "EOF") throw new src_ParseError("Expected a macro definition");
                    else delimiters[numArgs].push(tok.text);
                } // replacement text, enclosed in '{' and '}' and properly nested
                let { tokens: tokens } = parser.gullet.consumeArg();
                if (insert) tokens.unshift(insert);
                if (funcName === "\\edef" || funcName === "\\xdef") {
                    tokens = parser.gullet.expandTokens(tokens);
                    tokens.reverse(); // to fit in with stack order
                } // Final arg is the expansion of the macro
                parser.gullet.macros.set(name, {
                    tokens: tokens,
                    numArgs: numArgs,
                    delimiters: delimiters
                }, funcName === globalMap[funcName]);
                return {
                    type: "internal",
                    mode: parser.mode
                };
            }
        }); // <simple assignment> -> <let assignment>
        // <let assignment> -> \futurelet<control sequence><token><token>
        //     | \let<control sequence><equals><one optional space><token>
        // <equals> -> <optional spaces>|<optional spaces>=
        defineFunction({
            type: "internal",
            names: [
                "\\let",
                "\\\\globallet" // can’t be entered directly
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                primitive: true
            },
            handler (_ref3) {
                let { parser: parser, funcName: funcName } = _ref3;
                const name = checkControlSequence(parser.gullet.popToken());
                parser.gullet.consumeSpaces();
                const tok = getRHS(parser);
                letCommand(parser, name, tok, funcName === "\\\\globallet");
                return {
                    type: "internal",
                    mode: parser.mode
                };
            }
        }); // ref: https://www.tug.org/TUGboat/tb09-3/tb22bechtolsheim.pdf
        defineFunction({
            type: "internal",
            names: [
                "\\futurelet",
                "\\\\globalfuture" // can’t be entered directly
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                primitive: true
            },
            handler (_ref4) {
                let { parser: parser, funcName: funcName } = _ref4;
                const name = checkControlSequence(parser.gullet.popToken());
                const middle = parser.gullet.popToken();
                const tok = parser.gullet.popToken();
                letCommand(parser, name, tok, funcName === "\\\\globalfuture");
                parser.gullet.pushToken(tok);
                parser.gullet.pushToken(middle);
                return {
                    type: "internal",
                    mode: parser.mode
                };
            }
        });
        /**
 * This file deals with creating delimiters of various sizes. The TeXbook
 * discusses these routines on page 441-442, in the "Another subroutine sets box
 * x to a specified variable delimiter" paragraph.
 *
 * There are three main routines here. `makeSmallDelim` makes a delimiter in the
 * normal font, but in either text, script, or scriptscript style.
 * `makeLargeDelim` makes a delimiter in textstyle, but in one of the Size1,
 * Size2, Size3, or Size4 fonts. `makeStackedDelim` makes a delimiter out of
 * smaller pieces that are stacked on top of one another.
 *
 * The functions take a parameter `center`, which determines if the delimiter
 * should be centered around the axis.
 *
 * Then, there are three exposed functions. `sizedDelim` makes a delimiter in
 * one of the given sizes. This is used for things like `\bigl`.
 * `customSizedDelim` makes a delimiter with a given total height+depth. It is
 * called in places like `\sqrt`. `leftRightDelim` makes an appropriate
 * delimiter which surrounds an expression of a given height an depth. It is
 * used in `\left` and `\right`.
 */ /**
 * Get the metrics for a given symbol and font, after transformation (i.e.
 * after following replacement from symbols.js)
 */ const getMetrics = function(symbol, font, mode) {
            const replace = src_symbols.math[symbol] && src_symbols.math[symbol].replace;
            const metrics = getCharacterMetrics(replace || symbol, font, mode);
            if (!metrics) throw new Error("Unsupported symbol " + symbol + " and font size " + font + ".");
            return metrics;
        };
        /**
 * Puts a delimiter span in a given style, and adds appropriate height, depth,
 * and maxFontSizes.
 */ const styleWrap = function(delim, toStyle, options, classes) {
            const newOptions = options.havingBaseStyle(toStyle);
            const span = buildCommon.makeSpan(classes.concat(newOptions.sizingClasses(options)), [
                delim
            ], options);
            const delimSizeMultiplier = newOptions.sizeMultiplier / options.sizeMultiplier;
            span.height *= delimSizeMultiplier;
            span.depth *= delimSizeMultiplier;
            span.maxFontSize = newOptions.sizeMultiplier;
            return span;
        };
        const centerSpan = function(span, options, style) {
            const newOptions = options.havingBaseStyle(style);
            const shift = (1 - options.sizeMultiplier / newOptions.sizeMultiplier) * options.fontMetrics().axisHeight;
            span.classes.push("delimcenter");
            span.style.top = makeEm(shift);
            span.height -= shift;
            span.depth += shift;
        };
        /**
 * Makes a small delimiter. This is a delimiter that comes in the Main-Regular
 * font, but is restyled to either be in textstyle, scriptstyle, or
 * scriptscriptstyle.
 */ const makeSmallDelim = function(delim, style, center, options, mode, classes) {
            const text = buildCommon.makeSymbol(delim, "Main-Regular", mode, options);
            const span = styleWrap(text, style, options, classes);
            if (center) centerSpan(span, options, style);
            return span;
        };
        /**
 * Builds a symbol in the given font size (note size is an integer)
 */ const mathrmSize = function(value, size, mode, options) {
            return buildCommon.makeSymbol(value, "Size" + size + "-Regular", mode, options);
        };
        /**
 * Makes a large delimiter. This is a delimiter that comes in the Size1, Size2,
 * Size3, or Size4 fonts. It is always rendered in textstyle.
 */ const makeLargeDelim = function(delim, size, center, options, mode, classes) {
            const inner = mathrmSize(delim, size, mode, options);
            const span = styleWrap(buildCommon.makeSpan([
                "delimsizing",
                "size" + size
            ], [
                inner
            ], options), src_Style.TEXT, options, classes);
            if (center) centerSpan(span, options, src_Style.TEXT);
            return span;
        };
        /**
 * Make a span from a font glyph with the given offset and in the given font.
 * This is used in makeStackedDelim to make the stacking pieces for the delimiter.
 */ const makeGlyphSpan = function(symbol, font, mode) {
            let sizeClass; // Apply the correct CSS class to choose the right font.
            if (font === "Size1-Regular") sizeClass = "delim-size1";
            else sizeClass = "delim-size4";
            const corner = buildCommon.makeSpan([
                "delimsizinginner",
                sizeClass
            ], [
                buildCommon.makeSpan([], [
                    buildCommon.makeSymbol(symbol, font, mode)
                ])
            ]); // Since this will be passed into `makeVList` in the end, wrap the element
            // in the appropriate tag that VList uses.
            return {
                type: "elem",
                elem: corner
            };
        };
        const makeInner = function(ch, height, options) {
            // Create a span with inline SVG for the inner part of a tall stacked delimiter.
            const width = fontMetricsData['Size4-Regular'][ch.charCodeAt(0)] ? fontMetricsData['Size4-Regular'][ch.charCodeAt(0)][4] : fontMetricsData['Size1-Regular'][ch.charCodeAt(0)][4];
            const path = new PathNode("inner", innerPath(ch, Math.round(1000 * height)));
            const svgNode = new SvgNode([
                path
            ], {
                "width": makeEm(width),
                "height": makeEm(height),
                // Override CSS rule `.katex svg { width: 100% }`
                "style": "width:" + makeEm(width),
                "viewBox": "0 0 " + 1000 * width + " " + Math.round(1000 * height),
                "preserveAspectRatio": "xMinYMin"
            });
            const span = buildCommon.makeSvgSpan([], [
                svgNode
            ], options);
            span.height = height;
            span.style.height = makeEm(height);
            span.style.width = makeEm(width);
            return {
                type: "elem",
                elem: span
            };
        }; // Helpers for makeStackedDelim
        const lapInEms = 0.008;
        const lap = {
            type: "kern",
            size: -1 * lapInEms
        };
        const verts = [
            "|",
            "\\lvert",
            "\\rvert",
            "\\vert"
        ];
        const doubleVerts = [
            "\\|",
            "\\lVert",
            "\\rVert",
            "\\Vert"
        ];
        /**
 * Make a stacked delimiter out of a given delimiter, with the total height at
 * least `heightTotal`. This routine is mentioned on page 442 of the TeXbook.
 */ const makeStackedDelim = function(delim, heightTotal, center, options, mode, classes) {
            // There are four parts, the top, an optional middle, a repeated part, and a
            // bottom.
            let top;
            let middle;
            let repeat;
            let bottom;
            let svgLabel = "";
            let viewBoxWidth = 0;
            top = repeat = bottom = delim;
            middle = null; // Also keep track of what font the delimiters are in
            let font = "Size1-Regular"; // We set the parts and font based on the symbol. Note that we use
            // '\u23d0' instead of '|' and '\u2016' instead of '\\|' for the
            // repeats of the arrows
            if (delim === "\\uparrow") repeat = bottom = "\u23d0";
            else if (delim === "\\Uparrow") repeat = bottom = "\u2016";
            else if (delim === "\\downarrow") top = repeat = "\u23d0";
            else if (delim === "\\Downarrow") top = repeat = "\u2016";
            else if (delim === "\\updownarrow") {
                top = "\\uparrow";
                repeat = "\u23d0";
                bottom = "\\downarrow";
            } else if (delim === "\\Updownarrow") {
                top = "\\Uparrow";
                repeat = "\u2016";
                bottom = "\\Downarrow";
            } else if (verts.includes(delim)) {
                repeat = "\u2223";
                svgLabel = "vert";
                viewBoxWidth = 333;
            } else if (doubleVerts.includes(delim)) {
                repeat = "\u2225";
                svgLabel = "doublevert";
                viewBoxWidth = 556;
            } else if (delim === "[" || delim === "\\lbrack") {
                top = "\u23a1";
                repeat = "\u23a2";
                bottom = "\u23a3";
                font = "Size4-Regular";
                svgLabel = "lbrack";
                viewBoxWidth = 667;
            } else if (delim === "]" || delim === "\\rbrack") {
                top = "\u23a4";
                repeat = "\u23a5";
                bottom = "\u23a6";
                font = "Size4-Regular";
                svgLabel = "rbrack";
                viewBoxWidth = 667;
            } else if (delim === "\\lfloor" || delim === "\u230a") {
                repeat = top = "\u23a2";
                bottom = "\u23a3";
                font = "Size4-Regular";
                svgLabel = "lfloor";
                viewBoxWidth = 667;
            } else if (delim === "\\lceil" || delim === "\u2308") {
                top = "\u23a1";
                repeat = bottom = "\u23a2";
                font = "Size4-Regular";
                svgLabel = "lceil";
                viewBoxWidth = 667;
            } else if (delim === "\\rfloor" || delim === "\u230b") {
                repeat = top = "\u23a5";
                bottom = "\u23a6";
                font = "Size4-Regular";
                svgLabel = "rfloor";
                viewBoxWidth = 667;
            } else if (delim === "\\rceil" || delim === "\u2309") {
                top = "\u23a4";
                repeat = bottom = "\u23a5";
                font = "Size4-Regular";
                svgLabel = "rceil";
                viewBoxWidth = 667;
            } else if (delim === "(" || delim === "\\lparen") {
                top = "\u239b";
                repeat = "\u239c";
                bottom = "\u239d";
                font = "Size4-Regular";
                svgLabel = "lparen";
                viewBoxWidth = 875;
            } else if (delim === ")" || delim === "\\rparen") {
                top = "\u239e";
                repeat = "\u239f";
                bottom = "\u23a0";
                font = "Size4-Regular";
                svgLabel = "rparen";
                viewBoxWidth = 875;
            } else if (delim === "\\{" || delim === "\\lbrace") {
                top = "\u23a7";
                middle = "\u23a8";
                bottom = "\u23a9";
                repeat = "\u23aa";
                font = "Size4-Regular";
            } else if (delim === "\\}" || delim === "\\rbrace") {
                top = "\u23ab";
                middle = "\u23ac";
                bottom = "\u23ad";
                repeat = "\u23aa";
                font = "Size4-Regular";
            } else if (delim === "\\lgroup" || delim === "\u27ee") {
                top = "\u23a7";
                bottom = "\u23a9";
                repeat = "\u23aa";
                font = "Size4-Regular";
            } else if (delim === "\\rgroup" || delim === "\u27ef") {
                top = "\u23ab";
                bottom = "\u23ad";
                repeat = "\u23aa";
                font = "Size4-Regular";
            } else if (delim === "\\lmoustache" || delim === "\u23b0") {
                top = "\u23a7";
                bottom = "\u23ad";
                repeat = "\u23aa";
                font = "Size4-Regular";
            } else if (delim === "\\rmoustache" || delim === "\u23b1") {
                top = "\u23ab";
                bottom = "\u23a9";
                repeat = "\u23aa";
                font = "Size4-Regular";
            } // Get the metrics of the four sections
            const topMetrics = getMetrics(top, font, mode);
            const topHeightTotal = topMetrics.height + topMetrics.depth;
            const repeatMetrics = getMetrics(repeat, font, mode);
            const repeatHeightTotal = repeatMetrics.height + repeatMetrics.depth;
            const bottomMetrics = getMetrics(bottom, font, mode);
            const bottomHeightTotal = bottomMetrics.height + bottomMetrics.depth;
            let middleHeightTotal = 0;
            let middleFactor = 1;
            if (middle !== null) {
                const middleMetrics = getMetrics(middle, font, mode);
                middleHeightTotal = middleMetrics.height + middleMetrics.depth;
                middleFactor = 2; // repeat symmetrically above and below middle
            } // Calculate the minimal height that the delimiter can have.
            // It is at least the size of the top, bottom, and optional middle combined.
            const minHeight = topHeightTotal + bottomHeightTotal + middleHeightTotal; // Compute the number of copies of the repeat symbol we will need
            const repeatCount = Math.max(0, Math.ceil((heightTotal - minHeight) / (middleFactor * repeatHeightTotal))); // Compute the total height of the delimiter including all the symbols
            const realHeightTotal = minHeight + repeatCount * middleFactor * repeatHeightTotal; // The center of the delimiter is placed at the center of the axis. Note
            // that in this context, "center" means that the delimiter should be
            // centered around the axis in the current style, while normally it is
            // centered around the axis in textstyle.
            let axisHeight = options.fontMetrics().axisHeight;
            if (center) axisHeight *= options.sizeMultiplier;
             // Calculate the depth
            const depth = realHeightTotal / 2 - axisHeight; // Now, we start building the pieces that will go into the vlist
            // Keep a list of the pieces of the stacked delimiter
            const stack = [];
            if (svgLabel.length > 0) {
                // Instead of stacking glyphs, create a single SVG.
                // This evades browser problems with imprecise positioning of spans.
                const midHeight = realHeightTotal - topHeightTotal - bottomHeightTotal;
                const viewBoxHeight = Math.round(realHeightTotal * 1000);
                const pathStr = tallDelim(svgLabel, Math.round(midHeight * 1000));
                const path = new PathNode(svgLabel, pathStr);
                const width = (viewBoxWidth / 1000).toFixed(3) + "em";
                const height = (viewBoxHeight / 1000).toFixed(3) + "em";
                const svg = new SvgNode([
                    path
                ], {
                    "width": width,
                    "height": height,
                    "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight
                });
                const wrapper = buildCommon.makeSvgSpan([], [
                    svg
                ], options);
                wrapper.height = viewBoxHeight / 1000;
                wrapper.style.width = width;
                wrapper.style.height = height;
                stack.push({
                    type: "elem",
                    elem: wrapper
                });
            } else {
                // Stack glyphs
                // Start by adding the bottom symbol
                stack.push(makeGlyphSpan(bottom, font, mode));
                stack.push(lap); // overlap
                if (middle === null) {
                    // The middle section will be an SVG. Make it an extra 0.016em tall.
                    // We'll overlap by 0.008em at top and bottom.
                    const innerHeight = realHeightTotal - topHeightTotal - bottomHeightTotal + 2 * lapInEms;
                    stack.push(makeInner(repeat, innerHeight, options));
                } else {
                    // When there is a middle bit, we need the middle part and two repeated
                    // sections
                    const innerHeight = (realHeightTotal - topHeightTotal - bottomHeightTotal - middleHeightTotal) / 2 + 2 * lapInEms;
                    stack.push(makeInner(repeat, innerHeight, options)); // Now insert the middle of the brace.
                    stack.push(lap);
                    stack.push(makeGlyphSpan(middle, font, mode));
                    stack.push(lap);
                    stack.push(makeInner(repeat, innerHeight, options));
                } // Add the top symbol
                stack.push(lap);
                stack.push(makeGlyphSpan(top, font, mode));
            } // Finally, build the vlist
            const newOptions = options.havingBaseStyle(src_Style.TEXT);
            const inner = buildCommon.makeVList({
                positionType: "bottom",
                positionData: depth,
                children: stack
            }, newOptions);
            return styleWrap(buildCommon.makeSpan([
                "delimsizing",
                "mult"
            ], [
                inner
            ], newOptions), src_Style.TEXT, options, classes);
        }; // All surds have 0.08em padding above the vinculum inside the SVG.
        // That keeps browser span height rounding error from pinching the line.
        const vbPad = 80; // padding above the surd, measured inside the viewBox.
        const emPad = 0.08; // padding, in ems, measured in the document.
        const sqrtSvg = function(sqrtName, height, viewBoxHeight, extraVinculum, options) {
            const path = sqrtPath(sqrtName, extraVinculum, viewBoxHeight);
            const pathNode = new PathNode(sqrtName, path);
            const svg = new SvgNode([
                pathNode
            ], {
                // Note: 1000:1 ratio of viewBox to document em width.
                "width": "400em",
                "height": makeEm(height),
                "viewBox": "0 0 400000 " + viewBoxHeight,
                "preserveAspectRatio": "xMinYMin slice"
            });
            return buildCommon.makeSvgSpan([
                "hide-tail"
            ], [
                svg
            ], options);
        };
        /**
 * Make a sqrt image of the given height,
 */ const makeSqrtImage = function(height, options) {
            // Define a newOptions that removes the effect of size changes such as \Huge.
            // We don't pick different a height surd for \Huge. For it, we scale up.
            const newOptions = options.havingBaseSizing(); // Pick the desired surd glyph from a sequence of surds.
            const delim = traverseSequence("\\surd", height * newOptions.sizeMultiplier, stackLargeDelimiterSequence, newOptions);
            let sizeMultiplier = newOptions.sizeMultiplier; // default
            // The standard sqrt SVGs each have a 0.04em thick vinculum.
            // If Settings.minRuleThickness is larger than that, we add extraVinculum.
            const extraVinculum = Math.max(0, options.minRuleThickness - options.fontMetrics().sqrtRuleThickness); // Create a span containing an SVG image of a sqrt symbol.
            let span;
            let spanHeight = 0;
            let texHeight = 0;
            let viewBoxHeight = 0;
            let advanceWidth; // We create viewBoxes with 80 units of "padding" above each surd.
            // Then browser rounding error on the parent span height will not
            // encroach on the ink of the vinculum. But that padding is not
            // included in the TeX-like `height` used for calculation of
            // vertical alignment. So texHeight = span.height < span.style.height.
            if (delim.type === "small") {
                // Get an SVG that is derived from glyph U+221A in font KaTeX-Main.
                // 1000 unit normal glyph height.
                viewBoxHeight = 1000 + 1000 * extraVinculum + vbPad;
                if (height < 1.0) sizeMultiplier = 1.0; // mimic a \textfont radical
                else if (height < 1.4) sizeMultiplier = 0.7; // mimic a \scriptfont radical
                spanHeight = (1.0 + extraVinculum + emPad) / sizeMultiplier;
                texHeight = (1.00 + extraVinculum) / sizeMultiplier;
                span = sqrtSvg("sqrtMain", spanHeight, viewBoxHeight, extraVinculum, options);
                span.style.minWidth = "0.853em";
                advanceWidth = 0.833 / sizeMultiplier; // from the font.
            } else if (delim.type === "large") {
                // These SVGs come from fonts: KaTeX_Size1, _Size2, etc.
                viewBoxHeight = (1000 + vbPad) * sizeToMaxHeight[delim.size];
                texHeight = (sizeToMaxHeight[delim.size] + extraVinculum) / sizeMultiplier;
                spanHeight = (sizeToMaxHeight[delim.size] + extraVinculum + emPad) / sizeMultiplier;
                span = sqrtSvg("sqrtSize" + delim.size, spanHeight, viewBoxHeight, extraVinculum, options);
                span.style.minWidth = "1.02em";
                advanceWidth = 1.0 / sizeMultiplier; // 1.0 from the font.
            } else {
                // Tall sqrt. In TeX, this would be stacked using multiple glyphs.
                // We'll use a single SVG to accomplish the same thing.
                spanHeight = height + extraVinculum + emPad;
                texHeight = height + extraVinculum;
                viewBoxHeight = Math.floor(1000 * height + extraVinculum) + vbPad;
                span = sqrtSvg("sqrtTall", spanHeight, viewBoxHeight, extraVinculum, options);
                span.style.minWidth = "0.742em";
                advanceWidth = 1.056;
            }
            span.height = texHeight;
            span.style.height = makeEm(spanHeight);
            return {
                span: span,
                advanceWidth: advanceWidth,
                // Calculate the actual line width.
                // This actually should depend on the chosen font -- e.g. \boldmath
                // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
                // have thicker rules.
                ruleWidth: (options.fontMetrics().sqrtRuleThickness + extraVinculum) * sizeMultiplier
            };
        }; // There are three kinds of delimiters, delimiters that stack when they become
        // too large
        const stackLargeDelimiters = [
            "(",
            "\\lparen",
            ")",
            "\\rparen",
            "[",
            "\\lbrack",
            "]",
            "\\rbrack",
            "\\{",
            "\\lbrace",
            "\\}",
            "\\rbrace",
            "\\lfloor",
            "\\rfloor",
            "\u230a",
            "\u230b",
            "\\lceil",
            "\\rceil",
            "\u2308",
            "\u2309",
            "\\surd"
        ]; // delimiters that always stack
        const stackAlwaysDelimiters = [
            "\\uparrow",
            "\\downarrow",
            "\\updownarrow",
            "\\Uparrow",
            "\\Downarrow",
            "\\Updownarrow",
            "|",
            "\\|",
            "\\vert",
            "\\Vert",
            "\\lvert",
            "\\rvert",
            "\\lVert",
            "\\rVert",
            "\\lgroup",
            "\\rgroup",
            "\u27ee",
            "\u27ef",
            "\\lmoustache",
            "\\rmoustache",
            "\u23b0",
            "\u23b1"
        ]; // and delimiters that never stack
        const stackNeverDelimiters = [
            "<",
            ">",
            "\\langle",
            "\\rangle",
            "/",
            "\\backslash",
            "\\lt",
            "\\gt"
        ]; // Metrics of the different sizes. Found by looking at TeX's output of
        // $\bigl| // \Bigl| \biggl| \Biggl| \showlists$
        // Used to create stacked delimiters of appropriate sizes in makeSizedDelim.
        const sizeToMaxHeight = [
            0,
            1.2,
            1.8,
            2.4,
            3.0
        ];
        /**
 * Used to create a delimiter of a specific size, where `size` is 1, 2, 3, or 4.
 */ const makeSizedDelim = function(delim, size, options, mode, classes) {
            // < and > turn into \langle and \rangle in delimiters
            if (delim === "<" || delim === "\\lt" || delim === "\u27e8") delim = "\\langle";
            else if (delim === ">" || delim === "\\gt" || delim === "\u27e9") delim = "\\rangle";
             // Sized delimiters are never centered.
            if (stackLargeDelimiters.includes(delim) || stackNeverDelimiters.includes(delim)) return makeLargeDelim(delim, size, false, options, mode, classes);
            else if (stackAlwaysDelimiters.includes(delim)) return makeStackedDelim(delim, sizeToMaxHeight[size], false, options, mode, classes);
            else throw new src_ParseError("Illegal delimiter: '" + delim + "'");
        };
        /**
 * There are three different sequences of delimiter sizes that the delimiters
 * follow depending on the kind of delimiter. This is used when creating custom
 * sized delimiters to decide whether to create a small, large, or stacked
 * delimiter.
 *
 * In real TeX, these sequences aren't explicitly defined, but are instead
 * defined inside the font metrics. Since there are only three sequences that
 * are possible for the delimiters that TeX defines, it is easier to just encode
 * them explicitly here.
 */ // Delimiters that never stack try small delimiters and large delimiters only
        const stackNeverDelimiterSequence = [
            {
                type: "small",
                style: src_Style.SCRIPTSCRIPT
            },
            {
                type: "small",
                style: src_Style.SCRIPT
            },
            {
                type: "small",
                style: src_Style.TEXT
            },
            {
                type: "large",
                size: 1
            },
            {
                type: "large",
                size: 2
            },
            {
                type: "large",
                size: 3
            },
            {
                type: "large",
                size: 4
            }
        ]; // Delimiters that always stack try the small delimiters first, then stack
        const stackAlwaysDelimiterSequence = [
            {
                type: "small",
                style: src_Style.SCRIPTSCRIPT
            },
            {
                type: "small",
                style: src_Style.SCRIPT
            },
            {
                type: "small",
                style: src_Style.TEXT
            },
            {
                type: "stack"
            }
        ]; // Delimiters that stack when large try the small and then large delimiters, and
        // stack afterwards
        const stackLargeDelimiterSequence = [
            {
                type: "small",
                style: src_Style.SCRIPTSCRIPT
            },
            {
                type: "small",
                style: src_Style.SCRIPT
            },
            {
                type: "small",
                style: src_Style.TEXT
            },
            {
                type: "large",
                size: 1
            },
            {
                type: "large",
                size: 2
            },
            {
                type: "large",
                size: 3
            },
            {
                type: "large",
                size: 4
            },
            {
                type: "stack"
            }
        ];
        /**
 * Get the font used in a delimiter based on what kind of delimiter it is.
 * TODO(#963) Use more specific font family return type once that is introduced.
 */ const delimTypeToFont = function(type) {
            if (type.type === "small") return "Main-Regular";
            else if (type.type === "large") return "Size" + type.size + "-Regular";
            else if (type.type === "stack") return "Size4-Regular";
            else throw new Error("Add support for delim type '" + type.type + "' here.");
        };
        /**
 * Traverse a sequence of types of delimiters to decide what kind of delimiter
 * should be used to create a delimiter of the given height+depth.
 */ const traverseSequence = function(delim, height, sequence, options) {
            // Here, we choose the index we should start at in the sequences. In smaller
            // sizes (which correspond to larger numbers in style.size) we start earlier
            // in the sequence. Thus, scriptscript starts at index 3-3=0, script starts
            // at index 3-2=1, text starts at 3-1=2, and display starts at min(2,3-0)=2
            const start = Math.min(2, 3 - options.style.size);
            for(let i = start; i < sequence.length; i++){
                if (sequence[i].type === "stack") break;
                const metrics = getMetrics(delim, delimTypeToFont(sequence[i]), "math");
                let heightDepth = metrics.height + metrics.depth; // Small delimiters are scaled down versions of the same font, so we
                // account for the style change size.
                if (sequence[i].type === "small") {
                    const newOptions = options.havingBaseStyle(sequence[i].style);
                    heightDepth *= newOptions.sizeMultiplier;
                } // Check if the delimiter at this size works for the given height.
                if (heightDepth > height) return sequence[i];
            } // If we reached the end of the sequence, return the last sequence element.
            return sequence[sequence.length - 1];
        };
        /**
 * Make a delimiter of a given height+depth, with optional centering. Here, we
 * traverse the sequences, and create a delimiter that the sequence tells us to.
 */ const makeCustomSizedDelim = function(delim, height, center, options, mode, classes) {
            if (delim === "<" || delim === "\\lt" || delim === "\u27e8") delim = "\\langle";
            else if (delim === ">" || delim === "\\gt" || delim === "\u27e9") delim = "\\rangle";
             // Decide what sequence to use
            let sequence;
            if (stackNeverDelimiters.includes(delim)) sequence = stackNeverDelimiterSequence;
            else if (stackLargeDelimiters.includes(delim)) sequence = stackLargeDelimiterSequence;
            else sequence = stackAlwaysDelimiterSequence;
             // Look through the sequence
            const delimType = traverseSequence(delim, height, sequence, options); // Get the delimiter from font glyphs.
            // Depending on the sequence element we decided on, call the
            // appropriate function.
            if (delimType.type === "small") return makeSmallDelim(delim, delimType.style, center, options, mode, classes);
            else if (delimType.type === "large") return makeLargeDelim(delim, delimType.size, center, options, mode, classes);
            else return makeStackedDelim(delim, height, center, options, mode, classes);
        };
        /**
 * Make a delimiter for use with `\left` and `\right`, given a height and depth
 * of an expression that the delimiters surround.
 */ const makeLeftRightDelim = function(delim, height, depth, options, mode, classes) {
            // We always center \left/\right delimiters, so the axis is always shifted
            const axisHeight = options.fontMetrics().axisHeight * options.sizeMultiplier; // Taken from TeX source, tex.web, function make_left_right
            const delimiterFactor = 901;
            const delimiterExtend = 5.0 / options.fontMetrics().ptPerEm;
            const maxDistFromAxis = Math.max(height - axisHeight, depth + axisHeight);
            const totalHeight = Math.max(// 65536 per pt, or 655360 per em. So, the division here truncates in
            // TeX but doesn't here, producing different results. If we wanted to
            // exactly match TeX's calculation, we could do
            //   Math.floor(655360 * maxDistFromAxis / 500) *
            //    delimiterFactor / 655360
            // (To see the difference, compare
            //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
            // in TeX and KaTeX)
            maxDistFromAxis / 500 * delimiterFactor, 2 * maxDistFromAxis - delimiterExtend); // Finally, we defer to `makeCustomSizedDelim` with our calculated total
            // height
            return makeCustomSizedDelim(delim, totalHeight, true, options, mode, classes);
        };
        /* harmony default export */ var delimiter = {
            sqrtImage: makeSqrtImage,
            sizedDelim: makeSizedDelim,
            sizeToMaxHeight: sizeToMaxHeight,
            customSizedDelim: makeCustomSizedDelim,
            leftRightDelim: makeLeftRightDelim
        };
        // Extra data needed for the delimiter handler down below
        const delimiterSizes = {
            "\\bigl": {
                mclass: "mopen",
                size: 1
            },
            "\\Bigl": {
                mclass: "mopen",
                size: 2
            },
            "\\biggl": {
                mclass: "mopen",
                size: 3
            },
            "\\Biggl": {
                mclass: "mopen",
                size: 4
            },
            "\\bigr": {
                mclass: "mclose",
                size: 1
            },
            "\\Bigr": {
                mclass: "mclose",
                size: 2
            },
            "\\biggr": {
                mclass: "mclose",
                size: 3
            },
            "\\Biggr": {
                mclass: "mclose",
                size: 4
            },
            "\\bigm": {
                mclass: "mrel",
                size: 1
            },
            "\\Bigm": {
                mclass: "mrel",
                size: 2
            },
            "\\biggm": {
                mclass: "mrel",
                size: 3
            },
            "\\Biggm": {
                mclass: "mrel",
                size: 4
            },
            "\\big": {
                mclass: "mord",
                size: 1
            },
            "\\Big": {
                mclass: "mord",
                size: 2
            },
            "\\bigg": {
                mclass: "mord",
                size: 3
            },
            "\\Bigg": {
                mclass: "mord",
                size: 4
            }
        };
        const delimiters = [
            "(",
            "\\lparen",
            ")",
            "\\rparen",
            "[",
            "\\lbrack",
            "]",
            "\\rbrack",
            "\\{",
            "\\lbrace",
            "\\}",
            "\\rbrace",
            "\\lfloor",
            "\\rfloor",
            "\u230a",
            "\u230b",
            "\\lceil",
            "\\rceil",
            "\u2308",
            "\u2309",
            "<",
            ">",
            "\\langle",
            "\u27e8",
            "\\rangle",
            "\u27e9",
            "\\lt",
            "\\gt",
            "\\lvert",
            "\\rvert",
            "\\lVert",
            "\\rVert",
            "\\lgroup",
            "\\rgroup",
            "\u27ee",
            "\u27ef",
            "\\lmoustache",
            "\\rmoustache",
            "\u23b0",
            "\u23b1",
            "/",
            "\\backslash",
            "|",
            "\\vert",
            "\\|",
            "\\Vert",
            "\\uparrow",
            "\\Uparrow",
            "\\downarrow",
            "\\Downarrow",
            "\\updownarrow",
            "\\Updownarrow",
            "."
        ];
        // Delimiter functions
        function checkDelimiter(delim, context) {
            const symDelim = checkSymbolNodeType(delim);
            if (symDelim && delimiters.includes(symDelim.text)) return symDelim;
            else if (symDelim) throw new src_ParseError("Invalid delimiter '" + symDelim.text + "' after '" + context.funcName + "'", delim);
            else throw new src_ParseError("Invalid delimiter type '" + delim.type + "'", delim);
        }
        defineFunction({
            type: "delimsizing",
            names: [
                "\\bigl",
                "\\Bigl",
                "\\biggl",
                "\\Biggl",
                "\\bigr",
                "\\Bigr",
                "\\biggr",
                "\\Biggr",
                "\\bigm",
                "\\Bigm",
                "\\biggm",
                "\\Biggm",
                "\\big",
                "\\Big",
                "\\bigg",
                "\\Bigg"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "primitive"
                ]
            },
            handler: (context, args)=>{
                const delim = checkDelimiter(args[0], context);
                return {
                    type: "delimsizing",
                    mode: context.parser.mode,
                    size: delimiterSizes[context.funcName].size,
                    mclass: delimiterSizes[context.funcName].mclass,
                    delim: delim.text
                };
            },
            htmlBuilder: (group, options)=>{
                if (group.delim === ".") // Empty delimiters still count as elements, even though they don't
                // show anything.
                return buildCommon.makeSpan([
                    group.mclass
                ]);
                 // Use delimiter.sizedDelim to generate the delimiter.
                return delimiter.sizedDelim(group.delim, group.size, options, group.mode, [
                    group.mclass
                ]);
            },
            mathmlBuilder: (group)=>{
                const children = [];
                if (group.delim !== ".") children.push(makeText(group.delim, group.mode));
                const node = new mathMLTree.MathNode("mo", children);
                if (group.mclass === "mopen" || group.mclass === "mclose") // Only some of the delimsizing functions act as fences, and they
                // return "mopen" or "mclose" mclass.
                node.setAttribute("fence", "true");
                else // Explicitly disable fencing if it's not a fence, to override the
                // defaults.
                node.setAttribute("fence", "false");
                node.setAttribute("stretchy", "true");
                const size = makeEm(delimiter.sizeToMaxHeight[group.size]);
                node.setAttribute("minsize", size);
                node.setAttribute("maxsize", size);
                return node;
            }
        });
        function assertParsed(group) {
            if (!group.body) throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
        }
        defineFunction({
            type: "leftright-right",
            names: [
                "\\right"
            ],
            props: {
                numArgs: 1,
                primitive: true
            },
            handler: (context, args)=>{
                // \left case below triggers parsing of \right in
                //   `const right = parser.parseFunction();`
                // uses this return value.
                const color = context.parser.gullet.macros.get("\\current@color");
                if (color && typeof color !== "string") throw new src_ParseError("\\current@color set to non-string in \\right");
                return {
                    type: "leftright-right",
                    mode: context.parser.mode,
                    delim: checkDelimiter(args[0], context).text,
                    color: color // undefined if not set via \color
                };
            }
        });
        defineFunction({
            type: "leftright",
            names: [
                "\\left"
            ],
            props: {
                numArgs: 1,
                primitive: true
            },
            handler: (context, args)=>{
                const delim = checkDelimiter(args[0], context);
                const parser = context.parser; // Parse out the implicit body
                ++parser.leftrightDepth; // parseExpression stops before '\\right'
                const body = parser.parseExpression(false);
                --parser.leftrightDepth; // Check the next token
                parser.expect("\\right", false);
                const right = assertNodeType(parser.parseFunction(), "leftright-right");
                return {
                    type: "leftright",
                    mode: parser.mode,
                    body: body,
                    left: delim.text,
                    right: right.delim,
                    rightColor: right.color
                };
            },
            htmlBuilder: (group, options)=>{
                assertParsed(group); // Build the inner expression
                const inner = buildExpression(group.body, options, true, [
                    "mopen",
                    "mclose"
                ]);
                let innerHeight = 0;
                let innerDepth = 0;
                let hadMiddle = false; // Calculate its height and depth
                for(let i = 0; i < inner.length; i++)// Property `isMiddle` not defined on `span`. See comment in
                // "middle"'s htmlBuilder.
                // $FlowFixMe
                if (inner[i].isMiddle) hadMiddle = true;
                else {
                    innerHeight = Math.max(inner[i].height, innerHeight);
                    innerDepth = Math.max(inner[i].depth, innerDepth);
                }
                 // The size of delimiters is the same, regardless of what style we are
                // in. Thus, to correctly calculate the size of delimiter we need around
                // a group, we scale down the inner size based on the size.
                innerHeight *= options.sizeMultiplier;
                innerDepth *= options.sizeMultiplier;
                let leftDelim;
                if (group.left === ".") // Empty delimiters in \left and \right make null delimiter spaces.
                leftDelim = makeNullDelimiter(options, [
                    "mopen"
                ]);
                else // Otherwise, use leftRightDelim to generate the correct sized
                // delimiter.
                leftDelim = delimiter.leftRightDelim(group.left, innerHeight, innerDepth, options, group.mode, [
                    "mopen"
                ]);
                 // Add it to the beginning of the expression
                inner.unshift(leftDelim); // Handle middle delimiters
                if (hadMiddle) for(let i = 1; i < inner.length; i++){
                    const middleDelim = inner[i]; // Property `isMiddle` not defined on `span`. See comment in
                    // "middle"'s htmlBuilder.
                    // $FlowFixMe
                    const isMiddle = middleDelim.isMiddle;
                    if (isMiddle) // Apply the options that were active when \middle was called
                    inner[i] = delimiter.leftRightDelim(isMiddle.delim, innerHeight, innerDepth, isMiddle.options, group.mode, []);
                }
                let rightDelim; // Same for the right delimiter, but using color specified by \color
                if (group.right === ".") rightDelim = makeNullDelimiter(options, [
                    "mclose"
                ]);
                else {
                    const colorOptions = group.rightColor ? options.withColor(group.rightColor) : options;
                    rightDelim = delimiter.leftRightDelim(group.right, innerHeight, innerDepth, colorOptions, group.mode, [
                        "mclose"
                    ]);
                } // Add it to the end of the expression.
                inner.push(rightDelim);
                return buildCommon.makeSpan([
                    "minner"
                ], inner, options);
            },
            mathmlBuilder: (group, options)=>{
                assertParsed(group);
                const inner = buildMathML_buildExpression(group.body, options);
                if (group.left !== ".") {
                    const leftNode = new mathMLTree.MathNode("mo", [
                        makeText(group.left, group.mode)
                    ]);
                    leftNode.setAttribute("fence", "true");
                    inner.unshift(leftNode);
                }
                if (group.right !== ".") {
                    const rightNode = new mathMLTree.MathNode("mo", [
                        makeText(group.right, group.mode)
                    ]);
                    rightNode.setAttribute("fence", "true");
                    if (group.rightColor) rightNode.setAttribute("mathcolor", group.rightColor);
                    inner.push(rightNode);
                }
                return makeRow(inner);
            }
        });
        defineFunction({
            type: "middle",
            names: [
                "\\middle"
            ],
            props: {
                numArgs: 1,
                primitive: true
            },
            handler: (context, args)=>{
                const delim = checkDelimiter(args[0], context);
                if (!context.parser.leftrightDepth) throw new src_ParseError("\\middle without preceding \\left", delim);
                return {
                    type: "middle",
                    mode: context.parser.mode,
                    delim: delim.text
                };
            },
            htmlBuilder: (group, options)=>{
                let middleDelim;
                if (group.delim === ".") middleDelim = makeNullDelimiter(options, []);
                else {
                    middleDelim = delimiter.sizedDelim(group.delim, 1, options, group.mode, []);
                    const isMiddle = {
                        delim: group.delim,
                        options: options
                    }; // Property `isMiddle` not defined on `span`. It is only used in
                    // this file above.
                    // TODO: Fix this violation of the `span` type and possibly rename
                    // things since `isMiddle` sounds like a boolean, but is a struct.
                    // $FlowFixMe
                    middleDelim.isMiddle = isMiddle;
                }
                return middleDelim;
            },
            mathmlBuilder: (group, options)=>{
                // A Firefox \middle will stretch a character vertically only if it
                // is in the fence part of the operator dictionary at:
                // https://www.w3.org/TR/MathML3/appendixc.html.
                // So we need to avoid U+2223 and use plain "|" instead.
                const textNode = group.delim === "\\vert" || group.delim === "|" ? makeText("|", "text") : makeText(group.delim, group.mode);
                const middleNode = new mathMLTree.MathNode("mo", [
                    textNode
                ]);
                middleNode.setAttribute("fence", "true"); // MathML gives 5/18em spacing to each <mo> element.
                // \middle should get delimiter spacing instead.
                middleNode.setAttribute("lspace", "0.05em");
                middleNode.setAttribute("rspace", "0.05em");
                return middleNode;
            }
        });
        const enclose_htmlBuilder = (group, options)=>{
            // \cancel, \bcancel, \xcancel, \sout, \fbox, \colorbox, \fcolorbox, \phase
            // Some groups can return document fragments.  Handle those by wrapping
            // them in a span.
            const inner = buildCommon.wrapFragment(buildGroup(group.body, options), options);
            const label = group.label.slice(1);
            let scale = options.sizeMultiplier;
            let img;
            let imgShift = 0; // In the LaTeX cancel package, line geometry is slightly different
            // depending on whether the subject is wider than it is tall, or vice versa.
            // We don't know the width of a group, so as a proxy, we test if
            // the subject is a single character. This captures most of the
            // subjects that should get the "tall" treatment.
            const isSingleChar = utils.isCharacterBox(group.body);
            if (label === "sout") {
                img = buildCommon.makeSpan([
                    "stretchy",
                    "sout"
                ]);
                img.height = options.fontMetrics().defaultRuleThickness / scale;
                imgShift = -0.5 * options.fontMetrics().xHeight;
            } else if (label === "phase") {
                // Set a couple of dimensions from the steinmetz package.
                const lineWeight = calculateSize({
                    number: 0.6,
                    unit: "pt"
                }, options);
                const clearance = calculateSize({
                    number: 0.35,
                    unit: "ex"
                }, options); // Prevent size changes like \Huge from affecting line thickness
                const newOptions = options.havingBaseSizing();
                scale = scale / newOptions.sizeMultiplier;
                const angleHeight = inner.height + inner.depth + lineWeight + clearance; // Reserve a left pad for the angle.
                inner.style.paddingLeft = makeEm(angleHeight / 2 + lineWeight); // Create an SVG
                const viewBoxHeight = Math.floor(1000 * angleHeight * scale);
                const path = phasePath(viewBoxHeight);
                const svgNode = new SvgNode([
                    new PathNode("phase", path)
                ], {
                    "width": "400em",
                    "height": makeEm(viewBoxHeight / 1000),
                    "viewBox": "0 0 400000 " + viewBoxHeight,
                    "preserveAspectRatio": "xMinYMin slice"
                }); // Wrap it in a span with overflow: hidden.
                img = buildCommon.makeSvgSpan([
                    "hide-tail"
                ], [
                    svgNode
                ], options);
                img.style.height = makeEm(angleHeight);
                imgShift = inner.depth + lineWeight + clearance;
            } else {
                // Add horizontal padding
                if (/cancel/.test(label)) {
                    if (!isSingleChar) inner.classes.push("cancel-pad");
                } else if (label === "angl") inner.classes.push("anglpad");
                else inner.classes.push("boxpad");
                 // Add vertical padding
                let topPad = 0;
                let bottomPad = 0;
                let ruleThickness = 0; // ref: cancel package: \advance\totalheight2\p@ % "+2"
                if (/box/.test(label)) {
                    ruleThickness = Math.max(options.fontMetrics().fboxrule, options.minRuleThickness // User override.
                    );
                    topPad = options.fontMetrics().fboxsep + (label === "colorbox" ? 0 : ruleThickness);
                    bottomPad = topPad;
                } else if (label === "angl") {
                    ruleThickness = Math.max(options.fontMetrics().defaultRuleThickness, options.minRuleThickness);
                    topPad = 4 * ruleThickness; // gap = 3 × line, plus the line itself.
                    bottomPad = Math.max(0, 0.25 - inner.depth);
                } else {
                    topPad = isSingleChar ? 0.2 : 0;
                    bottomPad = topPad;
                }
                img = stretchy.encloseSpan(inner, label, topPad, bottomPad, options);
                if (/fbox|boxed|fcolorbox/.test(label)) {
                    img.style.borderStyle = "solid";
                    img.style.borderWidth = makeEm(ruleThickness);
                } else if (label === "angl" && ruleThickness !== 0.049) {
                    img.style.borderTopWidth = makeEm(ruleThickness);
                    img.style.borderRightWidth = makeEm(ruleThickness);
                }
                imgShift = inner.depth + bottomPad;
                if (group.backgroundColor) {
                    img.style.backgroundColor = group.backgroundColor;
                    if (group.borderColor) img.style.borderColor = group.borderColor;
                }
            }
            let vlist;
            if (group.backgroundColor) vlist = buildCommon.makeVList({
                positionType: "individualShift",
                children: [
                    {
                        type: "elem",
                        elem: img,
                        shift: imgShift
                    },
                    {
                        type: "elem",
                        elem: inner,
                        shift: 0
                    }
                ]
            }, options);
            else {
                const classes = /cancel|phase/.test(label) ? [
                    "svg-align"
                ] : [];
                vlist = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: [
                        {
                            type: "elem",
                            elem: inner,
                            shift: 0
                        },
                        {
                            type: "elem",
                            elem: img,
                            shift: imgShift,
                            wrapperClasses: classes
                        }
                    ]
                }, options);
            }
            if (/cancel/.test(label)) {
                // The cancel package documentation says that cancel lines add their height
                // to the expression, but tests show that isn't how it actually works.
                vlist.height = inner.height;
                vlist.depth = inner.depth;
            }
            if (/cancel/.test(label) && !isSingleChar) // cancel does not create horiz space for its line extension.
            return buildCommon.makeSpan([
                "mord",
                "cancel-lap"
            ], [
                vlist
            ], options);
            else return buildCommon.makeSpan([
                "mord"
            ], [
                vlist
            ], options);
        };
        const enclose_mathmlBuilder = (group, options)=>{
            let fboxsep = 0;
            const node = new mathMLTree.MathNode(group.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [
                buildMathML_buildGroup(group.body, options)
            ]);
            switch(group.label){
                case "\\cancel":
                    node.setAttribute("notation", "updiagonalstrike");
                    break;
                case "\\bcancel":
                    node.setAttribute("notation", "downdiagonalstrike");
                    break;
                case "\\phase":
                    node.setAttribute("notation", "phasorangle");
                    break;
                case "\\sout":
                    node.setAttribute("notation", "horizontalstrike");
                    break;
                case "\\fbox":
                    node.setAttribute("notation", "box");
                    break;
                case "\\angl":
                    node.setAttribute("notation", "actuarial");
                    break;
                case "\\fcolorbox":
                case "\\colorbox":
                    // <menclose> doesn't have a good notation option. So use <mpadded>
                    // instead. Set some attributes that come included with <menclose>.
                    fboxsep = options.fontMetrics().fboxsep * options.fontMetrics().ptPerEm;
                    node.setAttribute("width", "+" + 2 * fboxsep + "pt");
                    node.setAttribute("height", "+" + 2 * fboxsep + "pt");
                    node.setAttribute("lspace", fboxsep + "pt"); //
                    node.setAttribute("voffset", fboxsep + "pt");
                    if (group.label === "\\fcolorbox") {
                        const thk = Math.max(options.fontMetrics().fboxrule, options.minRuleThickness // user override
                        );
                        node.setAttribute("style", "border: " + thk + "em solid " + String(group.borderColor));
                    }
                    break;
                case "\\xcancel":
                    node.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
                    break;
            }
            if (group.backgroundColor) node.setAttribute("mathbackground", group.backgroundColor);
            return node;
        };
        defineFunction({
            type: "enclose",
            names: [
                "\\colorbox"
            ],
            props: {
                numArgs: 2,
                allowedInText: true,
                argTypes: [
                    "color",
                    "text"
                ]
            },
            handler (_ref, args, optArgs) {
                let { parser: parser, funcName: funcName } = _ref;
                const color = assertNodeType(args[0], "color-token").color;
                const body = args[1];
                return {
                    type: "enclose",
                    mode: parser.mode,
                    label: funcName,
                    backgroundColor: color,
                    body: body
                };
            },
            htmlBuilder: enclose_htmlBuilder,
            mathmlBuilder: enclose_mathmlBuilder
        });
        defineFunction({
            type: "enclose",
            names: [
                "\\fcolorbox"
            ],
            props: {
                numArgs: 3,
                allowedInText: true,
                argTypes: [
                    "color",
                    "color",
                    "text"
                ]
            },
            handler (_ref2, args, optArgs) {
                let { parser: parser, funcName: funcName } = _ref2;
                const borderColor = assertNodeType(args[0], "color-token").color;
                const backgroundColor = assertNodeType(args[1], "color-token").color;
                const body = args[2];
                return {
                    type: "enclose",
                    mode: parser.mode,
                    label: funcName,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    body: body
                };
            },
            htmlBuilder: enclose_htmlBuilder,
            mathmlBuilder: enclose_mathmlBuilder
        });
        defineFunction({
            type: "enclose",
            names: [
                "\\fbox"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "hbox"
                ],
                allowedInText: true
            },
            handler (_ref3, args) {
                let { parser: parser } = _ref3;
                return {
                    type: "enclose",
                    mode: parser.mode,
                    label: "\\fbox",
                    body: args[0]
                };
            }
        });
        defineFunction({
            type: "enclose",
            names: [
                "\\cancel",
                "\\bcancel",
                "\\xcancel",
                "\\sout",
                "\\phase"
            ],
            props: {
                numArgs: 1
            },
            handler (_ref4, args) {
                let { parser: parser, funcName: funcName } = _ref4;
                const body = args[0];
                return {
                    type: "enclose",
                    mode: parser.mode,
                    label: funcName,
                    body: body
                };
            },
            htmlBuilder: enclose_htmlBuilder,
            mathmlBuilder: enclose_mathmlBuilder
        });
        defineFunction({
            type: "enclose",
            names: [
                "\\angl"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "hbox"
                ],
                allowedInText: false
            },
            handler (_ref5, args) {
                let { parser: parser } = _ref5;
                return {
                    type: "enclose",
                    mode: parser.mode,
                    label: "\\angl",
                    body: args[0]
                };
            }
        });
        /**
 * All registered environments.
 * `environments.js` exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary via `environments.js`.
 */ const _environments = {};
        function defineEnvironment(_ref) {
            let { type: type, names: names, props: props, handler: handler, htmlBuilder: htmlBuilder, mathmlBuilder: mathmlBuilder } = _ref;
            // Set default values of environments.
            const data = {
                type: type,
                numArgs: props.numArgs || 0,
                allowedInText: false,
                numOptionalArgs: 0,
                handler: handler
            };
            for(let i = 0; i < names.length; ++i)// TODO: The value type of _environments should be a type union of all
            // possible `EnvSpec<>` possibilities instead of `EnvSpec<*>`, which is
            // an existential type.
            _environments[names[i]] = data;
            if (htmlBuilder) _htmlGroupBuilders[type] = htmlBuilder;
            if (mathmlBuilder) _mathmlGroupBuilders[type] = mathmlBuilder;
        }
        /**
 * All registered global/built-in macros.
 * `macros.js` exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary via `macros.js`.
 */ const _macros = {}; // This function might one day accept an additional argument and do more things.
        function defineMacro(name, body) {
            _macros[name] = body;
        }
        /**
 * Lexing or parsing positional information for error reporting.
 * This object is immutable.
 */ class SourceLocation {
            // The + prefix indicates that these fields aren't writeable
            // Lexer holding the input string.
            // Start offset, zero-based inclusive.
            // End offset, zero-based exclusive.
            constructor(lexer, start, end){
                this.lexer = void 0;
                this.start = void 0;
                this.end = void 0;
                this.lexer = lexer;
                this.start = start;
                this.end = end;
            }
            /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */ static range(first, second) {
                if (!second) return first && first.loc;
                else if (!first || !first.loc || !second.loc || first.loc.lexer !== second.loc.lexer) return null;
                else return new SourceLocation(first.loc.lexer, first.loc.start, second.loc.end);
            }
        }
        /**
 * Interface required to break circular dependency between Token, Lexer, and
 * ParseError.
 */ /**
 * The resulting token returned from `lex`.
 *
 * It consists of the token text plus some position information.
 * The position information is essentially a range in an input string,
 * but instead of referencing the bare input string, we refer to the lexer.
 * That way it is possible to attach extra metadata to the input string,
 * like for example a file name or similar.
 *
 * The position information is optional, so it is OK to construct synthetic
 * tokens if appropriate. Not providing available position information may
 * lead to degraded error reporting, though.
 */ class Token {
            // don't expand the token
            // used in \noexpand
            constructor(text, loc){
                this.text = void 0;
                this.loc = void 0;
                this.noexpand = void 0;
                this.treatAsRelax = void 0;
                this.text = text;
                this.loc = loc;
            }
            /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */ range(endToken, text // the text of the newly constructed token
            ) {
                return new Token(text, SourceLocation.range(this, endToken));
            }
        }
        // Helper functions
        function getHLines(parser) {
            // Return an array. The array length = number of hlines.
            // Each element in the array tells if the line is dashed.
            const hlineInfo = [];
            parser.consumeSpaces();
            let nxt = parser.fetch().text;
            if (nxt === "\\relax") {
                // \relax is an artifact of the \cr macro below
                parser.consume();
                parser.consumeSpaces();
                nxt = parser.fetch().text;
            }
            while(nxt === "\\hline" || nxt === "\\hdashline"){
                parser.consume();
                hlineInfo.push(nxt === "\\hdashline");
                parser.consumeSpaces();
                nxt = parser.fetch().text;
            }
            return hlineInfo;
        }
        const validateAmsEnvironmentContext = (context)=>{
            const settings = context.parser.settings;
            if (!settings.displayMode) throw new src_ParseError("{" + context.envName + "} can be used only in" + " display mode.");
        }; // autoTag (an argument to parseArray) can be one of three values:
        // * undefined: Regular (not-top-level) array; no tags on each row
        // * true: Automatic equation numbering, overridable by \tag
        // * false: Tags allowed on each row, but no automatic numbering
        // This function *doesn't* work with the "split" environment name.
        function getAutoTag(name) {
            if (name.indexOf("ed") === -1) return name.indexOf("*") === -1;
             // return undefined;
        }
        /**
 * Parse the body of the environment, with rows delimited by \\ and
 * columns delimited by &, and create a nested list in row-major order
 * with one group per cell.  If given an optional argument style
 * ("text", "display", etc.), then each cell is cast into that style.
 */ function parseArray(parser, _ref, style) {
            let { hskipBeforeAndAfter: hskipBeforeAndAfter, addJot: addJot, cols: cols, arraystretch: arraystretch, colSeparationType: colSeparationType, autoTag: autoTag, singleRow: singleRow, emptySingleRow: emptySingleRow, maxNumCols: maxNumCols, leqno: leqno } = _ref;
            parser.gullet.beginGroup();
            if (!singleRow) // \cr is equivalent to \\ without the optional size argument (see below)
            // TODO: provide helpful error when \cr is used outside array environment
            parser.gullet.macros.set("\\cr", "\\\\\\relax");
             // Get current arraystretch if it's not set by the environment
            if (!arraystretch) {
                const stretch = parser.gullet.expandMacroAsText("\\arraystretch");
                if (stretch == null) // Default \arraystretch from lttab.dtx
                arraystretch = 1;
                else {
                    arraystretch = parseFloat(stretch);
                    if (!arraystretch || arraystretch < 0) throw new src_ParseError("Invalid \\arraystretch: " + stretch);
                }
            } // Start group for first cell
            parser.gullet.beginGroup();
            let row = [];
            const body = [
                row
            ];
            const rowGaps = [];
            const hLinesBeforeRow = [];
            const tags = autoTag != null ? [] : undefined; // amsmath uses \global\@eqnswtrue and \global\@eqnswfalse to represent
            // whether this row should have an equation number.  Simulate this with
            // a \@eqnsw macro set to 1 or 0.
            function beginRow() {
                if (autoTag) parser.gullet.macros.set("\\@eqnsw", "1", true);
            }
            function endRow() {
                if (tags) {
                    if (parser.gullet.macros.get("\\df@tag")) {
                        tags.push(parser.subparse([
                            new Token("\\df@tag")
                        ]));
                        parser.gullet.macros.set("\\df@tag", undefined, true);
                    } else tags.push(Boolean(autoTag) && parser.gullet.macros.get("\\@eqnsw") === "1");
                }
            }
            beginRow(); // Test for \hline at the top of the array.
            hLinesBeforeRow.push(getHLines(parser));
            while(true){
                // eslint-disable-line no-constant-condition
                // Parse each cell in its own group (namespace)
                let cell = parser.parseExpression(false, singleRow ? "\\end" : "\\\\");
                parser.gullet.endGroup();
                parser.gullet.beginGroup();
                cell = {
                    type: "ordgroup",
                    mode: parser.mode,
                    body: cell
                };
                if (style) cell = {
                    type: "styling",
                    mode: parser.mode,
                    style: style,
                    body: [
                        cell
                    ]
                };
                row.push(cell);
                const next = parser.fetch().text;
                if (next === "&") {
                    if (maxNumCols && row.length === maxNumCols) {
                        if (singleRow || colSeparationType) // {equation} or {split}
                        throw new src_ParseError("Too many tab characters: &", parser.nextToken);
                        else // {array} environment
                        parser.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
                    }
                    parser.consume();
                } else if (next === "\\end") {
                    endRow(); // Arrays terminate newlines with `\crcr` which consumes a `\cr` if
                    // the last line is empty.  However, AMS environments keep the
                    // empty row if it's the only one.
                    // NOTE: Currently, `cell` is the last item added into `row`.
                    if (row.length === 1 && cell.type === "styling" && cell.body[0].body.length === 0 && (body.length > 1 || !emptySingleRow)) body.pop();
                    if (hLinesBeforeRow.length < body.length + 1) hLinesBeforeRow.push([]);
                    break;
                } else if (next === "\\\\") {
                    parser.consume();
                    let size; // \def\Let@{\let\\\math@cr}
                    // \def\math@cr{...\math@cr@}
                    // \def\math@cr@{\new@ifnextchar[\math@cr@@{\math@cr@@[\z@]}}
                    // \def\math@cr@@[#1]{...\math@cr@@@...}
                    // \def\math@cr@@@{\cr}
                    if (parser.gullet.future().text !== " ") size = parser.parseSizeGroup(true);
                    rowGaps.push(size ? size.value : null);
                    endRow(); // check for \hline(s) following the row separator
                    hLinesBeforeRow.push(getHLines(parser));
                    row = [];
                    body.push(row);
                    beginRow();
                } else throw new src_ParseError("Expected & or \\\\ or \\cr or \\end", parser.nextToken);
            } // End cell group
            parser.gullet.endGroup(); // End array group defining \cr
            parser.gullet.endGroup();
            return {
                type: "array",
                mode: parser.mode,
                addJot: addJot,
                arraystretch: arraystretch,
                body: body,
                cols: cols,
                rowGaps: rowGaps,
                hskipBeforeAndAfter: hskipBeforeAndAfter,
                hLinesBeforeRow: hLinesBeforeRow,
                colSeparationType: colSeparationType,
                tags: tags,
                leqno: leqno
            };
        } // Decides on a style for cells in an array according to whether the given
        // environment name starts with the letter 'd'.
        function dCellStyle(envName) {
            if (envName.slice(0, 1) === "d") return "display";
            else return "text";
        }
        const array_htmlBuilder = function(group, options) {
            let r;
            let c;
            const nr = group.body.length;
            const hLinesBeforeRow = group.hLinesBeforeRow;
            let nc = 0;
            let body = new Array(nr);
            const hlines = [];
            const ruleThickness = Math.max(options.fontMetrics().arrayRuleWidth, options.minRuleThickness // User override.
            ); // Horizontal spacing
            const pt = 1 / options.fontMetrics().ptPerEm;
            let arraycolsep = 5 * pt; // default value, i.e. \arraycolsep in article.cls
            if (group.colSeparationType && group.colSeparationType === "small") {
                // We're in a {smallmatrix}. Default column space is \thickspace,
                // i.e. 5/18em = 0.2778em, per amsmath.dtx for {smallmatrix}.
                // But that needs adjustment because LaTeX applies \scriptstyle to the
                // entire array, including the colspace, but this function applies
                // \scriptstyle only inside each element.
                const localMultiplier = options.havingStyle(src_Style.SCRIPT).sizeMultiplier;
                arraycolsep = 0.2778 * (localMultiplier / options.sizeMultiplier);
            } // Vertical spacing
            const baselineskip = group.colSeparationType === "CD" ? calculateSize({
                number: 3,
                unit: "ex"
            }, options) : 12 * pt; // see size10.clo
            // Default \jot from ltmath.dtx
            // TODO(edemaine): allow overriding \jot via \setlength (#687)
            const jot = 3 * pt;
            const arrayskip = group.arraystretch * baselineskip;
            const arstrutHeight = 0.7 * arrayskip; // \strutbox in ltfsstrc.dtx and
            const arstrutDepth = 0.3 * arrayskip; // \@arstrutbox in lttab.dtx
            let totalHeight = 0; // Set a position for \hline(s) at the top of the array, if any.
            function setHLinePos(hlinesInGap) {
                for(let i = 0; i < hlinesInGap.length; ++i){
                    if (i > 0) totalHeight += 0.25;
                    hlines.push({
                        pos: totalHeight,
                        isDashed: hlinesInGap[i]
                    });
                }
            }
            setHLinePos(hLinesBeforeRow[0]);
            for(r = 0; r < group.body.length; ++r){
                const inrow = group.body[r];
                let height = arstrutHeight; // \@array adds an \@arstrut
                let depth = arstrutDepth; // to each tow (via the template)
                if (nc < inrow.length) nc = inrow.length;
                const outrow = new Array(inrow.length);
                for(c = 0; c < inrow.length; ++c){
                    const elt = buildGroup(inrow[c], options);
                    if (depth < elt.depth) depth = elt.depth;
                    if (height < elt.height) height = elt.height;
                    outrow[c] = elt;
                }
                const rowGap = group.rowGaps[r];
                let gap = 0;
                if (rowGap) {
                    gap = calculateSize(rowGap, options);
                    if (gap > 0) {
                        // \@argarraycr
                        gap += arstrutDepth;
                        if (depth < gap) depth = gap; // \@xargarraycr
                        gap = 0;
                    }
                } // In AMS multiline environments such as aligned and gathered, rows
                // correspond to lines that have additional \jot added to the
                // \baselineskip via \openup.
                if (group.addJot) depth += jot;
                outrow.height = height;
                outrow.depth = depth;
                totalHeight += height;
                outrow.pos = totalHeight;
                totalHeight += depth + gap; // \@yargarraycr
                body[r] = outrow; // Set a position for \hline(s), if any.
                setHLinePos(hLinesBeforeRow[r + 1]);
            }
            const offset = totalHeight / 2 + options.fontMetrics().axisHeight;
            const colDescriptions = group.cols || [];
            const cols = [];
            let colSep;
            let colDescrNum;
            const tagSpans = [];
            if (group.tags && group.tags.some((tag)=>tag)) // An environment with manual tags and/or automatic equation numbers.
            // Create node(s), the latter of which trigger CSS counter increment.
            for(r = 0; r < nr; ++r){
                const rw = body[r];
                const shift = rw.pos - offset;
                const tag = group.tags[r];
                let tagSpan;
                if (tag === true) // automatic numbering
                tagSpan = buildCommon.makeSpan([
                    "eqn-num"
                ], [], options);
                else if (tag === false) // \nonumber/\notag or starred environment
                tagSpan = buildCommon.makeSpan([], [], options);
                else // manual \tag
                tagSpan = buildCommon.makeSpan([], buildExpression(tag, options, true), options);
                tagSpan.depth = rw.depth;
                tagSpan.height = rw.height;
                tagSpans.push({
                    type: "elem",
                    elem: tagSpan,
                    shift: shift
                });
            }
            for(c = 0, colDescrNum = 0; // descriptions, so trailing separators don't get lost.
            c < nc || colDescrNum < colDescriptions.length; ++c, ++colDescrNum){
                let colDescr = colDescriptions[colDescrNum] || {};
                let firstSeparator = true;
                while(colDescr.type === "separator"){
                    // If there is more than one separator in a row, add a space
                    // between them.
                    if (!firstSeparator) {
                        colSep = buildCommon.makeSpan([
                            "arraycolsep"
                        ], []);
                        colSep.style.width = makeEm(options.fontMetrics().doubleRuleSep);
                        cols.push(colSep);
                    }
                    if (colDescr.separator === "|" || colDescr.separator === ":") {
                        const lineType = colDescr.separator === "|" ? "solid" : "dashed";
                        const separator = buildCommon.makeSpan([
                            "vertical-separator"
                        ], [], options);
                        separator.style.height = makeEm(totalHeight);
                        separator.style.borderRightWidth = makeEm(ruleThickness);
                        separator.style.borderRightStyle = lineType;
                        separator.style.margin = "0 " + makeEm(-ruleThickness / 2);
                        const shift = totalHeight - offset;
                        if (shift) separator.style.verticalAlign = makeEm(-shift);
                        cols.push(separator);
                    } else throw new src_ParseError("Invalid separator type: " + colDescr.separator);
                    colDescrNum++;
                    colDescr = colDescriptions[colDescrNum] || {};
                    firstSeparator = false;
                }
                if (c >= nc) continue;
                let sepwidth;
                if (c > 0 || group.hskipBeforeAndAfter) {
                    sepwidth = utils.deflt(colDescr.pregap, arraycolsep);
                    if (sepwidth !== 0) {
                        colSep = buildCommon.makeSpan([
                            "arraycolsep"
                        ], []);
                        colSep.style.width = makeEm(sepwidth);
                        cols.push(colSep);
                    }
                }
                let col = [];
                for(r = 0; r < nr; ++r){
                    const row = body[r];
                    const elem = row[c];
                    if (!elem) continue;
                    const shift = row.pos - offset;
                    elem.depth = row.depth;
                    elem.height = row.height;
                    col.push({
                        type: "elem",
                        elem: elem,
                        shift: shift
                    });
                }
                col = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: col
                }, options);
                col = buildCommon.makeSpan([
                    "col-align-" + (colDescr.align || "c")
                ], [
                    col
                ]);
                cols.push(col);
                if (c < nc - 1 || group.hskipBeforeAndAfter) {
                    sepwidth = utils.deflt(colDescr.postgap, arraycolsep);
                    if (sepwidth !== 0) {
                        colSep = buildCommon.makeSpan([
                            "arraycolsep"
                        ], []);
                        colSep.style.width = makeEm(sepwidth);
                        cols.push(colSep);
                    }
                }
            }
            body = buildCommon.makeSpan([
                "mtable"
            ], cols); // Add \hline(s), if any.
            if (hlines.length > 0) {
                const line = buildCommon.makeLineSpan("hline", options, ruleThickness);
                const dashes = buildCommon.makeLineSpan("hdashline", options, ruleThickness);
                const vListElems = [
                    {
                        type: "elem",
                        elem: body,
                        shift: 0
                    }
                ];
                while(hlines.length > 0){
                    const hline = hlines.pop();
                    const lineShift = hline.pos - offset;
                    if (hline.isDashed) vListElems.push({
                        type: "elem",
                        elem: dashes,
                        shift: lineShift
                    });
                    else vListElems.push({
                        type: "elem",
                        elem: line,
                        shift: lineShift
                    });
                }
                body = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: vListElems
                }, options);
            }
            if (tagSpans.length === 0) return buildCommon.makeSpan([
                "mord"
            ], [
                body
            ], options);
            else {
                let eqnNumCol = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: tagSpans
                }, options);
                eqnNumCol = buildCommon.makeSpan([
                    "tag"
                ], [
                    eqnNumCol
                ], options);
                return buildCommon.makeFragment([
                    body,
                    eqnNumCol
                ]);
            }
        };
        const alignMap = {
            c: "center ",
            l: "left ",
            r: "right "
        };
        const array_mathmlBuilder = function(group, options) {
            const tbl = [];
            const glue = new mathMLTree.MathNode("mtd", [], [
                "mtr-glue"
            ]);
            const tag = new mathMLTree.MathNode("mtd", [], [
                "mml-eqn-num"
            ]);
            for(let i = 0; i < group.body.length; i++){
                const rw = group.body[i];
                const row = [];
                for(let j = 0; j < rw.length; j++)row.push(new mathMLTree.MathNode("mtd", [
                    buildMathML_buildGroup(rw[j], options)
                ]));
                if (group.tags && group.tags[i]) {
                    row.unshift(glue);
                    row.push(glue);
                    if (group.leqno) row.unshift(tag);
                    else row.push(tag);
                }
                tbl.push(new mathMLTree.MathNode("mtr", row));
            }
            let table = new mathMLTree.MathNode("mtable", tbl); // Set column alignment, row spacing, column spacing, and
            // array lines by setting attributes on the table element.
            // Set the row spacing. In MathML, we specify a gap distance.
            // We do not use rowGap[] because MathML automatically increases
            // cell height with the height/depth of the element content.
            // LaTeX \arraystretch multiplies the row baseline-to-baseline distance.
            // We simulate this by adding (arraystretch - 1)em to the gap. This
            // does a reasonable job of adjusting arrays containing 1 em tall content.
            // The 0.16 and 0.09 values are found empirically. They produce an array
            // similar to LaTeX and in which content does not interfere with \hlines.
            const gap = group.arraystretch === 0.5 ? 0.1 // {smallmatrix}, {subarray}
             : 0.16 + group.arraystretch - 1 + (group.addJot ? 0.09 : 0);
            table.setAttribute("rowspacing", makeEm(gap)); // MathML table lines go only between cells.
            // To place a line on an edge we'll use <menclose>, if necessary.
            let menclose = "";
            let align = "";
            if (group.cols && group.cols.length > 0) {
                // Find column alignment, column spacing, and  vertical lines.
                const cols = group.cols;
                let columnLines = "";
                let prevTypeWasAlign = false;
                let iStart = 0;
                let iEnd = cols.length;
                if (cols[0].type === "separator") {
                    menclose += "top ";
                    iStart = 1;
                }
                if (cols[cols.length - 1].type === "separator") {
                    menclose += "bottom ";
                    iEnd -= 1;
                }
                for(let i = iStart; i < iEnd; i++){
                    if (cols[i].type === "align") {
                        align += alignMap[cols[i].align];
                        if (prevTypeWasAlign) columnLines += "none ";
                        prevTypeWasAlign = true;
                    } else if (cols[i].type === "separator") // MathML accepts only single lines between cells.
                    // So we read only the first of consecutive separators.
                    {
                        if (prevTypeWasAlign) {
                            columnLines += cols[i].separator === "|" ? "solid " : "dashed ";
                            prevTypeWasAlign = false;
                        }
                    }
                }
                table.setAttribute("columnalign", align.trim());
                if (/[sd]/.test(columnLines)) table.setAttribute("columnlines", columnLines.trim());
            } // Set column spacing.
            if (group.colSeparationType === "align") {
                const cols = group.cols || [];
                let spacing = "";
                for(let i = 1; i < cols.length; i++)spacing += i % 2 ? "0em " : "1em ";
                table.setAttribute("columnspacing", spacing.trim());
            } else if (group.colSeparationType === "alignat" || group.colSeparationType === "gather") table.setAttribute("columnspacing", "0em");
            else if (group.colSeparationType === "small") table.setAttribute("columnspacing", "0.2778em");
            else if (group.colSeparationType === "CD") table.setAttribute("columnspacing", "0.5em");
            else table.setAttribute("columnspacing", "1em");
             // Address \hline and \hdashline
            let rowLines = "";
            const hlines = group.hLinesBeforeRow;
            menclose += hlines[0].length > 0 ? "left " : "";
            menclose += hlines[hlines.length - 1].length > 0 ? "right " : "";
            for(let i = 1; i < hlines.length - 1; i++)rowLines += hlines[i].length === 0 ? "none " // MathML accepts only a single line between rows. Read one element.
             : hlines[i][0] ? "dashed " : "solid ";
            if (/[sd]/.test(rowLines)) table.setAttribute("rowlines", rowLines.trim());
            if (menclose !== "") {
                table = new mathMLTree.MathNode("menclose", [
                    table
                ]);
                table.setAttribute("notation", menclose.trim());
            }
            if (group.arraystretch && group.arraystretch < 1) {
                // A small array. Wrap in scriptstyle so row gap is not too large.
                table = new mathMLTree.MathNode("mstyle", [
                    table
                ]);
                table.setAttribute("scriptlevel", "1");
            }
            return table;
        }; // Convenience function for align, align*, aligned, alignat, alignat*, alignedat.
        const alignedHandler = function(context, args) {
            if (context.envName.indexOf("ed") === -1) validateAmsEnvironmentContext(context);
            const cols = [];
            const separationType = context.envName.indexOf("at") > -1 ? "alignat" : "align";
            const isSplit = context.envName === "split";
            const res = parseArray(context.parser, {
                cols: cols,
                addJot: true,
                autoTag: isSplit ? undefined : getAutoTag(context.envName),
                emptySingleRow: true,
                colSeparationType: separationType,
                maxNumCols: isSplit ? 2 : undefined,
                leqno: context.parser.settings.leqno
            }, "display"); // Determining number of columns.
            // 1. If the first argument is given, we use it as a number of columns,
            //    and makes sure that each row doesn't exceed that number.
            // 2. Otherwise, just count number of columns = maximum number
            //    of cells in each row ("aligned" mode -- isAligned will be true).
            //
            // At the same time, prepend empty group {} at beginning of every second
            // cell in each row (starting with second cell) so that operators become
            // binary.  This behavior is implemented in amsmath's \start@aligned.
            let numMaths;
            let numCols = 0;
            const emptyGroup = {
                type: "ordgroup",
                mode: context.mode,
                body: []
            };
            if (args[0] && args[0].type === "ordgroup") {
                let arg0 = "";
                for(let i = 0; i < args[0].body.length; i++){
                    const textord = assertNodeType(args[0].body[i], "textord");
                    arg0 += textord.text;
                }
                numMaths = Number(arg0);
                numCols = numMaths * 2;
            }
            const isAligned = !numCols;
            res.body.forEach(function(row) {
                for(let i = 1; i < row.length; i += 2){
                    // Modify ordgroup node within styling node
                    const styling = assertNodeType(row[i], "styling");
                    const ordgroup = assertNodeType(styling.body[0], "ordgroup");
                    ordgroup.body.unshift(emptyGroup);
                }
                if (!isAligned) {
                    // Case 1
                    const curMaths = row.length / 2;
                    if (numMaths < curMaths) throw new src_ParseError("Too many math in a row: " + ("expected " + numMaths + ", but got " + curMaths), row[0]);
                } else if (numCols < row.length) // Case 2
                numCols = row.length;
            }); // Adjusting alignment.
            // In aligned mode, we add one \qquad between columns;
            // otherwise we add nothing.
            for(let i = 0; i < numCols; ++i){
                let align = "r";
                let pregap = 0;
                if (i % 2 === 1) align = "l";
                else if (i > 0 && isAligned) // "aligned" mode.
                pregap = 1; // add one \quad
                cols[i] = {
                    type: "align",
                    align: align,
                    pregap: pregap,
                    postgap: 0
                };
            }
            res.colSeparationType = isAligned ? "align" : "alignat";
            return res;
        }; // Arrays are part of LaTeX, defined in lttab.dtx so its documentation
        // is part of the source2e.pdf file of LaTeX2e source documentation.
        // {darray} is an {array} environment where cells are set in \displaystyle,
        // as defined in nccmath.sty.
        defineEnvironment({
            type: "array",
            names: [
                "array",
                "darray"
            ],
            props: {
                numArgs: 1
            },
            handler (context, args) {
                // Since no types are specified above, the two possibilities are
                // - The argument is wrapped in {} or [], in which case Parser's
                //   parseGroup() returns an "ordgroup" wrapping some symbol node.
                // - The argument is a bare symbol node.
                const symNode = checkSymbolNodeType(args[0]);
                const colalign = symNode ? [
                    args[0]
                ] : assertNodeType(args[0], "ordgroup").body;
                const cols = colalign.map(function(nde) {
                    const node = assertSymbolNodeType(nde);
                    const ca = node.text;
                    if ("lcr".indexOf(ca) !== -1) return {
                        type: "align",
                        align: ca
                    };
                    else if (ca === "|") return {
                        type: "separator",
                        separator: "|"
                    };
                    else if (ca === ":") return {
                        type: "separator",
                        separator: ":"
                    };
                    throw new src_ParseError("Unknown column alignment: " + ca, nde);
                });
                const res = {
                    cols: cols,
                    hskipBeforeAndAfter: true,
                    // \@preamble in lttab.dtx
                    maxNumCols: cols.length
                };
                return parseArray(context.parser, res, dCellStyle(context.envName));
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        }); // The matrix environments of amsmath builds on the array environment
        // of LaTeX, which is discussed above.
        // The mathtools package adds starred versions of the same environments.
        // These have an optional argument to choose left|center|right justification.
        defineEnvironment({
            type: "array",
            names: [
                "matrix",
                "pmatrix",
                "bmatrix",
                "Bmatrix",
                "vmatrix",
                "Vmatrix",
                "matrix*",
                "pmatrix*",
                "bmatrix*",
                "Bmatrix*",
                "vmatrix*",
                "Vmatrix*"
            ],
            props: {
                numArgs: 0
            },
            handler (context) {
                const delimiters = {
                    "matrix": null,
                    "pmatrix": [
                        "(",
                        ")"
                    ],
                    "bmatrix": [
                        "[",
                        "]"
                    ],
                    "Bmatrix": [
                        "\\{",
                        "\\}"
                    ],
                    "vmatrix": [
                        "|",
                        "|"
                    ],
                    "Vmatrix": [
                        "\\Vert",
                        "\\Vert"
                    ]
                }[context.envName.replace("*", "")]; // \hskip -\arraycolsep in amsmath
                let colAlign = "c";
                const payload = {
                    hskipBeforeAndAfter: false,
                    cols: [
                        {
                            type: "align",
                            align: colAlign
                        }
                    ]
                };
                if (context.envName.charAt(context.envName.length - 1) === "*") {
                    // It's one of the mathtools starred functions.
                    // Parse the optional alignment argument.
                    const parser = context.parser;
                    parser.consumeSpaces();
                    if (parser.fetch().text === "[") {
                        parser.consume();
                        parser.consumeSpaces();
                        colAlign = parser.fetch().text;
                        if ("lcr".indexOf(colAlign) === -1) throw new src_ParseError("Expected l or c or r", parser.nextToken);
                        parser.consume();
                        parser.consumeSpaces();
                        parser.expect("]");
                        parser.consume();
                        payload.cols = [
                            {
                                type: "align",
                                align: colAlign
                            }
                        ];
                    }
                }
                const res = parseArray(context.parser, payload, dCellStyle(context.envName)); // Populate cols with the correct number of column alignment specs.
                const numCols = Math.max(0, ...res.body.map((row)=>row.length));
                res.cols = new Array(numCols).fill({
                    type: "align",
                    align: colAlign
                });
                return delimiters ? {
                    type: "leftright",
                    mode: context.mode,
                    body: [
                        res
                    ],
                    left: delimiters[0],
                    right: delimiters[1],
                    rightColor: undefined // \right uninfluenced by \color in array
                } : res;
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        });
        defineEnvironment({
            type: "array",
            names: [
                "smallmatrix"
            ],
            props: {
                numArgs: 0
            },
            handler (context) {
                const payload = {
                    arraystretch: 0.5
                };
                const res = parseArray(context.parser, payload, "script");
                res.colSeparationType = "small";
                return res;
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        });
        defineEnvironment({
            type: "array",
            names: [
                "subarray"
            ],
            props: {
                numArgs: 1
            },
            handler (context, args) {
                // Parsing of {subarray} is similar to {array}
                const symNode = checkSymbolNodeType(args[0]);
                const colalign = symNode ? [
                    args[0]
                ] : assertNodeType(args[0], "ordgroup").body;
                const cols = colalign.map(function(nde) {
                    const node = assertSymbolNodeType(nde);
                    const ca = node.text; // {subarray} only recognizes "l" & "c"
                    if ("lc".indexOf(ca) !== -1) return {
                        type: "align",
                        align: ca
                    };
                    throw new src_ParseError("Unknown column alignment: " + ca, nde);
                });
                if (cols.length > 1) throw new src_ParseError("{subarray} can contain only one column");
                let res = {
                    cols: cols,
                    hskipBeforeAndAfter: false,
                    arraystretch: 0.5
                };
                res = parseArray(context.parser, res, "script");
                if (res.body.length > 0 && res.body[0].length > 1) throw new src_ParseError("{subarray} can contain only one column");
                return res;
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        }); // A cases environment (in amsmath.sty) is almost equivalent to
        // \def\arraystretch{1.2}%
        // \left\{\begin{array}{@{}l@{\quad}l@{}} … \end{array}\right.
        // {dcases} is a {cases} environment where cells are set in \displaystyle,
        // as defined in mathtools.sty.
        // {rcases} is another mathtools environment. It's brace is on the right side.
        defineEnvironment({
            type: "array",
            names: [
                "cases",
                "dcases",
                "rcases",
                "drcases"
            ],
            props: {
                numArgs: 0
            },
            handler (context) {
                const payload = {
                    arraystretch: 1.2,
                    cols: [
                        {
                            type: "align",
                            align: "l",
                            pregap: 0,
                            // TODO(kevinb) get the current style.
                            // For now we use the metrics for TEXT style which is what we were
                            // doing before.  Before attempting to get the current style we
                            // should look at TeX's behavior especially for \over and matrices.
                            postgap: 1.0
                        },
                        {
                            type: "align",
                            align: "l",
                            pregap: 0,
                            postgap: 0
                        }
                    ]
                };
                const res = parseArray(context.parser, payload, dCellStyle(context.envName));
                return {
                    type: "leftright",
                    mode: context.mode,
                    body: [
                        res
                    ],
                    left: context.envName.indexOf("r") > -1 ? "." : "\\{",
                    right: context.envName.indexOf("r") > -1 ? "\\}" : ".",
                    rightColor: undefined
                };
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        }); // In the align environment, one uses ampersands, &, to specify number of
        // columns in each row, and to locate spacing between each column.
        // align gets automatic numbering. align* and aligned do not.
        // The alignedat environment can be used in math mode.
        // Note that we assume \nomallineskiplimit to be zero,
        // so that \strut@ is the same as \strut.
        defineEnvironment({
            type: "array",
            names: [
                "align",
                "align*",
                "aligned",
                "split"
            ],
            props: {
                numArgs: 0
            },
            handler: alignedHandler,
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        }); // A gathered environment is like an array environment with one centered
        // column, but where rows are considered lines so get \jot line spacing
        // and contents are set in \displaystyle.
        defineEnvironment({
            type: "array",
            names: [
                "gathered",
                "gather",
                "gather*"
            ],
            props: {
                numArgs: 0
            },
            handler (context) {
                if ([
                    "gather",
                    "gather*"
                ].includes(context.envName)) validateAmsEnvironmentContext(context);
                const res = {
                    cols: [
                        {
                            type: "align",
                            align: "c"
                        }
                    ],
                    addJot: true,
                    colSeparationType: "gather",
                    autoTag: getAutoTag(context.envName),
                    emptySingleRow: true,
                    leqno: context.parser.settings.leqno
                };
                return parseArray(context.parser, res, "display");
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        }); // alignat environment is like an align environment, but one must explicitly
        // specify maximum number of columns in each row, and can adjust spacing between
        // each columns.
        defineEnvironment({
            type: "array",
            names: [
                "alignat",
                "alignat*",
                "alignedat"
            ],
            props: {
                numArgs: 1
            },
            handler: alignedHandler,
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        });
        defineEnvironment({
            type: "array",
            names: [
                "equation",
                "equation*"
            ],
            props: {
                numArgs: 0
            },
            handler (context) {
                validateAmsEnvironmentContext(context);
                const res = {
                    autoTag: getAutoTag(context.envName),
                    emptySingleRow: true,
                    singleRow: true,
                    maxNumCols: 1,
                    leqno: context.parser.settings.leqno
                };
                return parseArray(context.parser, res, "display");
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        });
        defineEnvironment({
            type: "array",
            names: [
                "CD"
            ],
            props: {
                numArgs: 0
            },
            handler (context) {
                validateAmsEnvironmentContext(context);
                return parseCD(context.parser);
            },
            htmlBuilder: array_htmlBuilder,
            mathmlBuilder: array_mathmlBuilder
        });
        defineMacro("\\nonumber", "\\gdef\\@eqnsw{0}");
        defineMacro("\\notag", "\\nonumber"); // Catch \hline outside array environment
        defineFunction({
            type: "text",
            // Doesn't matter what this is.
            names: [
                "\\hline",
                "\\hdashline"
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                allowedInMath: true
            },
            handler (context, args) {
                throw new src_ParseError(context.funcName + " valid only within array environment");
            }
        });
        const environments = _environments;
        /* harmony default export */ var src_environments = environments; // All environment definitions should be imported below
        // Environment delimiters. HTML/MathML rendering is defined in the corresponding
        // defineEnvironment definitions.
        defineFunction({
            type: "environment",
            names: [
                "\\begin",
                "\\end"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "text"
                ]
            },
            handler (_ref, args) {
                let { parser: parser, funcName: funcName } = _ref;
                const nameGroup = args[0];
                if (nameGroup.type !== "ordgroup") throw new src_ParseError("Invalid environment name", nameGroup);
                let envName = "";
                for(let i = 0; i < nameGroup.body.length; ++i)envName += assertNodeType(nameGroup.body[i], "textord").text;
                if (funcName === "\\begin") {
                    // begin...end is similar to left...right
                    if (!src_environments.hasOwnProperty(envName)) throw new src_ParseError("No such environment: " + envName, nameGroup);
                     // Build the environment object. Arguments and other information will
                    // be made available to the begin and end methods using properties.
                    const env = src_environments[envName];
                    const { args: args, optArgs: optArgs } = parser.parseArguments("\\begin{" + envName + "}", env);
                    const context = {
                        mode: parser.mode,
                        envName: envName,
                        parser: parser
                    };
                    const result = env.handler(context, args, optArgs);
                    parser.expect("\\end", false);
                    const endNameToken = parser.nextToken;
                    const end = assertNodeType(parser.parseFunction(), "environment");
                    if (end.name !== envName) throw new src_ParseError("Mismatch: \\begin{" + envName + "} matched by \\end{" + end.name + "}", endNameToken);
                     // $FlowFixMe, "environment" handler returns an environment ParseNode
                    return result;
                }
                return {
                    type: "environment",
                    mode: parser.mode,
                    name: envName,
                    nameGroup: nameGroup
                };
            }
        });
        // TODO(kevinb): implement \\sl and \\sc
        const font_htmlBuilder = (group, options)=>{
            const font = group.font;
            const newOptions = options.withFont(font);
            return buildGroup(group.body, newOptions);
        };
        const font_mathmlBuilder = (group, options)=>{
            const font = group.font;
            const newOptions = options.withFont(font);
            return buildMathML_buildGroup(group.body, newOptions);
        };
        const fontAliases = {
            "\\Bbb": "\\mathbb",
            "\\bold": "\\mathbf",
            "\\frak": "\\mathfrak",
            "\\bm": "\\boldsymbol"
        };
        defineFunction({
            type: "font",
            names: [
                "\\mathrm",
                "\\mathit",
                "\\mathbf",
                "\\mathnormal",
                "\\mathsfit",
                "\\mathbb",
                "\\mathcal",
                "\\mathfrak",
                "\\mathscr",
                "\\mathsf",
                "\\mathtt",
                "\\Bbb",
                "\\bold",
                "\\frak"
            ],
            props: {
                numArgs: 1,
                allowedInArgument: true
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName } = _ref;
                const body = normalizeArgument(args[0]);
                let func = funcName;
                if (func in fontAliases) func = fontAliases[func];
                return {
                    type: "font",
                    mode: parser.mode,
                    font: func.slice(1),
                    body: body
                };
            },
            htmlBuilder: font_htmlBuilder,
            mathmlBuilder: font_mathmlBuilder
        });
        defineFunction({
            type: "mclass",
            names: [
                "\\boldsymbol",
                "\\bm"
            ],
            props: {
                numArgs: 1
            },
            handler: (_ref2, args)=>{
                let { parser: parser } = _ref2;
                const body = args[0];
                const isCharacterBox = utils.isCharacterBox(body); // amsbsy.sty's \boldsymbol uses \binrel spacing to inherit the
                // argument's bin|rel|ord status
                return {
                    type: "mclass",
                    mode: parser.mode,
                    mclass: binrelClass(body),
                    body: [
                        {
                            type: "font",
                            mode: parser.mode,
                            font: "boldsymbol",
                            body: body
                        }
                    ],
                    isCharacterBox: isCharacterBox
                };
            }
        }); // Old font changing functions
        defineFunction({
            type: "font",
            names: [
                "\\rm",
                "\\sf",
                "\\tt",
                "\\bf",
                "\\it",
                "\\cal"
            ],
            props: {
                numArgs: 0,
                allowedInText: true
            },
            handler: (_ref3, args)=>{
                let { parser: parser, funcName: funcName, breakOnTokenText: breakOnTokenText } = _ref3;
                const { mode: mode } = parser;
                const body = parser.parseExpression(true, breakOnTokenText);
                const style = "math" + funcName.slice(1);
                return {
                    type: "font",
                    mode: mode,
                    font: style,
                    body: {
                        type: "ordgroup",
                        mode: parser.mode,
                        body: body
                    }
                };
            },
            htmlBuilder: font_htmlBuilder,
            mathmlBuilder: font_mathmlBuilder
        });
        const adjustStyle = (size, originalStyle)=>{
            // Figure out what style this fraction should be in based on the
            // function used
            let style = originalStyle;
            if (size === "display") // Get display style as a default.
            // If incoming style is sub/sup, use style.text() to get correct size.
            style = style.id >= src_Style.SCRIPT.id ? style.text() : src_Style.DISPLAY;
            else if (size === "text" && style.size === src_Style.DISPLAY.size) // We're in a \tfrac but incoming style is displaystyle, so:
            style = src_Style.TEXT;
            else if (size === "script") style = src_Style.SCRIPT;
            else if (size === "scriptscript") style = src_Style.SCRIPTSCRIPT;
            return style;
        };
        const genfrac_htmlBuilder = (group, options)=>{
            // Fractions are handled in the TeXbook on pages 444-445, rules 15(a-e).
            const style = adjustStyle(group.size, options.style);
            const nstyle = style.fracNum();
            const dstyle = style.fracDen();
            let newOptions;
            newOptions = options.havingStyle(nstyle);
            const numerm = buildGroup(group.numer, newOptions, options);
            if (group.continued) {
                // \cfrac inserts a \strut into the numerator.
                // Get \strut dimensions from TeXbook page 353.
                const hStrut = 8.5 / options.fontMetrics().ptPerEm;
                const dStrut = 3.5 / options.fontMetrics().ptPerEm;
                numerm.height = numerm.height < hStrut ? hStrut : numerm.height;
                numerm.depth = numerm.depth < dStrut ? dStrut : numerm.depth;
            }
            newOptions = options.havingStyle(dstyle);
            const denomm = buildGroup(group.denom, newOptions, options);
            let rule;
            let ruleWidth;
            let ruleSpacing;
            if (group.hasBarLine) {
                if (group.barSize) {
                    ruleWidth = calculateSize(group.barSize, options);
                    rule = buildCommon.makeLineSpan("frac-line", options, ruleWidth);
                } else rule = buildCommon.makeLineSpan("frac-line", options);
                ruleWidth = rule.height;
                ruleSpacing = rule.height;
            } else {
                rule = null;
                ruleWidth = 0;
                ruleSpacing = options.fontMetrics().defaultRuleThickness;
            } // Rule 15b
            let numShift;
            let clearance;
            let denomShift;
            if (style.size === src_Style.DISPLAY.size || group.size === "display") {
                numShift = options.fontMetrics().num1;
                if (ruleWidth > 0) clearance = 3 * ruleSpacing;
                else clearance = 7 * ruleSpacing;
                denomShift = options.fontMetrics().denom1;
            } else {
                if (ruleWidth > 0) {
                    numShift = options.fontMetrics().num2;
                    clearance = ruleSpacing;
                } else {
                    numShift = options.fontMetrics().num3;
                    clearance = 3 * ruleSpacing;
                }
                denomShift = options.fontMetrics().denom2;
            }
            let frac;
            if (!rule) {
                // Rule 15c
                const candidateClearance = numShift - numerm.depth - (denomm.height - denomShift);
                if (candidateClearance < clearance) {
                    numShift += 0.5 * (clearance - candidateClearance);
                    denomShift += 0.5 * (clearance - candidateClearance);
                }
                frac = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: [
                        {
                            type: "elem",
                            elem: denomm,
                            shift: denomShift
                        },
                        {
                            type: "elem",
                            elem: numerm,
                            shift: -numShift
                        }
                    ]
                }, options);
            } else {
                // Rule 15d
                const axisHeight = options.fontMetrics().axisHeight;
                if (numShift - numerm.depth - (axisHeight + 0.5 * ruleWidth) < clearance) numShift += clearance - (numShift - numerm.depth - (axisHeight + 0.5 * ruleWidth));
                if (axisHeight - 0.5 * ruleWidth - (denomm.height - denomShift) < clearance) denomShift += clearance - (axisHeight - 0.5 * ruleWidth - (denomm.height - denomShift));
                const midShift = -(axisHeight - 0.5 * ruleWidth);
                frac = buildCommon.makeVList({
                    positionType: "individualShift",
                    children: [
                        {
                            type: "elem",
                            elem: denomm,
                            shift: denomShift
                        },
                        {
                            type: "elem",
                            elem: rule,
                            shift: midShift
                        },
                        {
                            type: "elem",
                            elem: numerm,
                            shift: -numShift
                        }
                    ]
                }, options);
            } // Since we manually change the style sometimes (with \dfrac or \tfrac),
            // account for the possible size change here.
            newOptions = options.havingStyle(style);
            frac.height *= newOptions.sizeMultiplier / options.sizeMultiplier;
            frac.depth *= newOptions.sizeMultiplier / options.sizeMultiplier; // Rule 15e
            let delimSize;
            if (style.size === src_Style.DISPLAY.size) delimSize = options.fontMetrics().delim1;
            else if (style.size === src_Style.SCRIPTSCRIPT.size) delimSize = options.havingStyle(src_Style.SCRIPT).fontMetrics().delim2;
            else delimSize = options.fontMetrics().delim2;
            let leftDelim;
            let rightDelim;
            if (group.leftDelim == null) leftDelim = makeNullDelimiter(options, [
                "mopen"
            ]);
            else leftDelim = delimiter.customSizedDelim(group.leftDelim, delimSize, true, options.havingStyle(style), group.mode, [
                "mopen"
            ]);
            if (group.continued) rightDelim = buildCommon.makeSpan([]); // zero width for \cfrac
            else if (group.rightDelim == null) rightDelim = makeNullDelimiter(options, [
                "mclose"
            ]);
            else rightDelim = delimiter.customSizedDelim(group.rightDelim, delimSize, true, options.havingStyle(style), group.mode, [
                "mclose"
            ]);
            return buildCommon.makeSpan([
                "mord"
            ].concat(newOptions.sizingClasses(options)), [
                leftDelim,
                buildCommon.makeSpan([
                    "mfrac"
                ], [
                    frac
                ]),
                rightDelim
            ], options);
        };
        const genfrac_mathmlBuilder = (group, options)=>{
            let node = new mathMLTree.MathNode("mfrac", [
                buildMathML_buildGroup(group.numer, options),
                buildMathML_buildGroup(group.denom, options)
            ]);
            if (!group.hasBarLine) node.setAttribute("linethickness", "0px");
            else if (group.barSize) {
                const ruleWidth = calculateSize(group.barSize, options);
                node.setAttribute("linethickness", makeEm(ruleWidth));
            }
            const style = adjustStyle(group.size, options.style);
            if (style.size !== options.style.size) {
                node = new mathMLTree.MathNode("mstyle", [
                    node
                ]);
                const isDisplay = style.size === src_Style.DISPLAY.size ? "true" : "false";
                node.setAttribute("displaystyle", isDisplay);
                node.setAttribute("scriptlevel", "0");
            }
            if (group.leftDelim != null || group.rightDelim != null) {
                const withDelims = [];
                if (group.leftDelim != null) {
                    const leftOp = new mathMLTree.MathNode("mo", [
                        new mathMLTree.TextNode(group.leftDelim.replace("\\", ""))
                    ]);
                    leftOp.setAttribute("fence", "true");
                    withDelims.push(leftOp);
                }
                withDelims.push(node);
                if (group.rightDelim != null) {
                    const rightOp = new mathMLTree.MathNode("mo", [
                        new mathMLTree.TextNode(group.rightDelim.replace("\\", ""))
                    ]);
                    rightOp.setAttribute("fence", "true");
                    withDelims.push(rightOp);
                }
                return makeRow(withDelims);
            }
            return node;
        };
        defineFunction({
            type: "genfrac",
            names: [
                "\\dfrac",
                "\\frac",
                "\\tfrac",
                "\\dbinom",
                "\\binom",
                "\\tbinom",
                "\\\\atopfrac",
                "\\\\bracefrac",
                "\\\\brackfrac" // ditto
            ],
            props: {
                numArgs: 2,
                allowedInArgument: true
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName } = _ref;
                const numer = args[0];
                const denom = args[1];
                let hasBarLine;
                let leftDelim = null;
                let rightDelim = null;
                let size = "auto";
                switch(funcName){
                    case "\\dfrac":
                    case "\\frac":
                    case "\\tfrac":
                        hasBarLine = true;
                        break;
                    case "\\\\atopfrac":
                        hasBarLine = false;
                        break;
                    case "\\dbinom":
                    case "\\binom":
                    case "\\tbinom":
                        hasBarLine = false;
                        leftDelim = "(";
                        rightDelim = ")";
                        break;
                    case "\\\\bracefrac":
                        hasBarLine = false;
                        leftDelim = "\\{";
                        rightDelim = "\\}";
                        break;
                    case "\\\\brackfrac":
                        hasBarLine = false;
                        leftDelim = "[";
                        rightDelim = "]";
                        break;
                    default:
                        throw new Error("Unrecognized genfrac command");
                }
                switch(funcName){
                    case "\\dfrac":
                    case "\\dbinom":
                        size = "display";
                        break;
                    case "\\tfrac":
                    case "\\tbinom":
                        size = "text";
                        break;
                }
                return {
                    type: "genfrac",
                    mode: parser.mode,
                    continued: false,
                    numer: numer,
                    denom: denom,
                    hasBarLine: hasBarLine,
                    leftDelim: leftDelim,
                    rightDelim: rightDelim,
                    size: size,
                    barSize: null
                };
            },
            htmlBuilder: genfrac_htmlBuilder,
            mathmlBuilder: genfrac_mathmlBuilder
        });
        defineFunction({
            type: "genfrac",
            names: [
                "\\cfrac"
            ],
            props: {
                numArgs: 2
            },
            handler: (_ref2, args)=>{
                let { parser: parser, funcName: funcName } = _ref2;
                const numer = args[0];
                const denom = args[1];
                return {
                    type: "genfrac",
                    mode: parser.mode,
                    continued: true,
                    numer: numer,
                    denom: denom,
                    hasBarLine: true,
                    leftDelim: null,
                    rightDelim: null,
                    size: "display",
                    barSize: null
                };
            }
        }); // Infix generalized fractions -- these are not rendered directly, but replaced
        // immediately by one of the variants above.
        defineFunction({
            type: "infix",
            names: [
                "\\over",
                "\\choose",
                "\\atop",
                "\\brace",
                "\\brack"
            ],
            props: {
                numArgs: 0,
                infix: true
            },
            handler (_ref3) {
                let { parser: parser, funcName: funcName, token: token } = _ref3;
                let replaceWith;
                switch(funcName){
                    case "\\over":
                        replaceWith = "\\frac";
                        break;
                    case "\\choose":
                        replaceWith = "\\binom";
                        break;
                    case "\\atop":
                        replaceWith = "\\\\atopfrac";
                        break;
                    case "\\brace":
                        replaceWith = "\\\\bracefrac";
                        break;
                    case "\\brack":
                        replaceWith = "\\\\brackfrac";
                        break;
                    default:
                        throw new Error("Unrecognized infix genfrac command");
                }
                return {
                    type: "infix",
                    mode: parser.mode,
                    replaceWith: replaceWith,
                    token: token
                };
            }
        });
        const stylArray = [
            "display",
            "text",
            "script",
            "scriptscript"
        ];
        const delimFromValue = function(delimString) {
            let delim = null;
            if (delimString.length > 0) {
                delim = delimString;
                delim = delim === "." ? null : delim;
            }
            return delim;
        };
        defineFunction({
            type: "genfrac",
            names: [
                "\\genfrac"
            ],
            props: {
                numArgs: 6,
                allowedInArgument: true,
                argTypes: [
                    "math",
                    "math",
                    "size",
                    "text",
                    "math",
                    "math"
                ]
            },
            handler (_ref4, args) {
                let { parser: parser } = _ref4;
                const numer = args[4];
                const denom = args[5]; // Look into the parse nodes to get the desired delimiters.
                const leftNode = normalizeArgument(args[0]);
                const leftDelim = leftNode.type === "atom" && leftNode.family === "open" ? delimFromValue(leftNode.text) : null;
                const rightNode = normalizeArgument(args[1]);
                const rightDelim = rightNode.type === "atom" && rightNode.family === "close" ? delimFromValue(rightNode.text) : null;
                const barNode = assertNodeType(args[2], "size");
                let hasBarLine;
                let barSize = null;
                if (barNode.isBlank) // \genfrac acts differently than \above.
                // \genfrac treats an empty size group as a signal to use a
                // standard bar size. \above would see size = 0 and omit the bar.
                hasBarLine = true;
                else {
                    barSize = barNode.value;
                    hasBarLine = barSize.number > 0;
                } // Find out if we want displaystyle, textstyle, etc.
                let size = "auto";
                let styl = args[3];
                if (styl.type === "ordgroup") {
                    if (styl.body.length > 0) {
                        const textOrd = assertNodeType(styl.body[0], "textord");
                        size = stylArray[Number(textOrd.text)];
                    }
                } else {
                    styl = assertNodeType(styl, "textord");
                    size = stylArray[Number(styl.text)];
                }
                return {
                    type: "genfrac",
                    mode: parser.mode,
                    numer: numer,
                    denom: denom,
                    continued: false,
                    hasBarLine: hasBarLine,
                    barSize: barSize,
                    leftDelim: leftDelim,
                    rightDelim: rightDelim,
                    size: size
                };
            },
            htmlBuilder: genfrac_htmlBuilder,
            mathmlBuilder: genfrac_mathmlBuilder
        }); // \above is an infix fraction that also defines a fraction bar size.
        defineFunction({
            type: "infix",
            names: [
                "\\above"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "size"
                ],
                infix: true
            },
            handler (_ref5, args) {
                let { parser: parser, funcName: funcName, token: token } = _ref5;
                return {
                    type: "infix",
                    mode: parser.mode,
                    replaceWith: "\\\\abovefrac",
                    size: assertNodeType(args[0], "size").value,
                    token: token
                };
            }
        });
        defineFunction({
            type: "genfrac",
            names: [
                "\\\\abovefrac"
            ],
            props: {
                numArgs: 3,
                argTypes: [
                    "math",
                    "size",
                    "math"
                ]
            },
            handler: (_ref6, args)=>{
                let { parser: parser, funcName: funcName } = _ref6;
                const numer = args[0];
                const barSize = assert(assertNodeType(args[1], "infix").size);
                const denom = args[2];
                const hasBarLine = barSize.number > 0;
                return {
                    type: "genfrac",
                    mode: parser.mode,
                    numer: numer,
                    denom: denom,
                    continued: false,
                    hasBarLine: hasBarLine,
                    barSize: barSize,
                    leftDelim: null,
                    rightDelim: null,
                    size: "auto"
                };
            },
            htmlBuilder: genfrac_htmlBuilder,
            mathmlBuilder: genfrac_mathmlBuilder
        });
        // NOTE: Unlike most `htmlBuilder`s, this one handles not only "horizBrace", but
        // also "supsub" since an over/underbrace can affect super/subscripting.
        const horizBrace_htmlBuilder = (grp, options)=>{
            const style = options.style; // Pull out the `ParseNode<"horizBrace">` if `grp` is a "supsub" node.
            let supSubGroup;
            let group;
            if (grp.type === "supsub") {
                // Ref: LaTeX source2e: }}}}\limits}
                // i.e. LaTeX treats the brace similar to an op and passes it
                // with \limits, so we need to assign supsub style.
                supSubGroup = grp.sup ? buildGroup(grp.sup, options.havingStyle(style.sup()), options) : buildGroup(grp.sub, options.havingStyle(style.sub()), options);
                group = assertNodeType(grp.base, "horizBrace");
            } else group = assertNodeType(grp, "horizBrace");
             // Build the base group
            const body = buildGroup(group.base, options.havingBaseStyle(src_Style.DISPLAY)); // Create the stretchy element
            const braceBody = stretchy.svgSpan(group, options); // Generate the vlist, with the appropriate kerns        ┏━━━━━━━━┓
            // This first vlist contains the content and the brace:   equation
            let vlist;
            if (group.isOver) {
                vlist = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: body
                        },
                        {
                            type: "kern",
                            size: 0.1
                        },
                        {
                            type: "elem",
                            elem: braceBody
                        }
                    ]
                }, options); // $FlowFixMe: Replace this with passing "svg-align" into makeVList.
                vlist.children[0].children[0].children[1].classes.push("svg-align");
            } else {
                vlist = buildCommon.makeVList({
                    positionType: "bottom",
                    positionData: body.depth + 0.1 + braceBody.height,
                    children: [
                        {
                            type: "elem",
                            elem: braceBody
                        },
                        {
                            type: "kern",
                            size: 0.1
                        },
                        {
                            type: "elem",
                            elem: body
                        }
                    ]
                }, options); // $FlowFixMe: Replace this with passing "svg-align" into makeVList.
                vlist.children[0].children[0].children[0].classes.push("svg-align");
            }
            if (supSubGroup) {
                // To write the supsub, wrap the first vlist in another vlist:
                // They can't all go in the same vlist, because the note might be
                // wider than the equation. We want the equation to control the
                // brace width.
                //      note          long note           long note
                //   ┏━━━━━━━━┓   or    ┏━━━┓     not    ┏━━━━━━━━━┓
                //    equation           eqn                 eqn
                const vSpan = buildCommon.makeSpan([
                    "mord",
                    group.isOver ? "mover" : "munder"
                ], [
                    vlist
                ], options);
                if (group.isOver) vlist = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: vSpan
                        },
                        {
                            type: "kern",
                            size: 0.2
                        },
                        {
                            type: "elem",
                            elem: supSubGroup
                        }
                    ]
                }, options);
                else vlist = buildCommon.makeVList({
                    positionType: "bottom",
                    positionData: vSpan.depth + 0.2 + supSubGroup.height + supSubGroup.depth,
                    children: [
                        {
                            type: "elem",
                            elem: supSubGroup
                        },
                        {
                            type: "kern",
                            size: 0.2
                        },
                        {
                            type: "elem",
                            elem: vSpan
                        }
                    ]
                }, options);
            }
            return buildCommon.makeSpan([
                "mord",
                group.isOver ? "mover" : "munder"
            ], [
                vlist
            ], options);
        };
        const horizBrace_mathmlBuilder = (group, options)=>{
            const accentNode = stretchy.mathMLnode(group.label);
            return new mathMLTree.MathNode(group.isOver ? "mover" : "munder", [
                buildMathML_buildGroup(group.base, options),
                accentNode
            ]);
        }; // Horizontal stretchy braces
        defineFunction({
            type: "horizBrace",
            names: [
                "\\overbrace",
                "\\underbrace"
            ],
            props: {
                numArgs: 1
            },
            handler (_ref, args) {
                let { parser: parser, funcName: funcName } = _ref;
                return {
                    type: "horizBrace",
                    mode: parser.mode,
                    label: funcName,
                    isOver: /^\\over/.test(funcName),
                    base: args[0]
                };
            },
            htmlBuilder: horizBrace_htmlBuilder,
            mathmlBuilder: horizBrace_mathmlBuilder
        });
        defineFunction({
            type: "href",
            names: [
                "\\href"
            ],
            props: {
                numArgs: 2,
                argTypes: [
                    "url",
                    "original"
                ],
                allowedInText: true
            },
            handler: (_ref, args)=>{
                let { parser: parser } = _ref;
                const body = args[1];
                const href = assertNodeType(args[0], "url").url;
                if (!parser.settings.isTrusted({
                    command: "\\href",
                    url: href
                })) return parser.formatUnsupportedCmd("\\href");
                return {
                    type: "href",
                    mode: parser.mode,
                    href: href,
                    body: ordargument(body)
                };
            },
            htmlBuilder: (group, options)=>{
                const elements = buildExpression(group.body, options, false);
                return buildCommon.makeAnchor(group.href, [], elements, options);
            },
            mathmlBuilder: (group, options)=>{
                let math = buildExpressionRow(group.body, options);
                if (!(math instanceof MathNode)) math = new MathNode("mrow", [
                    math
                ]);
                math.setAttribute("href", group.href);
                return math;
            }
        });
        defineFunction({
            type: "href",
            names: [
                "\\url"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "url"
                ],
                allowedInText: true
            },
            handler: (_ref2, args)=>{
                let { parser: parser } = _ref2;
                const href = assertNodeType(args[0], "url").url;
                if (!parser.settings.isTrusted({
                    command: "\\url",
                    url: href
                })) return parser.formatUnsupportedCmd("\\url");
                const chars = [];
                for(let i = 0; i < href.length; i++){
                    let c = href[i];
                    if (c === "~") c = "\\textasciitilde";
                    chars.push({
                        type: "textord",
                        mode: "text",
                        text: c
                    });
                }
                const body = {
                    type: "text",
                    mode: parser.mode,
                    font: "\\texttt",
                    body: chars
                };
                return {
                    type: "href",
                    mode: parser.mode,
                    href: href,
                    body: ordargument(body)
                };
            }
        });
        // \hbox is provided for compatibility with LaTeX \vcenter.
        // In LaTeX, \vcenter can act only on a box, as in
        // \vcenter{\hbox{$\frac{a+b}{\dfrac{c}{d}}$}}
        // This function by itself doesn't do anything but prevent a soft line break.
        defineFunction({
            type: "hbox",
            names: [
                "\\hbox"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "text"
                ],
                allowedInText: true,
                primitive: true
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                return {
                    type: "hbox",
                    mode: parser.mode,
                    body: ordargument(args[0])
                };
            },
            htmlBuilder (group, options) {
                const elements = buildExpression(group.body, options, false);
                return buildCommon.makeFragment(elements);
            },
            mathmlBuilder (group, options) {
                return new mathMLTree.MathNode("mrow", buildMathML_buildExpression(group.body, options));
            }
        });
        defineFunction({
            type: "html",
            names: [
                "\\htmlClass",
                "\\htmlId",
                "\\htmlStyle",
                "\\htmlData"
            ],
            props: {
                numArgs: 2,
                argTypes: [
                    "raw",
                    "original"
                ],
                allowedInText: true
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName, token: token } = _ref;
                const value = assertNodeType(args[0], "raw").string;
                const body = args[1];
                if (parser.settings.strict) parser.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
                let trustContext;
                const attributes = {};
                switch(funcName){
                    case "\\htmlClass":
                        attributes.class = value;
                        trustContext = {
                            command: "\\htmlClass",
                            class: value
                        };
                        break;
                    case "\\htmlId":
                        attributes.id = value;
                        trustContext = {
                            command: "\\htmlId",
                            id: value
                        };
                        break;
                    case "\\htmlStyle":
                        attributes.style = value;
                        trustContext = {
                            command: "\\htmlStyle",
                            style: value
                        };
                        break;
                    case "\\htmlData":
                        {
                            const data = value.split(",");
                            for(let i = 0; i < data.length; i++){
                                const keyVal = data[i].split("=");
                                if (keyVal.length !== 2) throw new src_ParseError("Error parsing key-value for \\htmlData");
                                attributes["data-" + keyVal[0].trim()] = keyVal[1].trim();
                            }
                            trustContext = {
                                command: "\\htmlData",
                                attributes: attributes
                            };
                            break;
                        }
                    default:
                        throw new Error("Unrecognized html command");
                }
                if (!parser.settings.isTrusted(trustContext)) return parser.formatUnsupportedCmd(funcName);
                return {
                    type: "html",
                    mode: parser.mode,
                    attributes: attributes,
                    body: ordargument(body)
                };
            },
            htmlBuilder: (group, options)=>{
                const elements = buildExpression(group.body, options, false);
                const classes = [
                    "enclosing"
                ];
                if (group.attributes.class) classes.push(...group.attributes.class.trim().split(/\s+/));
                const span = buildCommon.makeSpan(classes, elements, options);
                for(const attr in group.attributes)if (attr !== "class" && group.attributes.hasOwnProperty(attr)) span.setAttribute(attr, group.attributes[attr]);
                return span;
            },
            mathmlBuilder: (group, options)=>{
                return buildExpressionRow(group.body, options);
            }
        });
        defineFunction({
            type: "htmlmathml",
            names: [
                "\\html@mathml"
            ],
            props: {
                numArgs: 2,
                allowedInText: true
            },
            handler: (_ref, args)=>{
                let { parser: parser } = _ref;
                return {
                    type: "htmlmathml",
                    mode: parser.mode,
                    html: ordargument(args[0]),
                    mathml: ordargument(args[1])
                };
            },
            htmlBuilder: (group, options)=>{
                const elements = buildExpression(group.html, options, false);
                return buildCommon.makeFragment(elements);
            },
            mathmlBuilder: (group, options)=>{
                return buildExpressionRow(group.mathml, options);
            }
        });
        const sizeData = function(str) {
            if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(str)) // str is a number with no unit specified.
            // default unit is bp, per graphix package.
            return {
                number: +str,
                unit: "bp"
            };
            else {
                const match = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(str);
                if (!match) throw new src_ParseError("Invalid size: '" + str + "' in \\includegraphics");
                const data = {
                    number: +(match[1] + match[2]),
                    // sign + magnitude, cast to number
                    unit: match[3]
                };
                if (!validUnit(data)) throw new src_ParseError("Invalid unit: '" + data.unit + "' in \\includegraphics.");
                return data;
            }
        };
        defineFunction({
            type: "includegraphics",
            names: [
                "\\includegraphics"
            ],
            props: {
                numArgs: 1,
                numOptionalArgs: 1,
                argTypes: [
                    "raw",
                    "url"
                ],
                allowedInText: false
            },
            handler: (_ref, args, optArgs)=>{
                let { parser: parser } = _ref;
                let width = {
                    number: 0,
                    unit: "em"
                };
                let height = {
                    number: 0.9,
                    unit: "em"
                }; // sorta character sized.
                let totalheight = {
                    number: 0,
                    unit: "em"
                };
                let alt = "";
                if (optArgs[0]) {
                    const attributeStr = assertNodeType(optArgs[0], "raw").string; // Parser.js does not parse key/value pairs. We get a string.
                    const attributes = attributeStr.split(",");
                    for(let i = 0; i < attributes.length; i++){
                        const keyVal = attributes[i].split("=");
                        if (keyVal.length === 2) {
                            const str = keyVal[1].trim();
                            switch(keyVal[0].trim()){
                                case "alt":
                                    alt = str;
                                    break;
                                case "width":
                                    width = sizeData(str);
                                    break;
                                case "height":
                                    height = sizeData(str);
                                    break;
                                case "totalheight":
                                    totalheight = sizeData(str);
                                    break;
                                default:
                                    throw new src_ParseError("Invalid key: '" + keyVal[0] + "' in \\includegraphics.");
                            }
                        }
                    }
                }
                const src = assertNodeType(args[0], "url").url;
                if (alt === "") {
                    // No alt given. Use the file name. Strip away the path.
                    alt = src;
                    alt = alt.replace(/^.*[\\/]/, '');
                    alt = alt.substring(0, alt.lastIndexOf('.'));
                }
                if (!parser.settings.isTrusted({
                    command: "\\includegraphics",
                    url: src
                })) return parser.formatUnsupportedCmd("\\includegraphics");
                return {
                    type: "includegraphics",
                    mode: parser.mode,
                    alt: alt,
                    width: width,
                    height: height,
                    totalheight: totalheight,
                    src: src
                };
            },
            htmlBuilder: (group, options)=>{
                const height = calculateSize(group.height, options);
                let depth = 0;
                if (group.totalheight.number > 0) depth = calculateSize(group.totalheight, options) - height;
                let width = 0;
                if (group.width.number > 0) width = calculateSize(group.width, options);
                const style = {
                    height: makeEm(height + depth)
                };
                if (width > 0) style.width = makeEm(width);
                if (depth > 0) style.verticalAlign = makeEm(-depth);
                const node = new Img(group.src, group.alt, style);
                node.height = height;
                node.depth = depth;
                return node;
            },
            mathmlBuilder: (group, options)=>{
                const node = new mathMLTree.MathNode("mglyph", []);
                node.setAttribute("alt", group.alt);
                const height = calculateSize(group.height, options);
                let depth = 0;
                if (group.totalheight.number > 0) {
                    depth = calculateSize(group.totalheight, options) - height;
                    node.setAttribute("valign", makeEm(-depth));
                }
                node.setAttribute("height", makeEm(height + depth));
                if (group.width.number > 0) {
                    const width = calculateSize(group.width, options);
                    node.setAttribute("width", makeEm(width));
                }
                node.setAttribute("src", group.src);
                return node;
            }
        });
        // Horizontal spacing commands
        // TODO: \hskip and \mskip should support plus and minus in lengths
        defineFunction({
            type: "kern",
            names: [
                "\\kern",
                "\\mkern",
                "\\hskip",
                "\\mskip"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "size"
                ],
                primitive: true,
                allowedInText: true
            },
            handler (_ref, args) {
                let { parser: parser, funcName: funcName } = _ref;
                const size = assertNodeType(args[0], "size");
                if (parser.settings.strict) {
                    const mathFunction = funcName[1] === 'm'; // \mkern, \mskip
                    const muUnit = size.value.unit === 'mu';
                    if (mathFunction) {
                        if (!muUnit) parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " supports only mu units, " + ("not " + size.value.unit + " units"));
                        if (parser.mode !== "math") parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " works only in math mode");
                    } else // !mathFunction
                    if (muUnit) parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " doesn't support mu units");
                }
                return {
                    type: "kern",
                    mode: parser.mode,
                    dimension: size.value
                };
            },
            htmlBuilder (group, options) {
                return buildCommon.makeGlue(group.dimension, options);
            },
            mathmlBuilder (group, options) {
                const dimension = calculateSize(group.dimension, options);
                return new mathMLTree.SpaceNode(dimension);
            }
        });
        // Horizontal overlap functions
        defineFunction({
            type: "lap",
            names: [
                "\\mathllap",
                "\\mathrlap",
                "\\mathclap"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName } = _ref;
                const body = args[0];
                return {
                    type: "lap",
                    mode: parser.mode,
                    alignment: funcName.slice(5),
                    body: body
                };
            },
            htmlBuilder: (group, options)=>{
                // mathllap, mathrlap, mathclap
                let inner;
                if (group.alignment === "clap") {
                    // ref: https://www.math.lsu.edu/~aperlis/publications/mathclap/
                    inner = buildCommon.makeSpan([], [
                        buildGroup(group.body, options)
                    ]); // wrap, since CSS will center a .clap > .inner > span
                    inner = buildCommon.makeSpan([
                        "inner"
                    ], [
                        inner
                    ], options);
                } else inner = buildCommon.makeSpan([
                    "inner"
                ], [
                    buildGroup(group.body, options)
                ]);
                const fix = buildCommon.makeSpan([
                    "fix"
                ], []);
                let node = buildCommon.makeSpan([
                    group.alignment
                ], [
                    inner,
                    fix
                ], options); // At this point, we have correctly set horizontal alignment of the
                // two items involved in the lap.
                // Next, use a strut to set the height of the HTML bounding box.
                // Otherwise, a tall argument may be misplaced.
                // This code resolved issue #1153
                const strut = buildCommon.makeSpan([
                    "strut"
                ]);
                strut.style.height = makeEm(node.height + node.depth);
                if (node.depth) strut.style.verticalAlign = makeEm(-node.depth);
                node.children.unshift(strut); // Next, prevent vertical misplacement when next to something tall.
                // This code resolves issue #1234
                node = buildCommon.makeSpan([
                    "thinbox"
                ], [
                    node
                ], options);
                return buildCommon.makeSpan([
                    "mord",
                    "vbox"
                ], [
                    node
                ], options);
            },
            mathmlBuilder: (group, options)=>{
                // mathllap, mathrlap, mathclap
                const node = new mathMLTree.MathNode("mpadded", [
                    buildMathML_buildGroup(group.body, options)
                ]);
                if (group.alignment !== "rlap") {
                    const offset = group.alignment === "llap" ? "-1" : "-0.5";
                    node.setAttribute("lspace", offset + "width");
                }
                node.setAttribute("width", "0px");
                return node;
            }
        });
        // Switching from text mode back to math mode
        defineFunction({
            type: "styling",
            names: [
                "\\(",
                "$"
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                allowedInMath: false
            },
            handler (_ref, args) {
                let { funcName: funcName, parser: parser } = _ref;
                const outerMode = parser.mode;
                parser.switchMode("math");
                const close = funcName === "\\(" ? "\\)" : "$";
                const body = parser.parseExpression(false, close);
                parser.expect(close);
                parser.switchMode(outerMode);
                return {
                    type: "styling",
                    mode: parser.mode,
                    style: "text",
                    body: body
                };
            }
        }); // Check for extra closing math delimiters
        defineFunction({
            type: "text",
            // Doesn't matter what this is.
            names: [
                "\\)",
                "\\]"
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                allowedInMath: false
            },
            handler (context, args) {
                throw new src_ParseError("Mismatched " + context.funcName);
            }
        });
        const chooseMathStyle = (group, options)=>{
            switch(options.style.size){
                case src_Style.DISPLAY.size:
                    return group.display;
                case src_Style.TEXT.size:
                    return group.text;
                case src_Style.SCRIPT.size:
                    return group.script;
                case src_Style.SCRIPTSCRIPT.size:
                    return group.scriptscript;
                default:
                    return group.text;
            }
        };
        defineFunction({
            type: "mathchoice",
            names: [
                "\\mathchoice"
            ],
            props: {
                numArgs: 4,
                primitive: true
            },
            handler: (_ref, args)=>{
                let { parser: parser } = _ref;
                return {
                    type: "mathchoice",
                    mode: parser.mode,
                    display: ordargument(args[0]),
                    text: ordargument(args[1]),
                    script: ordargument(args[2]),
                    scriptscript: ordargument(args[3])
                };
            },
            htmlBuilder: (group, options)=>{
                const body = chooseMathStyle(group, options);
                const elements = buildExpression(body, options, false);
                return buildCommon.makeFragment(elements);
            },
            mathmlBuilder: (group, options)=>{
                const body = chooseMathStyle(group, options);
                return buildExpressionRow(body, options);
            }
        });
        // For an operator with limits, assemble the base, sup, and sub into a span.
        const assembleSupSub = (base, supGroup, subGroup, options, style, slant, baseShift)=>{
            base = buildCommon.makeSpan([], [
                base
            ]);
            const subIsSingleCharacter = subGroup && utils.isCharacterBox(subGroup);
            let sub;
            let sup; // We manually have to handle the superscripts and subscripts. This,
            // aside from the kern calculations, is copied from supsub.
            if (supGroup) {
                const elem = buildGroup(supGroup, options.havingStyle(style.sup()), options);
                sup = {
                    elem: elem,
                    kern: Math.max(options.fontMetrics().bigOpSpacing1, options.fontMetrics().bigOpSpacing3 - elem.depth)
                };
            }
            if (subGroup) {
                const elem = buildGroup(subGroup, options.havingStyle(style.sub()), options);
                sub = {
                    elem: elem,
                    kern: Math.max(options.fontMetrics().bigOpSpacing2, options.fontMetrics().bigOpSpacing4 - elem.height)
                };
            } // Build the final group as a vlist of the possible subscript, base,
            // and possible superscript.
            let finalGroup;
            if (sup && sub) {
                const bottom = options.fontMetrics().bigOpSpacing5 + sub.elem.height + sub.elem.depth + sub.kern + base.depth + baseShift;
                finalGroup = buildCommon.makeVList({
                    positionType: "bottom",
                    positionData: bottom,
                    children: [
                        {
                            type: "kern",
                            size: options.fontMetrics().bigOpSpacing5
                        },
                        {
                            type: "elem",
                            elem: sub.elem,
                            marginLeft: makeEm(-slant)
                        },
                        {
                            type: "kern",
                            size: sub.kern
                        },
                        {
                            type: "elem",
                            elem: base
                        },
                        {
                            type: "kern",
                            size: sup.kern
                        },
                        {
                            type: "elem",
                            elem: sup.elem,
                            marginLeft: makeEm(slant)
                        },
                        {
                            type: "kern",
                            size: options.fontMetrics().bigOpSpacing5
                        }
                    ]
                }, options);
            } else if (sub) {
                const top = base.height - baseShift; // Shift the limits by the slant of the symbol. Note
                // that we are supposed to shift the limits by 1/2 of the slant,
                // but since we are centering the limits adding a full slant of
                // margin will shift by 1/2 that.
                finalGroup = buildCommon.makeVList({
                    positionType: "top",
                    positionData: top,
                    children: [
                        {
                            type: "kern",
                            size: options.fontMetrics().bigOpSpacing5
                        },
                        {
                            type: "elem",
                            elem: sub.elem,
                            marginLeft: makeEm(-slant)
                        },
                        {
                            type: "kern",
                            size: sub.kern
                        },
                        {
                            type: "elem",
                            elem: base
                        }
                    ]
                }, options);
            } else if (sup) {
                const bottom = base.depth + baseShift;
                finalGroup = buildCommon.makeVList({
                    positionType: "bottom",
                    positionData: bottom,
                    children: [
                        {
                            type: "elem",
                            elem: base
                        },
                        {
                            type: "kern",
                            size: sup.kern
                        },
                        {
                            type: "elem",
                            elem: sup.elem,
                            marginLeft: makeEm(slant)
                        },
                        {
                            type: "kern",
                            size: options.fontMetrics().bigOpSpacing5
                        }
                    ]
                }, options);
            } else // This case probably shouldn't occur (this would mean the
            // supsub was sending us a group with no superscript or
            // subscript) but be safe.
            return base;
            const parts = [
                finalGroup
            ];
            if (sub && slant !== 0 && !subIsSingleCharacter) {
                // A negative margin-left was applied to the lower limit.
                // Avoid an overlap by placing a spacer on the left on the group.
                const spacer = buildCommon.makeSpan([
                    "mspace"
                ], [], options);
                spacer.style.marginRight = makeEm(slant);
                parts.unshift(spacer);
            }
            return buildCommon.makeSpan([
                "mop",
                "op-limits"
            ], parts, options);
        };
        // Limits, symbols
        // Most operators have a large successor symbol, but these don't.
        const noSuccessor = [
            "\\smallint"
        ]; // NOTE: Unlike most `htmlBuilder`s, this one handles not only "op", but also
        // "supsub" since some of them (like \int) can affect super/subscripting.
        const op_htmlBuilder = (grp, options)=>{
            // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
            let supGroup;
            let subGroup;
            let hasLimits = false;
            let group;
            if (grp.type === "supsub") {
                // If we have limits, supsub will pass us its group to handle. Pull
                // out the superscript and subscript and set the group to the op in
                // its base.
                supGroup = grp.sup;
                subGroup = grp.sub;
                group = assertNodeType(grp.base, "op");
                hasLimits = true;
            } else group = assertNodeType(grp, "op");
            const style = options.style;
            let large = false;
            if (style.size === src_Style.DISPLAY.size && group.symbol && !noSuccessor.includes(group.name)) // Most symbol operators get larger in displaystyle (rule 13)
            large = true;
            let base;
            if (group.symbol) {
                // If this is a symbol, create the symbol.
                const fontName = large ? "Size2-Regular" : "Size1-Regular";
                let stash = "";
                if (group.name === "\\oiint" || group.name === "\\oiiint") {
                    // No font glyphs yet, so use a glyph w/o the oval.
                    // TODO: When font glyphs are available, delete this code.
                    stash = group.name.slice(1);
                    group.name = stash === "oiint" ? "\\iint" : "\\iiint";
                }
                base = buildCommon.makeSymbol(group.name, fontName, "math", options, [
                    "mop",
                    "op-symbol",
                    large ? "large-op" : "small-op"
                ]);
                if (stash.length > 0) {
                    // We're in \oiint or \oiiint. Overlay the oval.
                    // TODO: When font glyphs are available, delete this code.
                    const italic = base.italic;
                    const oval = buildCommon.staticSvg(stash + "Size" + (large ? "2" : "1"), options);
                    base = buildCommon.makeVList({
                        positionType: "individualShift",
                        children: [
                            {
                                type: "elem",
                                elem: base,
                                shift: 0
                            },
                            {
                                type: "elem",
                                elem: oval,
                                shift: large ? 0.08 : 0
                            }
                        ]
                    }, options);
                    group.name = "\\" + stash;
                    base.classes.unshift("mop"); // $FlowFixMe
                    base.italic = italic;
                }
            } else if (group.body) {
                // If this is a list, compose that list.
                const inner = buildExpression(group.body, options, true);
                if (inner.length === 1 && inner[0] instanceof SymbolNode) {
                    base = inner[0];
                    base.classes[0] = "mop"; // replace old mclass
                } else base = buildCommon.makeSpan([
                    "mop"
                ], inner, options);
            } else {
                // Otherwise, this is a text operator. Build the text from the
                // operator's name.
                const output = [];
                for(let i = 1; i < group.name.length; i++)output.push(buildCommon.mathsym(group.name[i], group.mode, options));
                base = buildCommon.makeSpan([
                    "mop"
                ], output, options);
            } // If content of op is a single symbol, shift it vertically.
            let baseShift = 0;
            let slant = 0;
            if ((base instanceof SymbolNode || group.name === "\\oiint" || group.name === "\\oiiint") && !group.suppressBaseShift) {
                // We suppress the shift of the base of \overset and \underset. Otherwise,
                // shift the symbol so its center lies on the axis (rule 13). It
                // appears that our fonts have the centers of the symbols already
                // almost on the axis, so these numbers are very small. Note we
                // don't actually apply this here, but instead it is used either in
                // the vlist creation or separately when there are no limits.
                baseShift = (base.height - base.depth) / 2 - options.fontMetrics().axisHeight; // The slant of the symbol is just its italic correction.
                // $FlowFixMe
                slant = base.italic;
            }
            if (hasLimits) return assembleSupSub(base, supGroup, subGroup, options, style, slant, baseShift);
            else {
                if (baseShift) {
                    base.style.position = "relative";
                    base.style.top = makeEm(baseShift);
                }
                return base;
            }
        };
        const op_mathmlBuilder = (group, options)=>{
            let node;
            if (group.symbol) {
                // This is a symbol. Just add the symbol.
                node = new MathNode("mo", [
                    makeText(group.name, group.mode)
                ]);
                if (noSuccessor.includes(group.name)) node.setAttribute("largeop", "false");
            } else if (group.body) // This is an operator with children. Add them.
            node = new MathNode("mo", buildMathML_buildExpression(group.body, options));
            else {
                // This is a text operator. Add all of the characters from the
                // operator's name.
                node = new MathNode("mi", [
                    new TextNode(group.name.slice(1))
                ]); // Append an <mo>&ApplyFunction;</mo>.
                // ref: https://www.w3.org/TR/REC-MathML/chap3_2.html#sec3.2.4
                const operator = new MathNode("mo", [
                    makeText("\u2061", "text")
                ]);
                if (group.parentIsSupSub) node = new MathNode("mrow", [
                    node,
                    operator
                ]);
                else node = newDocumentFragment([
                    node,
                    operator
                ]);
            }
            return node;
        };
        const singleCharBigOps = {
            "\u220F": "\\prod",
            "\u2210": "\\coprod",
            "\u2211": "\\sum",
            "\u22c0": "\\bigwedge",
            "\u22c1": "\\bigvee",
            "\u22c2": "\\bigcap",
            "\u22c3": "\\bigcup",
            "\u2a00": "\\bigodot",
            "\u2a01": "\\bigoplus",
            "\u2a02": "\\bigotimes",
            "\u2a04": "\\biguplus",
            "\u2a06": "\\bigsqcup"
        };
        defineFunction({
            type: "op",
            names: [
                "\\coprod",
                "\\bigvee",
                "\\bigwedge",
                "\\biguplus",
                "\\bigcap",
                "\\bigcup",
                "\\intop",
                "\\prod",
                "\\sum",
                "\\bigotimes",
                "\\bigoplus",
                "\\bigodot",
                "\\bigsqcup",
                "\\smallint",
                "\u220F",
                "\u2210",
                "\u2211",
                "\u22c0",
                "\u22c1",
                "\u22c2",
                "\u22c3",
                "\u2a00",
                "\u2a01",
                "\u2a02",
                "\u2a04",
                "\u2a06"
            ],
            props: {
                numArgs: 0
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName } = _ref;
                let fName = funcName;
                if (fName.length === 1) fName = singleCharBigOps[fName];
                return {
                    type: "op",
                    mode: parser.mode,
                    limits: true,
                    parentIsSupSub: false,
                    symbol: true,
                    name: fName
                };
            },
            htmlBuilder: op_htmlBuilder,
            mathmlBuilder: op_mathmlBuilder
        }); // Note: calling defineFunction with a type that's already been defined only
        // works because the same htmlBuilder and mathmlBuilder are being used.
        defineFunction({
            type: "op",
            names: [
                "\\mathop"
            ],
            props: {
                numArgs: 1,
                primitive: true
            },
            handler: (_ref2, args)=>{
                let { parser: parser } = _ref2;
                const body = args[0];
                return {
                    type: "op",
                    mode: parser.mode,
                    limits: false,
                    parentIsSupSub: false,
                    symbol: false,
                    body: ordargument(body)
                };
            },
            htmlBuilder: op_htmlBuilder,
            mathmlBuilder: op_mathmlBuilder
        }); // There are 2 flags for operators; whether they produce limits in
        // displaystyle, and whether they are symbols and should grow in
        // displaystyle. These four groups cover the four possible choices.
        const singleCharIntegrals = {
            "\u222b": "\\int",
            "\u222c": "\\iint",
            "\u222d": "\\iiint",
            "\u222e": "\\oint",
            "\u222f": "\\oiint",
            "\u2230": "\\oiiint"
        }; // No limits, not symbols
        defineFunction({
            type: "op",
            names: [
                "\\arcsin",
                "\\arccos",
                "\\arctan",
                "\\arctg",
                "\\arcctg",
                "\\arg",
                "\\ch",
                "\\cos",
                "\\cosec",
                "\\cosh",
                "\\cot",
                "\\cotg",
                "\\coth",
                "\\csc",
                "\\ctg",
                "\\cth",
                "\\deg",
                "\\dim",
                "\\exp",
                "\\hom",
                "\\ker",
                "\\lg",
                "\\ln",
                "\\log",
                "\\sec",
                "\\sin",
                "\\sinh",
                "\\sh",
                "\\tan",
                "\\tanh",
                "\\tg",
                "\\th"
            ],
            props: {
                numArgs: 0
            },
            handler (_ref3) {
                let { parser: parser, funcName: funcName } = _ref3;
                return {
                    type: "op",
                    mode: parser.mode,
                    limits: false,
                    parentIsSupSub: false,
                    symbol: false,
                    name: funcName
                };
            },
            htmlBuilder: op_htmlBuilder,
            mathmlBuilder: op_mathmlBuilder
        }); // Limits, not symbols
        defineFunction({
            type: "op",
            names: [
                "\\det",
                "\\gcd",
                "\\inf",
                "\\lim",
                "\\max",
                "\\min",
                "\\Pr",
                "\\sup"
            ],
            props: {
                numArgs: 0
            },
            handler (_ref4) {
                let { parser: parser, funcName: funcName } = _ref4;
                return {
                    type: "op",
                    mode: parser.mode,
                    limits: true,
                    parentIsSupSub: false,
                    symbol: false,
                    name: funcName
                };
            },
            htmlBuilder: op_htmlBuilder,
            mathmlBuilder: op_mathmlBuilder
        }); // No limits, symbols
        defineFunction({
            type: "op",
            names: [
                "\\int",
                "\\iint",
                "\\iiint",
                "\\oint",
                "\\oiint",
                "\\oiiint",
                "\u222b",
                "\u222c",
                "\u222d",
                "\u222e",
                "\u222f",
                "\u2230"
            ],
            props: {
                numArgs: 0
            },
            handler (_ref5) {
                let { parser: parser, funcName: funcName } = _ref5;
                let fName = funcName;
                if (fName.length === 1) fName = singleCharIntegrals[fName];
                return {
                    type: "op",
                    mode: parser.mode,
                    limits: false,
                    parentIsSupSub: false,
                    symbol: true,
                    name: fName
                };
            },
            htmlBuilder: op_htmlBuilder,
            mathmlBuilder: op_mathmlBuilder
        });
        // NOTE: Unlike most `htmlBuilder`s, this one handles not only
        // "operatorname", but also  "supsub" since \operatorname* can
        // affect super/subscripting.
        const operatorname_htmlBuilder = (grp, options)=>{
            // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
            let supGroup;
            let subGroup;
            let hasLimits = false;
            let group;
            if (grp.type === "supsub") {
                // If we have limits, supsub will pass us its group to handle. Pull
                // out the superscript and subscript and set the group to the op in
                // its base.
                supGroup = grp.sup;
                subGroup = grp.sub;
                group = assertNodeType(grp.base, "operatorname");
                hasLimits = true;
            } else group = assertNodeType(grp, "operatorname");
            let base;
            if (group.body.length > 0) {
                const body = group.body.map((child)=>{
                    // $FlowFixMe: Check if the node has a string `text` property.
                    const childText = child.text;
                    if (typeof childText === "string") return {
                        type: "textord",
                        mode: child.mode,
                        text: childText
                    };
                    else return child;
                }); // Consolidate function names into symbol characters.
                const expression = buildExpression(body, options.withFont("mathrm"), true);
                for(let i = 0; i < expression.length; i++){
                    const child = expression[i];
                    if (child instanceof SymbolNode) // Per amsopn package,
                    // change minus to hyphen and \ast to asterisk
                    child.text = child.text.replace(/\u2212/, "-").replace(/\u2217/, "*");
                }
                base = buildCommon.makeSpan([
                    "mop"
                ], expression, options);
            } else base = buildCommon.makeSpan([
                "mop"
            ], [], options);
            if (hasLimits) return assembleSupSub(base, supGroup, subGroup, options, options.style, 0, 0);
            else return base;
        };
        const operatorname_mathmlBuilder = (group, options)=>{
            // The steps taken here are similar to the html version.
            let expression = buildMathML_buildExpression(group.body, options.withFont("mathrm")); // Is expression a string or has it something like a fraction?
            let isAllString = true; // default
            for(let i = 0; i < expression.length; i++){
                const node = expression[i];
                if (node instanceof mathMLTree.SpaceNode) ;
                else if (node instanceof mathMLTree.MathNode) switch(node.type){
                    case "mi":
                    case "mn":
                    case "ms":
                    case "mspace":
                    case "mtext":
                        break;
                    // Do nothing yet.
                    case "mo":
                        {
                            const child = node.children[0];
                            if (node.children.length === 1 && child instanceof mathMLTree.TextNode) child.text = child.text.replace(/\u2212/, "-").replace(/\u2217/, "*");
                            else isAllString = false;
                            break;
                        }
                    default:
                        isAllString = false;
                }
                else isAllString = false;
            }
            if (isAllString) {
                // Write a single TextNode instead of multiple nested tags.
                const word = expression.map((node)=>node.toText()).join("");
                expression = [
                    new mathMLTree.TextNode(word)
                ];
            }
            const identifier = new mathMLTree.MathNode("mi", expression);
            identifier.setAttribute("mathvariant", "normal"); // \u2061 is the same as &ApplyFunction;
            // ref: https://www.w3schools.com/charsets/ref_html_entities_a.asp
            const operator = new mathMLTree.MathNode("mo", [
                makeText("\u2061", "text")
            ]);
            if (group.parentIsSupSub) return new mathMLTree.MathNode("mrow", [
                identifier,
                operator
            ]);
            else return mathMLTree.newDocumentFragment([
                identifier,
                operator
            ]);
        }; // \operatorname
        // amsopn.dtx: \mathop{#1\kern\z@\operator@font#3}\newmcodes@
        defineFunction({
            type: "operatorname",
            names: [
                "\\operatorname@",
                "\\operatornamewithlimits"
            ],
            props: {
                numArgs: 1
            },
            handler: (_ref, args)=>{
                let { parser: parser, funcName: funcName } = _ref;
                const body = args[0];
                return {
                    type: "operatorname",
                    mode: parser.mode,
                    body: ordargument(body),
                    alwaysHandleSupSub: funcName === "\\operatornamewithlimits",
                    limits: false,
                    parentIsSupSub: false
                };
            },
            htmlBuilder: operatorname_htmlBuilder,
            mathmlBuilder: operatorname_mathmlBuilder
        });
        defineMacro("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
        defineFunctionBuilders({
            type: "ordgroup",
            htmlBuilder (group, options) {
                if (group.semisimple) return buildCommon.makeFragment(buildExpression(group.body, options, false));
                return buildCommon.makeSpan([
                    "mord"
                ], buildExpression(group.body, options, true), options);
            },
            mathmlBuilder (group, options) {
                return buildExpressionRow(group.body, options, true);
            }
        });
        defineFunction({
            type: "overline",
            names: [
                "\\overline"
            ],
            props: {
                numArgs: 1
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                const body = args[0];
                return {
                    type: "overline",
                    mode: parser.mode,
                    body: body
                };
            },
            htmlBuilder (group, options) {
                // Overlines are handled in the TeXbook pg 443, Rule 9.
                // Build the inner group in the cramped style.
                const innerGroup = buildGroup(group.body, options.havingCrampedStyle()); // Create the line above the body
                const line = buildCommon.makeLineSpan("overline-line", options); // Generate the vlist, with the appropriate kerns
                const defaultRuleThickness = options.fontMetrics().defaultRuleThickness;
                const vlist = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: innerGroup
                        },
                        {
                            type: "kern",
                            size: 3 * defaultRuleThickness
                        },
                        {
                            type: "elem",
                            elem: line
                        },
                        {
                            type: "kern",
                            size: defaultRuleThickness
                        }
                    ]
                }, options);
                return buildCommon.makeSpan([
                    "mord",
                    "overline"
                ], [
                    vlist
                ], options);
            },
            mathmlBuilder (group, options) {
                const operator = new mathMLTree.MathNode("mo", [
                    new mathMLTree.TextNode("\u203e")
                ]);
                operator.setAttribute("stretchy", "true");
                const node = new mathMLTree.MathNode("mover", [
                    buildMathML_buildGroup(group.body, options),
                    operator
                ]);
                node.setAttribute("accent", "true");
                return node;
            }
        });
        defineFunction({
            type: "phantom",
            names: [
                "\\phantom"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler: (_ref, args)=>{
                let { parser: parser } = _ref;
                const body = args[0];
                return {
                    type: "phantom",
                    mode: parser.mode,
                    body: ordargument(body)
                };
            },
            htmlBuilder: (group, options)=>{
                const elements = buildExpression(group.body, options.withPhantom(), false); // \phantom isn't supposed to affect the elements it contains.
                // See "color" for more details.
                return buildCommon.makeFragment(elements);
            },
            mathmlBuilder: (group, options)=>{
                const inner = buildMathML_buildExpression(group.body, options);
                return new mathMLTree.MathNode("mphantom", inner);
            }
        });
        defineFunction({
            type: "hphantom",
            names: [
                "\\hphantom"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler: (_ref2, args)=>{
                let { parser: parser } = _ref2;
                const body = args[0];
                return {
                    type: "hphantom",
                    mode: parser.mode,
                    body: body
                };
            },
            htmlBuilder: (group, options)=>{
                let node = buildCommon.makeSpan([], [
                    buildGroup(group.body, options.withPhantom())
                ]);
                node.height = 0;
                node.depth = 0;
                if (node.children) for(let i = 0; i < node.children.length; i++){
                    node.children[i].height = 0;
                    node.children[i].depth = 0;
                }
                 // See smash for comment re: use of makeVList
                node = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: node
                        }
                    ]
                }, options); // For spacing, TeX treats \smash as a math group (same spacing as ord).
                return buildCommon.makeSpan([
                    "mord"
                ], [
                    node
                ], options);
            },
            mathmlBuilder: (group, options)=>{
                const inner = buildMathML_buildExpression(ordargument(group.body), options);
                const phantom = new mathMLTree.MathNode("mphantom", inner);
                const node = new mathMLTree.MathNode("mpadded", [
                    phantom
                ]);
                node.setAttribute("height", "0px");
                node.setAttribute("depth", "0px");
                return node;
            }
        });
        defineFunction({
            type: "vphantom",
            names: [
                "\\vphantom"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler: (_ref3, args)=>{
                let { parser: parser } = _ref3;
                const body = args[0];
                return {
                    type: "vphantom",
                    mode: parser.mode,
                    body: body
                };
            },
            htmlBuilder: (group, options)=>{
                const inner = buildCommon.makeSpan([
                    "inner"
                ], [
                    buildGroup(group.body, options.withPhantom())
                ]);
                const fix = buildCommon.makeSpan([
                    "fix"
                ], []);
                return buildCommon.makeSpan([
                    "mord",
                    "rlap"
                ], [
                    inner,
                    fix
                ], options);
            },
            mathmlBuilder: (group, options)=>{
                const inner = buildMathML_buildExpression(ordargument(group.body), options);
                const phantom = new mathMLTree.MathNode("mphantom", inner);
                const node = new mathMLTree.MathNode("mpadded", [
                    phantom
                ]);
                node.setAttribute("width", "0px");
                return node;
            }
        });
        // Box manipulation
        defineFunction({
            type: "raisebox",
            names: [
                "\\raisebox"
            ],
            props: {
                numArgs: 2,
                argTypes: [
                    "size",
                    "hbox"
                ],
                allowedInText: true
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                const amount = assertNodeType(args[0], "size").value;
                const body = args[1];
                return {
                    type: "raisebox",
                    mode: parser.mode,
                    dy: amount,
                    body: body
                };
            },
            htmlBuilder (group, options) {
                const body = buildGroup(group.body, options);
                const dy = calculateSize(group.dy, options);
                return buildCommon.makeVList({
                    positionType: "shift",
                    positionData: -dy,
                    children: [
                        {
                            type: "elem",
                            elem: body
                        }
                    ]
                }, options);
            },
            mathmlBuilder (group, options) {
                const node = new mathMLTree.MathNode("mpadded", [
                    buildMathML_buildGroup(group.body, options)
                ]);
                const dy = group.dy.number + group.dy.unit;
                node.setAttribute("voffset", dy);
                return node;
            }
        });
        defineFunction({
            type: "internal",
            names: [
                "\\relax"
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                allowedInArgument: true
            },
            handler (_ref) {
                let { parser: parser } = _ref;
                return {
                    type: "internal",
                    mode: parser.mode
                };
            }
        });
        defineFunction({
            type: "rule",
            names: [
                "\\rule"
            ],
            props: {
                numArgs: 2,
                numOptionalArgs: 1,
                allowedInText: true,
                allowedInMath: true,
                argTypes: [
                    "size",
                    "size",
                    "size"
                ]
            },
            handler (_ref, args, optArgs) {
                let { parser: parser } = _ref;
                const shift = optArgs[0];
                const width = assertNodeType(args[0], "size");
                const height = assertNodeType(args[1], "size");
                return {
                    type: "rule",
                    mode: parser.mode,
                    shift: shift && assertNodeType(shift, "size").value,
                    width: width.value,
                    height: height.value
                };
            },
            htmlBuilder (group, options) {
                // Make an empty span for the rule
                const rule = buildCommon.makeSpan([
                    "mord",
                    "rule"
                ], [], options); // Calculate the shift, width, and height of the rule, and account for units
                const width = calculateSize(group.width, options);
                const height = calculateSize(group.height, options);
                const shift = group.shift ? calculateSize(group.shift, options) : 0; // Style the rule to the right size
                rule.style.borderRightWidth = makeEm(width);
                rule.style.borderTopWidth = makeEm(height);
                rule.style.bottom = makeEm(shift); // Record the height and width
                rule.width = width;
                rule.height = height + shift;
                rule.depth = -shift; // Font size is the number large enough that the browser will
                // reserve at least `absHeight` space above the baseline.
                // The 1.125 factor was empirically determined
                rule.maxFontSize = height * 1.125 * options.sizeMultiplier;
                return rule;
            },
            mathmlBuilder (group, options) {
                const width = calculateSize(group.width, options);
                const height = calculateSize(group.height, options);
                const shift = group.shift ? calculateSize(group.shift, options) : 0;
                const color = options.color && options.getColor() || "black";
                const rule = new mathMLTree.MathNode("mspace");
                rule.setAttribute("mathbackground", color);
                rule.setAttribute("width", makeEm(width));
                rule.setAttribute("height", makeEm(height));
                const wrapper = new mathMLTree.MathNode("mpadded", [
                    rule
                ]);
                if (shift >= 0) wrapper.setAttribute("height", makeEm(shift));
                else {
                    wrapper.setAttribute("height", makeEm(shift));
                    wrapper.setAttribute("depth", makeEm(-shift));
                }
                wrapper.setAttribute("voffset", makeEm(shift));
                return wrapper;
            }
        });
        function sizingGroup(value, options, baseOptions) {
            const inner = buildExpression(value, options, false);
            const multiplier = options.sizeMultiplier / baseOptions.sizeMultiplier; // Add size-resetting classes to the inner list and set maxFontSize
            // manually. Handle nested size changes.
            for(let i = 0; i < inner.length; i++){
                const pos = inner[i].classes.indexOf("sizing");
                if (pos < 0) Array.prototype.push.apply(inner[i].classes, options.sizingClasses(baseOptions));
                else if (inner[i].classes[pos + 1] === "reset-size" + options.size) // This is a nested size change: e.g., inner[i] is the "b" in
                // `\Huge a \small b`. Override the old size (the `reset-` class)
                // but not the new size.
                inner[i].classes[pos + 1] = "reset-size" + baseOptions.size;
                inner[i].height *= multiplier;
                inner[i].depth *= multiplier;
            }
            return buildCommon.makeFragment(inner);
        }
        const sizeFuncs = [
            "\\tiny",
            "\\sixptsize",
            "\\scriptsize",
            "\\footnotesize",
            "\\small",
            "\\normalsize",
            "\\large",
            "\\Large",
            "\\LARGE",
            "\\huge",
            "\\Huge"
        ];
        const sizing_htmlBuilder = (group, options)=>{
            // Handle sizing operators like \Huge. Real TeX doesn't actually allow
            // these functions inside of math expressions, so we do some special
            // handling.
            const newOptions = options.havingSize(group.size);
            return sizingGroup(group.body, newOptions, options);
        };
        defineFunction({
            type: "sizing",
            names: sizeFuncs,
            props: {
                numArgs: 0,
                allowedInText: true
            },
            handler: (_ref, args)=>{
                let { breakOnTokenText: breakOnTokenText, funcName: funcName, parser: parser } = _ref;
                const body = parser.parseExpression(false, breakOnTokenText);
                return {
                    type: "sizing",
                    mode: parser.mode,
                    // Figure out what size to use based on the list of functions above
                    size: sizeFuncs.indexOf(funcName) + 1,
                    body: body
                };
            },
            htmlBuilder: sizing_htmlBuilder,
            mathmlBuilder: (group, options)=>{
                const newOptions = options.havingSize(group.size);
                const inner = buildMathML_buildExpression(group.body, newOptions);
                const node = new mathMLTree.MathNode("mstyle", inner); // TODO(emily): This doesn't produce the correct size for nested size
                // changes, because we don't keep state of what style we're currently
                // in, so we can't reset the size to normal before changing it.  Now
                // that we're passing an options parameter we should be able to fix
                // this.
                node.setAttribute("mathsize", makeEm(newOptions.sizeMultiplier));
                return node;
            }
        });
        // smash, with optional [tb], as in AMS
        defineFunction({
            type: "smash",
            names: [
                "\\smash"
            ],
            props: {
                numArgs: 1,
                numOptionalArgs: 1,
                allowedInText: true
            },
            handler: (_ref, args, optArgs)=>{
                let { parser: parser } = _ref;
                let smashHeight = false;
                let smashDepth = false;
                const tbArg = optArgs[0] && assertNodeType(optArgs[0], "ordgroup");
                if (tbArg) {
                    // Optional [tb] argument is engaged.
                    // ref: amsmath: \renewcommand{\smash}[1][tb]{%
                    //               def\mb@t{\ht}\def\mb@b{\dp}\def\mb@tb{\ht\z@\z@\dp}%
                    let letter = "";
                    for(let i = 0; i < tbArg.body.length; ++i){
                        const node = tbArg.body[i]; // $FlowFixMe: Not every node type has a `text` property.
                        letter = node.text;
                        if (letter === "t") smashHeight = true;
                        else if (letter === "b") smashDepth = true;
                        else {
                            smashHeight = false;
                            smashDepth = false;
                            break;
                        }
                    }
                } else {
                    smashHeight = true;
                    smashDepth = true;
                }
                const body = args[0];
                return {
                    type: "smash",
                    mode: parser.mode,
                    body: body,
                    smashHeight: smashHeight,
                    smashDepth: smashDepth
                };
            },
            htmlBuilder: (group, options)=>{
                const node = buildCommon.makeSpan([], [
                    buildGroup(group.body, options)
                ]);
                if (!group.smashHeight && !group.smashDepth) return node;
                if (group.smashHeight) {
                    node.height = 0; // In order to influence makeVList, we have to reset the children.
                    if (node.children) for(let i = 0; i < node.children.length; i++)node.children[i].height = 0;
                }
                if (group.smashDepth) {
                    node.depth = 0;
                    if (node.children) for(let i = 0; i < node.children.length; i++)node.children[i].depth = 0;
                } // At this point, we've reset the TeX-like height and depth values.
                // But the span still has an HTML line height.
                // makeVList applies "display: table-cell", which prevents the browser
                // from acting on that line height. So we'll call makeVList now.
                const smashedNode = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: node
                        }
                    ]
                }, options); // For spacing, TeX treats \hphantom as a math group (same spacing as ord).
                return buildCommon.makeSpan([
                    "mord"
                ], [
                    smashedNode
                ], options);
            },
            mathmlBuilder: (group, options)=>{
                const node = new mathMLTree.MathNode("mpadded", [
                    buildMathML_buildGroup(group.body, options)
                ]);
                if (group.smashHeight) node.setAttribute("height", "0px");
                if (group.smashDepth) node.setAttribute("depth", "0px");
                return node;
            }
        });
        defineFunction({
            type: "sqrt",
            names: [
                "\\sqrt"
            ],
            props: {
                numArgs: 1,
                numOptionalArgs: 1
            },
            handler (_ref, args, optArgs) {
                let { parser: parser } = _ref;
                const index = optArgs[0];
                const body = args[0];
                return {
                    type: "sqrt",
                    mode: parser.mode,
                    body: body,
                    index: index
                };
            },
            htmlBuilder (group, options) {
                // Square roots are handled in the TeXbook pg. 443, Rule 11.
                // First, we do the same steps as in overline to build the inner group
                // and line
                let inner = buildGroup(group.body, options.havingCrampedStyle());
                if (inner.height === 0) // Render a small surd.
                inner.height = options.fontMetrics().xHeight;
                 // Some groups can return document fragments.  Handle those by wrapping
                // them in a span.
                inner = buildCommon.wrapFragment(inner, options); // Calculate the minimum size for the \surd delimiter
                const metrics = options.fontMetrics();
                const theta = metrics.defaultRuleThickness;
                let phi = theta;
                if (options.style.id < src_Style.TEXT.id) phi = options.fontMetrics().xHeight;
                 // Calculate the clearance between the body and line
                let lineClearance = theta + phi / 4;
                const minDelimiterHeight = inner.height + inner.depth + lineClearance + theta; // Create a sqrt SVG of the required minimum size
                const { span: img, ruleWidth: ruleWidth, advanceWidth: advanceWidth } = delimiter.sqrtImage(minDelimiterHeight, options);
                const delimDepth = img.height - ruleWidth; // Adjust the clearance based on the delimiter size
                if (delimDepth > inner.height + inner.depth + lineClearance) lineClearance = (lineClearance + delimDepth - inner.height - inner.depth) / 2;
                 // Shift the sqrt image
                const imgShift = img.height - inner.height - lineClearance - ruleWidth;
                inner.style.paddingLeft = makeEm(advanceWidth); // Overlay the image and the argument.
                const body = buildCommon.makeVList({
                    positionType: "firstBaseline",
                    children: [
                        {
                            type: "elem",
                            elem: inner,
                            wrapperClasses: [
                                "svg-align"
                            ]
                        },
                        {
                            type: "kern",
                            size: -(inner.height + imgShift)
                        },
                        {
                            type: "elem",
                            elem: img
                        },
                        {
                            type: "kern",
                            size: ruleWidth
                        }
                    ]
                }, options);
                if (!group.index) return buildCommon.makeSpan([
                    "mord",
                    "sqrt"
                ], [
                    body
                ], options);
                else {
                    // Handle the optional root index
                    // The index is always in scriptscript style
                    const newOptions = options.havingStyle(src_Style.SCRIPTSCRIPT);
                    const rootm = buildGroup(group.index, newOptions, options); // The amount the index is shifted by. This is taken from the TeX
                    // source, in the definition of `\r@@t`.
                    const toShift = 0.6 * (body.height - body.depth); // Build a VList with the superscript shifted up correctly
                    const rootVList = buildCommon.makeVList({
                        positionType: "shift",
                        positionData: -toShift,
                        children: [
                            {
                                type: "elem",
                                elem: rootm
                            }
                        ]
                    }, options); // Add a class surrounding it so we can add on the appropriate
                    // kerning
                    const rootVListWrap = buildCommon.makeSpan([
                        "root"
                    ], [
                        rootVList
                    ]);
                    return buildCommon.makeSpan([
                        "mord",
                        "sqrt"
                    ], [
                        rootVListWrap,
                        body
                    ], options);
                }
            },
            mathmlBuilder (group, options) {
                const { body: body, index: index } = group;
                return index ? new mathMLTree.MathNode("mroot", [
                    buildMathML_buildGroup(body, options),
                    buildMathML_buildGroup(index, options)
                ]) : new mathMLTree.MathNode("msqrt", [
                    buildMathML_buildGroup(body, options)
                ]);
            }
        });
        const styling_styleMap = {
            "display": src_Style.DISPLAY,
            "text": src_Style.TEXT,
            "script": src_Style.SCRIPT,
            "scriptscript": src_Style.SCRIPTSCRIPT
        };
        defineFunction({
            type: "styling",
            names: [
                "\\displaystyle",
                "\\textstyle",
                "\\scriptstyle",
                "\\scriptscriptstyle"
            ],
            props: {
                numArgs: 0,
                allowedInText: true,
                primitive: true
            },
            handler (_ref, args) {
                let { breakOnTokenText: breakOnTokenText, funcName: funcName, parser: parser } = _ref;
                // parse out the implicit body
                const body = parser.parseExpression(true, breakOnTokenText); // TODO: Refactor to avoid duplicating styleMap in multiple places (e.g.
                // here and in buildHTML and de-dupe the enumeration of all the styles).
                // $FlowFixMe: The names above exactly match the styles.
                const style = funcName.slice(1, funcName.length - 5);
                return {
                    type: "styling",
                    mode: parser.mode,
                    style: // Figure out what style to use by pulling out the style from
                    // the function name
                    style,
                    body: body
                };
            },
            htmlBuilder (group, options) {
                // Style changes are handled in the TeXbook on pg. 442, Rule 3.
                const newStyle = styling_styleMap[group.style];
                const newOptions = options.havingStyle(newStyle).withFont('');
                return sizingGroup(group.body, newOptions, options);
            },
            mathmlBuilder (group, options) {
                // Figure out what style we're changing to.
                const newStyle = styling_styleMap[group.style];
                const newOptions = options.havingStyle(newStyle);
                const inner = buildMathML_buildExpression(group.body, newOptions);
                const node = new mathMLTree.MathNode("mstyle", inner);
                const styleAttributes = {
                    "display": [
                        "0",
                        "true"
                    ],
                    "text": [
                        "0",
                        "false"
                    ],
                    "script": [
                        "1",
                        "false"
                    ],
                    "scriptscript": [
                        "2",
                        "false"
                    ]
                };
                const attr = styleAttributes[group.style];
                node.setAttribute("scriptlevel", attr[0]);
                node.setAttribute("displaystyle", attr[1]);
                return node;
            }
        });
        /**
 * Sometimes, groups perform special rules when they have superscripts or
 * subscripts attached to them. This function lets the `supsub` group know that
 * Sometimes, groups perform special rules when they have superscripts or
 * its inner element should handle the superscripts and subscripts instead of
 * handling them itself.
 */ const htmlBuilderDelegate = function(group, options) {
            const base = group.base;
            if (!base) return null;
            else if (base.type === "op") {
                // Operators handle supsubs differently when they have limits
                // (e.g. `\displaystyle\sum_2^3`)
                const delegate = base.limits && (options.style.size === src_Style.DISPLAY.size || base.alwaysHandleSupSub);
                return delegate ? op_htmlBuilder : null;
            } else if (base.type === "operatorname") {
                const delegate = base.alwaysHandleSupSub && (options.style.size === src_Style.DISPLAY.size || base.limits);
                return delegate ? operatorname_htmlBuilder : null;
            } else if (base.type === "accent") return utils.isCharacterBox(base.base) ? htmlBuilder : null;
            else if (base.type === "horizBrace") {
                const isSup = !group.sub;
                return isSup === base.isOver ? horizBrace_htmlBuilder : null;
            } else return null;
        }; // Super scripts and subscripts, whose precise placement can depend on other
        // functions that precede them.
        defineFunctionBuilders({
            type: "supsub",
            htmlBuilder (group, options) {
                // Superscript and subscripts are handled in the TeXbook on page
                // 445-446, rules 18(a-f).
                // Here is where we defer to the inner group if it should handle
                // superscripts and subscripts itself.
                const builderDelegate = htmlBuilderDelegate(group, options);
                if (builderDelegate) return builderDelegate(group, options);
                const { base: valueBase, sup: valueSup, sub: valueSub } = group;
                const base = buildGroup(valueBase, options);
                let supm;
                let subm;
                const metrics = options.fontMetrics(); // Rule 18a
                let supShift = 0;
                let subShift = 0;
                const isCharacterBox = valueBase && utils.isCharacterBox(valueBase);
                if (valueSup) {
                    const newOptions = options.havingStyle(options.style.sup());
                    supm = buildGroup(valueSup, newOptions, options);
                    if (!isCharacterBox) supShift = base.height - newOptions.fontMetrics().supDrop * newOptions.sizeMultiplier / options.sizeMultiplier;
                }
                if (valueSub) {
                    const newOptions = options.havingStyle(options.style.sub());
                    subm = buildGroup(valueSub, newOptions, options);
                    if (!isCharacterBox) subShift = base.depth + newOptions.fontMetrics().subDrop * newOptions.sizeMultiplier / options.sizeMultiplier;
                } // Rule 18c
                let minSupShift;
                if (options.style === src_Style.DISPLAY) minSupShift = metrics.sup1;
                else if (options.style.cramped) minSupShift = metrics.sup3;
                else minSupShift = metrics.sup2;
                 // scriptspace is a font-size-independent size, so scale it
                // appropriately for use as the marginRight.
                const multiplier = options.sizeMultiplier;
                const marginRight = makeEm(0.5 / metrics.ptPerEm / multiplier);
                let marginLeft = null;
                if (subm) {
                    // Subscripts shouldn't be shifted by the base's italic correction.
                    // Account for that by shifting the subscript back the appropriate
                    // amount. Note we only do this when the base is a single symbol.
                    const isOiint = group.base && group.base.type === "op" && group.base.name && (group.base.name === "\\oiint" || group.base.name === "\\oiiint");
                    if (base instanceof SymbolNode || isOiint) // $FlowFixMe
                    marginLeft = makeEm(-base.italic);
                }
                let supsub;
                if (supm && subm) {
                    supShift = Math.max(supShift, minSupShift, supm.depth + 0.25 * metrics.xHeight);
                    subShift = Math.max(subShift, metrics.sub2);
                    const ruleWidth = metrics.defaultRuleThickness; // Rule 18e
                    const maxWidth = 4 * ruleWidth;
                    if (supShift - supm.depth - (subm.height - subShift) < maxWidth) {
                        subShift = maxWidth - (supShift - supm.depth) + subm.height;
                        const psi = 0.8 * metrics.xHeight - (supShift - supm.depth);
                        if (psi > 0) {
                            supShift += psi;
                            subShift -= psi;
                        }
                    }
                    const vlistElem = [
                        {
                            type: "elem",
                            elem: subm,
                            shift: subShift,
                            marginRight: marginRight,
                            marginLeft: marginLeft
                        },
                        {
                            type: "elem",
                            elem: supm,
                            shift: -supShift,
                            marginRight: marginRight
                        }
                    ];
                    supsub = buildCommon.makeVList({
                        positionType: "individualShift",
                        children: vlistElem
                    }, options);
                } else if (subm) {
                    // Rule 18b
                    subShift = Math.max(subShift, metrics.sub1, subm.height - 0.8 * metrics.xHeight);
                    const vlistElem = [
                        {
                            type: "elem",
                            elem: subm,
                            marginLeft: marginLeft,
                            marginRight: marginRight
                        }
                    ];
                    supsub = buildCommon.makeVList({
                        positionType: "shift",
                        positionData: subShift,
                        children: vlistElem
                    }, options);
                } else if (supm) {
                    // Rule 18c, d
                    supShift = Math.max(supShift, minSupShift, supm.depth + 0.25 * metrics.xHeight);
                    supsub = buildCommon.makeVList({
                        positionType: "shift",
                        positionData: -supShift,
                        children: [
                            {
                                type: "elem",
                                elem: supm,
                                marginRight: marginRight
                            }
                        ]
                    }, options);
                } else throw new Error("supsub must have either sup or sub.");
                 // Wrap the supsub vlist in a span.msupsub to reset text-align.
                const mclass = getTypeOfDomTree(base, "right") || "mord";
                return buildCommon.makeSpan([
                    mclass
                ], [
                    base,
                    buildCommon.makeSpan([
                        "msupsub"
                    ], [
                        supsub
                    ])
                ], options);
            },
            mathmlBuilder (group, options) {
                // Is the inner group a relevant horizontal brace?
                let isBrace = false;
                let isOver;
                let isSup;
                if (group.base && group.base.type === "horizBrace") {
                    isSup = !!group.sup;
                    if (isSup === group.base.isOver) {
                        isBrace = true;
                        isOver = group.base.isOver;
                    }
                }
                if (group.base && (group.base.type === "op" || group.base.type === "operatorname")) group.base.parentIsSupSub = true;
                const children = [
                    buildMathML_buildGroup(group.base, options)
                ];
                if (group.sub) children.push(buildMathML_buildGroup(group.sub, options));
                if (group.sup) children.push(buildMathML_buildGroup(group.sup, options));
                let nodeType;
                if (isBrace) nodeType = isOver ? "mover" : "munder";
                else if (!group.sub) {
                    const base = group.base;
                    if (base && base.type === "op" && base.limits && (options.style === src_Style.DISPLAY || base.alwaysHandleSupSub)) nodeType = "mover";
                    else if (base && base.type === "operatorname" && base.alwaysHandleSupSub && (base.limits || options.style === src_Style.DISPLAY)) nodeType = "mover";
                    else nodeType = "msup";
                } else if (!group.sup) {
                    const base = group.base;
                    if (base && base.type === "op" && base.limits && (options.style === src_Style.DISPLAY || base.alwaysHandleSupSub)) nodeType = "munder";
                    else if (base && base.type === "operatorname" && base.alwaysHandleSupSub && (base.limits || options.style === src_Style.DISPLAY)) nodeType = "munder";
                    else nodeType = "msub";
                } else {
                    const base = group.base;
                    if (base && base.type === "op" && base.limits && options.style === src_Style.DISPLAY) nodeType = "munderover";
                    else if (base && base.type === "operatorname" && base.alwaysHandleSupSub && (options.style === src_Style.DISPLAY || base.limits)) nodeType = "munderover";
                    else nodeType = "msubsup";
                }
                return new mathMLTree.MathNode(nodeType, children);
            }
        });
        // Operator ParseNodes created in Parser.js from symbol Groups in src/symbols.js.
        defineFunctionBuilders({
            type: "atom",
            htmlBuilder (group, options) {
                return buildCommon.mathsym(group.text, group.mode, options, [
                    "m" + group.family
                ]);
            },
            mathmlBuilder (group, options) {
                const node = new mathMLTree.MathNode("mo", [
                    makeText(group.text, group.mode)
                ]);
                if (group.family === "bin") {
                    const variant = getVariant(group, options);
                    if (variant === "bold-italic") node.setAttribute("mathvariant", variant);
                } else if (group.family === "punct") node.setAttribute("separator", "true");
                else if (group.family === "open" || group.family === "close") // Delims built here should not stretch vertically.
                // See delimsizing.js for stretchy delims.
                node.setAttribute("stretchy", "false");
                return node;
            }
        });
        // "mathord" and "textord" ParseNodes created in Parser.js from symbol Groups in
        // src/symbols.js.
        const defaultVariant = {
            "mi": "italic",
            "mn": "normal",
            "mtext": "normal"
        };
        defineFunctionBuilders({
            type: "mathord",
            htmlBuilder (group, options) {
                return buildCommon.makeOrd(group, options, "mathord");
            },
            mathmlBuilder (group, options) {
                const node = new mathMLTree.MathNode("mi", [
                    makeText(group.text, group.mode, options)
                ]);
                const variant = getVariant(group, options) || "italic";
                if (variant !== defaultVariant[node.type]) node.setAttribute("mathvariant", variant);
                return node;
            }
        });
        defineFunctionBuilders({
            type: "textord",
            htmlBuilder (group, options) {
                return buildCommon.makeOrd(group, options, "textord");
            },
            mathmlBuilder (group, options) {
                const text = makeText(group.text, group.mode, options);
                const variant = getVariant(group, options) || "normal";
                let node;
                if (group.mode === 'text') node = new mathMLTree.MathNode("mtext", [
                    text
                ]);
                else if (/[0-9]/.test(group.text)) node = new mathMLTree.MathNode("mn", [
                    text
                ]);
                else if (group.text === "\\prime") node = new mathMLTree.MathNode("mo", [
                    text
                ]);
                else node = new mathMLTree.MathNode("mi", [
                    text
                ]);
                if (variant !== defaultVariant[node.type]) node.setAttribute("mathvariant", variant);
                return node;
            }
        });
        // A map of CSS-based spacing functions to their CSS class.
        const cssSpace = {
            "\\nobreak": "nobreak",
            "\\allowbreak": "allowbreak"
        }; // A lookup table to determine whether a spacing function/symbol should be
        // treated like a regular space character.  If a symbol or command is a key
        // in this table, then it should be a regular space character.  Furthermore,
        // the associated value may have a `className` specifying an extra CSS class
        // to add to the created `span`.
        const regularSpace = {
            " ": {},
            "\\ ": {},
            "~": {
                className: "nobreak"
            },
            "\\space": {},
            "\\nobreakspace": {
                className: "nobreak"
            }
        }; // ParseNode<"spacing"> created in Parser.js from the "spacing" symbol Groups in
        // src/symbols.js.
        defineFunctionBuilders({
            type: "spacing",
            htmlBuilder (group, options) {
                if (regularSpace.hasOwnProperty(group.text)) {
                    const className = regularSpace[group.text].className || ""; // Spaces are generated by adding an actual space. Each of these
                    // things has an entry in the symbols table, so these will be turned
                    // into appropriate outputs.
                    if (group.mode === "text") {
                        const ord = buildCommon.makeOrd(group, options, "textord");
                        ord.classes.push(className);
                        return ord;
                    } else return buildCommon.makeSpan([
                        "mspace",
                        className
                    ], [
                        buildCommon.mathsym(group.text, group.mode, options)
                    ], options);
                } else if (cssSpace.hasOwnProperty(group.text)) // Spaces based on just a CSS class.
                return buildCommon.makeSpan([
                    "mspace",
                    cssSpace[group.text]
                ], [], options);
                else throw new src_ParseError("Unknown type of space \"" + group.text + "\"");
            },
            mathmlBuilder (group, options) {
                let node;
                if (regularSpace.hasOwnProperty(group.text)) node = new mathMLTree.MathNode("mtext", [
                    new mathMLTree.TextNode("\u00a0")
                ]);
                else if (cssSpace.hasOwnProperty(group.text)) // CSS-based MathML spaces (\nobreak, \allowbreak) are ignored
                return new mathMLTree.MathNode("mspace");
                else throw new src_ParseError("Unknown type of space \"" + group.text + "\"");
                return node;
            }
        });
        const pad = ()=>{
            const padNode = new mathMLTree.MathNode("mtd", []);
            padNode.setAttribute("width", "50%");
            return padNode;
        };
        defineFunctionBuilders({
            type: "tag",
            mathmlBuilder (group, options) {
                const table = new mathMLTree.MathNode("mtable", [
                    new mathMLTree.MathNode("mtr", [
                        pad(),
                        new mathMLTree.MathNode("mtd", [
                            buildExpressionRow(group.body, options)
                        ]),
                        pad(),
                        new mathMLTree.MathNode("mtd", [
                            buildExpressionRow(group.tag, options)
                        ])
                    ])
                ]);
                table.setAttribute("width", "100%");
                return table; // TODO: Left-aligned tags.
            // Currently, the group and options passed here do not contain
            // enough info to set tag alignment. `leqno` is in Settings but it is
            // not passed to Options. On the HTML side, leqno is
            // set by a CSS class applied in buildTree.js. That would have worked
            // in MathML if browsers supported <mlabeledtr>. Since they don't, we
            // need to rewrite the way this function is called.
            }
        });
        // Non-mathy text, possibly in a font
        const textFontFamilies = {
            "\\text": undefined,
            "\\textrm": "textrm",
            "\\textsf": "textsf",
            "\\texttt": "texttt",
            "\\textnormal": "textrm"
        };
        const textFontWeights = {
            "\\textbf": "textbf",
            "\\textmd": "textmd"
        };
        const textFontShapes = {
            "\\textit": "textit",
            "\\textup": "textup"
        };
        const optionsWithFont = (group, options)=>{
            const font = group.font; // Checks if the argument is a font family or a font style.
            if (!font) return options;
            else if (textFontFamilies[font]) return options.withTextFontFamily(textFontFamilies[font]);
            else if (textFontWeights[font]) return options.withTextFontWeight(textFontWeights[font]);
            else if (font === "\\emph") return options.fontShape === "textit" ? options.withTextFontShape("textup") : options.withTextFontShape("textit");
            return options.withTextFontShape(textFontShapes[font]);
        };
        defineFunction({
            type: "text",
            names: [
                "\\text",
                "\\textrm",
                "\\textsf",
                "\\texttt",
                "\\textnormal",
                "\\textbf",
                "\\textmd",
                "\\textit",
                "\\textup",
                "\\emph"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "text"
                ],
                allowedInArgument: true,
                allowedInText: true
            },
            handler (_ref, args) {
                let { parser: parser, funcName: funcName } = _ref;
                const body = args[0];
                return {
                    type: "text",
                    mode: parser.mode,
                    body: ordargument(body),
                    font: funcName
                };
            },
            htmlBuilder (group, options) {
                const newOptions = optionsWithFont(group, options);
                const inner = buildExpression(group.body, newOptions, true);
                return buildCommon.makeSpan([
                    "mord",
                    "text"
                ], inner, newOptions);
            },
            mathmlBuilder (group, options) {
                const newOptions = optionsWithFont(group, options);
                return buildExpressionRow(group.body, newOptions);
            }
        });
        defineFunction({
            type: "underline",
            names: [
                "\\underline"
            ],
            props: {
                numArgs: 1,
                allowedInText: true
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                return {
                    type: "underline",
                    mode: parser.mode,
                    body: args[0]
                };
            },
            htmlBuilder (group, options) {
                // Underlines are handled in the TeXbook pg 443, Rule 10.
                // Build the inner group.
                const innerGroup = buildGroup(group.body, options); // Create the line to go below the body
                const line = buildCommon.makeLineSpan("underline-line", options); // Generate the vlist, with the appropriate kerns
                const defaultRuleThickness = options.fontMetrics().defaultRuleThickness;
                const vlist = buildCommon.makeVList({
                    positionType: "top",
                    positionData: innerGroup.height,
                    children: [
                        {
                            type: "kern",
                            size: defaultRuleThickness
                        },
                        {
                            type: "elem",
                            elem: line
                        },
                        {
                            type: "kern",
                            size: 3 * defaultRuleThickness
                        },
                        {
                            type: "elem",
                            elem: innerGroup
                        }
                    ]
                }, options);
                return buildCommon.makeSpan([
                    "mord",
                    "underline"
                ], [
                    vlist
                ], options);
            },
            mathmlBuilder (group, options) {
                const operator = new mathMLTree.MathNode("mo", [
                    new mathMLTree.TextNode("\u203e")
                ]);
                operator.setAttribute("stretchy", "true");
                const node = new mathMLTree.MathNode("munder", [
                    buildMathML_buildGroup(group.body, options),
                    operator
                ]);
                node.setAttribute("accentunder", "true");
                return node;
            }
        });
        // \vcenter:  Vertically center the argument group on the math axis.
        defineFunction({
            type: "vcenter",
            names: [
                "\\vcenter"
            ],
            props: {
                numArgs: 1,
                argTypes: [
                    "original"
                ],
                // In LaTeX, \vcenter can act only on a box.
                allowedInText: false
            },
            handler (_ref, args) {
                let { parser: parser } = _ref;
                return {
                    type: "vcenter",
                    mode: parser.mode,
                    body: args[0]
                };
            },
            htmlBuilder (group, options) {
                const body = buildGroup(group.body, options);
                const axisHeight = options.fontMetrics().axisHeight;
                const dy = 0.5 * (body.height - axisHeight - (body.depth + axisHeight));
                return buildCommon.makeVList({
                    positionType: "shift",
                    positionData: dy,
                    children: [
                        {
                            type: "elem",
                            elem: body
                        }
                    ]
                }, options);
            },
            mathmlBuilder (group, options) {
                // There is no way to do this in MathML.
                // Write a class as a breadcrumb in case some post-processor wants
                // to perform a vcenter adjustment.
                return new mathMLTree.MathNode("mpadded", [
                    buildMathML_buildGroup(group.body, options)
                ], [
                    "vcenter"
                ]);
            }
        });
        defineFunction({
            type: "verb",
            names: [
                "\\verb"
            ],
            props: {
                numArgs: 0,
                allowedInText: true
            },
            handler (context, args, optArgs) {
                // \verb and \verb* are dealt with directly in Parser.js.
                // If we end up here, it's because of a failure to match the two delimiters
                // in the regex in Lexer.js.  LaTeX raises the following error when \verb is
                // terminated by end of line (or file).
                throw new src_ParseError("\\verb ended by end of line instead of matching delimiter");
            },
            htmlBuilder (group, options) {
                const text = makeVerb(group);
                const body = []; // \verb enters text mode and therefore is sized like \textstyle
                const newOptions = options.havingStyle(options.style.text());
                for(let i = 0; i < text.length; i++){
                    let c = text[i];
                    if (c === '~') c = '\\textasciitilde';
                    body.push(buildCommon.makeSymbol(c, "Typewriter-Regular", group.mode, newOptions, [
                        "mord",
                        "texttt"
                    ]));
                }
                return buildCommon.makeSpan([
                    "mord",
                    "text"
                ].concat(newOptions.sizingClasses(options)), buildCommon.tryCombineChars(body), newOptions);
            },
            mathmlBuilder (group, options) {
                const text = new mathMLTree.TextNode(makeVerb(group));
                const node = new mathMLTree.MathNode("mtext", [
                    text
                ]);
                node.setAttribute("mathvariant", "monospace");
                return node;
            }
        });
        /**
 * Converts verb group into body string.
 *
 * \verb* replaces each space with an open box \u2423
 * \verb replaces each space with a no-break space \xA0
 */ const makeVerb = (group)=>group.body.replace(/ /g, group.star ? '\u2423' : '\xA0');
        /** Include this to ensure that all functions are defined. */ const functions = _functions;
        /* harmony default export */ var src_functions = functions; // TODO(kevinb): have functions return an object and call defineFunction with
        /**
 * The Lexer class handles tokenizing the input in various ways. Since our
 * parser expects us to be able to backtrack, the lexer allows lexing from any
 * given starting point.
 *
 * Its main exposed function is the `lex` function, which takes a position to
 * lex from and a type of token to lex. It defers to the appropriate `_innerLex`
 * function.
 *
 * The various `_innerLex` functions perform the actual lexing of different
 * kinds.
 */ /* The following tokenRegex
 * - matches typical whitespace (but not NBSP etc.) using its first group
 * - does not match any control character \x00-\x1f except whitespace
 * - does not match a bare backslash
 * - matches any ASCII character except those just mentioned
 * - does not match the BMP private use area \uE000-\uF8FF
 * - does not match bare surrogate code units
 * - matches any BMP character except for those just described
 * - matches any valid Unicode surrogate pair
 * - matches a backslash followed by one or more whitespace characters
 * - matches a backslash followed by one or more letters then whitespace
 * - matches a backslash followed by any BMP character
 * Capturing groups:
 *   [1] regular whitespace
 *   [2] backslash followed by whitespace
 *   [3] anything else, which may include:
 *     [4] left character of \verb*
 *     [5] left character of \verb
 *     [6] backslash followed by word, excluding any trailing whitespace
 * Just because the Lexer matches something doesn't mean it's valid input:
 * If there is no matching function or symbol definition, the Parser will
 * still reject the input.
 */ const spaceRegexString = "[ \r\n\t]";
        const controlWordRegexString = "\\\\[a-zA-Z@]+";
        const controlSymbolRegexString = "\\\\[^\uD800-\uDFFF]";
        const controlWordWhitespaceRegexString = "(" + controlWordRegexString + ")" + spaceRegexString + "*";
        const controlSpaceRegexString = "\\\\(\n|[ \r\t]+\n?)[ \r\t]*";
        const combiningDiacriticalMarkString = "[\u0300-\u036f]";
        const combiningDiacriticalMarksEndRegex = new RegExp(combiningDiacriticalMarkString + "+$");
        const tokenRegexString = "(" + spaceRegexString + "+)|" + (controlSpaceRegexString + "|") + // \whitespace
        "([!-\\[\\]-\u2027\u202A-\uD7FF\uF900-\uFFFF]" + (combiningDiacriticalMarkString + "*") + // ...plus accents
        "|[\uD800-\uDBFF][\uDC00-\uDFFF]" + (combiningDiacriticalMarkString + "*") + // ...plus accents
        "|\\\\verb\\*([^]).*?\\4" + // \verb*
        "|\\\\verb([^*a-zA-Z]).*?\\5" + ("|" + controlWordWhitespaceRegexString) + ("|" + controlSymbolRegexString + ")"); // \\, \', etc.
        /** Main Lexer class */ class Lexer {
            // Category codes. The lexer only supports comment characters (14) for now.
            // MacroExpander additionally distinguishes active (13).
            constructor(input, settings){
                this.input = void 0;
                this.settings = void 0;
                this.tokenRegex = void 0;
                this.catcodes = void 0;
                // Separate accents from characters
                this.input = input;
                this.settings = settings;
                this.tokenRegex = new RegExp(tokenRegexString, 'g');
                this.catcodes = {
                    "%": 14,
                    // comment character
                    "~": 13 // active character
                };
            }
            setCatcode(char, code) {
                this.catcodes[char] = code;
            }
            /**
   * This function lexes a single token.
   */ lex() {
                const input = this.input;
                const pos = this.tokenRegex.lastIndex;
                if (pos === input.length) return new Token("EOF", new SourceLocation(this, pos, pos));
                const match = this.tokenRegex.exec(input);
                if (match === null || match.index !== pos) throw new src_ParseError("Unexpected character: '" + input[pos] + "'", new Token(input[pos], new SourceLocation(this, pos, pos + 1)));
                const text = match[6] || match[3] || (match[2] ? "\\ " : " ");
                if (this.catcodes[text] === 14) {
                    // comment character
                    const nlIndex = input.indexOf('\n', this.tokenRegex.lastIndex);
                    if (nlIndex === -1) {
                        this.tokenRegex.lastIndex = input.length; // EOF
                        this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)");
                    } else this.tokenRegex.lastIndex = nlIndex + 1;
                    return this.lex();
                }
                return new Token(text, new SourceLocation(this, pos, this.tokenRegex.lastIndex));
            }
        }
        /**
 * A `Namespace` refers to a space of nameable things like macros or lengths,
 * which can be `set` either globally or local to a nested group, using an
 * undo stack similar to how TeX implements this functionality.
 * Performance-wise, `get` and local `set` take constant time, while global
 * `set` takes time proportional to the depth of group nesting.
 */ class Namespace {
            /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */ constructor(builtins, globalMacros){
                if (builtins === void 0) builtins = {};
                if (globalMacros === void 0) globalMacros = {};
                this.current = void 0;
                this.builtins = void 0;
                this.undefStack = void 0;
                this.current = globalMacros;
                this.builtins = builtins;
                this.undefStack = [];
            }
            /**
   * Start a new nested group, affecting future local `set`s.
   */ beginGroup() {
                this.undefStack.push({});
            }
            /**
   * End current nested group, restoring values before the group began.
   */ endGroup() {
                if (this.undefStack.length === 0) throw new src_ParseError("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
                const undefs = this.undefStack.pop();
                for(const undef in undefs)if (undefs.hasOwnProperty(undef)) {
                    if (undefs[undef] == null) delete this.current[undef];
                    else this.current[undef] = undefs[undef];
                }
            }
            /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */ endGroups() {
                while(this.undefStack.length > 0)this.endGroup();
            }
            /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */ has(name) {
                return this.current.hasOwnProperty(name) || this.builtins.hasOwnProperty(name);
            }
            /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */ get(name) {
                if (this.current.hasOwnProperty(name)) return this.current[name];
                else return this.builtins[name];
            }
            /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */ set(name, value, global) {
                if (global === void 0) global = false;
                if (global) {
                    // Global set is equivalent to setting in all groups.  Simulate this
                    // by destroying any undos currently scheduled for this name,
                    // and adding an undo with the *new* value (in case it later gets
                    // locally reset within this environment).
                    for(let i = 0; i < this.undefStack.length; i++)delete this.undefStack[i][name];
                    if (this.undefStack.length > 0) this.undefStack[this.undefStack.length - 1][name] = value;
                } else {
                    // Undo this set at end of this group (possibly to `undefined`),
                    // unless an undo is already in place, in which case that older
                    // value is the correct one.
                    const top = this.undefStack[this.undefStack.length - 1];
                    if (top && !top.hasOwnProperty(name)) top[name] = this.current[name];
                }
                if (value == null) delete this.current[name];
                else this.current[name] = value;
            }
        }
        /**
 * Predefined macros for KaTeX.
 * This can be used to define some commands in terms of others.
 */ // Export global macros object from defineMacro
        const macros = _macros;
        /* harmony default export */ var src_macros = macros;
        //////////////////////////////////////////////////////////////////////
        // macro tools
        defineMacro("\\noexpand", function(context) {
            // The expansion is the token itself; but that token is interpreted
            // as if its meaning were ‘\relax’ if it is a control sequence that
            // would ordinarily be expanded by TeX’s expansion rules.
            const t = context.popToken();
            if (context.isExpandable(t.text)) {
                t.noexpand = true;
                t.treatAsRelax = true;
            }
            return {
                tokens: [
                    t
                ],
                numArgs: 0
            };
        });
        defineMacro("\\expandafter", function(context) {
            // TeX first reads the token that comes immediately after \expandafter,
            // without expanding it; let’s call this token t. Then TeX reads the
            // token that comes after t (and possibly more tokens, if that token
            // has an argument), replacing it by its expansion. Finally TeX puts
            // t back in front of that expansion.
            const t = context.popToken();
            context.expandOnce(true); // expand only an expandable token
            return {
                tokens: [
                    t
                ],
                numArgs: 0
            };
        }); // LaTeX's \@firstoftwo{#1}{#2} expands to #1, skipping #2
        // TeX source: \long\def\@firstoftwo#1#2{#1}
        defineMacro("\\@firstoftwo", function(context) {
            const args = context.consumeArgs(2);
            return {
                tokens: args[0],
                numArgs: 0
            };
        }); // LaTeX's \@secondoftwo{#1}{#2} expands to #2, skipping #1
        // TeX source: \long\def\@secondoftwo#1#2{#2}
        defineMacro("\\@secondoftwo", function(context) {
            const args = context.consumeArgs(2);
            return {
                tokens: args[1],
                numArgs: 0
            };
        }); // LaTeX's \@ifnextchar{#1}{#2}{#3} looks ahead to the next (unexpanded)
        // symbol that isn't a space, consuming any spaces but not consuming the
        // first nonspace character.  If that nonspace character matches #1, then
        // the macro expands to #2; otherwise, it expands to #3.
        defineMacro("\\@ifnextchar", function(context) {
            const args = context.consumeArgs(3); // symbol, if, else
            context.consumeSpaces();
            const nextToken = context.future();
            if (args[0].length === 1 && args[0][0].text === nextToken.text) return {
                tokens: args[1],
                numArgs: 0
            };
            else return {
                tokens: args[2],
                numArgs: 0
            };
        }); // LaTeX's \@ifstar{#1}{#2} looks ahead to the next (unexpanded) symbol.
        // If it is `*`, then it consumes the symbol, and the macro expands to #1;
        // otherwise, the macro expands to #2 (without consuming the symbol).
        // TeX source: \def\@ifstar#1{\@ifnextchar *{\@firstoftwo{#1}}}
        defineMacro("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}"); // LaTeX's \TextOrMath{#1}{#2} expands to #1 in text mode, #2 in math mode
        defineMacro("\\TextOrMath", function(context) {
            const args = context.consumeArgs(2);
            if (context.mode === 'text') return {
                tokens: args[0],
                numArgs: 0
            };
            else return {
                tokens: args[1],
                numArgs: 0
            };
        }); // Lookup table for parsing numbers in base 8 through 16
        const digitToNumber = {
            "0": 0,
            "1": 1,
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": 6,
            "7": 7,
            "8": 8,
            "9": 9,
            "a": 10,
            "A": 10,
            "b": 11,
            "B": 11,
            "c": 12,
            "C": 12,
            "d": 13,
            "D": 13,
            "e": 14,
            "E": 14,
            "f": 15,
            "F": 15
        }; // TeX \char makes a literal character (catcode 12) using the following forms:
        // (see The TeXBook, p. 43)
        //   \char123  -- decimal
        //   \char'123 -- octal
        //   \char"123 -- hex
        //   \char`x   -- character that can be written (i.e. isn't active)
        //   \char`\x  -- character that cannot be written (e.g. %)
        // These all refer to characters from the font, so we turn them into special
        // calls to a function \@char dealt with in the Parser.
        defineMacro("\\char", function(context) {
            let token = context.popToken();
            let base;
            let number = '';
            if (token.text === "'") {
                base = 8;
                token = context.popToken();
            } else if (token.text === '"') {
                base = 16;
                token = context.popToken();
            } else if (token.text === "`") {
                token = context.popToken();
                if (token.text[0] === "\\") number = token.text.charCodeAt(1);
                else if (token.text === "EOF") throw new src_ParseError("\\char` missing argument");
                else number = token.text.charCodeAt(0);
            } else base = 10;
            if (base) {
                // Parse a number in the given base, starting with first `token`.
                number = digitToNumber[token.text];
                if (number == null || number >= base) throw new src_ParseError("Invalid base-" + base + " digit " + token.text);
                let digit;
                while((digit = digitToNumber[context.future().text]) != null && digit < base){
                    number *= base;
                    number += digit;
                    context.popToken();
                }
            }
            return "\\@char{" + number + "}";
        }); // \newcommand{\macro}[args]{definition}
        // \renewcommand{\macro}[args]{definition}
        // TODO: Optional arguments: \newcommand{\macro}[args][default]{definition}
        const newcommand = (context, existsOK, nonexistsOK, skipIfExists)=>{
            let arg = context.consumeArg().tokens;
            if (arg.length !== 1) throw new src_ParseError("\\newcommand's first argument must be a macro name");
            const name = arg[0].text;
            const exists = context.isDefined(name);
            if (exists && !existsOK) throw new src_ParseError("\\newcommand{" + name + "} attempting to redefine " + (name + "; use \\renewcommand"));
            if (!exists && !nonexistsOK) throw new src_ParseError("\\renewcommand{" + name + "} when command " + name + " " + "does not yet exist; use \\newcommand");
            let numArgs = 0;
            arg = context.consumeArg().tokens;
            if (arg.length === 1 && arg[0].text === "[") {
                let argText = '';
                let token = context.expandNextToken();
                while(token.text !== "]" && token.text !== "EOF"){
                    // TODO: Should properly expand arg, e.g., ignore {}s
                    argText += token.text;
                    token = context.expandNextToken();
                }
                if (!argText.match(/^\s*[0-9]+\s*$/)) throw new src_ParseError("Invalid number of arguments: " + argText);
                numArgs = parseInt(argText);
                arg = context.consumeArg().tokens;
            }
            if (!(exists && skipIfExists)) // Final arg is the expansion of the macro
            context.macros.set(name, {
                tokens: arg,
                numArgs: numArgs
            });
            return '';
        };
        defineMacro("\\newcommand", (context)=>newcommand(context, false, true, false));
        defineMacro("\\renewcommand", (context)=>newcommand(context, true, false, false));
        defineMacro("\\providecommand", (context)=>newcommand(context, true, true, true)); // terminal (console) tools
        defineMacro("\\message", (context)=>{
            const arg = context.consumeArgs(1)[0]; // eslint-disable-next-line no-console
            console.log(arg.reverse().map((token)=>token.text).join(""));
            return '';
        });
        defineMacro("\\errmessage", (context)=>{
            const arg = context.consumeArgs(1)[0]; // eslint-disable-next-line no-console
            console.error(arg.reverse().map((token)=>token.text).join(""));
            return '';
        });
        defineMacro("\\show", (context)=>{
            const tok = context.popToken();
            const name = tok.text; // eslint-disable-next-line no-console
            console.log(tok, context.macros.get(name), src_functions[name], src_symbols.math[name], src_symbols.text[name]);
            return '';
        }); //////////////////////////////////////////////////////////////////////
        // Grouping
        // \let\bgroup={ \let\egroup=}
        defineMacro("\\bgroup", "{");
        defineMacro("\\egroup", "}"); // Symbols from latex.ltx:
        // \def~{\nobreakspace{}}
        // \def\lq{`}
        // \def\rq{'}
        // \def \aa {\r a}
        // \def \AA {\r A}
        defineMacro("~", "\\nobreakspace");
        defineMacro("\\lq", "`");
        defineMacro("\\rq", "'");
        defineMacro("\\aa", "\\r a");
        defineMacro("\\AA", "\\r A"); // Copyright (C) and registered (R) symbols. Use raw symbol in MathML.
        // \DeclareTextCommandDefault{\textcopyright}{\textcircled{c}}
        // \DeclareTextCommandDefault{\textregistered}{\textcircled{%
        //      \check@mathfonts\fontsize\sf@size\z@\math@fontsfalse\selectfont R}}
        // \DeclareRobustCommand{\copyright}{%
        //    \ifmmode{\nfss@text{\textcopyright}}\else\textcopyright\fi}
        defineMacro("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`\xa9}");
        defineMacro("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
        defineMacro("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`\xae}"); // Characters omitted from Unicode range 1D400–1D7FF
        defineMacro("\u212C", "\\mathscr{B}"); // script
        defineMacro("\u2130", "\\mathscr{E}");
        defineMacro("\u2131", "\\mathscr{F}");
        defineMacro("\u210B", "\\mathscr{H}");
        defineMacro("\u2110", "\\mathscr{I}");
        defineMacro("\u2112", "\\mathscr{L}");
        defineMacro("\u2133", "\\mathscr{M}");
        defineMacro("\u211B", "\\mathscr{R}");
        defineMacro("\u212D", "\\mathfrak{C}"); // Fraktur
        defineMacro("\u210C", "\\mathfrak{H}");
        defineMacro("\u2128", "\\mathfrak{Z}"); // Define \Bbbk with a macro that works in both HTML and MathML.
        defineMacro("\\Bbbk", "\\Bbb{k}"); // Unicode middle dot
        // The KaTeX fonts do not contain U+00B7. Instead, \cdotp displays
        // the dot at U+22C5 and gives it punct spacing.
        defineMacro("\u00b7", "\\cdotp"); // \llap and \rlap render their contents in text mode
        defineMacro("\\llap", "\\mathllap{\\textrm{#1}}");
        defineMacro("\\rlap", "\\mathrlap{\\textrm{#1}}");
        defineMacro("\\clap", "\\mathclap{\\textrm{#1}}"); // \mathstrut from the TeXbook, p 360
        defineMacro("\\mathstrut", "\\vphantom{(}"); // \underbar from TeXbook p 353
        defineMacro("\\underbar", "\\underline{\\text{#1}}"); // \not is defined by base/fontmath.ltx via
        // \DeclareMathSymbol{\not}{\mathrel}{symbols}{"36}
        // It's thus treated like a \mathrel, but defined by a symbol that has zero
        // width but extends to the right.  We use \rlap to get that spacing.
        // For MathML we write U+0338 here. buildMathML.js will then do the overlay.
        defineMacro("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}'); // Negated symbols from base/fontmath.ltx:
        // \def\neq{\not=} \let\ne=\neq
        // \DeclareRobustCommand
        //   \notin{\mathrel{\m@th\mathpalette\c@ncel\in}}
        // \def\c@ncel#1#2{\m@th\ooalign{$\hfil#1\mkern1mu/\hfil$\crcr$#1#2$}}
        defineMacro("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`\u2260}}");
        defineMacro("\\ne", "\\neq");
        defineMacro("\u2260", "\\neq");
        defineMacro("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`\u2209}}");
        defineMacro("\u2209", "\\notin"); // Unicode stacked relations
        defineMacro("\u2258", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`\u2258}}");
        defineMacro("\u2259", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`\u2258}}");
        defineMacro("\u225A", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`\u225A}}");
        defineMacro("\u225B", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`\u225B}}");
        defineMacro("\u225D", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`\u225D}}");
        defineMacro("\u225E", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`\u225E}}");
        defineMacro("\u225F", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`\u225F}}"); // Misc Unicode
        defineMacro("\u27C2", "\\perp");
        defineMacro("\u203C", "\\mathclose{!\\mkern-0.8mu!}");
        defineMacro("\u220C", "\\notni");
        defineMacro("\u231C", "\\ulcorner");
        defineMacro("\u231D", "\\urcorner");
        defineMacro("\u231E", "\\llcorner");
        defineMacro("\u231F", "\\lrcorner");
        defineMacro("\u00A9", "\\copyright");
        defineMacro("\u00AE", "\\textregistered");
        defineMacro("\uFE0F", "\\textregistered"); // The KaTeX fonts have corners at codepoints that don't match Unicode.
        // For MathML purposes, use the Unicode code point.
        defineMacro("\\ulcorner", "\\html@mathml{\\@ulcorner}{\\mathop{\\char\"231c}}");
        defineMacro("\\urcorner", "\\html@mathml{\\@urcorner}{\\mathop{\\char\"231d}}");
        defineMacro("\\llcorner", "\\html@mathml{\\@llcorner}{\\mathop{\\char\"231e}}");
        defineMacro("\\lrcorner", "\\html@mathml{\\@lrcorner}{\\mathop{\\char\"231f}}"); //////////////////////////////////////////////////////////////////////
        // LaTeX_2ε
        // \vdots{\vbox{\baselineskip4\p@  \lineskiplimit\z@
        // \kern6\p@\hbox{.}\hbox{.}\hbox{.}}}
        // We'll call \varvdots, which gets a glyph from symbols.js.
        // The zero-width rule gets us an equivalent to the vertical 6pt kern.
        defineMacro("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
        defineMacro("\u22ee", "\\vdots"); //////////////////////////////////////////////////////////////////////
        // amsmath.sty
        // http://mirrors.concertpass.com/tex-archive/macros/latex/required/amsmath/amsmath.pdf
        // Italic Greek capital letters.  AMS defines these with \DeclareMathSymbol,
        // but they are equivalent to \mathit{\Letter}.
        defineMacro("\\varGamma", "\\mathit{\\Gamma}");
        defineMacro("\\varDelta", "\\mathit{\\Delta}");
        defineMacro("\\varTheta", "\\mathit{\\Theta}");
        defineMacro("\\varLambda", "\\mathit{\\Lambda}");
        defineMacro("\\varXi", "\\mathit{\\Xi}");
        defineMacro("\\varPi", "\\mathit{\\Pi}");
        defineMacro("\\varSigma", "\\mathit{\\Sigma}");
        defineMacro("\\varUpsilon", "\\mathit{\\Upsilon}");
        defineMacro("\\varPhi", "\\mathit{\\Phi}");
        defineMacro("\\varPsi", "\\mathit{\\Psi}");
        defineMacro("\\varOmega", "\\mathit{\\Omega}"); //\newcommand{\substack}[1]{\subarray{c}#1\endsubarray}
        defineMacro("\\substack", "\\begin{subarray}{c}#1\\end{subarray}"); // \renewcommand{\colon}{\nobreak\mskip2mu\mathpunct{}\nonscript
        // \mkern-\thinmuskip{:}\mskip6muplus1mu\relax}
        defineMacro("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax"); // \newcommand{\boxed}[1]{\fbox{\m@th$\displaystyle#1$}}
        defineMacro("\\boxed", "\\fbox{$\\displaystyle{#1}$}"); // \def\iff{\DOTSB\;\Longleftrightarrow\;}
        // \def\implies{\DOTSB\;\Longrightarrow\;}
        // \def\impliedby{\DOTSB\;\Longleftarrow\;}
        defineMacro("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
        defineMacro("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
        defineMacro("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;"); // \def\dddot#1{{\mathop{#1}\limits^{\vbox to-1.4\ex@{\kern-\tw@\ex@
        //  \hbox{\normalfont ...}\vss}}}}
        // We use \overset which avoids the vertical shift of \mathop.
        defineMacro("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
        defineMacro("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}"); // AMSMath's automatic \dots, based on \mdots@@ macro.
        const dotsByToken = {
            ',': '\\dotsc',
            '\\not': '\\dotsb',
            // \keybin@ checks for the following:
            '+': '\\dotsb',
            '=': '\\dotsb',
            '<': '\\dotsb',
            '>': '\\dotsb',
            '-': '\\dotsb',
            '*': '\\dotsb',
            ':': '\\dotsb',
            // Symbols whose definition starts with \DOTSB:
            '\\DOTSB': '\\dotsb',
            '\\coprod': '\\dotsb',
            '\\bigvee': '\\dotsb',
            '\\bigwedge': '\\dotsb',
            '\\biguplus': '\\dotsb',
            '\\bigcap': '\\dotsb',
            '\\bigcup': '\\dotsb',
            '\\prod': '\\dotsb',
            '\\sum': '\\dotsb',
            '\\bigotimes': '\\dotsb',
            '\\bigoplus': '\\dotsb',
            '\\bigodot': '\\dotsb',
            '\\bigsqcup': '\\dotsb',
            '\\And': '\\dotsb',
            '\\longrightarrow': '\\dotsb',
            '\\Longrightarrow': '\\dotsb',
            '\\longleftarrow': '\\dotsb',
            '\\Longleftarrow': '\\dotsb',
            '\\longleftrightarrow': '\\dotsb',
            '\\Longleftrightarrow': '\\dotsb',
            '\\mapsto': '\\dotsb',
            '\\longmapsto': '\\dotsb',
            '\\hookrightarrow': '\\dotsb',
            '\\doteq': '\\dotsb',
            // Symbols whose definition starts with \mathbin:
            '\\mathbin': '\\dotsb',
            // Symbols whose definition starts with \mathrel:
            '\\mathrel': '\\dotsb',
            '\\relbar': '\\dotsb',
            '\\Relbar': '\\dotsb',
            '\\xrightarrow': '\\dotsb',
            '\\xleftarrow': '\\dotsb',
            // Symbols whose definition starts with \DOTSI:
            '\\DOTSI': '\\dotsi',
            '\\int': '\\dotsi',
            '\\oint': '\\dotsi',
            '\\iint': '\\dotsi',
            '\\iiint': '\\dotsi',
            '\\iiiint': '\\dotsi',
            '\\idotsint': '\\dotsi',
            // Symbols whose definition starts with \DOTSX:
            '\\DOTSX': '\\dotsx'
        };
        defineMacro("\\dots", function(context) {
            // TODO: If used in text mode, should expand to \textellipsis.
            // However, in KaTeX, \textellipsis and \ldots behave the same
            // (in text mode), and it's unlikely we'd see any of the math commands
            // that affect the behavior of \dots when in text mode.  So fine for now
            // (until we support \ifmmode ... \else ... \fi).
            let thedots = '\\dotso';
            const next = context.expandAfterFuture().text;
            if (next in dotsByToken) thedots = dotsByToken[next];
            else if (next.slice(0, 4) === '\\not') thedots = '\\dotsb';
            else if (next in src_symbols.math) {
                if ([
                    'bin',
                    'rel'
                ].includes(src_symbols.math[next].group)) thedots = '\\dotsb';
            }
            return thedots;
        });
        const spaceAfterDots = {
            // \rightdelim@ checks for the following:
            ')': true,
            ']': true,
            '\\rbrack': true,
            '\\}': true,
            '\\rbrace': true,
            '\\rangle': true,
            '\\rceil': true,
            '\\rfloor': true,
            '\\rgroup': true,
            '\\rmoustache': true,
            '\\right': true,
            '\\bigr': true,
            '\\biggr': true,
            '\\Bigr': true,
            '\\Biggr': true,
            // \extra@ also tests for the following:
            '$': true,
            // \extrap@ checks for the following:
            ';': true,
            '.': true,
            ',': true
        };
        defineMacro("\\dotso", function(context) {
            const next = context.future().text;
            if (next in spaceAfterDots) return "\\ldots\\,";
            else return "\\ldots";
        });
        defineMacro("\\dotsc", function(context) {
            const next = context.future().text; // \dotsc uses \extra@ but not \extrap@, instead specially checking for
            // ';' and '.', but doesn't check for ','.
            if (next in spaceAfterDots && next !== ',') return "\\ldots\\,";
            else return "\\ldots";
        });
        defineMacro("\\cdots", function(context) {
            const next = context.future().text;
            if (next in spaceAfterDots) return "\\@cdots\\,";
            else return "\\@cdots";
        });
        defineMacro("\\dotsb", "\\cdots");
        defineMacro("\\dotsm", "\\cdots");
        defineMacro("\\dotsi", "\\!\\cdots"); // amsmath doesn't actually define \dotsx, but \dots followed by a macro
        // starting with \DOTSX implies \dotso, and then \extra@ detects this case
        // and forces the added `\,`.
        defineMacro("\\dotsx", "\\ldots\\,"); // \let\DOTSI\relax
        // \let\DOTSB\relax
        // \let\DOTSX\relax
        defineMacro("\\DOTSI", "\\relax");
        defineMacro("\\DOTSB", "\\relax");
        defineMacro("\\DOTSX", "\\relax"); // Spacing, based on amsmath.sty's override of LaTeX defaults
        // \DeclareRobustCommand{\tmspace}[3]{%
        //   \ifmmode\mskip#1#2\else\kern#1#3\fi\relax}
        defineMacro("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax"); // \renewcommand{\,}{\tmspace+\thinmuskip{.1667em}}
        // TODO: math mode should use \thinmuskip
        defineMacro("\\,", "\\tmspace+{3mu}{.1667em}"); // \let\thinspace\,
        defineMacro("\\thinspace", "\\,"); // \def\>{\mskip\medmuskip}
        // \renewcommand{\:}{\tmspace+\medmuskip{.2222em}}
        // TODO: \> and math mode of \: should use \medmuskip = 4mu plus 2mu minus 4mu
        defineMacro("\\>", "\\mskip{4mu}");
        defineMacro("\\:", "\\tmspace+{4mu}{.2222em}"); // \let\medspace\:
        defineMacro("\\medspace", "\\:"); // \renewcommand{\;}{\tmspace+\thickmuskip{.2777em}}
        // TODO: math mode should use \thickmuskip = 5mu plus 5mu
        defineMacro("\\;", "\\tmspace+{5mu}{.2777em}"); // \let\thickspace\;
        defineMacro("\\thickspace", "\\;"); // \renewcommand{\!}{\tmspace-\thinmuskip{.1667em}}
        // TODO: math mode should use \thinmuskip
        defineMacro("\\!", "\\tmspace-{3mu}{.1667em}"); // \let\negthinspace\!
        defineMacro("\\negthinspace", "\\!"); // \newcommand{\negmedspace}{\tmspace-\medmuskip{.2222em}}
        // TODO: math mode should use \medmuskip
        defineMacro("\\negmedspace", "\\tmspace-{4mu}{.2222em}"); // \newcommand{\negthickspace}{\tmspace-\thickmuskip{.2777em}}
        // TODO: math mode should use \thickmuskip
        defineMacro("\\negthickspace", "\\tmspace-{5mu}{.277em}"); // \def\enspace{\kern.5em }
        defineMacro("\\enspace", "\\kern.5em "); // \def\enskip{\hskip.5em\relax}
        defineMacro("\\enskip", "\\hskip.5em\\relax"); // \def\quad{\hskip1em\relax}
        defineMacro("\\quad", "\\hskip1em\\relax"); // \def\qquad{\hskip2em\relax}
        defineMacro("\\qquad", "\\hskip2em\\relax"); // \tag@in@display form of \tag
        defineMacro("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
        defineMacro("\\tag@paren", "\\tag@literal{({#1})}");
        defineMacro("\\tag@literal", (context)=>{
            if (context.macros.get("\\df@tag")) throw new src_ParseError("Multiple \\tag");
            return "\\gdef\\df@tag{\\text{#1}}";
        }); // \renewcommand{\bmod}{\nonscript\mskip-\medmuskip\mkern5mu\mathbin
        //   {\operator@font mod}\penalty900
        //   \mkern5mu\nonscript\mskip-\medmuskip}
        // \newcommand{\pod}[1]{\allowbreak
        //   \if@display\mkern18mu\else\mkern8mu\fi(#1)}
        // \renewcommand{\pmod}[1]{\pod{{\operator@font mod}\mkern6mu#1}}
        // \newcommand{\mod}[1]{\allowbreak\if@display\mkern18mu
        //   \else\mkern12mu\fi{\operator@font mod}\,\,#1}
        // TODO: math mode should use \medmuskip = 4mu plus 2mu minus 4mu
        defineMacro("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
        defineMacro("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
        defineMacro("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
        defineMacro("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1"); //////////////////////////////////////////////////////////////////////
        // LaTeX source2e
        // \expandafter\let\expandafter\@normalcr
        //     \csname\expandafter\@gobble\string\\ \endcsname
        // \DeclareRobustCommand\newline{\@normalcr\relax}
        defineMacro("\\newline", "\\\\\\relax"); // \def\TeX{T\kern-.1667em\lower.5ex\hbox{E}\kern-.125emX\@}
        // TODO: Doesn't normally work in math mode because \@ fails.  KaTeX doesn't
        // support \@ yet, so that's omitted, and we add \text so that the result
        // doesn't look funny in math mode.
        defineMacro("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}"); // \DeclareRobustCommand{\LaTeX}{L\kern-.36em%
        //         {\sbox\z@ T%
        //          \vbox to\ht\z@{\hbox{\check@mathfonts
        //                               \fontsize\sf@size\z@
        //                               \math@fontsfalse\selectfont
        //                               A}%
        //                         \vss}%
        //         }%
        //         \kern-.15em%
        //         \TeX}
        // This code aligns the top of the A with the T (from the perspective of TeX's
        // boxes, though visually the A appears to extend above slightly).
        // We compute the corresponding \raisebox when A is rendered in \normalsize
        // \scriptstyle, which has a scale factor of 0.7 (see Options.js).
        const latexRaiseA = makeEm(fontMetricsData['Main-Regular']["T".charCodeAt(0)][1] - 0.7 * fontMetricsData['Main-Regular']["A".charCodeAt(0)][1]);
        defineMacro("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}"); // New KaTeX logo based on tweaking LaTeX logo
        defineMacro("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}"); // \DeclareRobustCommand\hspace{\@ifstar\@hspacer\@hspace}
        // \def\@hspace#1{\hskip  #1\relax}
        // \def\@hspacer#1{\vrule \@width\z@\nobreak
        //                 \hskip #1\hskip \z@skip}
        defineMacro("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
        defineMacro("\\@hspace", "\\hskip #1\\relax");
        defineMacro("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax"); //////////////////////////////////////////////////////////////////////
        // mathtools.sty
        //\providecommand\ordinarycolon{:}
        defineMacro("\\ordinarycolon", ":"); //\def\vcentcolon{\mathrel{\mathop\ordinarycolon}}
        //TODO(edemaine): Not yet centered. Fix via \raisebox or #726
        defineMacro("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}"); // \providecommand*\dblcolon{\vcentcolon\mathrel{\mkern-.9mu}\vcentcolon}
        defineMacro("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}'); // \providecommand*\coloneqq{\vcentcolon\mathrel{\mkern-1.2mu}=}
        defineMacro("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}'); // ≔
        // \providecommand*\Coloneqq{\dblcolon\mathrel{\mkern-1.2mu}=}
        defineMacro("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}'); // \providecommand*\coloneq{\vcentcolon\mathrel{\mkern-1.2mu}\mathrel{-}}
        defineMacro("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}'); // \providecommand*\Coloneq{\dblcolon\mathrel{\mkern-1.2mu}\mathrel{-}}
        defineMacro("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}'); // \providecommand*\eqqcolon{=\mathrel{\mkern-1.2mu}\vcentcolon}
        defineMacro("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}'); // ≕
        // \providecommand*\Eqqcolon{=\mathrel{\mkern-1.2mu}\dblcolon}
        defineMacro("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}'); // \providecommand*\eqcolon{\mathrel{-}\mathrel{\mkern-1.2mu}\vcentcolon}
        defineMacro("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}'); // \providecommand*\Eqcolon{\mathrel{-}\mathrel{\mkern-1.2mu}\dblcolon}
        defineMacro("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}'); // \providecommand*\colonapprox{\vcentcolon\mathrel{\mkern-1.2mu}\approx}
        defineMacro("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}'); // \providecommand*\Colonapprox{\dblcolon\mathrel{\mkern-1.2mu}\approx}
        defineMacro("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}'); // \providecommand*\colonsim{\vcentcolon\mathrel{\mkern-1.2mu}\sim}
        defineMacro("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}'); // \providecommand*\Colonsim{\dblcolon\mathrel{\mkern-1.2mu}\sim}
        defineMacro("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}'); // Some Unicode characters are implemented with macros to mathtools functions.
        defineMacro("\u2237", "\\dblcolon"); // ::
        defineMacro("\u2239", "\\eqcolon"); // -:
        defineMacro("\u2254", "\\coloneqq"); // :=
        defineMacro("\u2255", "\\eqqcolon"); // =:
        defineMacro("\u2A74", "\\Coloneqq"); // ::=
        //////////////////////////////////////////////////////////////////////
        // colonequals.sty
        // Alternate names for mathtools's macros:
        defineMacro("\\ratio", "\\vcentcolon");
        defineMacro("\\coloncolon", "\\dblcolon");
        defineMacro("\\colonequals", "\\coloneqq");
        defineMacro("\\coloncolonequals", "\\Coloneqq");
        defineMacro("\\equalscolon", "\\eqqcolon");
        defineMacro("\\equalscoloncolon", "\\Eqqcolon");
        defineMacro("\\colonminus", "\\coloneq");
        defineMacro("\\coloncolonminus", "\\Coloneq");
        defineMacro("\\minuscolon", "\\eqcolon");
        defineMacro("\\minuscoloncolon", "\\Eqcolon"); // \colonapprox name is same in mathtools and colonequals.
        defineMacro("\\coloncolonapprox", "\\Colonapprox"); // \colonsim name is same in mathtools and colonequals.
        defineMacro("\\coloncolonsim", "\\Colonsim"); // Additional macros, implemented by analogy with mathtools definitions:
        defineMacro("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
        defineMacro("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
        defineMacro("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
        defineMacro("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}"); // Present in newtxmath, pxfonts and txfonts
        defineMacro("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`\u220C}}");
        defineMacro("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
        defineMacro("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}"); //////////////////////////////////////////////////////////////////////
        // From amsopn.sty
        defineMacro("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
        defineMacro("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
        defineMacro("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
        defineMacro("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
        defineMacro("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
        defineMacro("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}"); //////////////////////////////////////////////////////////////////////
        // MathML alternates for KaTeX glyphs in the Unicode private area
        defineMacro("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{\u2269}");
        defineMacro("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{\u2268}");
        defineMacro("\\ngeqq", "\\html@mathml{\\@ngeqq}{\u2271}");
        defineMacro("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{\u2271}");
        defineMacro("\\nleqq", "\\html@mathml{\\@nleqq}{\u2270}");
        defineMacro("\\nleqslant", "\\html@mathml{\\@nleqslant}{\u2270}");
        defineMacro("\\nshortmid", "\\html@mathml{\\@nshortmid}{\u2224}");
        defineMacro("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{\u2226}");
        defineMacro("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{\u2288}");
        defineMacro("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{\u2289}");
        defineMacro("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{\u228A}");
        defineMacro("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{\u2ACB}");
        defineMacro("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{\u228B}");
        defineMacro("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{\u2ACC}");
        defineMacro("\\imath", "\\html@mathml{\\@imath}{\u0131}");
        defineMacro("\\jmath", "\\html@mathml{\\@jmath}{\u0237}"); //////////////////////////////////////////////////////////////////////
        // stmaryrd and semantic
        // The stmaryrd and semantic packages render the next four items by calling a
        // glyph. Those glyphs do not exist in the KaTeX fonts. Hence the macros.
        defineMacro("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`\u27E6}}");
        defineMacro("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`\u27E7}}");
        defineMacro("\u27e6", "\\llbracket"); // blackboard bold [
        defineMacro("\u27e7", "\\rrbracket"); // blackboard bold ]
        defineMacro("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`\u2983}}");
        defineMacro("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`\u2984}}");
        defineMacro("\u2983", "\\lBrace"); // blackboard bold {
        defineMacro("\u2984", "\\rBrace"); // blackboard bold }
        // TODO: Create variable sized versions of the last two items. I believe that
        // will require new font glyphs.
        // The stmaryrd function `\minuso` provides a "Plimsoll" symbol that
        // superimposes the characters \circ and \mathminus. Used in chemistry.
        defineMacro("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`\u29B5}}");
        defineMacro("\u29B5", "\\minuso"); //////////////////////////////////////////////////////////////////////
        // texvc.sty
        // The texvc package contains macros available in mediawiki pages.
        // We omit the functions deprecated at
        // https://en.wikipedia.org/wiki/Help:Displaying_a_formula#Deprecated_syntax
        // We also omit texvc's \O, which conflicts with \text{\O}
        defineMacro("\\darr", "\\downarrow");
        defineMacro("\\dArr", "\\Downarrow");
        defineMacro("\\Darr", "\\Downarrow");
        defineMacro("\\lang", "\\langle");
        defineMacro("\\rang", "\\rangle");
        defineMacro("\\uarr", "\\uparrow");
        defineMacro("\\uArr", "\\Uparrow");
        defineMacro("\\Uarr", "\\Uparrow");
        defineMacro("\\N", "\\mathbb{N}");
        defineMacro("\\R", "\\mathbb{R}");
        defineMacro("\\Z", "\\mathbb{Z}");
        defineMacro("\\alef", "\\aleph");
        defineMacro("\\alefsym", "\\aleph");
        defineMacro("\\Alpha", "\\mathrm{A}");
        defineMacro("\\Beta", "\\mathrm{B}");
        defineMacro("\\bull", "\\bullet");
        defineMacro("\\Chi", "\\mathrm{X}");
        defineMacro("\\clubs", "\\clubsuit");
        defineMacro("\\cnums", "\\mathbb{C}");
        defineMacro("\\Complex", "\\mathbb{C}");
        defineMacro("\\Dagger", "\\ddagger");
        defineMacro("\\diamonds", "\\diamondsuit");
        defineMacro("\\empty", "\\emptyset");
        defineMacro("\\Epsilon", "\\mathrm{E}");
        defineMacro("\\Eta", "\\mathrm{H}");
        defineMacro("\\exist", "\\exists");
        defineMacro("\\harr", "\\leftrightarrow");
        defineMacro("\\hArr", "\\Leftrightarrow");
        defineMacro("\\Harr", "\\Leftrightarrow");
        defineMacro("\\hearts", "\\heartsuit");
        defineMacro("\\image", "\\Im");
        defineMacro("\\infin", "\\infty");
        defineMacro("\\Iota", "\\mathrm{I}");
        defineMacro("\\isin", "\\in");
        defineMacro("\\Kappa", "\\mathrm{K}");
        defineMacro("\\larr", "\\leftarrow");
        defineMacro("\\lArr", "\\Leftarrow");
        defineMacro("\\Larr", "\\Leftarrow");
        defineMacro("\\lrarr", "\\leftrightarrow");
        defineMacro("\\lrArr", "\\Leftrightarrow");
        defineMacro("\\Lrarr", "\\Leftrightarrow");
        defineMacro("\\Mu", "\\mathrm{M}");
        defineMacro("\\natnums", "\\mathbb{N}");
        defineMacro("\\Nu", "\\mathrm{N}");
        defineMacro("\\Omicron", "\\mathrm{O}");
        defineMacro("\\plusmn", "\\pm");
        defineMacro("\\rarr", "\\rightarrow");
        defineMacro("\\rArr", "\\Rightarrow");
        defineMacro("\\Rarr", "\\Rightarrow");
        defineMacro("\\real", "\\Re");
        defineMacro("\\reals", "\\mathbb{R}");
        defineMacro("\\Reals", "\\mathbb{R}");
        defineMacro("\\Rho", "\\mathrm{P}");
        defineMacro("\\sdot", "\\cdot");
        defineMacro("\\sect", "\\S");
        defineMacro("\\spades", "\\spadesuit");
        defineMacro("\\sub", "\\subset");
        defineMacro("\\sube", "\\subseteq");
        defineMacro("\\supe", "\\supseteq");
        defineMacro("\\Tau", "\\mathrm{T}");
        defineMacro("\\thetasym", "\\vartheta"); // TODO: defineMacro("\\varcoppa", "\\\mbox{\\coppa}");
        defineMacro("\\weierp", "\\wp");
        defineMacro("\\Zeta", "\\mathrm{Z}"); //////////////////////////////////////////////////////////////////////
        // statmath.sty
        // https://ctan.math.illinois.edu/macros/latex/contrib/statmath/statmath.pdf
        defineMacro("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
        defineMacro("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
        defineMacro("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits"); //////////////////////////////////////////////////////////////////////
        // braket.sty
        // http://ctan.math.washington.edu/tex-archive/macros/latex/contrib/braket/braket.pdf
        defineMacro("\\bra", "\\mathinner{\\langle{#1}|}");
        defineMacro("\\ket", "\\mathinner{|{#1}\\rangle}");
        defineMacro("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
        defineMacro("\\Bra", "\\left\\langle#1\\right|");
        defineMacro("\\Ket", "\\left|#1\\right\\rangle");
        const braketHelper = (one)=>(context)=>{
                const left = context.consumeArg().tokens;
                const middle = context.consumeArg().tokens;
                const middleDouble = context.consumeArg().tokens;
                const right = context.consumeArg().tokens;
                const oldMiddle = context.macros.get("|");
                const oldMiddleDouble = context.macros.get("\\|");
                context.macros.beginGroup();
                const midMacro = (double)=>(context)=>{
                        if (one) {
                            // Only modify the first instance of | or \|
                            context.macros.set("|", oldMiddle);
                            if (middleDouble.length) context.macros.set("\\|", oldMiddleDouble);
                        }
                        let doubled = double;
                        if (!double && middleDouble.length) {
                            // Mimic \@ifnextchar
                            const nextToken = context.future();
                            if (nextToken.text === "|") {
                                context.popToken();
                                doubled = true;
                            }
                        }
                        return {
                            tokens: doubled ? middleDouble : middle,
                            numArgs: 0
                        };
                    };
                context.macros.set("|", midMacro(false));
                if (middleDouble.length) context.macros.set("\\|", midMacro(true));
                const arg = context.consumeArg().tokens;
                const expanded = context.expandTokens([
                    ...right,
                    ...arg,
                    ...left // reversed
                ]);
                context.macros.endGroup();
                return {
                    tokens: expanded.reverse(),
                    numArgs: 0
                };
            };
        defineMacro("\\bra@ket", braketHelper(false));
        defineMacro("\\bra@set", braketHelper(true));
        defineMacro("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
        defineMacro("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
        defineMacro("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}"); // has no support for special || or \|
        //////////////////////////////////////////////////////////////////////
        // actuarialangle.dtx
        defineMacro("\\angln", "{\\angl n}"); // Custom Khan Academy colors, should be moved to an optional package
        defineMacro("\\blue", "\\textcolor{##6495ed}{#1}");
        defineMacro("\\orange", "\\textcolor{##ffa500}{#1}");
        defineMacro("\\pink", "\\textcolor{##ff00af}{#1}");
        defineMacro("\\red", "\\textcolor{##df0030}{#1}");
        defineMacro("\\green", "\\textcolor{##28ae7b}{#1}");
        defineMacro("\\gray", "\\textcolor{gray}{#1}");
        defineMacro("\\purple", "\\textcolor{##9d38bd}{#1}");
        defineMacro("\\blueA", "\\textcolor{##ccfaff}{#1}");
        defineMacro("\\blueB", "\\textcolor{##80f6ff}{#1}");
        defineMacro("\\blueC", "\\textcolor{##63d9ea}{#1}");
        defineMacro("\\blueD", "\\textcolor{##11accd}{#1}");
        defineMacro("\\blueE", "\\textcolor{##0c7f99}{#1}");
        defineMacro("\\tealA", "\\textcolor{##94fff5}{#1}");
        defineMacro("\\tealB", "\\textcolor{##26edd5}{#1}");
        defineMacro("\\tealC", "\\textcolor{##01d1c1}{#1}");
        defineMacro("\\tealD", "\\textcolor{##01a995}{#1}");
        defineMacro("\\tealE", "\\textcolor{##208170}{#1}");
        defineMacro("\\greenA", "\\textcolor{##b6ffb0}{#1}");
        defineMacro("\\greenB", "\\textcolor{##8af281}{#1}");
        defineMacro("\\greenC", "\\textcolor{##74cf70}{#1}");
        defineMacro("\\greenD", "\\textcolor{##1fab54}{#1}");
        defineMacro("\\greenE", "\\textcolor{##0d923f}{#1}");
        defineMacro("\\goldA", "\\textcolor{##ffd0a9}{#1}");
        defineMacro("\\goldB", "\\textcolor{##ffbb71}{#1}");
        defineMacro("\\goldC", "\\textcolor{##ff9c39}{#1}");
        defineMacro("\\goldD", "\\textcolor{##e07d10}{#1}");
        defineMacro("\\goldE", "\\textcolor{##a75a05}{#1}");
        defineMacro("\\redA", "\\textcolor{##fca9a9}{#1}");
        defineMacro("\\redB", "\\textcolor{##ff8482}{#1}");
        defineMacro("\\redC", "\\textcolor{##f9685d}{#1}");
        defineMacro("\\redD", "\\textcolor{##e84d39}{#1}");
        defineMacro("\\redE", "\\textcolor{##bc2612}{#1}");
        defineMacro("\\maroonA", "\\textcolor{##ffbde0}{#1}");
        defineMacro("\\maroonB", "\\textcolor{##ff92c6}{#1}");
        defineMacro("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
        defineMacro("\\maroonD", "\\textcolor{##ca337c}{#1}");
        defineMacro("\\maroonE", "\\textcolor{##9e034e}{#1}");
        defineMacro("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
        defineMacro("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
        defineMacro("\\purpleC", "\\textcolor{##aa87ff}{#1}");
        defineMacro("\\purpleD", "\\textcolor{##7854ab}{#1}");
        defineMacro("\\purpleE", "\\textcolor{##543b78}{#1}");
        defineMacro("\\mintA", "\\textcolor{##f5f9e8}{#1}");
        defineMacro("\\mintB", "\\textcolor{##edf2df}{#1}");
        defineMacro("\\mintC", "\\textcolor{##e0e5cc}{#1}");
        defineMacro("\\grayA", "\\textcolor{##f6f7f7}{#1}");
        defineMacro("\\grayB", "\\textcolor{##f0f1f2}{#1}");
        defineMacro("\\grayC", "\\textcolor{##e3e5e6}{#1}");
        defineMacro("\\grayD", "\\textcolor{##d6d8da}{#1}");
        defineMacro("\\grayE", "\\textcolor{##babec2}{#1}");
        defineMacro("\\grayF", "\\textcolor{##888d93}{#1}");
        defineMacro("\\grayG", "\\textcolor{##626569}{#1}");
        defineMacro("\\grayH", "\\textcolor{##3b3e40}{#1}");
        defineMacro("\\grayI", "\\textcolor{##21242c}{#1}");
        defineMacro("\\kaBlue", "\\textcolor{##314453}{#1}");
        defineMacro("\\kaGreen", "\\textcolor{##71B307}{#1}");
        /**
 * This file contains the “gullet” where macros are expanded
 * until only non-macro tokens remain.
 */ // List of commands that act like macros but aren't defined as a macro,
        // function, or symbol.  Used in `isDefined`.
        const implicitCommands = {
            "^": true,
            // Parser.js
            "_": true,
            // Parser.js
            "\\limits": true,
            // Parser.js
            "\\nolimits": true // Parser.js
        };
        class MacroExpander {
            constructor(input, settings, mode){
                this.settings = void 0;
                this.expansionCount = void 0;
                this.lexer = void 0;
                this.macros = void 0;
                this.stack = void 0;
                this.mode = void 0;
                this.settings = settings;
                this.expansionCount = 0;
                this.feed(input); // Make new global namespace
                this.macros = new Namespace(src_macros, settings.macros);
                this.mode = mode;
                this.stack = []; // contains tokens in REVERSE order
            }
            /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */ feed(input) {
                this.lexer = new Lexer(input, this.settings);
            }
            /**
   * Switches between "text" and "math" modes.
   */ switchMode(newMode) {
                this.mode = newMode;
            }
            /**
   * Start a new group nesting within all namespaces.
   */ beginGroup() {
                this.macros.beginGroup();
            }
            /**
   * End current group nesting within all namespaces.
   */ endGroup() {
                this.macros.endGroup();
            }
            /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */ endGroups() {
                this.macros.endGroups();
            }
            /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */ future() {
                if (this.stack.length === 0) this.pushToken(this.lexer.lex());
                return this.stack[this.stack.length - 1];
            }
            /**
   * Remove and return the next unexpanded token.
   */ popToken() {
                this.future(); // ensure non-empty stack
                return this.stack.pop();
            }
            /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */ pushToken(token) {
                this.stack.push(token);
            }
            /**
   * Append an array of tokens to the token stack.
   */ pushTokens(tokens) {
                this.stack.push(...tokens);
            }
            /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */ scanArgument(isOptional) {
                let start;
                let end;
                let tokens;
                if (isOptional) {
                    this.consumeSpaces(); // \@ifnextchar gobbles any space following it
                    if (this.future().text !== "[") return null;
                    start = this.popToken(); // don't include [ in tokens
                    ({ tokens: tokens, end: end } = this.consumeArg([
                        "]"
                    ]));
                } else ({ tokens: tokens, start: start, end: end } = this.consumeArg());
                 // indicate the end of an argument
                this.pushToken(new Token("EOF", end.loc));
                this.pushTokens(tokens);
                return new Token("", SourceLocation.range(start, end));
            }
            /**
   * Consume all following space tokens, without expansion.
   */ consumeSpaces() {
                for(;;){
                    const token = this.future();
                    if (token.text === " ") this.stack.pop();
                    else break;
                }
            }
            /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */ consumeArg(delims) {
                // The argument for a delimited parameter is the shortest (possibly
                // empty) sequence of tokens with properly nested {...} groups that is
                // followed ... by this particular list of non-parameter tokens.
                // The argument for an undelimited parameter is the next nonblank
                // token, unless that token is ‘{’, when the argument will be the
                // entire {...} group that follows.
                const tokens = [];
                const isDelimited = delims && delims.length > 0;
                if (!isDelimited) // Ignore spaces between arguments.  As the TeXbook says:
                // "After you have said ‘\def\row#1#2{...}’, you are allowed to
                //  put spaces between the arguments (e.g., ‘\row x n’), because
                //  TeX doesn’t use single spaces as undelimited arguments."
                this.consumeSpaces();
                const start = this.future();
                let tok;
                let depth = 0;
                let match = 0;
                do {
                    tok = this.popToken();
                    tokens.push(tok);
                    if (tok.text === "{") ++depth;
                    else if (tok.text === "}") {
                        --depth;
                        if (depth === -1) throw new src_ParseError("Extra }", tok);
                    } else if (tok.text === "EOF") throw new src_ParseError("Unexpected end of input in a macro argument, expected '" + (delims && isDelimited ? delims[match] : "}") + "'", tok);
                    if (delims && isDelimited) {
                        if ((depth === 0 || depth === 1 && delims[match] === "{") && tok.text === delims[match]) {
                            ++match;
                            if (match === delims.length) {
                                // don't include delims in tokens
                                tokens.splice(-match, match);
                                break;
                            }
                        } else match = 0;
                    }
                }while (depth !== 0 || isDelimited); // If the argument found ... has the form ‘{<nested tokens>}’,
                // ... the outermost braces enclosing the argument are removed
                if (start.text === "{" && tokens[tokens.length - 1].text === "}") {
                    tokens.pop();
                    tokens.shift();
                }
                tokens.reverse(); // to fit in with stack order
                return {
                    tokens: tokens,
                    start: start,
                    end: tok
                };
            }
            /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */ consumeArgs(numArgs, delimiters) {
                if (delimiters) {
                    if (delimiters.length !== numArgs + 1) throw new src_ParseError("The length of delimiters doesn't match the number of args!");
                    const delims = delimiters[0];
                    for(let i = 0; i < delims.length; i++){
                        const tok = this.popToken();
                        if (delims[i] !== tok.text) throw new src_ParseError("Use of the macro doesn't match its definition", tok);
                    }
                }
                const args = [];
                for(let i = 0; i < numArgs; i++)args.push(this.consumeArg(delimiters && delimiters[i + 1]).tokens);
                return args;
            }
            /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */ countExpansion(amount) {
                this.expansionCount += amount;
                if (this.expansionCount > this.settings.maxExpand) throw new src_ParseError("Too many expansions: infinite loop or need to increase maxExpand setting");
            }
            /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */ expandOnce(expandableOnly) {
                const topToken = this.popToken();
                const name = topToken.text;
                const expansion = !topToken.noexpand ? this._getExpansion(name) : null;
                if (expansion == null || expandableOnly && expansion.unexpandable) {
                    if (expandableOnly && expansion == null && name[0] === "\\" && !this.isDefined(name)) throw new src_ParseError("Undefined control sequence: " + name);
                    this.pushToken(topToken);
                    return false;
                }
                this.countExpansion(1);
                let tokens = expansion.tokens;
                const args = this.consumeArgs(expansion.numArgs, expansion.delimiters);
                if (expansion.numArgs) {
                    // paste arguments in place of the placeholders
                    tokens = tokens.slice(); // make a shallow copy
                    for(let i = tokens.length - 1; i >= 0; --i){
                        let tok = tokens[i];
                        if (tok.text === "#") {
                            if (i === 0) throw new src_ParseError("Incomplete placeholder at end of macro body", tok);
                            tok = tokens[--i]; // next token on stack
                            if (tok.text === "#") // ## → #
                            tokens.splice(i + 1, 1); // drop first #
                            else if (/^[1-9]$/.test(tok.text)) // replace the placeholder with the indicated argument
                            tokens.splice(i, 2, ...args[+tok.text - 1]);
                            else throw new src_ParseError("Not a valid argument number", tok);
                        }
                    }
                } // Concatenate expansion onto top of stack.
                this.pushTokens(tokens);
                return tokens.length;
            }
            /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */ expandAfterFuture() {
                this.expandOnce();
                return this.future();
            }
            /**
   * Recursively expand first token, then return first non-expandable token.
   */ expandNextToken() {
                for(;;)if (this.expandOnce() === false) {
                    // fully expanded
                    const token = this.stack.pop(); // the token after \noexpand is interpreted as if its meaning
                    // were ‘\relax’
                    if (token.treatAsRelax) token.text = "\\relax";
                    return token;
                }
                 // Flow unable to figure out that this pathway is impossible.
                // https://github.com/facebook/flow/issues/4808
                throw new Error(); // eslint-disable-line no-unreachable
            }
            /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */ expandMacro(name) {
                return this.macros.has(name) ? this.expandTokens([
                    new Token(name)
                ]) : undefined;
            }
            /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */ expandTokens(tokens) {
                const output = [];
                const oldStackLength = this.stack.length;
                this.pushTokens(tokens);
                while(this.stack.length > oldStackLength)// Expand only expandable tokens
                if (this.expandOnce(true) === false) {
                    // fully expanded
                    const token = this.stack.pop();
                    if (token.treatAsRelax) {
                        // the expansion of \noexpand is the token itself
                        token.noexpand = false;
                        token.treatAsRelax = false;
                    }
                    output.push(token);
                }
                 // Count all of these tokens as additional expansions, to prevent
                // exponential blowup from linearly many \edef's.
                this.countExpansion(output.length);
                return output;
            }
            /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */ expandMacroAsText(name) {
                const tokens = this.expandMacro(name);
                if (tokens) return tokens.map((token)=>token.text).join("");
                else return tokens;
            }
            /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */ _getExpansion(name) {
                const definition = this.macros.get(name);
                if (definition == null) // mainly checking for undefined here
                return definition;
                 // If a single character has an associated catcode other than 13
                // (active character), then don't expand it.
                if (name.length === 1) {
                    const catcode = this.lexer.catcodes[name];
                    if (catcode != null && catcode !== 13) return;
                }
                const expansion = typeof definition === "function" ? definition(this) : definition;
                if (typeof expansion === "string") {
                    let numArgs = 0;
                    if (expansion.indexOf("#") !== -1) {
                        const stripped = expansion.replace(/##/g, "");
                        while(stripped.indexOf("#" + (numArgs + 1)) !== -1)++numArgs;
                    }
                    const bodyLexer = new Lexer(expansion, this.settings);
                    const tokens = [];
                    let tok = bodyLexer.lex();
                    while(tok.text !== "EOF"){
                        tokens.push(tok);
                        tok = bodyLexer.lex();
                    }
                    tokens.reverse(); // to fit in with stack using push and pop
                    const expanded = {
                        tokens: tokens,
                        numArgs: numArgs
                    };
                    return expanded;
                }
                return expansion;
            }
            /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */ isDefined(name) {
                return this.macros.has(name) || src_functions.hasOwnProperty(name) || src_symbols.math.hasOwnProperty(name) || src_symbols.text.hasOwnProperty(name) || implicitCommands.hasOwnProperty(name);
            }
            /**
   * Determine whether a command is expandable.
   */ isExpandable(name) {
                const macro = this.macros.get(name);
                return macro != null ? typeof macro === "string" || typeof macro === "function" || !macro.unexpandable : src_functions.hasOwnProperty(name) && !src_functions[name].primitive;
            }
        }
        // Helpers for Parser.js handling of Unicode (sub|super)script characters.
        const unicodeSubRegEx = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/;
        const uSubsAndSups = Object.freeze({
            "\u208A": '+',
            "\u208B": '-',
            "\u208C": '=',
            "\u208D": '(',
            "\u208E": ')',
            "\u2080": '0',
            "\u2081": '1',
            "\u2082": '2',
            "\u2083": '3',
            "\u2084": '4',
            "\u2085": '5',
            "\u2086": '6',
            "\u2087": '7',
            "\u2088": '8',
            "\u2089": '9',
            '\u2090': 'a',
            '\u2091': 'e',
            '\u2095': 'h',
            '\u1D62': 'i',
            '\u2C7C': 'j',
            '\u2096': 'k',
            '\u2097': 'l',
            '\u2098': 'm',
            '\u2099': 'n',
            '\u2092': 'o',
            '\u209A': 'p',
            '\u1D63': 'r',
            '\u209B': 's',
            '\u209C': 't',
            '\u1D64': 'u',
            '\u1D65': 'v',
            '\u2093': 'x',
            '\u1D66': "\u03B2",
            '\u1D67': "\u03B3",
            '\u1D68': "\u03C1",
            '\u1D69': '\u03d5',
            '\u1D6A': "\u03C7",
            "\u207A": '+',
            "\u207B": '-',
            "\u207C": '=',
            "\u207D": '(',
            "\u207E": ')',
            "\u2070": '0',
            "\xb9": '1',
            "\xb2": '2',
            "\xb3": '3',
            "\u2074": '4',
            "\u2075": '5',
            "\u2076": '6',
            "\u2077": '7',
            "\u2078": '8',
            "\u2079": '9',
            '\u1D2C': 'A',
            '\u1D2E': 'B',
            '\u1D30': 'D',
            '\u1D31': 'E',
            '\u1D33': 'G',
            '\u1D34': 'H',
            '\u1D35': 'I',
            '\u1D36': 'J',
            '\u1D37': 'K',
            '\u1D38': 'L',
            '\u1D39': 'M',
            '\u1D3A': 'N',
            '\u1D3C': 'O',
            '\u1D3E': 'P',
            '\u1D3F': 'R',
            '\u1D40': 'T',
            '\u1D41': 'U',
            '\u2C7D': 'V',
            '\u1D42': 'W',
            '\u1D43': 'a',
            '\u1D47': 'b',
            '\u1D9C': 'c',
            '\u1D48': 'd',
            '\u1D49': 'e',
            '\u1DA0': 'f',
            '\u1D4D': 'g',
            '\u02B0': 'h',
            '\u2071': 'i',
            '\u02B2': 'j',
            '\u1D4F': 'k',
            '\u02E1': 'l',
            '\u1D50': 'm',
            '\u207F': 'n',
            '\u1D52': 'o',
            '\u1D56': 'p',
            '\u02B3': 'r',
            '\u02E2': 's',
            '\u1D57': 't',
            '\u1D58': 'u',
            '\u1D5B': 'v',
            '\u02B7': 'w',
            '\u02E3': 'x',
            '\u02B8': 'y',
            '\u1DBB': 'z',
            '\u1D5D': "\u03B2",
            '\u1D5E': "\u03B3",
            '\u1D5F': "\u03B4",
            '\u1D60': '\u03d5',
            '\u1D61': "\u03C7",
            '\u1DBF': "\u03B8"
        });
        /* eslint no-constant-condition:0 */ // Pre-evaluate both modules as unicodeSymbols require String.normalize()
        const unicodeAccents = {
            "\u0301": {
                "text": "\\'",
                "math": "\\acute"
            },
            "\u0300": {
                "text": "\\`",
                "math": "\\grave"
            },
            "\u0308": {
                "text": "\\\"",
                "math": "\\ddot"
            },
            "\u0303": {
                "text": "\\~",
                "math": "\\tilde"
            },
            "\u0304": {
                "text": "\\=",
                "math": "\\bar"
            },
            "\u0306": {
                "text": "\\u",
                "math": "\\breve"
            },
            "\u030C": {
                "text": "\\v",
                "math": "\\check"
            },
            "\u0302": {
                "text": "\\^",
                "math": "\\hat"
            },
            "\u0307": {
                "text": "\\.",
                "math": "\\dot"
            },
            "\u030A": {
                "text": "\\r",
                "math": "\\mathring"
            },
            "\u030B": {
                "text": "\\H"
            },
            "\u0327": {
                "text": "\\c"
            }
        };
        const unicodeSymbols = {
            "\xe1": "a\u0301",
            "\xe0": "a\u0300",
            "\xe4": "a\u0308",
            "\u01DF": "a\u0308\u0304",
            "\xe3": "a\u0303",
            "\u0101": "a\u0304",
            "\u0103": "a\u0306",
            "\u1EAF": "a\u0306\u0301",
            "\u1EB1": "a\u0306\u0300",
            "\u1EB5": "a\u0306\u0303",
            "\u01CE": "a\u030C",
            "\xe2": "a\u0302",
            "\u1EA5": "a\u0302\u0301",
            "\u1EA7": "a\u0302\u0300",
            "\u1EAB": "a\u0302\u0303",
            "\u0227": "a\u0307",
            "\u01E1": "a\u0307\u0304",
            "\xe5": "a\u030A",
            "\u01FB": "a\u030A\u0301",
            "\u1E03": "b\u0307",
            "\u0107": "c\u0301",
            "\u1E09": "c\u0327\u0301",
            "\u010D": "c\u030C",
            "\u0109": "c\u0302",
            "\u010B": "c\u0307",
            "\xe7": "c\u0327",
            "\u010F": "d\u030C",
            "\u1E0B": "d\u0307",
            "\u1E11": "d\u0327",
            "\xe9": "e\u0301",
            "\xe8": "e\u0300",
            "\xeb": "e\u0308",
            "\u1EBD": "e\u0303",
            "\u0113": "e\u0304",
            "\u1E17": "e\u0304\u0301",
            "\u1E15": "e\u0304\u0300",
            "\u0115": "e\u0306",
            "\u1E1D": "e\u0327\u0306",
            "\u011B": "e\u030C",
            "\xea": "e\u0302",
            "\u1EBF": "e\u0302\u0301",
            "\u1EC1": "e\u0302\u0300",
            "\u1EC5": "e\u0302\u0303",
            "\u0117": "e\u0307",
            "\u0229": "e\u0327",
            "\u1E1F": "f\u0307",
            "\u01F5": "g\u0301",
            "\u1E21": "g\u0304",
            "\u011F": "g\u0306",
            "\u01E7": "g\u030C",
            "\u011D": "g\u0302",
            "\u0121": "g\u0307",
            "\u0123": "g\u0327",
            "\u1E27": "h\u0308",
            "\u021F": "h\u030C",
            "\u0125": "h\u0302",
            "\u1E23": "h\u0307",
            "\u1E29": "h\u0327",
            "\xed": "i\u0301",
            "\xec": "i\u0300",
            "\xef": "i\u0308",
            "\u1E2F": "i\u0308\u0301",
            "\u0129": "i\u0303",
            "\u012B": "i\u0304",
            "\u012D": "i\u0306",
            "\u01D0": "i\u030C",
            "\xee": "i\u0302",
            "\u01F0": "j\u030C",
            "\u0135": "j\u0302",
            "\u1E31": "k\u0301",
            "\u01E9": "k\u030C",
            "\u0137": "k\u0327",
            "\u013A": "l\u0301",
            "\u013E": "l\u030C",
            "\u013C": "l\u0327",
            "\u1E3F": "m\u0301",
            "\u1E41": "m\u0307",
            "\u0144": "n\u0301",
            "\u01F9": "n\u0300",
            "\xf1": "n\u0303",
            "\u0148": "n\u030C",
            "\u1E45": "n\u0307",
            "\u0146": "n\u0327",
            "\xf3": "o\u0301",
            "\xf2": "o\u0300",
            "\xf6": "o\u0308",
            "\u022B": "o\u0308\u0304",
            "\xf5": "o\u0303",
            "\u1E4D": "o\u0303\u0301",
            "\u1E4F": "o\u0303\u0308",
            "\u022D": "o\u0303\u0304",
            "\u014D": "o\u0304",
            "\u1E53": "o\u0304\u0301",
            "\u1E51": "o\u0304\u0300",
            "\u014F": "o\u0306",
            "\u01D2": "o\u030C",
            "\xf4": "o\u0302",
            "\u1ED1": "o\u0302\u0301",
            "\u1ED3": "o\u0302\u0300",
            "\u1ED7": "o\u0302\u0303",
            "\u022F": "o\u0307",
            "\u0231": "o\u0307\u0304",
            "\u0151": "o\u030B",
            "\u1E55": "p\u0301",
            "\u1E57": "p\u0307",
            "\u0155": "r\u0301",
            "\u0159": "r\u030C",
            "\u1E59": "r\u0307",
            "\u0157": "r\u0327",
            "\u015B": "s\u0301",
            "\u1E65": "s\u0301\u0307",
            "\u0161": "s\u030C",
            "\u1E67": "s\u030C\u0307",
            "\u015D": "s\u0302",
            "\u1E61": "s\u0307",
            "\u015F": "s\u0327",
            "\u1E97": "t\u0308",
            "\u0165": "t\u030C",
            "\u1E6B": "t\u0307",
            "\u0163": "t\u0327",
            "\xfa": "u\u0301",
            "\xf9": "u\u0300",
            "\xfc": "u\u0308",
            "\u01D8": "u\u0308\u0301",
            "\u01DC": "u\u0308\u0300",
            "\u01D6": "u\u0308\u0304",
            "\u01DA": "u\u0308\u030C",
            "\u0169": "u\u0303",
            "\u1E79": "u\u0303\u0301",
            "\u016B": "u\u0304",
            "\u1E7B": "u\u0304\u0308",
            "\u016D": "u\u0306",
            "\u01D4": "u\u030C",
            "\xfb": "u\u0302",
            "\u016F": "u\u030A",
            "\u0171": "u\u030B",
            "\u1E7D": "v\u0303",
            "\u1E83": "w\u0301",
            "\u1E81": "w\u0300",
            "\u1E85": "w\u0308",
            "\u0175": "w\u0302",
            "\u1E87": "w\u0307",
            "\u1E98": "w\u030A",
            "\u1E8D": "x\u0308",
            "\u1E8B": "x\u0307",
            "\xfd": "y\u0301",
            "\u1EF3": "y\u0300",
            "\xff": "y\u0308",
            "\u1EF9": "y\u0303",
            "\u0233": "y\u0304",
            "\u0177": "y\u0302",
            "\u1E8F": "y\u0307",
            "\u1E99": "y\u030A",
            "\u017A": "z\u0301",
            "\u017E": "z\u030C",
            "\u1E91": "z\u0302",
            "\u017C": "z\u0307",
            "\xc1": "A\u0301",
            "\xc0": "A\u0300",
            "\xc4": "A\u0308",
            "\u01DE": "A\u0308\u0304",
            "\xc3": "A\u0303",
            "\u0100": "A\u0304",
            "\u0102": "A\u0306",
            "\u1EAE": "A\u0306\u0301",
            "\u1EB0": "A\u0306\u0300",
            "\u1EB4": "A\u0306\u0303",
            "\u01CD": "A\u030C",
            "\xc2": "A\u0302",
            "\u1EA4": "A\u0302\u0301",
            "\u1EA6": "A\u0302\u0300",
            "\u1EAA": "A\u0302\u0303",
            "\u0226": "A\u0307",
            "\u01E0": "A\u0307\u0304",
            "\xc5": "A\u030A",
            "\u01FA": "A\u030A\u0301",
            "\u1E02": "B\u0307",
            "\u0106": "C\u0301",
            "\u1E08": "C\u0327\u0301",
            "\u010C": "C\u030C",
            "\u0108": "C\u0302",
            "\u010A": "C\u0307",
            "\xc7": "C\u0327",
            "\u010E": "D\u030C",
            "\u1E0A": "D\u0307",
            "\u1E10": "D\u0327",
            "\xc9": "E\u0301",
            "\xc8": "E\u0300",
            "\xcb": "E\u0308",
            "\u1EBC": "E\u0303",
            "\u0112": "E\u0304",
            "\u1E16": "E\u0304\u0301",
            "\u1E14": "E\u0304\u0300",
            "\u0114": "E\u0306",
            "\u1E1C": "E\u0327\u0306",
            "\u011A": "E\u030C",
            "\xca": "E\u0302",
            "\u1EBE": "E\u0302\u0301",
            "\u1EC0": "E\u0302\u0300",
            "\u1EC4": "E\u0302\u0303",
            "\u0116": "E\u0307",
            "\u0228": "E\u0327",
            "\u1E1E": "F\u0307",
            "\u01F4": "G\u0301",
            "\u1E20": "G\u0304",
            "\u011E": "G\u0306",
            "\u01E6": "G\u030C",
            "\u011C": "G\u0302",
            "\u0120": "G\u0307",
            "\u0122": "G\u0327",
            "\u1E26": "H\u0308",
            "\u021E": "H\u030C",
            "\u0124": "H\u0302",
            "\u1E22": "H\u0307",
            "\u1E28": "H\u0327",
            "\xcd": "I\u0301",
            "\xcc": "I\u0300",
            "\xcf": "I\u0308",
            "\u1E2E": "I\u0308\u0301",
            "\u0128": "I\u0303",
            "\u012A": "I\u0304",
            "\u012C": "I\u0306",
            "\u01CF": "I\u030C",
            "\xce": "I\u0302",
            "\u0130": "I\u0307",
            "\u0134": "J\u0302",
            "\u1E30": "K\u0301",
            "\u01E8": "K\u030C",
            "\u0136": "K\u0327",
            "\u0139": "L\u0301",
            "\u013D": "L\u030C",
            "\u013B": "L\u0327",
            "\u1E3E": "M\u0301",
            "\u1E40": "M\u0307",
            "\u0143": "N\u0301",
            "\u01F8": "N\u0300",
            "\xd1": "N\u0303",
            "\u0147": "N\u030C",
            "\u1E44": "N\u0307",
            "\u0145": "N\u0327",
            "\xd3": "O\u0301",
            "\xd2": "O\u0300",
            "\xd6": "O\u0308",
            "\u022A": "O\u0308\u0304",
            "\xd5": "O\u0303",
            "\u1E4C": "O\u0303\u0301",
            "\u1E4E": "O\u0303\u0308",
            "\u022C": "O\u0303\u0304",
            "\u014C": "O\u0304",
            "\u1E52": "O\u0304\u0301",
            "\u1E50": "O\u0304\u0300",
            "\u014E": "O\u0306",
            "\u01D1": "O\u030C",
            "\xd4": "O\u0302",
            "\u1ED0": "O\u0302\u0301",
            "\u1ED2": "O\u0302\u0300",
            "\u1ED6": "O\u0302\u0303",
            "\u022E": "O\u0307",
            "\u0230": "O\u0307\u0304",
            "\u0150": "O\u030B",
            "\u1E54": "P\u0301",
            "\u1E56": "P\u0307",
            "\u0154": "R\u0301",
            "\u0158": "R\u030C",
            "\u1E58": "R\u0307",
            "\u0156": "R\u0327",
            "\u015A": "S\u0301",
            "\u1E64": "S\u0301\u0307",
            "\u0160": "S\u030C",
            "\u1E66": "S\u030C\u0307",
            "\u015C": "S\u0302",
            "\u1E60": "S\u0307",
            "\u015E": "S\u0327",
            "\u0164": "T\u030C",
            "\u1E6A": "T\u0307",
            "\u0162": "T\u0327",
            "\xda": "U\u0301",
            "\xd9": "U\u0300",
            "\xdc": "U\u0308",
            "\u01D7": "U\u0308\u0301",
            "\u01DB": "U\u0308\u0300",
            "\u01D5": "U\u0308\u0304",
            "\u01D9": "U\u0308\u030C",
            "\u0168": "U\u0303",
            "\u1E78": "U\u0303\u0301",
            "\u016A": "U\u0304",
            "\u1E7A": "U\u0304\u0308",
            "\u016C": "U\u0306",
            "\u01D3": "U\u030C",
            "\xdb": "U\u0302",
            "\u016E": "U\u030A",
            "\u0170": "U\u030B",
            "\u1E7C": "V\u0303",
            "\u1E82": "W\u0301",
            "\u1E80": "W\u0300",
            "\u1E84": "W\u0308",
            "\u0174": "W\u0302",
            "\u1E86": "W\u0307",
            "\u1E8C": "X\u0308",
            "\u1E8A": "X\u0307",
            "\xdd": "Y\u0301",
            "\u1EF2": "Y\u0300",
            "\u0178": "Y\u0308",
            "\u1EF8": "Y\u0303",
            "\u0232": "Y\u0304",
            "\u0176": "Y\u0302",
            "\u1E8E": "Y\u0307",
            "\u0179": "Z\u0301",
            "\u017D": "Z\u030C",
            "\u1E90": "Z\u0302",
            "\u017B": "Z\u0307",
            "\u03AC": "\u03B1\u0301",
            "\u1F70": "\u03B1\u0300",
            "\u1FB1": "\u03B1\u0304",
            "\u1FB0": "\u03B1\u0306",
            "\u03AD": "\u03B5\u0301",
            "\u1F72": "\u03B5\u0300",
            "\u03AE": "\u03B7\u0301",
            "\u1F74": "\u03B7\u0300",
            "\u03AF": "\u03B9\u0301",
            "\u1F76": "\u03B9\u0300",
            "\u03CA": "\u03B9\u0308",
            "\u0390": "\u03B9\u0308\u0301",
            "\u1FD2": "\u03B9\u0308\u0300",
            "\u1FD1": "\u03B9\u0304",
            "\u1FD0": "\u03B9\u0306",
            "\u03CC": "\u03BF\u0301",
            "\u1F78": "\u03BF\u0300",
            "\u03CD": "\u03C5\u0301",
            "\u1F7A": "\u03C5\u0300",
            "\u03CB": "\u03C5\u0308",
            "\u03B0": "\u03C5\u0308\u0301",
            "\u1FE2": "\u03C5\u0308\u0300",
            "\u1FE1": "\u03C5\u0304",
            "\u1FE0": "\u03C5\u0306",
            "\u03CE": "\u03C9\u0301",
            "\u1F7C": "\u03C9\u0300",
            "\u038E": "\u03A5\u0301",
            "\u1FEA": "\u03A5\u0300",
            "\u03AB": "\u03A5\u0308",
            "\u1FE9": "\u03A5\u0304",
            "\u1FE8": "\u03A5\u0306",
            "\u038F": "\u03A9\u0301",
            "\u1FFA": "\u03A9\u0300"
        };
        /**
 * This file contains the parser used to parse out a TeX expression from the
 * input. Since TeX isn't context-free, standard parsers don't work particularly
 * well.
 *
 * The strategy of this parser is as such:
 *
 * The main functions (the `.parse...` ones) take a position in the current
 * parse string to parse tokens from. The lexer (found in Lexer.js, stored at
 * this.gullet.lexer) also supports pulling out tokens at arbitrary places. When
 * individual tokens are needed at a position, the lexer is called to pull out a
 * token, which is then used.
 *
 * The parser has a property called "mode" indicating the mode that
 * the parser is currently in. Currently it has to be one of "math" or
 * "text", which denotes whether the current environment is a math-y
 * one or a text-y one (e.g. inside \text). Currently, this serves to
 * limit the functions which can be used in text mode.
 *
 * The main functions then return an object which contains the useful data that
 * was parsed at its given point, and a new position at the end of the parsed
 * data. The main functions can call each other and continue the parsing by
 * using the returned position as a new starting point.
 *
 * There are also extra `.handle...` functions, which pull out some reused
 * functionality into self-contained functions.
 *
 * The functions return ParseNodes.
 */ class Parser {
            constructor(input, settings){
                this.mode = void 0;
                this.gullet = void 0;
                this.settings = void 0;
                this.leftrightDepth = void 0;
                this.nextToken = void 0;
                // Start in math mode
                this.mode = "math"; // Create a new macro expander (gullet) and (indirectly via that) also a
                // new lexer (mouth) for this parser (stomach, in the language of TeX)
                this.gullet = new MacroExpander(input, settings, this.mode); // Store the settings for use in parsing
                this.settings = settings; // Count leftright depth (for \middle errors)
                this.leftrightDepth = 0;
            }
            /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */ expect(text, consume) {
                if (consume === void 0) consume = true;
                if (this.fetch().text !== text) throw new src_ParseError("Expected '" + text + "', got '" + this.fetch().text + "'", this.fetch());
                if (consume) this.consume();
            }
            /**
   * Discards the current lookahead token, considering it consumed.
   */ consume() {
                this.nextToken = null;
            }
            /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */ fetch() {
                if (this.nextToken == null) this.nextToken = this.gullet.expandNextToken();
                return this.nextToken;
            }
            /**
   * Switches between "text" and "math" modes.
   */ switchMode(newMode) {
                this.mode = newMode;
                this.gullet.switchMode(newMode);
            }
            /**
   * Main parsing function, which parses an entire input.
   */ parse() {
                if (!this.settings.globalGroup) // Create a group namespace for the math expression.
                // (LaTeX creates a new group for every $...$, $$...$$, \[...\].)
                this.gullet.beginGroup();
                 // Use old \color behavior (same as LaTeX's \textcolor) if requested.
                // We do this within the group for the math expression, so it doesn't
                // pollute settings.macros.
                if (this.settings.colorIsTextColor) this.gullet.macros.set("\\color", "\\textcolor");
                try {
                    // Try to parse the input
                    const parse = this.parseExpression(false); // If we succeeded, make sure there's an EOF at the end
                    this.expect("EOF"); // End the group namespace for the expression
                    if (!this.settings.globalGroup) this.gullet.endGroup();
                    return parse; // Close any leftover groups in case of a parse error.
                } finally{
                    this.gullet.endGroups();
                }
            }
            /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */ subparse(tokens) {
                // Save the next token from the current job.
                const oldToken = this.nextToken;
                this.consume(); // Run the new job, terminating it with an excess '}'
                this.gullet.pushToken(new Token("}"));
                this.gullet.pushTokens(tokens);
                const parse = this.parseExpression(false);
                this.expect("}"); // Restore the next token from the current job.
                this.nextToken = oldToken;
                return parse;
            }
            /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */ parseExpression(breakOnInfix, breakOnTokenText) {
                const body = []; // Keep adding atoms to the body until we can't parse any more atoms (either
                // we reached the end, a }, or a \right)
                while(true){
                    // Ignore spaces in math mode
                    if (this.mode === "math") this.consumeSpaces();
                    const lex = this.fetch();
                    if (Parser.endOfExpression.indexOf(lex.text) !== -1) break;
                    if (breakOnTokenText && lex.text === breakOnTokenText) break;
                    if (breakOnInfix && src_functions[lex.text] && src_functions[lex.text].infix) break;
                    const atom = this.parseAtom(breakOnTokenText);
                    if (!atom) break;
                    else if (atom.type === "internal") continue;
                    body.push(atom);
                }
                if (this.mode === "text") this.formLigatures(body);
                return this.handleInfixNodes(body);
            }
            /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */ handleInfixNodes(body) {
                let overIndex = -1;
                let funcName;
                for(let i = 0; i < body.length; i++)if (body[i].type === "infix") {
                    if (overIndex !== -1) throw new src_ParseError("only one infix operator per group", body[i].token);
                    overIndex = i;
                    funcName = body[i].replaceWith;
                }
                if (overIndex !== -1 && funcName) {
                    let numerNode;
                    let denomNode;
                    const numerBody = body.slice(0, overIndex);
                    const denomBody = body.slice(overIndex + 1);
                    if (numerBody.length === 1 && numerBody[0].type === "ordgroup") numerNode = numerBody[0];
                    else numerNode = {
                        type: "ordgroup",
                        mode: this.mode,
                        body: numerBody
                    };
                    if (denomBody.length === 1 && denomBody[0].type === "ordgroup") denomNode = denomBody[0];
                    else denomNode = {
                        type: "ordgroup",
                        mode: this.mode,
                        body: denomBody
                    };
                    let node;
                    if (funcName === "\\\\abovefrac") node = this.callFunction(funcName, [
                        numerNode,
                        body[overIndex],
                        denomNode
                    ], []);
                    else node = this.callFunction(funcName, [
                        numerNode,
                        denomNode
                    ], []);
                    return [
                        node
                    ];
                } else return body;
            }
            /**
   * Handle a subscript or superscript with nice errors.
   */ handleSupSubscript(name // For error reporting.
            ) {
                const symbolToken = this.fetch();
                const symbol = symbolToken.text;
                this.consume();
                this.consumeSpaces(); // ignore spaces before sup/subscript argument
                // Skip over allowed internal nodes such as \relax
                let group;
                do {
                    var _group;
                    group = this.parseGroup(name);
                }while (((_group = group) == null ? void 0 : _group.type) === "internal");
                if (!group) throw new src_ParseError("Expected group after '" + symbol + "'", symbolToken);
                return group;
            }
            /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */ formatUnsupportedCmd(text) {
                const textordArray = [];
                for(let i = 0; i < text.length; i++)textordArray.push({
                    type: "textord",
                    mode: "text",
                    text: text[i]
                });
                const textNode = {
                    type: "text",
                    mode: this.mode,
                    body: textordArray
                };
                const colorNode = {
                    type: "color",
                    mode: this.mode,
                    color: this.settings.errorColor,
                    body: [
                        textNode
                    ]
                };
                return colorNode;
            }
            /**
   * Parses a group with optional super/subscripts.
   */ parseAtom(breakOnTokenText) {
                // The body of an atom is an implicit group, so that things like
                // \left(x\right)^2 work correctly.
                const base = this.parseGroup("atom", breakOnTokenText); // Internal nodes (e.g. \relax) cannot support super/subscripts.
                // Instead we will pick up super/subscripts with blank base next round.
                if ((base == null ? void 0 : base.type) === "internal") return base;
                 // In text mode, we don't have superscripts or subscripts
                if (this.mode === "text") return base;
                 // Note that base may be empty (i.e. null) at this point.
                let superscript;
                let subscript;
                while(true){
                    // Guaranteed in math mode, so eat any spaces first.
                    this.consumeSpaces(); // Lex the first token
                    const lex = this.fetch();
                    if (lex.text === "\\limits" || lex.text === "\\nolimits") {
                        // We got a limit control
                        if (base && base.type === "op") {
                            const limits = lex.text === "\\limits";
                            base.limits = limits;
                            base.alwaysHandleSupSub = true;
                        } else if (base && base.type === "operatorname") {
                            if (base.alwaysHandleSupSub) base.limits = lex.text === "\\limits";
                        } else throw new src_ParseError("Limit controls must follow a math operator", lex);
                        this.consume();
                    } else if (lex.text === "^") {
                        // We got a superscript start
                        if (superscript) throw new src_ParseError("Double superscript", lex);
                        superscript = this.handleSupSubscript("superscript");
                    } else if (lex.text === "_") {
                        // We got a subscript start
                        if (subscript) throw new src_ParseError("Double subscript", lex);
                        subscript = this.handleSupSubscript("subscript");
                    } else if (lex.text === "'") {
                        // We got a prime
                        if (superscript) throw new src_ParseError("Double superscript", lex);
                        const prime = {
                            type: "textord",
                            mode: this.mode,
                            text: "\\prime"
                        }; // Many primes can be grouped together, so we handle this here
                        const primes = [
                            prime
                        ];
                        this.consume(); // Keep lexing tokens until we get something that's not a prime
                        while(this.fetch().text === "'"){
                            // For each one, add another prime to the list
                            primes.push(prime);
                            this.consume();
                        } // If there's a superscript following the primes, combine that
                        // superscript in with the primes.
                        if (this.fetch().text === "^") primes.push(this.handleSupSubscript("superscript"));
                         // Put everything into an ordgroup as the superscript
                        superscript = {
                            type: "ordgroup",
                            mode: this.mode,
                            body: primes
                        };
                    } else if (uSubsAndSups[lex.text]) {
                        // A Unicode subscript or superscript character.
                        // We treat these similarly to the unicode-math package.
                        // So we render a string of Unicode (sub|super)scripts the
                        // same as a (sub|super)script of regular characters.
                        const isSub = unicodeSubRegEx.test(lex.text);
                        const subsupTokens = [];
                        subsupTokens.push(new Token(uSubsAndSups[lex.text]));
                        this.consume(); // Continue fetching tokens to fill out the string.
                        while(true){
                            const token = this.fetch().text;
                            if (!uSubsAndSups[token]) break;
                            if (unicodeSubRegEx.test(token) !== isSub) break;
                            subsupTokens.unshift(new Token(uSubsAndSups[token]));
                            this.consume();
                        } // Now create a (sub|super)script.
                        const body = this.subparse(subsupTokens);
                        if (isSub) subscript = {
                            type: "ordgroup",
                            mode: "math",
                            body: body
                        };
                        else superscript = {
                            type: "ordgroup",
                            mode: "math",
                            body: body
                        };
                    } else break;
                } // Base must be set if superscript or subscript are set per logic above,
                // but need to check here for type check to pass.
                if (superscript || subscript) // If we got either a superscript or subscript, create a supsub
                return {
                    type: "supsub",
                    mode: this.mode,
                    base: base,
                    sup: superscript,
                    sub: subscript
                };
                else // Otherwise return the original body
                return base;
            }
            /**
   * Parses an entire function, including its base and all of its arguments.
   */ parseFunction(breakOnTokenText, name // For determining its context
            ) {
                const token = this.fetch();
                const func = token.text;
                const funcData = src_functions[func];
                if (!funcData) return null;
                this.consume(); // consume command token
                if (name && name !== "atom" && !funcData.allowedInArgument) throw new src_ParseError("Got function '" + func + "' with no arguments" + (name ? " as " + name : ""), token);
                else if (this.mode === "text" && !funcData.allowedInText) throw new src_ParseError("Can't use function '" + func + "' in text mode", token);
                else if (this.mode === "math" && funcData.allowedInMath === false) throw new src_ParseError("Can't use function '" + func + "' in math mode", token);
                const { args: args, optArgs: optArgs } = this.parseArguments(func, funcData);
                return this.callFunction(func, args, optArgs, token, breakOnTokenText);
            }
            /**
   * Call a function handler with a suitable context and arguments.
   */ callFunction(name, args, optArgs, token, breakOnTokenText) {
                const context = {
                    funcName: name,
                    parser: this,
                    token: token,
                    breakOnTokenText: breakOnTokenText
                };
                const func = src_functions[name];
                if (func && func.handler) return func.handler(context, args, optArgs);
                else throw new src_ParseError("No function handler for " + name);
            }
            /**
   * Parses the arguments of a function or environment
   */ parseArguments(func, funcData) {
                const totalArgs = funcData.numArgs + funcData.numOptionalArgs;
                if (totalArgs === 0) return {
                    args: [],
                    optArgs: []
                };
                const args = [];
                const optArgs = [];
                for(let i = 0; i < totalArgs; i++){
                    let argType = funcData.argTypes && funcData.argTypes[i];
                    const isOptional = i < funcData.numOptionalArgs;
                    if (funcData.primitive && argType == null || // \sqrt expands into primitive if optional argument doesn't exist
                    funcData.type === "sqrt" && i === 1 && optArgs[0] == null) argType = "primitive";
                    const arg = this.parseGroupOfType("argument to '" + func + "'", argType, isOptional);
                    if (isOptional) optArgs.push(arg);
                    else if (arg != null) args.push(arg);
                    else // should be unreachable
                    throw new src_ParseError("Null argument, please report this as a bug");
                }
                return {
                    args: args,
                    optArgs: optArgs
                };
            }
            /**
   * Parses a group when the mode is changing.
   */ parseGroupOfType(name, type, optional) {
                switch(type){
                    case "color":
                        return this.parseColorGroup(optional);
                    case "size":
                        return this.parseSizeGroup(optional);
                    case "url":
                        return this.parseUrlGroup(optional);
                    case "math":
                    case "text":
                        return this.parseArgumentGroup(optional, type);
                    case "hbox":
                        {
                            // hbox argument type wraps the argument in the equivalent of
                            // \hbox, which is like \text but switching to \textstyle size.
                            const group = this.parseArgumentGroup(optional, "text");
                            return group != null ? {
                                type: "styling",
                                mode: group.mode,
                                body: [
                                    group
                                ],
                                style: "text" // simulate \textstyle
                            } : null;
                        }
                    case "raw":
                        {
                            const token = this.parseStringGroup("raw", optional);
                            return token != null ? {
                                type: "raw",
                                mode: "text",
                                string: token.text
                            } : null;
                        }
                    case "primitive":
                        {
                            if (optional) throw new src_ParseError("A primitive argument cannot be optional");
                            const group = this.parseGroup(name);
                            if (group == null) throw new src_ParseError("Expected group as " + name, this.fetch());
                            return group;
                        }
                    case "original":
                    case null:
                    case undefined:
                        return this.parseArgumentGroup(optional);
                    default:
                        throw new src_ParseError("Unknown group type as " + name, this.fetch());
                }
            }
            /**
   * Discard any space tokens, fetching the next non-space token.
   */ consumeSpaces() {
                while(this.fetch().text === " ")this.consume();
            }
            /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */ parseStringGroup(modeName, optional) {
                const argToken = this.gullet.scanArgument(optional);
                if (argToken == null) return null;
                let str = "";
                let nextToken;
                while((nextToken = this.fetch()).text !== "EOF"){
                    str += nextToken.text;
                    this.consume();
                }
                this.consume(); // consume the end of the argument
                argToken.text = str;
                return argToken;
            }
            /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */ parseRegexGroup(regex, modeName // Used to describe the mode in error messages.
            ) {
                const firstToken = this.fetch();
                let lastToken = firstToken;
                let str = "";
                let nextToken;
                while((nextToken = this.fetch()).text !== "EOF" && regex.test(str + nextToken.text)){
                    lastToken = nextToken;
                    str += lastToken.text;
                    this.consume();
                }
                if (str === "") throw new src_ParseError("Invalid " + modeName + ": '" + firstToken.text + "'", firstToken);
                return firstToken.range(lastToken, str);
            }
            /**
   * Parses a color description.
   */ parseColorGroup(optional) {
                const res = this.parseStringGroup("color", optional);
                if (res == null) return null;
                const match = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(res.text);
                if (!match) throw new src_ParseError("Invalid color: '" + res.text + "'", res);
                let color = match[0];
                if (/^[0-9a-f]{6}$/i.test(color)) // We allow a 6-digit HTML color spec without a leading "#".
                // This follows the xcolor package's HTML color model.
                // Predefined color names are all missed by this RegEx pattern.
                color = "#" + color;
                return {
                    type: "color-token",
                    mode: this.mode,
                    color: color
                };
            }
            /**
   * Parses a size specification, consisting of magnitude and unit.
   */ parseSizeGroup(optional) {
                let res;
                let isBlank = false; // don't expand before parseStringGroup
                this.gullet.consumeSpaces();
                if (!optional && this.gullet.future().text !== "{") res = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size");
                else res = this.parseStringGroup("size", optional);
                if (!res) return null;
                if (!optional && res.text.length === 0) {
                    // Because we've tested for what is !optional, this block won't
                    // affect \kern, \hspace, etc. It will capture the mandatory arguments
                    // to \genfrac and \above.
                    res.text = "0pt"; // Enable \above{}
                    isBlank = true; // This is here specifically for \genfrac
                }
                const match = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(res.text);
                if (!match) throw new src_ParseError("Invalid size: '" + res.text + "'", res);
                const data = {
                    number: +(match[1] + match[2]),
                    // sign + magnitude, cast to number
                    unit: match[3]
                };
                if (!validUnit(data)) throw new src_ParseError("Invalid unit: '" + data.unit + "'", res);
                return {
                    type: "size",
                    mode: this.mode,
                    value: data,
                    isBlank: isBlank
                };
            }
            /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */ parseUrlGroup(optional) {
                this.gullet.lexer.setCatcode("%", 13); // active character
                this.gullet.lexer.setCatcode("~", 12); // other character
                const res = this.parseStringGroup("url", optional);
                this.gullet.lexer.setCatcode("%", 14); // comment character
                this.gullet.lexer.setCatcode("~", 13); // active character
                if (res == null) return null;
                 // hyperref package allows backslashes alone in href, but doesn't
                // generate valid links in such cases; we interpret this as
                // "undefined" behaviour, and keep them as-is. Some browser will
                // replace backslashes with forward slashes.
                const url = res.text.replace(/\\([#$%&~_^{}])/g, '$1');
                return {
                    type: "url",
                    mode: this.mode,
                    url: url
                };
            }
            /**
   * Parses an argument with the mode specified.
   */ parseArgumentGroup(optional, mode) {
                const argToken = this.gullet.scanArgument(optional);
                if (argToken == null) return null;
                const outerMode = this.mode;
                if (mode) // Switch to specified mode
                this.switchMode(mode);
                this.gullet.beginGroup();
                const expression = this.parseExpression(false, "EOF"); // TODO: find an alternative way to denote the end
                this.expect("EOF"); // expect the end of the argument
                this.gullet.endGroup();
                const result = {
                    type: "ordgroup",
                    mode: this.mode,
                    loc: argToken.loc,
                    body: expression
                };
                if (mode) // Switch mode back
                this.switchMode(outerMode);
                return result;
            }
            /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */ parseGroup(name, breakOnTokenText) {
                const firstToken = this.fetch();
                const text = firstToken.text;
                let result; // Try to parse an open brace or \begingroup
                if (text === "{" || text === "\\begingroup") {
                    this.consume();
                    const groupEnd = text === "{" ? "}" : "\\endgroup";
                    this.gullet.beginGroup(); // If we get a brace, parse an expression
                    const expression = this.parseExpression(false, groupEnd);
                    const lastToken = this.fetch();
                    this.expect(groupEnd); // Check that we got a matching closing brace
                    this.gullet.endGroup();
                    result = {
                        type: "ordgroup",
                        mode: this.mode,
                        loc: SourceLocation.range(firstToken, lastToken),
                        body: expression,
                        // A group formed by \begingroup...\endgroup is a semi-simple group
                        // which doesn't affect spacing in math mode, i.e., is transparent.
                        // https://tex.stackexchange.com/questions/1930/when-should-one-
                        // use-begingroup-instead-of-bgroup
                        semisimple: text === "\\begingroup" || undefined
                    };
                } else {
                    // If there exists a function with this name, parse the function.
                    // Otherwise, just return a nucleus
                    result = this.parseFunction(breakOnTokenText, name) || this.parseSymbol();
                    if (result == null && text[0] === "\\" && !implicitCommands.hasOwnProperty(text)) {
                        if (this.settings.throwOnError) throw new src_ParseError("Undefined control sequence: " + text, firstToken);
                        result = this.formatUnsupportedCmd(text);
                        this.consume();
                    }
                }
                return result;
            }
            /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */ formLigatures(group) {
                let n = group.length - 1;
                for(let i = 0; i < n; ++i){
                    const a = group[i]; // $FlowFixMe: Not every node type has a `text` property.
                    const v = a.text;
                    if (v === "-" && group[i + 1].text === "-") {
                        if (i + 1 < n && group[i + 2].text === "-") {
                            group.splice(i, 3, {
                                type: "textord",
                                mode: "text",
                                loc: SourceLocation.range(a, group[i + 2]),
                                text: "---"
                            });
                            n -= 2;
                        } else {
                            group.splice(i, 2, {
                                type: "textord",
                                mode: "text",
                                loc: SourceLocation.range(a, group[i + 1]),
                                text: "--"
                            });
                            n -= 1;
                        }
                    }
                    if ((v === "'" || v === "`") && group[i + 1].text === v) {
                        group.splice(i, 2, {
                            type: "textord",
                            mode: "text",
                            loc: SourceLocation.range(a, group[i + 1]),
                            text: v + v
                        });
                        n -= 1;
                    }
                }
            }
            /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */ parseSymbol() {
                const nucleus = this.fetch();
                let text = nucleus.text;
                if (/^\\verb[^a-zA-Z]/.test(text)) {
                    this.consume();
                    let arg = text.slice(5);
                    const star = arg.charAt(0) === "*";
                    if (star) arg = arg.slice(1);
                     // Lexer's tokenRegex is constructed to always have matching
                    // first/last characters.
                    if (arg.length < 2 || arg.charAt(0) !== arg.slice(-1)) throw new src_ParseError("\\verb assertion failed --\n                    please report what input caused this bug");
                    arg = arg.slice(1, -1); // remove first and last char
                    return {
                        type: "verb",
                        mode: "text",
                        body: arg,
                        star: star
                    };
                } // At this point, we should have a symbol, possibly with accents.
                // First expand any accented base symbol according to unicodeSymbols.
                if (unicodeSymbols.hasOwnProperty(text[0]) && !src_symbols[this.mode][text[0]]) {
                    // This behavior is not strict (XeTeX-compatible) in math mode.
                    if (this.settings.strict && this.mode === "math") this.settings.reportNonstrict("unicodeTextInMathMode", "Accented Unicode text character \"" + text[0] + "\" used in " + "math mode", nucleus);
                    text = unicodeSymbols[text[0]] + text.slice(1);
                } // Strip off any combining characters
                const match = combiningDiacriticalMarksEndRegex.exec(text);
                if (match) {
                    text = text.substring(0, match.index);
                    if (text === 'i') text = '\u0131'; // dotless i, in math and text mode
                    else if (text === 'j') text = '\u0237'; // dotless j, in math and text mode
                } // Recognize base symbol
                let symbol;
                if (src_symbols[this.mode][text]) {
                    if (this.settings.strict && this.mode === 'math' && extraLatin.indexOf(text) >= 0) this.settings.reportNonstrict("unicodeTextInMathMode", "Latin-1/Unicode text character \"" + text[0] + "\" used in " + "math mode", nucleus);
                    const group = src_symbols[this.mode][text].group;
                    const loc = SourceLocation.range(nucleus);
                    let s;
                    if (ATOMS.hasOwnProperty(group)) {
                        // $FlowFixMe
                        const family = group;
                        s = {
                            type: "atom",
                            mode: this.mode,
                            family: family,
                            loc: loc,
                            text: text
                        };
                    } else // $FlowFixMe
                    s = {
                        type: group,
                        mode: this.mode,
                        loc: loc,
                        text: text
                    };
                     // $FlowFixMe
                    symbol = s;
                } else if (text.charCodeAt(0) >= 0x80) {
                    // no symbol for e.g. ^
                    if (this.settings.strict) {
                        if (!supportedCodepoint(text.charCodeAt(0))) this.settings.reportNonstrict("unknownSymbol", "Unrecognized Unicode character \"" + text[0] + "\"" + (" (" + text.charCodeAt(0) + ")"), nucleus);
                        else if (this.mode === "math") this.settings.reportNonstrict("unicodeTextInMathMode", "Unicode text character \"" + text[0] + "\" used in math mode", nucleus);
                    } // All nonmathematical Unicode characters are rendered as if they
                    // are in text mode (wrapped in \text) because that's what it
                    // takes to render them in LaTeX.  Setting `mode: this.mode` is
                    // another natural choice (the user requested math mode), but
                    // this makes it more difficult for getCharacterMetrics() to
                    // distinguish Unicode characters without metrics and those for
                    // which we want to simulate the letter M.
                    symbol = {
                        type: "textord",
                        mode: "text",
                        loc: SourceLocation.range(nucleus),
                        text: text
                    };
                } else return null; // EOF, ^, _, {, }, etc.
                this.consume(); // Transform combining characters into accents
                if (match) for(let i = 0; i < match[0].length; i++){
                    const accent = match[0][i];
                    if (!unicodeAccents[accent]) throw new src_ParseError("Unknown accent ' " + accent + "'", nucleus);
                    const command = unicodeAccents[accent][this.mode] || unicodeAccents[accent].text;
                    if (!command) throw new src_ParseError("Accent " + accent + " unsupported in " + this.mode + " mode", nucleus);
                    symbol = {
                        type: "accent",
                        mode: this.mode,
                        loc: SourceLocation.range(nucleus),
                        label: command,
                        isStretchy: false,
                        isShifty: true,
                        // $FlowFixMe
                        base: symbol
                    };
                }
                 // $FlowFixMe
                return symbol;
            }
        }
        Parser.endOfExpression = [
            "}",
            "\\endgroup",
            "\\end",
            "\\right",
            "&"
        ];
        /**
 * Provides a single function for parsing an expression using a Parser
 * TODO(emily): Remove this
 */ /**
 * Parses an expression using a Parser, then returns the parsed result.
 */ const parseTree = function(toParse, settings) {
            if (!(typeof toParse === 'string' || toParse instanceof String)) throw new TypeError('KaTeX can only parse string typed expression');
            const parser = new Parser(toParse, settings); // Blank out any \df@tag to avoid spurious "Duplicate \tag" errors
            delete parser.gullet.macros.current["\\df@tag"];
            let tree = parser.parse(); // Prevent a color definition from persisting between calls to katex.render().
            delete parser.gullet.macros.current["\\current@color"];
            delete parser.gullet.macros.current["\\color"]; // If the input used \tag, it will set the \df@tag macro to the tag.
            // In this case, we separately parse the tag and wrap the tree.
            if (parser.gullet.macros.get("\\df@tag")) {
                if (!settings.displayMode) throw new src_ParseError("\\tag works only in display equations");
                tree = [
                    {
                        type: "tag",
                        mode: "text",
                        body: tree,
                        tag: parser.subparse([
                            new Token("\\df@tag")
                        ])
                    }
                ];
            }
            return tree;
        };
        /* harmony default export */ var src_parseTree = parseTree;
        /* eslint no-console:0 */ /**
 * This is the main entry point for KaTeX. Here, we expose functions for
 * rendering expressions either to DOM nodes or to markup strings.
 *
 * We also expose the ParseError class to check if errors thrown from KaTeX are
 * errors in the expression, or errors in javascript handling.
 */ /**
 * Parse and build an expression, and place that expression in the DOM node
 * given.
 */ let render = function(expression, baseNode, options) {
            baseNode.textContent = "";
            const node = renderToDomTree(expression, options).toNode();
            baseNode.appendChild(node);
        }; // KaTeX's styles don't work properly in quirks mode. Print out an error, and
        // disable rendering.
        if (typeof document !== "undefined") {
            if (document.compatMode !== "CSS1Compat") {
                typeof console !== "undefined" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype.");
                render = function() {
                    throw new src_ParseError("KaTeX doesn't work in quirks mode.");
                };
            }
        }
        /**
 * Parse and build an expression, and return the markup for that.
 */ const renderToString = function(expression, options) {
            const markup = renderToDomTree(expression, options).toMarkup();
            return markup;
        };
        /**
 * Parse an expression and return the parse tree.
 */ const generateParseTree = function(expression, options) {
            const settings = new Settings(options);
            return src_parseTree(expression, settings);
        };
        /**
 * If the given error is a KaTeX ParseError and options.throwOnError is false,
 * renders the invalid LaTeX as a span with hover title giving the KaTeX
 * error message.  Otherwise, simply throws the error.
 */ const renderError = function(error, expression, options) {
            if (options.throwOnError || !(error instanceof src_ParseError)) throw error;
            const node = buildCommon.makeSpan([
                "katex-error"
            ], [
                new SymbolNode(expression)
            ]);
            node.setAttribute("title", error.toString());
            node.setAttribute("style", "color:" + options.errorColor);
            return node;
        };
        /**
 * Generates and returns the katex build tree. This is used for advanced
 * use cases (like rendering to custom output).
 */ const renderToDomTree = function(expression, options) {
            const settings = new Settings(options);
            try {
                const tree = src_parseTree(expression, settings);
                return buildTree(tree, expression, settings);
            } catch (error) {
                return renderError(error, expression, settings);
            }
        };
        /**
 * Generates and returns the katex build tree, with just HTML (no MathML).
 * This is used for advanced use cases (like rendering to custom output).
 */ const renderToHTMLTree = function(expression, options) {
            const settings = new Settings(options);
            try {
                const tree = src_parseTree(expression, settings);
                return buildHTMLTree(tree, expression, settings);
            } catch (error) {
                return renderError(error, expression, settings);
            }
        };
        const version = "0.16.25";
        const __domTree = {
            Span: Span,
            Anchor: Anchor,
            SymbolNode: SymbolNode,
            SvgNode: SvgNode,
            PathNode: PathNode,
            LineNode: LineNode
        }; // ESM exports
        // CJS exports and ESM default export
        /* harmony default export */ var katex = {
            version: /**
   * Current KaTeX version
   */ version,
            render: /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */ render,
            renderToString: /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */ renderToString,
            /**
   * KaTeX error, usually during parsing.
   */ ParseError: src_ParseError,
            /**
   * The schema of Settings
   */ SETTINGS_SCHEMA: SETTINGS_SCHEMA,
            /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __parse: generateParseTree,
            /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __renderToDomTree: renderToDomTree,
            /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __renderToHTMLTree: renderToHTMLTree,
            /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */ __setFontMetrics: setFontMetrics,
            /**
   * adds a new symbol to builtin symbols table
   */ __defineSymbol: defineSymbol,
            /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */ __defineFunction: defineFunction,
            /**
   * adds a new macro to builtin macro list
   */ __defineMacro: defineMacro,
            __domTree: /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __domTree
        };
        /**
 * This is the webpack entry point for KaTeX. As ECMAScript, flow[1] and jest[2]
 * doesn't support CSS modules natively, a separate entry point is used and
 * it is not flowtyped.
 *
 * [1] https://gist.github.com/lambdahands/d19e0da96285b749f0ef
 * [2] https://facebook.github.io/jest/docs/en/webpack.html
 */ /* harmony default export */ var katex_webpack = katex;
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});



var $iW1oU = parcelRequire("iW1oU");

var $4Bp2X = parcelRequire("4Bp2X");
// Injected at build time from MinVer
const $b768d5c7bc3d9f53$var$DOCS_BUILDER_VERSION = "0.92.1-canary.0.12"?.trim() ?? '0.0.0-dev';
// Initialize OpenTelemetry FIRST, before any other code runs
// This must happen early so all subsequent code is instrumented
(0, $7f8e6f5dc962e0e1$export$ddb438a168ec5ead)({
    serviceName: 'docs-frontend',
    serviceVersion: $b768d5c7bc3d9f53$var$DOCS_BUILDER_VERSION,
    baseUrl: '/docs',
    debug: false
});

// Dynamically import web components after telemetry is initialized
// This ensures telemetry is available when the components execute
// Parcel will automatically code-split this into a separate chunk
(parcelRequire("8z0uj"));

(parcelRequire("055be"));
const { getOS: $b768d5c7bc3d9f53$var$getOS } = new (0, $4Bp2X.UAParser)();
const $b768d5c7bc3d9f53$var$isLazyLoadNavigationEnabled = (0, $iW1oU.$)('meta[property="docs:feature:lazy-load-navigation"]')?.content === 'true';
/**
 * Initialize KaTeX math rendering for elements with class 'math'
 */ function $b768d5c7bc3d9f53$var$initMath() {
    const mathElements = (0, $iW1oU.$$)('.math:not([data-katex-processed])');
    mathElements.forEach((element)=>{
        try {
            const content = element.textContent?.trim();
            if (!content) return;
            // Determine if this is display math based on content and element type
            const isDisplayMath = element.tagName === 'DIV' || content.includes('\\[') || content.includes('$$') || content.includes('\\begin{') || content.includes('\n');
            // Clean up common LaTeX delimiters
            const cleanContent = content.replace(/^\$\$|\$\$$/g, '') // Remove $$ delimiters
            .replace(/^\\\[|\\\]$/g, '') // Remove \[ \] delimiters
            .trim();
            // Clear the element content before rendering
            element.innerHTML = '';
            $e633ba29072e4dc2$exports.render(cleanContent, element, {
                throwOnError: false,
                displayMode: isDisplayMath,
                strict: false,
                trust: false,
                output: 'mathml',
                macros: {
                }
            });
            // Mark as processed to prevent double processing
            element.setAttribute('data-katex-processed', 'true');
        } catch (error) {
            console.warn('KaTeX rendering error:', error);
            // Fallback: keep the original content
            element.innerHTML = element.textContent || '';
        }
    });
}
// Initialize math on initial page load
document.addEventListener('DOMContentLoaded', function() {
    $b768d5c7bc3d9f53$var$initMath();
});
document.addEventListener('htmx:load', function(event) {
    (0, $6b0015b9256b446f$export$770b3efc01f13311)();
    (0, $j96zz.initHighlight)();
    (0, $3RUqz.initCopyButton)();
    (0, $f19041c76187fb4a$export$c92e8f569ad2976f)();
    (0, $0e8c0a427244d80b$export$1bae6a6e343f38b8)();
    $b768d5c7bc3d9f53$var$initMath();
    // We do this so that the navigation is not initialized twice
    if ($b768d5c7bc3d9f53$var$isLazyLoadNavigationEnabled) {
        if (event.detail.elt.id === 'nav-tree') (0, $382b6492841cb628$export$240cd81d1fa164a8)();
    } else (0, $382b6492841cb628$export$240cd81d1fa164a8)();
    (0, $ca337ca22fc67714$export$22e4029a4c2fac28)();
    (0, $f4845c9feb6b8f9d$export$b352f2ce836dda92)();
    (0, $034734cddcc39867$export$6c5c949207b4b264)();
    const urlParams = new URLSearchParams(window.location.search);
    const editParam = urlParams.has('edit');
    if (editParam) (0, $iW1oU.$)('.edit-this-page.hidden')?.classList.remove('hidden');
});
// Don't remove style tags because they are used by the elastic global nav.
document.addEventListener('htmx:removingHeadElement', function(event) {
    const tagName = event.detail.headElement.tagName;
    if (tagName === 'STYLE') event.preventDefault();
});
document.addEventListener('htmx:beforeRequest', function(event) {
    if (event.detail.requestConfig.verb === 'get' && event.detail.requestConfig.triggeringEvent) {
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event.detail.requestConfig.triggeringEvent;
        const { name: os } = $b768d5c7bc3d9f53$var$getOS();
        const modifierKey = os === 'macOS' ? metaKey : ctrlKey;
        if (shiftKey || modifierKey) {
            event.preventDefault();
            window.open(event.detail.requestConfig.path, '_blank', 'noopener,noreferrer');
        }
    }
});
document.body.addEventListener('htmx:oobBeforeSwap', function(event) {
    // This is needed to scroll to the top of the page when the content is swapped
    if (event.target?.id === 'main-container' || event.target?.id === 'markdown-content' || event.target?.id === 'content-container') window.scrollTo(0, 0);
});
document.body.addEventListener('htmx:pushedIntoHistory', function(event) {
    const pagesNav = (0, $iW1oU.$)('#pages-nav');
    const currentNavItem = (0, $iW1oU.$$)('.current', pagesNav);
    currentNavItem.forEach((el)=>{
        el.classList.remove('current');
    });
    const navItems = (0, $iW1oU.$$)('a[href="' + event.detail.path + '"]', pagesNav);
    navItems.forEach((navItem)=>{
        navItem.classList.add('current');
    });
});
document.body.addEventListener('htmx:responseError', function(event) {
    // If you get a 404 error while clicking on a hx-get link, actually open the link
    // This is needed because the browser doesn't update the URL when the response is a 404
    // In production, cloudfront handles serving the 404 page.
    // Locally, the DocumentationWebHost handles it.
    // On previews, a generic 404 page is shown.
    if (event.detail.xhr.status === 404) window.location.assign(event.detail.pathInfo.requestPath);
});
// We add a query string to the get request to make sure the requested page is up to date
const $b768d5c7bc3d9f53$var$docsBuilderVersion = (0, $iW1oU.$)('body')?.dataset.docsBuilderVersion;
document.body.addEventListener('htmx:configRequest', function(event) {
    if (event.detail.verb === 'get' && $b768d5c7bc3d9f53$var$docsBuilderVersion) event.detail.parameters['v'] = $b768d5c7bc3d9f53$var$docsBuilderVersion;
});
// Here we need to strip the v parameter from the URL so
// that the browser doesn't show the v parameter in the address bar
document.body.addEventListener('htmx:beforeHistoryUpdate', function(event) {
    const params = new URLSearchParams(event.detail.history.path.split('?')[1] ?? '');
    params.delete('v');
    const pathWithoutQueryString = event.detail.history.path.split('?')[0];
    if (params.size === 0) event.detail.history.path = pathWithoutQueryString;
    else event.detail.history.path = pathWithoutQueryString + '?' + params.toString();
});

})();
//# sourceMappingURL=main.js.map
